 // Contiguous US Zip Codes
 const ZIPCODE_CITIES = {
    // Eastern Time Zone - 東岸時區 (EST/EDT)
    '00501': 'Holtsville,NY',
'00544': 'Holtsville,NY',
'01001': 'Agawam,MA',
'01002': 'Amherst,MA',
'01003': 'Amherst,MA',
'01004': 'Amherst,MA',
'01005': 'Barre,MA',
'01007': 'Belchertown,MA',
'01008': 'Blandford,MA',
'01009': 'Bondsville,MA',
'01010': 'Brimfield,MA',
'01011': 'Chester,MA',
'01012': 'Chesterfield,MA',
'01013': 'Chicopee,MA',
'01014': 'Chicopee,MA',
'01020': 'Chicopee,MA',
'01021': 'Chicopee,MA',
'01022': 'Chicopee,MA',
'01026': 'Cummington,MA',
'01027': 'Easthampton,MA',
'01028': 'East Longmeadow,MA',
'01029': 'East Otis,MA',
'01030': 'Feeding Hills,MA',
'01031': 'Gilbertville,MA',
'01032': 'Goshen,MA',
'01033': 'Granby,MA',
'01034': 'Granville,MA',
'01035': 'Hadley,MA',
'01036': 'Hampden,MA',
'01037': 'Hardwick,MA',
'01038': 'Hatfield,MA',
'01039': 'Haydenville,MA',
'01040': 'Holyoke,MA',
'01041': 'Holyoke,MA',
'01050': 'Huntington,MA',
'01053': 'Leeds,MA',
'01054': 'Leverett,MA',
'01056': 'Ludlow,MA',
'01057': 'Monson,MA',
'01059': 'North Amherst,MA',
'01060': 'Northampton,MA',
'01061': 'Northampton,MA',
'01062': 'Florence,MA',
'01063': 'Northampton,MA',
'01066': 'North Hatfield,MA',
'01068': 'Oakham,MA',
'01069': 'Palmer,MA',
'01070': 'Plainfield,MA',
'01071': 'Russell,MA',
'01072': 'Shutesbury,MA',
'01073': 'Southampton,MA',
'01074': 'South Barre,MA',
'01075': 'South Hadley,MA',
'01077': 'Southwick,MA',
'01079': 'Thorndike,MA',
'01080': 'Three Rivers,MA',
'01081': 'Wales,MA',
'01082': 'Ware,MA',
'01083': 'Warren,MA',
'01084': 'West Chesterfield,MA',
'01085': 'Westfield,MA',
'01086': 'Westfield,MA',
'01088': 'West Hatfield,MA',
'01089': 'West Springfield,MA',
'01090': 'West Springfield,MA',
'01092': 'West Warren,MA',
'01093': 'Whately,MA',
'01094': 'Wheelwright,MA',
'01095': 'Wilbraham,MA',
'01096': 'Williamsburg,MA',
'01097': 'Woronoco,MA',
'01098': 'Worthington,MA',
'01101': 'Springfield,MA',
'01102': 'Springfield,MA',
'01103': 'Springfield,MA',
'01104': 'Springfield,MA',
'01105': 'Springfield,MA',
'01106': 'Longmeadow,MA',
'01107': 'Springfield,MA',
'01108': 'Springfield,MA',
'01109': 'Springfield,MA',
'01111': 'Springfield,MA',
'01114': 'Springfield,MA',
'01115': 'Springfield,MA',
'01116': 'Longmeadow,MA',
'01118': 'Springfield,MA',
'01119': 'Springfield,MA',
'01128': 'Springfield,MA',
'01129': 'Springfield,MA',
'01133': 'Springfield,MA',
'01138': 'Springfield,MA',
'01139': 'Springfield,MA',
'01144': 'Springfield,MA',
'01151': 'Indian Orchard,MA',
'01152': 'Springfield,MA',
'01195': 'Springfield Bmc,MA',
'01199': 'Springfield,MA',
'01201': 'Pittsfield,MA',
'01202': 'Pittsfield,MA',
'01203': 'Pittsfield,MA',
'01220': 'Adams,MA',
'01222': 'Ashley Falls,MA',
'01223': 'Becket,MA',
'01224': 'Berkshire,MA',
'01225': 'Cheshire,MA',
'01226': 'Dalton,MA',
'01227': 'Dalton,MA',
'01229': 'Glendale,MA',
'01230': 'Great Barrington,MA',
'01235': 'Hinsdale,MA',
'01236': 'Housatonic,MA',
'01237': 'Lanesboro,MA',
'01238': 'Lee,MA',
'01240': 'Lenox,MA',
'01242': 'Lenox Dale,MA',
'01243': 'Middlefield,MA',
'01244': 'Mill River,MA',
'01245': 'Monterey,MA',
'01247': 'North Adams,MA',
'01252': 'North Egremont,MA',
'01253': 'Otis,MA',
'01254': 'Richmond,MA',
'01255': 'Sandisfield,MA',
'01256': 'Savoy,MA',
'01257': 'Sheffield,MA',
'01258': 'South Egremont,MA',
'01259': 'Southfield,MA',
'01260': 'South Lee,MA',
'01262': 'Stockbridge,MA',
'01263': 'Stockbridge,MA',
'01264': 'Tyringham,MA',
'01266': 'West Stockbridge,MA',
'01267': 'Williamstown,MA',
'01270': 'Windsor,MA',
'01301': 'Greenfield,MA',
'01302': 'Greenfield,MA',
'01330': 'Ashfield,MA',
'01331': 'Athol,MA',
'01337': 'Bernardston,MA',
'01338': 'Buckland,MA',
'01339': 'Charlemont,MA',
'01340': 'Colrain,MA',
'01341': 'Conway,MA',
'01342': 'Deerfield,MA',
'01343': 'Drury,MA',
'01344': 'Erving,MA',
'01346': 'Heath,MA',
'01347': 'Lake Pleasant,MA',
'01349': 'Turners Falls,MA',
'01350': 'Monroe Bridge,MA',
'01351': 'Montague,MA',
'01354': 'Northfield,MA',
'01355': 'New Salem,MA',
'01360': 'Northfield,MA',
'01364': 'Orange,MA',
'01366': 'Petersham,MA',
'01367': 'Rowe,MA',
'01368': 'Royalston,MA',
'01369': 'Shattuckville,MA',
'01370': 'Shelburne Falls,MA',
'01373': 'South Deerfield,MA',
'01375': 'Sunderland,MA',
'01376': 'Turners Falls,MA',
'01378': 'Warwick,MA',
'01379': 'Wendell,MA',
'01380': 'Wendell Depot,MA',
'01420': 'Fitchburg,MA',
'01430': 'Ashburnham,MA',
'01431': 'Ashby,MA',
'01432': 'Ayer,MA',
'01434': 'Devens,MA',
'01436': 'Baldwinville,MA',
'01438': 'East Templeton,MA',
'01440': 'Gardner,MA',
'01441': 'Westminster,MA',
'01450': 'Groton,MA',
'01451': 'Harvard,MA',
'01452': 'Hubbardston,MA',
'01453': 'Leominster,MA',
'01460': 'Littleton,MA',
'01462': 'Lunenburg,MA',
'01463': 'Pepperell,MA',
'01464': 'Shirley,MA',
'01467': 'Still River,MA',
'01468': 'Templeton,MA',
'01469': 'Townsend,MA',
'01470': 'Groton,MA',
'01471': 'Groton,MA',
'01472': 'West Groton,MA',
'01473': 'Westminster,MA',
'01474': 'West Townsend,MA',
'01475': 'Winchendon,MA',
'01477': 'Winchendon Springs,MA',
'01501': 'Auburn,MA',
'01503': 'Berlin,MA',
'01504': 'Blackstone,MA',
'01505': 'Boylston,MA',
'01506': 'Brookfield,MA',
'01507': 'Charlton,MA',
'01508': 'Charlton City,MA',
'01509': 'Charlton Depot,MA',
'01510': 'Clinton,MA',
'01515': 'East Brookfield,MA',
'01516': 'Douglas,MA',
'01517': 'East Princeton,MA',
'01518': 'Fiskdale,MA',
'01519': 'Grafton,MA',
'01520': 'Holden,MA',
'01521': 'Holland,MA',
'01522': 'Jefferson,MA',
'01523': 'Lancaster,MA',
'01524': 'Leicester,MA',
'01525': 'Linwood,MA',
'01526': 'Manchaug,MA',
'01527': 'Millbury,MA',
'01529': 'Millville,MA',
'01531': 'New Braintree,MA',
'01532': 'Northborough,MA',
'01534': 'Northbridge,MA',
'01535': 'North Brookfield,MA',
'01536': 'North Grafton,MA',
'01537': 'North Oxford,MA',
'01538': 'North Uxbridge,MA',
'01540': 'Oxford,MA',
'01541': 'Princeton,MA',
'01542': 'Rochdale,MA',
'01543': 'Rutland,MA',
'01545': 'Shrewsbury,MA',
'01546': 'Shrewsbury,MA',
'01550': 'Southbridge,MA',
'01560': 'South Grafton,MA',
'01561': 'South Lancaster,MA',
'01562': 'Spencer,MA',
'01564': 'Sterling,MA',
'01566': 'Sturbridge,MA',
'01568': 'Upton,MA',
'01569': 'Uxbridge,MA',
'01570': 'Webster,MA',
'01571': 'Dudley,MA',
'01580': 'Westborough,MA',
'01581': 'Westborough,MA',
'01582': 'Westborough,MA',
'01583': 'West Boylston,MA',
'01585': 'West Brookfield,MA',
'01586': 'West Millbury,MA',
'01588': 'Whitinsville,MA',
'01590': 'Sutton,MA',
'01601': 'Worcester,MA',
'01602': 'Worcester,MA',
'01603': 'Worcester,MA',
'01604': 'Worcester,MA',
'01605': 'Worcester,MA',
'01606': 'Worcester,MA',
'01607': 'Worcester,MA',
'01608': 'Worcester,MA',
'01609': 'Worcester,MA',
'01610': 'Worcester,MA',
'01611': 'Cherry Valley,MA',
'01612': 'Paxton,MA',
'01613': 'Worcester,MA',
'01614': 'Worcester,MA',
'01615': 'Worcester,MA',
'01653': 'Worcester,MA',
'01654': 'Worcester,MA',
'01655': 'Worcester,MA',
'01701': 'Framingham,MA',
'01702': 'Framingham,MA',
'01703': 'Framingham,MA',
'01704': 'Framingham,MA',
'01705': 'Framingham,MA',
'01718': 'Village Of Nagog Woods,MA',
'01719': 'Boxborough,MA',
'01720': 'Acton,MA',
'01721': 'Ashland,MA',
'01730': 'Bedford,MA',
'01731': 'Hanscom Afb,MA',
'01740': 'Bolton,MA',
'01741': 'Carlisle,MA',
'01742': 'Concord,MA',
'01745': 'Fayville,MA',
'01746': 'Holliston,MA',
'01747': 'Hopedale,MA',
'01748': 'Hopkinton,MA',
'01749': 'Hudson,MA',
'01752': 'Marlborough,MA',
'01754': 'Maynard,MA',
'01756': 'Mendon,MA',
'01757': 'Milford,MA',
'01760': 'Natick,MA',
'01770': 'Sherborn,MA',
'01772': 'Southborough,MA',
'01773': 'Lincoln,MA',
'01775': 'Stow,MA',
'01776': 'Sudbury,MA',
'01778': 'Wayland,MA',
'01784': 'Woodville,MA',
'01801': 'Woburn,MA',
'01803': 'Burlington,MA',
'01805': 'Burlington,MA',
'01806': 'Woburn,MA',
'01807': 'Woburn,MA',
'01808': 'Woburn,MA',
'01810': 'Andover,MA',
'01812': 'Andover,MA',
'01813': 'Woburn,MA',
'01815': 'Woburn,MA',
'01821': 'Billerica,MA',
'01822': 'Billerica,MA',
'01824': 'Chelmsford,MA',
'01826': 'Dracut,MA',
'01827': 'Dunstable,MA',
'01830': 'Haverhill,MA',
'01831': 'Haverhill,MA',
'01832': 'Haverhill,MA',
'01833': 'Georgetown,MA',
'01834': 'Groveland,MA',
'01835': 'Haverhill,MA',
'01840': 'Lawrence,MA',
'01841': 'Lawrence,MA',
'01842': 'Lawrence,MA',
'01843': 'Lawrence,MA',
'01844': 'Methuen,MA',
'01845': 'North Andover,MA',
'01850': 'Lowell,MA',
'01851': 'Lowell,MA',
'01852': 'Lowell,MA',
'01853': 'Lowell,MA',
'01854': 'Lowell,MA',
'01860': 'Merrimac,MA',
'01862': 'North Billerica,MA',
'01863': 'North Chelmsford,MA',
'01864': 'North Reading,MA',
'01865': 'Nutting Lake,MA',
'01866': 'Pinehurst,MA',
'01867': 'Reading,MA',
'01876': 'Tewksbury,MA',
'01879': 'Tyngsboro,MA',
'01880': 'Wakefield,MA',
'01885': 'West Boxford,MA',
'01886': 'Westford,MA',
'01887': 'Wilmington,MA',
'01888': 'Woburn,MA',
'01889': 'North Reading,MA',
'01890': 'Winchester,MA',
'01899': 'Andover,MA',
'01901': 'Lynn,MA',
'01902': 'Lynn,MA',
'01903': 'Lynn,MA',
'01904': 'Lynn,MA',
'01905': 'Lynn,MA',
'01906': 'Saugus,MA',
'01907': 'Swampscott,MA',
'01908': 'Nahant,MA',
'01910': 'Lynn,MA',
'01913': 'Amesbury,MA',
'01915': 'Beverly,MA',
'01921': 'Boxford,MA',
'01922': 'Byfield,MA',
'01923': 'Danvers,MA',
'01929': 'Essex,MA',
'01930': 'Gloucester,MA',
'01931': 'Gloucester,MA',
'01936': 'Hamilton,MA',
'01937': 'Hathorne,MA',
'01938': 'Ipswich,MA',
'01940': 'Lynnfield,MA',
'01944': 'Manchester,MA',
'01945': 'Marblehead,MA',
'01949': 'Middleton,MA',
'01950': 'Newburyport,MA',
'01951': 'Newbury,MA',
'01952': 'Salisbury,MA',
'01960': 'Peabody,MA',
'01961': 'Peabody,MA',
'01965': 'Prides Crossing,MA',
'01966': 'Rockport,MA',
'01969': 'Rowley,MA',
'01970': 'Salem,MA',
'01971': 'Salem,MA',
'01982': 'South Hamilton,MA',
'01983': 'Topsfield,MA',
'01984': 'Wenham,MA',
'01985': 'West Newbury,MA',
'02018': 'Accord,MA',
'02019': 'Bellingham,MA',
'02020': 'Brant Rock,MA',
'02021': 'Canton,MA',
'02025': 'Cohasset,MA',
'02026': 'Dedham,MA',
'02027': 'Dedham,MA',
'02030': 'Dover,MA',
'02031': 'East Mansfield,MA',
'02032': 'East Walpole,MA',
'02035': 'Foxboro,MA',
'02038': 'Franklin,MA',
'02040': 'Greenbush,MA',
'02041': 'Green Harbor,MA',
'02043': 'Hingham,MA',
'02044': 'Hingham,MA',
'02045': 'Hull,MA',
'02047': 'Humarock,MA',
'02048': 'Mansfield,MA',
'02050': 'Marshfield,MA',
'02051': 'Marshfield Hills,MA',
'02052': 'Medfield,MA',
'02053': 'Medway,MA',
'02054': 'Millis,MA',
'02055': 'Minot,MA',
'02056': 'Norfolk,MA',
'02059': 'North Marshfield,MA',
'02060': 'North Scituate,MA',
'02061': 'Norwell,MA',
'02062': 'Norwood,MA',
'02065': 'Ocean Bluff,MA',
'02066': 'Scituate,MA',
'02067': 'Sharon,MA',
'02070': 'Sheldonville,MA',
'02071': 'South Walpole,MA',
'02072': 'Stoughton,MA',
'02081': 'Walpole,MA',
'02090': 'Westwood,MA',
'02093': 'Wrentham,MA',
'02101': 'Boston,MA',
'02102': 'Boston,MA',
'02103': 'Boston,MA',
'02104': 'Boston,MA',
'02105': 'Boston,MA',
'02106': 'Boston,MA',
'02107': 'Boston,MA',
'02108': 'Boston,MA',
'02109': 'Boston,MA',
'02110': 'Boston,MA',
'02111': 'Boston,MA',
'02112': 'Boston,MA',
'02113': 'Boston,MA',
'02114': 'Boston,MA',
'02115': 'Boston,MA',
'02116': 'Boston,MA',
'02117': 'Boston,MA',
'02118': 'Boston,MA',
'02119': 'Boston,MA',
'02120': 'Boston,MA',
'02121': 'Boston,MA',
'02122': 'Boston,MA',
'02123': 'Boston,MA',
'02124': 'Boston,MA',
'02125': 'Boston,MA',
'02126': 'Mattapan,MA',
'02127': 'Boston,MA',
'02128': 'Boston,MA',
'02129': 'Charlestown,MA',
'02130': 'Jamaica Plain,MA',
'02131': 'Roslindale,MA',
'02132': 'West Roxbury,MA',
'02133': 'Boston,MA',
'02134': 'Allston,MA',
'02135': 'Brighton,MA',
'02136': 'Hyde Park,MA',
'02137': 'Readville,MA',
'02138': 'Cambridge,MA',
'02139': 'Cambridge,MA',
'02140': 'Cambridge,MA',
'02141': 'Cambridge,MA',
'02142': 'Cambridge,MA',
'02143': 'Somerville,MA',
'02144': 'Somerville,MA',
'02145': 'Somerville,MA',
'02148': 'Malden,MA',
'02149': 'Everett,MA',
'02150': 'Chelsea,MA',
'02151': 'Revere,MA',
'02152': 'Winthrop,MA',
'02153': 'Medford,MA',
'02155': 'Medford,MA',
'02156': 'West Medford,MA',
'02163': 'Boston,MA',
'02169': 'Quincy,MA',
'02170': 'Quincy,MA',
'02171': 'Quincy,MA',
'02176': 'Melrose,MA',
'02177': 'Melrose,MA',
'02180': 'Stoneham,MA',
'02184': 'Braintree,MA',
'02185': 'Braintree,MA',
'02186': 'Milton,MA',
'02187': 'Milton Village,MA',
'02188': 'Weymouth,MA',
'02189': 'Weymouth,MA',
'02190': 'Weymouth,MA',
'02191': 'Weymouth,MA',
'02196': 'Boston,MA',
'02199': 'Boston,MA',
'02201': 'Boston,MA',
'02202': 'Boston,MA',
'02203': 'Boston,MA',
'02204': 'Boston,MA',
'02205': 'Boston,MA',
'02206': 'Boston,MA',
'02207': 'Boston,MA',
'02208': 'Boston,MA',
'02209': 'Boston,MA',
'02210': 'Boston,MA',
'02211': 'Boston,MA',
'02212': 'Boston,MA',
'02215': 'Boston,MA',
'02216': 'Boston,MA',
'02217': 'Boston,MA',
'02222': 'Boston,MA',
'02228': 'East Boston,MA',
'02238': 'Cambridge,MA',
'02239': 'Cambridge,MA',
'02241': 'Boston,MA',
'02266': 'Boston,MA',
'02269': 'Quincy,MA',
'02283': 'Boston,MA',
'02284': 'Boston,MA',
'02293': 'Boston,MA',
'02295': 'Boston,MA',
'02297': 'Boston,MA',
'02298': 'Boston,MA',
'02301': 'Brockton,MA',
'02302': 'Brockton,MA',
'02303': 'Brockton,MA',
'02304': 'Brockton,MA',
'02305': 'Brockton,MA',
'02322': 'Avon,MA',
'02324': 'Bridgewater,MA',
'02325': 'Bridgewater,MA',
'02327': 'Bryantville,MA',
'02330': 'Carver,MA',
'02331': 'Duxbury,MA',
'02332': 'Duxbury,MA',
'02333': 'East Bridgewater,MA',
'02334': 'Easton,MA',
'02337': 'Elmwood,MA',
'02338': 'Halifax,MA',
'02339': 'Hanover,MA',
'02340': 'Hanover,MA',
'02341': 'Hanson,MA',
'02343': 'Holbrook,MA',
'02344': 'Middleboro,MA',
'02345': 'Manomet,MA',
'02346': 'Middleboro,MA',
'02347': 'Lakeville,MA',
'02348': 'Middleboro,MA',
'02349': 'Middleboro,MA',
'02350': 'Monponsett,MA',
'02351': 'Abington,MA',
'02355': 'North Carver,MA',
'02356': 'North Easton,MA',
'02357': 'North Easton,MA',
'02358': 'North Pembroke,MA',
'02359': 'Pembroke,MA',
'02360': 'Plymouth,MA',
'02361': 'Plymouth,MA',
'02362': 'Plymouth,MA',
'02364': 'Kingston,MA',
'02366': 'South Carver,MA',
'02367': 'Plympton,MA',
'02368': 'Randolph,MA',
'02370': 'Rockland,MA',
'02375': 'South Easton,MA',
'02379': 'West Bridgewater,MA',
'02381': 'White Horse Beach,MA',
'02382': 'Whitman,MA',
'02420': 'Lexington,MA',
'02421': 'Lexington,MA',
'02445': 'Brookline,MA',
'02446': 'Brookline,MA',
'02447': 'Brookline Village,MA',
'02451': 'Waltham,MA',
'02452': 'Waltham,MA',
'02453': 'Waltham,MA',
'02454': 'Waltham,MA',
'02455': 'North Waltham,MA',
'02456': 'New Town,MA',
'02457': 'Babson Park,MA',
'02458': 'Newton,MA',
'02459': 'Newton Center,MA',
'02460': 'Newtonville,MA',
'02461': 'Newton Highlands,MA',
'02462': 'Newton Lower Falls,MA',
'02464': 'Newton Upper Falls,MA',
'02465': 'West Newton,MA',
'02466': 'Auburndale,MA',
'02467': 'Chestnut Hill,MA',
'02468': 'Waban,MA',
'02471': 'Watertown,MA',
'02472': 'Watertown,MA',
'02474': 'Arlington,MA',
'02475': 'Arlington Heights,MA',
'02476': 'Arlington,MA',
'02477': 'Watertown,MA',
'02478': 'Belmont,MA',
'02479': 'Waverley,MA',
'02481': 'Wellesley Hills,MA',
'02482': 'Wellesley,MA',
'02492': 'Needham,MA',
'02493': 'Weston,MA',
'02494': 'Needham Heights,MA',
'02495': 'Nonantum,MA',
'02532': 'Buzzards Bay,MA',
'02534': 'Cataumet,MA',
'02535': 'Chilmark,MA',
'02536': 'East Falmouth,MA',
'02537': 'East Sandwich,MA',
'02538': 'East Wareham,MA',
'02539': 'Edgartown,MA',
'02540': 'Falmouth,MA',
'02541': 'Falmouth,MA',
'02542': 'Buzzards Bay,MA',
'02543': 'Woods Hole,MA',
'02552': 'Menemsha,MA',
'02553': 'Monument Beach,MA',
'02554': 'Nantucket,MA',
'02556': 'North Falmouth,MA',
'02557': 'Oak Bluffs,MA',
'02558': 'Onset,MA',
'02559': 'Pocasset,MA',
'02561': 'Sagamore,MA',
'02562': 'Sagamore Beach,MA',
'02563': 'Sandwich,MA',
'02564': 'Siasconset,MA',
'02565': 'Silver Beach,MA',
'02568': 'Vineyard Haven,MA',
'02571': 'Wareham,MA',
'02573': 'West Chop,MA',
'02574': 'West Falmouth,MA',
'02575': 'West Tisbury,MA',
'02576': 'West Wareham,MA',
'02584': 'Nantucket,MA',
'02601': 'Hyannis,MA',
'02630': 'Barnstable,MA',
'02631': 'Brewster,MA',
'02632': 'Centerville,MA',
'02633': 'Chatham,MA',
'02634': 'Centerville,MA',
'02635': 'Cotuit,MA',
'02636': 'Centerville,MA',
'02637': 'Cummaquid,MA',
'02638': 'Dennis,MA',
'02639': 'Dennis Port,MA',
'02641': 'East Dennis,MA',
'02642': 'Eastham,MA',
'02643': 'East Orleans,MA',
'02644': 'Forestdale,MA',
'02645': 'Harwich,MA',
'02646': 'Harwich Port,MA',
'02647': 'Hyannis Port,MA',
'02648': 'Marstons Mills,MA',
'02649': 'Mashpee,MA',
'02650': 'North Chatham,MA',
'02651': 'North Eastham,MA',
'02652': 'North Truro,MA',
'02653': 'Orleans,MA',
'02655': 'Osterville,MA',
'02657': 'Provincetown,MA',
'02659': 'South Chatham,MA',
'02660': 'South Dennis,MA',
'02661': 'South Harwich,MA',
'02662': 'South Orleans,MA',
'02663': 'South Wellfleet,MA',
'02664': 'South Yarmouth,MA',
'02666': 'Truro,MA',
'02667': 'Wellfleet,MA',
'02668': 'West Barnstable,MA',
'02669': 'West Chatham,MA',
'02670': 'West Dennis,MA',
'02671': 'West Harwich,MA',
'02672': 'West Hyannisport,MA',
'02673': 'West Yarmouth,MA',
'02675': 'Yarmouth Port,MA',
'02702': 'Assonet,MA',
'02703': 'Attleboro,MA',
'02712': 'Chartley,MA',
'02713': 'Cuttyhunk,MA',
'02714': 'Dartmouth,MA',
'02715': 'Dighton,MA',
'02717': 'East Freetown,MA',
'02718': 'East Taunton,MA',
'02719': 'Fairhaven,MA',
'02720': 'Fall River,MA',
'02721': 'Fall River,MA',
'02722': 'Fall River,MA',
'02723': 'Fall River,MA',
'02724': 'Fall River,MA',
'02725': 'Somerset,MA',
'02726': 'Somerset,MA',
'02738': 'Marion,MA',
'02739': 'Mattapoisett,MA',
'02740': 'New Bedford,MA',
'02741': 'New Bedford,MA',
'02742': 'New Bedford,MA',
'02743': 'Acushnet,MA',
'02744': 'New Bedford,MA',
'02745': 'New Bedford,MA',
'02746': 'New Bedford,MA',
'02747': 'North Dartmouth,MA',
'02748': 'South Dartmouth,MA',
'02760': 'North Attleboro,MA',
'02761': 'North Attleboro,MA',
'02762': 'Plainville,MA',
'02763': 'Attleboro Falls,MA',
'02764': 'North Dighton,MA',
'02766': 'Norton,MA',
'02767': 'Raynham,MA',
'02768': 'Raynham Center,MA',
'02769': 'Rehoboth,MA',
'02770': 'Rochester,MA',
'02771': 'Seekonk,MA',
'02777': 'Swansea,MA',
'02779': 'Berkley,MA',
'02780': 'Taunton,MA',
'02783': 'Taunton,MA',
'02790': 'Westport,MA',
'02791': 'Westport Point,MA',
'02801': 'Adamsville,RI',
'02802': 'Albion,RI',
'02804': 'Ashaway,RI',
'02806': 'Barrington,RI',
'02807': 'Block Island,RI',
'02808': 'Bradford,RI',
'02809': 'Bristol,RI',
'02812': 'Carolina,RI',
'02813': 'Charlestown,RI',
'02814': 'Chepachet,RI',
'02815': 'Clayville,RI',
'02816': 'Coventry,RI',
'02817': 'West Greenwich,RI',
'02818': 'East Greenwich,RI',
'02822': 'Exeter,RI',
'02823': 'Fiskeville,RI',
'02824': 'Forestdale,RI',
'02825': 'Foster,RI',
'02826': 'Glendale,RI',
'02827': 'Greene,RI',
'02828': 'Greenville,RI',
'02829': 'Harmony,RI',
'02830': 'Harrisville,RI',
'02831': 'Hope,RI',
'02832': 'Hope Valley,RI',
'02833': 'Hopkinton,RI',
'02835': 'Jamestown,RI',
'02836': 'Kenyon,RI',
'02837': 'Little Compton,RI',
'02838': 'Manville,RI',
'02839': 'Mapleville,RI',
'02840': 'Newport,RI',
'02841': 'Newport,RI',
'02842': 'Middletown,RI',
'02852': 'North Kingstown,RI',
'02854': 'North Kingstown,RI',
'02857': 'North Scituate,RI',
'02858': 'Oakland,RI',
'02859': 'Pascoag,RI',
'02860': 'Pawtucket,RI',
'02861': 'Pawtucket,RI',
'02862': 'Pawtucket,RI',
'02863': 'Central Falls,RI',
'02864': 'Cumberland,RI',
'02865': 'Lincoln,RI',
'02871': 'Portsmouth,RI',
'02872': 'Prudence Island,RI',
'02873': 'Rockville,RI',
'02874': 'Saunderstown,RI',
'02875': 'Shannock,RI',
'02876': 'Slatersville,RI',
'02877': 'Slocum,RI',
'02878': 'Tiverton,RI',
'02879': 'Wakefield,RI',
'02880': 'Wakefield,RI',
'02881': 'Kingston,RI',
'02882': 'Narragansett,RI',
'02883': 'Peace Dale,RI',
'02885': 'Warren,RI',
'02886': 'Warwick,RI',
'02887': 'Warwick,RI',
'02888': 'Warwick,RI',
'02889': 'Warwick,RI',
'02891': 'Westerly,RI',
'02892': 'West Kingston,RI',
'02893': 'West Warwick,RI',
'02894': 'Wood River Junction,RI',
'02895': 'Woonsocket,RI',
'02896': 'North Smithfield,RI',
'02898': 'Wyoming,RI',
'02901': 'Providence,RI',
'02902': 'Providence,RI',
'02903': 'Providence,RI',
'02904': 'Providence,RI',
'02905': 'Providence,RI',
'02906': 'Providence,RI',
'02907': 'Providence,RI',
'02908': 'Providence,RI',
'02909': 'Providence,RI',
'02910': 'Cranston,RI',
'02911': 'North Providence,RI',
'02912': 'Providence,RI',
'02914': 'East Providence,RI',
'02915': 'Riverside,RI',
'02916': 'Rumford,RI',
'02917': 'Smithfield,RI',
'02918': 'Providence,RI',
'02919': 'Johnston,RI',
'02920': 'Cranston,RI',
'02921': 'Cranston,RI',
'02940': 'Providence,RI',
'03031': 'Amherst,NH',
'03032': 'Auburn,NH',
'03033': 'Brookline,NH',
'03034': 'Candia,NH',
'03036': 'Chester,NH',
'03037': 'Deerfield,NH',
'03038': 'Derry,NH',
'03040': 'East Candia,NH',
'03041': 'East Derry,NH',
'03042': 'Epping,NH',
'03043': 'Francestown,NH',
'03044': 'Fremont,NH',
'03045': 'Goffstown,NH',
'03046': 'Dunbarton,NH',
'03047': 'Greenfield,NH',
'03048': 'Greenville,NH',
'03049': 'Hollis,NH',
'03051': 'Hudson,NH',
'03052': 'Litchfield,NH',
'03053': 'Londonderry,NH',
'03054': 'Merrimack,NH',
'03055': 'Milford,NH',
'03057': 'Mont Vernon,NH',
'03060': 'Nashua,NH',
'03061': 'Nashua,NH',
'03062': 'Nashua,NH',
'03063': 'Nashua,NH',
'03064': 'Nashua,NH',
'03070': 'New Boston,NH',
'03071': 'New Ipswich,NH',
'03073': 'North Salem,NH',
'03076': 'Pelham,NH',
'03077': 'Raymond,NH',
'03079': 'Salem,NH',
'03082': 'Lyndeborough,NH',
'03084': 'Temple,NH',
'03086': 'Wilton,NH',
'03087': 'Windham,NH',
'03101': 'Manchester,NH',
'03102': 'Manchester,NH',
'03103': 'Manchester,NH',
'03104': 'Manchester,NH',
'03105': 'Manchester,NH',
'03106': 'Hooksett,NH',
'03107': 'Manchester,NH',
'03108': 'Manchester,NH',
'03109': 'Manchester,NH',
'03110': 'Bedford,NH',
'03111': 'Manchester,NH',
'03215': 'Waterville Valley,NH',
'03216': 'Andover,NH',
'03217': 'Ashland,NH',
'03218': 'Barnstead,NH',
'03220': 'Belmont,NH',
'03221': 'Bradford,NH',
'03222': 'Bristol,NH',
'03223': 'Campton,NH',
'03224': 'Canterbury,NH',
'03225': 'Center Barnstead,NH',
'03226': 'Center Harbor,NH',
'03227': 'Center Sandwich,NH',
'03229': 'Contoocook,NH',
'03230': 'Danbury,NH',
'03231': 'East Andover,NH',
'03232': 'East Hebron,NH',
'03233': 'Elkins,NH',
'03234': 'Epsom,NH',
'03235': 'Franklin,NH',
'03237': 'Gilmanton,NH',
'03238': 'Glencliff,NH',
'03240': 'Grafton,NH',
'03241': 'Hebron,NH',
'03242': 'Henniker,NH',
'03243': 'Hill,NH',
'03244': 'Hillsboro,NH',
'03245': 'Holderness,NH',
'03246': 'Laconia,NH',
'03247': 'Laconia,NH',
'03249': 'Gilford,NH',
'03251': 'Lincoln,NH',
'03252': 'Lochmere,NH',
'03253': 'Meredith,NH',
'03254': 'Moultonborough,NH',
'03255': 'Newbury,NH',
'03256': 'New Hampton,NH',
'03257': 'New London,NH',
'03258': 'Chichester,NH',
'03259': 'North Sandwich,NH',
'03260': 'North Sutton,NH',
'03261': 'Northwood,NH',
'03262': 'North Woodstock,NH',
'03263': 'Pittsfield,NH',
'03264': 'Plymouth,NH',
'03266': 'Rumney,NH',
'03268': 'Salisbury,NH',
'03269': 'Sanbornton,NH',
'03272': 'South Newbury,NH',
'03273': 'South Sutton,NH',
'03274': 'Stinson Lake,NH',
'03275': 'Suncook,NH',
'03276': 'Tilton,NH',
'03278': 'Warner,NH',
'03279': 'Warren,NH',
'03280': 'Washington,NH',
'03281': 'Weare,NH',
'03282': 'Wentworth,NH',
'03284': 'Springfield,NH',
'03287': 'Wilmot,NH',
'03289': 'Winnisquam,NH',
'03290': 'Nottingham,NH',
'03291': 'West Nottingham,NH',
'03293': 'Woodstock,NH',
'03298': 'Tilton,NH',
'03299': 'Tilton,NH',
'03301': 'Concord,NH',
'03302': 'Concord,NH',
'03303': 'Concord,NH',
'03304': 'Bow,NH',
'03305': 'Concord,NH',
'03307': 'Loudon,NH',
'03431': 'Keene,NH',
'03435': 'Keene,NH',
'03440': 'Antrim,NH',
'03441': 'Ashuelot,NH',
'03442': 'Bennington,NH',
'03443': 'Chesterfield,NH',
'03444': 'Dublin,NH',
'03445': 'Sullivan,NH',
'03446': 'Swanzey,NH',
'03447': 'Fitzwilliam,NH',
'03448': 'Gilsum,NH',
'03449': 'Hancock,NH',
'03450': 'Harrisville,NH',
'03451': 'Hinsdale,NH',
'03452': 'Jaffrey,NH',
'03455': 'Marlborough,NH',
'03456': 'Marlow,NH',
'03457': 'Nelson,NH',
'03458': 'Peterborough,NH',
'03461': 'Rindge,NH',
'03462': 'Spofford,NH',
'03464': 'Stoddard,NH',
'03465': 'Troy,NH',
'03466': 'West Chesterfield,NH',
'03467': 'Westmoreland,NH',
'03468': 'West Peterborough,NH',
'03469': 'West Swanzey,NH',
'03470': 'Winchester,NH',
'03561': 'Littleton,NH',
'03570': 'Berlin,NH',
'03574': 'Bethlehem,NH',
'03575': 'Bretton Woods,NH',
'03576': 'Colebrook,NH',
'03579': 'Errol,NH',
'03580': 'Franconia,NH',
'03581': 'Gorham,NH',
'03582': 'Groveton,NH',
'03583': 'Jefferson,NH',
'03584': 'Lancaster,NH',
'03585': 'Lisbon,NH',
'03586': 'Sugar Hill,NH',
'03587': 'Meadows,NH',
'03588': 'Milan,NH',
'03589': 'Mount Washington,NH',
'03590': 'North Stratford,NH',
'03592': 'Pittsburg,NH',
'03593': 'Randolph,NH',
'03595': 'Twin Mountain,NH',
'03597': 'West Stewartstown,NH',
'03598': 'Whitefield,NH',
'03601': 'Acworth,NH',
'03602': 'Alstead,NH',
'03603': 'Charlestown,NH',
'03604': 'Drewsville,NH',
'03605': 'Lempster,NH',
'03607': 'South Acworth,NH',
'03608': 'Walpole,NH',
'03609': 'North Walpole,NH',
'03740': 'Bath,NH',
'03741': 'Canaan,NH',
'03743': 'Claremont,NH',
'03745': 'Cornish,NH',
'03746': 'Cornish Flat,NH',
'03748': 'Enfield,NH',
'03749': 'Enfield Center,NH',
'03750': 'Etna,NH',
'03751': 'Georges Mills,NH',
'03752': 'Goshen,NH',
'03753': 'Grantham,NH',
'03754': 'Guild,NH',
'03755': 'Hanover,NH',
'03756': 'Lebanon,NH',
'03765': 'Haverhill,NH',
'03766': 'Lebanon,NH',
'03768': 'Lyme,NH',
'03769': 'Lyme Center,NH',
'03770': 'Meriden,NH',
'03771': 'Monroe,NH',
'03773': 'Newport,NH',
'03774': 'North Haverhill,NH',
'03777': 'Orford,NH',
'03779': 'Piermont,NH',
'03780': 'Pike,NH',
'03781': 'Plainfield,NH',
'03782': 'Sunapee,NH',
'03784': 'West Lebanon,NH',
'03785': 'Woodsville,NH',
'03801': 'Portsmouth,NH',
'03802': 'Portsmouth,NH',
'03803': 'Portsmouth,NH',
'03804': 'Portsmouth,NH',
'03805': 'Rollinsford,NH',
'03809': 'Alton,NH',
'03810': 'Alton Bay,NH',
'03811': 'Atkinson,NH',
'03812': 'Bartlett,NH',
'03813': 'Center Conway,NH',
'03814': 'Center Ossipee,NH',
'03815': 'Center Strafford,NH',
'03816': 'Center Tuftonboro,NH',
'03817': 'Chocorua,NH',
'03818': 'Conway,NH',
'03819': 'Danville,NH',
'03820': 'Dover,NH',
'03821': 'Dover,NH',
'03822': 'Dover,NH',
'03823': 'Madbury,NH',
'03824': 'Durham,NH',
'03825': 'Barrington,NH',
'03826': 'East Hampstead,NH',
'03827': 'East Kingston,NH',
'03830': 'East Wakefield,NH',
'03832': 'Eaton Center,NH',
'03833': 'Exeter,NH',
'03835': 'Farmington,NH',
'03836': 'Freedom,NH',
'03837': 'Gilmanton Iron Works,NH',
'03838': 'Glen,NH',
'03839': 'Rochester,NH',
'03840': 'Greenland,NH',
'03841': 'Hampstead,NH',
'03842': 'Hampton,NH',
'03843': 'Hampton,NH',
'03844': 'Hampton Falls,NH',
'03845': 'Intervale,NH',
'03846': 'Jackson,NH',
'03847': 'Kearsarge,NH',
'03848': 'Kingston,NH',
'03849': 'Madison,NH',
'03850': 'Melvin Village,NH',
'03851': 'Milton,NH',
'03852': 'Milton Mills,NH',
'03853': 'Mirror Lake,NH',
'03854': 'New Castle,NH',
'03855': 'New Durham,NH',
'03856': 'Newfields,NH',
'03857': 'Newmarket,NH',
'03858': 'Newton,NH',
'03859': 'Newton Junction,NH',
'03860': 'North Conway,NH',
'03862': 'North Hampton,NH',
'03864': 'Ossipee,NH',
'03865': 'Plaistow,NH',
'03866': 'Rochester,NH',
'03867': 'Rochester,NH',
'03868': 'Rochester,NH',
'03869': 'Rollinsford,NH',
'03870': 'Rye,NH',
'03871': 'Rye Beach,NH',
'03872': 'Sanbornville,NH',
'03873': 'Sandown,NH',
'03874': 'Seabrook,NH',
'03875': 'Silver Lake,NH',
'03878': 'Somersworth,NH',
'03882': 'Effingham,NH',
'03883': 'South Tamworth,NH',
'03884': 'Strafford,NH',
'03885': 'Stratham,NH',
'03886': 'Tamworth,NH',
'03887': 'Union,NH',
'03890': 'West Ossipee,NH',
'03894': 'Wolfeboro,NH',
'03896': 'Wolfeboro Falls,NH',
'03897': 'Wonalancet,NH',
'03901': 'Berwick,ME',
'03902': 'Cape Neddick,ME',
'03903': 'Eliot,ME',
'03904': 'Kittery,ME',
'03905': 'Kittery Point,ME',
'03906': 'North Berwick,ME',
'03907': 'Ogunquit,ME',
'03908': 'South Berwick,ME',
'03909': 'York,ME',
'03910': 'York Beach,ME',
'03911': 'York Harbor,ME',
'04001': 'Acton,ME',
'04002': 'Alfred,ME',
'04003': 'Bailey Island,ME',
'04004': 'Bar Mills,ME',
'04005': 'Biddeford,ME',
'04006': 'Biddeford Pool,ME',
'04007': 'Biddeford,ME',
'04008': 'Bowdoinham,ME',
'04009': 'Bridgton,ME',
'04010': 'Brownfield,ME',
'04011': 'Brunswick,ME',
'04013': 'Bustins Island,ME',
'04014': 'Cape Porpoise,ME',
'04015': 'Casco,ME',
'04016': 'Center Lovell,ME',
'04017': 'Chebeague Island,ME',
'04019': 'Cliff Island,ME',
'04020': 'Cornish,ME',
'04021': 'Cumberland Center,ME',
'04022': 'Denmark,ME',
'04024': 'East Baldwin,ME',
'04027': 'Lebanon,ME',
'04028': 'East Parsonfield,ME',
'04029': 'Sebago,ME',
'04030': 'East Waterboro,ME',
'04032': 'Freeport,ME',
'04033': 'Freeport,ME',
'04034': 'Freeport,ME',
'04037': 'Fryeburg,ME',
'04038': 'Gorham,ME',
'04039': 'Gray,ME',
'04040': 'Harrison,ME',
'04041': 'Hiram,ME',
'04042': 'Hollis Center,ME',
'04043': 'Kennebunk,ME',
'04046': 'Kennebunkport,ME',
'04047': 'Parsonsfield,ME',
'04048': 'Limerick,ME',
'04049': 'Limington,ME',
'04050': 'Long Island,ME',
'04051': 'Lovell,ME',
'04053': 'Merepoint,ME',
'04054': 'Moody,ME',
'04055': 'Naples,ME',
'04056': 'Newfield,ME',
'04057': 'North Bridgton,ME',
'04061': 'North Waterboro,ME',
'04062': 'Windham,ME',
'04063': 'Ocean Park,ME',
'04064': 'Old Orchard Beach,ME',
'04066': 'Orrs Island,ME',
'04068': 'Porter,ME',
'04069': 'Pownal,ME',
'04070': 'Scarborough,ME',
'04071': 'Raymond,ME',
'04072': 'Saco,ME',
'04073': 'Sanford,ME',
'04074': 'Scarborough,ME',
'04075': 'Sebago Lake,ME',
'04076': 'Shapleigh,ME',
'04077': 'South Casco,ME',
'04078': 'South Freeport,ME',
'04079': 'Harpswell,ME',
'04081': 'South Waterford,ME',
'04082': 'South Windham,ME',
'04083': 'Springvale,ME',
'04084': 'Standish,ME',
'04085': 'Steep Falls,ME',
'04086': 'Topsham,ME',
'04087': 'Waterboro,ME',
'04088': 'Waterford,ME',
'04090': 'Wells,ME',
'04091': 'West Baldwin,ME',
'04092': 'Westbrook,ME',
'04093': 'Buxton,ME',
'04094': 'West Kennebunk,ME',
'04095': 'West Newfield,ME',
'04096': 'Yarmouth,ME',
'04097': 'North Yarmouth,ME',
'04098': 'Westbrook,ME',
'04101': 'Portland,ME',
'04102': 'Portland,ME',
'04103': 'Portland,ME',
'04104': 'Portland,ME',
'04105': 'Falmouth,ME',
'04106': 'South Portland,ME',
'04107': 'Cape Elizabeth,ME',
'04108': 'Peaks Island,ME',
'04109': 'Portland,ME',
'04110': 'Cumberland Foreside,ME',
'04112': 'Portland,ME',
'04116': 'South Portland,ME',
'04122': 'Portland,ME',
'04123': 'Portland,ME',
'04124': 'Portland,ME',
'04210': 'Auburn,ME',
'04211': 'Auburn,ME',
'04212': 'Auburn,ME',
'04216': 'Andover,ME',
'04217': 'Bethel,ME',
'04219': 'Bryant Pond,ME',
'04220': 'Buckfield,ME',
'04221': 'Canton,ME',
'04222': 'Durham,ME',
'04223': 'Danville,ME',
'04224': 'Dixfield,ME',
'04225': 'Dryden,ME',
'04226': 'East Andover,ME',
'04227': 'East Dixfield,ME',
'04228': 'East Livermore,ME',
'04230': 'East Poland,ME',
'04231': 'Stoneham,ME',
'04234': 'East Wilton,ME',
'04236': 'Greene,ME',
'04237': 'Hanover,ME',
'04238': 'Hebron,ME',
'04239': 'Jay,ME',
'04240': 'Lewiston,ME',
'04241': 'Lewiston,ME',
'04243': 'Lewiston,ME',
'04250': 'Lisbon,ME',
'04252': 'Lisbon Falls,ME',
'04253': 'Livermore,ME',
'04254': 'Livermore Falls,ME',
'04255': 'Greenwood,ME',
'04256': 'Mechanic Falls,ME',
'04257': 'Mexico,ME',
'04258': 'Minot,ME',
'04259': 'Monmouth,ME',
'04260': 'New Gloucester,ME',
'04261': 'Newry,ME',
'04262': 'North Jay,ME',
'04263': 'Leeds,ME',
'04265': 'North Monmouth,ME',
'04266': 'North Turner,ME',
'04267': 'North Waterford,ME',
'04268': 'Norway,ME',
'04270': 'Oxford,ME',
'04271': 'Paris,ME',
'04274': 'Poland,ME',
'04275': 'Roxbury,ME',
'04276': 'Rumford,ME',
'04278': 'Rumford Center,ME',
'04280': 'Sabattus,ME',
'04281': 'South Paris,ME',
'04282': 'Turner,ME',
'04283': 'Turner Center,ME',
'04284': 'Wayne,ME',
'04285': 'Weld,ME',
'04286': 'West Bethel,ME',
'04287': 'Bowdoin,ME',
'04288': 'West Minot,ME',
'04289': 'West Paris,ME',
'04290': 'Peru,ME',
'04291': 'West Poland,ME',
'04292': 'Sumner,ME',
'04294': 'Wilton,ME',
'04330': 'Augusta,ME',
'04332': 'Augusta,ME',
'04333': 'Augusta,ME',
'04336': 'Augusta,ME',
'04338': 'Augusta,ME',
'04341': 'Coopers Mills,ME',
'04342': 'Dresden,ME',
'04343': 'East Winthrop,ME',
'04344': 'Farmingdale,ME',
'04345': 'Gardiner,ME',
'04346': 'Randolph,ME',
'04347': 'Hallowell,ME',
'04348': 'Jefferson,ME',
'04349': 'Kents Hill,ME',
'04350': 'Litchfield,ME',
'04351': 'Manchester,ME',
'04352': 'Mount Vernon,ME',
'04353': 'Whitefield,ME',
'04354': 'Palermo,ME',
'04355': 'Readfield,ME',
'04357': 'Richmond,ME',
'04358': 'South China,ME',
'04359': 'South Gardiner,ME',
'04360': 'Vienna,ME',
'04363': 'Windsor,ME',
'04364': 'Winthrop,ME',
'04401': 'Bangor,ME',
'04402': 'Bangor,ME',
'04406': 'Abbot,ME',
'04408': 'Aurora,ME',
'04410': 'Bradford,ME',
'04411': 'Bradley,ME',
'04412': 'Brewer,ME',
'04413': 'Brookton,ME',
'04414': 'Brownville,ME',
'04415': 'Brownville Junction,ME',
'04416': 'Bucksport,ME',
'04417': 'Burlington,ME',
'04418': 'Greenbush,ME',
'04419': 'Carmel,ME',
'04420': 'Castine,ME',
'04421': 'Castine,ME',
'04422': 'Charleston,ME',
'04423': 'Costigan,ME',
'04424': 'Danforth,ME',
'04426': 'Dover Foxcroft,ME',
'04427': 'Corinth,ME',
'04428': 'Eddington,ME',
'04429': 'Holden,ME',
'04430': 'East Millinocket,ME',
'04431': 'East Orland,ME',
'04434': 'Etna,ME',
'04435': 'Exeter,ME',
'04438': 'Frankfort,ME',
'04441': 'Greenville,ME',
'04442': 'Greenville Junction,ME',
'04443': 'Guilford,ME',
'04444': 'Hampden,ME',
'04448': 'Howland,ME',
'04449': 'Hudson,ME',
'04450': 'Kenduskeag,ME',
'04451': 'Kingman,ME',
'04453': 'Lagrange,ME',
'04454': 'Lambert Lake,ME',
'04455': 'Lee,ME',
'04456': 'Levant,ME',
'04457': 'Lincoln,ME',
'04459': 'Mattawamkeag,ME',
'04460': 'Medway,ME',
'04461': 'Milford,ME',
'04462': 'Millinocket,ME',
'04463': 'Milo,ME',
'04464': 'Monson,ME',
'04467': 'Olamon,ME',
'04468': 'Old Town,ME',
'04469': 'Orono,ME',
'04471': 'Orient,ME',
'04472': 'Orland,ME',
'04473': 'Orono,ME',
'04474': 'Orrington,ME',
'04475': 'Passadumkeag,ME',
'04476': 'Penobscot,ME',
'04478': 'Rockwood,ME',
'04479': 'Sangerville,ME',
'04481': 'Sebec,ME',
'04485': 'Shirley Mills,ME',
'04487': 'Springfield,ME',
'04488': 'Stetson,ME',
'04489': 'Stillwater,ME',
'04490': 'Topsfield,ME',
'04491': 'Vanceboro,ME',
'04492': 'Waite,ME',
'04493': 'West Enfield,ME',
'04495': 'Winn,ME',
'04496': 'Winterport,ME',
'04497': 'Wytopitlock,ME',
'04530': 'Bath,ME',
'04535': 'Alna,ME',
'04536': 'Bayville,ME',
'04537': 'Boothbay,ME',
'04538': 'Boothbay Harbor,ME',
'04539': 'Bristol,ME',
'04541': 'Chamberlain,ME',
'04543': 'Damariscotta,ME',
'04544': 'East Boothbay,ME',
'04547': 'Friendship,ME',
'04548': 'Georgetown,ME',
'04549': 'Isle Of Springs,ME',
'04551': 'Bremen,ME',
'04552': 'Newagen,ME',
'04553': 'Newcastle,ME',
'04554': 'New Harbor,ME',
'04555': 'Nobleboro,ME',
'04556': 'Edgecomb,ME',
'04558': 'Pemaquid,ME',
'04562': 'Phippsburg,ME',
'04563': 'Cushing,ME',
'04564': 'Round Pond,ME',
'04565': 'Sebasco Estates,ME',
'04567': 'Small Point,ME',
'04568': 'South Bristol,ME',
'04570': 'Squirrel Island,ME',
'04571': 'Trevett,ME',
'04572': 'Waldoboro,ME',
'04573': 'Walpole,ME',
'04574': 'Washington,ME',
'04575': 'West Boothbay Harbor,ME',
'04576': 'Southport,ME',
'04578': 'Wiscasset,ME',
'04579': 'Woolwich,ME',
'04605': 'Ellsworth,ME',
'04606': 'Addison,ME',
'04607': 'Gouldsboro,ME',
'04609': 'Bar Harbor,ME',
'04611': 'Beals,ME',
'04612': 'Bernard,ME',
'04613': 'Birch Harbor,ME',
'04614': 'Blue Hill,ME',
'04615': 'Blue Hill Falls,ME',
'04616': 'Brooklin,ME',
'04617': 'Brooksville,ME',
'04619': 'Calais,ME',
'04622': 'Cherryfield,ME',
'04623': 'Columbia Falls,ME',
'04624': 'Corea,ME',
'04625': 'Cranberry Isles,ME',
'04626': 'Cutler,ME',
'04627': 'Deer Isle,ME',
'04628': 'Dennysville,ME',
'04629': 'East Blue Hill,ME',
'04630': 'East Machias,ME',
'04631': 'Eastport,ME',
'04634': 'Franklin,ME',
'04635': 'Frenchboro,ME',
'04637': 'Grand Lake Stream,ME',
'04640': 'Hancock,ME',
'04642': 'Harborside,ME',
'04643': 'Harrington,ME',
'04644': 'Hulls Cove,ME',
'04645': 'Isle Au Haut,ME',
'04646': 'Islesford,ME',
'04648': 'Jonesboro,ME',
'04649': 'Jonesport,ME',
'04650': 'Little Deer Isle,ME',
'04652': 'Lubec,ME',
'04653': 'Bass Harbor,ME',
'04654': 'Machias,ME',
'04655': 'Machiasport,ME',
'04656': 'Manset,ME',
'04657': 'Meddybemps,ME',
'04658': 'Milbridge,ME',
'04660': 'Mount Desert,ME',
'04662': 'Northeast Harbor,ME',
'04664': 'Sullivan,ME',
'04665': 'Otter Creek,ME',
'04666': 'Pembroke,ME',
'04667': 'Perry,ME',
'04668': 'Princeton,ME',
'04669': 'Prospect Harbor,ME',
'04671': 'Robbinston,ME',
'04672': 'Salsbury Cove,ME',
'04673': 'Sargentville,ME',
'04674': 'Seal Cove,ME',
'04675': 'Seal Harbor,ME',
'04676': 'Sedgwick,ME',
'04677': 'Sorrento,ME',
'04679': 'Southwest Harbor,ME',
'04680': 'Steuben,ME',
'04681': 'Stonington,ME',
'04683': 'Sunset,ME',
'04684': 'Surry,ME',
'04685': 'Swans Island,ME',
'04686': 'Wesley,ME',
'04690': 'West Tremont,ME',
'04691': 'Whiting,ME',
'04693': 'Winter Harbor,ME',
'04694': 'Baileyville,ME',
'04730': 'Houlton,ME',
'04732': 'Ashland,ME',
'04733': 'Benedicta,ME',
'04734': 'Blaine,ME',
'04735': 'Bridgewater,ME',
'04736': 'Caribou,ME',
'04737': 'Clayton Lake,ME',
'04738': 'Crouseville,ME',
'04739': 'Eagle Lake,ME',
'04740': 'Easton,ME',
'04741': 'Estcourt Station,ME',
'04742': 'Fort Fairfield,ME',
'04743': 'Fort Kent,ME',
'04744': 'Fort Kent Mills,ME',
'04745': 'Frenchville,ME',
'04746': 'Grand Isle,ME',
'04747': 'Island Falls,ME',
'04750': 'Limestone,ME',
'04751': 'Limestone,ME',
'04756': 'Madawaska,ME',
'04757': 'Mapleton,ME',
'04758': 'Mars Hill,ME',
'04759': 'Masardis,ME',
'04760': 'Monticello,ME',
'04761': 'New Limerick,ME',
'04762': 'New Sweden,ME',
'04763': 'Oakfield,ME',
'04764': 'Oxbow,ME',
'04765': 'Patten,ME',
'04766': 'Perham,ME',
'04768': 'Portage,ME',
'04769': 'Presque Isle,ME',
'04770': 'Quimby,ME',
'04772': 'Saint Agatha,ME',
'04773': 'Saint David,ME',
'04774': 'Saint Francis,ME',
'04775': 'Sheridan,ME',
'04776': 'Sherman Mills,ME',
'04777': 'Sherman Station,ME',
'04779': 'Sinclair,ME',
'04780': 'Smyrna Mills,ME',
'04781': 'Wallagrass,ME',
'04782': 'Stacyville,ME',
'04783': 'Stockholm,ME',
'04785': 'Van Buren,ME',
'04786': 'Washburn,ME',
'04787': 'Westfield,ME',
'04788': 'Winterville,ME',
'04841': 'Rockland,ME',
'04843': 'Camden,ME',
'04846': 'Glen Cove,ME',
'04847': 'Hope,ME',
'04848': 'Islesboro,ME',
'04849': 'Lincolnville,ME',
'04850': 'Lincolnville Center,ME',
'04851': 'Matinicus,ME',
'04852': 'Monhegan,ME',
'04853': 'North Haven,ME',
'04854': 'Owls Head,ME',
'04855': 'Port Clyde,ME',
'04856': 'Rockport,ME',
'04857': 'Saint George,ME',
'04858': 'South Thomaston,ME',
'04859': 'Spruce Head,ME',
'04860': 'Tenants Harbor,ME',
'04861': 'Thomaston,ME',
'04862': 'Union,ME',
'04863': 'Vinalhaven,ME',
'04864': 'Warren,ME',
'04865': 'West Rockport,ME',
'04901': 'Waterville,ME',
'04903': 'Waterville,ME',
'04910': 'Albion,ME',
'04911': 'Anson,ME',
'04912': 'Athens,ME',
'04915': 'Belfast,ME',
'04917': 'Belgrade,ME',
'04918': 'Belgrade Lakes,ME',
'04920': 'Bingham,ME',
'04921': 'Brooks,ME',
'04922': 'Burnham,ME',
'04923': 'Cambridge,ME',
'04924': 'Canaan,ME',
'04925': 'Caratunk,ME',
'04926': 'China Village,ME',
'04927': 'Clinton,ME',
'04928': 'Corinna,ME',
'04929': 'Detroit,ME',
'04930': 'Dexter,ME',
'04932': 'Dixmont,ME',
'04933': 'East Newport,ME',
'04935': 'East Vassalboro,ME',
'04936': 'Eustis,ME',
'04937': 'Fairfield,ME',
'04938': 'Farmington,ME',
'04939': 'Garland,ME',
'04940': 'Farmington Falls,ME',
'04941': 'Freedom,ME',
'04942': 'Harmony,ME',
'04943': 'Hartland,ME',
'04944': 'Hinckley,ME',
'04945': 'Jackman,ME',
'04947': 'Kingfield,ME',
'04949': 'Liberty,ME',
'04950': 'Madison,ME',
'04951': 'Monroe,ME',
'04952': 'Morrill,ME',
'04953': 'Newport,ME',
'04954': 'New Portland,ME',
'04955': 'New Sharon,ME',
'04956': 'New Vineyard,ME',
'04957': 'Norridgewock,ME',
'04958': 'North Anson,ME',
'04961': 'North New Portland,ME',
'04962': 'North Vassalboro,ME',
'04963': 'Oakland,ME',
'04964': 'Oquossoc,ME',
'04965': 'Palmyra,ME',
'04966': 'Phillips,ME',
'04967': 'Pittsfield,ME',
'04969': 'Plymouth,ME',
'04970': 'Rangeley,ME',
'04971': 'Saint Albans,ME',
'04972': 'Sandy Point,ME',
'04973': 'Searsmont,ME',
'04974': 'Searsport,ME',
'04975': 'Shawmut,ME',
'04976': 'Skowhegan,ME',
'04978': 'Smithfield,ME',
'04979': 'Solon,ME',
'04981': 'Stockton Springs,ME',
'04982': 'Stratton,ME',
'04983': 'Strong,ME',
'04984': 'Temple,ME',
'04985': 'West Forks,ME',
'04986': 'Thorndike,ME',
'04987': 'Troy,ME',
'04988': 'Unity,ME',
'04989': 'Vassalboro,ME',
'04992': 'West Farmington,ME',
'05001': 'White River Junction,VT',
'05009': 'White River Junction,VT',
'05030': 'Ascutney,VT',
'05031': 'Barnard,VT',
'05032': 'Bethel,VT',
'05033': 'Bradford,VT',
'05034': 'Bridgewater,VT',
'05035': 'Bridgewater Corners,VT',
'05036': 'Brookfield,VT',
'05037': 'Brownsville,VT',
'05038': 'Chelsea,VT',
'05039': 'Corinth,VT',
'05040': 'East Corinth,VT',
'05041': 'East Randolph,VT',
'05042': 'East Ryegate,VT',
'05043': 'East Thetford,VT',
'05045': 'Fairlee,VT',
'05046': 'Groton,VT',
'05047': 'Hartford,VT',
'05048': 'Hartland,VT',
'05049': 'Hartland Four Corners,VT',
'05050': 'Mc Indoe Falls,VT',
'05051': 'Newbury,VT',
'05052': 'North Hartland,VT',
'05053': 'North Pomfret,VT',
'05054': 'North Thetford,VT',
'05055': 'Norwich,VT',
'05056': 'Plymouth,VT',
'05058': 'Post Mills,VT',
'05059': 'Quechee,VT',
'05060': 'Randolph,VT',
'05061': 'Randolph Center,VT',
'05062': 'Reading,VT',
'05065': 'Sharon,VT',
'05067': 'South Pomfret,VT',
'05068': 'South Royalton,VT',
'05069': 'South Ryegate,VT',
'05070': 'South Strafford,VT',
'05071': 'South Woodstock,VT',
'05072': 'Strafford,VT',
'05073': 'Taftsville,VT',
'05074': 'Thetford,VT',
'05075': 'Thetford Center,VT',
'05076': 'East Corinth,VT',
'05077': 'Tunbridge,VT',
'05079': 'Vershire,VT',
'05081': 'Wells River,VT',
'05083': 'West Fairlee,VT',
'05084': 'West Hartford,VT',
'05085': 'West Newbury,VT',
'05086': 'West Topsham,VT',
'05088': 'Wilder,VT',
'05089': 'Windsor,VT',
'05091': 'Woodstock,VT',
'05101': 'Bellows Falls,VT',
'05141': 'Cambridgeport,VT',
'05142': 'Cavendish,VT',
'05143': 'Chester,VT',
'05144': 'Chester Depot,VT',
'05146': 'Grafton,VT',
'05148': 'Londonderry,VT',
'05149': 'Ludlow,VT',
'05150': 'North Springfield,VT',
'05151': 'Perkinsville,VT',
'05152': 'Peru,VT',
'05153': 'Proctorsville,VT',
'05154': 'Saxtons River,VT',
'05155': 'South Londonderry,VT',
'05156': 'Springfield,VT',
'05158': 'Westminster,VT',
'05159': 'Westminster Station,VT',
'05161': 'Weston,VT',
'05201': 'Bennington,VT',
'05250': 'Arlington,VT',
'05251': 'Dorset,VT',
'05252': 'East Arlington,VT',
'05253': 'East Dorset,VT',
'05254': 'Manchester,VT',
'05255': 'Manchester Center,VT',
'05257': 'North Bennington,VT',
'05260': 'North Pownal,VT',
'05261': 'Pownal,VT',
'05262': 'Shaftsbury,VT',
'05301': 'Brattleboro,VT',
'05302': 'Brattleboro,VT',
'05303': 'Brattleboro,VT',
'05304': 'Brattleboro,VT',
'05340': 'Bondville,VT',
'05341': 'East Dover,VT',
'05342': 'Jacksonville,VT',
'05343': 'Jamaica,VT',
'05344': 'Marlboro,VT',
'05345': 'Newfane,VT',
'05346': 'Putney,VT',
'05350': 'Readsboro,VT',
'05351': 'South Newfane,VT',
'05352': 'Stamford,VT',
'05353': 'Townshend,VT',
'05354': 'Vernon,VT',
'05355': 'Wardsboro,VT',
'05356': 'West Dover,VT',
'05357': 'West Dummerston,VT',
'05358': 'West Halifax,VT',
'05359': 'West Townshend,VT',
'05360': 'West Wardsboro,VT',
'05361': 'Whitingham,VT',
'05362': 'Williamsville,VT',
'05363': 'Wilmington,VT',
'05401': 'Burlington,VT',
'05402': 'Burlington,VT',
'05403': 'South Burlington,VT',
'05404': 'Winooski,VT',
'05405': 'Burlington,VT',
'05406': 'Burlington,VT',
'05407': 'South Burlington,VT',
'05408': 'North Burlington,VT',
'05439': 'Colchester,VT',
'05440': 'Alburg,VT',
'05441': 'Bakersfield,VT',
'05442': 'Belvidere Center,VT',
'05443': 'Bristol,VT',
'05444': 'Cambridge,VT',
'05445': 'Charlotte,VT',
'05446': 'Colchester,VT',
'05447': 'East Berkshire,VT',
'05448': 'East Fairfield,VT',
'05449': 'Colchester,VT',
'05450': 'Enosburg Falls,VT',
'05451': 'Essex,VT',
'05452': 'Essex Junction,VT',
'05453': 'Essex Junction,VT',
'05454': 'Fairfax,VT',
'05455': 'Fairfield,VT',
'05456': 'Ferrisburg,VT',
'05457': 'Franklin,VT',
'05458': 'Grand Isle,VT',
'05459': 'Highgate Center,VT',
'05460': 'Highgate Springs,VT',
'05461': 'Hinesburg,VT',
'05462': 'Huntington,VT',
'05463': 'Isle La Motte,VT',
'05464': 'Jeffersonville,VT',
'05465': 'Jericho,VT',
'05466': 'Jonesville,VT',
'05468': 'Milton,VT',
'05469': 'Monkton,VT',
'05470': 'Montgomery,VT',
'05471': 'Montgomery Center,VT',
'05472': 'New Haven,VT',
'05473': 'North Ferrisburg,VT',
'05474': 'North Hero,VT',
'05476': 'Richford,VT',
'05477': 'Richmond,VT',
'05478': 'Saint Albans,VT',
'05479': 'Saint Albans,VT',
'05481': 'Saint Albans Bay,VT',
'05482': 'Shelburne,VT',
'05483': 'Sheldon,VT',
'05485': 'Sheldon Springs,VT',
'05486': 'South Hero,VT',
'05487': 'Starksboro,VT',
'05488': 'Swanton,VT',
'05489': 'Underhill,VT',
'05490': 'Underhill Center,VT',
'05491': 'Vergennes,VT',
'05492': 'Waterville,VT',
'05494': 'Westford,VT',
'05495': 'Williston,VT',
'05501': 'Andover,MA',
'05544': 'Andover,MA',
'05601': 'Montpelier,VT',
'05602': 'Montpelier,VT',
'05603': 'Montpelier,VT',
'05604': 'Montpelier,VT',
'05609': 'Montpelier,VT',
'05620': 'Montpelier,VT',
'05633': 'Montpelier,VT',
'05640': 'Adamant,VT',
'05641': 'Barre,VT',
'05647': 'Cabot,VT',
'05648': 'Calais,VT',
'05649': 'East Barre,VT',
'05650': 'East Calais,VT',
'05651': 'East Montpelier,VT',
'05652': 'Eden,VT',
'05653': 'Eden Mills,VT',
'05654': 'Graniteville,VT',
'05655': 'Hyde Park,VT',
'05656': 'Johnson,VT',
'05657': 'Lake Elmore,VT',
'05658': 'Marshfield,VT',
'05660': 'Moretown,VT',
'05661': 'Morrisville,VT',
'05662': 'Moscow,VT',
'05663': 'Northfield,VT',
'05664': 'Northfield Falls,VT',
'05665': 'North Hyde Park,VT',
'05666': 'North Montpelier,VT',
'05667': 'Plainfield,VT',
'05669': 'Roxbury,VT',
'05670': 'South Barre,VT',
'05671': 'Waterbury,VT',
'05672': 'Stowe,VT',
'05673': 'Waitsfield,VT',
'05674': 'Warren,VT',
'05675': 'Washington,VT',
'05676': 'Waterbury,VT',
'05677': 'Waterbury Center,VT',
'05678': 'Websterville,VT',
'05679': 'Williamstown,VT',
'05680': 'Wolcott,VT',
'05681': 'Woodbury,VT',
'05682': 'Worcester,VT',
'05701': 'Rutland,VT',
'05702': 'Rutland,VT',
'05730': 'Belmont,VT',
'05731': 'Benson,VT',
'05732': 'Bomoseen,VT',
'05733': 'Brandon,VT',
'05734': 'Bridport,VT',
'05735': 'Castleton,VT',
'05736': 'Center Rutland,VT',
'05737': 'Chittenden,VT',
'05738': 'Cuttingsville,VT',
'05739': 'Danby,VT',
'05740': 'East Middlebury,VT',
'05741': 'East Poultney,VT',
'05742': 'East Wallingford,VT',
'05743': 'Fair Haven,VT',
'05744': 'Florence,VT',
'05745': 'Forest Dale,VT',
'05746': 'Gaysville,VT',
'05747': 'Granville,VT',
'05748': 'Hancock,VT',
'05750': 'Hydeville,VT',
'05751': 'Killington,VT',
'05753': 'Middlebury,VT',
'05757': 'Middletown Springs,VT',
'05758': 'Mount Holly,VT',
'05759': 'North Clarendon,VT',
'05760': 'Orwell,VT',
'05761': 'Pawlet,VT',
'05762': 'Pittsfield,VT',
'05763': 'Pittsford,VT',
'05764': 'Poultney,VT',
'05765': 'Proctor,VT',
'05766': 'Ripton,VT',
'05767': 'Rochester,VT',
'05768': 'Rupert,VT',
'05769': 'Salisbury,VT',
'05770': 'Shoreham,VT',
'05772': 'Stockbridge,VT',
'05773': 'Wallingford,VT',
'05774': 'Wells,VT',
'05775': 'West Pawlet,VT',
'05776': 'West Rupert,VT',
'05777': 'West Rutland,VT',
'05778': 'Whiting,VT',
'05819': 'Saint Johnsbury,VT',
'05820': 'Albany,VT',
'05821': 'Barnet,VT',
'05822': 'Barton,VT',
'05823': 'Beebe Plain,VT',
'05824': 'Concord,VT',
'05825': 'Coventry,VT',
'05826': 'Craftsbury,VT',
'05827': 'Craftsbury Common,VT',
'05828': 'Danville,VT',
'05829': 'Derby,VT',
'05830': 'Derby Line,VT',
'05832': 'East Burke,VT',
'05833': 'East Charleston,VT',
'05836': 'East Hardwick,VT',
'05837': 'East Haven,VT',
'05838': 'East Saint Johnsbury,VT',
'05839': 'Glover,VT',
'05840': 'Granby,VT',
'05841': 'Greensboro,VT',
'05842': 'Greensboro Bend,VT',
'05843': 'Hardwick,VT',
'05845': 'Irasburg,VT',
'05846': 'Island Pond,VT',
'05847': 'Lowell,VT',
'05848': 'Lower Waterford,VT',
'05849': 'Lyndon,VT',
'05850': 'Lyndon Center,VT',
'05851': 'Lyndonville,VT',
'05853': 'Morgan,VT',
'05855': 'Newport,VT',
'05857': 'Newport Center,VT',
'05858': 'North Concord,VT',
'05859': 'North Troy,VT',
'05860': 'Orleans,VT',
'05861': 'Passumpsic,VT',
'05862': 'Peacham,VT',
'05863': 'Saint Johnsbury Center,VT',
'05866': 'Sheffield,VT',
'05867': 'Sutton,VT',
'05868': 'Troy,VT',
'05871': 'West Burke,VT',
'05872': 'West Charleston,VT',
'05873': 'West Danville,VT',
'05874': 'Westfield,VT',
'05875': 'West Glover,VT',
'05901': 'Averill,VT',
'05902': 'Beecher Falls,VT',
'05903': 'Canaan,VT',
'05904': 'Gilman,VT',
'05905': 'Guildhall,VT',
'05906': 'Lunenburg,VT',
'05907': 'Norton,VT',
'06001': 'Avon,CT',
'06002': 'Bloomfield,CT',
'06006': 'Windsor,CT',
'06010': 'Bristol,CT',
'06011': 'Bristol,CT',
'06013': 'Burlington,CT',
'06016': 'Broad Brook,CT',
'06018': 'Canaan,CT',
'06019': 'Canton,CT',
'06020': 'Canton Center,CT',
'06021': 'Colebrook,CT',
'06022': 'Collinsville,CT',
'06023': 'East Berlin,CT',
'06024': 'East Canaan,CT',
'06025': 'East Glastonbury,CT',
'06026': 'East Granby,CT',
'06027': 'East Hartland,CT',
'06028': 'East Windsor Hill,CT',
'06029': 'Ellington,CT',
'06030': 'Farmington,CT',
'06031': 'Falls Village,CT',
'06032': 'Farmington,CT',
'06033': 'Glastonbury,CT',
'06034': 'Farmington,CT',
'06035': 'Granby,CT',
'06037': 'Berlin,CT',
'06039': 'Lakeville,CT',
'06040': 'Manchester,CT',
'06041': 'Manchester,CT',
'06042': 'Manchester,CT',
'06043': 'Bolton,CT',
'06045': 'Manchester,CT',
'06049': 'Melrose,CT',
'06050': 'New Britain,CT',
'06051': 'New Britain,CT',
'06052': 'New Britain,CT',
'06053': 'New Britain,CT',
'06057': 'New Hartford,CT',
'06058': 'Norfolk,CT',
'06059': 'North Canton,CT',
'06060': 'North Granby,CT',
'06061': 'Pine Meadow,CT',
'06062': 'Plainville,CT',
'06063': 'Barkhamsted,CT',
'06064': 'Poquonock,CT',
'06065': 'Riverton,CT',
'06066': 'Vernon Rockville,CT',
'06067': 'Rocky Hill,CT',
'06068': 'Salisbury,CT',
'06069': 'Sharon,CT',
'06070': 'Simsbury,CT',
'06071': 'Somers,CT',
'06072': 'Somersville,CT',
'06073': 'South Glastonbury,CT',
'06074': 'South Windsor,CT',
'06075': 'Stafford,CT',
'06076': 'Stafford Springs,CT',
'06077': 'Staffordville,CT',
'06078': 'Suffield,CT',
'06079': 'Taconic,CT',
'06080': 'Suffield,CT',
'06081': 'Tariffville,CT',
'06082': 'Enfield,CT',
'06083': 'Enfield,CT',
'06084': 'Tolland,CT',
'06085': 'Unionville,CT',
'06087': 'Unionville,CT',
'06088': 'East Windsor,CT',
'06089': 'Weatogue,CT',
'06090': 'West Granby,CT',
'06091': 'West Hartland,CT',
'06092': 'West Simsbury,CT',
'06093': 'West Suffield,CT',
'06094': 'Winchester Center,CT',
'06095': 'Windsor,CT',
'06096': 'Windsor Locks,CT',
'06098': 'Winsted,CT',
'06101': 'Hartford,CT',
'06102': 'Hartford,CT',
'06103': 'Hartford,CT',
'06104': 'Hartford,CT',
'06105': 'Hartford,CT',
'06106': 'Hartford,CT',
'06107': 'W Hartford,CT',
'06108': 'East Hartford,CT',
'06109': 'Wethersfield,CT',
'06110': 'W Hartford,CT',
'06111': 'Newington,CT',
'06112': 'Hartford,CT',
'06114': 'Hartford,CT',
'06115': 'Hartford,CT',
'06117': 'W Hartford,CT',
'06118': 'East Hartford,CT',
'06119': 'W Hartford,CT',
'06120': 'Hartford,CT',
'06123': 'Hartford,CT',
'06126': 'Hartford,CT',
'06127': 'W Hartford,CT',
'06128': 'East Hartford,CT',
'06129': 'Wethersfield,CT',
'06131': 'Newington,CT',
'06132': 'Hartford,CT',
'06133': 'W Hartford,CT',
'06134': 'Hartford,CT',
'06137': 'W Hartford,CT',
'06138': 'East Hartford,CT',
'06140': 'Hartford,CT',
'06141': 'Hartford,CT',
'06142': 'Hartford,CT',
'06143': 'Hartford,CT',
'06144': 'Hartford,CT',
'06145': 'Hartford,CT',
'06146': 'Hartford,CT',
'06147': 'Hartford,CT',
'06150': 'Hartford,CT',
'06151': 'Hartford,CT',
'06152': 'Hartford,CT',
'06153': 'Hartford,CT',
'06154': 'Hartford,CT',
'06155': 'Hartford,CT',
'06156': 'Hartford,CT',
'06160': 'Hartford,CT',
'06161': 'Hartford,CT',
'06167': 'Hartford,CT',
'06176': 'Hartford,CT',
'06180': 'Hartford,CT',
'06183': 'Hartford,CT',
'06199': 'Hartford,CT',
'06226': 'Willimantic,CT',
'06230': 'Abington,CT',
'06231': 'Amston,CT',
'06232': 'Andover,CT',
'06233': 'Ballouville,CT',
'06234': 'Brooklyn,CT',
'06235': 'Chaplin,CT',
'06237': 'Columbia,CT',
'06238': 'Coventry,CT',
'06239': 'Danielson,CT',
'06241': 'Dayville,CT',
'06242': 'Eastford,CT',
'06243': 'East Killingly,CT',
'06244': 'East Woodstock,CT',
'06245': 'Fabyan,CT',
'06246': 'Grosvenor Dale,CT',
'06247': 'Hampton,CT',
'06248': 'Hebron,CT',
'06249': 'Lebanon,CT',
'06250': 'Mansfield Center,CT',
'06251': 'Mansfield Depot,CT',
'06254': 'North Franklin,CT',
'06255': 'North Grosvenordale,CT',
'06256': 'North Windham,CT',
'06258': 'Pomfret,CT',
'06259': 'Pomfret Center,CT',
'06260': 'Putnam,CT',
'06262': 'Quinebaug,CT',
'06263': 'Rogers,CT',
'06264': 'Scotland,CT',
'06265': 'South Willington,CT',
'06266': 'South Windham,CT',
'06267': 'South Woodstock,CT',
'06268': 'Storrs Mansfield,CT',
'06269': 'Storrs Mansfield,CT',
'06277': 'Thompson,CT',
'06278': 'Ashford,CT',
'06279': 'Willington,CT',
'06280': 'Windham,CT',
'06281': 'Woodstock,CT',
'06282': 'Woodstock Valley,CT',
'06320': 'New London,CT',
'06330': 'Baltic,CT',
'06331': 'Canterbury,CT',
'06332': 'Central Village,CT',
'06333': 'East Lyme,CT',
'06334': 'Bozrah,CT',
'06335': 'Gales Ferry,CT',
'06336': 'Gilman,CT',
'06337': 'Glasgo,CT',
'06338': 'Mashantucket,CT',
'06339': 'Ledyard,CT',
'06340': 'Groton,CT',
'06349': 'Groton,CT',
'06350': 'Hanover,CT',
'06351': 'Jewett City,CT',
'06353': 'Montville,CT',
'06354': 'Moosup,CT',
'06355': 'Mystic,CT',
'06357': 'Niantic,CT',
'06359': 'North Stonington,CT',
'06360': 'Norwich,CT',
'06365': 'Preston,CT',
'06370': 'Oakdale,CT',
'06371': 'Old Lyme,CT',
'06372': 'Old Mystic,CT',
'06373': 'Oneco,CT',
'06374': 'Plainfield,CT',
'06375': 'Quaker Hill,CT',
'06376': 'South Lyme,CT',
'06377': 'Sterling,CT',
'06378': 'Stonington,CT',
'06379': 'Pawcatuck,CT',
'06380': 'Taftville,CT',
'06382': 'Uncasville,CT',
'06383': 'Versailles,CT',
'06384': 'Voluntown,CT',
'06385': 'Waterford,CT',
'06386': 'Waterford,CT',
'06387': 'Wauregan,CT',
'06388': 'West Mystic,CT',
'06389': 'Yantic,CT',
'06390': 'Fishers Island,NY',
'06401': 'Ansonia,CT',
'06403': 'Beacon Falls,CT',
'06404': 'Botsford,CT',
'06405': 'Branford,CT',
'06408': 'Cheshire,CT',
'06409': 'Centerbrook,CT',
'06410': 'Cheshire,CT',
'06411': 'Cheshire,CT',
'06412': 'Chester,CT',
'06413': 'Clinton,CT',
'06414': 'Cobalt,CT',
'06415': 'Colchester,CT',
'06416': 'Cromwell,CT',
'06417': 'Deep River,CT',
'06418': 'Derby,CT',
'06419': 'Killingworth,CT',
'06420': 'Salem,CT',
'06422': 'Durham,CT',
'06423': 'East Haddam,CT',
'06424': 'East Hampton,CT',
'06426': 'Essex,CT',
'06430': 'Fairfield,CT',
'06431': 'Fairfield,CT',
'06432': 'Fairfield,CT',
'06436': 'Greens Farms,CT',
'06437': 'Guilford,CT',
'06438': 'Haddam,CT',
'06439': 'Hadlyme,CT',
'06440': 'Hawleyville,CT',
'06441': 'Higganum,CT',
'06442': 'Ivoryton,CT',
'06443': 'Madison,CT',
'06444': 'Marion,CT',
'06447': 'Marlborough,CT',
'06450': 'Meriden,CT',
'06451': 'Meriden,CT',
'06454': 'Meriden,CT',
'06455': 'Middlefield,CT',
'06456': 'Middle Haddam,CT',
'06457': 'Middletown,CT',
'06459': 'Middletown,CT',
'06460': 'Milford,CT',
'06461': 'Milford,CT',
'06467': 'Milldale,CT',
'06468': 'Monroe,CT',
'06469': 'Moodus,CT',
'06470': 'Newtown,CT',
'06471': 'North Branford,CT',
'06472': 'Northford,CT',
'06473': 'North Haven,CT',
'06474': 'North Westchester,CT',
'06475': 'Old Saybrook,CT',
'06477': 'Orange,CT',
'06478': 'Oxford,CT',
'06479': 'Plantsville,CT',
'06480': 'Portland,CT',
'06481': 'Rockfall,CT',
'06482': 'Sandy Hook,CT',
'06483': 'Seymour,CT',
'06484': 'Shelton,CT',
'06487': 'South Britain,CT',
'06488': 'Southbury,CT',
'06489': 'Southington,CT',
'06490': 'Southport,CT',
'06491': 'Stevenson,CT',
'06492': 'Wallingford,CT',
'06493': 'Wallingford,CT',
'06494': 'Wallingford,CT',
'06495': 'Wallingford,CT',
'06497': 'Stratford,CT',
'06498': 'Westbrook,CT',
'06501': 'New Haven,CT',
'06502': 'New Haven,CT',
'06503': 'New Haven,CT',
'06504': 'New Haven,CT',
'06505': 'New Haven,CT',
'06506': 'New Haven,CT',
'06507': 'New Haven,CT',
'06508': 'New Haven,CT',
'06509': 'New Haven,CT',
'06510': 'New Haven,CT',
'06511': 'New Haven,CT',
'06512': 'East Haven,CT',
'06513': 'New Haven,CT',
'06514': 'Hamden,CT',
'06515': 'New Haven,CT',
'06516': 'West Haven,CT',
'06517': 'Hamden,CT',
'06518': 'Hamden,CT',
'06519': 'New Haven,CT',
'06520': 'New Haven,CT',
'06521': 'New Haven,CT',
'06524': 'Bethany,CT',
'06525': 'Woodbridge,CT',
'06530': 'New Haven,CT',
'06531': 'New Haven,CT',
'06532': 'New Haven,CT',
'06533': 'New Haven,CT',
'06534': 'New Haven,CT',
'06535': 'New Haven,CT',
'06536': 'New Haven,CT',
'06537': 'New Haven,CT',
'06538': 'New Haven,CT',
'06540': 'New Haven,CT',
'06601': 'Bridgeport,CT',
'06602': 'Bridgeport,CT',
'06604': 'Bridgeport,CT',
'06605': 'Bridgeport,CT',
'06606': 'Bridgeport,CT',
'06607': 'Bridgeport,CT',
'06608': 'Bridgeport,CT',
'06610': 'Bridgeport,CT',
'06611': 'Trumbull,CT',
'06612': 'Easton,CT',
'06614': 'Stratford,CT',
'06615': 'Stratford,CT',
'06650': 'Bridgeport,CT',
'06673': 'Bridgeport,CT',
'06699': 'Bridgeport,CT',
'06701': 'Waterbury,CT',
'06702': 'Waterbury,CT',
'06703': 'Waterbury,CT',
'06704': 'Waterbury,CT',
'06705': 'Waterbury,CT',
'06706': 'Waterbury,CT',
'06708': 'Waterbury,CT',
'06710': 'Waterbury,CT',
'06712': 'Prospect,CT',
'06716': 'Wolcott,CT',
'06720': 'Waterbury,CT',
'06721': 'Waterbury,CT',
'06722': 'Waterbury,CT',
'06723': 'Waterbury,CT',
'06724': 'Waterbury,CT',
'06725': 'Waterbury,CT',
'06726': 'Waterbury,CT',
'06749': 'Waterbury,CT',
'06750': 'Bantam,CT',
'06751': 'Bethlehem,CT',
'06752': 'Bridgewater,CT',
'06753': 'Cornwall,CT',
'06754': 'Cornwall Bridge,CT',
'06755': 'Gaylordsville,CT',
'06756': 'Goshen,CT',
'06757': 'Kent,CT',
'06758': 'Lakeside,CT',
'06759': 'Litchfield,CT',
'06762': 'Middlebury,CT',
'06763': 'Morris,CT',
'06770': 'Naugatuck,CT',
'06776': 'New Milford,CT',
'06777': 'New Preston Marble Dale,CT',
'06778': 'Northfield,CT',
'06779': 'Oakville,CT',
'06781': 'Pequabuck,CT',
'06782': 'Plymouth,CT',
'06783': 'Roxbury,CT',
'06784': 'Sherman,CT',
'06785': 'South Kent,CT',
'06786': 'Terryville,CT',
'06787': 'Thomaston,CT',
'06790': 'Torrington,CT',
'06791': 'Harwinton,CT',
'06792': 'Torrington,CT',
'06793': 'Washington,CT',
'06794': 'Washington Depot,CT',
'06795': 'Watertown,CT',
'06796': 'West Cornwall,CT',
'06798': 'Woodbury,CT',
'06801': 'Bethel,CT',
'06804': 'Brookfield,CT',
'06807': 'Cos Cob,CT',
'06810': 'Danbury,CT',
'06811': 'Danbury,CT',
'06812': 'New Fairfield,CT',
'06813': 'Danbury,CT',
'06814': 'Danbury,CT',
'06816': 'Danbury,CT',
'06817': 'Danbury,CT',
'06820': 'Darien,CT',
'06824': 'Fairfield,CT',
'06825': 'Fairfield,CT',
'06828': 'General Electric,CT',
'06829': 'Georgetown,CT',
'06830': 'Greenwich,CT',
'06831': 'Greenwich,CT',
'06832': 'Greenwich,CT',
'06836': 'Greenwich,CT',
'06838': 'Greens Farms,CT',
'06840': 'New Canaan,CT',
'06842': 'New Canaan,CT',
'06850': 'Norwalk,CT',
'06851': 'Norwalk,CT',
'06852': 'Norwalk,CT',
'06853': 'Norwalk,CT',
'06854': 'Norwalk,CT',
'06855': 'Norwalk,CT',
'06856': 'Norwalk,CT',
'06857': 'Norwalk,CT',
'06858': 'Norwalk,CT',
'06859': 'Norwalk,CT',
'06860': 'Norwalk,CT',
'06870': 'Old Greenwich,CT',
'06875': 'Redding Center,CT',
'06876': 'Redding Ridge,CT',
'06877': 'Ridgefield,CT',
'06878': 'Riverside,CT',
'06879': 'Ridgefield,CT',
'06880': 'Westport,CT',
'06881': 'Westport,CT',
'06883': 'Weston,CT',
'06888': 'Westport,CT',
'06889': 'Westport,CT',
'06890': 'Southport,CT',
'06896': 'Redding,CT',
'06897': 'Wilton,CT',
'06901': 'Stamford,CT',
'06902': 'Stamford,CT',
'06903': 'Stamford,CT',
'06904': 'Stamford,CT',
'06905': 'Stamford,CT',
'06906': 'Stamford,CT',
'06907': 'Stamford,CT',
'06910': 'Stamford,CT',
'06911': 'Stamford,CT',
'06912': 'Stamford,CT',
'06913': 'Stamford,CT',
'06914': 'Stamford,CT',
'06920': 'Stamford,CT',
'06921': 'Stamford,CT',
'06922': 'Stamford,CT',
'06925': 'Stamford,CT',
'06926': 'Stamford,CT',
'06927': 'Stamford,CT',
'06928': 'Stamford,CT',
'07001': 'Avenel,NJ',
'07002': 'Bayonne,NJ',
'07003': 'Bloomfield,NJ',
'07004': 'Fairfield,NJ',
'07005': 'Boonton,NJ',
'07006': 'Caldwell,NJ',
'07007': 'Caldwell,NJ',
'07008': 'Carteret,NJ',
'07009': 'Cedar Grove,NJ',
'07010': 'Cliffside Park,NJ',
'07011': 'Clifton,NJ',
'07012': 'Clifton,NJ',
'07013': 'Clifton,NJ',
'07014': 'Clifton,NJ',
'07015': 'Clifton,NJ',
'07016': 'Cranford,NJ',
'07017': 'East Orange,NJ',
'07018': 'East Orange,NJ',
'07019': 'East Orange,NJ',
'07020': 'Edgewater,NJ',
'07021': 'Essex Fells,NJ',
'07022': 'Fairview,NJ',
'07023': 'Fanwood,NJ',
'07024': 'Fort Lee,NJ',
'07026': 'Garfield,NJ',
'07027': 'Garwood,NJ',
'07028': 'Glen Ridge,NJ',
'07029': 'Harrison,NJ',
'07030': 'Hoboken,NJ',
'07031': 'North Arlington,NJ',
'07032': 'Kearny,NJ',
'07033': 'Kenilworth,NJ',
'07034': 'Lake Hiawatha,NJ',
'07035': 'Lincoln Park,NJ',
'07036': 'Linden,NJ',
'07039': 'Livingston,NJ',
'07040': 'Maplewood,NJ',
'07041': 'Millburn,NJ',
'07042': 'Montclair,NJ',
'07043': 'Montclair,NJ',
'07044': 'Verona,NJ',
'07045': 'Montville,NJ',
'07046': 'Mountain Lakes,NJ',
'07047': 'North Bergen,NJ',
'07050': 'Orange,NJ',
'07051': 'Orange,NJ',
'07052': 'West Orange,NJ',
'07054': 'Parsippany,NJ',
'07055': 'Passaic,NJ',
'07057': 'Wallington,NJ',
'07058': 'Pine Brook,NJ',
'07059': 'Warren,NJ',
'07060': 'Plainfield,NJ',
'07061': 'Plainfield,NJ',
'07062': 'Plainfield,NJ',
'07063': 'Plainfield,NJ',
'07064': 'Port Reading,NJ',
'07065': 'Rahway,NJ',
'07066': 'Clark,NJ',
'07067': 'Colonia,NJ',
'07068': 'Roseland,NJ',
'07069': 'Watchung,NJ',
'07070': 'Rutherford,NJ',
'07071': 'Lyndhurst,NJ',
'07072': 'Carlstadt,NJ',
'07073': 'East Rutherford,NJ',
'07074': 'Moonachie,NJ',
'07075': 'Wood Ridge,NJ',
'07076': 'Scotch Plains,NJ',
'07077': 'Sewaren,NJ',
'07078': 'Short Hills,NJ',
'07079': 'South Orange,NJ',
'07080': 'South Plainfield,NJ',
'07081': 'Springfield,NJ',
'07082': 'Towaco,NJ',
'07083': 'Union,NJ',
'07086': 'Weehawken,NJ',
'07087': 'Union City,NJ',
'07088': 'Vauxhall,NJ',
'07090': 'Westfield,NJ',
'07091': 'Westfield,NJ',
'07092': 'Mountainside,NJ',
'07093': 'West New York,NJ',
'07094': 'Secaucus,NJ',
'07095': 'Woodbridge,NJ',
'07096': 'Secaucus,NJ',
'07097': 'Jersey City,NJ',
'07099': 'Kearny,NJ',
'07101': 'Newark,NJ',
'07102': 'Newark,NJ',
'07103': 'Newark,NJ',
'07104': 'Newark,NJ',
'07105': 'Newark,NJ',
'07106': 'Newark,NJ',
'07107': 'Newark,NJ',
'07108': 'Newark,NJ',
'07109': 'Belleville,NJ',
'07110': 'Nutley,NJ',
'07111': 'Irvington,NJ',
'07112': 'Newark,NJ',
'07114': 'Newark,NJ',
'07175': 'Newark,NJ',
'07182': 'Newark,NJ',
'07184': 'Newark,NJ',
'07188': 'Newark,NJ',
'07189': 'Newark,NJ',
'07191': 'Newark,NJ',
'07192': 'Newark,NJ',
'07193': 'Newark,NJ',
'07194': 'Newark,NJ',
'07195': 'Newark,NJ',
'07197': 'Newark,NJ',
'07198': 'Newark,NJ',
'07199': 'Newark,NJ',
'07201': 'Elizabeth,NJ',
'07202': 'Elizabeth,NJ',
'07203': 'Roselle,NJ',
'07204': 'Roselle Park,NJ',
'07205': 'Hillside,NJ',
'07206': 'Elizabeth,NJ',
'07207': 'Elizabeth,NJ',
'07208': 'Elizabeth,NJ',
'07302': 'Jersey City,NJ',
'07303': 'Jersey City,NJ',
'07304': 'Jersey City,NJ',
'07305': 'Jersey City,NJ',
'07306': 'Jersey City,NJ',
'07307': 'Jersey City,NJ',
'07308': 'Jersey City,NJ',
'07309': 'Jersey City,NJ',
'07310': 'Jersey City,NJ',
'07311': 'Jersey City,NJ',
'07395': 'New Jersey Bmc,NJ',
'07399': 'Jersey City,NJ',
'07401': 'Allendale,NJ',
'07403': 'Bloomingdale,NJ',
'07405': 'Butler,NJ',
'07407': 'Elmwood Park,NJ',
'07410': 'Fair Lawn,NJ',
'07416': 'Franklin,NJ',
'07417': 'Franklin Lakes,NJ',
'07418': 'Glenwood,NJ',
'07419': 'Hamburg,NJ',
'07420': 'Haskell,NJ',
'07421': 'Hewitt,NJ',
'07422': 'Highland Lakes,NJ',
'07423': 'Ho Ho Kus,NJ',
'07424': 'Little Falls,NJ',
'07428': 'Mc Afee,NJ',
'07430': 'Mahwah,NJ',
'07432': 'Midland Park,NJ',
'07435': 'Newfoundland,NJ',
'07436': 'Oakland,NJ',
'07438': 'Oak Ridge,NJ',
'07439': 'Ogdensburg,NJ',
'07440': 'Pequannock,NJ',
'07442': 'Pompton Lakes,NJ',
'07444': 'Pompton Plains,NJ',
'07446': 'Ramsey,NJ',
'07450': 'Ridgewood,NJ',
'07451': 'Ridgewood,NJ',
'07452': 'Glen Rock,NJ',
'07456': 'Ringwood,NJ',
'07457': 'Riverdale,NJ',
'07458': 'Saddle River,NJ',
'07460': 'Stockholm,NJ',
'07461': 'Sussex,NJ',
'07462': 'Vernon,NJ',
'07463': 'Waldwick,NJ',
'07465': 'Wanaque,NJ',
'07470': 'Wayne,NJ',
'07474': 'Wayne,NJ',
'07477': 'Wayne,NJ',
'07480': 'West Milford,NJ',
'07481': 'Wyckoff,NJ',
'07495': 'Mahwah,NJ',
'07498': 'Mahwah,NJ',
'07501': 'Paterson,NJ',
'07502': 'Paterson,NJ',
'07503': 'Paterson,NJ',
'07504': 'Paterson,NJ',
'07505': 'Paterson,NJ',
'07506': 'Hawthorne,NJ',
'07507': 'Hawthorne,NJ',
'07508': 'Haledon,NJ',
'07509': 'Paterson,NJ',
'07510': 'Paterson,NJ',
'07511': 'Totowa,NJ',
'07512': 'Totowa,NJ',
'07513': 'Paterson,NJ',
'07514': 'Paterson,NJ',
'07522': 'Paterson,NJ',
'07524': 'Paterson,NJ',
'07533': 'Paterson,NJ',
'07538': 'Haledon,NJ',
'07543': 'Paterson,NJ',
'07544': 'Paterson,NJ',
'07601': 'Hackensack,NJ',
'07602': 'Hackensack,NJ',
'07603': 'Bogota,NJ',
'07604': 'Hasbrouck Heights,NJ',
'07605': 'Leonia,NJ',
'07606': 'South Hackensack,NJ',
'07607': 'Maywood,NJ',
'07608': 'Teterboro,NJ',
'07620': 'Alpine,NJ',
'07621': 'Bergenfield,NJ',
'07624': 'Closter,NJ',
'07626': 'Cresskill,NJ',
'07627': 'Demarest,NJ',
'07628': 'Dumont,NJ',
'07630': 'Emerson,NJ',
'07631': 'Englewood,NJ',
'07632': 'Englewood Cliffs,NJ',
'07640': 'Harrington Park,NJ',
'07641': 'Haworth,NJ',
'07642': 'Hillsdale,NJ',
'07643': 'Little Ferry,NJ',
'07644': 'Lodi,NJ',
'07645': 'Montvale,NJ',
'07646': 'New Milford,NJ',
'07647': 'Northvale,NJ',
'07648': 'Norwood,NJ',
'07649': 'Oradell,NJ',
'07650': 'Palisades Park,NJ',
'07652': 'Paramus,NJ',
'07653': 'Paramus,NJ',
'07656': 'Park Ridge,NJ',
'07657': 'Ridgefield,NJ',
'07660': 'Ridgefield Park,NJ',
'07661': 'River Edge,NJ',
'07662': 'Rochelle Park,NJ',
'07663': 'Saddle Brook,NJ',
'07666': 'Teaneck,NJ',
'07670': 'Tenafly,NJ',
'07675': 'Westwood,NJ',
'07676': 'Township Of Washington,NJ',
'07677': 'Woodcliff Lake,NJ',
'07699': 'Teterboro,NJ',
'07701': 'Red Bank,NJ',
'07702': 'Shrewsbury,NJ',
'07703': 'Fort Monmouth,NJ',
'07704': 'Fair Haven,NJ',
'07709': 'Allenhurst,NJ',
'07710': 'Adelphia,NJ',
'07711': 'Allenhurst,NJ',
'07712': 'Asbury Park,NJ',
'07715': 'Belmar,NJ',
'07716': 'Atlantic Highlands,NJ',
'07717': 'Avon By The Sea,NJ',
'07718': 'Belford,NJ',
'07719': 'Belmar,NJ',
'07720': 'Bradley Beach,NJ',
'07721': 'Cliffwood,NJ',
'07722': 'Colts Neck,NJ',
'07723': 'Deal,NJ',
'07724': 'Eatontown,NJ',
'07726': 'Englishtown,NJ',
'07727': 'Farmingdale,NJ',
'07728': 'Freehold,NJ',
'07730': 'Hazlet,NJ',
'07731': 'Howell,NJ',
'07732': 'Highlands,NJ',
'07733': 'Holmdel,NJ',
'07734': 'Keansburg,NJ',
'07735': 'Keyport,NJ',
'07737': 'Leonardo,NJ',
'07738': 'Lincroft,NJ',
'07739': 'Little Silver,NJ',
'07740': 'Long Branch,NJ',
'07746': 'Marlboro,NJ',
'07747': 'Matawan,NJ',
'07748': 'Middletown,NJ',
'07750': 'Monmouth Beach,NJ',
'07751': 'Morganville,NJ',
'07752': 'Navesink,NJ',
'07753': 'Neptune,NJ',
'07754': 'Neptune,NJ',
'07755': 'Oakhurst,NJ',
'07756': 'Ocean Grove,NJ',
'07757': 'Oceanport,NJ',
'07758': 'Port Monmouth,NJ',
'07760': 'Rumson,NJ',
'07762': 'Spring Lake,NJ',
'07763': 'Tennent,NJ',
'07764': 'West Long Branch,NJ',
'07765': 'Wickatunk,NJ',
'07777': 'Holmdel,NJ',
'07799': 'Eatontown,NJ',
'07801': 'Dover,NJ',
'07802': 'Dover,NJ',
'07803': 'Mine Hill,NJ',
'07806': 'Picatinny Arsenal,NJ',
'07820': 'Allamuchy,NJ',
'07821': 'Andover,NJ',
'07822': 'Augusta,NJ',
'07823': 'Belvidere,NJ',
'07825': 'Blairstown,NJ',
'07826': 'Branchville,NJ',
'07827': 'Montague,NJ',
'07828': 'Budd Lake,NJ',
'07829': 'Buttzville,NJ',
'07830': 'Califon,NJ',
'07831': 'Changewater,NJ',
'07832': 'Columbia,NJ',
'07833': 'Delaware,NJ',
'07834': 'Denville,NJ',
'07836': 'Flanders,NJ',
'07837': 'Glasser,NJ',
'07838': 'Great Meadows,NJ',
'07839': 'Greendell,NJ',
'07840': 'Hackettstown,NJ',
'07842': 'Hibernia,NJ',
'07843': 'Hopatcong,NJ',
'07844': 'Hope,NJ',
'07845': 'Ironia,NJ',
'07846': 'Johnsonburg,NJ',
'07847': 'Kenvil,NJ',
'07848': 'Lafayette,NJ',
'07849': 'Lake Hopatcong,NJ',
'07850': 'Landing,NJ',
'07851': 'Layton,NJ',
'07852': 'Ledgewood,NJ',
'07853': 'Long Valley,NJ',
'07855': 'Middleville,NJ',
'07856': 'Mount Arlington,NJ',
'07857': 'Netcong,NJ',
'07860': 'Newton,NJ',
'07863': 'Oxford,NJ',
'07865': 'Port Murray,NJ',
'07866': 'Rockaway,NJ',
'07869': 'Randolph,NJ',
'07870': 'Schooleys Mountain,NJ',
'07871': 'Sparta,NJ',
'07874': 'Stanhope,NJ',
'07875': 'Stillwater,NJ',
'07876': 'Succasunna,NJ',
'07877': 'Swartswood,NJ',
'07878': 'Mount Tabor,NJ',
'07879': 'Tranquility,NJ',
'07880': 'Vienna,NJ',
'07881': 'Wallpack Center,NJ',
'07882': 'Washington,NJ',
'07885': 'Wharton,NJ',
'07890': 'Branchville,NJ',
'07901': 'Summit,NJ',
'07902': 'Summit,NJ',
'07920': 'Basking Ridge,NJ',
'07921': 'Bedminster,NJ',
'07922': 'Berkeley Heights,NJ',
'07924': 'Bernardsville,NJ',
'07926': 'Brookside,NJ',
'07927': 'Cedar Knolls,NJ',
'07928': 'Chatham,NJ',
'07930': 'Chester,NJ',
'07931': 'Far Hills,NJ',
'07932': 'Florham Park,NJ',
'07933': 'Gillette,NJ',
'07934': 'Gladstone,NJ',
'07935': 'Green Village,NJ',
'07936': 'East Hanover,NJ',
'07938': 'Liberty Corner,NJ',
'07939': 'Lyons,NJ',
'07940': 'Madison,NJ',
'07945': 'Mendham,NJ',
'07946': 'Millington,NJ',
'07950': 'Morris Plains,NJ',
'07960': 'Morristown,NJ',
'07961': 'Morristown,NJ',
'07962': 'Morristown,NJ',
'07963': 'Morristown,NJ',
'07970': 'Mount Freedom,NJ',
'07974': 'New Providence,NJ',
'07976': 'New Vernon,NJ',
'07977': 'Peapack,NJ',
'07978': 'Pluckemin,NJ',
'07979': 'Pottersville,NJ',
'07980': 'Stirling,NJ',
'07981': 'Whippany,NJ',
'07983': 'Whippany,NJ',
'07999': 'Whippany,NJ',
'08001': 'Alloway,NJ',
'08002': 'Cherry Hill,NJ',
'08003': 'Cherry Hill,NJ',
'08004': 'Atco,NJ',
'08005': 'Barnegat,NJ',
'08006': 'Barnegat Light,NJ',
'08007': 'Barrington,NJ',
'08008': 'Beach Haven,NJ',
'08009': 'Berlin,NJ',
'08010': 'Beverly,NJ',
'08011': 'Birmingham,NJ',
'08012': 'Blackwood,NJ',
'08014': 'Bridgeport,NJ',
'08015': 'Browns Mills,NJ',
'08016': 'Burlington,NJ',
'08018': 'Cedar Brook,NJ',
'08019': 'Chatsworth,NJ',
'08020': 'Clarksboro,NJ',
'08021': 'Clementon,NJ',
'08022': 'Columbus,NJ',
'08023': 'Deepwater,NJ',
'08025': 'Ewan,NJ',
'08026': 'Gibbsboro,NJ',
'08027': 'Gibbstown,NJ',
'08028': 'Glassboro,NJ',
'08029': 'Glendora,NJ',
'08030': 'Gloucester City,NJ',
'08031': 'Bellmawr,NJ',
'08032': 'Grenloch,NJ',
'08033': 'Haddonfield,NJ',
'08034': 'Cherry Hill,NJ',
'08035': 'Haddon Heights,NJ',
'08036': 'Hainesport,NJ',
'08037': 'Hammonton,NJ',
'08038': 'Hancocks Bridge,NJ',
'08039': 'Harrisonville,NJ',
'08041': 'Jobstown,NJ',
'08042': 'Juliustown,NJ',
'08043': 'Voorhees,NJ',
'08045': 'Lawnside,NJ',
'08046': 'Willingboro,NJ',
'08048': 'Lumberton,NJ',
'08049': 'Magnolia,NJ',
'08050': 'Manahawkin,NJ',
'08051': 'Mantua,NJ',
'08052': 'Maple Shade,NJ',
'08053': 'Marlton,NJ',
'08054': 'Mount Laurel,NJ',
'08055': 'Medford,NJ',
'08056': 'Mickleton,NJ',
'08057': 'Moorestown,NJ',
'08059': 'Mount Ephraim,NJ',
'08060': 'Mount Holly,NJ',
'08061': 'Mount Royal,NJ',
'08062': 'Mullica Hill,NJ',
'08063': 'National Park,NJ',
'08064': 'New Lisbon,NJ',
'08065': 'Palmyra,NJ',
'08066': 'Paulsboro,NJ',
'08067': 'Pedricktown,NJ',
'08068': 'Pemberton,NJ',
'08069': 'Penns Grove,NJ',
'08070': 'Pennsville,NJ',
'08071': 'Pitman,NJ',
'08072': 'Quinton,NJ',
'08073': 'Rancocas,NJ',
'08074': 'Richwood,NJ',
'08075': 'Riverside,NJ',
'08076': 'Riverton,NJ',
'08077': 'Riverton,NJ',
'08078': 'Runnemede,NJ',
'08079': 'Salem,NJ',
'08080': 'Sewell,NJ',
'08081': 'Sicklerville,NJ',
'08083': 'Somerdale,NJ',
'08084': 'Stratford,NJ',
'08085': 'Swedesboro,NJ',
'08086': 'Thorofare,NJ',
'08087': 'Tuckerton,NJ',
'08088': 'Vincentown,NJ',
'08089': 'Waterford Works,NJ',
'08090': 'Wenonah,NJ',
'08091': 'West Berlin,NJ',
'08092': 'West Creek,NJ',
'08093': 'Westville,NJ',
'08094': 'Williamstown,NJ',
'08095': 'Winslow,NJ',
'08096': 'Woodbury,NJ',
'08097': 'Woodbury Heights,NJ',
'08098': 'Woodstown,NJ',
'08099': 'Bellmawr,NJ',
'08101': 'Camden,NJ',
'08102': 'Camden,NJ',
'08103': 'Camden,NJ',
'08104': 'Camden,NJ',
'08105': 'Camden,NJ',
'08106': 'Audubon,NJ',
'08107': 'Oaklyn,NJ',
'08108': 'Collingswood,NJ',
'08109': 'Merchantville,NJ',
'08110': 'Pennsauken,NJ',
'08201': 'Absecon,NJ',
'08202': 'Avalon,NJ',
'08203': 'Brigantine,NJ',
'08204': 'Cape May,NJ',
'08205': 'Absecon,NJ',
'08210': 'Cape May Court House,NJ',
'08212': 'Cape May Point,NJ',
'08213': 'Cologne,NJ',
'08214': 'Dennisville,NJ',
'08215': 'Egg Harbor City,NJ',
'08217': 'Elwood,NJ',
'08218': 'Goshen,NJ',
'08219': 'Green Creek,NJ',
'08220': 'Leeds Point,NJ',
'08221': 'Linwood,NJ',
'08223': 'Marmora,NJ',
'08224': 'New Gretna,NJ',
'08225': 'Northfield,NJ',
'08226': 'Ocean City,NJ',
'08230': 'Ocean View,NJ',
'08231': 'Oceanville,NJ',
'08232': 'Pleasantville,NJ',
'08234': 'Egg Harbor Township,NJ',
'08240': 'Pomona,NJ',
'08241': 'Port Republic,NJ',
'08242': 'Rio Grande,NJ',
'08243': 'Sea Isle City,NJ',
'08244': 'Somers Point,NJ',
'08245': 'South Dennis,NJ',
'08246': 'South Seaville,NJ',
'08247': 'Stone Harbor,NJ',
'08248': 'Strathmere,NJ',
'08250': 'Tuckahoe,NJ',
'08251': 'Villas,NJ',
'08252': 'Whitesboro,NJ',
'08260': 'Wildwood,NJ',
'08270': 'Woodbine,NJ',
'08302': 'Bridgeton,NJ',
'08310': 'Buena,NJ',
'08311': 'Cedarville,NJ',
'08312': 'Clayton,NJ',
'08313': 'Deerfield Street,NJ',
'08314': 'Delmont,NJ',
'08315': 'Dividing Creek,NJ',
'08316': 'Dorchester,NJ',
'08317': 'Dorothy,NJ',
'08318': 'Elmer,NJ',
'08319': 'Estell Manor,NJ',
'08320': 'Fairton,NJ',
'08321': 'Fortescue,NJ',
'08322': 'Franklinville,NJ',
'08323': 'Greenwich,NJ',
'08324': 'Heislerville,NJ',
'08326': 'Landisville,NJ',
'08327': 'Leesburg,NJ',
'08328': 'Malaga,NJ',
'08329': 'Mauricetown,NJ',
'08330': 'Mays Landing,NJ',
'08332': 'Millville,NJ',
'08340': 'Milmay,NJ',
'08341': 'Minotola,NJ',
'08342': 'Mizpah,NJ',
'08343': 'Monroeville,NJ',
'08344': 'Newfield,NJ',
'08345': 'Newport,NJ',
'08346': 'Newtonville,NJ',
'08347': 'Norma,NJ',
'08348': 'Port Elizabeth,NJ',
'08349': 'Port Norris,NJ',
'08350': 'Richland,NJ',
'08352': 'Rosenhayn,NJ',
'08353': 'Shiloh,NJ',
'08360': 'Vineland,NJ',
'08361': 'Vineland,NJ',
'08362': 'Vineland,NJ',
'08401': 'Atlantic City,NJ',
'08402': 'Margate City,NJ',
'08403': 'Longport,NJ',
'08404': 'Atlantic City,NJ',
'08405': 'Atlantic City,NJ',
'08406': 'Ventnor City,NJ',
'08501': 'Allentown,NJ',
'08502': 'Belle Mead,NJ',
'08504': 'Blawenburg,NJ',
'08505': 'Bordentown,NJ',
'08510': 'Clarksburg,NJ',
'08511': 'Cookstown,NJ',
'08512': 'Cranbury,NJ',
'08514': 'Cream Ridge,NJ',
'08515': 'Crosswicks,NJ',
'08518': 'Florence,NJ',
'08520': 'Hightstown,NJ',
'08525': 'Hopewell,NJ',
'08526': 'Imlaystown,NJ',
'08527': 'Jackson,NJ',
'08528': 'Kingston,NJ',
'08530': 'Lambertville,NJ',
'08533': 'New Egypt,NJ',
'08534': 'Pennington,NJ',
'08535': 'Perrineville,NJ',
'08536': 'Plainsboro,NJ',
'08540': 'Princeton,NJ',
'08541': 'Princeton,NJ',
'08542': 'Princeton,NJ',
'08543': 'Princeton,NJ',
'08544': 'Princeton,NJ',
'08550': 'Princeton Junction,NJ',
'08551': 'Ringoes,NJ',
'08553': 'Rocky Hill,NJ',
'08554': 'Roebling,NJ',
'08555': 'Roosevelt,NJ',
'08556': 'Rosemont,NJ',
'08557': 'Sergeantsville,NJ',
'08558': 'Skillman,NJ',
'08559': 'Stockton,NJ',
'08560': 'Titusville,NJ',
'08561': 'Windsor,NJ',
'08562': 'Wrightstown,NJ',
'08570': 'Cranbury,NJ',
'08601': 'Trenton,NJ',
'08602': 'Trenton,NJ',
'08603': 'Trenton,NJ',
'08604': 'Trenton,NJ',
'08605': 'Trenton,NJ',
'08606': 'Trenton,NJ',
'08607': 'Trenton,NJ',
'08608': 'Trenton,NJ',
'08609': 'Trenton,NJ',
'08610': 'Trenton,NJ',
'08611': 'Trenton,NJ',
'08618': 'Trenton,NJ',
'08619': 'Trenton,NJ',
'08620': 'Trenton,NJ',
'08625': 'Trenton,NJ',
'08628': 'Trenton,NJ',
'08629': 'Trenton,NJ',
'08638': 'Trenton,NJ',
'08640': 'Trenton,NJ',
'08641': 'Trenton,NJ',
'08645': 'Trenton,NJ',
'08646': 'Trenton,NJ',
'08647': 'Trenton,NJ',
'08648': 'Trenton,NJ',
'08650': 'Trenton,NJ',
'08666': 'Trenton,NJ',
'08677': 'Trenton,NJ',
'08690': 'Trenton,NJ',
'08691': 'Trenton,NJ',
'08695': 'Trenton,NJ',
'08701': 'Lakewood,NJ',
'08720': 'Allenwood,NJ',
'08721': 'Bayville,NJ',
'08722': 'Beachwood,NJ',
'08723': 'Brick,NJ',
'08724': 'Brick,NJ',
'08730': 'Brielle,NJ',
'08731': 'Forked River,NJ',
'08732': 'Island Heights,NJ',
'08733': 'Lakehurst,NJ',
'08734': 'Lanoka Harbor,NJ',
'08735': 'Lavallette,NJ',
'08736': 'Manasquan,NJ',
'08738': 'Mantoloking,NJ',
'08739': 'Normandy Beach,NJ',
'08740': 'Ocean Gate,NJ',
'08741': 'Pine Beach,NJ',
'08742': 'Point Pleasant Beach,NJ',
'08750': 'Sea Girt,NJ',
'08751': 'Seaside Heights,NJ',
'08752': 'Seaside Park,NJ',
'08753': 'Toms River,NJ',
'08754': 'Toms River,NJ',
'08755': 'Toms River,NJ',
'08756': 'Toms River,NJ',
'08757': 'Toms River,NJ',
'08758': 'Waretown,NJ',
'08759': 'Manchester Township,NJ',
'08801': 'Annandale,NJ',
'08802': 'Asbury,NJ',
'08803': 'Baptistown,NJ',
'08804': 'Bloomsbury,NJ',
'08805': 'Bound Brook,NJ',
'08807': 'Bridgewater,NJ',
'08808': 'Broadway,NJ',
'08809': 'Clinton,NJ',
'08810': 'Dayton,NJ',
'08812': 'Dunellen,NJ',
'08816': 'East Brunswick,NJ',
'08817': 'Edison,NJ',
'08818': 'Edison,NJ',
'08820': 'Edison,NJ',
'08821': 'Flagtown,NJ',
'08822': 'Flemington,NJ',
'08823': 'Franklin Park,NJ',
'08824': 'Kendall Park,NJ',
'08825': 'Frenchtown,NJ',
'08826': 'Glen Gardner,NJ',
'08827': 'Hampton,NJ',
'08828': 'Helmetta,NJ',
'08829': 'High Bridge,NJ',
'08830': 'Iselin,NJ',
'08831': 'Monroe Township,NJ',
'08832': 'Keasbey,NJ',
'08833': 'Lebanon,NJ',
'08834': 'Little York,NJ',
'08835': 'Manville,NJ',
'08836': 'Martinsville,NJ',
'08837': 'Edison,NJ',
'08840': 'Metuchen,NJ',
'08844': 'Hillsborough,NJ',
'08846': 'Middlesex,NJ',
'08848': 'Milford,NJ',
'08850': 'Milltown,NJ',
'08852': 'Monmouth Junction,NJ',
'08853': 'Neshanic Station,NJ',
'08854': 'Piscataway,NJ',
'08855': 'Piscataway,NJ',
'08857': 'Old Bridge,NJ',
'08858': 'Oldwick,NJ',
'08859': 'Parlin,NJ',
'08861': 'Perth Amboy,NJ',
'08862': 'Perth Amboy,NJ',
'08863': 'Fords,NJ',
'08865': 'Phillipsburg,NJ',
'08867': 'Pittstown,NJ',
'08868': 'Quakertown,NJ',
'08869': 'Raritan,NJ',
'08870': 'Readington,NJ',
'08871': 'Sayreville,NJ',
'08872': 'Sayreville,NJ',
'08873': 'Somerset,NJ',
'08875': 'Somerset,NJ',
'08876': 'Somerville,NJ',
'08877': 'South River,NJ',
'08878': 'South Amboy,NJ',
'08879': 'South Amboy,NJ',
'08880': 'South Bound Brook,NJ',
'08882': 'South River,NJ',
'08884': 'Spotswood,NJ',
'08885': 'Stanton,NJ',
'08886': 'Stewartsville,NJ',
'08887': 'Three Bridges,NJ',
'08888': 'Whitehouse,NJ',
'08889': 'Whitehouse Station,NJ',
'08890': 'Zarephath,NJ',
'08896': 'Raritan,NJ',
'08899': 'Edison,NJ',
'08901': 'New Brunswick,NJ',
'08902': 'North Brunswick,NJ',
'08903': 'New Brunswick,NJ',
'08904': 'Highland Park,NJ',
'08905': 'New Brunswick,NJ',
'08906': 'New Brunswick,NJ',
'08922': 'New Brunswick,NJ',
'08933': 'New Brunswick,NJ',
'08988': 'New Brunswick,NJ',
'08989': 'New Brunswick,NJ',
'10001': 'New York,NY',
'10002': 'New York,NY',
'10003': 'New York,NY',
'10004': 'New York,NY',
'10005': 'New York,NY',
'10006': 'New York,NY',
'10007': 'New York,NY',
'10008': 'New York,NY',
'10009': 'New York,NY',
'10010': 'New York,NY',
'10011': 'New York,NY',
'10012': 'New York,NY',
'10013': 'New York,NY',
'10014': 'New York,NY',
'10015': 'New York,NY',
'10016': 'New York,NY',
'10017': 'New York,NY',
'10018': 'New York,NY',
'10019': 'New York,NY',
'10020': 'New York,NY',
'10021': 'New York,NY',
'10022': 'New York,NY',
'10023': 'New York,NY',
'10024': 'New York,NY',
'10025': 'New York,NY',
'10026': 'New York,NY',
'10027': 'New York,NY',
'10028': 'New York,NY',
'10029': 'New York,NY',
'10030': 'New York,NY',
'10031': 'New York,NY',
'10032': 'New York,NY',
'10033': 'New York,NY',
'10034': 'New York,NY',
'10035': 'New York,NY',
'10036': 'New York,NY',
'10037': 'New York,NY',
'10038': 'New York,NY',
'10039': 'New York,NY',
'10040': 'New York,NY',
'10041': 'New York,NY',
'10043': 'New York,NY',
'10044': 'New York,NY',
'10045': 'New York,NY',
'10046': 'New York,NY',
'10047': 'New York,NY',
'10048': 'New York,NY',
'10055': 'New York,NY',
'10060': 'New York,NY',
'10069': 'New York,NY',
'10072': 'New York,NY',
'10079': 'New York,NY',
'10080': 'New York,NY',
'10081': 'New York,NY',
'10082': 'New York,NY',
'10087': 'New York,NY',
'10090': 'New York,NY',
'10094': 'New York,NY',
'10095': 'New York,NY',
'10096': 'New York,NY',
'10098': 'New York,NY',
'10099': 'New York,NY',
'10101': 'New York,NY',
'10102': 'New York,NY',
'10103': 'New York,NY',
'10104': 'New York,NY',
'10105': 'New York,NY',
'10106': 'New York,NY',
'10107': 'New York,NY',
'10108': 'New York,NY',
'10109': 'New York,NY',
'10110': 'New York,NY',
'10111': 'New York,NY',
'10112': 'New York,NY',
'10113': 'New York,NY',
'10114': 'New York,NY',
'10115': 'New York,NY',
'10116': 'New York,NY',
'10117': 'New York,NY',
'10118': 'New York,NY',
'10119': 'New York,NY',
'10120': 'New York,NY',
'10121': 'New York,NY',
'10122': 'New York,NY',
'10123': 'New York,NY',
'10124': 'New York,NY',
'10125': 'New York,NY',
'10126': 'New York,NY',
'10128': 'New York,NY',
'10129': 'New York,NY',
'10130': 'New York,NY',
'10131': 'New York,NY',
'10132': 'New York,NY',
'10133': 'New York,NY',
'10138': 'New York,NY',
'10149': 'New York,NY',
'10150': 'New York,NY',
'10151': 'New York,NY',
'10152': 'New York,NY',
'10153': 'New York,NY',
'10154': 'New York,NY',
'10155': 'New York,NY',
'10156': 'New York,NY',
'10157': 'New York,NY',
'10158': 'New York,NY',
'10159': 'New York,NY',
'10160': 'New York,NY',
'10161': 'New York,NY',
'10162': 'New York,NY',
'10163': 'New York,NY',
'10164': 'New York,NY',
'10165': 'New York,NY',
'10166': 'New York,NY',
'10167': 'New York,NY',
'10168': 'New York,NY',
'10169': 'New York,NY',
'10170': 'New York,NY',
'10171': 'New York,NY',
'10172': 'New York,NY',
'10173': 'New York,NY',
'10174': 'New York,NY',
'10175': 'New York,NY',
'10176': 'New York,NY',
'10177': 'New York,NY',
'10178': 'New York,NY',
'10179': 'New York,NY',
'10184': 'New York,NY',
'10185': 'New York,NY',
'10196': 'New York,NY',
'10197': 'New York,NY',
'10199': 'New York,NY',
'10203': 'New York,NY',
'10211': 'New York,NY',
'10212': 'New York,NY',
'10213': 'New York,NY',
'10242': 'New York,NY',
'10249': 'New York,NY',
'10256': 'New York,NY',
'10257': 'New York,NY',
'10258': 'New York,NY',
'10259': 'New York,NY',
'10260': 'New York,NY',
'10261': 'New York,NY',
'10265': 'New York,NY',
'10268': 'New York,NY',
'10269': 'New York,NY',
'10270': 'New York,NY',
'10271': 'New York,NY',
'10272': 'New York,NY',
'10273': 'New York,NY',
'10274': 'New York,NY',
'10275': 'New York,NY',
'10276': 'New York,NY',
'10277': 'New York,NY',
'10278': 'New York,NY',
'10279': 'New York,NY',
'10280': 'New York,NY',
'10281': 'New York,NY',
'10282': 'New York,NY',
'10285': 'New York,NY',
'10286': 'New York,NY',
'10292': 'New York,NY',
'10301': 'Staten Island,NY',
'10302': 'Staten Island,NY',
'10303': 'Staten Island,NY',
'10304': 'Staten Island,NY',
'10305': 'Staten Island,NY',
'10306': 'Staten Island,NY',
'10307': 'Staten Island,NY',
'10308': 'Staten Island,NY',
'10309': 'Staten Island,NY',
'10310': 'Staten Island,NY',
'10311': 'Staten Island,NY',
'10312': 'Staten Island,NY',
'10313': 'Staten Island,NY',
'10314': 'Staten Island,NY',
'10451': 'Bronx,NY',
'10452': 'Bronx,NY',
'10453': 'Bronx,NY',
'10454': 'Bronx,NY',
'10455': 'Bronx,NY',
'10456': 'Bronx,NY',
'10457': 'Bronx,NY',
'10458': 'Bronx,NY',
'10459': 'Bronx,NY',
'10460': 'Bronx,NY',
'10461': 'Bronx,NY',
'10462': 'Bronx,NY',
'10463': 'Bronx,NY',
'10464': 'Bronx,NY',
'10465': 'Bronx,NY',
'10466': 'Bronx,NY',
'10467': 'Bronx,NY',
'10468': 'Bronx,NY',
'10469': 'Bronx,NY',
'10470': 'Bronx,NY',
'10471': 'Bronx,NY',
'10472': 'Bronx,NY',
'10473': 'Bronx,NY',
'10474': 'Bronx,NY',
'10475': 'Bronx,NY',
'10499': 'Bronx,NY',
'10501': 'Amawalk,NY',
'10502': 'Ardsley,NY',
'10503': 'Ardsley On Hudson,NY',
'10504': 'Armonk,NY',
'10505': 'Baldwin Place,NY',
'10506': 'Bedford,NY',
'10507': 'Bedford Hills,NY',
'10509': 'Brewster,NY',
'10510': 'Briarcliff Manor,NY',
'10511': 'Buchanan,NY',
'10512': 'Carmel,NY',
'10514': 'Chappaqua,NY',
'10516': 'Cold Spring,NY',
'10517': 'Crompond,NY',
'10518': 'Cross River,NY',
'10519': 'Croton Falls,NY',
'10520': 'Croton On Hudson,NY',
'10521': 'Croton On Hudson,NY',
'10522': 'Dobbs Ferry,NY',
'10523': 'Elmsford,NY',
'10524': 'Garrison,NY',
'10526': 'Goldens Bridge,NY',
'10527': 'Granite Springs,NY',
'10528': 'Harrison,NY',
'10530': 'Hartsdale,NY',
'10532': 'Hawthorne,NY',
'10533': 'Irvington,NY',
'10535': 'Jefferson Valley,NY',
'10536': 'Katonah,NY',
'10537': 'Lake Peekskill,NY',
'10538': 'Larchmont,NY',
'10540': 'Lincolndale,NY',
'10541': 'Mahopac,NY',
'10542': 'Mahopac Falls,NY',
'10543': 'Mamaroneck,NY',
'10545': 'Maryknoll,NY',
'10546': 'Millwood,NY',
'10547': 'Mohegan Lake,NY',
'10548': 'Montrose,NY',
'10549': 'Mount Kisco,NY',
'10550': 'Mount Vernon,NY',
'10551': 'Mount Vernon,NY',
'10552': 'Mount Vernon,NY',
'10553': 'Mount Vernon,NY',
'10557': 'Mount Vernon,NY',
'10558': 'Mount Vernon,NY',
'10559': 'Mount Vernon,NY',
'10560': 'North Salem,NY',
'10562': 'Ossining,NY',
'10566': 'Peekskill,NY',
'10567': 'Cortlandt Manor,NY',
'10570': 'Pleasantville,NY',
'10571': 'Pleasantville,NY',
'10572': 'Pleasantville,NY',
'10573': 'Port Chester,NY',
'10576': 'Pound Ridge,NY',
'10577': 'Purchase,NY',
'10578': 'Purdys,NY',
'10579': 'Putnam Valley,NY',
'10580': 'Rye,NY',
'10581': 'Rye,NY',
'10583': 'Scarsdale,NY',
'10587': 'Shenorock,NY',
'10588': 'Shrub Oak,NY',
'10589': 'Somers,NY',
'10590': 'South Salem,NY',
'10591': 'Tarrytown,NY',
'10592': 'Tarrytown,NY',
'10594': 'Thornwood,NY',
'10595': 'Valhalla,NY',
'10596': 'Verplanck,NY',
'10597': 'Waccabuc,NY',
'10598': 'Yorktown Heights,NY',
'10601': 'White Plains,NY',
'10602': 'White Plains,NY',
'10603': 'White Plains,NY',
'10604': 'West Harrison,NY',
'10605': 'White Plains,NY',
'10606': 'White Plains,NY',
'10607': 'White Plains,NY',
'10610': 'White Plains,NY',
'10625': 'White Plains,NY',
'10629': 'White Plains,NY',
'10633': 'White Plains,NY',
'10650': 'White Plains,NY',
'10701': 'Yonkers,NY',
'10702': 'Yonkers,NY',
'10703': 'Yonkers,NY',
'10704': 'Yonkers,NY',
'10705': 'Yonkers,NY',
'10706': 'Hastings On Hudson,NY',
'10707': 'Tuckahoe,NY',
'10708': 'Bronxville,NY',
'10709': 'Eastchester,NY',
'10710': 'Yonkers,NY',
'10801': 'New Rochelle,NY',
'10802': 'New Rochelle,NY',
'10803': 'Pelham,NY',
'10804': 'New Rochelle,NY',
'10805': 'New Rochelle,NY',
'10901': 'Suffern,NY',
'10910': 'Arden,NY',
'10911': 'Bear Mountain,NY',
'10912': 'Bellvale,NY',
'10913': 'Blauvelt,NY',
'10914': 'Blooming Grove,NY',
'10915': 'Bullville,NY',
'10916': 'Campbell Hall,NY',
'10917': 'Central Valley,NY',
'10918': 'Chester,NY',
'10919': 'Circleville,NY',
'10920': 'Congers,NY',
'10921': 'Florida,NY',
'10922': 'Fort Montgomery,NY',
'10923': 'Garnerville,NY',
'10924': 'Goshen,NY',
'10925': 'Greenwood Lake,NY',
'10926': 'Harriman,NY',
'10927': 'Haverstraw,NY',
'10928': 'Highland Falls,NY',
'10930': 'Highland Mills,NY',
'10931': 'Hillburn,NY',
'10932': 'Howells,NY',
'10933': 'Johnson,NY',
'10940': 'Middletown,NY',
'10941': 'Middletown,NY',
'10943': 'Middletown,NY',
'10949': 'Monroe,NY',
'10950': 'Monroe,NY',
'10952': 'Monsey,NY',
'10953': 'Mountainville,NY',
'10954': 'Nanuet,NY',
'10956': 'New City,NY',
'10958': 'New Hampton,NY',
'10959': 'New Milford,NY',
'10960': 'Nyack,NY',
'10962': 'Orangeburg,NY',
'10963': 'Otisville,NY',
'10964': 'Palisades,NY',
'10965': 'Pearl River,NY',
'10968': 'Piermont,NY',
'10969': 'Pine Island,NY',
'10970': 'Pomona,NY',
'10973': 'Slate Hill,NY',
'10974': 'Sloatsburg,NY',
'10975': 'Southfields,NY',
'10976': 'Sparkill,NY',
'10977': 'Spring Valley,NY',
'10979': 'Sterling Forest,NY',
'10980': 'Stony Point,NY',
'10981': 'Sugar Loaf,NY',
'10982': 'Tallman,NY',
'10983': 'Tappan,NY',
'10984': 'Thiells,NY',
'10985': 'Thompson Ridge,NY',
'10986': 'Tomkins Cove,NY',
'10987': 'Tuxedo Park,NY',
'10988': 'Unionville,NY',
'10989': 'Valley Cottage,NY',
'10990': 'Warwick,NY',
'10992': 'Washingtonville,NY',
'10993': 'West Haverstraw,NY',
'10994': 'West Nyack,NY',
'10995': 'West Nyack,NY',
'10996': 'West Point,NY',
'10997': 'West Point,NY',
'10998': 'Westtown,NY',
'11001': 'Floral Park,NY',
'11002': 'Floral Park,NY',
'11003': 'Elmont,NY',
'11004': 'Glen Oaks,NY',
'11005': 'Floral Park,NY',
'11010': 'Franklin Square,NY',
'11020': 'Great Neck,NY',
'11021': 'Great Neck,NY',
'11022': 'Great Neck,NY',
'11023': 'Great Neck,NY',
'11024': 'Great Neck,NY',
'11025': 'Great Neck,NY',
'11026': 'Great Neck,NY',
'11027': 'Great Neck,NY',
'11030': 'Manhasset,NY',
'11040': 'New Hyde Park,NY',
'11041': 'New Hyde Park,NY',
'11042': 'New Hyde Park,NY',
'11043': 'New Hyde Park,NY',
'11044': 'New Hyde Park,NY',
'11050': 'Port Washington,NY',
'11051': 'Port Washington,NY',
'11052': 'Port Washington,NY',
'11053': 'Port Washington,NY',
'11054': 'Port Washington,NY',
'11055': 'Port Washington,NY',
'11096': 'Inwood,NY',
'11099': 'New Hyde Park,NY',
'11101': 'Long Island City,NY',
'11102': 'Astoria,NY',
'11103': 'Astoria,NY',
'11104': 'Sunnyside,NY',
'11105': 'Astoria,NY',
'11106': 'Astoria,NY',
'11109': 'Long Island City,NY',
'11120': 'Long Island City,NY',
'11201': 'Brooklyn,NY',
'11202': 'Brooklyn,NY',
'11203': 'Brooklyn,NY',
'11204': 'Brooklyn,NY',
'11205': 'Brooklyn,NY',
'11206': 'Brooklyn,NY',
'11207': 'Brooklyn,NY',
'11208': 'Brooklyn,NY',
'11209': 'Brooklyn,NY',
'11210': 'Brooklyn,NY',
'11211': 'Brooklyn,NY',
'11212': 'Brooklyn,NY',
'11213': 'Brooklyn,NY',
'11214': 'Brooklyn,NY',
'11215': 'Brooklyn,NY',
'11216': 'Brooklyn,NY',
'11217': 'Brooklyn,NY',
'11218': 'Brooklyn,NY',
'11219': 'Brooklyn,NY',
'11220': 'Brooklyn,NY',
'11221': 'Brooklyn,NY',
'11222': 'Brooklyn,NY',
'11223': 'Brooklyn,NY',
'11224': 'Brooklyn,NY',
'11225': 'Brooklyn,NY',
'11226': 'Brooklyn,NY',
'11228': 'Brooklyn,NY',
'11229': 'Brooklyn,NY',
'11230': 'Brooklyn,NY',
'11231': 'Brooklyn,NY',
'11232': 'Brooklyn,NY',
'11233': 'Brooklyn,NY',
'11234': 'Brooklyn,NY',
'11235': 'Brooklyn,NY',
'11236': 'Brooklyn,NY',
'11237': 'Brooklyn,NY',
'11238': 'Brooklyn,NY',
'11239': 'Brooklyn,NY',
'11240': 'Brooklyn,NY',
'11241': 'Brooklyn,NY',
'11242': 'Brooklyn,NY',
'11243': 'Brooklyn,NY',
'11244': 'Brooklyn,NY',
'11245': 'Brooklyn,NY',
'11247': 'Brooklyn,NY',
'11248': 'Brooklyn,NY',
'11249': 'Brooklyn,NY',
'11251': 'Brooklyn,NY',
'11252': 'Brooklyn,NY',
'11254': 'Brooklyn,NY',
'11255': 'Brooklyn,NY',
'11256': 'Brooklyn,NY',
'11351': 'Flushing,NY',
'11352': 'Flushing,NY',
'11354': 'Flushing,NY',
'11355': 'Flushing,NY',
'11356': 'College Point,NY',
'11357': 'Whitestone,NY',
'11358': 'Flushing,NY',
'11359': 'Bayside,NY',
'11360': 'Bayside,NY',
'11361': 'Bayside,NY',
'11362': 'Little Neck,NY',
'11363': 'Little Neck,NY',
'11364': 'Oakland Gardens,NY',
'11365': 'Fresh Meadows,NY',
'11366': 'Fresh Meadows,NY',
'11367': 'Flushing,NY',
'11368': 'Corona,NY',
'11369': 'East Elmhurst,NY',
'11370': 'East Elmhurst,NY',
'11371': 'Flushing,NY',
'11372': 'Jackson Heights,NY',
'11373': 'Elmhurst,NY',
'11374': 'Rego Park,NY',
'11375': 'Forest Hills,NY',
'11377': 'Woodside,NY',
'11378': 'Maspeth,NY',
'11379': 'Middle Village,NY',
'11380': 'Elmhurst,NY',
'11381': 'Flushing,NY',
'11385': 'Ridgewood,NY',
'11386': 'Ridgewood,NY',
'11390': 'Flushing,NY',
'11405': 'Jamaica,NY',
'11411': 'Cambria Heights,NY',
'11412': 'Saint Albans,NY',
'11413': 'Springfield Gardens,NY',
'11414': 'Howard Beach,NY',
'11415': 'Kew Gardens,NY',
'11416': 'Ozone Park,NY',
'11417': 'Ozone Park,NY',
'11418': 'Richmond Hill,NY',
'11419': 'South Richmond Hill,NY',
'11420': 'South Ozone Park,NY',
'11421': 'Woodhaven,NY',
'11422': 'Rosedale,NY',
'11423': 'Hollis,NY',
'11424': 'Jamaica,NY',
'11425': 'Jamaica,NY',
'11426': 'Bellerose,NY',
'11427': 'Queens Village,NY',
'11428': 'Queens Village,NY',
'11429': 'Queens Village,NY',
'11430': 'Jamaica,NY',
'11431': 'Jamaica,NY',
'11432': 'Jamaica,NY',
'11433': 'Jamaica,NY',
'11434': 'Jamaica,NY',
'11435': 'Jamaica,NY',
'11436': 'Jamaica,NY',
'11439': 'Jamaica,NY',
'11451': 'Jamaica,NY',
'11484': 'Jamaica,NY',
'11499': 'Jamaica,NY',
'11501': 'Mineola,NY',
'11507': 'Albertson,NY',
'11509': 'Atlantic Beach,NY',
'11510': 'Baldwin,NY',
'11514': 'Carle Place,NY',
'11516': 'Cedarhurst,NY',
'11518': 'East Rockaway,NY',
'11520': 'Freeport,NY',
'11530': 'Garden City,NY',
'11531': 'Garden City,NY',
'11535': 'Garden City,NY',
'11536': 'Garden City,NY',
'11542': 'Glen Cove,NY',
'11545': 'Glen Head,NY',
'11547': 'Glenwood Landing,NY',
'11548': 'Greenvale,NY',
'11549': 'Hempstead,NY',
'11550': 'Hempstead,NY',
'11551': 'Hempstead,NY',
'11552': 'West Hempstead,NY',
'11553': 'Uniondale,NY',
'11554': 'East Meadow,NY',
'11555': 'Uniondale,NY',
'11556': 'Uniondale,NY',
'11557': 'Hewlett,NY',
'11558': 'Island Park,NY',
'11559': 'Lawrence,NY',
'11560': 'Locust Valley,NY',
'11561': 'Long Beach,NY',
'11563': 'Lynbrook,NY',
'11564': 'Lynbrook,NY',
'11565': 'Malverne,NY',
'11566': 'Merrick,NY',
'11568': 'Old Westbury,NY',
'11569': 'Point Lookout,NY',
'11570': 'Rockville Centre,NY',
'11571': 'Rockville Centre,NY',
'11572': 'Oceanside,NY',
'11575': 'Roosevelt,NY',
'11576': 'Roslyn,NY',
'11577': 'Roslyn Heights,NY',
'11579': 'Sea Cliff,NY',
'11580': 'Valley Stream,NY',
'11581': 'Valley Stream,NY',
'11582': 'Valley Stream,NY',
'11583': 'Valley Stream,NY',
'11588': 'Uniondale,NY',
'11590': 'Westbury,NY',
'11592': 'Rockville Centre,NY',
'11593': 'Westbury,NY',
'11594': 'Westbury,NY',
'11595': 'Westbury,NY',
'11596': 'Williston Park,NY',
'11597': 'Westbury,NY',
'11598': 'Woodmere,NY',
'11599': 'Garden City,NY',
'11690': 'Far Rockaway,NY',
'11691': 'Far Rockaway,NY',
'11692': 'Arverne,NY',
'11693': 'Far Rockaway,NY',
'11694': 'Rockaway Park,NY',
'11695': 'Far Rockaway,NY',
'11697': 'Breezy Point,NY',
'11701': 'Amityville,NY',
'11702': 'Babylon,NY',
'11703': 'North Babylon,NY',
'11704': 'West Babylon,NY',
'11705': 'Bayport,NY',
'11706': 'Bay Shore,NY',
'11707': 'West Babylon,NY',
'11708': 'Amityville,NY',
'11709': 'Bayville,NY',
'11710': 'Bellmore,NY',
'11713': 'Bellport,NY',
'11714': 'Bethpage,NY',
'11715': 'Blue Point,NY',
'11716': 'Bohemia,NY',
'11717': 'Brentwood,NY',
'11718': 'Brightwaters,NY',
'11719': 'Brookhaven,NY',
'11720': 'Centereach,NY',
'11721': 'Centerport,NY',
'11722': 'Central Islip,NY',
'11724': 'Cold Spring Harbor,NY',
'11725': 'Commack,NY',
'11726': 'Copiague,NY',
'11727': 'Coram,NY',
'11729': 'Deer Park,NY',
'11730': 'East Islip,NY',
'11731': 'East Northport,NY',
'11732': 'East Norwich,NY',
'11733': 'East Setauket,NY',
'11735': 'Farmingdale,NY',
'11736': 'Farmingdale,NY',
'11737': 'Farmingdale,NY',
'11738': 'Farmingville,NY',
'11739': 'Great River,NY',
'11740': 'Greenlawn,NY',
'11741': 'Holbrook,NY',
'11742': 'Holtsville,NY',
'11743': 'Huntington,NY',
'11745': 'Smithtown,NY',
'11746': 'Huntington Station,NY',
'11747': 'Melville,NY',
'11749': 'Islandia,NY',
'11750': 'Huntington Station,NY',
'11751': 'Islip,NY',
'11752': 'Islip Terrace,NY',
'11753': 'Jericho,NY',
'11754': 'Kings Park,NY',
'11755': 'Lake Grove,NY',
'11756': 'Levittown,NY',
'11757': 'Lindenhurst,NY',
'11758': 'Massapequa,NY',
'11760': 'Islandia,NY',
'11762': 'Massapequa Park,NY',
'11763': 'Medford,NY',
'11764': 'Miller Place,NY',
'11765': 'Mill Neck,NY',
'11766': 'Mount Sinai,NY',
'11767': 'Nesconset,NY',
'11768': 'Northport,NY',
'11769': 'Oakdale,NY',
'11770': 'Ocean Beach,NY',
'11771': 'Oyster Bay,NY',
'11772': 'Patchogue,NY',
'11773': 'Syosset,NY',
'11774': 'Farmingdale,NY',
'11775': 'Melville,NY',
'11776': 'Port Jefferson Station,NY',
'11777': 'Port Jefferson,NY',
'11778': 'Rocky Point,NY',
'11779': 'Ronkonkoma,NY',
'11780': 'Saint James,NY',
'11782': 'Sayville,NY',
'11783': 'Seaford,NY',
'11784': 'Selden,NY',
'11786': 'Shoreham,NY',
'11787': 'Smithtown,NY',
'11788': 'Hauppauge,NY',
'11789': 'Sound Beach,NY',
'11790': 'Stony Brook,NY',
'11791': 'Syosset,NY',
'11792': 'Wading River,NY',
'11793': 'Wantagh,NY',
'11794': 'Stony Brook,NY',
'11795': 'West Islip,NY',
'11796': 'West Sayville,NY',
'11797': 'Woodbury,NY',
'11798': 'Wyandanch,NY',
'11801': 'Hicksville,NY',
'11802': 'Hicksville,NY',
'11803': 'Plainview,NY',
'11804': 'Old Bethpage,NY',
'11805': 'Mid Island,NY',
'11815': 'Hicksville,NY',
'11819': 'Hicksville,NY',
'11853': 'Jericho,NY',
'11854': 'Hicksville,NY',
'11855': 'Hicksville,NY',
'11901': 'Riverhead,NY',
'11930': 'Amagansett,NY',
'11931': 'Aquebogue,NY',
'11932': 'Bridgehampton,NY',
'11933': 'Calverton,NY',
'11934': 'Center Moriches,NY',
'11935': 'Cutchogue,NY',
'11937': 'East Hampton,NY',
'11939': 'East Marion,NY',
'11940': 'East Moriches,NY',
'11941': 'Eastport,NY',
'11942': 'East Quogue,NY',
'11944': 'Greenport,NY',
'11946': 'Hampton Bays,NY',
'11947': 'Jamesport,NY',
'11948': 'Laurel,NY',
'11949': 'Manorville,NY',
'11950': 'Mastic,NY',
'11951': 'Mastic Beach,NY',
'11952': 'Mattituck,NY',
'11953': 'Middle Island,NY',
'11954': 'Montauk,NY',
'11955': 'Moriches,NY',
'11956': 'New Suffolk,NY',
'11957': 'Orient,NY',
'11958': 'Peconic,NY',
'11959': 'Quogue,NY',
'11960': 'Remsenburg,NY',
'11961': 'Ridge,NY',
'11962': 'Sagaponack,NY',
'11963': 'Sag Harbor,NY',
'11964': 'Shelter Island,NY',
'11965': 'Shelter Island Heights,NY',
'11967': 'Shirley,NY',
'11968': 'Southampton,NY',
'11969': 'Southampton,NY',
'11970': 'South Jamesport,NY',
'11971': 'Southold,NY',
'11972': 'Speonk,NY',
'11973': 'Upton,NY',
'11975': 'Wainscott,NY',
'11976': 'Water Mill,NY',
'11977': 'Westhampton,NY',
'11978': 'Westhampton Beach,NY',
'11980': 'Yaphank,NY',
'12007': 'Alcove,NY',
'12008': 'Alplaus,NY',
'12009': 'Altamont,NY',
'12010': 'Amsterdam,NY',
'12015': 'Athens,NY',
'12016': 'Auriesville,NY',
'12017': 'Austerlitz,NY',
'12018': 'Averill Park,NY',
'12019': 'Ballston Lake,NY',
'12020': 'Ballston Spa,NY',
'12022': 'Berlin,NY',
'12023': 'Berne,NY',
'12024': 'Brainard,NY',
'12025': 'Broadalbin,NY',
'12027': 'Burnt Hills,NY',
'12028': 'Buskirk,NY',
'12029': 'Canaan,NY',
'12031': 'Carlisle,NY',
'12032': 'Caroga Lake,NY',
'12033': 'Castleton On Hudson,NY',
'12035': 'Central Bridge,NY',
'12036': 'Charlotteville,NY',
'12037': 'Chatham,NY',
'12040': 'Cherry Plain,NY',
'12041': 'Clarksville,NY',
'12042': 'Climax,NY',
'12043': 'Cobleskill,NY',
'12045': 'Coeymans,NY',
'12046': 'Coeymans Hollow,NY',
'12047': 'Cohoes,NY',
'12050': 'Columbiaville,NY',
'12051': 'Coxsackie,NY',
'12052': 'Cropseyville,NY',
'12053': 'Delanson,NY',
'12054': 'Delmar,NY',
'12055': 'Dormansville,NY',
'12056': 'Duanesburg,NY',
'12057': 'Eagle Bridge,NY',
'12058': 'Earlton,NY',
'12059': 'East Berne,NY',
'12060': 'East Chatham,NY',
'12061': 'East Greenbush,NY',
'12062': 'East Nassau,NY',
'12063': 'East Schodack,NY',
'12064': 'East Worcester,NY',
'12065': 'Clifton Park,NY',
'12066': 'Esperance,NY',
'12067': 'Feura Bush,NY',
'12068': 'Fonda,NY',
'12069': 'Fort Hunter,NY',
'12070': 'Fort Johnson,NY',
'12071': 'Fultonham,NY',
'12072': 'Fultonville,NY',
'12073': 'Gallupville,NY',
'12074': 'Galway,NY',
'12075': 'Ghent,NY',
'12076': 'Gilboa,NY',
'12077': 'Glenmont,NY',
'12078': 'Gloversville,NY',
'12082': 'Grafton,NY',
'12083': 'Greenville,NY',
'12084': 'Guilderland,NY',
'12085': 'Guilderland Center,NY',
'12086': 'Hagaman,NY',
'12087': 'Hannacroix,NY',
'12089': 'Hoosick,NY',
'12090': 'Hoosick Falls,NY',
'12092': 'Howes Cave,NY',
'12093': 'Jefferson,NY',
'12094': 'Johnsonville,NY',
'12095': 'Johnstown,NY',
'12106': 'Kinderhook,NY',
'12107': 'Knox,NY',
'12108': 'Lake Pleasant,NY',
'12110': 'Latham,NY',
'12111': 'Latham,NY',
'12115': 'Malden Bridge,NY',
'12116': 'Maryland,NY',
'12117': 'Mayfield,NY',
'12118': 'Mechanicville,NY',
'12120': 'Medusa,NY',
'12121': 'Melrose,NY',
'12122': 'Middleburgh,NY',
'12123': 'Nassau,NY',
'12124': 'New Baltimore,NY',
'12125': 'New Lebanon,NY',
'12128': 'Newtonville,NY',
'12130': 'Niverville,NY',
'12131': 'North Blenheim,NY',
'12132': 'North Chatham,NY',
'12133': 'North Hoosick,NY',
'12134': 'Northville,NY',
'12136': 'Old Chatham,NY',
'12137': 'Pattersonville,NY',
'12138': 'Petersburg,NY',
'12139': 'Piseco,NY',
'12140': 'Poestenkill,NY',
'12141': 'Quaker Street,NY',
'12143': 'Ravena,NY',
'12144': 'Rensselaer,NY',
'12147': 'Rensselaerville,NY',
'12148': 'Rexford,NY',
'12149': 'Richmondville,NY',
'12150': 'Rotterdam Junction,NY',
'12151': 'Round Lake,NY',
'12153': 'Sand Lake,NY',
'12154': 'Schaghticoke,NY',
'12155': 'Schenevus,NY',
'12156': 'Schodack Landing,NY',
'12157': 'Schoharie,NY',
'12158': 'Selkirk,NY',
'12159': 'Slingerlands,NY',
'12160': 'Sloansville,NY',
'12161': 'South Bethlehem,NY',
'12164': 'Speculator,NY',
'12165': 'Spencertown,NY',
'12166': 'Sprakers,NY',
'12167': 'Stamford,NY',
'12168': 'Stephentown,NY',
'12169': 'Stephentown,NY',
'12170': 'Stillwater,NY',
'12172': 'Stottville,NY',
'12173': 'Stuyvesant,NY',
'12174': 'Stuyvesant Falls,NY',
'12175': 'Summit,NY',
'12176': 'Surprise,NY',
'12177': 'Tribes Hill,NY',
'12179': 'Troy,NY',
'12180': 'Troy,NY',
'12181': 'Troy,NY',
'12182': 'Troy,NY',
'12183': 'Troy,NY',
'12184': 'Valatie,NY',
'12185': 'Valley Falls,NY',
'12186': 'Voorheesville,NY',
'12187': 'Warnerville,NY',
'12188': 'Waterford,NY',
'12189': 'Watervliet,NY',
'12190': 'Wells,NY',
'12192': 'West Coxsackie,NY',
'12193': 'Westerlo,NY',
'12194': 'West Fulton,NY',
'12195': 'West Lebanon,NY',
'12196': 'West Sand Lake,NY',
'12197': 'Worcester,NY',
'12198': 'Wynantskill,NY',
'12201': 'Albany,NY',
'12202': 'Albany,NY',
'12203': 'Albany,NY',
'12204': 'Albany,NY',
'12205': 'Albany,NY',
'12206': 'Albany,NY',
'12207': 'Albany,NY',
'12208': 'Albany,NY',
'12209': 'Albany,NY',
'12210': 'Albany,NY',
'12211': 'Albany,NY',
'12212': 'Albany,NY',
'12214': 'Albany,NY',
'12220': 'Albany,NY',
'12222': 'Albany,NY',
'12223': 'Albany,NY',
'12224': 'Albany,NY',
'12225': 'Albany,NY',
'12226': 'Albany,NY',
'12227': 'Albany,NY',
'12228': 'Albany,NY',
'12229': 'Albany,NY',
'12230': 'Albany,NY',
'12231': 'Albany,NY',
'12232': 'Albany,NY',
'12233': 'Albany,NY',
'12234': 'Albany,NY',
'12235': 'Albany,NY',
'12236': 'Albany,NY',
'12237': 'Albany,NY',
'12238': 'Albany,NY',
'12239': 'Albany,NY',
'12240': 'Albany,NY',
'12241': 'Albany,NY',
'12242': 'Albany,NY',
'12243': 'Albany,NY',
'12244': 'Albany,NY',
'12245': 'Albany,NY',
'12246': 'Albany,NY',
'12247': 'Albany,NY',
'12248': 'Albany,NY',
'12249': 'Albany,NY',
'12250': 'Albany,NY',
'12252': 'Albany,NY',
'12255': 'Albany,NY',
'12256': 'Albany,NY',
'12257': 'Albany,NY',
'12260': 'Albany,NY',
'12261': 'Albany,NY',
'12262': 'Albany,NY',
'12288': 'Albany,NY',
'12301': 'Schenectady,NY',
'12302': 'Schenectady,NY',
'12303': 'Schenectady,NY',
'12304': 'Schenectady,NY',
'12305': 'Schenectady,NY',
'12306': 'Schenectady,NY',
'12307': 'Schenectady,NY',
'12308': 'Schenectady,NY',
'12309': 'Schenectady,NY',
'12325': 'Schenectady,NY',
'12345': 'Schenectady,NY',
'12401': 'Kingston,NY',
'12402': 'Kingston,NY',
'12404': 'Accord,NY',
'12405': 'Acra,NY',
'12406': 'Arkville,NY',
'12407': 'Ashland,NY',
'12409': 'Bearsville,NY',
'12410': 'Big Indian,NY',
'12411': 'Bloomington,NY',
'12412': 'Boiceville,NY',
'12413': 'Cairo,NY',
'12414': 'Catskill,NY',
'12416': 'Chichester,NY',
'12417': 'Connelly,NY',
'12418': 'Cornwallville,NY',
'12419': 'Cottekill,NY',
'12420': 'Cragsmoor,NY',
'12421': 'Denver,NY',
'12422': 'Durham,NY',
'12423': 'East Durham,NY',
'12424': 'East Jewett,NY',
'12427': 'Elka Park,NY',
'12428': 'Ellenville,NY',
'12429': 'Esopus,NY',
'12430': 'Fleischmanns,NY',
'12431': 'Freehold,NY',
'12432': 'Glasco,NY',
'12433': 'Glenford,NY',
'12434': 'Grand Gorge,NY',
'12435': 'Greenfield Park,NY',
'12436': 'Haines Falls,NY',
'12438': 'Halcottsville,NY',
'12439': 'Hensonville,NY',
'12440': 'High Falls,NY',
'12441': 'Highmount,NY',
'12442': 'Hunter,NY',
'12443': 'Hurley,NY',
'12444': 'Jewett,NY',
'12446': 'Kerhonkson,NY',
'12448': 'Lake Hill,NY',
'12449': 'Lake Katrine,NY',
'12450': 'Lanesville,NY',
'12451': 'Leeds,NY',
'12452': 'Lexington,NY',
'12453': 'Malden On Hudson,NY',
'12454': 'Maplecrest,NY',
'12455': 'Margaretville,NY',
'12456': 'Mount Marion,NY',
'12457': 'Mount Tremper,NY',
'12458': 'Napanoch,NY',
'12459': 'New Kingston,NY',
'12460': 'Oak Hill,NY',
'12461': 'Olivebridge,NY',
'12463': 'Palenville,NY',
'12464': 'Phoenicia,NY',
'12465': 'Pine Hill,NY',
'12466': 'Port Ewen,NY',
'12468': 'Prattsville,NY',
'12469': 'Preston Hollow,NY',
'12470': 'Purling,NY',
'12471': 'Rifton,NY',
'12472': 'Rosendale,NY',
'12473': 'Round Top,NY',
'12474': 'Roxbury,NY',
'12475': 'Ruby,NY',
'12477': 'Saugerties,NY',
'12480': 'Shandaken,NY',
'12481': 'Shokan,NY',
'12482': 'South Cairo,NY',
'12483': 'Spring Glen,NY',
'12484': 'Stone Ridge,NY',
'12485': 'Tannersville,NY',
'12486': 'Tillson,NY',
'12487': 'Ulster Park,NY',
'12489': 'Wawarsing,NY',
'12490': 'West Camp,NY',
'12491': 'West Hurley,NY',
'12492': 'West Kill,NY',
'12493': 'West Park,NY',
'12494': 'West Shokan,NY',
'12495': 'Willow,NY',
'12496': 'Windham,NY',
'12498': 'Woodstock,NY',
'12501': 'Amenia,NY',
'12502': 'Ancram,NY',
'12503': 'Ancramdale,NY',
'12504': 'Annandale On Hudson,NY',
'12506': 'Bangall,NY',
'12507': 'Barrytown,NY',
'12508': 'Beacon,NY',
'12510': 'Billings,NY',
'12511': 'Castle Point,NY',
'12512': 'Chelsea,NY',
'12513': 'Claverack,NY',
'12514': 'Clinton Corners,NY',
'12515': 'Clintondale,NY',
'12516': 'Copake,NY',
'12517': 'Copake Falls,NY',
'12518': 'Cornwall,NY',
'12520': 'Cornwall On Hudson,NY',
'12521': 'Craryville,NY',
'12522': 'Dover Plains,NY',
'12523': 'Elizaville,NY',
'12524': 'Fishkill,NY',
'12525': 'Gardiner,NY',
'12526': 'Germantown,NY',
'12527': 'Glenham,NY',
'12528': 'Highland,NY',
'12529': 'Hillsdale,NY',
'12530': 'Hollowville,NY',
'12531': 'Holmes,NY',
'12533': 'Hopewell Junction,NY',
'12534': 'Hudson,NY',
'12537': 'Hughsonville,NY',
'12538': 'Hyde Park,NY',
'12540': 'Lagrangeville,NY',
'12541': 'Livingston,NY',
'12542': 'Marlboro,NY',
'12543': 'Maybrook,NY',
'12544': 'Mellenville,NY',
'12545': 'Millbrook,NY',
'12546': 'Millerton,NY',
'12547': 'Milton,NY',
'12548': 'Modena,NY',
'12549': 'Montgomery,NY',
'12550': 'Newburgh,NY',
'12551': 'Newburgh,NY',
'12552': 'Newburgh,NY',
'12553': 'New Windsor,NY',
'12555': 'Mid Hudson,NY',
'12561': 'New Paltz,NY',
'12563': 'Patterson,NY',
'12564': 'Pawling,NY',
'12565': 'Philmont,NY',
'12566': 'Pine Bush,NY',
'12567': 'Pine Plains,NY',
'12568': 'Plattekill,NY',
'12569': 'Pleasant Valley,NY',
'12570': 'Poughquag,NY',
'12571': 'Red Hook,NY',
'12572': 'Rhinebeck,NY',
'12574': 'Rhinecliff,NY',
'12575': 'Rock Tavern,NY',
'12577': 'Salisbury Mills,NY',
'12578': 'Salt Point,NY',
'12580': 'Staatsburg,NY',
'12581': 'Stanfordville,NY',
'12582': 'Stormville,NY',
'12583': 'Tivoli,NY',
'12584': 'Vails Gate,NY',
'12585': 'Verbank,NY',
'12586': 'Walden,NY',
'12588': 'Walker Valley,NY',
'12589': 'Wallkill,NY',
'12590': 'Wappingers Falls,NY',
'12592': 'Wassaic,NY',
'12593': 'West Copake,NY',
'12594': 'Wingdale,NY',
'12601': 'Poughkeepsie,NY',
'12602': 'Poughkeepsie,NY',
'12603': 'Poughkeepsie,NY',
'12604': 'Poughkeepsie,NY',
'12701': 'Monticello,NY',
'12719': 'Barryville,NY',
'12720': 'Bethel,NY',
'12721': 'Bloomingburg,NY',
'12722': 'Burlingham,NY',
'12723': 'Callicoon,NY',
'12724': 'Callicoon Center,NY',
'12725': 'Claryville,NY',
'12726': 'Cochecton,NY',
'12727': 'Cochecton Center,NY',
'12729': 'Cuddebackville,NY',
'12732': 'Eldred,NY',
'12733': 'Fallsburg,NY',
'12734': 'Ferndale,NY',
'12736': 'Fremont Center,NY',
'12737': 'Glen Spey,NY',
'12738': 'Glen Wild,NY',
'12739': 'Godeffroy,NY',
'12740': 'Grahamsville,NY',
'12741': 'Hankins,NY',
'12742': 'Harris,NY',
'12743': 'Highland Lake,NY',
'12745': 'Hortonville,NY',
'12746': 'Huguenot,NY',
'12747': 'Hurleyville,NY',
'12748': 'Jeffersonville,NY',
'12749': 'Kauneonga Lake,NY',
'12750': 'Kenoza Lake,NY',
'12751': 'Kiamesha Lake,NY',
'12752': 'Lake Huntington,NY',
'12754': 'Liberty,NY',
'12758': 'Livingston Manor,NY',
'12759': 'Loch Sheldrake,NY',
'12760': 'Long Eddy,NY',
'12762': 'Mongaup Valley,NY',
'12763': 'Mountain Dale,NY',
'12764': 'Narrowsburg,NY',
'12765': 'Neversink,NY',
'12766': 'North Branch,NY',
'12767': 'Obernburg,NY',
'12768': 'Parksville,NY',
'12769': 'Phillipsport,NY',
'12770': 'Pond Eddy,NY',
'12771': 'Port Jervis,NY',
'12775': 'Rock Hill,NY',
'12776': 'Roscoe,NY',
'12777': 'Forestburgh,NY',
'12778': 'Smallwood,NY',
'12779': 'South Fallsburg,NY',
'12780': 'Sparrow Bush,NY',
'12781': 'Summitville,NY',
'12782': 'Sundown,NY',
'12783': 'Swan Lake,NY',
'12784': 'Thompsonville,NY',
'12785': 'Westbrookville,NY',
'12786': 'White Lake,NY',
'12787': 'White Sulphur Springs,NY',
'12788': 'Woodbourne,NY',
'12789': 'Woodridge,NY',
'12790': 'Wurtsboro,NY',
'12791': 'Youngsville,NY',
'12792': 'Yulan,NY',
'12801': 'Glens Falls,NY',
'12803': 'South Glens Falls,NY',
'12804': 'Queensbury,NY',
'12808': 'Adirondack,NY',
'12809': 'Argyle,NY',
'12810': 'Athol,NY',
'12811': 'Bakers Mills,NY',
'12812': 'Blue Mountain Lake,NY',
'12814': 'Bolton Landing,NY',
'12815': 'Brant Lake,NY',
'12816': 'Cambridge,NY',
'12817': 'Chestertown,NY',
'12819': 'Clemons,NY',
'12820': 'Cleverdale,NY',
'12821': 'Comstock,NY',
'12822': 'Corinth,NY',
'12823': 'Cossayuna,NY',
'12824': 'Diamond Point,NY',
'12827': 'Fort Ann,NY',
'12828': 'Fort Edward,NY',
'12831': 'Gansevoort,NY',
'12832': 'Granville,NY',
'12833': 'Greenfield Center,NY',
'12834': 'Greenwich,NY',
'12835': 'Hadley,NY',
'12836': 'Hague,NY',
'12837': 'Hampton,NY',
'12838': 'Hartford,NY',
'12839': 'Hudson Falls,NY',
'12841': 'Huletts Landing,NY',
'12842': 'Indian Lake,NY',
'12843': 'Johnsburg,NY',
'12844': 'Kattskill Bay,NY',
'12845': 'Lake George,NY',
'12846': 'Lake Luzerne,NY',
'12847': 'Long Lake,NY',
'12848': 'Middle Falls,NY',
'12849': 'Middle Granville,NY',
'12850': 'Middle Grove,NY',
'12851': 'Minerva,NY',
'12852': 'Newcomb,NY',
'12853': 'North Creek,NY',
'12854': 'North Granville,NY',
'12855': 'North Hudson,NY',
'12856': 'North River,NY',
'12857': 'Olmstedville,NY',
'12858': 'Paradox,NY',
'12859': 'Porter Corners,NY',
'12860': 'Pottersville,NY',
'12861': 'Putnam Station,NY',
'12862': 'Riparius,NY',
'12863': 'Rock City Falls,NY',
'12864': 'Sabael,NY',
'12865': 'Salem,NY',
'12866': 'Saratoga Springs,NY',
'12870': 'Schroon Lake,NY',
'12871': 'Schuylerville,NY',
'12872': 'Severance,NY',
'12873': 'Shushan,NY',
'12874': 'Silver Bay,NY',
'12878': 'Stony Creek,NY',
'12879': 'Newcomb,NY',
'12883': 'Ticonderoga,NY',
'12884': 'Victory Mills,NY',
'12885': 'Warrensburg,NY',
'12886': 'Wevertown,NY',
'12887': 'Whitehall,NY',
'12901': 'Plattsburgh,NY',
'12903': 'Plattsburgh,NY',
'12910': 'Altona,NY',
'12911': 'Keeseville,NY',
'12912': 'Au Sable Forks,NY',
'12913': 'Bloomingdale,NY',
'12914': 'Bombay,NY',
'12915': 'Brainardsville,NY',
'12916': 'Brushton,NY',
'12917': 'Burke,NY',
'12918': 'Cadyville,NY',
'12919': 'Champlain,NY',
'12920': 'Chateaugay,NY',
'12921': 'Chazy,NY',
'12922': 'Childwold,NY',
'12923': 'Churubusco,NY',
'12924': 'Keeseville,NY',
'12926': 'Constable,NY',
'12927': 'Cranberry Lake,NY',
'12928': 'Crown Point,NY',
'12929': 'Dannemora,NY',
'12930': 'Dickinson Center,NY',
'12932': 'Elizabethtown,NY',
'12933': 'Ellenburg,NY',
'12934': 'Ellenburg Center,NY',
'12935': 'Ellenburg Depot,NY',
'12936': 'Essex,NY',
'12937': 'Fort Covington,NY',
'12939': 'Gabriels,NY',
'12941': 'Jay,NY',
'12942': 'Keene,NY',
'12943': 'Keene Valley,NY',
'12944': 'Keeseville,NY',
'12945': 'Lake Clear,NY',
'12946': 'Lake Placid,NY',
'12949': 'Lawrenceville,NY',
'12950': 'Lewis,NY',
'12952': 'Lyon Mountain,NY',
'12953': 'Malone,NY',
'12955': 'Lyon Mountain,NY',
'12956': 'Mineville,NY',
'12957': 'Moira,NY',
'12958': 'Mooers,NY',
'12959': 'Mooers Forks,NY',
'12960': 'Moriah,NY',
'12961': 'Moriah Center,NY',
'12962': 'Morrisonville,NY',
'12964': 'New Russia,NY',
'12965': 'Nicholville,NY',
'12966': 'North Bangor,NY',
'12967': 'North Lawrence,NY',
'12969': 'Owls Head,NY',
'12970': 'Paul Smiths,NY',
'12972': 'Peru,NY',
'12973': 'Piercefield,NY',
'12974': 'Port Henry,NY',
'12975': 'Port Kent,NY',
'12976': 'Rainbow Lake,NY',
'12977': 'Ray Brook,NY',
'12978': 'Redford,NY',
'12979': 'Rouses Point,NY',
'12980': 'Saint Regis Falls,NY',
'12981': 'Saranac,NY',
'12983': 'Saranac Lake,NY',
'12985': 'Schuyler Falls,NY',
'12986': 'Tupper Lake,NY',
'12987': 'Upper Jay,NY',
'12989': 'Vermontville,NY',
'12992': 'West Chazy,NY',
'12993': 'Westport,NY',
'12995': 'Whippleville,NY',
'12996': 'Willsboro,NY',
'12997': 'Wilmington,NY',
'12998': 'Witherbee,NY',
'13020': 'Apulia Station,NY',
'13021': 'Auburn,NY',
'13022': 'Auburn,NY',
'13024': 'Auburn,NY',
'13026': 'Aurora,NY',
'13027': 'Baldwinsville,NY',
'13028': 'Bernhards Bay,NY',
'13029': 'Brewerton,NY',
'13030': 'Bridgeport,NY',
'13031': 'Camillus,NY',
'13032': 'Canastota,NY',
'13033': 'Cato,NY',
'13034': 'Cayuga,NY',
'13035': 'Cazenovia,NY',
'13036': 'Central Square,NY',
'13037': 'Chittenango,NY',
'13039': 'Cicero,NY',
'13040': 'Cincinnatus,NY',
'13041': 'Clay,NY',
'13042': 'Cleveland,NY',
'13043': 'Clockville,NY',
'13044': 'Constantia,NY',
'13045': 'Cortland,NY',
'13051': 'Delphi Falls,NY',
'13052': 'De Ruyter,NY',
'13053': 'Dryden,NY',
'13054': 'Durhamville,NY',
'13056': 'East Homer,NY',
'13057': 'East Syracuse,NY',
'13060': 'Elbridge,NY',
'13061': 'Erieville,NY',
'13062': 'Etna,NY',
'13063': 'Fabius,NY',
'13064': 'Fair Haven,NY',
'13065': 'Fayette,NY',
'13066': 'Fayetteville,NY',
'13068': 'Freeville,NY',
'13069': 'Fulton,NY',
'13071': 'Genoa,NY',
'13072': 'Georgetown,NY',
'13073': 'Groton,NY',
'13074': 'Hannibal,NY',
'13076': 'Hastings,NY',
'13077': 'Homer,NY',
'13078': 'Jamesville,NY',
'13080': 'Jordan,NY',
'13081': 'King Ferry,NY',
'13082': 'Kirkville,NY',
'13083': 'Lacona,NY',
'13084': 'La Fayette,NY',
'13087': 'Little York,NY',
'13088': 'Liverpool,NY',
'13089': 'Liverpool,NY',
'13090': 'Liverpool,NY',
'13092': 'Locke,NY',
'13093': 'Lycoming,NY',
'13101': 'Mc Graw,NY',
'13102': 'Mc Lean,NY',
'13103': 'Mallory,NY',
'13104': 'Manlius,NY',
'13107': 'Maple View,NY',
'13108': 'Marcellus,NY',
'13110': 'Marietta,NY',
'13111': 'Martville,NY',
'13112': 'Memphis,NY',
'13113': 'Meridian,NY',
'13114': 'Mexico,NY',
'13115': 'Minetto,NY',
'13116': 'Minoa,NY',
'13117': 'Montezuma,NY',
'13118': 'Moravia,NY',
'13119': 'Mottville,NY',
'13120': 'Nedrow,NY',
'13121': 'New Haven,NY',
'13122': 'New Woodstock,NY',
'13123': 'North Bay,NY',
'13124': 'North Pitcher,NY',
'13126': 'Oswego,NY',
'13129': 'Georgetown,NY',
'13131': 'Parish,NY',
'13132': 'Pennellville,NY',
'13134': 'Peterboro,NY',
'13135': 'Phoenix,NY',
'13136': 'Pitcher,NY',
'13137': 'Plainville,NY',
'13138': 'Pompey,NY',
'13139': 'Poplar Ridge,NY',
'13140': 'Port Byron,NY',
'13141': 'Preble,NY',
'13142': 'Pulaski,NY',
'13143': 'Red Creek,NY',
'13144': 'Richland,NY',
'13145': 'Sandy Creek,NY',
'13146': 'Savannah,NY',
'13147': 'Scipio Center,NY',
'13148': 'Seneca Falls,NY',
'13152': 'Skaneateles,NY',
'13153': 'Skaneateles Falls,NY',
'13154': 'South Butler,NY',
'13155': 'South Otselic,NY',
'13156': 'Sterling,NY',
'13157': 'Sylvan Beach,NY',
'13158': 'Truxton,NY',
'13159': 'Tully,NY',
'13160': 'Union Springs,NY',
'13162': 'Verona Beach,NY',
'13163': 'Wampsville,NY',
'13164': 'Warners,NY',
'13165': 'Waterloo,NY',
'13166': 'Weedsport,NY',
'13167': 'West Monroe,NY',
'13201': 'Syracuse,NY',
'13202': 'Syracuse,NY',
'13203': 'Syracuse,NY',
'13204': 'Syracuse,NY',
'13205': 'Syracuse,NY',
'13206': 'Syracuse,NY',
'13207': 'Syracuse,NY',
'13208': 'Syracuse,NY',
'13209': 'Syracuse,NY',
'13210': 'Syracuse,NY',
'13211': 'Syracuse,NY',
'13212': 'Syracuse,NY',
'13214': 'Syracuse,NY',
'13215': 'Syracuse,NY',
'13217': 'Syracuse,NY',
'13218': 'Syracuse,NY',
'13219': 'Syracuse,NY',
'13220': 'Syracuse,NY',
'13221': 'Syracuse,NY',
'13224': 'Syracuse,NY',
'13225': 'Syracuse,NY',
'13235': 'Syracuse,NY',
'13244': 'Syracuse,NY',
'13250': 'Syracuse,NY',
'13251': 'Syracuse,NY',
'13252': 'Syracuse,NY',
'13260': 'Syracuse,NY',
'13261': 'Syracuse,NY',
'13290': 'Syracuse,NY',
'13301': 'Alder Creek,NY',
'13302': 'Altmar,NY',
'13303': 'Ava,NY',
'13304': 'Barneveld,NY',
'13305': 'Beaver Falls,NY',
'13308': 'Blossvale,NY',
'13309': 'Boonville,NY',
'13310': 'Bouckville,NY',
'13312': 'Brantingham,NY',
'13313': 'Bridgewater,NY',
'13314': 'Brookfield,NY',
'13315': 'Burlington Flats,NY',
'13316': 'Camden,NY',
'13317': 'Canajoharie,NY',
'13318': 'Cassville,NY',
'13319': 'Chadwicks,NY',
'13320': 'Cherry Valley,NY',
'13321': 'Clark Mills,NY',
'13322': 'Clayville,NY',
'13323': 'Clinton,NY',
'13324': 'Cold Brook,NY',
'13325': 'Constableville,NY',
'13326': 'Cooperstown,NY',
'13327': 'Croghan,NY',
'13328': 'Deansboro,NY',
'13329': 'Dolgeville,NY',
'13331': 'Eagle Bay,NY',
'13332': 'Earlville,NY',
'13333': 'East Springfield,NY',
'13334': 'Eaton,NY',
'13335': 'Edmeston,NY',
'13337': 'Fly Creek,NY',
'13338': 'Forestport,NY',
'13339': 'Fort Plain,NY',
'13340': 'Frankfort,NY',
'13341': 'Franklin Springs,NY',
'13342': 'Garrattsville,NY',
'13343': 'Glenfield,NY',
'13345': 'Greig,NY',
'13346': 'Hamilton,NY',
'13348': 'Hartwick,NY',
'13350': 'Herkimer,NY',
'13352': 'Hinckley,NY',
'13353': 'Hoffmeister,NY',
'13354': 'Holland Patent,NY',
'13355': 'Hubbardsville,NY',
'13357': 'Ilion,NY',
'13360': 'Inlet,NY',
'13361': 'Jordanville,NY',
'13362': 'Knoxboro,NY',
'13363': 'Lee Center,NY',
'13364': 'Leonardsville,NY',
'13365': 'Little Falls,NY',
'13367': 'Lowville,NY',
'13368': 'Lyons Falls,NY',
'13401': 'Mc Connellsville,NY',
'13402': 'Madison,NY',
'13403': 'Marcy,NY',
'13404': 'Martinsburg,NY',
'13406': 'Middleville,NY',
'13407': 'Mohawk,NY',
'13408': 'Morrisville,NY',
'13409': 'Munnsville,NY',
'13410': 'Nelliston,NY',
'13411': 'New Berlin,NY',
'13413': 'New Hartford,NY',
'13415': 'New Lisbon,NY',
'13416': 'Newport,NY',
'13417': 'New York Mills,NY',
'13418': 'North Brookfield,NY',
'13420': 'Old Forge,NY',
'13421': 'Oneida,NY',
'13424': 'Oriskany,NY',
'13425': 'Oriskany Falls,NY',
'13426': 'Orwell,NY',
'13428': 'Palatine Bridge,NY',
'13431': 'Poland,NY',
'13433': 'Port Leyden,NY',
'13435': 'Prospect,NY',
'13436': 'Raquette Lake,NY',
'13437': 'Redfield,NY',
'13438': 'Remsen,NY',
'13439': 'Richfield Springs,NY',
'13440': 'Rome,NY',
'13441': 'Rome,NY',
'13442': 'Rome,NY',
'13449': 'Rome,NY',
'13450': 'Roseboom,NY',
'13452': 'Saint Johnsville,NY',
'13454': 'Salisbury Center,NY',
'13455': 'Sangerfield,NY',
'13456': 'Sauquoit,NY',
'13457': 'Schuyler Lake,NY',
'13459': 'Sharon Springs,NY',
'13460': 'Sherburne,NY',
'13461': 'Sherrill,NY',
'13464': 'Smyrna,NY',
'13465': 'Solsville,NY',
'13468': 'Springfield Center,NY',
'13469': 'Stittville,NY',
'13470': 'Stratford,NY',
'13471': 'Taberg,NY',
'13472': 'Thendara,NY',
'13473': 'Turin,NY',
'13475': 'Van Hornesville,NY',
'13476': 'Vernon,NY',
'13477': 'Vernon Center,NY',
'13478': 'Verona,NY',
'13479': 'Washington Mills,NY',
'13480': 'Waterville,NY',
'13482': 'West Burlington,NY',
'13483': 'Westdale,NY',
'13484': 'West Eaton,NY',
'13485': 'West Edmeston,NY',
'13486': 'Westernville,NY',
'13488': 'Westford,NY',
'13489': 'West Leyden,NY',
'13490': 'Westmoreland,NY',
'13491': 'West Winfield,NY',
'13492': 'Whitesboro,NY',
'13493': 'Williamstown,NY',
'13494': 'Woodgate,NY',
'13495': 'Yorkville,NY',
'13501': 'Utica,NY',
'13502': 'Utica,NY',
'13503': 'Utica,NY',
'13504': 'Utica,NY',
'13505': 'Utica,NY',
'13599': 'Utica,NY',
'13601': 'Watertown,NY',
'13602': 'Fort Drum,NY',
'13603': 'Watertown,NY',
'13605': 'Adams,NY',
'13606': 'Adams Center,NY',
'13607': 'Alexandria Bay,NY',
'13608': 'Antwerp,NY',
'13611': 'Belleville,NY',
'13612': 'Black River,NY',
'13613': 'Brasher Falls,NY',
'13614': 'Brier Hill,NY',
'13615': 'Brownville,NY',
'13616': 'Calcium,NY',
'13617': 'Canton,NY',
'13618': 'Cape Vincent,NY',
'13619': 'Carthage,NY',
'13620': 'Castorland,NY',
'13621': 'Chase Mills,NY',
'13622': 'Chaumont,NY',
'13623': 'Chippewa Bay,NY',
'13624': 'Clayton,NY',
'13625': 'Colton,NY',
'13626': 'Copenhagen,NY',
'13627': 'Deer River,NY',
'13628': 'Deferiet,NY',
'13630': 'De Kalb Junction,NY',
'13631': 'Denmark,NY',
'13632': 'Depauville,NY',
'13633': 'De Peyster,NY',
'13634': 'Dexter,NY',
'13635': 'Edwards,NY',
'13636': 'Ellisburg,NY',
'13637': 'Evans Mills,NY',
'13638': 'Felts Mills,NY',
'13639': 'Fine,NY',
'13640': 'Wellesley Island,NY',
'13641': 'Fishers Landing,NY',
'13642': 'Gouverneur,NY',
'13643': 'Great Bend,NY',
'13645': 'Hailesboro,NY',
'13646': 'Hammond,NY',
'13647': 'Hannawa Falls,NY',
'13648': 'Harrisville,NY',
'13649': 'Helena,NY',
'13650': 'Henderson,NY',
'13651': 'Henderson Harbor,NY',
'13652': 'Hermon,NY',
'13654': 'Heuvelton,NY',
'13655': 'Hogansburg,NY',
'13656': 'La Fargeville,NY',
'13657': 'Limerick,NY',
'13658': 'Lisbon,NY',
'13659': 'Lorraine,NY',
'13660': 'Madrid,NY',
'13661': 'Mannsville,NY',
'13662': 'Massena,NY',
'13664': 'Morristown,NY',
'13665': 'Natural Bridge,NY',
'13666': 'Newton Falls,NY',
'13667': 'Norfolk,NY',
'13668': 'Norwood,NY',
'13669': 'Ogdensburg,NY',
'13670': 'Oswegatchie,NY',
'13671': 'Oxbow,NY',
'13672': 'Parishville,NY',
'13673': 'Philadelphia,NY',
'13674': 'Pierrepont Manor,NY',
'13675': 'Plessis,NY',
'13676': 'Potsdam,NY',
'13677': 'Pyrites,NY',
'13678': 'Raymondville,NY',
'13679': 'Redwood,NY',
'13680': 'Rensselaer Falls,NY',
'13681': 'Richville,NY',
'13682': 'Rodman,NY',
'13683': 'Rooseveltown,NY',
'13684': 'Russell,NY',
'13685': 'Sackets Harbor,NY',
'13687': 'South Colton,NY',
'13688': 'South Rutland,NY',
'13690': 'Star Lake,NY',
'13691': 'Theresa,NY',
'13692': 'Thousand Island Park,NY',
'13693': 'Three Mile Bay,NY',
'13694': 'Waddington,NY',
'13695': 'Wanakena,NY',
'13696': 'West Stockholm,NY',
'13697': 'Winthrop,NY',
'13699': 'Potsdam,NY',
'13730': 'Afton,NY',
'13731': 'Andes,NY',
'13732': 'Apalachin,NY',
'13733': 'Bainbridge,NY',
'13734': 'Barton,NY',
'13736': 'Berkshire,NY',
'13737': 'Bible School Park,NY',
'13738': 'Blodgett Mills,NY',
'13739': 'Bloomville,NY',
'13740': 'Bovina Center,NY',
'13743': 'Candor,NY',
'13744': 'Castle Creek,NY',
'13745': 'Chenango Bridge,NY',
'13746': 'Chenango Forks,NY',
'13747': 'Colliersville,NY',
'13748': 'Conklin,NY',
'13749': 'Corbettsville,NY',
'13750': 'Davenport,NY',
'13751': 'Davenport Center,NY',
'13752': 'De Lancey,NY',
'13753': 'Delhi,NY',
'13754': 'Deposit,NY',
'13755': 'Downsville,NY',
'13756': 'East Branch,NY',
'13757': 'East Meredith,NY',
'13758': 'East Pharsalia,NY',
'13760': 'Endicott,NY',
'13761': 'Endicott,NY',
'13762': 'Endwell,NY',
'13763': 'Endicott,NY',
'13774': 'Fishs Eddy,NY',
'13775': 'Franklin,NY',
'13776': 'Gilbertsville,NY',
'13777': 'Glen Aubrey,NY',
'13778': 'Greene,NY',
'13780': 'Guilford,NY',
'13782': 'Hamden,NY',
'13783': 'Hancock,NY',
'13784': 'Harford,NY',
'13786': 'Harpersfield,NY',
'13787': 'Harpursville,NY',
'13788': 'Hobart,NY',
'13790': 'Johnson City,NY',
'13794': 'Killawog,NY',
'13795': 'Kirkwood,NY',
'13796': 'Laurens,NY',
'13797': 'Lisle,NY',
'13801': 'Mc Donough,NY',
'13802': 'Maine,NY',
'13803': 'Marathon,NY',
'13804': 'Masonville,NY',
'13806': 'Meridale,NY',
'13807': 'Milford,NY',
'13808': 'Morris,NY',
'13809': 'Mount Upton,NY',
'13810': 'Mount Vision,NY',
'13811': 'Newark Valley,NY',
'13812': 'Nichols,NY',
'13813': 'Nineveh,NY',
'13814': 'North Norwich,NY',
'13815': 'Norwich,NY',
'13820': 'Oneonta,NY',
'13825': 'Otego,NY',
'13826': 'Ouaquaga,NY',
'13827': 'Owego,NY',
'13830': 'Oxford,NY',
'13832': 'Plymouth,NY',
'13833': 'Port Crane,NY',
'13834': 'Portlandville,NY',
'13835': 'Richford,NY',
'13837': 'Shinhopple,NY',
'13838': 'Sidney,NY',
'13839': 'Sidney Center,NY',
'13840': 'Smithboro,NY',
'13841': 'Smithville Flats,NY',
'13842': 'South Kortright,NY',
'13843': 'South New Berlin,NY',
'13844': 'South Plymouth,NY',
'13845': 'Tioga Center,NY',
'13846': 'Treadwell,NY',
'13847': 'Trout Creek,NY',
'13848': 'Tunnel,NY',
'13849': 'Unadilla,NY',
'13850': 'Vestal,NY',
'13851': 'Vestal,NY',
'13856': 'Walton,NY',
'13859': 'Wells Bridge,NY',
'13860': 'West Davenport,NY',
'13861': 'West Oneonta,NY',
'13862': 'Whitney Point,NY',
'13863': 'Willet,NY',
'13864': 'Willseyville,NY',
'13865': 'Windsor,NY',
'13901': 'Binghamton,NY',
'13902': 'Binghamton,NY',
'13903': 'Binghamton,NY',
'13904': 'Binghamton,NY',
'13905': 'Binghamton,NY',
'14001': 'Akron,NY',
'14003': 'Alabama,NY',
'14004': 'Alden,NY',
'14005': 'Alexander,NY',
'14006': 'Angola,NY',
'14008': 'Appleton,NY',
'14009': 'Arcade,NY',
'14010': 'Athol Springs,NY',
'14011': 'Attica,NY',
'14012': 'Barker,NY',
'14013': 'Basom,NY',
'14020': 'Batavia,NY',
'14021': 'Batavia,NY',
'14024': 'Bliss,NY',
'14025': 'Boston,NY',
'14026': 'Bowmansville,NY',
'14027': 'Brant,NY',
'14028': 'Burt,NY',
'14029': 'Centerville,NY',
'14030': 'Chaffee,NY',
'14031': 'Clarence,NY',
'14032': 'Clarence Center,NY',
'14033': 'Colden,NY',
'14034': 'Collins,NY',
'14035': 'Collins Center,NY',
'14036': 'Corfu,NY',
'14037': 'Cowlesville,NY',
'14038': 'Crittenden,NY',
'14039': 'Dale,NY',
'14040': 'Darien Center,NY',
'14041': 'Dayton,NY',
'14042': 'Delevan,NY',
'14043': 'Depew,NY',
'14047': 'Derby,NY',
'14048': 'Dunkirk,NY',
'14051': 'East Amherst,NY',
'14052': 'East Aurora,NY',
'14054': 'East Bethany,NY',
'14055': 'East Concord,NY',
'14056': 'East Pembroke,NY',
'14057': 'Eden,NY',
'14058': 'Elba,NY',
'14059': 'Elma,NY',
'14060': 'Farmersville Station,NY',
'14061': 'Farnham,NY',
'14062': 'Forestville,NY',
'14063': 'Fredonia,NY',
'14065': 'Freedom,NY',
'14066': 'Gainesville,NY',
'14067': 'Gasport,NY',
'14068': 'Getzville,NY',
'14069': 'Glenwood,NY',
'14070': 'Gowanda,NY',
'14072': 'Grand Island,NY',
'14075': 'Hamburg,NY',
'14080': 'Holland,NY',
'14081': 'Irving,NY',
'14082': 'Java Center,NY',
'14083': 'Java Village,NY',
'14085': 'Lake View,NY',
'14086': 'Lancaster,NY',
'14091': 'Lawtons,NY',
'14092': 'Lewiston,NY',
'14094': 'Lockport,NY',
'14095': 'Lockport,NY',
'14098': 'Lyndonville,NY',
'14101': 'Machias,NY',
'14102': 'Marilla,NY',
'14103': 'Medina,NY',
'14105': 'Middleport,NY',
'14107': 'Model City,NY',
'14108': 'Newfane,NY',
'14109': 'Niagara University,NY',
'14110': 'North Boston,NY',
'14111': 'North Collins,NY',
'14112': 'North Evans,NY',
'14113': 'North Java,NY',
'14120': 'North Tonawanda,NY',
'14125': 'Oakfield,NY',
'14126': 'Olcott,NY',
'14127': 'Orchard Park,NY',
'14129': 'Perrysburg,NY',
'14130': 'Pike,NY',
'14131': 'Ransomville,NY',
'14132': 'Sanborn,NY',
'14133': 'Sandusky,NY',
'14134': 'Sardinia,NY',
'14135': 'Sheridan,NY',
'14136': 'Silver Creek,NY',
'14138': 'South Dayton,NY',
'14139': 'South Wales,NY',
'14140': 'Spring Brook,NY',
'14141': 'Springville,NY',
'14143': 'Stafford,NY',
'14144': 'Stella Niagara,NY',
'14145': 'Strykersville,NY',
'14150': 'Tonawanda,NY',
'14151': 'Tonawanda,NY',
'14166': 'Van Buren Point,NY',
'14167': 'Varysburg,NY',
'14168': 'Versailles,NY',
'14169': 'Wales Center,NY',
'14170': 'West Falls,NY',
'14171': 'West Valley,NY',
'14172': 'Wilson,NY',
'14173': 'Yorkshire,NY',
'14174': 'Youngstown,NY',
'14201': 'Buffalo,NY',
'14202': 'Buffalo,NY',
'14203': 'Buffalo,NY',
'14204': 'Buffalo,NY',
'14205': 'Buffalo,NY',
'14206': 'Buffalo,NY',
'14207': 'Buffalo,NY',
'14208': 'Buffalo,NY',
'14209': 'Buffalo,NY',
'14210': 'Buffalo,NY',
'14211': 'Buffalo,NY',
'14212': 'Buffalo,NY',
'14213': 'Buffalo,NY',
'14214': 'Buffalo,NY',
'14215': 'Buffalo,NY',
'14216': 'Buffalo,NY',
'14217': 'Buffalo,NY',
'14218': 'Buffalo,NY',
'14219': 'Buffalo,NY',
'14220': 'Buffalo,NY',
'14221': 'Buffalo,NY',
'14222': 'Buffalo,NY',
'14223': 'Buffalo,NY',
'14224': 'Buffalo,NY',
'14225': 'Buffalo,NY',
'14226': 'Buffalo,NY',
'14227': 'Buffalo,NY',
'14228': 'Buffalo,NY',
'14231': 'Buffalo,NY',
'14233': 'Buffalo,NY',
'14240': 'Buffalo,NY',
'14241': 'Buffalo,NY',
'14260': 'Buffalo,NY',
'14261': 'Buffalo,NY',
'14263': 'Buffalo,NY',
'14264': 'Buffalo,NY',
'14265': 'Buffalo,NY',
'14267': 'Buffalo,NY',
'14269': 'Buffalo,NY',
'14270': 'Buffalo,NY',
'14272': 'Buffalo,NY',
'14273': 'Buffalo,NY',
'14276': 'Buffalo,NY',
'14280': 'Buffalo,NY',
'14301': 'Niagara Falls,NY',
'14302': 'Niagara Falls,NY',
'14303': 'Niagara Falls,NY',
'14304': 'Niagara Falls,NY',
'14305': 'Niagara Falls,NY',
'14410': 'Adams Basin,NY',
'14411': 'Albion,NY',
'14413': 'Alton,NY',
'14414': 'Avon,NY',
'14415': 'Bellona,NY',
'14416': 'Bergen,NY',
'14418': 'Branchport,NY',
'14420': 'Brockport,NY',
'14422': 'Byron,NY',
'14423': 'Caledonia,NY',
'14424': 'Canandaigua,NY',
'14425': 'Farmington,NY',
'14427': 'Castile,NY',
'14428': 'Churchville,NY',
'14429': 'Clarendon,NY',
'14430': 'Clarkson,NY',
'14432': 'Clifton Springs,NY',
'14433': 'Clyde,NY',
'14435': 'Conesus,NY',
'14437': 'Dansville,NY',
'14441': 'Dresden,NY',
'14443': 'East Bloomfield,NY',
'14445': 'East Rochester,NY',
'14449': 'East Williamson,NY',
'14450': 'Fairport,NY',
'14452': 'Fancher,NY',
'14453': 'Fishers,NY',
'14454': 'Geneseo,NY',
'14456': 'Geneva,NY',
'14461': 'Gorham,NY',
'14462': 'Groveland,NY',
'14463': 'Hall,NY',
'14464': 'Hamlin,NY',
'14466': 'Hemlock,NY',
'14467': 'Henrietta,NY',
'14468': 'Hilton,NY',
'14469': 'Bloomfield,NY',
'14470': 'Holley,NY',
'14471': 'Honeoye,NY',
'14472': 'Honeoye Falls,NY',
'14475': 'Ionia,NY',
'14476': 'Kendall,NY',
'14477': 'Kent,NY',
'14478': 'Keuka Park,NY',
'14479': 'Knowlesville,NY',
'14480': 'Lakeville,NY',
'14481': 'Leicester,NY',
'14482': 'Le Roy,NY',
'14485': 'Lima,NY',
'14486': 'Linwood,NY',
'14487': 'Livonia,NY',
'14488': 'Livonia Center,NY',
'14489': 'Lyons,NY',
'14502': 'Macedon,NY',
'14504': 'Manchester,NY',
'14505': 'Marion,NY',
'14506': 'Mendon,NY',
'14507': 'Middlesex,NY',
'14508': 'Morton,NY',
'14510': 'Mount Morris,NY',
'14511': 'Mumford,NY',
'14512': 'Naples,NY',
'14513': 'Newark,NY',
'14514': 'North Chili,NY',
'14515': 'North Greece,NY',
'14516': 'North Rose,NY',
'14517': 'Nunda,NY',
'14518': 'Oaks Corners,NY',
'14519': 'Ontario,NY',
'14520': 'Ontario Center,NY',
'14521': 'Ovid,NY',
'14522': 'Palmyra,NY',
'14525': 'Pavilion,NY',
'14526': 'Penfield,NY',
'14527': 'Penn Yan,NY',
'14529': 'Perkinsville,NY',
'14530': 'Perry,NY',
'14532': 'Phelps,NY',
'14533': 'Piffard,NY',
'14534': 'Pittsford,NY',
'14536': 'Portageville,NY',
'14537': 'Port Gibson,NY',
'14538': 'Pultneyville,NY',
'14539': 'Retsof,NY',
'14541': 'Romulus,NY',
'14542': 'Rose,NY',
'14543': 'Rush,NY',
'14544': 'Rushville,NY',
'14545': 'Scottsburg,NY',
'14546': 'Scottsville,NY',
'14547': 'Seneca Castle,NY',
'14548': 'Shortsville,NY',
'14549': 'Silver Lake,NY',
'14550': 'Silver Springs,NY',
'14551': 'Sodus,NY',
'14555': 'Sodus Point,NY',
'14556': 'Sonyea,NY',
'14557': 'South Byron,NY',
'14558': 'South Lima,NY',
'14559': 'Spencerport,NY',
'14560': 'Springwater,NY',
'14561': 'Stanley,NY',
'14563': 'Union Hill,NY',
'14564': 'Victor,NY',
'14568': 'Walworth,NY',
'14569': 'Warsaw,NY',
'14571': 'Waterport,NY',
'14572': 'Wayland,NY',
'14580': 'Webster,NY',
'14585': 'West Bloomfield,NY',
'14586': 'West Henrietta,NY',
'14588': 'Willard,NY',
'14589': 'Williamson,NY',
'14590': 'Wolcott,NY',
'14591': 'Wyoming,NY',
'14592': 'York,NY',
'14601': 'Rochester,NY',
'14602': 'Rochester,NY',
'14603': 'Rochester,NY',
'14604': 'Rochester,NY',
'14605': 'Rochester,NY',
'14606': 'Rochester,NY',
'14607': 'Rochester,NY',
'14608': 'Rochester,NY',
'14609': 'Rochester,NY',
'14610': 'Rochester,NY',
'14611': 'Rochester,NY',
'14612': 'Rochester,NY',
'14613': 'Rochester,NY',
'14614': 'Rochester,NY',
'14615': 'Rochester,NY',
'14616': 'Rochester,NY',
'14617': 'Rochester,NY',
'14618': 'Rochester,NY',
'14619': 'Rochester,NY',
'14620': 'Rochester,NY',
'14621': 'Rochester,NY',
'14622': 'Rochester,NY',
'14623': 'Rochester,NY',
'14624': 'Rochester,NY',
'14625': 'Rochester,NY',
'14626': 'Rochester,NY',
'14627': 'Rochester,NY',
'14638': 'Rochester,NY',
'14639': 'Rochester,NY',
'14642': 'Rochester,NY',
'14643': 'Rochester,NY',
'14644': 'Rochester,NY',
'14645': 'Rochester,NY',
'14646': 'Rochester,NY',
'14647': 'Rochester,NY',
'14649': 'Rochester,NY',
'14650': 'Rochester,NY',
'14651': 'Rochester,NY',
'14652': 'Rochester,NY',
'14653': 'Rochester,NY',
'14660': 'Rochester,NY',
'14664': 'Rochester,NY',
'14673': 'Rochester,NY',
'14683': 'Rochester,NY',
'14692': 'Rochester,NY',
'14694': 'Rochester,NY',
'14701': 'Jamestown,NY',
'14702': 'Jamestown,NY',
'14703': 'Jamestown,NY',
'14704': 'Jamestown,NY',
'14706': 'Allegany,NY',
'14707': 'Allentown,NY',
'14708': 'Alma,NY',
'14709': 'Angelica,NY',
'14710': 'Ashville,NY',
'14711': 'Belfast,NY',
'14712': 'Bemus Point,NY',
'14714': 'Black Creek,NY',
'14715': 'Bolivar,NY',
'14716': 'Brocton,NY',
'14717': 'Caneadea,NY',
'14718': 'Cassadaga,NY',
'14719': 'Cattaraugus,NY',
'14720': 'Celoron,NY',
'14721': 'Ceres,NY',
'14722': 'Chautauqua,NY',
'14723': 'Cherry Creek,NY',
'14724': 'Clymer,NY',
'14726': 'Conewango Valley,NY',
'14727': 'Cuba,NY',
'14728': 'Dewittville,NY',
'14729': 'East Otto,NY',
'14730': 'East Randolph,NY',
'14731': 'Ellicottville,NY',
'14732': 'Ellington,NY',
'14733': 'Falconer,NY',
'14735': 'Fillmore,NY',
'14736': 'Findley Lake,NY',
'14737': 'Franklinville,NY',
'14738': 'Frewsburg,NY',
'14739': 'Friendship,NY',
'14740': 'Gerry,NY',
'14741': 'Great Valley,NY',
'14742': 'Greenhurst,NY',
'14743': 'Hinsdale,NY',
'14744': 'Houghton,NY',
'14745': 'Hume,NY',
'14747': 'Kennedy,NY',
'14748': 'Kill Buck,NY',
'14750': 'Lakewood,NY',
'14751': 'Leon,NY',
'14752': 'Lily Dale,NY',
'14753': 'Limestone,NY',
'14754': 'Little Genesee,NY',
'14755': 'Little Valley,NY',
'14756': 'Maple Springs,NY',
'14757': 'Mayville,NY',
'14758': 'Niobe,NY',
'14760': 'Olean,NY',
'14766': 'Otto,NY',
'14767': 'Panama,NY',
'14769': 'Portland,NY',
'14770': 'Portville,NY',
'14772': 'Randolph,NY',
'14774': 'Richburg,NY',
'14775': 'Ripley,NY',
'14777': 'Rushford,NY',
'14778': 'Saint Bonaventure,NY',
'14779': 'Salamanca,NY',
'14781': 'Sherman,NY',
'14782': 'Sinclairville,NY',
'14783': 'Steamburg,NY',
'14784': 'Stockton,NY',
'14785': 'Stow,NY',
'14786': 'West Clarksville,NY',
'14787': 'Westfield,NY',
'14788': 'Westons Mills,NY',
'14801': 'Addison,NY',
'14802': 'Alfred,NY',
'14803': 'Alfred Station,NY',
'14804': 'Almond,NY',
'14805': 'Alpine,NY',
'14806': 'Andover,NY',
'14807': 'Arkport,NY',
'14808': 'Atlanta,NY',
'14809': 'Avoca,NY',
'14810': 'Bath,NY',
'14812': 'Beaver Dams,NY',
'14813': 'Belmont,NY',
'14814': 'Big Flats,NY',
'14815': 'Bradford,NY',
'14816': 'Breesport,NY',
'14817': 'Brooktondale,NY',
'14818': 'Burdett,NY',
'14819': 'Cameron,NY',
'14820': 'Cameron Mills,NY',
'14821': 'Campbell,NY',
'14822': 'Canaseraga,NY',
'14823': 'Canisteo,NY',
'14824': 'Cayuta,NY',
'14825': 'Chemung,NY',
'14826': 'Cohocton,NY',
'14827': 'Coopers Plains,NY',
'14830': 'Corning,NY',
'14831': 'Corning,NY',
'14836': 'Dalton,NY',
'14837': 'Dundee,NY',
'14838': 'Erin,NY',
'14839': 'Greenwood,NY',
'14840': 'Hammondsport,NY',
'14841': 'Hector,NY',
'14842': 'Himrod,NY',
'14843': 'Hornell,NY',
'14844': 'Horseheads,NY',
'14845': 'Horseheads,NY',
'14846': 'Hunt,NY',
'14847': 'Interlaken,NY',
'14850': 'Ithaca,NY',
'14851': 'Ithaca,NY',
'14852': 'Ithaca,NY',
'14853': 'Ithaca,NY',
'14854': 'Jacksonville,NY',
'14855': 'Jasper,NY',
'14856': 'Kanona,NY',
'14857': 'Lakemont,NY',
'14858': 'Lindley,NY',
'14859': 'Lockwood,NY',
'14860': 'Lodi,NY',
'14861': 'Lowman,NY',
'14863': 'Mecklenburg,NY',
'14864': 'Millport,NY',
'14865': 'Montour Falls,NY',
'14867': 'Newfield,NY',
'14869': 'Odessa,NY',
'14870': 'Painted Post,NY',
'14871': 'Pine City,NY',
'14872': 'Pine Valley,NY',
'14873': 'Prattsburgh,NY',
'14874': 'Pulteney,NY',
'14876': 'Reading Center,NY',
'14877': 'Rexville,NY',
'14878': 'Rock Stream,NY',
'14879': 'Savona,NY',
'14880': 'Scio,NY',
'14881': 'Slaterville Springs,NY',
'14882': 'Lansing,NY',
'14883': 'Spencer,NY',
'14884': 'Swain,NY',
'14885': 'Troupsburg,NY',
'14886': 'Trumansburg,NY',
'14887': 'Tyrone,NY',
'14889': 'Van Etten,NY',
'14891': 'Watkins Glen,NY',
'14892': 'Waverly,NY',
'14893': 'Wayne,NY',
'14894': 'Wellsburg,NY',
'14895': 'Wellsville,NY',
'14897': 'Whitesville,NY',
'14898': 'Woodhull,NY',
'14901': 'Elmira,NY',
'14902': 'Elmira,NY',
'14903': 'Elmira,NY',
'14904': 'Elmira,NY',
'14905': 'Elmira,NY',
'14925': 'Elmira,NY',
'15001': 'Aliquippa,PA',
'15003': 'Ambridge,PA',
'15004': 'Atlasburg,PA',
'15005': 'Baden,PA',
'15006': 'Bairdford,PA',
'15007': 'Bakerstown,PA',
'15009': 'Beaver,PA',
'15010': 'Beaver Falls,PA',
'15012': 'Belle Vernon,PA',
'15014': 'Brackenridge,PA',
'15015': 'Bradfordwoods,PA',
'15017': 'Bridgeville,PA',
'15018': 'Buena Vista,PA',
'15019': 'Bulger,PA',
'15020': 'Bunola,PA',
'15021': 'Burgettstown,PA',
'15022': 'Charleroi,PA',
'15024': 'Cheswick,PA',
'15025': 'Clairton,PA',
'15026': 'Clinton,PA',
'15027': 'Conway,PA',
'15028': 'Coulters,PA',
'15030': 'Creighton,PA',
'15031': 'Cuddy,PA',
'15032': 'Curtisville,PA',
'15033': 'Donora,PA',
'15034': 'Dravosburg,PA',
'15035': 'East Mc Keesport,PA',
'15036': 'Eldersville,PA',
'15037': 'Elizabeth,PA',
'15038': 'Elrama,PA',
'15042': 'Freedom,PA',
'15043': 'Georgetown,PA',
'15044': 'Gibsonia,PA',
'15045': 'Glassport,PA',
'15046': 'Crescent,PA',
'15047': 'Greenock,PA',
'15049': 'Harwick,PA',
'15050': 'Hookstown,PA',
'15051': 'Indianola,PA',
'15052': 'Industry,PA',
'15053': 'Joffre,PA',
'15054': 'Langeloth,PA',
'15055': 'Lawrence,PA',
'15056': 'Leetsdale,PA',
'15057': 'Mc Donald,PA',
'15059': 'Midland,PA',
'15060': 'Midway,PA',
'15061': 'Monaca,PA',
'15062': 'Monessen,PA',
'15063': 'Monongahela,PA',
'15064': 'Morgan,PA',
'15065': 'Natrona Heights,PA',
'15066': 'New Brighton,PA',
'15067': 'New Eagle,PA',
'15068': 'New Kensington,PA',
'15069': 'New Kensington,PA',
'15071': 'Oakdale,PA',
'15072': 'Pricedale,PA',
'15074': 'Rochester,PA',
'15075': 'Rural Ridge,PA',
'15076': 'Russellton,PA',
'15077': 'Shippingport,PA',
'15078': 'Slovan,PA',
'15081': 'South Heights,PA',
'15082': 'Sturgeon,PA',
'15083': 'Sutersville,PA',
'15084': 'Tarentum,PA',
'15085': 'Trafford,PA',
'15086': 'Warrendale,PA',
'15087': 'Webster,PA',
'15088': 'West Elizabeth,PA',
'15089': 'West Newton,PA',
'15090': 'Wexford,PA',
'15091': 'Wildwood,PA',
'15095': 'Warrendale,PA',
'15096': 'Warrendale,PA',
'15101': 'Allison Park,PA',
'15102': 'Bethel Park,PA',
'15104': 'Braddock,PA',
'15106': 'Carnegie,PA',
'15108': 'Coraopolis,PA',
'15110': 'Duquesne,PA',
'15112': 'East Pittsburgh,PA',
'15116': 'Glenshaw,PA',
'15120': 'Homestead,PA',
'15122': 'West Mifflin,PA',
'15123': 'West Mifflin,PA',
'15126': 'Imperial,PA',
'15127': 'Ingomar,PA',
'15129': 'South Park,PA',
'15130': 'Mc Keesport,PA',
'15131': 'Mc Keesport,PA',
'15132': 'Mc Keesport,PA',
'15133': 'Mc Keesport,PA',
'15134': 'Mc Keesport,PA',
'15135': 'Mc Keesport,PA',
'15136': 'Mc Kees Rocks,PA',
'15137': 'North Versailles,PA',
'15139': 'Oakmont,PA',
'15140': 'Pitcairn,PA',
'15142': 'Presto,PA',
'15143': 'Sewickley,PA',
'15144': 'Springdale,PA',
'15145': 'Turtle Creek,PA',
'15146': 'Monroeville,PA',
'15147': 'Verona,PA',
'15148': 'Wilmerding,PA',
'15189': 'Sewickley,PA',
'15201': 'Pittsburgh,PA',
'15202': 'Pittsburgh,PA',
'15203': 'Pittsburgh,PA',
'15204': 'Pittsburgh,PA',
'15205': 'Pittsburgh,PA',
'15206': 'Pittsburgh,PA',
'15207': 'Pittsburgh,PA',
'15208': 'Pittsburgh,PA',
'15209': 'Pittsburgh,PA',
'15210': 'Pittsburgh,PA',
'15211': 'Pittsburgh,PA',
'15212': 'Pittsburgh,PA',
'15213': 'Pittsburgh,PA',
'15214': 'Pittsburgh,PA',
'15215': 'Pittsburgh,PA',
'15216': 'Pittsburgh,PA',
'15217': 'Pittsburgh,PA',
'15218': 'Pittsburgh,PA',
'15219': 'Pittsburgh,PA',
'15220': 'Pittsburgh,PA',
'15221': 'Pittsburgh,PA',
'15222': 'Pittsburgh,PA',
'15223': 'Pittsburgh,PA',
'15224': 'Pittsburgh,PA',
'15225': 'Pittsburgh,PA',
'15226': 'Pittsburgh,PA',
'15227': 'Pittsburgh,PA',
'15228': 'Pittsburgh,PA',
'15229': 'Pittsburgh,PA',
'15230': 'Pittsburgh,PA',
'15231': 'Pittsburgh,PA',
'15232': 'Pittsburgh,PA',
'15233': 'Pittsburgh,PA',
'15234': 'Pittsburgh,PA',
'15235': 'Pittsburgh,PA',
'15236': 'Pittsburgh,PA',
'15237': 'Pittsburgh,PA',
'15238': 'Pittsburgh,PA',
'15239': 'Pittsburgh,PA',
'15240': 'Pittsburgh,PA',
'15241': 'Pittsburgh,PA',
'15242': 'Pittsburgh,PA',
'15243': 'Pittsburgh,PA',
'15244': 'Pittsburgh,PA',
'15250': 'Pittsburgh,PA',
'15251': 'Pittsburgh,PA',
'15252': 'Pittsburgh,PA',
'15253': 'Pittsburgh,PA',
'15254': 'Pittsburgh,PA',
'15255': 'Pittsburgh,PA',
'15257': 'Pittsburgh,PA',
'15258': 'Pittsburgh,PA',
'15259': 'Pittsburgh,PA',
'15260': 'Pittsburgh,PA',
'15261': 'Pittsburgh,PA',
'15262': 'Pittsburgh,PA',
'15263': 'Pittsburgh,PA',
'15264': 'Pittsburgh,PA',
'15265': 'Pittsburgh,PA',
'15266': 'Pittsburgh,PA',
'15267': 'Pittsburgh,PA',
'15268': 'Pittsburgh,PA',
'15270': 'Pittsburgh,PA',
'15272': 'Pittsburgh,PA',
'15274': 'Pittsburgh,PA',
'15275': 'Pittsburgh,PA',
'15276': 'Pittsburgh,PA',
'15277': 'Pittsburgh,PA',
'15278': 'Pittsburgh,PA',
'15279': 'Pittsburgh,PA',
'15281': 'Pittsburgh,PA',
'15282': 'Pittsburgh,PA',
'15283': 'Pittsburgh,PA',
'15285': 'Pittsburgh,PA',
'15286': 'Pittsburgh,PA',
'15289': 'Pittsburgh,PA',
'15290': 'Pittsburgh,PA',
'15295': 'Pittsburgh,PA',
'15301': 'Washington,PA',
'15310': 'Aleppo,PA',
'15311': 'Amity,PA',
'15312': 'Avella,PA',
'15313': 'Beallsville,PA',
'15314': 'Bentleyville,PA',
'15315': 'Bobtown,PA',
'15316': 'Brave,PA',
'15317': 'Canonsburg,PA',
'15320': 'Carmichaels,PA',
'15321': 'Cecil,PA',
'15322': 'Clarksville,PA',
'15323': 'Claysville,PA',
'15324': 'Cokeburg,PA',
'15325': 'Crucible,PA',
'15327': 'Dilliner,PA',
'15329': 'Prosperity,PA',
'15330': 'Eighty Four,PA',
'15331': 'Ellsworth,PA',
'15332': 'Finleyville,PA',
'15333': 'Fredericktown,PA',
'15334': 'Garards Fort,PA',
'15336': 'Gastonville,PA',
'15337': 'Graysville,PA',
'15338': 'Greensboro,PA',
'15339': 'Hendersonville,PA',
'15340': 'Hickory,PA',
'15341': 'Holbrook,PA',
'15342': 'Houston,PA',
'15344': 'Jefferson,PA',
'15345': 'Marianna,PA',
'15346': 'Mather,PA',
'15347': 'Meadow Lands,PA',
'15348': 'Millsboro,PA',
'15349': 'Mount Morris,PA',
'15350': 'Muse,PA',
'15351': 'Nemacolin,PA',
'15352': 'New Freeport,PA',
'15353': 'Nineveh,PA',
'15354': 'Pine Bank,PA',
'15357': 'Rices Landing,PA',
'15358': 'Richeyville,PA',
'15359': 'Rogersville,PA',
'15360': 'Scenery Hill,PA',
'15361': 'Southview,PA',
'15362': 'Spraggs,PA',
'15363': 'Strabane,PA',
'15364': 'Sycamore,PA',
'15365': 'Taylorstown,PA',
'15366': 'Van Voorhis,PA',
'15367': 'Venetia,PA',
'15368': 'Vestaburg,PA',
'15370': 'Waynesburg,PA',
'15376': 'West Alexander,PA',
'15377': 'West Finley,PA',
'15378': 'Westland,PA',
'15379': 'West Middletown,PA',
'15380': 'Wind Ridge,PA',
'15401': 'Uniontown,PA',
'15410': 'Adah,PA',
'15411': 'Addison,PA',
'15412': 'Allenport,PA',
'15413': 'Allison,PA',
'15415': 'Brier Hill,PA',
'15416': 'Brownfield,PA',
'15417': 'Brownsville,PA',
'15419': 'California,PA',
'15420': 'Cardale,PA',
'15421': 'Chalk Hill,PA',
'15422': 'Chestnut Ridge,PA',
'15423': 'Coal Center,PA',
'15424': 'Confluence,PA',
'15425': 'Connellsville,PA',
'15427': 'Daisytown,PA',
'15428': 'Dawson,PA',
'15429': 'Denbo,PA',
'15430': 'Dickerson Run,PA',
'15431': 'Dunbar,PA',
'15432': 'Dunlevy,PA',
'15433': 'East Millsboro,PA',
'15434': 'Elco,PA',
'15435': 'Fairbank,PA',
'15436': 'Fairchance,PA',
'15437': 'Farmington,PA',
'15438': 'Fayette City,PA',
'15439': 'Gans,PA',
'15440': 'Gibbon Glade,PA',
'15442': 'Grindstone,PA',
'15443': 'Hibbs,PA',
'15444': 'Hiller,PA',
'15445': 'Hopwood,PA',
'15446': 'Indian Head,PA',
'15447': 'Isabella,PA',
'15448': 'Jacobs Creek,PA',
'15449': 'Keisterville,PA',
'15450': 'La Belle,PA',
'15451': 'Lake Lynn,PA',
'15454': 'Leckrone,PA',
'15455': 'Leisenring,PA',
'15456': 'Lemont Furnace,PA',
'15458': 'Mc Clellandtown,PA',
'15459': 'Markleysburg,PA',
'15460': 'Martin,PA',
'15461': 'Masontown,PA',
'15462': 'Melcroft,PA',
'15463': 'Merrittstown,PA',
'15464': 'Mill Run,PA',
'15465': 'Mount Braddock,PA',
'15466': 'Newell,PA',
'15467': 'New Geneva,PA',
'15468': 'New Salem,PA',
'15469': 'Normalville,PA',
'15470': 'Ohiopyle,PA',
'15472': 'Oliver,PA',
'15473': 'Perryopolis,PA',
'15474': 'Point Marion,PA',
'15475': 'Republic,PA',
'15476': 'Ronco,PA',
'15477': 'Roscoe,PA',
'15478': 'Smithfield,PA',
'15479': 'Smithton,PA',
'15480': 'Smock,PA',
'15482': 'Star Junction,PA',
'15483': 'Stockdale,PA',
'15484': 'Uledi,PA',
'15485': 'Ursina,PA',
'15486': 'Vanderbilt,PA',
'15488': 'Waltersburg,PA',
'15489': 'West Leisenring,PA',
'15490': 'White,PA',
'15492': 'Wickhaven,PA',
'15501': 'Somerset,PA',
'15502': 'Hidden Valley,PA',
'15510': 'Somerset,PA',
'15520': 'Acosta,PA',
'15521': 'Alum Bank,PA',
'15522': 'Bedford,PA',
'15530': 'Berlin,PA',
'15531': 'Boswell,PA',
'15532': 'Boynton,PA',
'15533': 'Breezewood,PA',
'15534': 'Buffalo Mills,PA',
'15535': 'Clearville,PA',
'15536': 'Crystal Spring,PA',
'15537': 'Everett,PA',
'15538': 'Fairhope,PA',
'15539': 'Fishertown,PA',
'15540': 'Fort Hill,PA',
'15541': 'Friedens,PA',
'15542': 'Garrett,PA',
'15544': 'Gray,PA',
'15545': 'Hyndman,PA',
'15546': 'Jenners,PA',
'15547': 'Jennerstown,PA',
'15548': 'Kantner,PA',
'15549': 'Listie,PA',
'15550': 'Manns Choice,PA',
'15551': 'Markleton,PA',
'15552': 'Meyersdale,PA',
'15553': 'New Baltimore,PA',
'15554': 'New Paris,PA',
'15555': 'Quecreek,PA',
'15557': 'Rockwood,PA',
'15558': 'Salisbury,PA',
'15559': 'Schellsburg,PA',
'15560': 'Shanksville,PA',
'15561': 'Sipesville,PA',
'15562': 'Springs,PA',
'15563': 'Stoystown,PA',
'15564': 'Wellersburg,PA',
'15565': 'West Salisbury,PA',
'15601': 'Greensburg,PA',
'15605': 'Greensburg,PA',
'15606': 'Greensburg,PA',
'15610': 'Acme,PA',
'15611': 'Adamsburg,PA',
'15612': 'Alverton,PA',
'15613': 'Apollo,PA',
'15615': 'Ardara,PA',
'15616': 'Armbrust,PA',
'15617': 'Arona,PA',
'15618': 'Avonmore,PA',
'15619': 'Bovard,PA',
'15620': 'Bradenville,PA',
'15621': 'Calumet,PA',
'15622': 'Champion,PA',
'15623': 'Claridge,PA',
'15624': 'Crabtree,PA',
'15625': 'Darragh,PA',
'15626': 'Delmont,PA',
'15627': 'Derry,PA',
'15628': 'Donegal,PA',
'15629': 'East Vandergrift,PA',
'15630': 'Edmon,PA',
'15631': 'Everson,PA',
'15632': 'Export,PA',
'15633': 'Forbes Road,PA',
'15634': 'Grapeville,PA',
'15635': 'Hannastown,PA',
'15636': 'Harrison City,PA',
'15637': 'Herminie,PA',
'15638': 'Hostetter,PA',
'15639': 'Hunker,PA',
'15640': 'Hutchinson,PA',
'15641': 'Hyde Park,PA',
'15642': 'Irwin,PA',
'15644': 'Jeannette,PA',
'15646': 'Jones Mills,PA',
'15647': 'Larimer,PA',
'15650': 'Latrobe,PA',
'15655': 'Laughlintown,PA',
'15656': 'Leechburg,PA',
'15658': 'Ligonier,PA',
'15660': 'Lowber,PA',
'15661': 'Loyalhanna,PA',
'15662': 'Luxor,PA',
'15663': 'Madison,PA',
'15664': 'Mammoth,PA',
'15665': 'Manor,PA',
'15666': 'Mount Pleasant,PA',
'15668': 'Murrysville,PA',
'15670': 'New Alexandria,PA',
'15671': 'New Derry,PA',
'15672': 'New Stanton,PA',
'15673': 'North Apollo,PA',
'15674': 'Norvelt,PA',
'15675': 'Penn,PA',
'15676': 'Pleasant Unity,PA',
'15677': 'Rector,PA',
'15678': 'Rillton,PA',
'15679': 'Ruffs Dale,PA',
'15680': 'Salina,PA',
'15681': 'Saltsburg,PA',
'15682': 'Schenley,PA',
'15683': 'Scottdale,PA',
'15684': 'Slickville,PA',
'15685': 'Southwest,PA',
'15686': 'Spring Church,PA',
'15687': 'Stahlstown,PA',
'15688': 'Tarrs,PA',
'15689': 'United,PA',
'15690': 'Vandergrift,PA',
'15691': 'Wendel,PA',
'15692': 'Westmoreland City,PA',
'15693': 'Whitney,PA',
'15695': 'Wyano,PA',
'15696': 'Youngstown,PA',
'15697': 'Youngwood,PA',
'15698': 'Yukon,PA',
'15701': 'Indiana,PA',
'15705': 'Indiana,PA',
'15710': 'Alverda,PA',
'15711': 'Anita,PA',
'15712': 'Arcadia,PA',
'15713': 'Aultman,PA',
'15714': 'Northern Cambria,PA',
'15715': 'Big Run,PA',
'15716': 'Black Lick,PA',
'15717': 'Blairsville,PA',
'15720': 'Brush Valley,PA',
'15721': 'Burnside,PA',
'15722': 'Carrolltown,PA',
'15723': 'Chambersville,PA',
'15724': 'Cherry Tree,PA',
'15725': 'Clarksburg,PA',
'15727': 'Clune,PA',
'15728': 'Clymer,PA',
'15729': 'Commodore,PA',
'15730': 'Coolspring,PA',
'15731': 'Coral,PA',
'15732': 'Creekside,PA',
'15733': 'De Lancey,PA',
'15734': 'Dixonville,PA',
'15736': 'Elderton,PA',
'15737': 'Elmora,PA',
'15738': 'Emeigh,PA',
'15739': 'Ernest,PA',
'15740': 'Frostburg,PA',
'15741': 'Gipsy,PA',
'15742': 'Glen Campbell,PA',
'15744': 'Hamilton,PA',
'15745': 'Heilwood,PA',
'15746': 'Hillsdale,PA',
'15747': 'Home,PA',
'15748': 'Homer City,PA',
'15750': 'Josephine,PA',
'15751': 'Juneau,PA',
'15752': 'Kent,PA',
'15753': 'La Jose,PA',
'15754': 'Lucernemines,PA',
'15756': 'Mc Intyre,PA',
'15757': 'Mahaffey,PA',
'15758': 'Marchand,PA',
'15759': 'Marion Center,PA',
'15760': 'Marsteller,PA',
'15761': 'Mentcle,PA',
'15762': 'Nicktown,PA',
'15763': 'Northpoint,PA',
'15764': 'Oliveburg,PA',
'15765': 'Penn Run,PA',
'15767': 'Punxsutawney,PA',
'15770': 'Ringgold,PA',
'15771': 'Rochester Mills,PA',
'15772': 'Rossiter,PA',
'15773': 'Saint Benedict,PA',
'15774': 'Shelocta,PA',
'15775': 'Spangler,PA',
'15776': 'Sprankle Mills,PA',
'15777': 'Starford,PA',
'15778': 'Timblin,PA',
'15779': 'Torrance,PA',
'15780': 'Valier,PA',
'15781': 'Walston,PA',
'15783': 'West Lebanon,PA',
'15784': 'Worthville,PA',
'15801': 'Du Bois,PA',
'15821': 'Benezett,PA',
'15822': 'Brandy Camp,PA',
'15823': 'Brockport,PA',
'15824': 'Brockway,PA',
'15825': 'Brookville,PA',
'15827': 'Byrnedale,PA',
'15828': 'Clarington,PA',
'15829': 'Corsica,PA',
'15831': 'Dagus Mines,PA',
'15832': 'Driftwood,PA',
'15834': 'Emporium,PA',
'15840': 'Falls Creek,PA',
'15841': 'Force,PA',
'15845': 'Johnsonburg,PA',
'15846': 'Kersey,PA',
'15847': 'Knox Dale,PA',
'15848': 'Luthersburg,PA',
'15849': 'Penfield,PA',
'15851': 'Reynoldsville,PA',
'15853': 'Ridgway,PA',
'15856': 'Rockton,PA',
'15857': 'Saint Marys,PA',
'15860': 'Sigel,PA',
'15861': 'Sinnamahoning,PA',
'15863': 'Stump Creek,PA',
'15864': 'Summerville,PA',
'15865': 'Sykesville,PA',
'15866': 'Troutville,PA',
'15868': 'Weedville,PA',
'15870': 'Wilcox,PA',
'15901': 'Johnstown,PA',
'15902': 'Johnstown,PA',
'15904': 'Johnstown,PA',
'15905': 'Johnstown,PA',
'15906': 'Johnstown,PA',
'15907': 'Johnstown,PA',
'15909': 'Johnstown,PA',
'15915': 'Johnstown,PA',
'15920': 'Armagh,PA',
'15921': 'Beaverdale,PA',
'15922': 'Belsano,PA',
'15923': 'Bolivar,PA',
'15924': 'Cairnbrook,PA',
'15925': 'Cassandra,PA',
'15926': 'Central City,PA',
'15927': 'Colver,PA',
'15928': 'Davidsville,PA',
'15929': 'Dilltown,PA',
'15930': 'Dunlo,PA',
'15931': 'Ebensburg,PA',
'15934': 'Elton,PA',
'15935': 'Hollsopple,PA',
'15936': 'Hooversville,PA',
'15937': 'Jerome,PA',
'15938': 'Lilly,PA',
'15940': 'Loretto,PA',
'15942': 'Mineral Point,PA',
'15943': 'Nanty Glo,PA',
'15944': 'New Florence,PA',
'15945': 'Parkhill,PA',
'15946': 'Portage,PA',
'15948': 'Revloc,PA',
'15949': 'Robinson,PA',
'15951': 'Saint Michael,PA',
'15952': 'Salix,PA',
'15953': 'Seanor,PA',
'15954': 'Seward,PA',
'15955': 'Sidman,PA',
'15956': 'South Fork,PA',
'15957': 'Strongstown,PA',
'15958': 'Summerhill,PA',
'15959': 'Tire Hill,PA',
'15960': 'Twin Rocks,PA',
'15961': 'Vintondale,PA',
'15962': 'Wilmore,PA',
'15963': 'Windber,PA',
'16001': 'Butler,PA',
'16002': 'Butler,PA',
'16003': 'Butler,PA',
'16016': 'Boyers,PA',
'16017': 'Boyers,PA',
'16018': 'Boyers,PA',
'16020': 'Boyers,PA',
'16021': 'Branchton,PA',
'16022': 'Bruin,PA',
'16023': 'Cabot,PA',
'16024': 'Callery,PA',
'16025': 'Chicora,PA',
'16027': 'Connoquenessing,PA',
'16028': 'East Brady,PA',
'16029': 'East Butler,PA',
'16030': 'Eau Claire,PA',
'16033': 'Evans City,PA',
'16034': 'Fenelton,PA',
'16035': 'Forestville,PA',
'16036': 'Foxburg,PA',
'16037': 'Harmony,PA',
'16038': 'Harrisville,PA',
'16039': 'Herman,PA',
'16040': 'Hilliards,PA',
'16041': 'Karns City,PA',
'16045': 'Lyndora,PA',
'16046': 'Mars,PA',
'16048': 'North Washington,PA',
'16049': 'Parker,PA',
'16050': 'Petrolia,PA',
'16051': 'Portersville,PA',
'16052': 'Prospect,PA',
'16053': 'Renfrew,PA',
'16054': 'Saint Petersburg,PA',
'16055': 'Sarver,PA',
'16056': 'Saxonburg,PA',
'16057': 'Slippery Rock,PA',
'16058': 'Turkey City,PA',
'16059': 'Valencia,PA',
'16061': 'West Sunbury,PA',
'16063': 'Zelienople,PA',
'16066': 'Cranberry Twp,PA',
'16101': 'New Castle,PA',
'16102': 'New Castle,PA',
'16103': 'New Castle,PA',
'16105': 'New Castle,PA',
'16107': 'New Castle,PA',
'16108': 'New Castle,PA',
'16110': 'Adamsville,PA',
'16111': 'Atlantic,PA',
'16112': 'Bessemer,PA',
'16113': 'Clark,PA',
'16114': 'Clarks Mills,PA',
'16115': 'Darlington,PA',
'16116': 'Edinburg,PA',
'16117': 'Ellwood City,PA',
'16120': 'Enon Valley,PA',
'16121': 'Farrell,PA',
'16123': 'Fombell,PA',
'16124': 'Fredonia,PA',
'16125': 'Greenville,PA',
'16127': 'Grove City,PA',
'16130': 'Hadley,PA',
'16131': 'Hartstown,PA',
'16132': 'Hillsville,PA',
'16133': 'Jackson Center,PA',
'16134': 'Jamestown,PA',
'16136': 'Koppel,PA',
'16137': 'Mercer,PA',
'16140': 'New Bedford,PA',
'16141': 'New Galilee,PA',
'16142': 'New Wilmington,PA',
'16143': 'Pulaski,PA',
'16145': 'Sandy Lake,PA',
'16146': 'Sharon,PA',
'16148': 'Hermitage,PA',
'16150': 'Sharpsville,PA',
'16151': 'Sheakleyville,PA',
'16153': 'Stoneboro,PA',
'16154': 'Transfer,PA',
'16155': 'Villa Maria,PA',
'16156': 'Volant,PA',
'16157': 'Wampum,PA',
'16159': 'West Middlesex,PA',
'16160': 'West Pittsburg,PA',
'16161': 'Wheatland,PA',
'16172': 'New Wilmington,PA',
'16201': 'Kittanning,PA',
'16210': 'Adrian,PA',
'16211': 'Beyer,PA',
'16212': 'Cadogan,PA',
'16213': 'Callensburg,PA',
'16214': 'Clarion,PA',
'16215': 'Kittanning,PA',
'16216': 'Climax,PA',
'16217': 'Cooksburg,PA',
'16218': 'Cowansville,PA',
'16220': 'Crown,PA',
'16221': 'Curllsville,PA',
'16222': 'Dayton,PA',
'16223': 'Distant,PA',
'16224': 'Fairmount City,PA',
'16225': 'Fisher,PA',
'16226': 'Ford City,PA',
'16228': 'Ford Cliff,PA',
'16229': 'Freeport,PA',
'16230': 'Hawthorn,PA',
'16232': 'Knox,PA',
'16233': 'Leeper,PA',
'16234': 'Limestone,PA',
'16235': 'Lucinda,PA',
'16236': 'Mc Grann,PA',
'16238': 'Manorville,PA',
'16239': 'Marienville,PA',
'16240': 'Mayport,PA',
'16242': 'New Bethlehem,PA',
'16244': 'Nu Mine,PA',
'16245': 'Oak Ridge,PA',
'16246': 'Plumville,PA',
'16248': 'Rimersburg,PA',
'16249': 'Rural Valley,PA',
'16250': 'Sagamore,PA',
'16253': 'Seminole,PA',
'16254': 'Shippenville,PA',
'16255': 'Sligo,PA',
'16256': 'Smicksburg,PA',
'16257': 'Snydersburg,PA',
'16258': 'Strattanville,PA',
'16259': 'Templeton,PA',
'16260': 'Vowinckel,PA',
'16261': 'Widnoon,PA',
'16262': 'Worthington,PA',
'16263': 'Yatesboro,PA',
'16301': 'Oil City,PA',
'16311': 'Carlton,PA',
'16312': 'Chandlers Valley,PA',
'16313': 'Clarendon,PA',
'16314': 'Cochranton,PA',
'16316': 'Conneaut Lake,PA',
'16317': 'Cooperstown,PA',
'16319': 'Cranberry,PA',
'16321': 'East Hickory,PA',
'16322': 'Endeavor,PA',
'16323': 'Franklin,PA',
'16326': 'Fryburg,PA',
'16327': 'Guys Mills,PA',
'16328': 'Hydetown,PA',
'16329': 'Irvine,PA',
'16331': 'Kossuth,PA',
'16332': 'Lickingville,PA',
'16333': 'Ludlow,PA',
'16334': 'Marble,PA',
'16335': 'Meadville,PA',
'16340': 'Pittsfield,PA',
'16341': 'Pleasantville,PA',
'16342': 'Polk,PA',
'16343': 'Reno,PA',
'16344': 'Rouseville,PA',
'16345': 'Russell,PA',
'16346': 'Seneca,PA',
'16347': 'Sheffield,PA',
'16350': 'Sugar Grove,PA',
'16351': 'Tidioute,PA',
'16352': 'Tiona,PA',
'16353': 'Tionesta,PA',
'16354': 'Titusville,PA',
'16360': 'Townville,PA',
'16361': 'Tylersburg,PA',
'16362': 'Utica,PA',
'16364': 'Venus,PA',
'16365': 'Warren,PA',
'16366': 'Warren,PA',
'16367': 'Warren,PA',
'16368': 'Warren,PA',
'16369': 'Warren,PA',
'16370': 'West Hickory,PA',
'16371': 'Youngsville,PA',
'16372': 'Clintonville,PA',
'16373': 'Emlenton,PA',
'16374': 'Kennerdell,PA',
'16375': 'Lamartine,PA',
'16388': 'Meadville,PA',
'16401': 'Albion,PA',
'16402': 'Bear Lake,PA',
'16403': 'Cambridge Springs,PA',
'16404': 'Centerville,PA',
'16405': 'Columbus,PA',
'16406': 'Conneautville,PA',
'16407': 'Corry,PA',
'16410': 'Cranesville,PA',
'16411': 'East Springfield,PA',
'16412': 'Edinboro,PA',
'16413': 'Elgin,PA',
'16415': 'Fairview,PA',
'16416': 'Garland,PA',
'16417': 'Girard,PA',
'16420': 'Grand Valley,PA',
'16421': 'Harborcreek,PA',
'16422': 'Harmonsburg,PA',
'16423': 'Lake City,PA',
'16424': 'Linesville,PA',
'16426': 'Mc Kean,PA',
'16427': 'Mill Village,PA',
'16428': 'North East,PA',
'16430': 'North Springfield,PA',
'16432': 'Riceville,PA',
'16433': 'Saegertown,PA',
'16434': 'Spartansburg,PA',
'16435': 'Springboro,PA',
'16436': 'Spring Creek,PA',
'16438': 'Union City,PA',
'16440': 'Venango,PA',
'16441': 'Waterford,PA',
'16442': 'Wattsburg,PA',
'16443': 'West Springfield,PA',
'16444': 'Edinboro,PA',
'16475': 'Albion,PA',
'16501': 'Erie,PA',
'16502': 'Erie,PA',
'16503': 'Erie,PA',
'16504': 'Erie,PA',
'16505': 'Erie,PA',
'16506': 'Erie,PA',
'16507': 'Erie,PA',
'16508': 'Erie,PA',
'16509': 'Erie,PA',
'16510': 'Erie,PA',
'16511': 'Erie,PA',
'16512': 'Erie,PA',
'16514': 'Erie,PA',
'16515': 'Erie,PA',
'16522': 'Erie,PA',
'16530': 'Erie,PA',
'16531': 'Erie,PA',
'16532': 'Erie,PA',
'16533': 'Erie,PA',
'16534': 'Erie,PA',
'16538': 'Erie,PA',
'16541': 'Erie,PA',
'16544': 'Erie,PA',
'16546': 'Erie,PA',
'16550': 'Erie,PA',
'16553': 'Erie,PA',
'16554': 'Erie,PA',
'16558': 'Erie,PA',
'16563': 'Erie,PA',
'16565': 'Erie,PA',
'16601': 'Altoona,PA',
'16602': 'Altoona,PA',
'16603': 'Altoona,PA',
'16611': 'Alexandria,PA',
'16613': 'Ashville,PA',
'16614': 'Bakers Summit,PA',
'16616': 'Beccaria,PA',
'16617': 'Bellwood,PA',
'16619': 'Blandburg,PA',
'16620': 'Brisbin,PA',
'16621': 'Broad Top,PA',
'16622': 'Calvin,PA',
'16623': 'Cassville,PA',
'16624': 'Chest Springs,PA',
'16625': 'Claysburg,PA',
'16627': 'Coalport,PA',
'16629': 'Coupon,PA',
'16630': 'Cresson,PA',
'16631': 'Curryville,PA',
'16633': 'Defiance,PA',
'16634': 'Dudley,PA',
'16635': 'Duncansville,PA',
'16636': 'Dysart,PA',
'16637': 'East Freedom,PA',
'16638': 'Entriken,PA',
'16639': 'Fallentimber,PA',
'16640': 'Flinton,PA',
'16641': 'Gallitzin,PA',
'16644': 'Glasgow,PA',
'16645': 'Glen Hope,PA',
'16646': 'Hastings,PA',
'16647': 'Hesston,PA',
'16648': 'Hollidaysburg,PA',
'16650': 'Hopewell,PA',
'16651': 'Houtzdale,PA',
'16652': 'Huntingdon,PA',
'16654': 'Huntingdon,PA',
'16655': 'Imler,PA',
'16656': 'Irvona,PA',
'16657': 'James Creek,PA',
'16659': 'Loysburg,PA',
'16660': 'Mc Connellstown,PA',
'16661': 'Madera,PA',
'16662': 'Martinsburg,PA',
'16663': 'Morann,PA',
'16664': 'New Enterprise,PA',
'16665': 'Newry,PA',
'16666': 'Osceola Mills,PA',
'16667': 'Osterburg,PA',
'16668': 'Patton,PA',
'16669': 'Petersburg,PA',
'16670': 'Queen,PA',
'16671': 'Ramey,PA',
'16672': 'Riddlesburg,PA',
'16673': 'Roaring Spring,PA',
'16674': 'Robertsdale,PA',
'16675': 'Saint Boniface,PA',
'16677': 'Sandy Ridge,PA',
'16678': 'Saxton,PA',
'16679': 'Six Mile Run,PA',
'16680': 'Smithmill,PA',
'16681': 'Smokerun,PA',
'16682': 'Sproul,PA',
'16683': 'Spruce Creek,PA',
'16684': 'Tipton,PA',
'16685': 'Todd,PA',
'16686': 'Tyrone,PA',
'16689': 'Waterfall,PA',
'16691': 'Wells Tannery,PA',
'16692': 'Westover,PA',
'16693': 'Williamsburg,PA',
'16694': 'Wood,PA',
'16695': 'Woodbury,PA',
'16698': 'Houtzdale,PA',
'16699': 'Cresson,PA',
'16701': 'Bradford,PA',
'16720': 'Austin,PA',
'16724': 'Crosby,PA',
'16725': 'Custer City,PA',
'16726': 'Cyclone,PA',
'16727': 'Derrick City,PA',
'16728': 'De Young,PA',
'16729': 'Duke Center,PA',
'16730': 'East Smethport,PA',
'16731': 'Eldred,PA',
'16732': 'Gifford,PA',
'16733': 'Hazel Hurst,PA',
'16734': 'James City,PA',
'16735': 'Kane,PA',
'16738': 'Lewis Run,PA',
'16740': 'Mount Jewett,PA',
'16743': 'Port Allegany,PA',
'16744': 'Rew,PA',
'16745': 'Rixford,PA',
'16746': 'Roulette,PA',
'16748': 'Shinglehouse,PA',
'16749': 'Smethport,PA',
'16750': 'Turtlepoint,PA',
'16751': 'Westline,PA',
'16801': 'State College,PA',
'16802': 'University Park,PA',
'16803': 'State College,PA',
'16804': 'State College,PA',
'16805': 'State College,PA',
'16820': 'Aaronsburg,PA',
'16821': 'Allport,PA',
'16822': 'Beech Creek,PA',
'16823': 'Bellefonte,PA',
'16825': 'Bigler,PA',
'16826': 'Blanchard,PA',
'16827': 'Boalsburg,PA',
'16828': 'Centre Hall,PA',
'16829': 'Clarence,PA',
'16830': 'Clearfield,PA',
'16832': 'Coburn,PA',
'16833': 'Curwensville,PA',
'16834': 'Drifting,PA',
'16835': 'Fleming,PA',
'16836': 'Frenchville,PA',
'16837': 'Glen Richey,PA',
'16838': 'Grampian,PA',
'16839': 'Grassflat,PA',
'16840': 'Hawk Run,PA',
'16841': 'Howard,PA',
'16843': 'Hyde,PA',
'16844': 'Julian,PA',
'16845': 'Karthaus,PA',
'16847': 'Kylertown,PA',
'16848': 'Lamar,PA',
'16849': 'Lanse,PA',
'16850': 'Lecontes Mills,PA',
'16851': 'Lemont,PA',
'16852': 'Madisonburg,PA',
'16853': 'Milesburg,PA',
'16854': 'Millheim,PA',
'16855': 'Mineral Springs,PA',
'16856': 'Mingoville,PA',
'16858': 'Morrisdale,PA',
'16859': 'Moshannon,PA',
'16860': 'Munson,PA',
'16861': 'New Millport,PA',
'16863': 'Olanta,PA',
'16864': 'Orviston,PA',
'16865': 'Pennsylvania Furnace,PA',
'16866': 'Philipsburg,PA',
'16868': 'Pine Grove Mills,PA',
'16870': 'Port Matilda,PA',
'16871': 'Pottersdale,PA',
'16872': 'Rebersburg,PA',
'16873': 'Shawville,PA',
'16874': 'Snow Shoe,PA',
'16875': 'Spring Mills,PA',
'16876': 'Wallaceton,PA',
'16877': 'Warriors Mark,PA',
'16878': 'West Decatur,PA',
'16879': 'Winburne,PA',
'16881': 'Woodland,PA',
'16882': 'Woodward,PA',
'16901': 'Wellsboro,PA',
'16910': 'Alba,PA',
'16911': 'Arnot,PA',
'16912': 'Blossburg,PA',
'16914': 'Columbia Cross Roads,PA',
'16915': 'Coudersport,PA',
'16917': 'Covington,PA',
'16918': 'Cowanesque,PA',
'16920': 'Elkland,PA',
'16921': 'Gaines,PA',
'16922': 'Galeton,PA',
'16923': 'Genesee,PA',
'16925': 'Gillett,PA',
'16926': 'Granville Summit,PA',
'16927': 'Harrison Valley,PA',
'16928': 'Knoxville,PA',
'16929': 'Lawrenceville,PA',
'16930': 'Liberty,PA',
'16932': 'Mainesburg,PA',
'16933': 'Mansfield,PA',
'16935': 'Middlebury Center,PA',
'16936': 'Millerton,PA',
'16937': 'Mills,PA',
'16938': 'Morris,PA',
'16939': 'Morris Run,PA',
'16940': 'Nelson,PA',
'16941': 'Genesee,PA',
'16942': 'Osceola,PA',
'16943': 'Sabinsville,PA',
'16945': 'Sylvania,PA',
'16946': 'Tioga,PA',
'16947': 'Troy,PA',
'16948': 'Ulysses,PA',
'16950': 'Westfield,PA',
'17001': 'Camp Hill,PA',
'17002': 'Allensville,PA',
'17003': 'Annville,PA',
'17004': 'Belleville,PA',
'17005': 'Berrysburg,PA',
'17006': 'Blain,PA',
'17007': 'Boiling Springs,PA',
'17008': 'Bowmansdale,PA',
'17009': 'Burnham,PA',
'17010': 'Campbelltown,PA',
'17011': 'Camp Hill,PA',
'17012': 'Camp Hill,PA',
'17013': 'Carlisle,PA',
'17014': 'Cocolamus,PA',
'17015': 'Carlisle,PA',
'17016': 'Cornwall,PA',
'17017': 'Dalmatia,PA',
'17018': 'Dauphin,PA',
'17019': 'Dillsburg,PA',
'17020': 'Duncannon,PA',
'17021': 'East Waterford,PA',
'17022': 'Elizabethtown,PA',
'17023': 'Elizabethville,PA',
'17024': 'Elliottsburg,PA',
'17025': 'Enola,PA',
'17026': 'Fredericksburg,PA',
'17027': 'Grantham,PA',
'17028': 'Grantville,PA',
'17029': 'Granville,PA',
'17030': 'Gratz,PA',
'17031': 'Green Park,PA',
'17032': 'Halifax,PA',
'17033': 'Hershey,PA',
'17034': 'Highspire,PA',
'17035': 'Honey Grove,PA',
'17036': 'Hummelstown,PA',
'17037': 'Ickesburg,PA',
'17038': 'Jonestown,PA',
'17039': 'Kleinfeltersville,PA',
'17040': 'Landisburg,PA',
'17041': 'Lawn,PA',
'17042': 'Lebanon,PA',
'17043': 'Lemoyne,PA',
'17044': 'Lewistown,PA',
'17045': 'Liverpool,PA',
'17046': 'Lebanon,PA',
'17047': 'Loysville,PA',
'17048': 'Lykens,PA',
'17049': 'Mc Alisterville,PA',
'17050': 'Mechanicsburg,PA',
'17051': 'Mc Veytown,PA',
'17052': 'Mapleton Depot,PA',
'17053': 'Marysville,PA',
'17054': 'Mattawana,PA',
'17055': 'Mechanicsburg,PA',
'17056': 'Mexico,PA',
'17057': 'Middletown,PA',
'17058': 'Mifflin,PA',
'17059': 'Mifflintown,PA',
'17060': 'Mill Creek,PA',
'17061': 'Millersburg,PA',
'17062': 'Millerstown,PA',
'17063': 'Milroy,PA',
'17064': 'Mount Gretna,PA',
'17065': 'Mount Holly Springs,PA',
'17066': 'Mount Union,PA',
'17067': 'Myerstown,PA',
'17068': 'New Bloomfield,PA',
'17069': 'New Buffalo,PA',
'17070': 'New Cumberland,PA',
'17071': 'New Germantown,PA',
'17072': 'New Kingstown,PA',
'17073': 'Newmanstown,PA',
'17074': 'Newport,PA',
'17075': 'Newton Hamilton,PA',
'17076': 'Oakland Mills,PA',
'17077': 'Ono,PA',
'17078': 'Palmyra,PA',
'17080': 'Pillow,PA',
'17081': 'Plainfield,PA',
'17082': 'Port Royal,PA',
'17083': 'Quentin,PA',
'17084': 'Reedsville,PA',
'17085': 'Rexmont,PA',
'17086': 'Richfield,PA',
'17087': 'Richland,PA',
'17088': 'Schaefferstown,PA',
'17089': 'Camp Hill,PA',
'17090': 'Shermans Dale,PA',
'17091': 'Camp Hill,PA',
'17093': 'Summerdale,PA',
'17094': 'Thompsontown,PA',
'17097': 'Wiconisco,PA',
'17098': 'Williamstown,PA',
'17099': 'Yeagertown,PA',
'17101': 'Harrisburg,PA',
'17102': 'Harrisburg,PA',
'17103': 'Harrisburg,PA',
'17104': 'Harrisburg,PA',
'17105': 'Harrisburg,PA',
'17106': 'Harrisburg,PA',
'17107': 'Harrisburg,PA',
'17108': 'Harrisburg,PA',
'17109': 'Harrisburg,PA',
'17110': 'Harrisburg,PA',
'17111': 'Harrisburg,PA',
'17112': 'Harrisburg,PA',
'17113': 'Harrisburg,PA',
'17120': 'Harrisburg,PA',
'17121': 'Harrisburg,PA',
'17122': 'Harrisburg,PA',
'17123': 'Harrisburg,PA',
'17124': 'Harrisburg,PA',
'17125': 'Harrisburg,PA',
'17126': 'Harrisburg,PA',
'17127': 'Harrisburg,PA',
'17128': 'Harrisburg,PA',
'17129': 'Harrisburg,PA',
'17130': 'Harrisburg,PA',
'17140': 'Harrisburg,PA',
'17177': 'Harrisburg,PA',
'17201': 'Chambersburg,PA',
'17210': 'Amberson,PA',
'17211': 'Artemas,PA',
'17212': 'Big Cove Tannery,PA',
'17213': 'Blairs Mills,PA',
'17214': 'Blue Ridge Summit,PA',
'17215': 'Burnt Cabins,PA',
'17217': 'Concord,PA',
'17219': 'Doylesburg,PA',
'17220': 'Dry Run,PA',
'17221': 'Fannettsburg,PA',
'17222': 'Fayetteville,PA',
'17223': 'Fort Littleton,PA',
'17224': 'Fort Loudon,PA',
'17225': 'Greencastle,PA',
'17228': 'Harrisonville,PA',
'17229': 'Hustontown,PA',
'17231': 'Lemasters,PA',
'17232': 'Lurgan,PA',
'17233': 'Mc Connellsburg,PA',
'17235': 'Marion,PA',
'17236': 'Mercersburg,PA',
'17237': 'Mont Alto,PA',
'17238': 'Needmore,PA',
'17239': 'Neelyton,PA',
'17240': 'Newburg,PA',
'17241': 'Newville,PA',
'17243': 'Orbisonia,PA',
'17244': 'Orrstown,PA',
'17246': 'Pleasant Hall,PA',
'17247': 'Quincy,PA',
'17249': 'Rockhill Furnace,PA',
'17250': 'Rouzerville,PA',
'17251': 'Roxbury,PA',
'17252': 'Saint Thomas,PA',
'17253': 'Saltillo,PA',
'17254': 'Scotland,PA',
'17255': 'Shade Gap,PA',
'17256': 'Shady Grove,PA',
'17257': 'Shippensburg,PA',
'17260': 'Shirleysburg,PA',
'17261': 'South Mountain,PA',
'17262': 'Spring Run,PA',
'17263': 'State Line,PA',
'17264': 'Three Springs,PA',
'17265': 'Upperstrasburg,PA',
'17266': 'Walnut Bottom,PA',
'17267': 'Warfordsburg,PA',
'17268': 'Waynesboro,PA',
'17270': 'Williamson,PA',
'17271': 'Willow Hill,PA',
'17272': 'Zullinger,PA',
'17301': 'Abbottstown,PA',
'17302': 'Airville,PA',
'17303': 'Arendtsville,PA',
'17304': 'Aspers,PA',
'17306': 'Bendersville,PA',
'17307': 'Biglerville,PA',
'17309': 'Brogue,PA',
'17310': 'Cashtown,PA',
'17311': 'Codorus,PA',
'17312': 'Craley,PA',
'17313': 'Dallastown,PA',
'17314': 'Delta,PA',
'17315': 'Dover,PA',
'17316': 'East Berlin,PA',
'17317': 'East Prospect,PA',
'17318': 'Emigsville,PA',
'17319': 'Etters,PA',
'17320': 'Fairfield,PA',
'17321': 'Fawn Grove,PA',
'17322': 'Felton,PA',
'17323': 'Franklintown,PA',
'17324': 'Gardners,PA',
'17325': 'Gettysburg,PA',
'17326': 'Gettysburg,PA',
'17327': 'Glen Rock,PA',
'17329': 'Glenville,PA',
'17331': 'Hanover,PA',
'17332': 'Hanover,PA',
'17333': 'Hanover,PA',
'17334': 'Hanover,PA',
'17335': 'Direct Brands,PA',
'17337': 'Idaville,PA',
'17339': 'Lewisberry,PA',
'17340': 'Littlestown,PA',
'17342': 'Loganville,PA',
'17343': 'Mc Knightstown,PA',
'17344': 'Mc Sherrystown,PA',
'17345': 'Manchester,PA',
'17347': 'Mount Wolf,PA',
'17349': 'New Freedom,PA',
'17350': 'New Oxford,PA',
'17352': 'New Park,PA',
'17353': 'Orrtanna,PA',
'17354': 'Porters Sideling,PA',
'17355': 'Railroad,PA',
'17356': 'Red Lion,PA',
'17358': 'Rossville,PA',
'17360': 'Seven Valleys,PA',
'17361': 'Shrewsbury,PA',
'17362': 'Spring Grove,PA',
'17363': 'Stewartstown,PA',
'17364': 'Thomasville,PA',
'17365': 'Wellsville,PA',
'17366': 'Windsor,PA',
'17368': 'Wrightsville,PA',
'17370': 'York Haven,PA',
'17371': 'York New Salem,PA',
'17372': 'York Springs,PA',
'17375': 'Peach Glen,PA',
'17401': 'York,PA',
'17402': 'York,PA',
'17403': 'York,PA',
'17404': 'York,PA',
'17405': 'York,PA',
'17406': 'York,PA',
'17407': 'York,PA',
'17415': 'York,PA',
'17501': 'Akron,PA',
'17502': 'Bainbridge,PA',
'17503': 'Bart,PA',
'17504': 'Bausman,PA',
'17505': 'Bird In Hand,PA',
'17506': 'Blue Ball,PA',
'17507': 'Bowmansville,PA',
'17508': 'Brownstown,PA',
'17509': 'Christiana,PA',
'17512': 'Columbia,PA',
'17516': 'Conestoga,PA',
'17517': 'Denver,PA',
'17518': 'Drumore,PA',
'17519': 'East Earl,PA',
'17520': 'East Petersburg,PA',
'17521': 'Elm,PA',
'17522': 'Ephrata,PA',
'17527': 'Gap,PA',
'17528': 'Goodville,PA',
'17529': 'Gordonville,PA',
'17532': 'Holtwood,PA',
'17533': 'Hopeland,PA',
'17534': 'Intercourse,PA',
'17535': 'Kinzers,PA',
'17536': 'Kirkwood,PA',
'17537': 'Lampeter,PA',
'17538': 'Landisville,PA',
'17540': 'Leola,PA',
'17543': 'Lititz,PA',
'17545': 'Manheim,PA',
'17547': 'Marietta,PA',
'17549': 'Martindale,PA',
'17550': 'Maytown,PA',
'17551': 'Millersville,PA',
'17552': 'Mount Joy,PA',
'17554': 'Mountville,PA',
'17555': 'Narvon,PA',
'17557': 'New Holland,PA',
'17560': 'New Providence,PA',
'17562': 'Paradise,PA',
'17563': 'Peach Bottom,PA',
'17564': 'Penryn,PA',
'17565': 'Pequea,PA',
'17566': 'Quarryville,PA',
'17567': 'Reamstown,PA',
'17568': 'Refton,PA',
'17569': 'Reinholds,PA',
'17570': 'Rheems,PA',
'17572': 'Ronks,PA',
'17573': 'Ronks,PA',
'17575': 'Silver Spring,PA',
'17576': 'Smoketown,PA',
'17577': 'Soudersburg,PA',
'17578': 'Stevens,PA',
'17579': 'Strasburg,PA',
'17580': 'Talmage,PA',
'17581': 'Terre Hill,PA',
'17582': 'Washington Boro,PA',
'17583': 'West Willow,PA',
'17584': 'Willow Street,PA',
'17585': 'Witmer,PA',
'17601': 'Lancaster,PA',
'17602': 'Lancaster,PA',
'17603': 'Lancaster,PA',
'17604': 'Lancaster,PA',
'17605': 'Lancaster,PA',
'17606': 'Lancaster,PA',
'17607': 'Lancaster,PA',
'17608': 'Lancaster,PA',
'17611': 'Lancaster,PA',
'17622': 'Qvc Network Inc,PA',
'17699': 'Lancaster,PA',
'17701': 'Williamsport,PA',
'17702': 'Williamsport,PA',
'17703': 'Williamsport,PA',
'17705': 'Williamsport,PA',
'17720': 'Antes Fort,PA',
'17721': 'Avis,PA',
'17722': 'Bodines,PA',
'17723': 'Jersey Shore,PA',
'17724': 'Canton,PA',
'17726': 'Castanea,PA',
'17727': 'Cedar Run,PA',
'17728': 'Cogan Station,PA',
'17729': 'Cross Fork,PA',
'17730': 'Dewart,PA',
'17731': 'Eagles Mere,PA',
'17735': 'Grover,PA',
'17737': 'Hughesville,PA',
'17738': 'Hyner,PA',
'17739': 'Jersey Mills,PA',
'17740': 'Jersey Shore,PA',
'17742': 'Lairdsville,PA',
'17743': 'Leroy,PA',
'17744': 'Linden,PA',
'17745': 'Lock Haven,PA',
'17747': 'Loganton,PA',
'17748': 'Mc Elhattan,PA',
'17749': 'Mc Ewensville,PA',
'17750': 'Mackeyville,PA',
'17751': 'Mill Hall,PA',
'17752': 'Montgomery,PA',
'17754': 'Montoursville,PA',
'17756': 'Muncy,PA',
'17758': 'Muncy Valley,PA',
'17759': 'Nisbet,PA',
'17760': 'North Bend,PA',
'17762': 'Picture Rocks,PA',
'17763': 'Ralston,PA',
'17764': 'Renovo,PA',
'17765': 'Roaring Branch,PA',
'17767': 'Salona,PA',
'17768': 'Shunk,PA',
'17769': 'Slate Run,PA',
'17771': 'Trout Run,PA',
'17772': 'Turbotville,PA',
'17773': 'Tylersville,PA',
'17774': 'Unityville,PA',
'17776': 'Waterville,PA',
'17777': 'Watsontown,PA',
'17778': 'Westport,PA',
'17779': 'Woolrich,PA',
'17801': 'Sunbury,PA',
'17810': 'Allenwood,PA',
'17812': 'Beaver Springs,PA',
'17813': 'Beavertown,PA',
'17814': 'Benton,PA',
'17815': 'Bloomsburg,PA',
'17820': 'Catawissa,PA',
'17821': 'Danville,PA',
'17822': 'Danville,PA',
'17823': 'Dornsife,PA',
'17824': 'Elysburg,PA',
'17825': 'Excelsior,PA',
'17827': 'Freeburg,PA',
'17828': 'Gowen City,PA',
'17829': 'Hartleton,PA',
'17830': 'Herndon,PA',
'17831': 'Hummels Wharf,PA',
'17832': 'Marion Heights,PA',
'17833': 'Kreamer,PA',
'17834': 'Kulpmont,PA',
'17835': 'Laurelton,PA',
'17836': 'Leck Kill,PA',
'17837': 'Lewisburg,PA',
'17839': 'Light Street,PA',
'17840': 'Locust Gap,PA',
'17841': 'Mc Clure,PA',
'17842': 'Middleburg,PA',
'17843': 'Beaver Springs,PA',
'17844': 'Mifflinburg,PA',
'17845': 'Millmont,PA',
'17846': 'Millville,PA',
'17847': 'Milton,PA',
'17850': 'Montandon,PA',
'17851': 'Mount Carmel,PA',
'17853': 'Mount Pleasant Mills,PA',
'17855': 'New Berlin,PA',
'17856': 'New Columbia,PA',
'17857': 'Northumberland,PA',
'17858': 'Numidia,PA',
'17859': 'Orangeville,PA',
'17860': 'Paxinos,PA',
'17861': 'Paxtonville,PA',
'17862': 'Penns Creek,PA',
'17864': 'Port Trevorton,PA',
'17865': 'Potts Grove,PA',
'17866': 'Coal Township,PA',
'17867': 'Rebuck,PA',
'17868': 'Riverside,PA',
'17870': 'Selinsgrove,PA',
'17872': 'Shamokin,PA',
'17876': 'Shamokin Dam,PA',
'17877': 'Snydertown,PA',
'17878': 'Stillwater,PA',
'17880': 'Swengel,PA',
'17881': 'Trevorton,PA',
'17882': 'Troxelville,PA',
'17883': 'Vicksburg,PA',
'17884': 'Washingtonville,PA',
'17885': 'Weikert,PA',
'17886': 'West Milton,PA',
'17887': 'White Deer,PA',
'17888': 'Wilburton,PA',
'17889': 'Winfield,PA',
'17901': 'Pottsville,PA',
'17920': 'Aristes,PA',
'17921': 'Ashland,PA',
'17922': 'Auburn,PA',
'17923': 'Branchdale,PA',
'17925': 'Brockton,PA',
'17927': 'Centralia,PA',
'17929': 'Cressona,PA',
'17930': 'Cumbola,PA',
'17931': 'Frackville,PA',
'17932': 'Frackville,PA',
'17933': 'Friedensburg,PA',
'17934': 'Gilberton,PA',
'17935': 'Girardville,PA',
'17936': 'Gordon,PA',
'17938': 'Hegins,PA',
'17941': 'Klingerstown,PA',
'17942': 'Landingville,PA',
'17943': 'Lavelle,PA',
'17944': 'Llewellyn,PA',
'17945': 'Locustdale,PA',
'17946': 'Lost Creek,PA',
'17948': 'Mahanoy City,PA',
'17949': 'Mahanoy Plane,PA',
'17951': 'Mar Lin,PA',
'17952': 'Mary D,PA',
'17953': 'Middleport,PA',
'17954': 'Minersville,PA',
'17957': 'Muir,PA',
'17959': 'New Philadelphia,PA',
'17960': 'New Ringgold,PA',
'17961': 'Orwigsburg,PA',
'17963': 'Pine Grove,PA',
'17964': 'Pitman,PA',
'17965': 'Port Carbon,PA',
'17966': 'Ravine,PA',
'17967': 'Ringtown,PA',
'17968': 'Sacramento,PA',
'17970': 'Saint Clair,PA',
'17972': 'Schuylkill Haven,PA',
'17974': 'Seltzer,PA',
'17976': 'Shenandoah,PA',
'17978': 'Spring Glen,PA',
'17979': 'Summit Station,PA',
'17980': 'Tower City,PA',
'17981': 'Tremont,PA',
'17982': 'Tuscarora,PA',
'17983': 'Valley View,PA',
'17985': 'Zion Grove,PA',
'18001': 'Lehigh Valley,PA',
'18002': 'Lehigh Valley,PA',
'18003': 'Lehigh Valley,PA',
'18010': 'Ackermanville,PA',
'18011': 'Alburtis,PA',
'18012': 'Aquashicola,PA',
'18013': 'Bangor,PA',
'18014': 'Bath,PA',
'18015': 'Bethlehem,PA',
'18016': 'Bethlehem,PA',
'18017': 'Bethlehem,PA',
'18018': 'Bethlehem,PA',
'18020': 'Bethlehem,PA',
'18025': 'Bethlehem,PA',
'18030': 'Bowmanstown,PA',
'18031': 'Breinigsville,PA',
'18032': 'Catasauqua,PA',
'18034': 'Center Valley,PA',
'18035': 'Cherryville,PA',
'18036': 'Coopersburg,PA',
'18037': 'Coplay,PA',
'18038': 'Danielsville,PA',
'18039': 'Durham,PA',
'18040': 'Easton,PA',
'18041': 'East Greenville,PA',
'18042': 'Easton,PA',
'18043': 'Easton,PA',
'18044': 'Easton,PA',
'18045': 'Easton,PA',
'18046': 'East Texas,PA',
'18049': 'Emmaus,PA',
'18050': 'Flicksville,PA',
'18051': 'Fogelsville,PA',
'18052': 'Whitehall,PA',
'18053': 'Germansville,PA',
'18054': 'Green Lane,PA',
'18055': 'Hellertown,PA',
'18056': 'Hereford,PA',
'18058': 'Kunkletown,PA',
'18059': 'Laurys Station,PA',
'18060': 'Limeport,PA',
'18062': 'Macungie,PA',
'18063': 'Martins Creek,PA',
'18064': 'Nazareth,PA',
'18065': 'Neffs,PA',
'18066': 'New Tripoli,PA',
'18067': 'Northampton,PA',
'18068': 'Old Zionsville,PA',
'18069': 'Orefield,PA',
'18070': 'Palm,PA',
'18071': 'Palmerton,PA',
'18072': 'Pen Argyl,PA',
'18073': 'Pennsburg,PA',
'18074': 'Perkiomenville,PA',
'18076': 'Red Hill,PA',
'18077': 'Riegelsville,PA',
'18078': 'Schnecksville,PA',
'18079': 'Slatedale,PA',
'18080': 'Slatington,PA',
'18081': 'Springtown,PA',
'18083': 'Stockertown,PA',
'18084': 'Sumneytown,PA',
'18085': 'Tatamy,PA',
'18086': 'Treichlers,PA',
'18087': 'Trexlertown,PA',
'18088': 'Walnutport,PA',
'18091': 'Wind Gap,PA',
'18092': 'Zionsville,PA',
'18098': 'Emmaus,PA',
'18099': 'Emmaus,PA',
'18101': 'Allentown,PA',
'18102': 'Allentown,PA',
'18103': 'Allentown,PA',
'18104': 'Allentown,PA',
'18105': 'Allentown,PA',
'18106': 'Allentown,PA',
'18109': 'Allentown,PA',
'18175': 'Allentown,PA',
'18195': 'Allentown,PA',
'18201': 'Hazleton,PA',
'18202': 'Hazleton,PA',
'18210': 'Albrightsville,PA',
'18211': 'Andreas,PA',
'18212': 'Ashfield,PA',
'18214': 'Barnesville,PA',
'18216': 'Beaver Meadows,PA',
'18218': 'Coaldale,PA',
'18219': 'Conyngham,PA',
'18220': 'Delano,PA',
'18221': 'Drifton,PA',
'18222': 'Drums,PA',
'18223': 'Ebervale,PA',
'18224': 'Freeland,PA',
'18225': 'Harleigh,PA',
'18229': 'Jim Thorpe,PA',
'18230': 'Junedale,PA',
'18231': 'Kelayres,PA',
'18232': 'Lansford,PA',
'18234': 'Lattimer Mines,PA',
'18235': 'Lehighton,PA',
'18237': 'Mcadoo,PA',
'18239': 'Milnesville,PA',
'18240': 'Nesquehoning,PA',
'18241': 'Nuremberg,PA',
'18242': 'Oneida,PA',
'18243': 'Pardeesville,PA',
'18244': 'Parryville,PA',
'18245': 'Quakake,PA',
'18246': 'Rock Glen,PA',
'18247': 'Saint Johns,PA',
'18248': 'Sheppton,PA',
'18249': 'Sugarloaf,PA',
'18250': 'Summit Hill,PA',
'18251': 'Sybertsville,PA',
'18252': 'Tamaqua,PA',
'18254': 'Tresckow,PA',
'18255': 'Weatherly,PA',
'18256': 'Weston,PA',
'18301': 'East Stroudsburg,PA',
'18302': 'East Stroudsburg,PA',
'18320': 'Analomink,PA',
'18321': 'Bartonsville,PA',
'18322': 'Brodheadsville,PA',
'18323': 'Buck Hill Falls,PA',
'18324': 'Bushkill,PA',
'18325': 'Canadensis,PA',
'18326': 'Cresco,PA',
'18327': 'Delaware Water Gap,PA',
'18328': 'Dingmans Ferry,PA',
'18330': 'Effort,PA',
'18331': 'Gilbert,PA',
'18332': 'Henryville,PA',
'18333': 'Kresgeville,PA',
'18334': 'Long Pond,PA',
'18335': 'Marshalls Creek,PA',
'18336': 'Matamoras,PA',
'18337': 'Milford,PA',
'18340': 'Millrift,PA',
'18341': 'Minisink Hills,PA',
'18342': 'Mountainhome,PA',
'18343': 'Mount Bethel,PA',
'18344': 'Mount Pocono,PA',
'18346': 'Pocono Summit,PA',
'18347': 'Pocono Lake,PA',
'18348': 'Pocono Lake Preserve,PA',
'18349': 'Pocono Manor,PA',
'18350': 'Pocono Pines,PA',
'18351': 'Portland,PA',
'18352': 'Reeders,PA',
'18353': 'Saylorsburg,PA',
'18354': 'Sciota,PA',
'18355': 'Scotrun,PA',
'18356': 'Shawnee On Delaware,PA',
'18357': 'Skytop,PA',
'18360': 'Stroudsburg,PA',
'18370': 'Swiftwater,PA',
'18371': 'Tamiment,PA',
'18372': 'Tannersville,PA',
'18373': 'Unity House,PA',
'18401': 'Aldenville,PA',
'18403': 'Archbald,PA',
'18405': 'Beach Lake,PA',
'18407': 'Carbondale,PA',
'18410': 'Chinchilla,PA',
'18411': 'Clarks Summit,PA',
'18413': 'Clifford,PA',
'18414': 'Dalton,PA',
'18415': 'Damascus,PA',
'18416': 'Elmhurst,PA',
'18417': 'Equinunk,PA',
'18419': 'Factoryville,PA',
'18420': 'Fleetville,PA',
'18421': 'Forest City,PA',
'18424': 'Gouldsboro,PA',
'18425': 'Greeley,PA',
'18426': 'Greentown,PA',
'18427': 'Hamlin,PA',
'18428': 'Hawley,PA',
'18430': 'Herrick Center,PA',
'18431': 'Honesdale,PA',
'18433': 'Jermyn,PA',
'18434': 'Jessup,PA',
'18435': 'Lackawaxen,PA',
'18436': 'Lake Ariel,PA',
'18437': 'Lake Como,PA',
'18438': 'Lakeville,PA',
'18439': 'Lakewood,PA',
'18440': 'La Plume,PA',
'18441': 'Lenoxville,PA',
'18443': 'Milanville,PA',
'18444': 'Moscow,PA',
'18445': 'Newfoundland,PA',
'18446': 'Nicholson,PA',
'18447': 'Olyphant,PA',
'18448': 'Olyphant,PA',
'18449': 'Orson,PA',
'18451': 'Paupack,PA',
'18452': 'Peckville,PA',
'18453': 'Pleasant Mount,PA',
'18454': 'Poyntelle,PA',
'18455': 'Preston Park,PA',
'18456': 'Prompton,PA',
'18457': 'Rowland,PA',
'18458': 'Shohola,PA',
'18459': 'South Canaan,PA',
'18460': 'South Sterling,PA',
'18461': 'Starlight,PA',
'18462': 'Starrucca,PA',
'18463': 'Sterling,PA',
'18464': 'Tafton,PA',
'18465': 'Thompson,PA',
'18466': 'Tobyhanna,PA',
'18469': 'Tyler Hill,PA',
'18470': 'Union Dale,PA',
'18471': 'Waverly,PA',
'18472': 'Waymart,PA',
'18473': 'White Mills,PA',
'18501': 'Scranton,PA',
'18502': 'Scranton,PA',
'18503': 'Scranton,PA',
'18504': 'Scranton,PA',
'18505': 'Scranton,PA',
'18507': 'Moosic,PA',
'18508': 'Scranton,PA',
'18509': 'Scranton,PA',
'18510': 'Scranton,PA',
'18512': 'Scranton,PA',
'18514': 'Scranton,PA',
'18515': 'Scranton,PA',
'18517': 'Taylor,PA',
'18518': 'Old Forge,PA',
'18519': 'Dickson City,PA',
'18522': 'Scranton,PA',
'18540': 'Scranton,PA',
'18577': 'Scranton,PA',
'18601': 'Beach Haven,PA',
'18602': 'Bear Creek,PA',
'18603': 'Berwick,PA',
'18610': 'Blakeslee,PA',
'18611': 'Cambra,PA',
'18612': 'Dallas,PA',
'18614': 'Dushore,PA',
'18615': 'Falls,PA',
'18616': 'Forksville,PA',
'18617': 'Glen Lyon,PA',
'18618': 'Harveys Lake,PA',
'18619': 'Hillsgrove,PA',
'18621': 'Hunlock Creek,PA',
'18622': 'Huntington Mills,PA',
'18623': 'Laceyville,PA',
'18624': 'Lake Harmony,PA',
'18625': 'Lake Winola,PA',
'18626': 'Laporte,PA',
'18627': 'Lehman,PA',
'18628': 'Lopez,PA',
'18629': 'Mehoopany,PA',
'18630': 'Meshoppen,PA',
'18631': 'Mifflinville,PA',
'18632': 'Mildred,PA',
'18634': 'Nanticoke,PA',
'18635': 'Nescopeck,PA',
'18636': 'Noxen,PA',
'18640': 'Pittston,PA',
'18641': 'Pittston,PA',
'18642': 'Duryea,PA',
'18643': 'Pittston,PA',
'18644': 'Wyoming,PA',
'18651': 'Plymouth,PA',
'18653': 'Ransom,PA',
'18654': 'Shawanese,PA',
'18655': 'Shickshinny,PA',
'18656': 'Sweet Valley,PA',
'18657': 'Tunkhannock,PA',
'18660': 'Wapwallopen,PA',
'18661': 'White Haven,PA',
'18690': 'Dallas,PA',
'18701': 'Wilkes Barre,PA',
'18702': 'Wilkes Barre,PA',
'18703': 'Wilkes Barre,PA',
'18704': 'Kingston,PA',
'18705': 'Wilkes Barre,PA',
'18706': 'Wilkes Barre,PA',
'18707': 'Mountain Top,PA',
'18708': 'Shavertown,PA',
'18709': 'Luzerne,PA',
'18710': 'Wilkes Barre,PA',
'18711': 'Wilkes Barre,PA',
'18761': 'Wilkes Barre,PA',
'18762': 'Wilkes Barre,PA',
'18763': 'Wilkes Barre,PA',
'18764': 'Wilkes Barre,PA',
'18765': 'Wilkes Barre,PA',
'18766': 'Wilkes Barre,PA',
'18767': 'Wilkes Barre,PA',
'18768': 'Wilkes Barre,PA',
'18769': 'Wilkes Barre,PA',
'18773': 'Wilkes Barre,PA',
'18774': 'Wilkes Barre,PA',
'18801': 'Montrose,PA',
'18810': 'Athens,PA',
'18812': 'Brackney,PA',
'18813': 'Brooklyn,PA',
'18814': 'Burlington,PA',
'18815': 'Camptown,PA',
'18816': 'Dimock,PA',
'18817': 'East Smithfield,PA',
'18818': 'Friendsville,PA',
'18820': 'Gibson,PA',
'18821': 'Great Bend,PA',
'18822': 'Hallstead,PA',
'18823': 'Harford,PA',
'18824': 'Hop Bottom,PA',
'18825': 'Jackson,PA',
'18826': 'Kingsley,PA',
'18827': 'Lanesboro,PA',
'18828': 'Lawton,PA',
'18829': 'Le Raysville,PA',
'18830': 'Little Meadows,PA',
'18831': 'Milan,PA',
'18832': 'Monroeton,PA',
'18833': 'New Albany,PA',
'18834': 'New Milford,PA',
'18837': 'Rome,PA',
'18839': 'Rushville,PA',
'18840': 'Sayre,PA',
'18842': 'South Gibson,PA',
'18843': 'South Montrose,PA',
'18844': 'Springville,PA',
'18845': 'Stevensville,PA',
'18846': 'Sugar Run,PA',
'18847': 'Susquehanna,PA',
'18848': 'Towanda,PA',
'18850': 'Ulster,PA',
'18851': 'Warren Center,PA',
'18853': 'Wyalusing,PA',
'18854': 'Wysox,PA',
'18901': 'Doylestown,PA',
'18902': 'Gardenville,PA',
'18910': 'Bedminster,PA',
'18911': 'Blooming Glen,PA',
'18912': 'Buckingham,PA',
'18913': 'Carversville,PA',
'18914': 'Chalfont,PA',
'18915': 'Colmar,PA',
'18916': 'Danboro,PA',
'18917': 'Dublin,PA',
'18918': 'Earlington,PA',
'18920': 'Erwinna,PA',
'18921': 'Ferndale,PA',
'18922': 'Forest Grove,PA',
'18923': 'Fountainville,PA',
'18924': 'Franconia,PA',
'18925': 'Furlong,PA',
'18926': 'Gardenville,PA',
'18927': 'Hilltown,PA',
'18928': 'Holicong,PA',
'18929': 'Jamison,PA',
'18930': 'Kintnersville,PA',
'18931': 'Lahaska,PA',
'18932': 'Line Lexington,PA',
'18933': 'Lumberville,PA',
'18934': 'Mechanicsville,PA',
'18935': 'Milford Square,PA',
'18936': 'Montgomeryville,PA',
'18938': 'New Hope,PA',
'18940': 'Newtown,PA',
'18942': 'Ottsville,PA',
'18943': 'Penns Park,PA',
'18944': 'Perkasie,PA',
'18946': 'Pineville,PA',
'18947': 'Pipersville,PA',
'18949': 'Plumsteadville,PA',
'18950': 'Point Pleasant,PA',
'18951': 'Quakertown,PA',
'18953': 'Revere,PA',
'18954': 'Richboro,PA',
'18955': 'Richlandtown,PA',
'18956': 'Rushland,PA',
'18957': 'Salford,PA',
'18958': 'Salfordville,PA',
'18960': 'Sellersville,PA',
'18962': 'Silverdale,PA',
'18963': 'Solebury,PA',
'18964': 'Souderton,PA',
'18966': 'Southampton,PA',
'18968': 'Spinnerstown,PA',
'18969': 'Telford,PA',
'18970': 'Trumbauersville,PA',
'18971': 'Tylersport,PA',
'18972': 'Upper Black Eddy,PA',
'18974': 'Warminster,PA',
'18976': 'Warrington,PA',
'18977': 'Washington Crossing,PA',
'18979': 'Woxall,PA',
'18980': 'Wycombe,PA',
'18981': 'Zionhill,PA',
'18991': 'Warminster,PA',
'19001': 'Abington,PA',
'19002': 'Ambler,PA',
'19003': 'Ardmore,PA',
'19004': 'Bala Cynwyd,PA',
'19006': 'Huntingdon Valley,PA',
'19007': 'Bristol,PA',
'19008': 'Broomall,PA',
'19009': 'Bryn Athyn,PA',
'19010': 'Bryn Mawr,PA',
'19012': 'Cheltenham,PA',
'19013': 'Chester,PA',
'19014': 'Aston,PA',
'19015': 'Brookhaven,PA',
'19016': 'Chester,PA',
'19017': 'Chester Heights,PA',
'19018': 'Clifton Heights,PA',
'19019': 'Philadelphia,PA',
'19020': 'Bensalem,PA',
'19021': 'Croydon,PA',
'19022': 'Crum Lynne,PA',
'19023': 'Darby,PA',
'19025': 'Dresher,PA',
'19026': 'Drexel Hill,PA',
'19027': 'Elkins Park,PA',
'19028': 'Edgemont,PA',
'19029': 'Essington,PA',
'19030': 'Fairless Hills,PA',
'19031': 'Flourtown,PA',
'19032': 'Folcroft,PA',
'19033': 'Folsom,PA',
'19034': 'Fort Washington,PA',
'19035': 'Gladwyne,PA',
'19036': 'Glenolden,PA',
'19037': 'Glen Riddle Lima,PA',
'19038': 'Glenside,PA',
'19039': 'Gradyville,PA',
'19040': 'Hatboro,PA',
'19041': 'Haverford,PA',
'19043': 'Holmes,PA',
'19044': 'Horsham,PA',
'19046': 'Jenkintown,PA',
'19047': 'Langhorne,PA',
'19048': 'Fort Washington,PA',
'19049': 'Fort Washington,PA',
'19050': 'Lansdowne,PA',
'19052': 'Lenni,PA',
'19053': 'Feasterville Trevose,PA',
'19054': 'Levittown,PA',
'19055': 'Levittown,PA',
'19056': 'Levittown,PA',
'19057': 'Levittown,PA',
'19058': 'Levittown,PA',
'19059': 'Levittown,PA',
'19060': 'Upper Chichester,PA',
'19061': 'Marcus Hook,PA',
'19063': 'Media,PA',
'19064': 'Springfield,PA',
'19065': 'Media,PA',
'19066': 'Merion Station,PA',
'19067': 'Morrisville,PA',
'19070': 'Morton,PA',
'19072': 'Narberth,PA',
'19073': 'Newtown Square,PA',
'19074': 'Norwood,PA',
'19075': 'Oreland,PA',
'19076': 'Prospect Park,PA',
'19078': 'Ridley Park,PA',
'19079': 'Sharon Hill,PA',
'19080': 'Wayne,PA',
'19081': 'Swarthmore,PA',
'19082': 'Upper Darby,PA',
'19083': 'Havertown,PA',
'19085': 'Villanova,PA',
'19086': 'Wallingford,PA',
'19087': 'Wayne,PA',
'19088': 'Wayne,PA',
'19089': 'Wayne,PA',
'19090': 'Willow Grove,PA',
'19091': 'Media,PA',
'19092': 'Philadelphia,PA',
'19093': 'Philadelphia,PA',
'19094': 'Woodlyn,PA',
'19095': 'Wyncote,PA',
'19096': 'Wynnewood,PA',
'19098': 'Holmes,PA',
'19099': 'Philadelphia,PA',
'19101': 'Philadelphia,PA',
'19102': 'Philadelphia,PA',
'19103': 'Philadelphia,PA',
'19104': 'Philadelphia,PA',
'19105': 'Philadelphia,PA',
'19106': 'Philadelphia,PA',
'19107': 'Philadelphia,PA',
'19108': 'Philadelphia,PA',
'19109': 'Philadelphia,PA',
'19110': 'Philadelphia,PA',
'19111': 'Philadelphia,PA',
'19112': 'Philadelphia,PA',
'19113': 'Philadelphia,PA',
'19114': 'Philadelphia,PA',
'19115': 'Philadelphia,PA',
'19116': 'Philadelphia,PA',
'19118': 'Philadelphia,PA',
'19119': 'Philadelphia,PA',
'19120': 'Philadelphia,PA',
'19121': 'Philadelphia,PA',
'19122': 'Philadelphia,PA',
'19123': 'Philadelphia,PA',
'19124': 'Philadelphia,PA',
'19125': 'Philadelphia,PA',
'19126': 'Philadelphia,PA',
'19127': 'Philadelphia,PA',
'19128': 'Philadelphia,PA',
'19129': 'Philadelphia,PA',
'19130': 'Philadelphia,PA',
'19131': 'Philadelphia,PA',
'19132': 'Philadelphia,PA',
'19133': 'Philadelphia,PA',
'19134': 'Philadelphia,PA',
'19135': 'Philadelphia,PA',
'19136': 'Philadelphia,PA',
'19137': 'Philadelphia,PA',
'19138': 'Philadelphia,PA',
'19139': 'Philadelphia,PA',
'19140': 'Philadelphia,PA',
'19141': 'Philadelphia,PA',
'19142': 'Philadelphia,PA',
'19143': 'Philadelphia,PA',
'19144': 'Philadelphia,PA',
'19145': 'Philadelphia,PA',
'19146': 'Philadelphia,PA',
'19147': 'Philadelphia,PA',
'19148': 'Philadelphia,PA',
'19149': 'Philadelphia,PA',
'19150': 'Philadelphia,PA',
'19151': 'Philadelphia,PA',
'19152': 'Philadelphia,PA',
'19153': 'Philadelphia,PA',
'19154': 'Philadelphia,PA',
'19155': 'Philadelphia,PA',
'19160': 'Philadelphia,PA',
'19161': 'Philadelphia,PA',
'19162': 'Philadelphia,PA',
'19170': 'Philadelphia,PA',
'19171': 'Philadelphia,PA',
'19172': 'Philadelphia,PA',
'19173': 'Philadelphia,PA',
'19175': 'Philadelphia,PA',
'19176': 'Philadelphia,PA',
'19177': 'Philadelphia,PA',
'19178': 'Philadelphia,PA',
'19179': 'Philadelphia,PA',
'19181': 'Philadelphia,PA',
'19182': 'Philadelphia,PA',
'19183': 'Philadelphia,PA',
'19184': 'Philadelphia,PA',
'19185': 'Philadelphia,PA',
'19187': 'Philadelphia,PA',
'19188': 'Philadelphia,PA',
'19191': 'Philadelphia,PA',
'19192': 'Philadelphia,PA',
'19193': 'Philadelphia,PA',
'19194': 'Philadelphia,PA',
'19195': 'Philadelphia,PA',
'19196': 'Philadelphia,PA',
'19197': 'Philadelphia,PA',
'19244': 'Philadelphia,PA',
'19255': 'Philadelphia,PA',
'19301': 'Paoli,PA',
'19310': 'Atglen,PA',
'19311': 'Avondale,PA',
'19312': 'Berwyn,PA',
'19316': 'Brandamore,PA',
'19317': 'Chadds Ford,PA',
'19318': 'Chatham,PA',
'19319': 'Cheyney,PA',
'19320': 'Coatesville,PA',
'19330': 'Cochranville,PA',
'19331': 'Concordville,PA',
'19333': 'Devon,PA',
'19335': 'Downingtown,PA',
'19339': 'Concordville,PA',
'19340': 'Concordville,PA',
'19341': 'Exton,PA',
'19342': 'Glen Mills,PA',
'19343': 'Glenmoore,PA',
'19344': 'Honey Brook,PA',
'19345': 'Immaculata,PA',
'19346': 'Kelton,PA',
'19347': 'Kemblesville,PA',
'19348': 'Kennett Square,PA',
'19350': 'Landenberg,PA',
'19351': 'Lewisville,PA',
'19352': 'Lincoln University,PA',
'19353': 'Lionville,PA',
'19354': 'Lyndell,PA',
'19355': 'Malvern,PA',
'19357': 'Mendenhall,PA',
'19358': 'Modena,PA',
'19360': 'New London,PA',
'19362': 'Nottingham,PA',
'19363': 'Oxford,PA',
'19365': 'Parkesburg,PA',
'19366': 'Pocopson,PA',
'19367': 'Pomeroy,PA',
'19369': 'Sadsburyville,PA',
'19370': 'Steelville,PA',
'19371': 'Suplee,PA',
'19372': 'Thorndale,PA',
'19373': 'Thornton,PA',
'19374': 'Toughkenamon,PA',
'19375': 'Unionville,PA',
'19376': 'Wagontown,PA',
'19380': 'West Chester,PA',
'19381': 'West Chester,PA',
'19382': 'West Chester,PA',
'19383': 'West Chester,PA',
'19388': 'Qvc Network Inc,PA',
'19390': 'West Grove,PA',
'19395': 'Westtown,PA',
'19397': 'Southeastern,PA',
'19398': 'Southeastern,PA',
'19399': 'Southeastern,PA',
'19401': 'Norristown,PA',
'19403': 'Norristown,PA',
'19404': 'Norristown,PA',
'19405': 'Bridgeport,PA',
'19406': 'King Of Prussia,PA',
'19407': 'Audubon,PA',
'19408': 'Eagleville,PA',
'19409': 'Fairview Village,PA',
'19415': 'Eagleville,PA',
'19420': 'Arcola,PA',
'19421': 'Birchrunville,PA',
'19422': 'Blue Bell,PA',
'19423': 'Cedars,PA',
'19424': 'Blue Bell,PA',
'19425': 'Chester Springs,PA',
'19426': 'Collegeville,PA',
'19428': 'Conshohocken,PA',
'19429': 'Conshohocken,PA',
'19430': 'Creamery,PA',
'19432': 'Devault,PA',
'19435': 'Frederick,PA',
'19436': 'Gwynedd,PA',
'19437': 'Gwynedd Valley,PA',
'19438': 'Harleysville,PA',
'19440': 'Hatfield,PA',
'19441': 'Harleysville,PA',
'19442': 'Kimberton,PA',
'19443': 'Kulpsville,PA',
'19444': 'Lafayette Hill,PA',
'19446': 'Lansdale,PA',
'19450': 'Lederach,PA',
'19451': 'Mainland,PA',
'19452': 'Miquon,PA',
'19453': 'Mont Clare,PA',
'19454': 'North Wales,PA',
'19455': 'North Wales,PA',
'19456': 'Oaks,PA',
'19457': 'Parker Ford,PA',
'19460': 'Phoenixville,PA',
'19462': 'Plymouth Meeting,PA',
'19464': 'Pottstown,PA',
'19465': 'Pottstown,PA',
'19468': 'Royersford,PA',
'19470': 'Saint Peters,PA',
'19472': 'Sassamansville,PA',
'19473': 'Schwenksville,PA',
'19474': 'Skippack,PA',
'19475': 'Spring City,PA',
'19477': 'Spring House,PA',
'19478': 'Spring Mount,PA',
'19480': 'Uwchland,PA',
'19481': 'Valley Forge,PA',
'19482': 'Valley Forge,PA',
'19483': 'Valley Forge,PA',
'19484': 'Valley Forge,PA',
'19485': 'Valley Forge,PA',
'19486': 'West Point,PA',
'19487': 'King Of Prussia,PA',
'19488': 'Norristown,PA',
'19489': 'Norristown,PA',
'19490': 'Worcester,PA',
'19492': 'Zieglerville,PA',
'19493': 'Valley Forge,PA',
'19494': 'Valley Forge,PA',
'19495': 'Valley Forge,PA',
'19496': 'Valley Forge,PA',
'19501': 'Adamstown,PA',
'19503': 'Bally,PA',
'19504': 'Barto,PA',
'19505': 'Bechtelsville,PA',
'19506': 'Bernville,PA',
'19507': 'Bethel,PA',
'19508': 'Birdsboro,PA',
'19510': 'Blandon,PA',
'19511': 'Bowers,PA',
'19512': 'Boyertown,PA',
'19516': 'Centerport,PA',
'19518': 'Douglassville,PA',
'19519': 'Earlville,PA',
'19520': 'Elverson,PA',
'19522': 'Fleetwood,PA',
'19523': 'Geigertown,PA',
'19525': 'Gilbertsville,PA',
'19526': 'Hamburg,PA',
'19529': 'Kempton,PA',
'19530': 'Kutztown,PA',
'19533': 'Leesport,PA',
'19534': 'Lenhartsville,PA',
'19535': 'Limekiln,PA',
'19536': 'Lyon Station,PA',
'19538': 'Maxatawny,PA',
'19539': 'Mertztown,PA',
'19540': 'Mohnton,PA',
'19541': 'Mohrsville,PA',
'19542': 'Monocacy Station,PA',
'19543': 'Morgantown,PA',
'19544': 'Mount Aetna,PA',
'19545': 'New Berlinville,PA',
'19547': 'Oley,PA',
'19548': 'Pine Forge,PA',
'19549': 'Port Clinton,PA',
'19550': 'Rehrersburg,PA',
'19551': 'Robesonia,PA',
'19554': 'Shartlesville,PA',
'19555': 'Shoemakersville,PA',
'19557': 'Stony Run,PA',
'19559': 'Strausstown,PA',
'19560': 'Temple,PA',
'19562': 'Topton,PA',
'19564': 'Virginville,PA',
'19565': 'Wernersville,PA',
'19567': 'Womelsdorf,PA',
'19601': 'Reading,PA',
'19602': 'Reading,PA',
'19603': 'Reading,PA',
'19604': 'Reading,PA',
'19605': 'Reading,PA',
'19606': 'Reading,PA',
'19607': 'Reading,PA',
'19608': 'Reading,PA',
'19609': 'Reading,PA',
'19610': 'Reading,PA',
'19611': 'Reading,PA',
'19612': 'Reading,PA',
'19640': 'Reading,PA',
'19701': 'Bear,DE',
'19702': 'Newark,DE',
'19703': 'Claymont,DE',
'19706': 'Delaware City,DE',
'19707': 'Hockessin,DE',
'19708': 'Kirkwood,DE',
'19709': 'Middletown,DE',
'19710': 'Montchanin,DE',
'19711': 'Newark,DE',
'19712': 'Newark,DE',
'19713': 'Newark,DE',
'19714': 'Newark,DE',
'19715': 'Newark,DE',
'19716': 'Newark,DE',
'19717': 'Newark,DE',
'19718': 'Newark,DE',
'19720': 'New Castle,DE',
'19721': 'New Castle,DE',
'19725': 'Newark,DE',
'19726': 'Newark,DE',
'19730': 'Odessa,DE',
'19731': 'Port Penn,DE',
'19732': 'Rockland,DE',
'19733': 'Saint Georges,DE',
'19734': 'Townsend,DE',
'19735': 'Winterthur,DE',
'19736': 'Yorklyn,DE',
'19801': 'Wilmington,DE',
'19802': 'Wilmington,DE',
'19803': 'Wilmington,DE',
'19804': 'Wilmington,DE',
'19805': 'Wilmington,DE',
'19806': 'Wilmington,DE',
'19807': 'Wilmington,DE',
'19808': 'Wilmington,DE',
'19809': 'Wilmington,DE',
'19810': 'Wilmington,DE',
'19850': 'Wilmington,DE',
'19880': 'Wilmington,DE',
'19884': 'Wilmington,DE',
'19885': 'Wilmington,DE',
'19886': 'Wilmington,DE',
'19887': 'Wilmington,DE',
'19889': 'Wilmington,DE',
'19890': 'Wilmington,DE',
'19891': 'Wilmington,DE',
'19892': 'Wilmington,DE',
'19893': 'Wilmington,DE',
'19894': 'Wilmington,DE',
'19895': 'Wilmington,DE',
'19896': 'Wilmington,DE',
'19897': 'Wilmington,DE',
'19898': 'Wilmington,DE',
'19899': 'Wilmington,DE',
'19901': 'Dover,DE',
'19902': 'Dover Afb,DE',
'19903': 'Dover,DE',
'19904': 'Dover,DE',
'19905': 'Dover,DE',
'19906': 'Dover,DE',
'19930': 'Bethany Beach,DE',
'19931': 'Bethel,DE',
'19933': 'Bridgeville,DE',
'19934': 'Camden Wyoming,DE',
'19936': 'Cheswold,DE',
'19938': 'Clayton,DE',
'19939': 'Dagsboro,DE',
'19940': 'Delmar,DE',
'19941': 'Ellendale,DE',
'19943': 'Felton,DE',
'19944': 'Fenwick Island,DE',
'19945': 'Frankford,DE',
'19946': 'Frederica,DE',
'19947': 'Georgetown,DE',
'19950': 'Greenwood,DE',
'19951': 'Harbeson,DE',
'19952': 'Harrington,DE',
'19953': 'Hartly,DE',
'19954': 'Houston,DE',
'19955': 'Kenton,DE',
'19956': 'Laurel,DE',
'19958': 'Lewes,DE',
'19960': 'Lincoln,DE',
'19961': 'Little Creek,DE',
'19962': 'Magnolia,DE',
'19963': 'Milford,DE',
'19964': 'Marydel,DE',
'19966': 'Millsboro,DE',
'19967': 'Millville,DE',
'19968': 'Milton,DE',
'19969': 'Nassau,DE',
'19970': 'Ocean View,DE',
'19971': 'Rehoboth Beach,DE',
'19973': 'Seaford,DE',
'19975': 'Selbyville,DE',
'19977': 'Smyrna,DE',
'19979': 'Viola,DE',
'19980': 'Woodside,DE',
'20001': 'Washington,DC',
'20002': 'Washington,DC',
'20003': 'Washington,DC',
'20004': 'Washington,DC',
'20005': 'Washington,DC',
'20006': 'Washington,DC',
'20007': 'Washington,DC',
'20008': 'Washington,DC',
'20009': 'Washington,DC',
'20010': 'Washington,DC',
'20011': 'Washington,DC',
'20012': 'Washington,DC',
'20013': 'Washington,DC',
'20015': 'Washington,DC',
'20016': 'Washington,DC',
'20017': 'Washington,DC',
'20018': 'Washington,DC',
'20019': 'Washington,DC',
'20020': 'Washington,DC',
'20022': 'Washington,DC',
'20023': 'Washington,DC',
'20024': 'Washington,DC',
'20026': 'Washington,DC',
'20027': 'Washington,DC',
'20029': 'Washington,DC',
'20030': 'Washington,DC',
'20032': 'Washington,DC',
'20033': 'Washington,DC',
'20035': 'Washington,DC',
'20036': 'Washington,DC',
'20037': 'Washington,DC',
'20038': 'Washington,DC',
'20039': 'Washington,DC',
'20040': 'Washington,DC',
'20041': 'Washington,DC',
'20042': 'Washington,DC',
'20043': 'Washington,DC',
'20044': 'Washington,DC',
'20045': 'Washington,DC',
'20046': 'Washington,DC',
'20047': 'Washington,DC',
'20049': 'Washington,DC',
'20050': 'Washington,DC',
'20051': 'Washington,DC',
'20052': 'Washington,DC',
'20053': 'Washington,DC',
'20055': 'Washington,DC',
'20056': 'Washington,DC',
'20057': 'Washington,DC',
'20058': 'Washington,DC',
'20059': 'Washington,DC',
'20060': 'Washington,DC',
'20061': 'Washington,DC',
'20062': 'Washington,DC',
'20063': 'Washington,DC',
'20064': 'Washington,DC',
'20065': 'Washington,DC',
'20066': 'Washington,DC',
'20067': 'Washington,DC',
'20068': 'Washington,DC',
'20069': 'Washington,DC',
'20070': 'Washington,DC',
'20071': 'Washington,DC',
'20073': 'Washington,DC',
'20074': 'Washington,DC',
'20075': 'Washington,DC',
'20076': 'Washington,DC',
'20077': 'Washington,DC',
'20078': 'Washington,DC',
'20080': 'Washington,DC',
'20081': 'Washington,DC',
'20082': 'Washington,DC',
'20088': 'Washington,DC',
'20090': 'Washington,DC',
'20091': 'Washington,DC',
'20097': 'Washington,DC',
'20098': 'Washington,DC',
'20099': 'Washington,DC',
'20101': 'Dulles,VA',
'20102': 'Dulles,VA',
'20103': 'Dulles,VA',
'20104': 'Dulles,VA',
'20105': 'Aldie,VA',
'20106': 'Amissville,VA',
'20107': 'Arcola,VA',
'20108': 'Manassas,VA',
'20109': 'Manassas,VA',
'20110': 'Manassas,VA',
'20111': 'Manassas,VA',
'20112': 'Manassas,VA',
'20113': 'Manassas,VA',
'20115': 'Marshall,VA',
'20116': 'Marshall,VA',
'20117': 'Middleburg,VA',
'20118': 'Middleburg,VA',
'20119': 'Catlett,VA',
'20120': 'Centreville,VA',
'20121': 'Centreville,VA',
'20122': 'Centreville,VA',
'20124': 'Clifton,VA',
'20128': 'Orlean,VA',
'20129': 'Paeonian Springs,VA',
'20130': 'Paris,VA',
'20131': 'Philomont,VA',
'20132': 'Purcellville,VA',
'20134': 'Purcellville,VA',
'20135': 'Bluemont,VA',
'20136': 'Bristow,VA',
'20137': 'Broad Run,VA',
'20138': 'Calverton,VA',
'20139': 'Casanova,VA',
'20140': 'Rectortown,VA',
'20141': 'Round Hill,VA',
'20142': 'Round Hill,VA',
'20143': 'Catharpin,VA',
'20144': 'Delaplane,VA',
'20146': 'Ashburn,VA',
'20147': 'Ashburn,VA',
'20148': 'Ashburn,VA',
'20149': 'Ashburn,VA',
'20151': 'Chantilly,VA',
'20152': 'Chantilly,VA',
'20153': 'Chantilly,VA',
'20155': 'Gainesville,VA',
'20156': 'Gainesville,VA',
'20158': 'Hamilton,VA',
'20159': 'Hamilton,VA',
'20160': 'Lincoln,VA',
'20163': 'Sterling,VA',
'20164': 'Sterling,VA',
'20165': 'Sterling,VA',
'20166': 'Sterling,VA',
'20167': 'Sterling,VA',
'20168': 'Haymarket,VA',
'20169': 'Haymarket,VA',
'20170': 'Herndon,VA',
'20171': 'Herndon,VA',
'20172': 'Herndon,VA',
'20175': 'Leesburg,VA',
'20176': 'Leesburg,VA',
'20177': 'Leesburg,VA',
'20178': 'Leesburg,VA',
'20180': 'Lovettsville,VA',
'20181': 'Nokesville,VA',
'20182': 'Nokesville,VA',
'20184': 'Upperville,VA',
'20185': 'Upperville,VA',
'20186': 'Warrenton,VA',
'20187': 'Warrenton,VA',
'20188': 'Warrenton,VA',
'20189': 'Dulles,VA',
'20190': 'Reston,VA',
'20191': 'Reston,VA',
'20192': 'Herndon,VA',
'20193': 'Reston,VA',
'20194': 'Reston,VA',
'20195': 'Reston,VA',
'20196': 'Reston,VA',
'20197': 'Waterford,VA',
'20198': 'The Plains,VA',
'20199': 'Dulles,VA',
'20201': 'Washington,DC',
'20202': 'Washington,DC',
'20203': 'Washington,DC',
'20204': 'Washington,DC',
'20206': 'Washington,DC',
'20207': 'Washington,DC',
'20208': 'Washington,DC',
'20210': 'Washington,DC',
'20211': 'Washington,DC',
'20212': 'Washington,DC',
'20213': 'Washington,DC',
'20214': 'Washington,DC',
'20215': 'Washington,DC',
'20216': 'Washington,DC',
'20217': 'Washington,DC',
'20218': 'Washington,DC',
'20219': 'Washington,DC',
'20220': 'Washington,DC',
'20221': 'Washington,DC',
'20222': 'Washington,DC',
'20223': 'Washington,DC',
'20224': 'Washington,DC',
'20226': 'Washington,DC',
'20227': 'Washington,DC',
'20228': 'Washington,DC',
'20229': 'Washington,DC',
'20230': 'Washington,DC',
'20231': 'Washington,DC',
'20232': 'Washington,DC',
'20233': 'Washington,DC',
'20235': 'Washington,DC',
'20237': 'Washington,DC',
'20238': 'Washington,DC',
'20239': 'Washington,DC',
'20240': 'Washington,DC',
'20241': 'Washington,DC',
'20242': 'Washington,DC',
'20244': 'Washington,DC',
'20245': 'Washington,DC',
'20250': 'Washington,DC',
'20251': 'Washington,DC',
'20254': 'Washington,DC',
'20260': 'Washington,DC',
'20261': 'Washington,DC',
'20262': 'Washington,DC',
'20265': 'Washington,DC',
'20266': 'Washington,DC',
'20268': 'Washington,DC',
'20270': 'Washington,DC',
'20277': 'Washington,DC',
'20289': 'Washington,DC',
'20299': 'Washington,DC',
'20301': 'Washington,DC',
'20303': 'Washington,DC',
'20306': 'Washington,DC',
'20307': 'Washington,DC',
'20310': 'Washington,DC',
'20314': 'Washington,DC',
'20315': 'Washington,DC',
'20317': 'Washington,DC',
'20318': 'Washington,DC',
'20319': 'Washington,DC',
'20330': 'Washington,DC',
'20332': 'Washington,DC',
'20336': 'Washington,DC',
'20337': 'Washington,DC',
'20338': 'Washington,DC',
'20340': 'Washington,DC',
'20350': 'Washington,DC',
'20355': 'Washington,DC',
'20370': 'Washington,DC',
'20372': 'Washington,DC',
'20373': 'Anacostia Annex,DC',
'20374': 'Washington,DC',
'20375': 'Washington,DC',
'20376': 'Washington,DC',
'20380': 'Washington,DC',
'20388': 'Washington,DC',
'20389': 'Washington,DC',
'20390': 'Washington,DC',
'20391': 'Washington,DC',
'20392': 'Washington,DC',
'20393': 'Washington,DC',
'20394': 'Washington,DC',
'20395': 'Washington,DC',
'20398': 'Washington,DC',
'20401': 'Washington,DC',
'20402': 'Washington,DC',
'20403': 'Washington,DC',
'20404': 'Washington,DC',
'20405': 'Washington,DC',
'20406': 'Washington,DC',
'20407': 'Washington,DC',
'20408': 'Washington,DC',
'20409': 'Washington,DC',
'20410': 'Washington,DC',
'20411': 'Washington,DC',
'20412': 'Washington,DC',
'20413': 'Washington,DC',
'20414': 'Washington,DC',
'20415': 'Washington,DC',
'20416': 'Washington,DC',
'20418': 'Washington,DC',
'20419': 'Washington,DC',
'20420': 'Washington,DC',
'20421': 'Washington,DC',
'20422': 'Washington,DC',
'20423': 'Washington,DC',
'20424': 'Washington,DC',
'20425': 'Washington,DC',
'20426': 'Washington,DC',
'20427': 'Washington,DC',
'20428': 'Washington,DC',
'20429': 'Washington,DC',
'20431': 'Washington,DC',
'20433': 'Washington,DC',
'20434': 'Washington,DC',
'20435': 'Washington,DC',
'20436': 'Washington,DC',
'20437': 'Washington,DC',
'20439': 'Washington,DC',
'20440': 'Washington,DC',
'20441': 'Washington,DC',
'20442': 'Washington,DC',
'20444': 'Washington,DC',
'20447': 'Washington,DC',
'20451': 'Washington,DC',
'20453': 'Washington,DC',
'20456': 'Washington,DC',
'20460': 'Washington,DC',
'20463': 'Washington,DC',
'20468': 'Washington,DC',
'20469': 'Washington,DC',
'20470': 'Washington,DC',
'20472': 'Washington,DC',
'20500': 'Washington,DC',
'20501': 'Washington,DC',
'20502': 'Washington,DC',
'20503': 'Washington,DC',
'20504': 'Washington,DC',
'20505': 'Washington,DC',
'20506': 'Washington,DC',
'20507': 'Washington,DC',
'20508': 'Washington,DC',
'20509': 'Washington,DC',
'20510': 'Washington,DC',
'20511': 'Washington,DC',
'20515': 'Washington,DC',
'20520': 'Washington,DC',
'20521': 'Washington,DC',
'20522': 'Washington,DC',
'20523': 'Washington,DC',
'20524': 'Washington,DC',
'20525': 'Washington,DC',
'20526': 'Washington,DC',
'20527': 'Washington,DC',
'20528': 'Washington,DC',
'20529': 'Washington,DC',
'20530': 'Washington,DC',
'20531': 'Washington,DC',
'20532': 'Washington,DC',
'20533': 'Washington,DC',
'20534': 'Washington,DC',
'20535': 'Washington,DC',
'20536': 'Washington,DC',
'20537': 'Washington,DC',
'20538': 'Washington,DC',
'20539': 'Washington,DC',
'20540': 'Washington,DC',
'20541': 'Washington,DC',
'20542': 'Washington,DC',
'20543': 'Washington,DC',
'20544': 'Washington,DC',
'20546': 'Washington,DC',
'20547': 'Washington,DC',
'20548': 'Washington,DC',
'20549': 'Washington,DC',
'20550': 'Washington,DC',
'20551': 'Washington,DC',
'20552': 'Washington,DC',
'20553': 'Washington,DC',
'20554': 'Washington,DC',
'20555': 'Washington,DC',
'20557': 'Washington,DC',
'20558': 'Washington,DC',
'20559': 'Washington,DC',
'20560': 'Washington,DC',
'20565': 'Washington,DC',
'20566': 'Washington,DC',
'20570': 'Washington,DC',
'20571': 'Washington,DC',
'20572': 'Washington,DC',
'20573': 'Washington,DC',
'20575': 'Washington,DC',
'20576': 'Washington,DC',
'20577': 'Washington,DC',
'20578': 'Washington,DC',
'20579': 'Washington,DC',
'20580': 'Washington,DC',
'20581': 'Washington,DC',
'20585': 'Washington,DC',
'20586': 'Washington,DC',
'20588': 'Dept Hs,MD',
'20590': 'Washington,DC',
'20591': 'Washington,DC',
'20593': 'Washington,DC',
'20594': 'Washington,DC',
'20597': 'Washington,DC',
'20598': 'Dept Hs,VA',
'20599': 'Washington,DC',
'20601': 'Waldorf,MD',
'20602': 'Waldorf,MD',
'20603': 'Waldorf,MD',
'20604': 'Waldorf,MD',
'20606': 'Abell,MD',
'20607': 'Accokeek,MD',
'20608': 'Aquasco,MD',
'20609': 'Avenue,MD',
'20610': 'Barstow,MD',
'20611': 'Bel Alton,MD',
'20612': 'Benedict,MD',
'20613': 'Brandywine,MD',
'20615': 'Broomes Island,MD',
'20616': 'Bryans Road,MD',
'20617': 'Bryantown,MD',
'20618': 'Bushwood,MD',
'20619': 'California,MD',
'20620': 'Callaway,MD',
'20621': 'Chaptico,MD',
'20622': 'Charlotte Hall,MD',
'20623': 'Cheltenham,MD',
'20624': 'Clements,MD',
'20625': 'Cobb Island,MD',
'20626': 'Coltons Point,MD',
'20627': 'Compton,MD',
'20628': 'Dameron,MD',
'20629': 'Dowell,MD',
'20630': 'Drayden,MD',
'20632': 'Faulkner,MD',
'20634': 'Great Mills,MD',
'20635': 'Helen,MD',
'20636': 'Hollywood,MD',
'20637': 'Hughesville,MD',
'20639': 'Huntingtown,MD',
'20640': 'Indian Head,MD',
'20643': 'Ironsides,MD',
'20645': 'Issue,MD',
'20646': 'La Plata,MD',
'20650': 'Leonardtown,MD',
'20653': 'Lexington Park,MD',
'20656': 'Loveville,MD',
'20657': 'Lusby,MD',
'20658': 'Marbury,MD',
'20659': 'Mechanicsville,MD',
'20660': 'Morganza,MD',
'20661': 'Mount Victoria,MD',
'20662': 'Nanjemoy,MD',
'20664': 'Newburg,MD',
'20667': 'Park Hall,MD',
'20670': 'Patuxent River,MD',
'20674': 'Piney Point,MD',
'20675': 'Pomfret,MD',
'20676': 'Port Republic,MD',
'20677': 'Port Tobacco,MD',
'20678': 'Prince Frederick,MD',
'20680': 'Ridge,MD',
'20682': 'Rock Point,MD',
'20684': 'Saint Inigoes,MD',
'20685': 'Saint Leonard,MD',
'20686': 'Saint Marys City,MD',
'20687': 'Scotland,MD',
'20688': 'Solomons,MD',
'20689': 'Sunderland,MD',
'20690': 'Tall Timbers,MD',
'20692': 'Valley Lee,MD',
'20693': 'Welcome,MD',
'20695': 'White Plains,MD',
'20697': 'Southern Md Facility,MD',
'20701': 'Annapolis Junction,MD',
'20703': 'Lanham,MD',
'20704': 'Beltsville,MD',
'20705': 'Beltsville,MD',
'20706': 'Lanham,MD',
'20707': 'Laurel,MD',
'20708': 'Laurel,MD',
'20709': 'Laurel,MD',
'20710': 'Bladensburg,MD',
'20711': 'Lothian,MD',
'20712': 'Mount Rainier,MD',
'20714': 'North Beach,MD',
'20715': 'Bowie,MD',
'20716': 'Bowie,MD',
'20717': 'Bowie,MD',
'20718': 'Bowie,MD',
'20719': 'Bowie,MD',
'20720': 'Bowie,MD',
'20721': 'Bowie,MD',
'20722': 'Brentwood,MD',
'20723': 'Laurel,MD',
'20724': 'Laurel,MD',
'20725': 'Laurel,MD',
'20726': 'Laurel,MD',
'20731': 'Capitol Heights,MD',
'20732': 'Chesapeake Beach,MD',
'20733': 'Churchton,MD',
'20735': 'Clinton,MD',
'20736': 'Owings,MD',
'20737': 'Riverdale,MD',
'20738': 'Riverdale,MD',
'20740': 'College Park,MD',
'20741': 'College Park,MD',
'20742': 'College Park,MD',
'20743': 'Capitol Heights,MD',
'20744': 'Fort Washington,MD',
'20745': 'Oxon Hill,MD',
'20746': 'Suitland,MD',
'20747': 'District Heights,MD',
'20748': 'Temple Hills,MD',
'20749': 'Fort Washington,MD',
'20750': 'Oxon Hill,MD',
'20751': 'Deale,MD',
'20752': 'Suitland,MD',
'20753': 'District Heights,MD',
'20754': 'Dunkirk,MD',
'20755': 'Fort George G Meade,MD',
'20757': 'Temple Hills,MD',
'20758': 'Friendship,MD',
'20759': 'Fulton,MD',
'20762': 'Andrews Air Force Base,MD',
'20763': 'Savage,MD',
'20764': 'Shady Side,MD',
'20765': 'Galesville,MD',
'20768': 'Greenbelt,MD',
'20769': 'Glenn Dale,MD',
'20770': 'Greenbelt,MD',
'20771': 'Greenbelt,MD',
'20772': 'Upper Marlboro,MD',
'20773': 'Upper Marlboro,MD',
'20774': 'Upper Marlboro,MD',
'20775': 'Upper Marlboro,MD',
'20776': 'Harwood,MD',
'20777': 'Highland,MD',
'20778': 'West River,MD',
'20779': 'Tracys Landing,MD',
'20781': 'Hyattsville,MD',
'20782': 'Hyattsville,MD',
'20783': 'Hyattsville,MD',
'20784': 'Hyattsville,MD',
'20785': 'Hyattsville,MD',
'20787': 'Hyattsville,MD',
'20788': 'Hyattsville,MD',
'20790': 'Capitol Heights,MD',
'20791': 'Capitol Heights,MD',
'20792': 'Upper Marlboro,MD',
'20794': 'Jessup,MD',
'20797': 'Southern Md Facility,MD',
'20799': 'Capitol Heights,MD',
'20810': 'Geico,MD',
'20811': 'Geico,MD',
'20812': 'Glen Echo,MD',
'20813': 'Bethesda,MD',
'20814': 'Bethesda,MD',
'20815': 'Chevy Chase,MD',
'20816': 'Bethesda,MD',
'20817': 'Bethesda,MD',
'20818': 'Cabin John,MD',
'20824': 'Bethesda,MD',
'20825': 'Chevy Chase,MD',
'20827': 'Bethesda,MD',
'20830': 'Olney,MD',
'20832': 'Olney,MD',
'20833': 'Brookeville,MD',
'20837': 'Poolesville,MD',
'20838': 'Barnesville,MD',
'20839': 'Beallsville,MD',
'20841': 'Boyds,MD',
'20842': 'Dickerson,MD',
'20847': 'Rockville,MD',
'20848': 'Rockville,MD',
'20849': 'Rockville,MD',
'20850': 'Rockville,MD',
'20851': 'Rockville,MD',
'20852': 'Rockville,MD',
'20853': 'Rockville,MD',
'20854': 'Potomac,MD',
'20855': 'Derwood,MD',
'20857': 'Rockville,MD',
'20859': 'Potomac,MD',
'20860': 'Sandy Spring,MD',
'20861': 'Ashton,MD',
'20862': 'Brinklow,MD',
'20866': 'Burtonsville,MD',
'20868': 'Spencerville,MD',
'20871': 'Clarksburg,MD',
'20872': 'Damascus,MD',
'20874': 'Germantown,MD',
'20875': 'Germantown,MD',
'20876': 'Germantown,MD',
'20877': 'Gaithersburg,MD',
'20878': 'Gaithersburg,MD',
'20879': 'Gaithersburg,MD',
'20880': 'Washington Grove,MD',
'20882': 'Gaithersburg,MD',
'20883': 'Gaithersburg,MD',
'20884': 'Gaithersburg,MD',
'20885': 'Gaithersburg,MD',
'20886': 'Montgomery Village,MD',
'20889': 'Bethesda,MD',
'20891': 'Kensington,MD',
'20892': 'Bethesda,MD',
'20894': 'Bethesda,MD',
'20895': 'Kensington,MD',
'20896': 'Garrett Park,MD',
'20897': 'Suburb Maryland Fac,MD',
'20898': 'Gaithersburg,MD',
'20899': 'Gaithersburg,MD',
'20901': 'Silver Spring,MD',
'20902': 'Silver Spring,MD',
'20903': 'Silver Spring,MD',
'20904': 'Silver Spring,MD',
'20905': 'Silver Spring,MD',
'20906': 'Silver Spring,MD',
'20907': 'Silver Spring,MD',
'20908': 'Silver Spring,MD',
'20910': 'Silver Spring,MD',
'20911': 'Silver Spring,MD',
'20912': 'Takoma Park,MD',
'20913': 'Takoma Park,MD',
'20914': 'Silver Spring,MD',
'20915': 'Silver Spring,MD',
'20916': 'Silver Spring,MD',
'20918': 'Silver Spring,MD',
'20993': 'Us Food And Drug Admin,MD',
'20997': 'Silver Spring,MD',
'21001': 'Aberdeen,MD',
'21005': 'Aberdeen Proving Ground,MD',
'21009': 'Abingdon,MD',
'21010': 'Gunpowder,MD',
'21012': 'Arnold,MD',
'21013': 'Baldwin,MD',
'21014': 'Bel Air,MD',
'21015': 'Bel Air,MD',
'21017': 'Belcamp,MD',
'21018': 'Benson,MD',
'21020': 'Boring,MD',
'21022': 'Brooklandville,MD',
'21023': 'Butler,MD',
'21027': 'Chase,MD',
'21028': 'Churchville,MD',
'21029': 'Clarksville,MD',
'21030': 'Cockeysville,MD',
'21031': 'Hunt Valley,MD',
'21032': 'Crownsville,MD',
'21034': 'Darlington,MD',
'21035': 'Davidsonville,MD',
'21036': 'Dayton,MD',
'21037': 'Edgewater,MD',
'21040': 'Edgewood,MD',
'21041': 'Ellicott City,MD',
'21042': 'Ellicott City,MD',
'21043': 'Ellicott City,MD',
'21044': 'Columbia,MD',
'21045': 'Columbia,MD',
'21046': 'Columbia,MD',
'21047': 'Fallston,MD',
'21048': 'Finksburg,MD',
'21050': 'Forest Hill,MD',
'21051': 'Fork,MD',
'21052': 'Fort Howard,MD',
'21053': 'Freeland,MD',
'21054': 'Gambrills,MD',
'21055': 'Garrison,MD',
'21056': 'Gibson Island,MD',
'21057': 'Glen Arm,MD',
'21060': 'Glen Burnie,MD',
'21061': 'Glen Burnie,MD',
'21062': 'Glen Burnie,MD',
'21065': 'Pdp Group Inc,MD',
'21071': 'Glyndon,MD',
'21074': 'Hampstead,MD',
'21075': 'Elkridge,MD',
'21076': 'Hanover,MD',
'21077': 'Harmans,MD',
'21078': 'Havre De Grace,MD',
'21080': 'Henryton,MD',
'21082': 'Hydes,MD',
'21084': 'Jarrettsville,MD',
'21085': 'Joppa,MD',
'21087': 'Kingsville,MD',
'21088': 'Lineboro,MD',
'21090': 'Linthicum Heights,MD',
'21092': 'Long Green,MD',
'21093': 'Lutherville Timonium,MD',
'21094': 'Lutherville Timonium,MD',
'21098': 'Hanover,MD',
'21102': 'Manchester,MD',
'21104': 'Marriottsville,MD',
'21105': 'Maryland Line,MD',
'21106': 'Mayo,MD',
'21108': 'Millersville,MD',
'21111': 'Monkton,MD',
'21113': 'Odenton,MD',
'21114': 'Crofton,MD',
'21117': 'Owings Mills,MD',
'21120': 'Parkton,MD',
'21122': 'Pasadena,MD',
'21123': 'Pasadena,MD',
'21128': 'Perry Hall,MD',
'21130': 'Perryman,MD',
'21131': 'Phoenix,MD',
'21132': 'Pylesville,MD',
'21133': 'Randallstown,MD',
'21136': 'Reisterstown,MD',
'21139': 'Riderwood,MD',
'21140': 'Riva,MD',
'21144': 'Severn,MD',
'21146': 'Severna Park,MD',
'21150': 'Simpsonville,MD',
'21152': 'Sparks Glencoe,MD',
'21153': 'Stevenson,MD',
'21154': 'Street,MD',
'21155': 'Upperco,MD',
'21156': 'Upper Falls,MD',
'21157': 'Westminster,MD',
'21158': 'Westminster,MD',
'21160': 'Whiteford,MD',
'21161': 'White Hall,MD',
'21162': 'White Marsh,MD',
'21163': 'Woodstock,MD',
'21201': 'Baltimore,MD',
'21202': 'Baltimore,MD',
'21203': 'Baltimore,MD',
'21204': 'Towson,MD',
'21205': 'Baltimore,MD',
'21206': 'Baltimore,MD',
'21207': 'Gwynn Oak,MD',
'21208': 'Pikesville,MD',
'21209': 'Baltimore,MD',
'21210': 'Baltimore,MD',
'21211': 'Baltimore,MD',
'21212': 'Baltimore,MD',
'21213': 'Baltimore,MD',
'21214': 'Baltimore,MD',
'21215': 'Baltimore,MD',
'21216': 'Baltimore,MD',
'21217': 'Baltimore,MD',
'21218': 'Baltimore,MD',
'21219': 'Sparrows Point,MD',
'21220': 'Middle River,MD',
'21221': 'Essex,MD',
'21222': 'Dundalk,MD',
'21223': 'Baltimore,MD',
'21224': 'Baltimore,MD',
'21225': 'Brooklyn,MD',
'21226': 'Curtis Bay,MD',
'21227': 'Halethorpe,MD',
'21228': 'Catonsville,MD',
'21229': 'Baltimore,MD',
'21230': 'Baltimore,MD',
'21231': 'Baltimore,MD',
'21233': 'Baltimore,MD',
'21234': 'Parkville,MD',
'21235': 'Baltimore,MD',
'21236': 'Nottingham,MD',
'21237': 'Rosedale,MD',
'21239': 'Baltimore,MD',
'21240': 'Baltimore,MD',
'21241': 'Baltimore,MD',
'21244': 'Windsor Mill,MD',
'21250': 'Baltimore,MD',
'21251': 'Baltimore,MD',
'21252': 'Baltimore,MD',
'21260': 'Census Bureau,MD',
'21261': 'Census Bureau,MD',
'21263': 'Baltimore,MD',
'21264': 'Baltimore,MD',
'21265': 'Baltimore,MD',
'21268': 'Baltimore,MD',
'21270': 'Baltimore,MD',
'21273': 'Baltimore,MD',
'21274': 'Baltimore,MD',
'21275': 'Baltimore,MD',
'21278': 'Baltimore,MD',
'21279': 'Baltimore,MD',
'21280': 'Baltimore,MD',
'21281': 'Baltimore,MD',
'21282': 'Baltimore,MD',
'21283': 'Baltimore,MD',
'21284': 'Baltimore,MD',
'21285': 'Baltimore,MD',
'21286': 'Towson,MD',
'21287': 'Baltimore,MD',
'21288': 'Baltimore,MD',
'21289': 'Baltimore,MD',
'21290': 'Baltimore,MD',
'21297': 'Baltimore,MD',
'21298': 'Baltimore,MD',
'21401': 'Annapolis,MD',
'21402': 'Annapolis,MD',
'21403': 'Annapolis,MD',
'21404': 'Annapolis,MD',
'21405': 'Annapolis,MD',
'21409': 'Annapolis,MD',
'21411': 'Annapolis,MD',
'21412': 'Annapolis,MD',
'21501': 'Cumberland,MD',
'21502': 'Cumberland,MD',
'21503': 'Cumberland,MD',
'21504': 'Cumberland,MD',
'21505': 'Cumberland,MD',
'21520': 'Accident,MD',
'21521': 'Barton,MD',
'21522': 'Bittinger,MD',
'21523': 'Bloomington,MD',
'21524': 'Corriganville,MD',
'21528': 'Eckhart Mines,MD',
'21529': 'Ellerslie,MD',
'21530': 'Flintstone,MD',
'21531': 'Friendsville,MD',
'21532': 'Frostburg,MD',
'21536': 'Grantsville,MD',
'21538': 'Kitzmiller,MD',
'21539': 'Lonaconing,MD',
'21540': 'Luke,MD',
'21541': 'Mc Henry,MD',
'21542': 'Midland,MD',
'21543': 'Midlothian,MD',
'21545': 'Mount Savage,MD',
'21550': 'Oakland,MD',
'21555': 'Oldtown,MD',
'21556': 'Pinto,MD',
'21557': 'Rawlings,MD',
'21560': 'Spring Gap,MD',
'21561': 'Swanton,MD',
'21562': 'Westernport,MD',
'21601': 'Easton,MD',
'21606': 'Easton,MD',
'21607': 'Barclay,MD',
'21609': 'Bethlehem,MD',
'21610': 'Betterton,MD',
'21612': 'Bozman,MD',
'21613': 'Cambridge,MD',
'21617': 'Centreville,MD',
'21619': 'Chester,MD',
'21620': 'Chestertown,MD',
'21622': 'Church Creek,MD',
'21623': 'Church Hill,MD',
'21624': 'Claiborne,MD',
'21625': 'Cordova,MD',
'21626': 'Crapo,MD',
'21627': 'Crocheron,MD',
'21628': 'Crumpton,MD',
'21629': 'Denton,MD',
'21631': 'East New Market,MD',
'21632': 'Federalsburg,MD',
'21634': 'Fishing Creek,MD',
'21635': 'Galena,MD',
'21636': 'Goldsboro,MD',
'21638': 'Grasonville,MD',
'21639': 'Greensboro,MD',
'21640': 'Henderson,MD',
'21641': 'Hillsboro,MD',
'21643': 'Hurlock,MD',
'21644': 'Ingleside,MD',
'21645': 'Kennedyville,MD',
'21647': 'Mcdaniel,MD',
'21648': 'Madison,MD',
'21649': 'Marydel,MD',
'21650': 'Massey,MD',
'21651': 'Millington,MD',
'21652': 'Neavitt,MD',
'21653': 'Newcomb,MD',
'21654': 'Oxford,MD',
'21655': 'Preston,MD',
'21656': 'Price,MD',
'21657': 'Queen Anne,MD',
'21658': 'Queenstown,MD',
'21659': 'Rhodesdale,MD',
'21660': 'Ridgely,MD',
'21661': 'Rock Hall,MD',
'21662': 'Royal Oak,MD',
'21663': 'Saint Michaels,MD',
'21664': 'Secretary,MD',
'21665': 'Sherwood,MD',
'21666': 'Stevensville,MD',
'21667': 'Still Pond,MD',
'21668': 'Sudlersville,MD',
'21669': 'Taylors Island,MD',
'21670': 'Templeville,MD',
'21671': 'Tilghman,MD',
'21672': 'Toddville,MD',
'21673': 'Trappe,MD',
'21675': 'Wingate,MD',
'21676': 'Wittman,MD',
'21677': 'Woolford,MD',
'21678': 'Worton,MD',
'21679': 'Wye Mills,MD',
'21681': 'Ridgely,MD',
'21682': 'Ridgely,MD',
'21683': 'Ridgely,MD',
'21684': 'Ridgely,MD',
'21685': 'Ridgely,MD',
'21686': 'Ridgely,MD',
'21687': 'Ridgely,MD',
'21688': 'Ridgely,MD',
'21690': 'Chestertown,MD',
'21701': 'Frederick,MD',
'21702': 'Frederick,MD',
'21703': 'Frederick,MD',
'21704': 'Frederick,MD',
'21705': 'Frederick,MD',
'21709': 'Frederick,MD',
'21710': 'Adamstown,MD',
'21711': 'Big Pool,MD',
'21713': 'Boonsboro,MD',
'21714': 'Braddock Heights,MD',
'21715': 'Brownsville,MD',
'21716': 'Brunswick,MD',
'21717': 'Buckeystown,MD',
'21718': 'Burkittsville,MD',
'21719': 'Cascade,MD',
'21720': 'Cavetown,MD',
'21721': 'Chewsville,MD',
'21722': 'Clear Spring,MD',
'21723': 'Cooksville,MD',
'21727': 'Emmitsburg,MD',
'21733': 'Fairplay,MD',
'21734': 'Funkstown,MD',
'21736': 'Gapland,MD',
'21737': 'Glenelg,MD',
'21738': 'Glenwood,MD',
'21740': 'Hagerstown,MD',
'21741': 'Hagerstown,MD',
'21742': 'Hagerstown,MD',
'21746': 'Hagerstown,MD',
'21747': 'Hagerstown,MD',
'21748': 'Hagerstown,MD',
'21749': 'Hagerstown,MD',
'21750': 'Hancock,MD',
'21754': 'Ijamsville,MD',
'21755': 'Jefferson,MD',
'21756': 'Keedysville,MD',
'21757': 'Keymar,MD',
'21758': 'Knoxville,MD',
'21759': 'Ladiesburg,MD',
'21762': 'Libertytown,MD',
'21764': 'Linwood,MD',
'21765': 'Lisbon,MD',
'21766': 'Little Orleans,MD',
'21767': 'Maugansville,MD',
'21769': 'Middletown,MD',
'21770': 'Monrovia,MD',
'21771': 'Mount Airy,MD',
'21773': 'Myersville,MD',
'21774': 'New Market,MD',
'21775': 'New Midway,MD',
'21776': 'New Windsor,MD',
'21777': 'Point Of Rocks,MD',
'21778': 'Rocky Ridge,MD',
'21779': 'Rohrersville,MD',
'21780': 'Sabillasville,MD',
'21781': 'Saint James,MD',
'21782': 'Sharpsburg,MD',
'21783': 'Smithsburg,MD',
'21784': 'Sykesville,MD',
'21787': 'Taneytown,MD',
'21788': 'Thurmont,MD',
'21790': 'Tuscarora,MD',
'21791': 'Union Bridge,MD',
'21792': 'Unionville,MD',
'21793': 'Walkersville,MD',
'21794': 'West Friendship,MD',
'21795': 'Williamsport,MD',
'21797': 'Woodbine,MD',
'21798': 'Woodsboro,MD',
'21801': 'Salisbury,MD',
'21802': 'Salisbury,MD',
'21803': 'Salisbury,MD',
'21804': 'Salisbury,MD',
'21810': 'Allen,MD',
'21811': 'Berlin,MD',
'21813': 'Bishopville,MD',
'21814': 'Bivalve,MD',
'21817': 'Crisfield,MD',
'21821': 'Deal Island,MD',
'21822': 'Eden,MD',
'21824': 'Ewell,MD',
'21826': 'Fruitland,MD',
'21829': 'Girdletree,MD',
'21830': 'Hebron,MD',
'21835': 'Linkwood,MD',
'21836': 'Manokin,MD',
'21837': 'Mardela Springs,MD',
'21838': 'Marion Station,MD',
'21840': 'Nanticoke,MD',
'21841': 'Newark,MD',
'21842': 'Ocean City,MD',
'21843': 'Ocean City,MD',
'21849': 'Parsonsburg,MD',
'21850': 'Pittsville,MD',
'21851': 'Pocomoke City,MD',
'21852': 'Powellville,MD',
'21853': 'Princess Anne,MD',
'21856': 'Quantico,MD',
'21857': 'Rehobeth,MD',
'21861': 'Sharptown,MD',
'21862': 'Showell,MD',
'21863': 'Snow Hill,MD',
'21864': 'Stockton,MD',
'21865': 'Tyaskin,MD',
'21866': 'Tylerton,MD',
'21867': 'Upper Fairmount,MD',
'21869': 'Vienna,MD',
'21870': 'Wenona,MD',
'21871': 'Westover,MD',
'21872': 'Whaleyville,MD',
'21874': 'Willards,MD',
'21875': 'Delmar,MD',
'21890': 'Westover,MD',
'21901': 'North East,MD',
'21902': 'Perry Point,MD',
'21903': 'Perryville,MD',
'21904': 'Port Deposit,MD',
'21911': 'Rising Sun,MD',
'21912': 'Warwick,MD',
'21913': 'Cecilton,MD',
'21914': 'Charlestown,MD',
'21915': 'Chesapeake City,MD',
'21916': 'Childs,MD',
'21917': 'Colora,MD',
'21918': 'Conowingo,MD',
'21919': 'Earleville,MD',
'21920': 'Elk Mills,MD',
'21921': 'Elkton,MD',
'21922': 'Elkton,MD',
'21930': 'Georgetown,MD',
'22002': 'Amissville,VA',
'22003': 'Annandale,VA',
'22009': 'Burke,VA',
'22015': 'Burke,VA',
'22025': 'Delaplane,VA',
'22026': 'Dumfries,VA',
'22027': 'Dunn Loring,VA',
'22030': 'Fairfax,VA',
'22031': 'Fairfax,VA',
'22032': 'Fairfax,VA',
'22033': 'Fairfax,VA',
'22034': 'Fairfax,VA',
'22035': 'Fairfax,VA',
'22036': 'Fairfax,VA',
'22037': 'Fairfax,VA',
'22038': 'Fairfax,VA',
'22039': 'Fairfax Station,VA',
'22040': 'Falls Church,VA',
'22041': 'Falls Church,VA',
'22042': 'Falls Church,VA',
'22043': 'Falls Church,VA',
'22044': 'Falls Church,VA',
'22046': 'Falls Church,VA',
'22047': 'Falls Church,VA',
'22060': 'Fort Belvoir,VA',
'22066': 'Great Falls,VA',
'22067': 'Greenway,VA',
'22079': 'Lorton,VA',
'22081': 'Merrifield,VA',
'22082': 'Merrifield,VA',
'22092': 'Herndon,VA',
'22093': 'Ashburn,VA',
'22095': 'Herndon,VA',
'22096': 'Reston,VA',
'22101': 'Mc Lean,VA',
'22102': 'Mc Lean,VA',
'22103': 'West Mclean,VA',
'22106': 'Mc Lean,VA',
'22107': 'Mc Lean,VA',
'22108': 'Mc Lean,VA',
'22109': 'Mc Lean,VA',
'22116': 'Merrifield,VA',
'22118': 'Merrifield,VA',
'22119': 'Merrifield,VA',
'22120': 'Merrifield,VA',
'22121': 'Mount Vernon,VA',
'22122': 'Newington,VA',
'22124': 'Oakton,VA',
'22125': 'Occoquan,VA',
'22134': 'Quantico,VA',
'22135': 'Quantico,VA',
'22150': 'Springfield,VA',
'22151': 'Springfield,VA',
'22152': 'Springfield,VA',
'22153': 'Springfield,VA',
'22156': 'Springfield,VA',
'22158': 'Springfield,VA',
'22159': 'Springfield,VA',
'22160': 'Springfield,VA',
'22161': 'Springfield,VA',
'22172': 'Triangle,VA',
'22180': 'Vienna,VA',
'22181': 'Vienna,VA',
'22182': 'Vienna,VA',
'22183': 'Vienna,VA',
'22184': 'Vienna,VA',
'22185': 'Vienna,VA',
'22191': 'Woodbridge,VA',
'22192': 'Woodbridge,VA',
'22193': 'Woodbridge,VA',
'22194': 'Woodbridge,VA',
'22195': 'Woodbridge,VA',
'22199': 'Lorton,VA',
'22201': 'Arlington,VA',
'22202': 'Arlington,VA',
'22203': 'Arlington,VA',
'22204': 'Arlington,VA',
'22205': 'Arlington,VA',
'22206': 'Arlington,VA',
'22207': 'Arlington,VA',
'22209': 'Arlington,VA',
'22210': 'Arlington,VA',
'22211': 'Ft Myer,VA',
'22212': 'Arlington,VA',
'22213': 'Arlington,VA',
'22214': 'Arlington,VA',
'22215': 'Arlington,VA',
'22216': 'Arlington,VA',
'22217': 'Arlington,VA',
'22218': 'Arlington,VA',
'22219': 'Arlington,VA',
'22222': 'Arlington,VA',
'22223': 'Arlington,VA',
'22225': 'Arlington,VA',
'22226': 'Arlington,VA',
'22227': 'Arlington,VA',
'22229': 'Arlington,VA',
'22230': 'Arlington,VA',
'22234': 'Arlington,VA',
'22240': 'Arlington,VA',
'22241': 'Arlington,VA',
'22242': 'Arlington,VA',
'22243': 'Arlington,VA',
'22244': 'Arlington,VA',
'22245': 'Arlington,VA',
'22246': 'Arlington,VA',
'22301': 'Alexandria,VA',
'22302': 'Alexandria,VA',
'22303': 'Alexandria,VA',
'22304': 'Alexandria,VA',
'22305': 'Alexandria,VA',
'22306': 'Alexandria,VA',
'22307': 'Alexandria,VA',
'22308': 'Alexandria,VA',
'22309': 'Alexandria,VA',
'22310': 'Alexandria,VA',
'22311': 'Alexandria,VA',
'22312': 'Alexandria,VA',
'22313': 'Alexandria,VA',
'22314': 'Alexandria,VA',
'22315': 'Alexandria,VA',
'22320': 'Alexandria,VA',
'22321': 'Alexandria,VA',
'22331': 'Alexandria,VA',
'22332': 'Alexandria,VA',
'22333': 'Alexandria,VA',
'22334': 'Alexandria,VA',
'22336': 'Alexandria,VA',
'22401': 'Fredericksburg,VA',
'22402': 'Fredericksburg,VA',
'22403': 'Fredericksburg,VA',
'22404': 'Fredericksburg,VA',
'22405': 'Fredericksburg,VA',
'22406': 'Fredericksburg,VA',
'22407': 'Fredericksburg,VA',
'22408': 'Fredericksburg,VA',
'22412': 'Fredericksburg,VA',
'22427': 'Bowling Green,VA',
'22428': 'Bowling Green,VA',
'22430': 'Brooke,VA',
'22432': 'Burgess,VA',
'22433': 'Burr Hill,VA',
'22435': 'Callao,VA',
'22436': 'Caret,VA',
'22437': 'Center Cross,VA',
'22438': 'Champlain,VA',
'22442': 'Coles Point,VA',
'22443': 'Colonial Beach,VA',
'22446': 'Corbin,VA',
'22448': 'Dahlgren,VA',
'22451': 'Dogue,VA',
'22454': 'Dunnsville,VA',
'22456': 'Edwardsville,VA',
'22460': 'Farnham,VA',
'22463': 'Garrisonville,VA',
'22469': 'Hague,VA',
'22471': 'Hartwood,VA',
'22472': 'Haynesville,VA',
'22473': 'Heathsville,VA',
'22476': 'Hustle,VA',
'22480': 'Irvington,VA',
'22481': 'Jersey,VA',
'22482': 'Kilmarnock,VA',
'22485': 'King George,VA',
'22488': 'Kinsale,VA',
'22501': 'Ladysmith,VA',
'22503': 'Lancaster,VA',
'22504': 'Laneview,VA',
'22507': 'Lively,VA',
'22508': 'Locust Grove,VA',
'22509': 'Loretto,VA',
'22511': 'Lottsburg,VA',
'22513': 'Merry Point,VA',
'22514': 'Milford,VA',
'22517': 'Mollusk,VA',
'22520': 'Montross,VA',
'22523': 'Morattico,VA',
'22524': 'Mount Holly,VA',
'22526': 'Ninde,VA',
'22528': 'Nuttsville,VA',
'22529': 'Oldhams,VA',
'22530': 'Ophelia,VA',
'22534': 'Partlow,VA',
'22535': 'Port Royal,VA',
'22538': 'Rappahannock Academy,VA',
'22539': 'Reedville,VA',
'22542': 'Rhoadesville,VA',
'22544': 'Rollins Fork,VA',
'22545': 'Ruby,VA',
'22546': 'Ruther Glen,VA',
'22547': 'Sealston,VA',
'22548': 'Sharps,VA',
'22552': 'Sparta,VA',
'22553': 'Spotsylvania,VA',
'22554': 'Stafford,VA',
'22555': 'Stafford,VA',
'22558': 'Stratford,VA',
'22560': 'Tappahannock,VA',
'22565': 'Thornburg,VA',
'22567': 'Unionville,VA',
'22570': 'Village,VA',
'22572': 'Warsaw,VA',
'22576': 'Weems,VA',
'22577': 'Sandy Point,VA',
'22578': 'White Stone,VA',
'22579': 'Wicomico Church,VA',
'22580': 'Woodford,VA',
'22581': 'Zacata,VA',
'22601': 'Winchester,VA',
'22602': 'Winchester,VA',
'22603': 'Winchester,VA',
'22604': 'Winchester,VA',
'22610': 'Bentonville,VA',
'22611': 'Berryville,VA',
'22620': 'Boyce,VA',
'22622': 'Brucetown,VA',
'22623': 'Chester Gap,VA',
'22624': 'Clear Brook,VA',
'22625': 'Cross Junction,VA',
'22626': 'Fishers Hill,VA',
'22627': 'Flint Hill,VA',
'22630': 'Front Royal,VA',
'22637': 'Gore,VA',
'22638': 'Winchester,VA',
'22639': 'Hume,VA',
'22640': 'Huntly,VA',
'22641': 'Strasburg,VA',
'22642': 'Linden,VA',
'22643': 'Markham,VA',
'22644': 'Maurertown,VA',
'22645': 'Middletown,VA',
'22646': 'Millwood,VA',
'22649': 'Middletown,VA',
'22650': 'Rileyville,VA',
'22652': 'Fort Valley,VA',
'22654': 'Star Tannery,VA',
'22655': 'Stephens City,VA',
'22656': 'Stephenson,VA',
'22657': 'Strasburg,VA',
'22660': 'Toms Brook,VA',
'22663': 'White Post,VA',
'22664': 'Woodstock,VA',
'22701': 'Culpeper,VA',
'22709': 'Aroda,VA',
'22711': 'Banco,VA',
'22712': 'Bealeton,VA',
'22713': 'Boston,VA',
'22714': 'Brandy Station,VA',
'22715': 'Brightwood,VA',
'22716': 'Castleton,VA',
'22718': 'Elkwood,VA',
'22719': 'Etlan,VA',
'22720': 'Goldvein,VA',
'22721': 'Graves Mill,VA',
'22722': 'Haywood,VA',
'22723': 'Hood,VA',
'22724': 'Jeffersonton,VA',
'22725': 'Leon,VA',
'22726': 'Lignum,VA',
'22727': 'Madison,VA',
'22728': 'Midland,VA',
'22729': 'Mitchells,VA',
'22730': 'Oakpark,VA',
'22731': 'Pratts,VA',
'22732': 'Radiant,VA',
'22733': 'Rapidan,VA',
'22734': 'Remington,VA',
'22735': 'Reva,VA',
'22736': 'Richardsville,VA',
'22737': 'Rixeyville,VA',
'22738': 'Rochelle,VA',
'22739': 'Somerville,VA',
'22740': 'Sperryville,VA',
'22741': 'Stevensburg,VA',
'22742': 'Sumerduck,VA',
'22743': 'Syria,VA',
'22746': 'Viewtown,VA',
'22747': 'Washington,VA',
'22748': 'Wolftown,VA',
'22749': 'Woodville,VA',
'22801': 'Harrisonburg,VA',
'22802': 'Harrisonburg,VA',
'22803': 'Harrisonburg,VA',
'22807': 'Harrisonburg,VA',
'22810': 'Basye,VA',
'22811': 'Bergton,VA',
'22812': 'Bridgewater,VA',
'22815': 'Broadway,VA',
'22820': 'Criders,VA',
'22821': 'Dayton,VA',
'22824': 'Edinburg,VA',
'22827': 'Elkton,VA',
'22830': 'Fulks Run,VA',
'22831': 'Hinton,VA',
'22832': 'Keezletown,VA',
'22833': 'Lacey Spring,VA',
'22834': 'Linville,VA',
'22835': 'Luray,VA',
'22840': 'Mc Gaheysville,VA',
'22841': 'Mount Crawford,VA',
'22842': 'Mount Jackson,VA',
'22843': 'Mount Solon,VA',
'22844': 'New Market,VA',
'22845': 'Orkney Springs,VA',
'22846': 'Penn Laird,VA',
'22847': 'Quicksburg,VA',
'22848': 'Pleasant Valley,VA',
'22849': 'Shenandoah,VA',
'22850': 'Singers Glen,VA',
'22851': 'Stanley,VA',
'22853': 'Timberville,VA',
'22901': 'Charlottesville,VA',
'22902': 'Charlottesville,VA',
'22903': 'Charlottesville,VA',
'22904': 'Charlottesville,VA',
'22905': 'Charlottesville,VA',
'22906': 'Charlottesville,VA',
'22907': 'Charlottesville,VA',
'22908': 'Charlottesville,VA',
'22909': 'Charlottesville,VA',
'22910': 'Charlottesville,VA',
'22911': 'Charlottesville,VA',
'22920': 'Afton,VA',
'22922': 'Arrington,VA',
'22923': 'Barboursville,VA',
'22924': 'Batesville,VA',
'22931': 'Covesville,VA',
'22932': 'Crozet,VA',
'22935': 'Dyke,VA',
'22936': 'Earlysville,VA',
'22937': 'Esmont,VA',
'22938': 'Faber,VA',
'22939': 'Fishersville,VA',
'22940': 'Free Union,VA',
'22942': 'Gordonsville,VA',
'22943': 'Greenwood,VA',
'22945': 'Ivy,VA',
'22946': 'Keene,VA',
'22947': 'Keswick,VA',
'22948': 'Locust Dale,VA',
'22949': 'Lovingston,VA',
'22952': 'Lyndhurst,VA',
'22953': 'Madison Mills,VA',
'22954': 'Massies Mill,VA',
'22957': 'Montpelier Station,VA',
'22958': 'Nellysford,VA',
'22959': 'North Garden,VA',
'22960': 'Orange,VA',
'22963': 'Palmyra,VA',
'22964': 'Piney River,VA',
'22965': 'Quinque,VA',
'22967': 'Roseland,VA',
'22968': 'Ruckersville,VA',
'22969': 'Schuyler,VA',
'22971': 'Shipman,VA',
'22972': 'Somerset,VA',
'22973': 'Stanardsville,VA',
'22974': 'Troy,VA',
'22976': 'Tyro,VA',
'22980': 'Waynesboro,VA',
'22987': 'White Hall,VA',
'22989': 'Woodberry Forest,VA',
'23001': 'Achilles,VA',
'23002': 'Amelia Court House,VA',
'23003': 'Ark,VA',
'23004': 'Arvonia,VA',
'23005': 'Ashland,VA',
'23009': 'Aylett,VA',
'23011': 'Barhamsville,VA',
'23014': 'Beaumont,VA',
'23015': 'Beaverdam,VA',
'23017': 'Bellamy,VA',
'23018': 'Bena,VA',
'23021': 'Bohannon,VA',
'23022': 'Bremo Bluff,VA',
'23023': 'Bruington,VA',
'23024': 'Bumpass,VA',
'23025': 'Cardinal,VA',
'23027': 'Cartersville,VA',
'23030': 'Charles City,VA',
'23031': 'Christchurch,VA',
'23032': 'Church View,VA',
'23035': 'Cobbs Creek,VA',
'23038': 'Columbia,VA',
'23039': 'Crozier,VA',
'23040': 'Cumberland,VA',
'23043': 'Deltaville,VA',
'23045': 'Diggs,VA',
'23047': 'Doswell,VA',
'23050': 'Dutton,VA',
'23054': 'Fife,VA',
'23055': 'Fork Union,VA',
'23056': 'Foster,VA',
'23058': 'Glen Allen,VA',
'23059': 'Glen Allen,VA',
'23060': 'Glen Allen,VA',
'23061': 'Gloucester,VA',
'23062': 'Gloucester Point,VA',
'23063': 'Goochland,VA',
'23064': 'Grimstead,VA',
'23065': 'Gum Spring,VA',
'23066': 'Gwynn,VA',
'23067': 'Hadensville,VA',
'23068': 'Hallieford,VA',
'23069': 'Hanover,VA',
'23070': 'Hardyville,VA',
'23071': 'Hartfield,VA',
'23072': 'Hayes,VA',
'23075': 'Highland Springs,VA',
'23076': 'Hudgins,VA',
'23079': 'Jamaica,VA',
'23081': 'Jamestown,VA',
'23083': 'Jetersville,VA',
'23084': 'Kents Store,VA',
'23085': 'King And Queen Court Hous,VA',
'23086': 'King William,VA',
'23089': 'Lanexa,VA',
'23090': 'Lightfoot,VA',
'23091': 'Little Plymouth,VA',
'23092': 'Locust Hill,VA',
'23093': 'Louisa,VA',
'23101': 'Macon,VA',
'23102': 'Maidens,VA',
'23103': 'Manakin Sabot,VA',
'23105': 'Mannboro,VA',
'23106': 'Manquin,VA',
'23107': 'Maryus,VA',
'23108': 'Mascot,VA',
'23109': 'Mathews,VA',
'23110': 'Mattaponi,VA',
'23111': 'Mechanicsville,VA',
'23112': 'Midlothian,VA',
'23113': 'Midlothian,VA',
'23114': 'Midlothian,VA',
'23115': 'Millers Tavern,VA',
'23116': 'Mechanicsville,VA',
'23117': 'Mineral,VA',
'23119': 'Moon,VA',
'23120': 'Moseley,VA',
'23123': 'New Canton,VA',
'23124': 'New Kent,VA',
'23125': 'New Point,VA',
'23126': 'Newtown,VA',
'23127': 'Norge,VA',
'23128': 'North,VA',
'23129': 'Oilville,VA',
'23130': 'Onemo,VA',
'23131': 'Ordinary,VA',
'23138': 'Port Haywood,VA',
'23139': 'Powhatan,VA',
'23140': 'Providence Forge,VA',
'23141': 'Quinton,VA',
'23146': 'Rockville,VA',
'23147': 'Ruthville,VA',
'23148': 'Saint Stephens Church,VA',
'23149': 'Saluda,VA',
'23150': 'Sandston,VA',
'23153': 'Sandy Hook,VA',
'23154': 'Schley,VA',
'23155': 'Severn,VA',
'23156': 'Shacklefords,VA',
'23160': 'State Farm,VA',
'23161': 'Stevensville,VA',
'23162': 'Studley,VA',
'23163': 'Susan,VA',
'23168': 'Toano,VA',
'23169': 'Topping,VA',
'23170': 'Trevilians,VA',
'23173': 'University Of Richmond,VA',
'23175': 'Urbanna,VA',
'23176': 'Wake,VA',
'23177': 'Walkerton,VA',
'23178': 'Ware Neck,VA',
'23180': 'Water View,VA',
'23181': 'West Point,VA',
'23183': 'White Marsh,VA',
'23184': 'Wicomico,VA',
'23185': 'Williamsburg,VA',
'23186': 'Williamsburg,VA',
'23187': 'Williamsburg,VA',
'23188': 'Williamsburg,VA',
'23190': 'Woods Cross Roads,VA',
'23191': 'Zanoni,VA',
'23192': 'Montpelier,VA',
'23218': 'Richmond,VA',
'23219': 'Richmond,VA',
'23220': 'Richmond,VA',
'23221': 'Richmond,VA',
'23222': 'Richmond,VA',
'23223': 'Richmond,VA',
'23224': 'Richmond,VA',
'23225': 'Richmond,VA',
'23226': 'Richmond,VA',
'23227': 'Richmond,VA',
'23228': 'Richmond,VA',
'23229': 'Richmond,VA',
'23230': 'Richmond,VA',
'23231': 'Richmond,VA',
'23232': 'Richmond,VA',
'23233': 'Richmond,VA',
'23234': 'Richmond,VA',
'23235': 'Richmond,VA',
'23236': 'Richmond,VA',
'23237': 'Richmond,VA',
'23238': 'Richmond,VA',
'23240': 'Richmond,VA',
'23241': 'Richmond,VA',
'23242': 'Richmond,VA',
'23249': 'Richmond,VA',
'23250': 'Richmond,VA',
'23255': 'Richmond,VA',
'23260': 'Richmond,VA',
'23261': 'Richmond,VA',
'23266': 'Richmond,VA',
'23269': 'Richmond,VA',
'23270': 'Richmond,VA',
'23272': 'Richmond,VA',
'23273': 'Richmond,VA',
'23274': 'Richmond,VA',
'23275': 'Richmond,VA',
'23276': 'Richmond,VA',
'23278': 'Richmond,VA',
'23279': 'Richmond,VA',
'23280': 'Richmond,VA',
'23282': 'Richmond,VA',
'23284': 'Richmond,VA',
'23285': 'Richmond,VA',
'23286': 'Richmond,VA',
'23288': 'Richmond,VA',
'23289': 'Richmond,VA',
'23290': 'Richmond,VA',
'23291': 'Richmond,VA',
'23292': 'Richmond,VA',
'23293': 'Richmond,VA',
'23294': 'Richmond,VA',
'23295': 'Richmond,VA',
'23297': 'Richmond,VA',
'23298': 'Richmond,VA',
'23301': 'Accomac,VA',
'23302': 'Assawoman,VA',
'23303': 'Atlantic,VA',
'23304': 'Battery Park,VA',
'23306': 'Belle Haven,VA',
'23307': 'Birdsnest,VA',
'23308': 'Bloxom,VA',
'23310': 'Cape Charles,VA',
'23313': 'Capeville,VA',
'23314': 'Carrollton,VA',
'23315': 'Carrsville,VA',
'23316': 'Cheriton,VA',
'23320': 'Chesapeake,VA',
'23321': 'Chesapeake,VA',
'23322': 'Chesapeake,VA',
'23323': 'Chesapeake,VA',
'23324': 'Chesapeake,VA',
'23325': 'Chesapeake,VA',
'23326': 'Chesapeake,VA',
'23327': 'Chesapeake,VA',
'23328': 'Chesapeake,VA',
'23336': 'Chincoteague Island,VA',
'23337': 'Wallops Island,VA',
'23341': 'Craddockville,VA',
'23345': 'Davis Wharf,VA',
'23347': 'Eastville,VA',
'23350': 'Exmore,VA',
'23354': 'Franktown,VA',
'23356': 'Greenbackville,VA',
'23357': 'Greenbush,VA',
'23358': 'Hacksneck,VA',
'23359': 'Hallwood,VA',
'23389': 'Harborton,VA',
'23395': 'Horntown,VA',
'23396': 'Oak Hall,VA',
'23397': 'Isle Of Wight,VA',
'23398': 'Jamesville,VA',
'23399': 'Jenkins Bridge,VA',
'23401': 'Keller,VA',
'23404': 'Locustville,VA',
'23405': 'Machipongo,VA',
'23407': 'Mappsville,VA',
'23408': 'Marionville,VA',
'23409': 'Mears,VA',
'23410': 'Melfa,VA',
'23412': 'Modest Town,VA',
'23413': 'Nassawadox,VA',
'23414': 'Nelsonia,VA',
'23415': 'New Church,VA',
'23416': 'Oak Hall,VA',
'23417': 'Onancock,VA',
'23418': 'Onley,VA',
'23419': 'Oyster,VA',
'23420': 'Painter,VA',
'23421': 'Parksley,VA',
'23422': 'Pungoteague,VA',
'23423': 'Quinby,VA',
'23424': 'Rescue,VA',
'23426': 'Sanford,VA',
'23427': 'Saxis,VA',
'23429': 'Seaview,VA',
'23430': 'Smithfield,VA',
'23431': 'Smithfield,VA',
'23432': 'Suffolk,VA',
'23433': 'Suffolk,VA',
'23434': 'Suffolk,VA',
'23435': 'Suffolk,VA',
'23436': 'Suffolk,VA',
'23437': 'Suffolk,VA',
'23438': 'Suffolk,VA',
'23439': 'Suffolk,VA',
'23440': 'Tangier,VA',
'23441': 'Tasley,VA',
'23442': 'Temperanceville,VA',
'23443': 'Townsend,VA',
'23450': 'Virginia Beach,VA',
'23451': 'Virginia Beach,VA',
'23452': 'Virginia Beach,VA',
'23453': 'Virginia Beach,VA',
'23454': 'Virginia Beach,VA',
'23455': 'Virginia Beach,VA',
'23456': 'Virginia Beach,VA',
'23457': 'Virginia Beach,VA',
'23458': 'Virginia Beach,VA',
'23459': 'Virginia Beach,VA',
'23460': 'Virginia Beach,VA',
'23461': 'Virginia Beach,VA',
'23462': 'Virginia Beach,VA',
'23463': 'Virginia Beach,VA',
'23464': 'Virginia Beach,VA',
'23465': 'Virginia Beach,VA',
'23466': 'Virginia Beach,VA',
'23467': 'Virginia Beach,VA',
'23468': 'Virginia Beach,VA',
'23471': 'Virginia Beach,VA',
'23479': 'Virginia Beach,VA',
'23480': 'Wachapreague,VA',
'23482': 'Wardtown,VA',
'23483': 'Wattsville,VA',
'23486': 'Willis Wharf,VA',
'23487': 'Windsor,VA',
'23488': 'Withams,VA',
'23501': 'Norfolk,VA',
'23502': 'Norfolk,VA',
'23503': 'Norfolk,VA',
'23504': 'Norfolk,VA',
'23505': 'Norfolk,VA',
'23506': 'Norfolk,VA',
'23507': 'Norfolk,VA',
'23508': 'Norfolk,VA',
'23509': 'Norfolk,VA',
'23510': 'Norfolk,VA',
'23511': 'Norfolk,VA',
'23512': 'Norfolk,VA',
'23513': 'Norfolk,VA',
'23514': 'Norfolk,VA',
'23515': 'Norfolk,VA',
'23517': 'Norfolk,VA',
'23518': 'Norfolk,VA',
'23519': 'Norfolk,VA',
'23520': 'Norfolk,VA',
'23521': 'Norfolk,VA',
'23523': 'Norfolk,VA',
'23529': 'Norfolk,VA',
'23530': 'Norfolk,VA',
'23541': 'Norfolk,VA',
'23551': 'Norfolk,VA',
'23601': 'Newport News,VA',
'23602': 'Newport News,VA',
'23603': 'Newport News,VA',
'23604': 'Fort Eustis,VA',
'23605': 'Newport News,VA',
'23606': 'Newport News,VA',
'23607': 'Newport News,VA',
'23608': 'Newport News,VA',
'23609': 'Newport News,VA',
'23612': 'Newport News,VA',
'23628': 'Newport News,VA',
'23630': 'Hampton,VA',
'23631': 'Hampton,VA',
'23651': 'Fort Monroe,VA',
'23653': 'Hampton,VA',
'23661': 'Hampton,VA',
'23662': 'Poquoson,VA',
'23663': 'Hampton,VA',
'23664': 'Hampton,VA',
'23665': 'Hampton,VA',
'23666': 'Hampton,VA',
'23667': 'Hampton,VA',
'23668': 'Hampton,VA',
'23669': 'Hampton,VA',
'23670': 'Hampton,VA',
'23681': 'Hampton,VA',
'23690': 'Yorktown,VA',
'23691': 'Yorktown,VA',
'23692': 'Yorktown,VA',
'23693': 'Yorktown,VA',
'23694': 'Lackey,VA',
'23696': 'Seaford,VA',
'23701': 'Portsmouth,VA',
'23702': 'Portsmouth,VA',
'23703': 'Portsmouth,VA',
'23704': 'Portsmouth,VA',
'23705': 'Portsmouth,VA',
'23707': 'Portsmouth,VA',
'23708': 'Portsmouth,VA',
'23709': 'Portsmouth,VA',
'23801': 'Fort Lee,VA',
'23803': 'Petersburg,VA',
'23804': 'Petersburg,VA',
'23805': 'Petersburg,VA',
'23806': 'Petersburg,VA',
'23821': 'Alberta,VA',
'23822': 'Ammon,VA',
'23824': 'Blackstone,VA',
'23825': 'Blackstone,VA',
'23827': 'Boykins,VA',
'23828': 'Branchville,VA',
'23829': 'Capron,VA',
'23830': 'Carson,VA',
'23831': 'Chester,VA',
'23832': 'Chesterfield,VA',
'23833': 'Church Road,VA',
'23834': 'Colonial Heights,VA',
'23836': 'Chester,VA',
'23837': 'Courtland,VA',
'23838': 'Chesterfield,VA',
'23839': 'Dendron,VA',
'23840': 'Dewitt,VA',
'23841': 'Dinwiddie,VA',
'23842': 'Disputanta,VA',
'23843': 'Dolphin,VA',
'23844': 'Drewryville,VA',
'23845': 'Ebony,VA',
'23846': 'Elberon,VA',
'23847': 'Emporia,VA',
'23850': 'Ford,VA',
'23851': 'Franklin,VA',
'23856': 'Freeman,VA',
'23857': 'Gasburg,VA',
'23860': 'Hopewell,VA',
'23866': 'Ivor,VA',
'23867': 'Jarratt,VA',
'23868': 'Lawrenceville,VA',
'23870': 'Jarratt,VA',
'23872': 'Mc Kenney,VA',
'23873': 'Meredithville,VA',
'23874': 'Newsoms,VA',
'23875': 'Prince George,VA',
'23876': 'Rawlings,VA',
'23878': 'Sedley,VA',
'23879': 'Skippers,VA',
'23881': 'Spring Grove,VA',
'23882': 'Stony Creek,VA',
'23883': 'Surry,VA',
'23884': 'Sussex,VA',
'23885': 'Sutherland,VA',
'23887': 'Valentines,VA',
'23888': 'Wakefield,VA',
'23889': 'Warfield,VA',
'23890': 'Waverly,VA',
'23891': 'Waverly,VA',
'23893': 'White Plains,VA',
'23894': 'Wilsons,VA',
'23897': 'Yale,VA',
'23898': 'Zuni,VA',
'23899': 'Claremont,VA',
'23901': 'Farmville,VA',
'23909': 'Farmville,VA',
'23915': 'Baskerville,VA',
'23917': 'Boydton,VA',
'23919': 'Bracey,VA',
'23920': 'Brodnax,VA',
'23921': 'Buckingham,VA',
'23922': 'Burkeville,VA',
'23923': 'Charlotte Court House,VA',
'23924': 'Chase City,VA',
'23927': 'Clarksville,VA',
'23930': 'Crewe,VA',
'23934': 'Cullen,VA',
'23936': 'Dillwyn,VA',
'23937': 'Drakes Branch,VA',
'23938': 'Dundas,VA',
'23939': 'Evergreen,VA',
'23941': 'Fort Mitchell,VA',
'23942': 'Green Bay,VA',
'23943': 'Hampden Sydney,VA',
'23944': 'Kenbridge,VA',
'23947': 'Keysville,VA',
'23950': 'La Crosse,VA',
'23952': 'Lunenburg,VA',
'23954': 'Meherrin,VA',
'23955': 'Nottoway,VA',
'23958': 'Pamplin,VA',
'23959': 'Phenix,VA',
'23960': 'Prospect,VA',
'23962': 'Randolph,VA',
'23963': 'Red House,VA',
'23964': 'Red Oak,VA',
'23966': 'Rice,VA',
'23967': 'Saxe,VA',
'23968': 'Skipwith,VA',
'23970': 'South Hill,VA',
'23974': 'Victoria,VA',
'23976': 'Wylliesburg,VA',
'24001': 'Roanoke,VA',
'24002': 'Roanoke,VA',
'24003': 'Roanoke,VA',
'24004': 'Roanoke,VA',
'24005': 'Roanoke,VA',
'24006': 'Roanoke,VA',
'24007': 'Roanoke,VA',
'24008': 'Roanoke,VA',
'24009': 'Roanoke,VA',
'24010': 'Roanoke,VA',
'24011': 'Roanoke,VA',
'24012': 'Roanoke,VA',
'24013': 'Roanoke,VA',
'24014': 'Roanoke,VA',
'24015': 'Roanoke,VA',
'24016': 'Roanoke,VA',
'24017': 'Roanoke,VA',
'24018': 'Roanoke,VA',
'24019': 'Roanoke,VA',
'24020': 'Roanoke,VA',
'24022': 'Roanoke,VA',
'24023': 'Roanoke,VA',
'24024': 'Roanoke,VA',
'24025': 'Roanoke,VA',
'24026': 'Roanoke,VA',
'24027': 'Roanoke,VA',
'24028': 'Roanoke,VA',
'24029': 'Roanoke,VA',
'24030': 'Roanoke,VA',
'24031': 'Roanoke,VA',
'24032': 'Roanoke,VA',
'24033': 'Roanoke,VA',
'24034': 'Roanoke,VA',
'24035': 'Roanoke,VA',
'24036': 'Roanoke,VA',
'24037': 'Roanoke,VA',
'24038': 'Roanoke,VA',
'24040': 'Roanoke,VA',
'24042': 'Roanoke,VA',
'24043': 'Roanoke,VA',
'24044': 'Roanoke,VA',
'24045': 'Roanoke,VA',
'24048': 'Roanoke,VA',
'24050': 'Roanoke,VA',
'24053': 'Ararat,VA',
'24054': 'Axton,VA',
'24055': 'Bassett,VA',
'24058': 'Belspring,VA',
'24059': 'Bent Mountain,VA',
'24060': 'Blacksburg,VA',
'24061': 'Blacksburg,VA',
'24062': 'Blacksburg,VA',
'24063': 'Blacksburg,VA',
'24064': 'Blue Ridge,VA',
'24065': 'Boones Mill,VA',
'24066': 'Buchanan,VA',
'24067': 'Callaway,VA',
'24068': 'Christiansburg,VA',
'24069': 'Cascade,VA',
'24070': 'Catawba,VA',
'24072': 'Check,VA',
'24073': 'Christiansburg,VA',
'24076': 'Claudville,VA',
'24077': 'Cloverdale,VA',
'24078': 'Collinsville,VA',
'24079': 'Copper Hill,VA',
'24082': 'Critz,VA',
'24083': 'Daleville,VA',
'24084': 'Dublin,VA',
'24085': 'Eagle Rock,VA',
'24086': 'Eggleston,VA',
'24087': 'Elliston,VA',
'24088': 'Ferrum,VA',
'24089': 'Fieldale,VA',
'24090': 'Fincastle,VA',
'24091': 'Floyd,VA',
'24092': 'Glade Hill,VA',
'24093': 'Glen Lyn,VA',
'24094': 'Goldbond,VA',
'24095': 'Goodview,VA',
'24101': 'Hardy,VA',
'24102': 'Henry,VA',
'24104': 'Huddleston,VA',
'24105': 'Indian Valley,VA',
'24111': 'Mc Coy,VA',
'24112': 'Martinsville,VA',
'24113': 'Martinsville,VA',
'24114': 'Martinsville,VA',
'24115': 'Martinsville,VA',
'24120': 'Meadows Of Dan,VA',
'24121': 'Moneta,VA',
'24122': 'Montvale,VA',
'24124': 'Narrows,VA',
'24126': 'Newbern,VA',
'24127': 'New Castle,VA',
'24128': 'Newport,VA',
'24129': 'New River,VA',
'24130': 'Oriskany,VA',
'24131': 'Paint Bank,VA',
'24132': 'Parrott,VA',
'24133': 'Patrick Springs,VA',
'24134': 'Pearisburg,VA',
'24136': 'Pembroke,VA',
'24137': 'Penhook,VA',
'24138': 'Pilot,VA',
'24139': 'Pittsville,VA',
'24141': 'Radford,VA',
'24142': 'Radford,VA',
'24143': 'Radford,VA',
'24146': 'Redwood,VA',
'24147': 'Rich Creek,VA',
'24148': 'Ridgeway,VA',
'24149': 'Riner,VA',
'24150': 'Ripplemead,VA',
'24151': 'Rocky Mount,VA',
'24153': 'Salem,VA',
'24155': 'Salem,VA',
'24156': 'Salem,VA',
'24157': 'Salem,VA',
'24161': 'Sandy Level,VA',
'24162': 'Shawsville,VA',
'24165': 'Spencer,VA',
'24167': 'Staffordsville,VA',
'24168': 'Stanleytown,VA',
'24171': 'Stuart,VA',
'24174': 'Thaxton,VA',
'24175': 'Troutville,VA',
'24176': 'Union Hall,VA',
'24177': 'Vesta,VA',
'24178': 'Villamont,VA',
'24179': 'Vinton,VA',
'24184': 'Wirtz,VA',
'24185': 'Woolwine,VA',
'24201': 'Bristol,VA',
'24202': 'Bristol,VA',
'24203': 'Bristol,VA',
'24205': 'Bristol Merchandise Return,VA',
'24209': 'Bristol,VA',
'24210': 'Abingdon,VA',
'24211': 'Abingdon,VA',
'24212': 'Abingdon,VA',
'24215': 'Andover,VA',
'24216': 'Appalachia,VA',
'24217': 'Bee,VA',
'24218': 'Ben Hur,VA',
'24219': 'Big Stone Gap,VA',
'24220': 'Birchleaf,VA',
'24221': 'Blackwater,VA',
'24224': 'Castlewood,VA',
'24225': 'Cleveland,VA',
'24226': 'Clinchco,VA',
'24228': 'Clintwood,VA',
'24230': 'Coeburn,VA',
'24236': 'Damascus,VA',
'24237': 'Dante,VA',
'24239': 'Davenport,VA',
'24243': 'Dryden,VA',
'24244': 'Duffield,VA',
'24245': 'Dungannon,VA',
'24246': 'East Stone Gap,VA',
'24248': 'Ewing,VA',
'24250': 'Fort Blackmore,VA',
'24251': 'Gate City,VA',
'24256': 'Haysi,VA',
'24258': 'Hiltons,VA',
'24260': 'Honaker,VA',
'24263': 'Jonesville,VA',
'24265': 'Keokee,VA',
'24266': 'Lebanon,VA',
'24269': 'Mc Clure,VA',
'24270': 'Mendota,VA',
'24271': 'Nickelsville,VA',
'24272': 'Nora,VA',
'24273': 'Norton,VA',
'24277': 'Pennington Gap,VA',
'24279': 'Pound,VA',
'24280': 'Rosedale,VA',
'24281': 'Rose Hill,VA',
'24282': 'Saint Charles,VA',
'24283': 'Saint Paul,VA',
'24285': 'Stonega,VA',
'24289': 'Trammel,VA',
'24290': 'Weber City,VA',
'24292': 'Whitetop,VA',
'24293': 'Wise,VA',
'24301': 'Pulaski,VA',
'24311': 'Atkins,VA',
'24312': 'Austinville,VA',
'24313': 'Barren Springs,VA',
'24314': 'Bastian,VA',
'24315': 'Bland,VA',
'24316': 'Broadford,VA',
'24317': 'Cana,VA',
'24318': 'Ceres,VA',
'24319': 'Chilhowie,VA',
'24322': 'Cripple Creek,VA',
'24323': 'Crockett,VA',
'24324': 'Draper,VA',
'24325': 'Dugspur,VA',
'24326': 'Elk Creek,VA',
'24327': 'Emory,VA',
'24328': 'Fancy Gap,VA',
'24330': 'Fries,VA',
'24333': 'Galax,VA',
'24340': 'Glade Spring,VA',
'24343': 'Hillsville,VA',
'24347': 'Hiwassee,VA',
'24348': 'Independence,VA',
'24350': 'Ivanhoe,VA',
'24351': 'Lambsburg,VA',
'24352': 'Laurel Fork,VA',
'24354': 'Marion,VA',
'24360': 'Max Meadows,VA',
'24361': 'Meadowview,VA',
'24363': 'Mouth Of Wilson,VA',
'24366': 'Rocky Gap,VA',
'24368': 'Rural Retreat,VA',
'24370': 'Saltville,VA',
'24373': 'Seven Mile Ford,VA',
'24374': 'Speedwell,VA',
'24375': 'Sugar Grove,VA',
'24377': 'Tannersville,VA',
'24378': 'Trout Dale,VA',
'24379': 'Volney,VA',
'24380': 'Willis,VA',
'24381': 'Woodlawn,VA',
'24382': 'Wytheville,VA',
'24401': 'Staunton,VA',
'24402': 'Staunton,VA',
'24407': 'Staunton,VA',
'24411': 'Augusta Springs,VA',
'24412': 'Bacova,VA',
'24413': 'Blue Grass,VA',
'24415': 'Brownsburg,VA',
'24416': 'Buena Vista,VA',
'24421': 'Churchville,VA',
'24422': 'Clifton Forge,VA',
'24426': 'Covington,VA',
'24430': 'Craigsville,VA',
'24431': 'Crimora,VA',
'24432': 'Deerfield,VA',
'24433': 'Doe Hill,VA',
'24435': 'Fairfield,VA',
'24437': 'Fort Defiance,VA',
'24438': 'Glen Wilton,VA',
'24439': 'Goshen,VA',
'24440': 'Greenville,VA',
'24441': 'Grottoes,VA',
'24442': 'Head Waters,VA',
'24445': 'Hot Springs,VA',
'24448': 'Iron Gate,VA',
'24450': 'Lexington,VA',
'24457': 'Low Moor,VA',
'24458': 'Mc Dowell,VA',
'24459': 'Middlebrook,VA',
'24460': 'Millboro,VA',
'24463': 'Mint Spring,VA',
'24464': 'Montebello,VA',
'24465': 'Monterey,VA',
'24467': 'Mount Sidney,VA',
'24468': 'Mustoe,VA',
'24469': 'New Hope,VA',
'24471': 'Port Republic,VA',
'24472': 'Raphine,VA',
'24473': 'Rockbridge Baths,VA',
'24474': 'Selma,VA',
'24476': 'Steeles Tavern,VA',
'24477': 'Stuarts Draft,VA',
'24479': 'Swoope,VA',
'24482': 'Verona,VA',
'24483': 'Vesuvius,VA',
'24484': 'Warm Springs,VA',
'24485': 'West Augusta,VA',
'24486': 'Weyers Cave,VA',
'24487': 'Williamsville,VA',
'24501': 'Lynchburg,VA',
'24502': 'Lynchburg,VA',
'24503': 'Lynchburg,VA',
'24504': 'Lynchburg,VA',
'24505': 'Lynchburg,VA',
'24506': 'Lynchburg,VA',
'24512': 'Lynchburg,VA',
'24513': 'Lynchburg,VA',
'24514': 'Lynchburg,VA',
'24515': 'Lynchburg,VA',
'24517': 'Altavista,VA',
'24520': 'Alton,VA',
'24521': 'Amherst,VA',
'24522': 'Appomattox,VA',
'24523': 'Bedford,VA',
'24526': 'Big Island,VA',
'24527': 'Blairs,VA',
'24528': 'Brookneal,VA',
'24529': 'Buffalo Junction,VA',
'24530': 'Callands,VA',
'24531': 'Chatham,VA',
'24533': 'Clifford,VA',
'24534': 'Clover,VA',
'24535': 'Cluster Springs,VA',
'24536': 'Coleman Falls,VA',
'24538': 'Concord,VA',
'24539': 'Crystal Hill,VA',
'24540': 'Danville,VA',
'24541': 'Danville,VA',
'24543': 'Danville,VA',
'24544': 'Danville,VA',
'24549': 'Dry Fork,VA',
'24550': 'Evington,VA',
'24551': 'Forest,VA',
'24553': 'Gladstone,VA',
'24554': 'Gladys,VA',
'24555': 'Glasgow,VA',
'24556': 'Goode,VA',
'24557': 'Gretna,VA',
'24558': 'Halifax,VA',
'24562': 'Howardsville,VA',
'24563': 'Hurt,VA',
'24565': 'Java,VA',
'24566': 'Keeling,VA',
'24569': 'Long Island,VA',
'24570': 'Lowry,VA',
'24571': 'Lynch Station,VA',
'24572': 'Madison Heights,VA',
'24574': 'Monroe,VA',
'24576': 'Naruna,VA',
'24577': 'Nathalie,VA',
'24578': 'Natural Bridge,VA',
'24579': 'Natural Bridge Station,VA',
'24580': 'Nelson,VA',
'24581': 'Norwood,VA',
'24585': 'Republican Grove,VA',
'24586': 'Ringgold,VA',
'24588': 'Rustburg,VA',
'24589': 'Scottsburg,VA',
'24590': 'Scottsville,VA',
'24592': 'South Boston,VA',
'24593': 'Spout Spring,VA',
'24594': 'Sutherlin,VA',
'24595': 'Sweet Briar,VA',
'24597': 'Vernon Hill,VA',
'24598': 'Virgilina,VA',
'24599': 'Wingina,VA',
'24601': 'Amonate,VA',
'24602': 'Bandy,VA',
'24603': 'Big Rock,VA',
'24604': 'Bishop,VA',
'24605': 'Bluefield,VA',
'24606': 'Boissevain,VA',
'24607': 'Breaks,VA',
'24608': 'Burkes Garden,VA',
'24609': 'Cedar Bluff,VA',
'24612': 'Doran,VA',
'24613': 'Falls Mills,VA',
'24614': 'Grundy,VA',
'24618': 'Harman,VA',
'24619': 'Horsepen,VA',
'24620': 'Hurley,VA',
'24622': 'Jewell Ridge,VA',
'24624': 'Keen Mountain,VA',
'24627': 'Mavisdale,VA',
'24628': 'Maxie,VA',
'24630': 'North Tazewell,VA',
'24631': 'Oakwood,VA',
'24634': 'Pilgrims Knob,VA',
'24635': 'Pocahontas,VA',
'24637': 'Pounding Mill,VA',
'24639': 'Raven,VA',
'24640': 'Red Ash,VA',
'24641': 'Richlands,VA',
'24646': 'Rowe,VA',
'24647': 'Shortt Gap,VA',
'24649': 'Swords Creek,VA',
'24651': 'Tazewell,VA',
'24656': 'Vansant,VA',
'24657': 'Whitewood,VA',
'24658': 'Wolford,VA',
'24701': 'Bluefield,WV',
'24712': 'Athens,WV',
'24714': 'Beeson,WV',
'24715': 'Bramwell,WV',
'24716': 'Bud,WV',
'24719': 'Covel,WV',
'24724': 'Freeman,WV',
'24726': 'Herndon,WV',
'24729': 'Hiawatha,WV',
'24731': 'Kegley,WV',
'24732': 'Kellysville,WV',
'24733': 'Lashmeet,WV',
'24736': 'Matoaka,WV',
'24737': 'Montcalm,WV',
'24738': 'Nemours,WV',
'24739': 'Oakvale,WV',
'24740': 'Princeton,WV',
'24747': 'Rock,WV',
'24751': 'Wolfe,WV',
'24801': 'Welch,WV',
'24808': 'Anawalt,WV',
'24811': 'Avondale,WV',
'24813': 'Bartley,WV',
'24815': 'Berwind,WV',
'24816': 'Big Sandy,WV',
'24817': 'Bradshaw,WV',
'24818': 'Brenton,WV',
'24820': 'Capels,WV',
'24821': 'Caretta,WV',
'24822': 'Clear Fork,WV',
'24823': 'Coal Mountain,WV',
'24824': 'Coalwood,WV',
'24825': 'Crumpler,WV',
'24826': 'Cucumber,WV',
'24827': 'Cyclone,WV',
'24828': 'Davy,WV',
'24829': 'Eckman,WV',
'24830': 'Elbert,WV',
'24831': 'Elkhorn,WV',
'24832': 'English,WV',
'24834': 'Fanrock,WV',
'24836': 'Gary,WV',
'24839': 'Hanover,WV',
'24841': 'Havaco,WV',
'24842': 'Hemphill,WV',
'24843': 'Hensley,WV',
'24844': 'Iaeger,WV',
'24845': 'Ikes Fork,WV',
'24846': 'Isaban,WV',
'24847': 'Itmann,WV',
'24848': 'Jenkinjones,WV',
'24849': 'Jesse,WV',
'24850': 'Jolo,WV',
'24851': 'Justice,WV',
'24852': 'Keystone,WV',
'24853': 'Kimball,WV',
'24854': 'Kopperston,WV',
'24855': 'Kyle,WV',
'24856': 'Leckie,WV',
'24857': 'Lynco,WV',
'24859': 'Marianna,WV',
'24860': 'Matheny,WV',
'24861': 'Maybeury,WV',
'24862': 'Mohawk,WV',
'24866': 'Newhall,WV',
'24867': 'New Richmond,WV',
'24868': 'Northfork,WV',
'24869': 'North Spring,WV',
'24870': 'Oceana,WV',
'24871': 'Pageton,WV',
'24872': 'Panther,WV',
'24873': 'Paynesville,WV',
'24874': 'Pineville,WV',
'24877': 'Powhatan,WV',
'24878': 'Premier,WV',
'24879': 'Raysal,WV',
'24880': 'Rock View,WV',
'24881': 'Roderfield,WV',
'24882': 'Simon,WV',
'24883': 'Skygusty,WV',
'24884': 'Squire,WV',
'24887': 'Switchback,WV',
'24888': 'Thorpe,WV',
'24889': 'Twin Branch,WV',
'24892': 'War,WV',
'24894': 'Warriormine,WV',
'24895': 'Wilcoe,WV',
'24896': 'Wolf Pen,WV',
'24897': 'Worth,WV',
'24898': 'Wyoming,WV',
'24899': 'Yukon,WV',
'24901': 'Lewisburg,WV',
'24902': 'Fairlea,WV',
'24910': 'Alderson,WV',
'24915': 'Arbovale,WV',
'24916': 'Asbury,WV',
'24917': 'Auto,WV',
'24918': 'Ballard,WV',
'24919': 'Ballengee,WV',
'24920': 'Bartow,WV',
'24924': 'Buckeye,WV',
'24925': 'Caldwell,WV',
'24927': 'Cass,WV',
'24931': 'Crawley,WV',
'24934': 'Dunmore,WV',
'24935': 'Forest Hill,WV',
'24936': 'Fort Spring,WV',
'24938': 'Frankford,WV',
'24941': 'Gap Mills,WV',
'24942': 'Glace,WV',
'24943': 'Grassy Meadows,WV',
'24944': 'Green Bank,WV',
'24945': 'Greenville,WV',
'24946': 'Hillsboro,WV',
'24950': 'Kieffer,WV',
'24951': 'Lindside,WV',
'24954': 'Marlinton,WV',
'24957': 'Maxwelton,WV',
'24958': 'Meadow Bluff,WV',
'24961': 'Neola,WV',
'24962': 'Pence Springs,WV',
'24963': 'Peterstown,WV',
'24966': 'Renick,WV',
'24970': 'Ronceverte,WV',
'24974': 'Secondcreek,WV',
'24976': 'Sinks Grove,WV',
'24977': 'Smoot,WV',
'24981': 'Talcott,WV',
'24983': 'Union,WV',
'24984': 'Waiteville,WV',
'24985': 'Wayside,WV',
'24986': 'White Sulphur Springs,WV',
'24991': 'Williamsburg,WV',
'24993': 'Wolfcreek,WV',
'25002': 'Alloy,WV',
'25003': 'Alum Creek,WV',
'25004': 'Ameagle,WV',
'25005': 'Amma,WV',
'25007': 'Arnett,WV',
'25008': 'Artie,WV',
'25009': 'Ashford,WV',
'25010': 'Bald Knob,WV',
'25011': 'Bancroft,WV',
'25015': 'Belle,WV',
'25018': 'Bentree,WV',
'25019': 'Bickmore,WV',
'25021': 'Bim,WV',
'25022': 'Blair,WV',
'25024': 'Bloomingrose,WV',
'25025': 'Blount,WV',
'25026': 'Blue Creek,WV',
'25028': 'Bob White,WV',
'25030': 'Bomont,WV',
'25031': 'Boomer,WV',
'25033': 'Buffalo,WV',
'25035': 'Cabin Creek,WV',
'25036': 'Cannelton,WV',
'25039': 'Cedar Grove,WV',
'25040': 'Charlton Heights,WV',
'25043': 'Clay,WV',
'25044': 'Clear Creek,WV',
'25045': 'Clendenin,WV',
'25046': 'Clio,WV',
'25047': 'Clothier,WV',
'25048': 'Colcord,WV',
'25049': 'Comfort,WV',
'25051': 'Costa,WV',
'25053': 'Danville,WV',
'25054': 'Dawes,WV',
'25057': 'Deep Water,WV',
'25059': 'Dixie,WV',
'25060': 'Dorothy,WV',
'25061': 'Drybranch,WV',
'25062': 'Dry Creek,WV',
'25063': 'Duck,WV',
'25064': 'Dunbar,WV',
'25067': 'East Bank,WV',
'25070': 'Eleanor,WV',
'25071': 'Elkview,WV',
'25075': 'Eskdale,WV',
'25076': 'Ethel,WV',
'25079': 'Falling Rock,WV',
'25081': 'Foster,WV',
'25082': 'Fraziers Bottom,WV',
'25083': 'Gallagher,WV',
'25085': 'Gauley Bridge,WV',
'25086': 'Glasgow,WV',
'25088': 'Glen,WV',
'25090': 'Glen Ferris,WV',
'25093': 'Gordon,WV',
'25095': 'Grimms Landing,WV',
'25102': 'Handley,WV',
'25103': 'Hansford,WV',
'25106': 'Henderson,WV',
'25107': 'Hernshaw,WV',
'25108': 'Hewett,WV',
'25109': 'Hometown,WV',
'25110': 'Hugheston,WV',
'25111': 'Indore,WV',
'25112': 'Institute,WV',
'25113': 'Ivydale,WV',
'25114': 'Jeffrey,WV',
'25115': 'Kanawha Falls,WV',
'25118': 'Kimberly,WV',
'25119': 'Kincaid,WV',
'25121': 'Lake,WV',
'25122': 'Leewood,WV',
'25123': 'Leon,WV',
'25124': 'Liberty,WV',
'25125': 'Lizemores,WV',
'25126': 'London,WV',
'25130': 'Madison,WV',
'25132': 'Mammoth,WV',
'25133': 'Maysel,WV',
'25134': 'Miami,WV',
'25136': 'Montgomery,WV',
'25139': 'Mount Carbon,WV',
'25140': 'Naoma,WV',
'25141': 'Nebo,WV',
'25142': 'Nellis,WV',
'25143': 'Nitro,WV',
'25147': 'Ohley,WV',
'25148': 'Orgas,WV',
'25149': 'Ottawa,WV',
'25150': 'Ovapa,WV',
'25152': 'Page,WV',
'25154': 'Peytona,WV',
'25156': 'Pinch,WV',
'25159': 'Poca,WV',
'25160': 'Pond Gap,WV',
'25161': 'Powellton,WV',
'25162': 'Pratt,WV',
'25164': 'Procious,WV',
'25165': 'Racine,WV',
'25168': 'Red House,WV',
'25169': 'Ridgeview,WV',
'25173': 'Robson,WV',
'25174': 'Rock Creek,WV',
'25177': 'Saint Albans,WV',
'25180': 'Saxon,WV',
'25181': 'Seth,WV',
'25182': 'Sharon,WV',
'25183': 'Sharples,WV',
'25185': 'Mount Olive,WV',
'25186': 'Smithers,WV',
'25187': 'Southside,WV',
'25193': 'Sylvester,WV',
'25201': 'Tad,WV',
'25202': 'Tornado,WV',
'25203': 'Turtle Creek,WV',
'25204': 'Twilight,WV',
'25205': 'Uneeda,WV',
'25206': 'Van,WV',
'25208': 'Wharton,WV',
'25209': 'Whitesville,WV',
'25211': 'Widen,WV',
'25213': 'Winfield,WV',
'25214': 'Winifrede,WV',
'25231': 'Advent,WV',
'25234': 'Arnoldsburg,WV',
'25235': 'Chloe,WV',
'25239': 'Cottageville,WV',
'25241': 'Evans,WV',
'25243': 'Gandeeville,WV',
'25244': 'Gay,WV',
'25245': 'Given,WV',
'25247': 'Hartford,WV',
'25248': 'Kenna,WV',
'25250': 'Lakin,WV',
'25251': 'Left Hand,WV',
'25252': 'Le Roy,WV',
'25253': 'Letart,WV',
'25256': 'Linden,WV',
'25258': 'Lockney,WV',
'25259': 'Looneyville,WV',
'25260': 'Mason,WV',
'25261': 'Millstone,WV',
'25262': 'Millwood,WV',
'25264': 'Mount Alto,WV',
'25265': 'New Haven,WV',
'25266': 'Newton,WV',
'25267': 'Normantown,WV',
'25268': 'Orma,WV',
'25270': 'Reedy,WV',
'25271': 'Ripley,WV',
'25275': 'Sandyville,WV',
'25276': 'Spencer,WV',
'25279': 'Statts Mills,WV',
'25281': 'Tariff,WV',
'25283': 'Valley Fork,WV',
'25285': 'Wallback,WV',
'25286': 'Walton,WV',
'25287': 'West Columbia,WV',
'25301': 'Charleston,WV',
'25302': 'Charleston,WV',
'25303': 'Charleston,WV',
'25304': 'Charleston,WV',
'25305': 'Charleston,WV',
'25306': 'Charleston,WV',
'25309': 'Charleston,WV',
'25311': 'Charleston,WV',
'25312': 'Charleston,WV',
'25313': 'Charleston,WV',
'25314': 'Charleston,WV',
'25315': 'Charleston,WV',
'25317': 'Charleston,WV',
'25320': 'Charleston,WV',
'25321': 'Charleston,WV',
'25322': 'Charleston,WV',
'25323': 'Charleston,WV',
'25324': 'Charleston,WV',
'25325': 'Charleston,WV',
'25326': 'Charleston,WV',
'25327': 'Charleston,WV',
'25328': 'Charleston,WV',
'25329': 'Charleston,WV',
'25330': 'Charleston,WV',
'25331': 'Charleston,WV',
'25332': 'Charleston,WV',
'25333': 'Charleston,WV',
'25334': 'Charleston,WV',
'25335': 'Charleston,WV',
'25336': 'Charleston,WV',
'25337': 'Charleston,WV',
'25338': 'Charleston,WV',
'25339': 'Charleston,WV',
'25350': 'Charleston,WV',
'25356': 'Charleston,WV',
'25357': 'Charleston,WV',
'25358': 'Charleston,WV',
'25360': 'Charleston,WV',
'25361': 'Charleston,WV',
'25362': 'Charleston,WV',
'25364': 'Charleston,WV',
'25365': 'Charleston,WV',
'25375': 'Charleston,WV',
'25387': 'Charleston,WV',
'25389': 'Charleston,WV',
'25392': 'Charleston,WV',
'25396': 'Charleston,WV',
'25401': 'Martinsburg,WV',
'25402': 'Martinsburg,WV',
'25403': 'Martinsburg,WV',
'25404': 'Martinsburg,WV',
'25405': 'Martinsburg,WV',
'25410': 'Bakerton,WV',
'25411': 'Berkeley Springs,WV',
'25413': 'Bunker Hill,WV',
'25414': 'Charles Town,WV',
'25419': 'Falling Waters,WV',
'25420': 'Gerrardstown,WV',
'25421': 'Glengary,WV',
'25422': 'Great Cacapon,WV',
'25423': 'Halltown,WV',
'25425': 'Harpers Ferry,WV',
'25427': 'Hedgesville,WV',
'25428': 'Inwood,WV',
'25429': 'Kearneysville,WV',
'25430': 'Kearneysville,WV',
'25431': 'Levels,WV',
'25432': 'Millville,WV',
'25434': 'Paw Paw,WV',
'25437': 'Points,WV',
'25438': 'Ranson,WV',
'25440': 'Ridgeway,WV',
'25441': 'Rippon,WV',
'25442': 'Shenandoah Junction,WV',
'25443': 'Shepherdstown,WV',
'25444': 'Slanesville,WV',
'25446': 'Summit Point,WV',
'25501': 'Alkol,WV',
'25502': 'Apple Grove,WV',
'25503': 'Ashton,WV',
'25504': 'Barboursville,WV',
'25505': 'Big Creek,WV',
'25506': 'Branchland,WV',
'25507': 'Ceredo,WV',
'25508': 'Chapmanville,WV',
'25510': 'Culloden,WV',
'25511': 'Dunlow,WV',
'25512': 'East Lynn,WV',
'25514': 'Fort Gay,WV',
'25515': 'Gallipolis Ferry,WV',
'25517': 'Genoa,WV',
'25519': 'Glenhayes,WV',
'25520': 'Glenwood,WV',
'25521': 'Griffithsville,WV',
'25523': 'Hamlin,WV',
'25524': 'Harts,WV',
'25526': 'Hurricane,WV',
'25529': 'Julian,WV',
'25530': 'Kenova,WV',
'25534': 'Kiahsville,WV',
'25535': 'Lavalette,WV',
'25537': 'Lesage,WV',
'25540': 'Midkiff,WV',
'25541': 'Milton,WV',
'25544': 'Myra,WV',
'25545': 'Ona,WV',
'25547': 'Pecks Mill,WV',
'25550': 'Point Pleasant,WV',
'25555': 'Prichard,WV',
'25557': 'Ranger,WV',
'25559': 'Salt Rock,WV',
'25560': 'Scott Depot,WV',
'25562': 'Shoals,WV',
'25564': 'Sod,WV',
'25565': 'Spurlockville,WV',
'25567': 'Sumerco,WV',
'25569': 'Teays,WV',
'25570': 'Wayne,WV',
'25571': 'West Hamlin,WV',
'25572': 'Woodville,WV',
'25573': 'Yawkey,WV',
'25601': 'Logan,WV',
'25606': 'Accoville,WV',
'25607': 'Amherstdale,WV',
'25608': 'Baisden,WV',
'25611': 'Bruno,WV',
'25612': 'Chauncey,WV',
'25614': 'Cora,WV',
'25617': 'Davin,WV',
'25621': 'Gilbert,WV',
'25623': 'Hampden,WV',
'25624': 'Henlawson,WV',
'25625': 'Holden,WV',
'25628': 'Kistler,WV',
'25630': 'Lorado,WV',
'25632': 'Lyburn,WV',
'25634': 'Mallory,WV',
'25635': 'Man,WV',
'25636': 'Monaville,WV',
'25637': 'Mount Gay,WV',
'25638': 'Omar,WV',
'25639': 'Peach Creek,WV',
'25644': 'Sarah Ann,WV',
'25645': 'Stirrat,WV',
'25646': 'Stollings,WV',
'25647': 'Switzer,WV',
'25649': 'Verdunville,WV',
'25650': 'Verner,WV',
'25651': 'Wharncliffe,WV',
'25652': 'Whitman,WV',
'25653': 'Wilkinson,WV',
'25654': 'Yolyn,WV',
'25661': 'Williamson,WV',
'25665': 'Borderland,WV',
'25666': 'Breeden,WV',
'25667': 'Chattaroy,WV',
'25669': 'Crum,WV',
'25670': 'Delbarton,WV',
'25671': 'Dingess,WV',
'25672': 'Edgarton,WV',
'25674': 'Kermit,WV',
'25676': 'Lenore,WV',
'25678': 'Matewan,WV',
'25682': 'Meador,WV',
'25685': 'Naugatuck,WV',
'25686': 'Newtown,WV',
'25687': 'Nolan,WV',
'25688': 'North Matewan,WV',
'25690': 'Ragland,WV',
'25691': 'Rawl,WV',
'25692': 'Red Jacket,WV',
'25694': 'Thacker,WV',
'25696': 'Varney,WV',
'25697': 'Vulcan,WV',
'25699': 'Wilsondale,WV',
'25701': 'Huntington,WV',
'25702': 'Huntington,WV',
'25703': 'Huntington,WV',
'25704': 'Huntington,WV',
'25705': 'Huntington,WV',
'25706': 'Huntington,WV',
'25707': 'Huntington,WV',
'25708': 'Huntington,WV',
'25709': 'Huntington,WV',
'25710': 'Huntington,WV',
'25711': 'Huntington,WV',
'25712': 'Huntington,WV',
'25713': 'Huntington,WV',
'25714': 'Huntington,WV',
'25715': 'Huntington,WV',
'25716': 'Huntington,WV',
'25717': 'Huntington,WV',
'25718': 'Huntington,WV',
'25719': 'Huntington,WV',
'25720': 'Huntington,WV',
'25721': 'Huntington,WV',
'25722': 'Huntington,WV',
'25723': 'Huntington,WV',
'25724': 'Huntington,WV',
'25725': 'Huntington,WV',
'25726': 'Huntington,WV',
'25727': 'Huntington,WV',
'25728': 'Huntington,WV',
'25729': 'Huntington,WV',
'25755': 'Huntington,WV',
'25770': 'Huntington,WV',
'25771': 'Huntington,WV',
'25772': 'Huntington,WV',
'25773': 'Huntington,WV',
'25774': 'Huntington,WV',
'25775': 'Huntington,WV',
'25776': 'Huntington,WV',
'25777': 'Huntington,WV',
'25778': 'Huntington,WV',
'25779': 'Huntington,WV',
'25801': 'Beckley,WV',
'25802': 'Beckley,WV',
'25810': 'Allen Junction,WV',
'25811': 'Amigo,WV',
'25812': 'Ansted,WV',
'25813': 'Beaver,WV',
'25816': 'Blue Jay,WV',
'25817': 'Bolt,WV',
'25818': 'Bradley,WV',
'25820': 'Camp Creek,WV',
'25823': 'Coal City,WV',
'25825': 'Cool Ridge,WV',
'25826': 'Corinne,WV',
'25827': 'Crab Orchard,WV',
'25831': 'Danese,WV',
'25832': 'Daniels,WV',
'25833': 'Dothan,WV',
'25836': 'Eccles,WV',
'25837': 'Edmond,WV',
'25839': 'Fairdale,WV',
'25840': 'Fayetteville,WV',
'25841': 'Flat Top,WV',
'25843': 'Ghent,WV',
'25844': 'Glen Daniel,WV',
'25845': 'Glen Fork,WV',
'25846': 'Glen Jean,WV',
'25847': 'Glen Morgan,WV',
'25848': 'Glen Rogers,WV',
'25849': 'Glen White,WV',
'25851': 'Harper,WV',
'25853': 'Helen,WV',
'25854': 'Hico,WV',
'25855': 'Hilltop,WV',
'25856': 'Jonben,WV',
'25857': 'Josephine,WV',
'25859': 'Kilsyth,WV',
'25860': 'Lanark,WV',
'25862': 'Lansing,WV',
'25864': 'Layland,WV',
'25865': 'Lester,WV',
'25866': 'Lochgelly,WV',
'25868': 'Lookout,WV',
'25870': 'Maben,WV',
'25871': 'Mabscott,WV',
'25873': 'Mac Arthur,WV',
'25875': 'Mc Graws,WV',
'25876': 'Saulsville,WV',
'25878': 'Midway,WV',
'25879': 'Minden,WV',
'25880': 'Mount Hope,WV',
'25882': 'Mullens,WV',
'25901': 'Oak Hill,WV',
'25902': 'Odd,WV',
'25904': 'Pax,WV',
'25906': 'Piney View,WV',
'25907': 'Prince,WV',
'25908': 'Princewick,WV',
'25909': 'Prosperity,WV',
'25911': 'Raleigh,WV',
'25912': 'Ramsey,WV',
'25913': 'Ravencliff,WV',
'25914': 'Redstar,WV',
'25915': 'Rhodell,WV',
'25916': 'Sabine,WV',
'25917': 'Scarbro,WV',
'25918': 'Shady Spring,WV',
'25919': 'Skelton,WV',
'25920': 'Slab Fork,WV',
'25921': 'Sophia,WV',
'25922': 'Spanishburg,WV',
'25926': 'Sprague,WV',
'25927': 'Stanaford,WV',
'25928': 'Stephenson,WV',
'25931': 'Summerlee,WV',
'25932': 'Surveyor,WV',
'25934': 'Terry,WV',
'25936': 'Thurmond,WV',
'25938': 'Victor,WV',
'25942': 'Winona,WV',
'25943': 'Wyco,WV',
'25951': 'Hinton,WV',
'25958': 'Charmco,WV',
'25961': 'Crichton,WV',
'25962': 'Rainelle,WV',
'25965': 'Elton,WV',
'25966': 'Green Sulphur Springs,WV',
'25967': 'Hines,WV',
'25969': 'Jumping Branch,WV',
'25971': 'Lerona,WV',
'25972': 'Leslie,WV',
'25976': 'Meadow Bridge,WV',
'25977': 'Meadow Creek,WV',
'25978': 'Nimitz,WV',
'25979': 'Pipestem,WV',
'25981': 'Quinwood,WV',
'25984': 'Rupert,WV',
'25985': 'Sandstone,WV',
'25986': 'Spring Dale,WV',
'25988': 'True,WV',
'25989': 'White Oak,WV',
'26003': 'Wheeling,WV',
'26030': 'Beech Bottom,WV',
'26031': 'Benwood,WV',
'26032': 'Bethany,WV',
'26033': 'Cameron,WV',
'26034': 'Chester,WV',
'26035': 'Colliers,WV',
'26036': 'Dallas,WV',
'26037': 'Follansbee,WV',
'26038': 'Glen Dale,WV',
'26039': 'Glen Easton,WV',
'26040': 'Mc Mechen,WV',
'26041': 'Moundsville,WV',
'26047': 'New Cumberland,WV',
'26050': 'Newell,WV',
'26055': 'Proctor,WV',
'26056': 'New Manchester,WV',
'26058': 'Short Creek,WV',
'26059': 'Triadelphia,WV',
'26060': 'Valley Grove,WV',
'26062': 'Weirton,WV',
'26070': 'Wellsburg,WV',
'26074': 'West Liberty,WV',
'26075': 'Windsor Heights,WV',
'26101': 'Parkersburg,WV',
'26102': 'Parkersburg,WV',
'26103': 'Parkersburg,WV',
'26104': 'Parkersburg,WV',
'26105': 'Vienna,WV',
'26106': 'Parkersburg,WV',
'26120': 'Mineral Wells,WV',
'26121': 'Mineral Wells,WV',
'26133': 'Belleville,WV',
'26134': 'Belmont,WV',
'26135': 'Bens Run,WV',
'26136': 'Big Bend,WV',
'26137': 'Big Springs,WV',
'26138': 'Brohard,WV',
'26141': 'Creston,WV',
'26142': 'Davisville,WV',
'26143': 'Elizabeth,WV',
'26146': 'Friendly,WV',
'26147': 'Grantsville,WV',
'26148': 'Macfarlan,WV',
'26149': 'Middlebourne,WV',
'26150': 'Mineral Wells,WV',
'26151': 'Mount Zion,WV',
'26152': 'Munday,WV',
'26155': 'New Martinsville,WV',
'26159': 'Paden City,WV',
'26160': 'Palestine,WV',
'26161': 'Petroleum,WV',
'26162': 'Porters Falls,WV',
'26164': 'Ravenswood,WV',
'26167': 'Reader,WV',
'26169': 'Rockport,WV',
'26170': 'Saint Marys,WV',
'26173': 'Sherman,WV',
'26175': 'Sistersville,WV',
'26178': 'Smithville,WV',
'26180': 'Walker,WV',
'26181': 'Washington,WV',
'26184': 'Waverly,WV',
'26186': 'Wileyville,WV',
'26187': 'Williamstown,WV',
'26201': 'Buckhannon,WV',
'26202': 'Fenwick,WV',
'26203': 'Erbacon,WV',
'26205': 'Craigsville,WV',
'26206': 'Cowen,WV',
'26208': 'Camden On Gauley,WV',
'26209': 'Snowshoe,WV',
'26210': 'Adrian,WV',
'26215': 'Cleveland,WV',
'26217': 'Diana,WV',
'26218': 'French Creek,WV',
'26219': 'Frenchton,WV',
'26222': 'Hacker Valley,WV',
'26224': 'Helvetia,WV',
'26228': 'Kanawha Head,WV',
'26229': 'Lorentz,WV',
'26230': 'Pickens,WV',
'26234': 'Rock Cave,WV',
'26236': 'Selbyville,WV',
'26237': 'Tallmansville,WV',
'26238': 'Volga,WV',
'26241': 'Elkins,WV',
'26250': 'Belington,WV',
'26253': 'Beverly,WV',
'26254': 'Bowden,WV',
'26257': 'Coalton,WV',
'26259': 'Dailey,WV',
'26260': 'Davis,WV',
'26261': 'Richwood,WV',
'26263': 'Dryfork,WV',
'26264': 'Durbin,WV',
'26266': 'Upperglade,WV',
'26267': 'Ellamore,WV',
'26268': 'Glady,WV',
'26269': 'Hambleton,WV',
'26270': 'Harman,WV',
'26271': 'Hendricks,WV',
'26273': 'Huttonsville,WV',
'26275': 'Junior,WV',
'26276': 'Kerens,WV',
'26278': 'Mabie,WV',
'26280': 'Mill Creek,WV',
'26282': 'Monterville,WV',
'26283': 'Montrose,WV',
'26285': 'Norton,WV',
'26287': 'Parsons,WV',
'26288': 'Webster Springs,WV',
'26289': 'Red Creek,WV',
'26291': 'Slatyfork,WV',
'26292': 'Thomas,WV',
'26293': 'Valley Bend,WV',
'26294': 'Valley Head,WV',
'26296': 'Whitmer,WV',
'26298': 'Bergoo,WV',
'26301': 'Clarksburg,WV',
'26302': 'Clarksburg,WV',
'26306': 'Clarksburg,WV',
'26320': 'Alma,WV',
'26321': 'Alum Bridge,WV',
'26323': 'Anmoore,WV',
'26325': 'Auburn,WV',
'26327': 'Berea,WV',
'26328': 'Blandville,WV',
'26330': 'Bridgeport,WV',
'26332': 'Bristol,WV',
'26334': 'Brownton,WV',
'26335': 'Burnsville,WV',
'26337': 'Cairo,WV',
'26338': 'Camden,WV',
'26339': 'Center Point,WV',
'26342': 'Coxs Mills,WV',
'26343': 'Crawford,WV',
'26346': 'Ellenboro,WV',
'26347': 'Flemington,WV',
'26348': 'Folsom,WV',
'26349': 'Galloway,WV',
'26350': 'Gilmer,WV',
'26351': 'Glenville,WV',
'26354': 'Grafton,WV',
'26361': 'Gypsy,WV',
'26362': 'Harrisville,WV',
'26366': 'Haywood,WV',
'26369': 'Hepzibah,WV',
'26372': 'Horner,WV',
'26374': 'Independence,WV',
'26375': 'Industrial,WV',
'26376': 'Ireland,WV',
'26377': 'Jacksonburg,WV',
'26378': 'Jane Lew,WV',
'26384': 'Linn,WV',
'26385': 'Lost Creek,WV',
'26386': 'Lumberport,WV',
'26404': 'Meadowbrook,WV',
'26405': 'Moatsville,WV',
'26407': 'Mountain,WV',
'26408': 'Mount Clare,WV',
'26410': 'Newburg,WV',
'26411': 'New Milton,WV',
'26412': 'Orlando,WV',
'26415': 'Pennsboro,WV',
'26416': 'Philippi,WV',
'26419': 'Pine Grove,WV',
'26421': 'Pullman,WV',
'26422': 'Reynoldsville,WV',
'26424': 'Rosemont,WV',
'26425': 'Rowlesburg,WV',
'26426': 'Salem,WV',
'26430': 'Sand Fork,WV',
'26431': 'Shinnston,WV',
'26434': 'Shirley,WV',
'26435': 'Simpson,WV',
'26436': 'Smithburg,WV',
'26437': 'Smithfield,WV',
'26438': 'Spelter,WV',
'26440': 'Thornton,WV',
'26443': 'Troy,WV',
'26444': 'Tunnelton,WV',
'26447': 'Walkersville,WV',
'26448': 'Wallace,WV',
'26451': 'West Milford,WV',
'26452': 'Weston,WV',
'26456': 'West Union,WV',
'26461': 'Wilsonburg,WV',
'26463': 'Wyatt,WV',
'26501': 'Morgantown,WV',
'26502': 'Morgantown,WV',
'26503': 'Morgantown,WV',
'26504': 'Morgantown,WV',
'26505': 'Morgantown,WV',
'26506': 'Morgantown,WV',
'26507': 'Morgantown,WV',
'26508': 'Morgantown,WV',
'26519': 'Albright,WV',
'26520': 'Arthurdale,WV',
'26521': 'Blacksville,WV',
'26522': 'Booth,WV',
'26524': 'Bretz,WV',
'26525': 'Bruceton Mills,WV',
'26527': 'Cassville,WV',
'26529': 'Core,WV',
'26531': 'Dellslow,WV',
'26533': 'Everettville,WV',
'26534': 'Granville,WV',
'26535': 'Hazelton,WV',
'26537': 'Kingwood,WV',
'26541': 'Maidsville,WV',
'26542': 'Masontown,WV',
'26543': 'Osage,WV',
'26544': 'Pentress,WV',
'26546': 'Pursglove,WV',
'26547': 'Reedsville,WV',
'26554': 'Fairmont,WV',
'26555': 'Fairmont,WV',
'26559': 'Barrackville,WV',
'26560': 'Baxter,WV',
'26561': 'Big Run,WV',
'26562': 'Burton,WV',
'26563': 'Carolina,WV',
'26566': 'Colfax,WV',
'26568': 'Enterprise,WV',
'26570': 'Fairview,WV',
'26571': 'Farmington,WV',
'26572': 'Four States,WV',
'26574': 'Grant Town,WV',
'26575': 'Hundred,WV',
'26576': 'Idamay,WV',
'26578': 'Kingmont,WV',
'26581': 'Littleton,WV',
'26582': 'Mannington,WV',
'26585': 'Metz,WV',
'26586': 'Montana Mines,WV',
'26587': 'Rachel,WV',
'26588': 'Rivesville,WV',
'26589': 'Wadestown,WV',
'26590': 'Wana,WV',
'26591': 'Worthington,WV',
'26601': 'Sutton,WV',
'26610': 'Birch River,WV',
'26611': 'Cedarville,WV',
'26612': 'Centralia,WV',
'26615': 'Copen,WV',
'26617': 'Dille,WV',
'26618': 'Elmira,WV',
'26619': 'Exchange,WV',
'26621': 'Flatwoods,WV',
'26623': 'Frametown,WV',
'26624': 'Gassaway,WV',
'26627': 'Heaters,WV',
'26629': 'Little Birch,WV',
'26631': 'Napier,WV',
'26634': 'Perkins,WV',
'26636': 'Rosedale,WV',
'26638': 'Shock,WV',
'26639': 'Strange Creek,WV',
'26641': 'Wilsie,WV',
'26651': 'Summersville,WV',
'26656': 'Belva,WV',
'26660': 'Calvin,WV',
'26662': 'Canvas,WV',
'26667': 'Drennen,WV',
'26671': 'Gilboa,WV',
'26674': 'Jodie,WV',
'26675': 'Keslers Cross Lanes,WV',
'26676': 'Leivasy,WV',
'26678': 'Mount Lookout,WV',
'26679': 'Mount Nebo,WV',
'26680': 'Nallen,WV',
'26681': 'Nettie,WV',
'26684': 'Pool,WV',
'26690': 'Swiss,WV',
'26691': 'Tioga,WV',
'26704': 'Augusta,WV',
'26705': 'Aurora,WV',
'26707': 'Bayard,WV',
'26710': 'Burlington,WV',
'26711': 'Capon Bridge,WV',
'26714': 'Delray,WV',
'26716': 'Eglon,WV',
'26717': 'Elk Garden,WV',
'26719': 'Fort Ashby,WV',
'26720': 'Gormania,WV',
'26722': 'Green Spring,WV',
'26726': 'Keyser,WV',
'26731': 'Lahmansville,WV',
'26734': 'Medley,WV',
'26739': 'Mount Storm,WV',
'26743': 'New Creek,WV',
'26750': 'Piedmont,WV',
'26753': 'Ridgeley,WV',
'26755': 'Rio,WV',
'26757': 'Romney,WV',
'26761': 'Shanks,WV',
'26763': 'Springfield,WV',
'26764': 'Terra Alta,WV',
'26767': 'Wiley Ford,WV',
'26801': 'Baker,WV',
'26802': 'Brandywine,WV',
'26804': 'Circleville,WV',
'26807': 'Franklin,WV',
'26808': 'High View,WV',
'26810': 'Lost City,WV',
'26812': 'Mathias,WV',
'26814': 'Riverton,WV',
'26815': 'Sugar Grove,WV',
'26817': 'Bloomery,WV',
'26818': 'Fisher,WV',
'26823': 'Capon Springs,WV',
'26824': 'Junction,WV',
'26833': 'Maysville,WV',
'26836': 'Moorefield,WV',
'26838': 'Milam,WV',
'26845': 'Old Fields,WV',
'26847': 'Petersburg,WV',
'26851': 'Wardensville,WV',
'26852': 'Purgitsville,WV',
'26855': 'Cabins,WV',
'26865': 'Yellow Spring,WV',
'26866': 'Upper Tract,WV',
'26884': 'Seneca Rocks,WV',
'26886': 'Onego,WV',
'27006': 'Advance,NC',
'27007': 'Ararat,NC',
'27009': 'Belews Creek,NC',
'27010': 'Bethania,NC',
'27011': 'Boonville,NC',
'27012': 'Clemmons,NC',
'27013': 'Cleveland,NC',
'27014': 'Cooleemee,NC',
'27016': 'Danbury,NC',
'27017': 'Dobson,NC',
'27018': 'East Bend,NC',
'27019': 'Germanton,NC',
'27020': 'Hamptonville,NC',
'27021': 'King,NC',
'27022': 'Lawsonville,NC',
'27023': 'Lewisville,NC',
'27024': 'Lowgap,NC',
'27025': 'Madison,NC',
'27027': 'Mayodan,NC',
'27028': 'Mocksville,NC',
'27030': 'Mount Airy,NC',
'27031': 'White Plains,NC',
'27040': 'Pfafftown,NC',
'27041': 'Pilot Mountain,NC',
'27042': 'Pine Hall,NC',
'27043': 'Pinnacle,NC',
'27045': 'Rural Hall,NC',
'27046': 'Sandy Ridge,NC',
'27047': 'Siloam,NC',
'27048': 'Stoneville,NC',
'27049': 'Toast,NC',
'27050': 'Tobaccoville,NC',
'27051': 'Walkertown,NC',
'27052': 'Walnut Cove,NC',
'27053': 'Westfield,NC',
'27054': 'Woodleaf,NC',
'27055': 'Yadkinville,NC',
'27094': 'Rural Hall,NC',
'27098': 'Rural Hall,NC',
'27099': 'Rural Hall,NC',
'27101': 'Winston Salem,NC',
'27102': 'Winston Salem,NC',
'27103': 'Winston Salem,NC',
'27104': 'Winston Salem,NC',
'27105': 'Winston Salem,NC',
'27106': 'Winston Salem,NC',
'27107': 'Winston Salem,NC',
'27108': 'Winston Salem,NC',
'27109': 'Winston Salem,NC',
'27110': 'Winston Salem,NC',
'27111': 'Winston Salem,NC',
'27113': 'Winston Salem,NC',
'27114': 'Winston Salem,NC',
'27115': 'Winston Salem,NC',
'27116': 'Winston Salem,NC',
'27117': 'Winston Salem,NC',
'27120': 'Winston Salem,NC',
'27127': 'Winston Salem,NC',
'27130': 'Winston Salem,NC',
'27150': 'Winston Salem,NC',
'27151': 'Winston Salem,NC',
'27152': 'Winston Salem,NC',
'27155': 'Winston Salem,NC',
'27156': 'Winston Salem,NC',
'27157': 'Winston Salem,NC',
'27198': 'Winston Salem,NC',
'27199': 'Winston Salem,NC',
'27201': 'Alamance,NC',
'27202': 'Altamahaw,NC',
'27203': 'Asheboro,NC',
'27204': 'Asheboro,NC',
'27205': 'Asheboro,NC',
'27207': 'Bear Creek,NC',
'27208': 'Bennett,NC',
'27209': 'Biscoe,NC',
'27212': 'Blanch,NC',
'27213': 'Bonlee,NC',
'27214': 'Browns Summit,NC',
'27215': 'Burlington,NC',
'27216': 'Burlington,NC',
'27217': 'Burlington,NC',
'27220': 'Burlington,NC',
'27228': 'Bynum,NC',
'27229': 'Candor,NC',
'27230': 'Cedar Falls,NC',
'27231': 'Cedar Grove,NC',
'27233': 'Climax,NC',
'27235': 'Colfax,NC',
'27237': 'Cumnock,NC',
'27239': 'Denton,NC',
'27242': 'Eagle Springs,NC',
'27243': 'Efland,NC',
'27244': 'Elon College,NC',
'27247': 'Ether,NC',
'27248': 'Franklinville,NC',
'27249': 'Gibsonville,NC',
'27252': 'Goldston,NC',
'27253': 'Graham,NC',
'27256': 'Gulf,NC',
'27258': 'Haw River,NC',
'27259': 'Highfalls,NC',
'27260': 'High Point,NC',
'27261': 'High Point,NC',
'27262': 'High Point,NC',
'27263': 'High Point,NC',
'27264': 'High Point,NC',
'27265': 'High Point,NC',
'27278': 'Hillsborough,NC',
'27281': 'Jackson Springs,NC',
'27282': 'Jamestown,NC',
'27283': 'Julian,NC',
'27284': 'Kernersville,NC',
'27285': 'Kernersville,NC',
'27288': 'Eden,NC',
'27289': 'Eden,NC',
'27291': 'Leasburg,NC',
'27292': 'Lexington,NC',
'27293': 'Lexington,NC',
'27294': 'Lexington,NC',
'27295': 'Lexington,NC',
'27298': 'Liberty,NC',
'27299': 'Linwood,NC',
'27301': 'Mc Leansville,NC',
'27302': 'Mebane,NC',
'27305': 'Milton,NC',
'27306': 'Mount Gilead,NC',
'27310': 'Oak Ridge,NC',
'27311': 'Pelham,NC',
'27312': 'Pittsboro,NC',
'27313': 'Pleasant Garden,NC',
'27314': 'Prospect Hill,NC',
'27315': 'Providence,NC',
'27316': 'Ramseur,NC',
'27317': 'Randleman,NC',
'27320': 'Reidsville,NC',
'27321': 'Reidsville,NC',
'27322': 'Reidsville,NC',
'27323': 'Reidsville,NC',
'27325': 'Robbins,NC',
'27326': 'Ruffin,NC',
'27330': 'Sanford,NC',
'27331': 'Sanford,NC',
'27332': 'Sanford,NC',
'27340': 'Saxapahaw,NC',
'27341': 'Seagrove,NC',
'27342': 'Sedalia,NC',
'27343': 'Semora,NC',
'27344': 'Siler City,NC',
'27349': 'Snow Camp,NC',
'27350': 'Sophia,NC',
'27351': 'Southmont,NC',
'27355': 'Staley,NC',
'27356': 'Star,NC',
'27357': 'Stokesdale,NC',
'27358': 'Summerfield,NC',
'27359': 'Swepsonville,NC',
'27360': 'Thomasville,NC',
'27361': 'Thomasville,NC',
'27370': 'Trinity,NC',
'27371': 'Troy,NC',
'27373': 'Wallburg,NC',
'27374': 'Welcome,NC',
'27375': 'Wentworth,NC',
'27376': 'West End,NC',
'27377': 'Whitsett,NC',
'27379': 'Yanceyville,NC',
'27395': 'Greensboro Bmc,NC',
'27401': 'Greensboro,NC',
'27402': 'Greensboro,NC',
'27403': 'Greensboro,NC',
'27404': 'Greensboro,NC',
'27405': 'Greensboro,NC',
'27406': 'Greensboro,NC',
'27407': 'Greensboro,NC',
'27408': 'Greensboro,NC',
'27409': 'Greensboro,NC',
'27410': 'Greensboro,NC',
'27411': 'Greensboro,NC',
'27412': 'Greensboro,NC',
'27413': 'Greensboro,NC',
'27415': 'Greensboro,NC',
'27416': 'Greensboro,NC',
'27417': 'Greensboro,NC',
'27419': 'Greensboro,NC',
'27420': 'Greensboro,NC',
'27425': 'Greensboro,NC',
'27427': 'Greensboro,NC',
'27429': 'Greensboro,NC',
'27435': 'Greensboro,NC',
'27438': 'Greensboro,NC',
'27455': 'Greensboro,NC',
'27480': 'Greensboro,NC',
'27495': 'Greensboro,NC',
'27497': 'Usps Hr Shared Svcs,NC',
'27498': 'Greensboro,NC',
'27499': 'Greensboro,NC',
'27501': 'Angier,NC',
'27502': 'Apex,NC',
'27503': 'Bahama,NC',
'27504': 'Benson,NC',
'27505': 'Broadway,NC',
'27506': 'Buies Creek,NC',
'27507': 'Bullock,NC',
'27508': 'Bunn,NC',
'27509': 'Butner,NC',
'27510': 'Carrboro,NC',
'27511': 'Cary,NC',
'27512': 'Cary,NC',
'27513': 'Cary,NC',
'27514': 'Chapel Hill,NC',
'27515': 'Chapel Hill,NC',
'27516': 'Chapel Hill,NC',
'27517': 'Chapel Hill,NC',
'27518': 'Cary,NC',
'27519': 'Cary,NC',
'27520': 'Clayton,NC',
'27521': 'Coats,NC',
'27522': 'Creedmoor,NC',
'27523': 'Apex,NC',
'27524': 'Four Oaks,NC',
'27525': 'Franklinton,NC',
'27526': 'Fuquay Varina,NC',
'27527': 'Clayton,NC',
'27528': 'Clayton,NC',
'27529': 'Garner,NC',
'27530': 'Goldsboro,NC',
'27531': 'Goldsboro,NC',
'27532': 'Goldsboro,NC',
'27533': 'Goldsboro,NC',
'27534': 'Goldsboro,NC',
'27536': 'Henderson,NC',
'27537': 'Henderson,NC',
'27539': 'Apex,NC',
'27540': 'Holly Springs,NC',
'27541': 'Hurdle Mills,NC',
'27542': 'Kenly,NC',
'27543': 'Kipling,NC',
'27544': 'Kittrell,NC',
'27545': 'Knightdale,NC',
'27546': 'Lillington,NC',
'27549': 'Louisburg,NC',
'27551': 'Macon,NC',
'27552': 'Mamers,NC',
'27553': 'Manson,NC',
'27555': 'Micro,NC',
'27556': 'Middleburg,NC',
'27557': 'Middlesex,NC',
'27559': 'Moncure,NC',
'27560': 'Morrisville,NC',
'27562': 'New Hill,NC',
'27563': 'Norlina,NC',
'27564': 'Creedmoor,NC',
'27565': 'Oxford,NC',
'27568': 'Pine Level,NC',
'27569': 'Princeton,NC',
'27570': 'Ridgeway,NC',
'27571': 'Rolesville,NC',
'27572': 'Rougemont,NC',
'27573': 'Roxboro,NC',
'27574': 'Roxboro,NC',
'27576': 'Selma,NC',
'27577': 'Smithfield,NC',
'27581': 'Stem,NC',
'27582': 'Stovall,NC',
'27583': 'Timberlake,NC',
'27584': 'Townsville,NC',
'27586': 'Vaughan,NC',
'27587': 'Wake Forest,NC',
'27588': 'Wake Forest,NC',
'27589': 'Warrenton,NC',
'27591': 'Wendell,NC',
'27592': 'Willow Spring,NC',
'27593': 'Wilsons Mills,NC',
'27594': 'Wise,NC',
'27596': 'Youngsville,NC',
'27597': 'Zebulon,NC',
'27599': 'Chapel Hill,NC',
'27601': 'Raleigh,NC',
'27602': 'Raleigh,NC',
'27603': 'Raleigh,NC',
'27604': 'Raleigh,NC',
'27605': 'Raleigh,NC',
'27606': 'Raleigh,NC',
'27607': 'Raleigh,NC',
'27608': 'Raleigh,NC',
'27609': 'Raleigh,NC',
'27610': 'Raleigh,NC',
'27611': 'Raleigh,NC',
'27612': 'Raleigh,NC',
'27613': 'Raleigh,NC',
'27614': 'Raleigh,NC',
'27615': 'Raleigh,NC',
'27616': 'Raleigh,NC',
'27617': 'Raleigh,NC',
'27619': 'Raleigh,NC',
'27620': 'Raleigh,NC',
'27621': 'Raleigh,NC',
'27622': 'Raleigh,NC',
'27623': 'Raleigh,NC',
'27624': 'Raleigh,NC',
'27625': 'Raleigh,NC',
'27626': 'Raleigh,NC',
'27627': 'Raleigh,NC',
'27628': 'Raleigh,NC',
'27629': 'Raleigh,NC',
'27634': 'Raleigh,NC',
'27635': 'Raleigh,NC',
'27636': 'Raleigh,NC',
'27640': 'Raleigh,NC',
'27650': 'Raleigh,NC',
'27656': 'Raleigh,NC',
'27658': 'Raleigh,NC',
'27661': 'Raleigh,NC',
'27668': 'Raleigh,NC',
'27675': 'Raleigh,NC',
'27676': 'Raleigh,NC',
'27690': 'Raleigh,NC',
'27695': 'Raleigh,NC',
'27697': 'Raleigh,NC',
'27698': 'Raleigh,NC',
'27699': 'Raleigh,NC',
'27701': 'Durham,NC',
'27702': 'Durham,NC',
'27703': 'Durham,NC',
'27704': 'Durham,NC',
'27705': 'Durham,NC',
'27706': 'Durham,NC',
'27707': 'Durham,NC',
'27708': 'Durham,NC',
'27709': 'Durham,NC',
'27710': 'Durham,NC',
'27711': 'Durham,NC',
'27712': 'Durham,NC',
'27713': 'Durham,NC',
'27715': 'Durham,NC',
'27717': 'Durham,NC',
'27722': 'Durham,NC',
'27801': 'Rocky Mount,NC',
'27802': 'Rocky Mount,NC',
'27803': 'Rocky Mount,NC',
'27804': 'Rocky Mount,NC',
'27805': 'Aulander,NC',
'27806': 'Aurora,NC',
'27807': 'Bailey,NC',
'27808': 'Bath,NC',
'27809': 'Battleboro,NC',
'27810': 'Belhaven,NC',
'27811': 'Bellarthur,NC',
'27812': 'Bethel,NC',
'27813': 'Black Creek,NC',
'27814': 'Blounts Creek,NC',
'27815': 'Rocky Mount,NC',
'27816': 'Castalia,NC',
'27817': 'Chocowinity,NC',
'27818': 'Como,NC',
'27819': 'Conetoe,NC',
'27820': 'Conway,NC',
'27821': 'Edward,NC',
'27822': 'Elm City,NC',
'27823': 'Enfield,NC',
'27824': 'Engelhard,NC',
'27825': 'Everetts,NC',
'27826': 'Fairfield,NC',
'27827': 'Falkland,NC',
'27828': 'Farmville,NC',
'27829': 'Fountain,NC',
'27830': 'Fremont,NC',
'27831': 'Garysburg,NC',
'27832': 'Gaston,NC',
'27833': 'Greenville,NC',
'27834': 'Greenville,NC',
'27835': 'Greenville,NC',
'27836': 'Greenville,NC',
'27837': 'Grimesland,NC',
'27838': 'Gumberry,NC',
'27839': 'Halifax,NC',
'27840': 'Hamilton,NC',
'27841': 'Hassell,NC',
'27842': 'Henrico,NC',
'27843': 'Hobgood,NC',
'27844': 'Hollister,NC',
'27845': 'Jackson,NC',
'27846': 'Jamesville,NC',
'27847': 'Kelford,NC',
'27849': 'Lewiston Woodville,NC',
'27850': 'Littleton,NC',
'27851': 'Lucama,NC',
'27852': 'Macclesfield,NC',
'27853': 'Margarettsville,NC',
'27854': 'Milwaukee,NC',
'27855': 'Murfreesboro,NC',
'27856': 'Nashville,NC',
'27857': 'Oak City,NC',
'27858': 'Greenville,NC',
'27860': 'Pantego,NC',
'27861': 'Parmele,NC',
'27862': 'Pendleton,NC',
'27863': 'Pikeville,NC',
'27864': 'Pinetops,NC',
'27865': 'Pinetown,NC',
'27866': 'Pleasant Hill,NC',
'27867': 'Potecasi,NC',
'27868': 'Red Oak,NC',
'27869': 'Rich Square,NC',
'27870': 'Roanoke Rapids,NC',
'27871': 'Robersonville,NC',
'27872': 'Roxobel,NC',
'27873': 'Saratoga,NC',
'27874': 'Scotland Neck,NC',
'27875': 'Scranton,NC',
'27876': 'Seaboard,NC',
'27877': 'Severn,NC',
'27878': 'Sharpsburg,NC',
'27879': 'Simpson,NC',
'27880': 'Sims,NC',
'27881': 'Speed,NC',
'27882': 'Spring Hope,NC',
'27883': 'Stantonsburg,NC',
'27884': 'Stokes,NC',
'27885': 'Swanquarter,NC',
'27886': 'Tarboro,NC',
'27887': 'Tillery,NC',
'27888': 'Walstonburg,NC',
'27889': 'Washington,NC',
'27890': 'Weldon,NC',
'27891': 'Whitakers,NC',
'27892': 'Williamston,NC',
'27893': 'Wilson,NC',
'27894': 'Wilson,NC',
'27895': 'Wilson,NC',
'27896': 'Wilson,NC',
'27897': 'Woodland,NC',
'27906': 'Elizabeth City,NC',
'27907': 'Elizabeth City,NC',
'27909': 'Elizabeth City,NC',
'27910': 'Ahoskie,NC',
'27915': 'Avon,NC',
'27916': 'Aydlett,NC',
'27917': 'Barco,NC',
'27919': 'Belvidere,NC',
'27920': 'Buxton,NC',
'27921': 'Camden,NC',
'27922': 'Cofield,NC',
'27923': 'Coinjock,NC',
'27924': 'Colerain,NC',
'27925': 'Columbia,NC',
'27926': 'Corapeake,NC',
'27927': 'Corolla,NC',
'27928': 'Creswell,NC',
'27929': 'Currituck,NC',
'27930': 'Durants Neck,NC',
'27932': 'Edenton,NC',
'27935': 'Eure,NC',
'27936': 'Frisco,NC',
'27937': 'Gates,NC',
'27938': 'Gatesville,NC',
'27939': 'Grandy,NC',
'27941': 'Harbinger,NC',
'27942': 'Harrellsville,NC',
'27943': 'Hatteras,NC',
'27944': 'Hertford,NC',
'27946': 'Hobbsville,NC',
'27947': 'Jarvisburg,NC',
'27948': 'Kill Devil Hills,NC',
'27949': 'Kitty Hawk,NC',
'27950': 'Knotts Island,NC',
'27953': 'Manns Harbor,NC',
'27954': 'Manteo,NC',
'27956': 'Maple,NC',
'27957': 'Merry Hill,NC',
'27958': 'Moyock,NC',
'27959': 'Nags Head,NC',
'27960': 'Ocracoke,NC',
'27962': 'Plymouth,NC',
'27964': 'Point Harbor,NC',
'27965': 'Poplar Branch,NC',
'27966': 'Powells Point,NC',
'27967': 'Powellsville,NC',
'27968': 'Rodanthe,NC',
'27969': 'Roduco,NC',
'27970': 'Roper,NC',
'27972': 'Salvo,NC',
'27973': 'Shawboro,NC',
'27974': 'Shiloh,NC',
'27976': 'South Mills,NC',
'27978': 'Stumpy Point,NC',
'27979': 'Sunbury,NC',
'27980': 'Tyner,NC',
'27981': 'Wanchese,NC',
'27982': 'Waves,NC',
'27983': 'Windsor,NC',
'27985': 'Winfall,NC',
'27986': 'Winton,NC',
'28001': 'Albemarle,NC',
'28002': 'Albemarle,NC',
'28006': 'Alexis,NC',
'28007': 'Ansonville,NC',
'28009': 'Badin,NC',
'28010': 'Barium Springs,NC',
'28012': 'Belmont,NC',
'28016': 'Bessemer City,NC',
'28017': 'Boiling Springs,NC',
'28018': 'Bostic,NC',
'28019': 'Caroleen,NC',
'28020': 'Casar,NC',
'28021': 'Cherryville,NC',
'28023': 'China Grove,NC',
'28024': 'Cliffside,NC',
'28025': 'Concord,NC',
'28026': 'Concord,NC',
'28027': 'Concord,NC',
'28031': 'Cornelius,NC',
'28032': 'Cramerton,NC',
'28033': 'Crouse,NC',
'28034': 'Dallas,NC',
'28035': 'Davidson College,NC',
'28036': 'Davidson,NC',
'28037': 'Denver,NC',
'28038': 'Earl,NC',
'28039': 'East Spencer,NC',
'28040': 'Ellenboro,NC',
'28041': 'Faith,NC',
'28042': 'Fallston,NC',
'28043': 'Forest City,NC',
'28052': 'Gastonia,NC',
'28053': 'Gastonia,NC',
'28054': 'Gastonia,NC',
'28055': 'Gastonia,NC',
'28056': 'Gastonia,NC',
'28070': 'Huntersville,NC',
'28071': 'Gold Hill,NC',
'28072': 'Granite Quarry,NC',
'28073': 'Grover,NC',
'28074': 'Harris,NC',
'28075': 'Harrisburg,NC',
'28076': 'Henrietta,NC',
'28077': 'High Shoals,NC',
'28078': 'Huntersville,NC',
'28079': 'Indian Trail,NC',
'28080': 'Iron Station,NC',
'28081': 'Kannapolis,NC',
'28082': 'Kannapolis,NC',
'28083': 'Kannapolis,NC',
'28086': 'Kings Mountain,NC',
'28088': 'Landis,NC',
'28089': 'Lattimore,NC',
'28090': 'Lawndale,NC',
'28091': 'Lilesville,NC',
'28092': 'Lincolnton,NC',
'28093': 'Lincolnton,NC',
'28097': 'Locust,NC',
'28098': 'Lowell,NC',
'28101': 'Mc Adenville,NC',
'28102': 'Mc Farlan,NC',
'28103': 'Marshville,NC',
'28104': 'Matthews,NC',
'28105': 'Matthews,NC',
'28106': 'Matthews,NC',
'28107': 'Midland,NC',
'28108': 'Mineral Springs,NC',
'28109': 'Misenheimer,NC',
'28110': 'Monroe,NC',
'28111': 'Monroe,NC',
'28112': 'Monroe,NC',
'28114': 'Mooresboro,NC',
'28115': 'Mooresville,NC',
'28117': 'Mooresville,NC',
'28119': 'Morven,NC',
'28120': 'Mount Holly,NC',
'28123': 'Mount Mourne,NC',
'28124': 'Mount Pleasant,NC',
'28125': 'Mount Ulla,NC',
'28126': 'Newell,NC',
'28127': 'New London,NC',
'28128': 'Norwood,NC',
'28129': 'Oakboro,NC',
'28130': 'Paw Creek,NC',
'28133': 'Peachland,NC',
'28134': 'Pineville,NC',
'28135': 'Polkton,NC',
'28136': 'Polkville,NC',
'28137': 'Richfield,NC',
'28138': 'Rockwell,NC',
'28139': 'Rutherfordton,NC',
'28144': 'Salisbury,NC',
'28145': 'Salisbury,NC',
'28146': 'Salisbury,NC',
'28147': 'Salisbury,NC',
'28150': 'Shelby,NC',
'28151': 'Shelby,NC',
'28152': 'Shelby,NC',
'28159': 'Spencer,NC',
'28160': 'Spindale,NC',
'28163': 'Stanfield,NC',
'28164': 'Stanley,NC',
'28166': 'Troutman,NC',
'28167': 'Union Mills,NC',
'28168': 'Vale,NC',
'28169': 'Waco,NC',
'28170': 'Wadesboro,NC',
'28173': 'Waxhaw,NC',
'28174': 'Wingate,NC',
'28201': 'Charlotte,NC',
'28202': 'Charlotte,NC',
'28203': 'Charlotte,NC',
'28204': 'Charlotte,NC',
'28205': 'Charlotte,NC',
'28206': 'Charlotte,NC',
'28207': 'Charlotte,NC',
'28208': 'Charlotte,NC',
'28209': 'Charlotte,NC',
'28210': 'Charlotte,NC',
'28211': 'Charlotte,NC',
'28212': 'Charlotte,NC',
'28213': 'Charlotte,NC',
'28214': 'Charlotte,NC',
'28215': 'Charlotte,NC',
'28216': 'Charlotte,NC',
'28217': 'Charlotte,NC',
'28218': 'Charlotte,NC',
'28219': 'Charlotte,NC',
'28220': 'Charlotte,NC',
'28221': 'Charlotte,NC',
'28222': 'Charlotte,NC',
'28223': 'Charlotte,NC',
'28224': 'Charlotte,NC',
'28225': 'Charlotte,NC',
'28226': 'Charlotte,NC',
'28227': 'Charlotte,NC',
'28228': 'Charlotte,NC',
'28229': 'Charlotte,NC',
'28230': 'Charlotte,NC',
'28231': 'Charlotte,NC',
'28232': 'Charlotte,NC',
'28233': 'Charlotte,NC',
'28234': 'Charlotte,NC',
'28235': 'Charlotte,NC',
'28236': 'Charlotte,NC',
'28237': 'Charlotte,NC',
'28240': 'Charlotte,NC',
'28241': 'Charlotte,NC',
'28242': 'Charlotte,NC',
'28243': 'Charlotte,NC',
'28244': 'Charlotte,NC',
'28246': 'Charlotte,NC',
'28247': 'Charlotte,NC',
'28250': 'Charlotte,NC',
'28253': 'Charlotte,NC',
'28254': 'Charlotte,NC',
'28255': 'Charlotte,NC',
'28256': 'Charlotte,NC',
'28258': 'Charlotte,NC',
'28260': 'Charlotte,NC',
'28261': 'Charlotte,NC',
'28262': 'Charlotte,NC',
'28263': 'First Citizens Bank,NC',
'28265': 'Charlotte,NC',
'28266': 'Charlotte,NC',
'28269': 'Charlotte,NC',
'28270': 'Charlotte,NC',
'28271': 'Charlotte,NC',
'28272': 'Charlotte,NC',
'28273': 'Charlotte,NC',
'28274': 'Charlotte,NC',
'28275': 'Charlotte,NC',
'28277': 'Charlotte,NC',
'28278': 'Charlotte,NC',
'28280': 'Charlotte,NC',
'28281': 'Charlotte,NC',
'28282': 'Charlotte,NC',
'28283': 'Charlotte,NC',
'28284': 'Charlotte,NC',
'28285': 'Charlotte,NC',
'28286': 'Charlotte,NC',
'28287': 'Charlotte,NC',
'28288': 'Charlotte,NC',
'28289': 'Charlotte,NC',
'28290': 'Charlotte,NC',
'28296': 'Charlotte,NC',
'28297': 'Charlotte,NC',
'28299': 'Charlotte,NC',
'28301': 'Fayetteville,NC',
'28302': 'Fayetteville,NC',
'28303': 'Fayetteville,NC',
'28304': 'Fayetteville,NC',
'28305': 'Fayetteville,NC',
'28306': 'Fayetteville,NC',
'28307': 'Fort Bragg,NC',
'28308': 'Pope A F B,NC',
'28309': 'Fayetteville,NC',
'28310': 'Fort Bragg,NC',
'28311': 'Fayetteville,NC',
'28312': 'Fayetteville,NC',
'28314': 'Fayetteville,NC',
'28315': 'Aberdeen,NC',
'28318': 'Autryville,NC',
'28319': 'Barnesville,NC',
'28320': 'Bladenboro,NC',
'28323': 'Bunnlevel,NC',
'28325': 'Calypso,NC',
'28326': 'Cameron,NC',
'28327': 'Carthage,NC',
'28328': 'Clinton,NC',
'28329': 'Clinton,NC',
'28330': 'Cordova,NC',
'28331': 'Cumberland,NC',
'28332': 'Dublin,NC',
'28333': 'Dudley,NC',
'28334': 'Dunn,NC',
'28335': 'Dunn,NC',
'28337': 'Elizabethtown,NC',
'28338': 'Ellerbe,NC',
'28339': 'Erwin,NC',
'28340': 'Fairmont,NC',
'28341': 'Faison,NC',
'28342': 'Falcon,NC',
'28343': 'Gibson,NC',
'28344': 'Godwin,NC',
'28345': 'Hamlet,NC',
'28347': 'Hoffman,NC',
'28348': 'Hope Mills,NC',
'28349': 'Kenansville,NC',
'28350': 'Lakeview,NC',
'28351': 'Laurel Hill,NC',
'28352': 'Laurinburg,NC',
'28353': 'Laurinburg,NC',
'28355': 'Lemon Springs,NC',
'28356': 'Linden,NC',
'28357': 'Lumber Bridge,NC',
'28358': 'Lumberton,NC',
'28359': 'Lumberton,NC',
'28360': 'Lumberton,NC',
'28361': 'Mccain,NC',
'28362': 'Marietta,NC',
'28363': 'Marston,NC',
'28364': 'Maxton,NC',
'28365': 'Mount Olive,NC',
'28366': 'Newton Grove,NC',
'28367': 'Norman,NC',
'28368': 'Olivia,NC',
'28369': 'Orrum,NC',
'28370': 'Pinehurst,NC',
'28371': 'Parkton,NC',
'28372': 'Pembroke,NC',
'28373': 'Pinebluff,NC',
'28374': 'Pinehurst,NC',
'28375': 'Proctorville,NC',
'28376': 'Raeford,NC',
'28377': 'Red Springs,NC',
'28378': 'Rex,NC',
'28379': 'Rockingham,NC',
'28380': 'Rockingham,NC',
'28382': 'Roseboro,NC',
'28383': 'Rowland,NC',
'28384': 'Saint Pauls,NC',
'28385': 'Salemburg,NC',
'28386': 'Shannon,NC',
'28387': 'Southern Pines,NC',
'28388': 'Southern Pines,NC',
'28390': 'Spring Lake,NC',
'28391': 'Stedman,NC',
'28392': 'Tar Heel,NC',
'28393': 'Turkey,NC',
'28394': 'Vass,NC',
'28395': 'Wade,NC',
'28396': 'Wagram,NC',
'28398': 'Warsaw,NC',
'28399': 'White Oak,NC',
'28401': 'Wilmington,NC',
'28402': 'Wilmington,NC',
'28403': 'Wilmington,NC',
'28404': 'Wilmington,NC',
'28405': 'Wilmington,NC',
'28406': 'Wilmington,NC',
'28407': 'Wilmington,NC',
'28408': 'Wilmington,NC',
'28409': 'Wilmington,NC',
'28410': 'Wilmington,NC',
'28411': 'Wilmington,NC',
'28412': 'Wilmington,NC',
'28420': 'Ash,NC',
'28421': 'Atkinson,NC',
'28422': 'Bolivia,NC',
'28423': 'Bolton,NC',
'28424': 'Brunswick,NC',
'28425': 'Burgaw,NC',
'28428': 'Carolina Beach,NC',
'28429': 'Castle Hayne,NC',
'28430': 'Cerro Gordo,NC',
'28431': 'Chadbourn,NC',
'28432': 'Clarendon,NC',
'28433': 'Clarkton,NC',
'28434': 'Council,NC',
'28435': 'Currie,NC',
'28436': 'Delco,NC',
'28438': 'Evergreen,NC',
'28439': 'Fair Bluff,NC',
'28441': 'Garland,NC',
'28442': 'Hallsboro,NC',
'28443': 'Hampstead,NC',
'28444': 'Harrells,NC',
'28445': 'Holly Ridge,NC',
'28446': 'Ingold,NC',
'28447': 'Ivanhoe,NC',
'28448': 'Kelly,NC',
'28449': 'Kure Beach,NC',
'28450': 'Lake Waccamaw,NC',
'28451': 'Leland,NC',
'28452': 'Longwood,NC',
'28453': 'Magnolia,NC',
'28454': 'Maple Hill,NC',
'28455': 'Nakina,NC',
'28456': 'Riegelwood,NC',
'28457': 'Rocky Point,NC',
'28458': 'Rose Hill,NC',
'28459': 'Shallotte,NC',
'28460': 'Sneads Ferry,NC',
'28461': 'Southport,NC',
'28462': 'Supply,NC',
'28463': 'Tabor City,NC',
'28464': 'Teachey,NC',
'28465': 'Oak Island,NC',
'28466': 'Wallace,NC',
'28467': 'Calabash,NC',
'28468': 'Sunset Beach,NC',
'28469': 'Ocean Isle Beach,NC',
'28470': 'Shallotte,NC',
'28471': 'Watha,NC',
'28472': 'Whiteville,NC',
'28478': 'Willard,NC',
'28479': 'Winnabow,NC',
'28480': 'Wrightsville Beach,NC',
'28501': 'Kinston,NC',
'28502': 'Kinston,NC',
'28503': 'Kinston,NC',
'28504': 'Kinston,NC',
'28508': 'Albertson,NC',
'28509': 'Alliance,NC',
'28510': 'Arapahoe,NC',
'28511': 'Atlantic,NC',
'28512': 'Atlantic Beach,NC',
'28513': 'Ayden,NC',
'28515': 'Bayboro,NC',
'28516': 'Beaufort,NC',
'28518': 'Beulaville,NC',
'28519': 'Bridgeton,NC',
'28520': 'Cedar Island,NC',
'28521': 'Chinquapin,NC',
'28522': 'Comfort,NC',
'28523': 'Cove City,NC',
'28524': 'Davis,NC',
'28525': 'Deep Run,NC',
'28526': 'Dover,NC',
'28527': 'Ernul,NC',
'28528': 'Gloucester,NC',
'28529': 'Grantsboro,NC',
'28530': 'Grifton,NC',
'28531': 'Harkers Island,NC',
'28532': 'Havelock,NC',
'28533': 'Cherry Point,NC',
'28537': 'Hobucken,NC',
'28538': 'Hookerton,NC',
'28539': 'Hubert,NC',
'28540': 'Jacksonville,NC',
'28541': 'Jacksonville,NC',
'28542': 'Camp Lejeune,NC',
'28543': 'Tarawa Terrace,NC',
'28544': 'Midway Park,NC',
'28545': 'Mccutcheon Field,NC',
'28546': 'Jacksonville,NC',
'28547': 'Camp Lejeune,NC',
'28551': 'La Grange,NC',
'28552': 'Lowland,NC',
'28553': 'Marshallberg,NC',
'28554': 'Maury,NC',
'28555': 'Maysville,NC',
'28556': 'Merritt,NC',
'28557': 'Morehead City,NC',
'28560': 'New Bern,NC',
'28561': 'New Bern,NC',
'28562': 'New Bern,NC',
'28563': 'New Bern,NC',
'28564': 'New Bern,NC',
'28570': 'Newport,NC',
'28571': 'Oriental,NC',
'28572': 'Pink Hill,NC',
'28573': 'Pollocksville,NC',
'28574': 'Richlands,NC',
'28575': 'Salter Path,NC',
'28577': 'Sealevel,NC',
'28578': 'Seven Springs,NC',
'28579': 'Smyrna,NC',
'28580': 'Snow Hill,NC',
'28581': 'Stacy,NC',
'28582': 'Stella,NC',
'28583': 'Stonewall,NC',
'28584': 'Swansboro,NC',
'28585': 'Trenton,NC',
'28586': 'Vanceboro,NC',
'28587': 'Vandemere,NC',
'28589': 'Williston,NC',
'28590': 'Winterville,NC',
'28594': 'Emerald Isle,NC',
'28601': 'Hickory,NC',
'28602': 'Hickory,NC',
'28603': 'Hickory,NC',
'28604': 'Banner Elk,NC',
'28605': 'Blowing Rock,NC',
'28606': 'Boomer,NC',
'28607': 'Boone,NC',
'28608': 'Boone,NC',
'28609': 'Catawba,NC',
'28610': 'Claremont,NC',
'28611': 'Collettsville,NC',
'28612': 'Connellys Springs,NC',
'28613': 'Conover,NC',
'28615': 'Creston,NC',
'28616': 'Crossnore,NC',
'28617': 'Crumpler,NC',
'28618': 'Deep Gap,NC',
'28619': 'Drexel,NC',
'28621': 'Elkin,NC',
'28622': 'Elk Park,NC',
'28623': 'Ennice,NC',
'28624': 'Ferguson,NC',
'28625': 'Statesville,NC',
'28626': 'Fleetwood,NC',
'28627': 'Glade Valley,NC',
'28628': 'Glen Alpine,NC',
'28629': 'Glendale Springs,NC',
'28630': 'Granite Falls,NC',
'28631': 'Grassy Creek,NC',
'28633': 'Lenoir,NC',
'28634': 'Harmony,NC',
'28635': 'Hays,NC',
'28636': 'Hiddenite,NC',
'28637': 'Hildebran,NC',
'28638': 'Hudson,NC',
'28640': 'Jefferson,NC',
'28641': 'Jonas Ridge,NC',
'28642': 'Jonesville,NC',
'28643': 'Lansing,NC',
'28644': 'Laurel Springs,NC',
'28645': 'Lenoir,NC',
'28646': 'Linville,NC',
'28647': 'Linville Falls,NC',
'28649': 'Mc Grady,NC',
'28650': 'Maiden,NC',
'28651': 'Millers Creek,NC',
'28652': 'Minneapolis,NC',
'28653': 'Montezuma,NC',
'28654': 'Moravian Falls,NC',
'28655': 'Morganton,NC',
'28656': 'North Wilkesboro,NC',
'28657': 'Newland,NC',
'28658': 'Newton,NC',
'28659': 'North Wilkesboro,NC',
'28660': 'Olin,NC',
'28661': 'Patterson,NC',
'28662': 'Pineola,NC',
'28663': 'Piney Creek,NC',
'28664': 'Plumtree,NC',
'28665': 'Purlear,NC',
'28666': 'Icard,NC',
'28667': 'Rhodhiss,NC',
'28668': 'Roaring Gap,NC',
'28669': 'Roaring River,NC',
'28670': 'Ronda,NC',
'28671': 'Rutherford College,NC',
'28672': 'Scottville,NC',
'28673': 'Sherrills Ford,NC',
'28674': 'North Wilkesboro,NC',
'28675': 'Sparta,NC',
'28676': 'State Road,NC',
'28677': 'Statesville,NC',
'28678': 'Stony Point,NC',
'28679': 'Sugar Grove,NC',
'28680': 'Morganton,NC',
'28681': 'Taylorsville,NC',
'28682': 'Terrell,NC',
'28683': 'Thurmond,NC',
'28684': 'Todd,NC',
'28685': 'Traphill,NC',
'28687': 'Statesville,NC',
'28688': 'Turnersburg,NC',
'28689': 'Union Grove,NC',
'28690': 'Valdese,NC',
'28691': 'Valle Crucis,NC',
'28692': 'Vilas,NC',
'28693': 'Warrensville,NC',
'28694': 'West Jefferson,NC',
'28697': 'Wilkesboro,NC',
'28698': 'Zionville,NC',
'28699': 'Scotts,NC',
'28701': 'Alexander,NC',
'28702': 'Almond,NC',
'28704': 'Arden,NC',
'28705': 'Bakersville,NC',
'28707': 'Balsam,NC',
'28708': 'Balsam Grove,NC',
'28709': 'Barnardsville,NC',
'28710': 'Bat Cave,NC',
'28711': 'Black Mountain,NC',
'28712': 'Brevard,NC',
'28713': 'Bryson City,NC',
'28714': 'Burnsville,NC',
'28715': 'Candler,NC',
'28716': 'Canton,NC',
'28717': 'Cashiers,NC',
'28718': 'Cedar Mountain,NC',
'28719': 'Cherokee,NC',
'28720': 'Chimney Rock,NC',
'28721': 'Clyde,NC',
'28722': 'Columbus,NC',
'28723': 'Cullowhee,NC',
'28724': 'Dana,NC',
'28725': 'Dillsboro,NC',
'28726': 'East Flat Rock,NC',
'28727': 'Edneyville,NC',
'28728': 'Enka,NC',
'28729': 'Etowah,NC',
'28730': 'Fairview,NC',
'28731': 'Flat Rock,NC',
'28732': 'Fletcher,NC',
'28733': 'Fontana Dam,NC',
'28734': 'Franklin,NC',
'28735': 'Gerton,NC',
'28736': 'Glenville,NC',
'28737': 'Glenwood,NC',
'28738': 'Hazelwood,NC',
'28739': 'Hendersonville,NC',
'28740': 'Green Mountain,NC',
'28741': 'Highlands,NC',
'28742': 'Horse Shoe,NC',
'28743': 'Hot Springs,NC',
'28744': 'Franklin,NC',
'28745': 'Lake Junaluska,NC',
'28746': 'Lake Lure,NC',
'28747': 'Lake Toxaway,NC',
'28748': 'Leicester,NC',
'28749': 'Little Switzerland,NC',
'28750': 'Lynn,NC',
'28751': 'Maggie Valley,NC',
'28752': 'Marion,NC',
'28753': 'Marshall,NC',
'28754': 'Mars Hill,NC',
'28755': 'Micaville,NC',
'28756': 'Mill Spring,NC',
'28757': 'Montreat,NC',
'28758': 'Mountain Home,NC',
'28759': 'Mills River,NC',
'28760': 'Naples,NC',
'28761': 'Nebo,NC',
'28762': 'Old Fort,NC',
'28763': 'Otto,NC',
'28765': 'Penland,NC',
'28766': 'Penrose,NC',
'28768': 'Pisgah Forest,NC',
'28770': 'Ridgecrest,NC',
'28771': 'Robbinsville,NC',
'28772': 'Rosman,NC',
'28773': 'Saluda,NC',
'28774': 'Sapphire,NC',
'28775': 'Scaly Mountain,NC',
'28776': 'Skyland,NC',
'28777': 'Spruce Pine,NC',
'28778': 'Swannanoa,NC',
'28779': 'Sylva,NC',
'28781': 'Topton,NC',
'28782': 'Tryon,NC',
'28783': 'Tuckasegee,NC',
'28784': 'Tuxedo,NC',
'28785': 'Waynesville,NC',
'28786': 'Waynesville,NC',
'28787': 'Weaverville,NC',
'28788': 'Webster,NC',
'28789': 'Whittier,NC',
'28790': 'Zirconia,NC',
'28791': 'Hendersonville,NC',
'28792': 'Hendersonville,NC',
'28793': 'Hendersonville,NC',
'28801': 'Asheville,NC',
'28802': 'Asheville,NC',
'28803': 'Asheville,NC',
'28804': 'Asheville,NC',
'28805': 'Asheville,NC',
'28806': 'Asheville,NC',
'28810': 'Asheville,NC',
'28813': 'Asheville,NC',
'28814': 'Asheville,NC',
'28815': 'Asheville,NC',
'28816': 'Asheville,NC',
'28901': 'Andrews,NC',
'28902': 'Brasstown,NC',
'28903': 'Culberson,NC',
'28904': 'Hayesville,NC',
'28905': 'Marble,NC',
'28906': 'Murphy,NC',
'28909': 'Warne,NC',
'29001': 'Alcolu,SC',
'29002': 'Ballentine,SC',
'29003': 'Bamberg,SC',
'29006': 'Batesburg,SC',
'29009': 'Bethune,SC',
'29010': 'Bishopville,SC',
'29014': 'Blackstock,SC',
'29015': 'Blair,SC',
'29016': 'Blythewood,SC',
'29018': 'Bowman,SC',
'29020': 'Camden,SC',
'29021': 'Shamokin,SC',
'29030': 'Cameron,SC',
'29031': 'Carlisle,SC',
'29032': 'Cassatt,SC',
'29033': 'Cayce,SC',
'29036': 'Chapin,SC',
'29037': 'Chappells,SC',
'29038': 'Cope,SC',
'29039': 'Cordova,SC',
'29040': 'Dalzell,SC',
'29041': 'Davis Station,SC',
'29042': 'Denmark,SC',
'29044': 'Eastover,SC',
'29045': 'Elgin,SC',
'29046': 'Elliott,SC',
'29047': 'Elloree,SC',
'29048': 'Eutawville,SC',
'29051': 'Gable,SC',
'29052': 'Gadsden,SC',
'29053': 'Gaston,SC',
'29054': 'Gilbert,SC',
'29055': 'Great Falls,SC',
'29056': 'Greeleyville,SC',
'29058': 'Heath Springs,SC',
'29059': 'Holly Hill,SC',
'29061': 'Hopkins,SC',
'29062': 'Horatio,SC',
'29063': 'Irmo,SC',
'29065': 'Jenkinsville,SC',
'29067': 'Kershaw,SC',
'29069': 'Lamar,SC',
'29070': 'Leesville,SC',
'29071': 'Lexington,SC',
'29072': 'Lexington,SC',
'29073': 'Lexington,SC',
'29074': 'Liberty Hill,SC',
'29075': 'Little Mountain,SC',
'29078': 'Lugoff,SC',
'29079': 'Lydia,SC',
'29080': 'Lynchburg,SC',
'29081': 'Ehrhardt,SC',
'29082': 'Lodge,SC',
'29101': 'Mc Bee,SC',
'29102': 'Manning,SC',
'29104': 'Mayesville,SC',
'29105': 'Monetta,SC',
'29106': 'Monticello,SC',
'29107': 'Neeses,SC',
'29108': 'Newberry,SC',
'29111': 'New Zion,SC',
'29112': 'North,SC',
'29113': 'Norway,SC',
'29114': 'Olanta,SC',
'29115': 'Orangeburg,SC',
'29116': 'Orangeburg,SC',
'29117': 'Orangeburg,SC',
'29118': 'Orangeburg,SC',
'29122': 'Peak,SC',
'29123': 'Pelion,SC',
'29125': 'Pinewood,SC',
'29126': 'Pomaria,SC',
'29127': 'Prosperity,SC',
'29128': 'Rembert,SC',
'29129': 'Ridge Spring,SC',
'29130': 'Ridgeway,SC',
'29132': 'Rion,SC',
'29133': 'Rowesville,SC',
'29135': 'Saint Matthews,SC',
'29137': 'Salley,SC',
'29138': 'Saluda,SC',
'29142': 'Santee,SC',
'29143': 'Sardinia,SC',
'29145': 'Silverstreet,SC',
'29146': 'Springfield,SC',
'29147': 'State Park,SC',
'29148': 'Summerton,SC',
'29150': 'Sumter,SC',
'29151': 'Sumter,SC',
'29152': 'Shaw A F B,SC',
'29153': 'Sumter,SC',
'29154': 'Sumter,SC',
'29160': 'Swansea,SC',
'29161': 'Timmonsville,SC',
'29162': 'Turbeville,SC',
'29163': 'Vance,SC',
'29164': 'Wagener,SC',
'29166': 'Ward,SC',
'29168': 'Wedgefield,SC',
'29169': 'West Columbia,SC',
'29170': 'West Columbia,SC',
'29171': 'West Columbia,SC',
'29172': 'West Columbia,SC',
'29175': 'Westville,SC',
'29176': 'White Oak,SC',
'29177': 'White Rock,SC',
'29178': 'Whitmire,SC',
'29180': 'Winnsboro,SC',
'29201': 'Columbia,SC',
'29202': 'Columbia,SC',
'29203': 'Columbia,SC',
'29204': 'Columbia,SC',
'29205': 'Columbia,SC',
'29206': 'Columbia,SC',
'29207': 'Columbia,SC',
'29208': 'Columbia,SC',
'29209': 'Columbia,SC',
'29210': 'Columbia,SC',
'29211': 'Columbia,SC',
'29212': 'Columbia,SC',
'29214': 'Columbia,SC',
'29215': 'Columbia,SC',
'29216': 'Columbia,SC',
'29217': 'Columbia,SC',
'29218': 'Columbia,SC',
'29219': 'Columbia,SC',
'29220': 'Columbia,SC',
'29221': 'Columbia,SC',
'29222': 'Columbia,SC',
'29223': 'Columbia,SC',
'29224': 'Columbia,SC',
'29225': 'Columbia,SC',
'29226': 'Columbia,SC',
'29227': 'Columbia,SC',
'29228': 'Columbia,SC',
'29229': 'Columbia,SC',
'29230': 'Columbia,SC',
'29240': 'Columbia,SC',
'29250': 'Columbia,SC',
'29260': 'Columbia,SC',
'29290': 'Columbia,SC',
'29292': 'Columbia,SC',
'29301': 'Spartanburg,SC',
'29302': 'Spartanburg,SC',
'29303': 'Spartanburg,SC',
'29304': 'Spartanburg,SC',
'29305': 'Spartanburg,SC',
'29306': 'Spartanburg,SC',
'29307': 'Spartanburg,SC',
'29316': 'Spartanburg,SC',
'29318': 'Spartanburg,SC',
'29319': 'Spartanburg,SC',
'29320': 'Arcadia,SC',
'29321': 'Buffalo,SC',
'29322': 'Campobello,SC',
'29323': 'Chesnee,SC',
'29324': 'Clifton,SC',
'29325': 'Clinton,SC',
'29329': 'Converse,SC',
'29330': 'Cowpens,SC',
'29331': 'Cross Anchor,SC',
'29332': 'Cross Hill,SC',
'29333': 'Drayton,SC',
'29334': 'Duncan,SC',
'29335': 'Enoree,SC',
'29336': 'Fairforest,SC',
'29338': 'Fingerville,SC',
'29340': 'Gaffney,SC',
'29341': 'Gaffney,SC',
'29342': 'Gaffney,SC',
'29346': 'Glendale,SC',
'29348': 'Gramling,SC',
'29349': 'Inman,SC',
'29351': 'Joanna,SC',
'29353': 'Jonesville,SC',
'29355': 'Kinards,SC',
'29356': 'Landrum,SC',
'29360': 'Laurens,SC',
'29364': 'Lockhart,SC',
'29365': 'Lyman,SC',
'29368': 'Mayo,SC',
'29369': 'Moore,SC',
'29370': 'Mountville,SC',
'29372': 'Pacolet,SC',
'29373': 'Pacolet Mills,SC',
'29374': 'Pauline,SC',
'29375': 'Reidville,SC',
'29376': 'Roebuck,SC',
'29377': 'Startex,SC',
'29378': 'Una,SC',
'29379': 'Union,SC',
'29384': 'Waterloo,SC',
'29385': 'Wellford,SC',
'29386': 'White Stone,SC',
'29388': 'Woodruff,SC',
'29390': 'Duncan,SC',
'29391': 'Duncan,SC',
'29395': 'Jonesville,SC',
'29401': 'Charleston,SC',
'29402': 'Charleston,SC',
'29403': 'Charleston,SC',
'29404': 'Charleston Afb,SC',
'29405': 'North Charleston,SC',
'29406': 'Charleston,SC',
'29407': 'Charleston,SC',
'29409': 'Charleston,SC',
'29410': 'North Charleston,SC',
'29412': 'Charleston,SC',
'29413': 'Charleston,SC',
'29414': 'Charleston,SC',
'29415': 'North Charleston,SC',
'29416': 'Charleston,SC',
'29417': 'Charleston,SC',
'29418': 'North Charleston,SC',
'29419': 'North Charleston,SC',
'29420': 'North Charleston,SC',
'29422': 'Charleston,SC',
'29423': 'Charleston,SC',
'29424': 'Charleston,SC',
'29425': 'Charleston,SC',
'29426': 'Adams Run,SC',
'29429': 'Awendaw,SC',
'29430': 'Bethera,SC',
'29431': 'Bonneau,SC',
'29432': 'Branchville,SC',
'29433': 'Canadys,SC',
'29434': 'Cordesville,SC',
'29435': 'Cottageville,SC',
'29436': 'Cross,SC',
'29437': 'Dorchester,SC',
'29438': 'Edisto Island,SC',
'29439': 'Folly Beach,SC',
'29440': 'Georgetown,SC',
'29442': 'Georgetown,SC',
'29445': 'Goose Creek,SC',
'29446': 'Green Pond,SC',
'29447': 'Grover,SC',
'29448': 'Harleyville,SC',
'29449': 'Hollywood,SC',
'29450': 'Huger,SC',
'29451': 'Isle Of Palms,SC',
'29452': 'Jacksonboro,SC',
'29453': 'Jamestown,SC',
'29455': 'Johns Island,SC',
'29456': 'Ladson,SC',
'29457': 'Johns Island,SC',
'29458': 'Mc Clellanville,SC',
'29461': 'Moncks Corner,SC',
'29464': 'Mount Pleasant,SC',
'29465': 'Mount Pleasant,SC',
'29466': 'Mount Pleasant,SC',
'29468': 'Pineville,SC',
'29469': 'Pinopolis,SC',
'29470': 'Ravenel,SC',
'29471': 'Reevesville,SC',
'29472': 'Ridgeville,SC',
'29474': 'Round O,SC',
'29475': 'Ruffin,SC',
'29476': 'Russellville,SC',
'29477': 'Saint George,SC',
'29479': 'Saint Stephen,SC',
'29481': 'Smoaks,SC',
'29482': 'Sullivans Island,SC',
'29483': 'Summerville,SC',
'29484': 'Summerville,SC',
'29485': 'Summerville,SC',
'29487': 'Wadmalaw Island,SC',
'29488': 'Walterboro,SC',
'29492': 'Charleston,SC',
'29493': 'Williams,SC',
'29501': 'Florence,SC',
'29502': 'Florence,SC',
'29503': 'Florence,SC',
'29504': 'Florence,SC',
'29505': 'Florence,SC',
'29506': 'Florence,SC',
'29510': 'Andrews,SC',
'29511': 'Aynor,SC',
'29512': 'Bennettsville,SC',
'29516': 'Blenheim,SC',
'29518': 'Cades,SC',
'29519': 'Centenary,SC',
'29520': 'Cheraw,SC',
'29525': 'Clio,SC',
'29526': 'Conway,SC',
'29527': 'Conway,SC',
'29528': 'Conway,SC',
'29530': 'Coward,SC',
'29532': 'Darlington,SC',
'29536': 'Dillon,SC',
'29540': 'Darlington,SC',
'29541': 'Effingham,SC',
'29542': 'Floyd Dale,SC',
'29543': 'Fork,SC',
'29544': 'Galivants Ferry,SC',
'29545': 'Green Sea,SC',
'29546': 'Gresham,SC',
'29547': 'Hamer,SC',
'29550': 'Hartsville,SC',
'29551': 'Hartsville,SC',
'29554': 'Hemingway,SC',
'29555': 'Johnsonville,SC',
'29556': 'Kingstree,SC',
'29560': 'Lake City,SC',
'29563': 'Lake View,SC',
'29564': 'Lane,SC',
'29565': 'Latta,SC',
'29566': 'Little River,SC',
'29567': 'Little Rock,SC',
'29568': 'Longs,SC',
'29569': 'Loris,SC',
'29570': 'Mc Coll,SC',
'29571': 'Marion,SC',
'29572': 'Myrtle Beach,SC',
'29573': 'Minturn,SC',
'29574': 'Mullins,SC',
'29575': 'Myrtle Beach,SC',
'29576': 'Murrells Inlet,SC',
'29577': 'Myrtle Beach,SC',
'29578': 'Myrtle Beach,SC',
'29579': 'Myrtle Beach,SC',
'29580': 'Nesmith,SC',
'29581': 'Nichols,SC',
'29582': 'North Myrtle Beach,SC',
'29583': 'Pamplico,SC',
'29584': 'Patrick,SC',
'29585': 'Pawleys Island,SC',
'29587': 'Myrtle Beach,SC',
'29588': 'Myrtle Beach,SC',
'29589': 'Rains,SC',
'29590': 'Salters,SC',
'29591': 'Scranton,SC',
'29592': 'Sellers,SC',
'29593': 'Society Hill,SC',
'29594': 'Tatum,SC',
'29596': 'Wallace,SC',
'29597': 'North Myrtle Beach,SC',
'29598': 'North Myrtle Beach,SC',
'29601': 'Greenville,SC',
'29602': 'Greenville,SC',
'29603': 'Greenville,SC',
'29604': 'Greenville,SC',
'29605': 'Greenville,SC',
'29606': 'Greenville,SC',
'29607': 'Greenville,SC',
'29608': 'Greenville,SC',
'29609': 'Greenville,SC',
'29610': 'Greenville,SC',
'29611': 'Greenville,SC',
'29612': 'Greenville,SC',
'29613': 'Greenville,SC',
'29614': 'Greenville,SC',
'29615': 'Greenville,SC',
'29616': 'Greenville,SC',
'29617': 'Greenville,SC',
'29620': 'Abbeville,SC',
'29621': 'Anderson,SC',
'29622': 'Anderson,SC',
'29623': 'Anderson,SC',
'29624': 'Anderson,SC',
'29625': 'Anderson,SC',
'29626': 'Anderson,SC',
'29627': 'Belton,SC',
'29628': 'Calhoun Falls,SC',
'29630': 'Central,SC',
'29631': 'Clemson,SC',
'29632': 'Clemson,SC',
'29633': 'Clemson,SC',
'29634': 'Clemson,SC',
'29635': 'Cleveland,SC',
'29636': 'Conestee,SC',
'29638': 'Donalds,SC',
'29639': 'Due West,SC',
'29640': 'Easley,SC',
'29641': 'Easley,SC',
'29642': 'Easley,SC',
'29643': 'Fair Play,SC',
'29644': 'Fountain Inn,SC',
'29645': 'Gray Court,SC',
'29646': 'Greenwood,SC',
'29647': 'Greenwood,SC',
'29648': 'Greenwood,SC',
'29649': 'Greenwood,SC',
'29650': 'Greer,SC',
'29651': 'Greer,SC',
'29652': 'Greer,SC',
'29653': 'Hodges,SC',
'29654': 'Honea Path,SC',
'29655': 'Iva,SC',
'29656': 'La France,SC',
'29657': 'Liberty,SC',
'29658': 'Long Creek,SC',
'29659': 'Lowndesville,SC',
'29661': 'Marietta,SC',
'29662': 'Mauldin,SC',
'29664': 'Mountain Rest,SC',
'29665': 'Newry,SC',
'29666': 'Ninety Six,SC',
'29667': 'Norris,SC',
'29669': 'Pelzer,SC',
'29670': 'Pendleton,SC',
'29671': 'Pickens,SC',
'29672': 'Seneca,SC',
'29673': 'Piedmont,SC',
'29675': 'Richland,SC',
'29676': 'Salem,SC',
'29677': 'Sandy Springs,SC',
'29678': 'Seneca,SC',
'29679': 'Seneca,SC',
'29680': 'Simpsonville,SC',
'29681': 'Simpsonville,SC',
'29682': 'Six Mile,SC',
'29683': 'Slater,SC',
'29684': 'Starr,SC',
'29685': 'Sunset,SC',
'29686': 'Tamassee,SC',
'29687': 'Taylors,SC',
'29688': 'Tigerville,SC',
'29689': 'Townville,SC',
'29690': 'Travelers Rest,SC',
'29691': 'Walhalla,SC',
'29692': 'Ware Shoals,SC',
'29693': 'Westminster,SC',
'29695': 'Hodges,SC',
'29696': 'West Union,SC',
'29697': 'Williamston,SC',
'29698': 'Greenville,SC',
'29702': 'Blacksburg,SC',
'29703': 'Bowling Green,SC',
'29704': 'Catawba,SC',
'29706': 'Chester,SC',
'29708': 'Fort Mill,SC',
'29709': 'Chesterfield,SC',
'29710': 'Clover,SC',
'29712': 'Edgemoor,SC',
'29714': 'Fort Lawn,SC',
'29715': 'Fort Mill,SC',
'29716': 'Fort Mill,SC',
'29717': 'Hickory Grove,SC',
'29718': 'Jefferson,SC',
'29720': 'Lancaster,SC',
'29721': 'Lancaster,SC',
'29722': 'Lancaster,SC',
'29724': 'Lando,SC',
'29726': 'Mc Connells,SC',
'29727': 'Mount Croghan,SC',
'29728': 'Pageland,SC',
'29729': 'Richburg,SC',
'29730': 'Rock Hill,SC',
'29731': 'Rock Hill,SC',
'29732': 'Rock Hill,SC',
'29733': 'Rock Hill,SC',
'29734': 'Rock Hill,SC',
'29741': 'Ruby,SC',
'29742': 'Sharon,SC',
'29743': 'Smyrna,SC',
'29744': 'Van Wyck,SC',
'29745': 'York,SC',
'29801': 'Aiken,SC',
'29802': 'Aiken,SC',
'29803': 'Aiken,SC',
'29804': 'Aiken,SC',
'29805': 'Aiken,SC',
'29808': 'Aiken,SC',
'29809': 'New Ellenton,SC',
'29810': 'Allendale,SC',
'29812': 'Barnwell,SC',
'29813': 'Hilda,SC',
'29816': 'Bath,SC',
'29817': 'Blackville,SC',
'29819': 'Bradley,SC',
'29821': 'Clarks Hill,SC',
'29822': 'Clearwater,SC',
'29824': 'Edgefield,SC',
'29826': 'Elko,SC',
'29827': 'Fairfax,SC',
'29828': 'Gloverville,SC',
'29829': 'Graniteville,SC',
'29831': 'Jackson,SC',
'29832': 'Johnston,SC',
'29834': 'Langley,SC',
'29835': 'Mc Cormick,SC',
'29836': 'Martin,SC',
'29838': 'Modoc,SC',
'29839': 'Montmorenci,SC',
'29840': 'Mount Carmel,SC',
'29841': 'North Augusta,SC',
'29842': 'Beech Island,SC',
'29843': 'Olar,SC',
'29844': 'Parksville,SC',
'29845': 'Plum Branch,SC',
'29846': 'Sycamore,SC',
'29847': 'Trenton,SC',
'29848': 'Troy,SC',
'29849': 'Ulmer,SC',
'29850': 'Vaucluse,SC',
'29851': 'Warrenville,SC',
'29853': 'Williston,SC',
'29856': 'Windsor,SC',
'29860': 'North Augusta,SC',
'29861': 'North Augusta,SC',
'29899': 'Mc Cormick,SC',
'29901': 'Beaufort,SC',
'29902': 'Beaufort,SC',
'29903': 'Beaufort,SC',
'29904': 'Beaufort,SC',
'29905': 'Beaufort,SC',
'29906': 'Beaufort,SC',
'29907': 'Ladys Island,SC',
'29909': 'Sun City,SC',
'29910': 'Bluffton,SC',
'29911': 'Brunson,SC',
'29912': 'Coosawatchie,SC',
'29913': 'Crocketville,SC',
'29914': 'Dale,SC',
'29915': 'Daufuskie Island,SC',
'29916': 'Early Branch,SC',
'29918': 'Estill,SC',
'29920': 'Saint Helena Island,SC',
'29921': 'Furman,SC',
'29922': 'Garnett,SC',
'29923': 'Gifford,SC',
'29924': 'Hampton,SC',
'29925': 'Hilton Head Island,SC',
'29926': 'Hilton Head Island,SC',
'29927': 'Hardeeville,SC',
'29928': 'Hilton Head Island,SC',
'29929': 'Islandton,SC',
'29931': 'Lobeco,SC',
'29932': 'Luray,SC',
'29933': 'Miley,SC',
'29934': 'Pineland,SC',
'29935': 'Port Royal,SC',
'29936': 'Ridgeland,SC',
'29938': 'Hilton Head Island,SC',
'29939': 'Scotia,SC',
'29940': 'Seabrook,SC',
'29941': 'Sheldon,SC',
'29943': 'Tillman,SC',
'29944': 'Varnville,SC',
'29945': 'Yemassee,SC',
'30002': 'Avondale Estates,GA',
'30003': 'Norcross,GA',
'30004': 'Alpharetta,GA',
'30005': 'Alpharetta,GA',
'30006': 'Marietta,GA',
'30007': 'Marietta,GA',
'30008': 'Marietta,GA',
'30009': 'Alpharetta,GA',
'30010': 'Norcross,GA',
'30011': 'Auburn,GA',
'30012': 'Conyers,GA',
'30013': 'Conyers,GA',
'30014': 'Covington,GA',
'30015': 'Covington,GA',
'30016': 'Covington,GA',
'30017': 'Grayson,GA',
'30018': 'Jersey,GA',
'30019': 'Dacula,GA',
'30021': 'Clarkston,GA',
'30022': 'Alpharetta,GA',
'30023': 'Alpharetta,GA',
'30024': 'Suwanee,GA',
'30025': 'Social Circle,GA',
'30026': 'North Metro,GA',
'30028': 'Cumming,GA',
'30029': 'North Metro,GA',
'30030': 'Decatur,GA',
'30031': 'Decatur,GA',
'30032': 'Decatur,GA',
'30033': 'Decatur,GA',
'30034': 'Decatur,GA',
'30035': 'Decatur,GA',
'30036': 'Decatur,GA',
'30037': 'Decatur,GA',
'30038': 'Lithonia,GA',
'30039': 'Snellville,GA',
'30040': 'Cumming,GA',
'30041': 'Cumming,GA',
'30042': 'Lawrenceville,GA',
'30043': 'Lawrenceville,GA',
'30044': 'Lawrenceville,GA',
'30045': 'Lawrenceville,GA',
'30046': 'Lawrenceville,GA',
'30047': 'Lilburn,GA',
'30048': 'Lilburn,GA',
'30049': 'Lawrenceville,GA',
'30052': 'Loganville,GA',
'30054': 'Oxford,GA',
'30055': 'Mansfield,GA',
'30056': 'Newborn,GA',
'30058': 'Lithonia,GA',
'30060': 'Marietta,GA',
'30061': 'Marietta,GA',
'30062': 'Marietta,GA',
'30063': 'Marietta,GA',
'30064': 'Marietta,GA',
'30065': 'Marietta,GA',
'30066': 'Marietta,GA',
'30067': 'Marietta,GA',
'30068': 'Marietta,GA',
'30069': 'Marietta,GA',
'30070': 'Porterdale,GA',
'30071': 'Norcross,GA',
'30072': 'Pine Lake,GA',
'30073': 'Powder Springs,GA',
'30074': 'Redan,GA',
'30075': 'Roswell,GA',
'30076': 'Roswell,GA',
'30077': 'Roswell,GA',
'30078': 'Snellville,GA',
'30079': 'Scottdale,GA',
'30080': 'Smyrna,GA',
'30081': 'Smyrna,GA',
'30082': 'Smyrna,GA',
'30083': 'Stone Mountain,GA',
'30084': 'Tucker,GA',
'30085': 'Tucker,GA',
'30086': 'Stone Mountain,GA',
'30087': 'Stone Mountain,GA',
'30088': 'Stone Mountain,GA',
'30090': 'Marietta,GA',
'30091': 'Norcross,GA',
'30092': 'Norcross,GA',
'30093': 'Norcross,GA',
'30094': 'Conyers,GA',
'30095': 'Duluth,GA',
'30096': 'Duluth,GA',
'30097': 'Duluth,GA',
'30098': 'Duluth,GA',
'30099': 'Duluth,GA',
'30101': 'Acworth,GA',
'30102': 'Acworth,GA',
'30103': 'Adairsville,GA',
'30104': 'Aragon,GA',
'30105': 'Armuchee,GA',
'30106': 'Austell,GA',
'30107': 'Ball Ground,GA',
'30108': 'Bowdon,GA',
'30109': 'Bowdon Junction,GA',
'30110': 'Bremen,GA',
'30111': 'Clarkdale,GA',
'30112': 'Carrollton,GA',
'30113': 'Buchanan,GA',
'30114': 'Canton,GA',
'30115': 'Canton,GA',
'30116': 'Carrollton,GA',
'30117': 'Carrollton,GA',
'30118': 'Carrollton,GA',
'30119': 'Carrollton,GA',
'30120': 'Cartersville,GA',
'30121': 'Cartersville,GA',
'30122': 'Lithia Springs,GA',
'30123': 'Cassville,GA',
'30124': 'Cave Spring,GA',
'30125': 'Cedartown,GA',
'30126': 'Mableton,GA',
'30127': 'Powder Springs,GA',
'30129': 'Coosa,GA',
'30132': 'Dallas,GA',
'30133': 'Douglasville,GA',
'30134': 'Douglasville,GA',
'30135': 'Douglasville,GA',
'30137': 'Emerson,GA',
'30138': 'Esom Hill,GA',
'30139': 'Fairmount,GA',
'30140': 'Felton,GA',
'30141': 'Hiram,GA',
'30142': 'Holly Springs,GA',
'30143': 'Jasper,GA',
'30144': 'Kennesaw,GA',
'30145': 'Kingston,GA',
'30146': 'Lebanon,GA',
'30147': 'Lindale,GA',
'30148': 'Marble Hill,GA',
'30149': 'Mount Berry,GA',
'30150': 'Mount Zion,GA',
'30151': 'Nelson,GA',
'30152': 'Kennesaw,GA',
'30153': 'Rockmart,GA',
'30154': 'Douglasville,GA',
'30156': 'Kennesaw,GA',
'30157': 'Dallas,GA',
'30160': 'Kennesaw,GA',
'30161': 'Rome,GA',
'30162': 'Rome,GA',
'30163': 'Rome,GA',
'30164': 'Rome,GA',
'30165': 'Rome,GA',
'30168': 'Austell,GA',
'30169': 'Canton,GA',
'30170': 'Roopville,GA',
'30171': 'Rydal,GA',
'30172': 'Shannon,GA',
'30173': 'Silver Creek,GA',
'30175': 'Talking Rock,GA',
'30176': 'Tallapoosa,GA',
'30177': 'Tate,GA',
'30178': 'Taylorsville,GA',
'30179': 'Temple,GA',
'30180': 'Villa Rica,GA',
'30182': 'Waco,GA',
'30183': 'Waleska,GA',
'30184': 'White,GA',
'30185': 'Whitesburg,GA',
'30187': 'Winston,GA',
'30188': 'Woodstock,GA',
'30189': 'Woodstock,GA',
'30204': 'Barnesville,GA',
'30205': 'Brooks,GA',
'30206': 'Concord,GA',
'30212': 'Experiment,GA',
'30213': 'Fairburn,GA',
'30214': 'Fayetteville,GA',
'30215': 'Fayetteville,GA',
'30216': 'Flovilla,GA',
'30217': 'Franklin,GA',
'30218': 'Gay,GA',
'30219': 'Glenn,GA',
'30220': 'Grantville,GA',
'30222': 'Greenville,GA',
'30223': 'Griffin,GA',
'30224': 'Griffin,GA',
'30228': 'Hampton,GA',
'30229': 'Haralson,GA',
'30230': 'Hogansville,GA',
'30232': 'Inman,GA',
'30233': 'Jackson,GA',
'30234': 'Jenkinsburg,GA',
'30236': 'Jonesboro,GA',
'30237': 'Jonesboro,GA',
'30238': 'Jonesboro,GA',
'30240': 'Lagrange,GA',
'30241': 'Lagrange,GA',
'30248': 'Locust Grove,GA',
'30250': 'Lovejoy,GA',
'30251': 'Luthersville,GA',
'30252': 'Mcdonough,GA',
'30253': 'Mcdonough,GA',
'30256': 'Meansville,GA',
'30257': 'Milner,GA',
'30258': 'Molena,GA',
'30259': 'Moreland,GA',
'30260': 'Morrow,GA',
'30261': 'Lagrange,GA',
'30263': 'Newnan,GA',
'30264': 'Newnan,GA',
'30265': 'Newnan,GA',
'30266': 'Orchard Hill,GA',
'30268': 'Palmetto,GA',
'30269': 'Peachtree City,GA',
'30270': 'Peachtree Cty,GA',
'30271': 'Newnan,GA',
'30272': 'Red Oak,GA',
'30273': 'Rex,GA',
'30274': 'Riverdale,GA',
'30275': 'Sargent,GA',
'30276': 'Senoia,GA',
'30277': 'Sharpsburg,GA',
'30281': 'Stockbridge,GA',
'30284': 'Sunny Side,GA',
'30285': 'The Rock,GA',
'30286': 'Thomaston,GA',
'30287': 'Morrow,GA',
'30288': 'Conley,GA',
'30289': 'Turin,GA',
'30290': 'Tyrone,GA',
'30291': 'Union City,GA',
'30292': 'Williamson,GA',
'30293': 'Woodbury,GA',
'30294': 'Ellenwood,GA',
'30295': 'Zebulon,GA',
'30296': 'Riverdale,GA',
'30297': 'Forest Park,GA',
'30298': 'Forest Park,GA',
'30301': 'Atlanta,GA',
'30302': 'Atlanta,GA',
'30303': 'Atlanta,GA',
'30304': 'Atlanta,GA',
'30305': 'Atlanta,GA',
'30306': 'Atlanta,GA',
'30307': 'Atlanta,GA',
'30308': 'Atlanta,GA',
'30309': 'Atlanta,GA',
'30310': 'Atlanta,GA',
'30311': 'Atlanta,GA',
'30312': 'Atlanta,GA',
'30313': 'Atlanta,GA',
'30314': 'Atlanta,GA',
'30315': 'Atlanta,GA',
'30316': 'Atlanta,GA',
'30317': 'Atlanta,GA',
'30318': 'Atlanta,GA',
'30319': 'Atlanta,GA',
'30320': 'Atlanta,GA',
'30321': 'Atlanta,GA',
'30322': 'Atlanta,GA',
'30324': 'Atlanta,GA',
'30325': 'Atlanta,GA',
'30326': 'Atlanta,GA',
'30327': 'Atlanta,GA',
'30328': 'Atlanta,GA',
'30329': 'Atlanta,GA',
'30330': 'Atlanta,GA',
'30331': 'Atlanta,GA',
'30332': 'Atlanta,GA',
'30333': 'Atlanta,GA',
'30334': 'Atlanta,GA',
'30336': 'Atlanta,GA',
'30337': 'Atlanta,GA',
'30338': 'Atlanta,GA',
'30339': 'Atlanta,GA',
'30340': 'Atlanta,GA',
'30341': 'Atlanta,GA',
'30342': 'Atlanta,GA',
'30343': 'Atlanta,GA',
'30344': 'Atlanta,GA',
'30345': 'Atlanta,GA',
'30346': 'Atlanta,GA',
'30347': 'Atlanta,GA',
'30348': 'Atlanta,GA',
'30349': 'Atlanta,GA',
'30350': 'Atlanta,GA',
'30353': 'Atlanta,GA',
'30354': 'Atlanta,GA',
'30355': 'Atlanta,GA',
'30356': 'Atlanta,GA',
'30357': 'Atlanta,GA',
'30358': 'Atlanta,GA',
'30359': 'Atlanta,GA',
'30360': 'Atlanta,GA',
'30361': 'Atlanta,GA',
'30362': 'Atlanta,GA',
'30363': 'Atlanta,GA',
'30364': 'Atlanta,GA',
'30366': 'Atlanta,GA',
'30368': 'Atlanta,GA',
'30369': 'Atlanta,GA',
'30370': 'Atlanta,GA',
'30371': 'Atlanta,GA',
'30374': 'Atlanta,GA',
'30375': 'Atlanta,GA',
'30376': 'Atlanta,GA',
'30377': 'Atlanta,GA',
'30378': 'Atlanta,GA',
'30379': 'Atlanta,GA',
'30380': 'Atlanta,GA',
'30384': 'Atlanta,GA',
'30385': 'Atlanta,GA',
'30386': 'Atlanta,GA',
'30387': 'Atlanta,GA',
'30388': 'Atlanta,GA',
'30389': 'Atlanta,GA',
'30390': 'Atlanta,GA',
'30392': 'Atlanta,GA',
'30394': 'Atlanta,GA',
'30396': 'Atlanta,GA',
'30398': 'Atlanta,GA',
'30399': 'Atlanta,GA',
'30401': 'Swainsboro,GA',
'30410': 'Ailey,GA',
'30411': 'Alamo,GA',
'30412': 'Alston,GA',
'30413': 'Bartow,GA',
'30414': 'Bellville,GA',
'30415': 'Brooklet,GA',
'30417': 'Claxton,GA',
'30420': 'Cobbtown,GA',
'30421': 'Collins,GA',
'30423': 'Daisy,GA',
'30424': 'Dover,GA',
'30425': 'Garfield,GA',
'30426': 'Girard,GA',
'30427': 'Glennville,GA',
'30428': 'Glenwood,GA',
'30429': 'Hagan,GA',
'30434': 'Louisville,GA',
'30436': 'Lyons,GA',
'30438': 'Manassas,GA',
'30439': 'Metter,GA',
'30441': 'Midville,GA',
'30442': 'Millen,GA',
'30445': 'Mount Vernon,GA',
'30446': 'Newington,GA',
'30447': 'Norristown,GA',
'30448': 'Nunez,GA',
'30449': 'Oliver,GA',
'30450': 'Portal,GA',
'30451': 'Pulaski,GA',
'30452': 'Register,GA',
'30453': 'Reidsville,GA',
'30454': 'Rockledge,GA',
'30455': 'Rocky Ford,GA',
'30456': 'Sardis,GA',
'30457': 'Soperton,GA',
'30458': 'Statesboro,GA',
'30459': 'Statesboro,GA',
'30460': 'Statesboro,GA',
'30461': 'Statesboro,GA',
'30464': 'Stillmore,GA',
'30467': 'Sylvania,GA',
'30470': 'Tarrytown,GA',
'30471': 'Twin City,GA',
'30473': 'Uvalda,GA',
'30474': 'Vidalia,GA',
'30475': 'Vidalia,GA',
'30477': 'Wadley,GA',
'30499': 'Reidsville,GA',
'30501': 'Gainesville,GA',
'30502': 'Chestnut Mountain,GA',
'30503': 'Gainesville,GA',
'30504': 'Gainesville,GA',
'30506': 'Gainesville,GA',
'30507': 'Gainesville,GA',
'30510': 'Alto,GA',
'30511': 'Baldwin,GA',
'30512': 'Blairsville,GA',
'30513': 'Blue Ridge,GA',
'30514': 'Blairsville,GA',
'30515': 'Buford,GA',
'30516': 'Bowersville,GA',
'30517': 'Braselton,GA',
'30518': 'Buford,GA',
'30519': 'Buford,GA',
'30520': 'Canon,GA',
'30521': 'Carnesville,GA',
'30522': 'Cherrylog,GA',
'30523': 'Clarkesville,GA',
'30525': 'Clayton,GA',
'30527': 'Clermont,GA',
'30528': 'Cleveland,GA',
'30529': 'Commerce,GA',
'30530': 'Commerce,GA',
'30531': 'Cornelia,GA',
'30533': 'Dahlonega,GA',
'30534': 'Dawsonville,GA',
'30535': 'Demorest,GA',
'30536': 'Ellijay,GA',
'30537': 'Dillard,GA',
'30538': 'Eastanollee,GA',
'30539': 'East Ellijay,GA',
'30540': 'Ellijay,GA',
'30541': 'Epworth,GA',
'30542': 'Flowery Branch,GA',
'30543': 'Gillsville,GA',
'30544': 'Demorest,GA',
'30545': 'Helen,GA',
'30546': 'Hiawassee,GA',
'30547': 'Homer,GA',
'30548': 'Hoschton,GA',
'30549': 'Jefferson,GA',
'30552': 'Lakemont,GA',
'30553': 'Lavonia,GA',
'30554': 'Lula,GA',
'30555': 'Mc Caysville,GA',
'30557': 'Martin,GA',
'30558': 'Maysville,GA',
'30559': 'Mineral Bluff,GA',
'30560': 'Morganton,GA',
'30562': 'Mountain City,GA',
'30563': 'Mount Airy,GA',
'30564': 'Murrayville,GA',
'30565': 'Nicholson,GA',
'30566': 'Oakwood,GA',
'30567': 'Pendergrass,GA',
'30568': 'Rabun Gap,GA',
'30571': 'Sautee Nacoochee,GA',
'30572': 'Suches,GA',
'30573': 'Tallulah Falls,GA',
'30575': 'Talmo,GA',
'30576': 'Tiger,GA',
'30577': 'Toccoa,GA',
'30580': 'Turnerville,GA',
'30581': 'Wiley,GA',
'30582': 'Young Harris,GA',
'30596': 'Alto,GA',
'30597': 'Dahlonega,GA',
'30598': 'Toccoa Falls,GA',
'30599': 'Commerce,GA',
'30601': 'Athens,GA',
'30602': 'Athens,GA',
'30603': 'Athens,GA',
'30604': 'Athens,GA',
'30605': 'Athens,GA',
'30606': 'Athens,GA',
'30607': 'Athens,GA',
'30608': 'Athens,GA',
'30609': 'Athens,GA',
'30612': 'Athens,GA',
'30619': 'Arnoldsville,GA',
'30620': 'Bethlehem,GA',
'30621': 'Bishop,GA',
'30622': 'Bogart,GA',
'30623': 'Bostwick,GA',
'30624': 'Bowman,GA',
'30625': 'Buckhead,GA',
'30627': 'Carlton,GA',
'30628': 'Colbert,GA',
'30629': 'Comer,GA',
'30630': 'Crawford,GA',
'30631': 'Crawfordville,GA',
'30633': 'Danielsville,GA',
'30634': 'Dewy Rose,GA',
'30635': 'Elberton,GA',
'30638': 'Farmington,GA',
'30639': 'Franklin Springs,GA',
'30641': 'Good Hope,GA',
'30642': 'Greensboro,GA',
'30643': 'Hartwell,GA',
'30645': 'High Shoals,GA',
'30646': 'Hull,GA',
'30647': 'Ila,GA',
'30648': 'Lexington,GA',
'30650': 'Madison,GA',
'30655': 'Monroe,GA',
'30656': 'Monroe,GA',
'30660': 'Rayle,GA',
'30662': 'Royston,GA',
'30663': 'Rutledge,GA',
'30664': 'Sharon,GA',
'30665': 'Siloam,GA',
'30666': 'Statham,GA',
'30667': 'Stephens,GA',
'30668': 'Tignall,GA',
'30669': 'Union Point,GA',
'30671': 'Maxeys,GA',
'30673': 'Washington,GA',
'30677': 'Watkinsville,GA',
'30678': 'White Plains,GA',
'30680': 'Winder,GA',
'30683': 'Winterville,GA',
'30701': 'Calhoun,GA',
'30703': 'Calhoun,GA',
'30705': 'Chatsworth,GA',
'30707': 'Chickamauga,GA',
'30708': 'Cisco,GA',
'30710': 'Cohutta,GA',
'30711': 'Crandall,GA',
'30719': 'Dalton,GA',
'30720': 'Dalton,GA',
'30721': 'Dalton,GA',
'30722': 'Dalton,GA',
'30724': 'Eton,GA',
'30725': 'Flintstone,GA',
'30726': 'Graysville,GA',
'30728': 'La Fayette,GA',
'30730': 'Lyerly,GA',
'30731': 'Menlo,GA',
'30732': 'Oakman,GA',
'30733': 'Plainville,GA',
'30734': 'Ranger,GA',
'30735': 'Resaca,GA',
'30736': 'Ringgold,GA',
'30738': 'Rising Fawn,GA',
'30739': 'Rock Spring,GA',
'30740': 'Rocky Face,GA',
'30741': 'Rossville,GA',
'30742': 'Fort Oglethorpe,GA',
'30746': 'Sugar Valley,GA',
'30747': 'Summerville,GA',
'30750': 'Lookout Mountain,GA',
'30751': 'Tennga,GA',
'30752': 'Trenton,GA',
'30753': 'Trion,GA',
'30755': 'Tunnel Hill,GA',
'30756': 'Varnell,GA',
'30757': 'Wildwood,GA',
'30802': 'Appling,GA',
'30803': 'Avera,GA',
'30805': 'Blythe,GA',
'30806': 'Boneville,GA',
'30807': 'Camak,GA',
'30808': 'Dearing,GA',
'30809': 'Evans,GA',
'30810': 'Gibson,GA',
'30811': 'Gough,GA',
'30812': 'Gracewood,GA',
'30813': 'Grovetown,GA',
'30814': 'Harlem,GA',
'30815': 'Hephzibah,GA',
'30816': 'Keysville,GA',
'30817': 'Lincolnton,GA',
'30818': 'Matthews,GA',
'30819': 'Mesena,GA',
'30820': 'Mitchell,GA',
'30821': 'Norwood,GA',
'30822': 'Perkins,GA',
'30823': 'Stapleton,GA',
'30824': 'Thomson,GA',
'30828': 'Warrenton,GA',
'30830': 'Waynesboro,GA',
'30833': 'Wrens,GA',
'30901': 'Augusta,GA',
'30903': 'Augusta,GA',
'30904': 'Augusta,GA',
'30905': 'Augusta,GA',
'30906': 'Augusta,GA',
'30907': 'Augusta,GA',
'30909': 'Augusta,GA',
'30910': 'Augusta,GA',
'30911': 'Augusta,GA',
'30912': 'Augusta,GA',
'30913': 'Augusta,GA',
'30914': 'Augusta,GA',
'30916': 'Augusta,GA',
'30917': 'Augusta,GA',
'30919': 'Augusta,GA',
'30999': 'Augusta,GA',
'31001': 'Abbeville,GA',
'31002': 'Adrian,GA',
'31003': 'Allentown,GA',
'31004': 'Bolingbroke,GA',
'31005': 'Bonaire,GA',
'31006': 'Butler,GA',
'31007': 'Byromville,GA',
'31008': 'Byron,GA',
'31009': 'Cadwell,GA',
'31010': 'Cordele,GA',
'31011': 'Chauncey,GA',
'31012': 'Chester,GA',
'31013': 'Clinchfield,GA',
'31014': 'Cochran,GA',
'31015': 'Cordele,GA',
'31016': 'Culloden,GA',
'31017': 'Danville,GA',
'31018': 'Davisboro,GA',
'31019': 'Dexter,GA',
'31020': 'Dry Branch,GA',
'31021': 'Dublin,GA',
'31022': 'Dudley,GA',
'31023': 'Eastman,GA',
'31024': 'Eatonton,GA',
'31025': 'Elko,GA',
'31026': 'Haband,GA',
'31027': 'Dublin,GA',
'31028': 'Centerville,GA',
'31029': 'Forsyth,GA',
'31030': 'Fort Valley,GA',
'31031': 'Gordon,GA',
'31032': 'Gray,GA',
'31033': 'Haddock,GA',
'31034': 'Hardwick,GA',
'31035': 'Harrison,GA',
'31036': 'Hawkinsville,GA',
'31037': 'Helena,GA',
'31038': 'Hillsboro,GA',
'31039': 'Howard,GA',
'31040': 'Dublin,GA',
'31041': 'Ideal,GA',
'31042': 'Irwinton,GA',
'31044': 'Jeffersonville,GA',
'31045': 'Jewell,GA',
'31046': 'Juliette,GA',
'31047': 'Kathleen,GA',
'31049': 'Kite,GA',
'31050': 'Knoxville,GA',
'31051': 'Lilly,GA',
'31052': 'Lizella,GA',
'31054': 'Mc Intyre,GA',
'31055': 'Mc Rae,GA',
'31057': 'Marshallville,GA',
'31058': 'Mauk,GA',
'31059': 'Milledgeville,GA',
'31060': 'Milan,GA',
'31061': 'Milledgeville,GA',
'31062': 'Milledgeville,GA',
'31063': 'Montezuma,GA',
'31064': 'Monticello,GA',
'31065': 'Montrose,GA',
'31066': 'Musella,GA',
'31067': 'Oconee,GA',
'31068': 'Oglethorpe,GA',
'31069': 'Perry,GA',
'31070': 'Pinehurst,GA',
'31071': 'Pineview,GA',
'31072': 'Pitts,GA',
'31073': 'Plainfield,GA',
'31075': 'Rentz,GA',
'31076': 'Reynolds,GA',
'31077': 'Rhine,GA',
'31078': 'Roberta,GA',
'31079': 'Rochelle,GA',
'31081': 'Rupert,GA',
'31082': 'Sandersville,GA',
'31083': 'Scotland,GA',
'31084': 'Seville,GA',
'31085': 'Shady Dale,GA',
'31086': 'Smarr,GA',
'31087': 'Sparta,GA',
'31088': 'Warner Robins,GA',
'31089': 'Tennille,GA',
'31090': 'Toomsboro,GA',
'31091': 'Unadilla,GA',
'31092': 'Vienna,GA',
'31093': 'Warner Robins,GA',
'31094': 'Warthen,GA',
'31095': 'Warner Robins,GA',
'31096': 'Wrightsville,GA',
'31097': 'Yatesville,GA',
'31098': 'Warner Robins,GA',
'31099': 'Warner Robins,GA',
'31106': 'Atlanta,GA',
'31107': 'Atlanta,GA',
'31119': 'Atlanta,GA',
'31120': 'T Mobile,GA',
'31126': 'Atlanta,GA',
'31131': 'Atlanta,GA',
'31136': 'Newgistics,GA',
'31139': 'Atlanta,GA',
'31141': 'Atlanta,GA',
'31145': 'Atlanta,GA',
'31146': 'Atlanta,GA',
'31150': 'Atlanta,GA',
'31156': 'Atlanta,GA',
'31169': 'Peachtree City Parcel Return,GA',
'31191': 'Atlanta,GA',
'31192': 'Atlanta,GA',
'31193': 'Atlanta,GA',
'31195': 'Atlanta,GA',
'31196': 'Atlanta,GA',
'31197': 'Atlanta,GA',
'31198': 'Atlanta,GA',
'31199': 'Atlanta,GA',
'31201': 'Macon,GA',
'31202': 'Macon,GA',
'31203': 'Macon,GA',
'31204': 'Macon,GA',
'31205': 'Macon,GA',
'31206': 'Macon,GA',
'31207': 'Macon,GA',
'31208': 'Macon,GA',
'31209': 'Macon,GA',
'31210': 'Macon,GA',
'31211': 'Macon,GA',
'31212': 'Macon,GA',
'31213': 'Macon,GA',
'31216': 'Macon,GA',
'31217': 'Macon,GA',
'31220': 'Macon,GA',
'31221': 'Macon,GA',
'31294': 'Macon,GA',
'31295': 'Macon,GA',
'31296': 'Macon,GA',
'31297': 'Macon,GA',
'31298': 'Macon,GA',
'31299': 'Macon,GA',
'31301': 'Allenhurst,GA',
'31302': 'Bloomingdale,GA',
'31303': 'Clyo,GA',
'31304': 'Crescent,GA',
'31305': 'Darien,GA',
'31307': 'Eden,GA',
'31308': 'Ellabell,GA',
'31309': 'Fleming,GA',
'31310': 'Hinesville,GA',
'31312': 'Guyton,GA',
'31313': 'Hinesville,GA',
'31314': 'Fort Stewart,GA',
'31315': 'Fort Stewart,GA',
'31316': 'Ludowici,GA',
'31318': 'Meldrim,GA',
'31319': 'Meridian,GA',
'31320': 'Midway,GA',
'31321': 'Pembroke,GA',
'31322': 'Pooler,GA',
'31323': 'Riceboro,GA',
'31324': 'Richmond Hill,GA',
'31326': 'Rincon,GA',
'31327': 'Sapelo Island,GA',
'31328': 'Tybee Island,GA',
'31329': 'Springfield,GA',
'31331': 'Townsend,GA',
'31333': 'Walthourville,GA',
'31401': 'Savannah,GA',
'31402': 'Savannah,GA',
'31403': 'Savannah,GA',
'31404': 'Savannah,GA',
'31405': 'Savannah,GA',
'31406': 'Savannah,GA',
'31407': 'Savannah,GA',
'31408': 'Savannah,GA',
'31409': 'Savannah,GA',
'31410': 'Savannah,GA',
'31411': 'Savannah,GA',
'31412': 'Savannah,GA',
'31414': 'Savannah,GA',
'31415': 'Savannah,GA',
'31416': 'Savannah,GA',
'31418': 'Savannah,GA',
'31419': 'Savannah,GA',
'31420': 'Savannah,GA',
'31421': 'Savannah,GA',
'31422': 'Savannah,GA',
'31498': 'Savannah,GA',
'31499': 'Savannah,GA',
'31501': 'Waycross,GA',
'31502': 'Waycross,GA',
'31503': 'Waycross,GA',
'31510': 'Alma,GA',
'31512': 'Ambrose,GA',
'31513': 'Baxley,GA',
'31515': 'Baxley,GA',
'31516': 'Blackshear,GA',
'31518': 'Bristol,GA',
'31519': 'Broxton,GA',
'31520': 'Brunswick,GA',
'31521': 'Brunswick,GA',
'31522': 'Saint Simons Island,GA',
'31523': 'Brunswick,GA',
'31524': 'Brunswick,GA',
'31525': 'Brunswick,GA',
'31527': 'Jekyll Island,GA',
'31532': 'Denton,GA',
'31533': 'Douglas,GA',
'31534': 'Douglas,GA',
'31535': 'Douglas,GA',
'31537': 'Folkston,GA',
'31539': 'Hazlehurst,GA',
'31542': 'Hoboken,GA',
'31543': 'Hortense,GA',
'31544': 'Jacksonville,GA',
'31545': 'Jesup,GA',
'31546': 'Jesup,GA',
'31547': 'Kings Bay,GA',
'31548': 'Kingsland,GA',
'31549': 'Lumber City,GA',
'31550': 'Manor,GA',
'31551': 'Mershon,GA',
'31552': 'Millwood,GA',
'31553': 'Nahunta,GA',
'31554': 'Nicholls,GA',
'31555': 'Odum,GA',
'31556': 'Offerman,GA',
'31557': 'Patterson,GA',
'31558': 'Saint Marys,GA',
'31560': 'Screven,GA',
'31561': 'Sea Island,GA',
'31562': 'Saint George,GA',
'31563': 'Surrency,GA',
'31564': 'Waresboro,GA',
'31565': 'Waverly,GA',
'31566': 'Waynesville,GA',
'31567': 'West Green,GA',
'31568': 'White Oak,GA',
'31569': 'Woodbine,GA',
'31598': 'Jesup,GA',
'31599': 'Jesup,GA',
'31601': 'Valdosta,GA',
'31602': 'Valdosta,GA',
'31603': 'Valdosta,GA',
'31604': 'Valdosta,GA',
'31605': 'Valdosta,GA',
'31606': 'Valdosta,GA',
'31620': 'Adel,GA',
'31622': 'Alapaha,GA',
'31623': 'Argyle,GA',
'31624': 'Axson,GA',
'31625': 'Barney,GA',
'31626': 'Boston,GA',
'31627': 'Cecil,GA',
'31629': 'Dixie,GA',
'31630': 'Du Pont,GA',
'31631': 'Fargo,GA',
'31632': 'Hahira,GA',
'31634': 'Homerville,GA',
'31635': 'Lakeland,GA',
'31636': 'Lake Park,GA',
'31637': 'Lenox,GA',
'31638': 'Morven,GA',
'31639': 'Nashville,GA',
'31641': 'Naylor,GA',
'31642': 'Pearson,GA',
'31643': 'Quitman,GA',
'31645': 'Ray City,GA',
'31646': 'Saint George,GA',
'31647': 'Sparks,GA',
'31648': 'Statenville,GA',
'31649': 'Stockton,GA',
'31650': 'Willacoochee,GA',
'31698': 'Valdosta,GA',
'31699': 'Valdosta,GA',
'31701': 'Albany,GA',
'31702': 'Albany,GA',
'31703': 'Albany,GA',
'31704': 'Albany,GA',
'31705': 'Albany,GA',
'31706': 'Albany,GA',
'31707': 'Albany,GA',
'31708': 'Albany,GA',
'31709': 'Americus,GA',
'31710': 'Americus,GA',
'31711': 'Andersonville,GA',
'31712': 'Arabi,GA',
'31713': 'Arlington,GA',
'31714': 'Ashburn,GA',
'31715': 'Attapulgus,GA',
'31716': 'Baconton,GA',
'31717': 'Bainbridge,GA',
'31718': 'Bainbridge,GA',
'31719': 'Americus,GA',
'31720': 'Barwick,GA',
'31721': 'Albany,GA',
'31722': 'Berlin,GA',
'31723': 'Blakely,GA',
'31724': 'Bluffton,GA',
'31725': 'Brinson,GA',
'31726': 'Bronwood,GA',
'31727': 'Brookfield,GA',
'31728': 'Cairo,GA',
'31729': 'Calvary,GA',
'31730': 'Camilla,GA',
'31732': 'Cedar Springs,GA',
'31733': 'Chula,GA',
'31734': 'Climax,GA',
'31735': 'Cobb,GA',
'31736': 'Coleman,GA',
'31738': 'Coolidge,GA',
'31739': 'Cotton,GA',
'31740': 'Cuthbert,GA',
'31741': 'Damascus,GA',
'31742': 'Dawson,GA',
'31743': 'De Soto,GA',
'31744': 'Doerun,GA',
'31745': 'Donalsonville,GA',
'31746': 'Edison,GA',
'31747': 'Ellenton,GA',
'31749': 'Enigma,GA',
'31750': 'Fitzgerald,GA',
'31751': 'Fort Gaines,GA',
'31752': 'Fowlstown,GA',
'31753': 'Funston,GA',
'31754': 'Georgetown,GA',
'31756': 'Hartsfield,GA',
'31757': 'Thomasville,GA',
'31758': 'Thomasville,GA',
'31759': 'Iron City,GA',
'31760': 'Irwinville,GA',
'31761': 'Jakin,GA',
'31762': 'Leary,GA',
'31763': 'Leesburg,GA',
'31764': 'Leslie,GA',
'31765': 'Meigs,GA',
'31766': 'Morgan,GA',
'31767': 'Morris,GA',
'31768': 'Moultrie,GA',
'31769': 'Mystic,GA',
'31770': 'Newton,GA',
'31771': 'Norman Park,GA',
'31772': 'Oakfield,GA',
'31773': 'Ochlocknee,GA',
'31774': 'Ocilla,GA',
'31775': 'Omega,GA',
'31776': 'Moultrie,GA',
'31777': 'Parrott,GA',
'31778': 'Pavo,GA',
'31779': 'Pelham,GA',
'31780': 'Plains,GA',
'31781': 'Poulan,GA',
'31782': 'Putney,GA',
'31783': 'Rebecca,GA',
'31784': 'Sale City,GA',
'31785': 'Sasser,GA',
'31786': 'Shellman,GA',
'31787': 'Smithville,GA',
'31788': 'Moultrie,GA',
'31789': 'Sumner,GA',
'31790': 'Sycamore,GA',
'31791': 'Sylvester,GA',
'31792': 'Thomasville,GA',
'31793': 'Tifton,GA',
'31794': 'Tifton,GA',
'31795': 'Ty Ty,GA',
'31796': 'Warwick,GA',
'31797': 'Whigham,GA',
'31798': 'Wray,GA',
'31799': 'Thomasville,GA',
'31801': 'Box Springs,GA',
'31803': 'Buena Vista,GA',
'31804': 'Cataula,GA',
'31805': 'Cusseta,GA',
'31806': 'Ellaville,GA',
'31807': 'Ellerslie,GA',
'31808': 'Fortson,GA',
'31810': 'Geneva,GA',
'31811': 'Hamilton,GA',
'31812': 'Junction City,GA',
'31814': 'Louvale,GA',
'31815': 'Lumpkin,GA',
'31816': 'Manchester,GA',
'31820': 'Midland,GA',
'31821': 'Omaha,GA',
'31822': 'Pine Mountain,GA',
'31823': 'Pine Mountain Valley,GA',
'31824': 'Preston,GA',
'31825': 'Richland,GA',
'31826': 'Shiloh,GA',
'31827': 'Talbotton,GA',
'31829': 'Upatoi,GA',
'31830': 'Warm Springs,GA',
'31831': 'Waverly Hall,GA',
'31832': 'Weston,GA',
'31833': 'West Point,GA',
'31836': 'Woodland,GA',
'31901': 'Columbus,GA',
'31902': 'Columbus,GA',
'31903': 'Columbus,GA',
'31904': 'Columbus,GA',
'31905': 'Fort Benning,GA',
'31906': 'Columbus,GA',
'31907': 'Columbus,GA',
'31908': 'Columbus,GA',
'31909': 'Columbus,GA',
'31914': 'Columbus,GA',
'31917': 'Columbus,GA',
'31993': 'Columbus,GA',
'31994': 'Columbus,GA',
'31995': 'Fort Benning,GA',
'31997': 'Columbus,GA',
'31998': 'Columbus,GA',
'31999': 'Columbus,GA',
'32003': 'Orange Park,FL',
'32004': 'Ponte Vedra Beach,FL',
'32006': 'Orange Park,FL',
'32007': 'Bostwick,FL',
'32008': 'Branford,FL',
'32009': 'Bryceville,FL',
'32011': 'Callahan,FL',
'32013': 'Day,FL',
'32024': 'Lake City,FL',
'32025': 'Lake City,FL',
'32026': 'Raiford,FL',
'32030': 'Doctors Inlet,FL',
'32033': 'Elkton,FL',
'32034': 'Fernandina Beach,FL',
'32035': 'Fernandina Beach,FL',
'32038': 'Fort White,FL',
'32040': 'Glen Saint Mary,FL',
'32041': 'Yulee,FL',
'32042': 'Graham,FL',
'32043': 'Green Cove Springs,FL',
'32044': 'Hampton,FL',
'32046': 'Hilliard,FL',
'32050': 'Middleburg,FL',
'32052': 'Jasper,FL',
'32053': 'Jennings,FL',
'32054': 'Lake Butler,FL',
'32055': 'Lake City,FL',
'32056': 'Lake City,FL',
'32058': 'Lawtey,FL',
'32059': 'Lee,FL',
'32060': 'Live Oak,FL',
'32061': 'Lulu,FL',
'32062': 'Mc Alpin,FL',
'32063': 'Macclenny,FL',
'32064': 'Live Oak,FL',
'32065': 'Orange Park,FL',
'32066': 'Mayo,FL',
'32067': 'Orange Park,FL',
'32068': 'Middleburg,FL',
'32071': 'O Brien,FL',
'32072': 'Olustee,FL',
'32073': 'Orange Park,FL',
'32079': 'Penney Farms,FL',
'32080': 'Saint Augustine,FL',
'32081': 'Town Of Nocatee,FL',
'32082': 'Ponte Vedra Beach,FL',
'32083': 'Raiford,FL',
'32084': 'Saint Augustine,FL',
'32085': 'Saint Augustine,FL',
'32086': 'Saint Augustine,FL',
'32087': 'Sanderson,FL',
'32091': 'Starke,FL',
'32092': 'Saint Augustine,FL',
'32094': 'Wellborn,FL',
'32095': 'Saint Augustine,FL',
'32096': 'White Springs,FL',
'32097': 'Yulee,FL',
'32099': 'Jacksonville,FL',
'32102': 'Astor,FL',
'32105': 'Barberville,FL',
'32110': 'Bunnell,FL',
'32111': 'Candler,FL',
'32112': 'Crescent City,FL',
'32113': 'Citra,FL',
'32114': 'Daytona Beach,FL',
'32115': 'Daytona Beach,FL',
'32116': 'Daytona Beach,FL',
'32117': 'Daytona Beach,FL',
'32118': 'Daytona Beach,FL',
'32119': 'Daytona Beach,FL',
'32120': 'Daytona Beach,FL',
'32121': 'Daytona Beach,FL',
'32122': 'Daytona Beach,FL',
'32123': 'Daytona Beach,FL',
'32124': 'Daytona Beach,FL',
'32125': 'Daytona Beach,FL',
'32126': 'Daytona Beach,FL',
'32127': 'Daytona Beach,FL',
'32128': 'Daytona Beach,FL',
'32129': 'Port Orange,FL',
'32130': 'De Leon Springs,FL',
'32131': 'East Palatka,FL',
'32132': 'Edgewater,FL',
'32133': 'Eastlake Weir,FL',
'32134': 'Fort Mc Coy,FL',
'32135': 'Palm Coast,FL',
'32136': 'Flagler Beach,FL',
'32137': 'Palm Coast,FL',
'32138': 'Grandin,FL',
'32139': 'Georgetown,FL',
'32140': 'Florahome,FL',
'32141': 'Edgewater,FL',
'32142': 'Palm Coast,FL',
'32143': 'Flagler Beach,FL',
'32145': 'Hastings,FL',
'32147': 'Hollister,FL',
'32148': 'Interlachen,FL',
'32149': 'Interlachen,FL',
'32151': 'Flagler Beach,FL',
'32157': 'Lake Como,FL',
'32158': 'Lady Lake,FL',
'32159': 'Lady Lake,FL',
'32160': 'Lake Geneva,FL',
'32162': 'Lady Lake,FL',
'32164': 'Palm Coast,FL',
'32168': 'New Smyrna Beach,FL',
'32169': 'New Smyrna Beach,FL',
'32170': 'New Smyrna Beach,FL',
'32173': 'Ormond Beach,FL',
'32174': 'Ormond Beach,FL',
'32175': 'Ormond Beach,FL',
'32176': 'Ormond Beach,FL',
'32177': 'Palatka,FL',
'32178': 'Palatka,FL',
'32179': 'Ocklawaha,FL',
'32180': 'Pierson,FL',
'32181': 'Pomona Park,FL',
'32182': 'Orange Springs,FL',
'32183': 'Ocklawaha,FL',
'32185': 'Putnam Hall,FL',
'32187': 'San Mateo,FL',
'32189': 'Satsuma,FL',
'32190': 'Seville,FL',
'32192': 'Sparr,FL',
'32193': 'Welaka,FL',
'32195': 'Weirsdale,FL',
'32198': 'Daytona Beach,FL',
'32201': 'Jacksonville,FL',
'32202': 'Jacksonville,FL',
'32203': 'Jacksonville,FL',
'32204': 'Jacksonville,FL',
'32205': 'Jacksonville,FL',
'32206': 'Jacksonville,FL',
'32207': 'Jacksonville,FL',
'32208': 'Jacksonville,FL',
'32209': 'Jacksonville,FL',
'32210': 'Jacksonville,FL',
'32211': 'Jacksonville,FL',
'32212': 'Jacksonville,FL',
'32214': 'Jacksonville,FL',
'32215': 'Jacksonville,FL',
'32216': 'Jacksonville,FL',
'32217': 'Jacksonville,FL',
'32218': 'Jacksonville,FL',
'32219': 'Jacksonville,FL',
'32220': 'Jacksonville,FL',
'32221': 'Jacksonville,FL',
'32222': 'Jacksonville,FL',
'32223': 'Jacksonville,FL',
'32224': 'Jacksonville,FL',
'32225': 'Jacksonville,FL',
'32226': 'Jacksonville,FL',
'32227': 'Jacksonville,FL',
'32228': 'Jacksonville,FL',
'32229': 'Jacksonville,FL',
'32230': 'Jacksonville,FL',
'32231': 'Jacksonville,FL',
'32232': 'Jacksonville,FL',
'32233': 'Atlantic Beach,FL',
'32234': 'Jacksonville,FL',
'32235': 'Jacksonville,FL',
'32236': 'Jacksonville,FL',
'32237': 'Jacksonville,FL',
'32238': 'Jacksonville,FL',
'32239': 'Jacksonville,FL',
'32240': 'Jacksonville Beach,FL',
'32241': 'Jacksonville,FL',
'32244': 'Jacksonville,FL',
'32245': 'Jacksonville,FL',
'32246': 'Jacksonville,FL',
'32247': 'Jacksonville,FL',
'32250': 'Jacksonville Beach,FL',
'32254': 'Jacksonville,FL',
'32255': 'Jacksonville,FL',
'32256': 'Jacksonville,FL',
'32257': 'Jacksonville,FL',
'32258': 'Jacksonville,FL',
'32259': 'Jacksonville,FL',
'32260': 'Jacksonville,FL',
'32266': 'Neptune Beach,FL',
'32267': 'Jacksonville,FL',
'32276': 'Jacksonville,FL',
'32277': 'Jacksonville,FL',
'32290': 'Jacksonville,FL',
'32301': 'Tallahassee,FL',
'32302': 'Tallahassee,FL',
'32303': 'Tallahassee,FL',
'32304': 'Tallahassee,FL',
'32305': 'Tallahassee,FL',
'32306': 'Tallahassee,FL',
'32307': 'Tallahassee,FL',
'32308': 'Tallahassee,FL',
'32309': 'Tallahassee,FL',
'32310': 'Tallahassee,FL',
'32311': 'Tallahassee,FL',
'32312': 'Tallahassee,FL',
'32313': 'Tallahassee,FL',
'32314': 'Tallahassee,FL',
'32315': 'Tallahassee,FL',
'32316': 'Tallahassee,FL',
'32317': 'Tallahassee,FL',
'32318': 'Tallahassee,FL',
'32320': 'Apalachicola,FL',
'32321': 'Bristol,FL',
'32322': 'Carrabelle,FL',
'32323': 'Lanark Village,FL',
'32324': 'Chattahoochee,FL',
'32326': 'Crawfordville,FL',
'32327': 'Crawfordville,FL',
'32328': 'Eastpoint,FL',
'32329': 'Apalachicola,FL',
'32330': 'Greensboro,FL',
'32331': 'Greenville,FL',
'32332': 'Gretna,FL',
'32333': 'Havana,FL',
'32334': 'Hosford,FL',
'32335': 'Sumatra,FL',
'32336': 'Lamont,FL',
'32337': 'Lloyd,FL',
'32340': 'Madison,FL',
'32341': 'Madison,FL',
'32343': 'Midway,FL',
'32344': 'Monticello,FL',
'32345': 'Monticello,FL',
'32346': 'Panacea,FL',
'32347': 'Perry,FL',
'32348': 'Perry,FL',
'32350': 'Pinetta,FL',
'32351': 'Quincy,FL',
'32352': 'Quincy,FL',
'32353': 'Quincy,FL',
'32355': 'Saint Marks,FL',
'32356': 'Salem,FL',
'32357': 'Shady Grove,FL',
'32358': 'Sopchoppy,FL',
'32359': 'Steinhatchee,FL',
'32360': 'Telogia,FL',
'32361': 'Wacissa,FL',
'32362': 'Woodville,FL',
'32395': 'Tallahassee,FL',
'32399': 'Tallahassee,FL',
'32401': 'Panama City,FL',
'32402': 'Panama City,FL',
'32403': 'Panama City,FL',
'32404': 'Panama City,FL',
'32405': 'Panama City,FL',
'32406': 'Panama City,FL',
'32407': 'Panama City Beach,FL',
'32408': 'Panama City,FL',
'32409': 'Panama City,FL',
'32410': 'Mexico Beach,FL',
'32411': 'Panama City,FL',
'32412': 'Panama City,FL',
'32413': 'Panama City Beach,FL',
'32417': 'Panama City,FL',
'32420': 'Alford,FL',
'32421': 'Altha,FL',
'32422': 'Argyle,FL',
'32423': 'Bascom,FL',
'32424': 'Blountstown,FL',
'32425': 'Bonifay,FL',
'32426': 'Campbellton,FL',
'32427': 'Caryville,FL',
'32428': 'Chipley,FL',
'32430': 'Clarksville,FL',
'32431': 'Cottondale,FL',
'32432': 'Cypress,FL',
'32433': 'Defuniak Springs,FL',
'32434': 'Mossy Head,FL',
'32435': 'Defuniak Springs,FL',
'32437': 'Ebro,FL',
'32438': 'Fountain,FL',
'32439': 'Freeport,FL',
'32440': 'Graceville,FL',
'32442': 'Grand Ridge,FL',
'32443': 'Greenwood,FL',
'32444': 'Lynn Haven,FL',
'32445': 'Malone,FL',
'32446': 'Marianna,FL',
'32447': 'Marianna,FL',
'32448': 'Marianna,FL',
'32449': 'Kinard,FL',
'32452': 'Noma,FL',
'32454': 'Point Washington,FL',
'32455': 'Ponce De Leon,FL',
'32456': 'Port Saint Joe,FL',
'32457': 'Port Saint Joe,FL',
'32459': 'Santa Rosa Beach,FL',
'32460': 'Sneads,FL',
'32461': 'Rosemary Bch,FL',
'32462': 'Vernon,FL',
'32463': 'Wausau,FL',
'32464': 'Westville,FL',
'32465': 'Wewahitchka,FL',
'32466': 'Youngstown,FL',
'32501': 'Pensacola,FL',
'32502': 'Pensacola,FL',
'32503': 'Pensacola,FL',
'32504': 'Pensacola,FL',
'32505': 'Pensacola,FL',
'32506': 'Pensacola,FL',
'32507': 'Pensacola,FL',
'32508': 'Pensacola,FL',
'32509': 'Pensacola,FL',
'32511': 'Pensacola,FL',
'32512': 'Pensacola,FL',
'32513': 'Pensacola,FL',
'32514': 'Pensacola,FL',
'32516': 'Pensacola,FL',
'32520': 'Pensacola,FL',
'32521': 'Pensacola,FL',
'32522': 'Pensacola,FL',
'32523': 'Pensacola,FL',
'32524': 'Pensacola,FL',
'32526': 'Pensacola,FL',
'32530': 'Bagdad,FL',
'32531': 'Baker,FL',
'32533': 'Cantonment,FL',
'32534': 'Pensacola,FL',
'32535': 'Century,FL',
'32536': 'Crestview,FL',
'32537': 'Milligan,FL',
'32538': 'Paxton,FL',
'32539': 'Crestview,FL',
'32540': 'Destin,FL',
'32541': 'Destin,FL',
'32542': 'Eglin Afb,FL',
'32544': 'Hurlburt Field,FL',
'32547': 'Fort Walton Beach,FL',
'32548': 'Fort Walton Beach,FL',
'32549': 'Fort Walton Beach,FL',
'32550': 'Destin,FL',
'32559': 'Pensacola,FL',
'32560': 'Gonzalez,FL',
'32561': 'Gulf Breeze,FL',
'32562': 'Gulf Breeze,FL',
'32563': 'Gulf Breeze,FL',
'32564': 'Holt,FL',
'32565': 'Jay,FL',
'32566': 'Navarre,FL',
'32567': 'Laurel Hill,FL',
'32568': 'Mc David,FL',
'32569': 'Mary Esther,FL',
'32570': 'Milton,FL',
'32571': 'Milton,FL',
'32572': 'Milton,FL',
'32573': 'Pensacola,FL',
'32574': 'Pensacola,FL',
'32575': 'Pensacola,FL',
'32576': 'Pensacola,FL',
'32577': 'Molino,FL',
'32578': 'Niceville,FL',
'32579': 'Shalimar,FL',
'32580': 'Valparaiso,FL',
'32581': 'Pensacola,FL',
'32582': 'Pensacola,FL',
'32583': 'Milton,FL',
'32588': 'Niceville,FL',
'32589': 'Pensacola,FL',
'32590': 'Pensacola,FL',
'32591': 'Pensacola,FL',
'32592': 'Pensacola,FL',
'32593': 'Pensacola,FL',
'32594': 'Pensacola,FL',
'32595': 'Pensacola,FL',
'32596': 'Pensacola,FL',
'32597': 'Pensacola,FL',
'32598': 'Pensacola,FL',
'32601': 'Gainesville,FL',
'32602': 'Gainesville,FL',
'32603': 'Gainesville,FL',
'32604': 'Gainesville,FL',
'32605': 'Gainesville,FL',
'32606': 'Gainesville,FL',
'32607': 'Gainesville,FL',
'32608': 'Gainesville,FL',
'32609': 'Gainesville,FL',
'32610': 'Gainesville,FL',
'32611': 'Gainesville,FL',
'32612': 'Gainesville,FL',
'32613': 'Gainesville,FL',
'32614': 'Gainesville,FL',
'32615': 'Alachua,FL',
'32616': 'Alachua,FL',
'32617': 'Anthony,FL',
'32618': 'Archer,FL',
'32619': 'Bell,FL',
'32621': 'Bronson,FL',
'32622': 'Brooker,FL',
'32625': 'Cedar Key,FL',
'32626': 'Chiefland,FL',
'32627': 'Gainesville,FL',
'32628': 'Cross City,FL',
'32631': 'Earleton,FL',
'32633': 'Evinston,FL',
'32634': 'Fairfield,FL',
'32635': 'Gainesville,FL',
'32639': 'Gulf Hammock,FL',
'32640': 'Hawthorne,FL',
'32641': 'Gainesville,FL',
'32643': 'High Springs,FL',
'32644': 'Chiefland,FL',
'32648': 'Horseshoe Beach,FL',
'32653': 'Gainesville,FL',
'32654': 'Island Grove,FL',
'32655': 'High Springs,FL',
'32656': 'Keystone Heights,FL',
'32658': 'La Crosse,FL',
'32662': 'Lochloosa,FL',
'32663': 'Lowell,FL',
'32664': 'Mc Intosh,FL',
'32666': 'Melrose,FL',
'32667': 'Micanopy,FL',
'32668': 'Morriston,FL',
'32669': 'Newberry,FL',
'32680': 'Old Town,FL',
'32681': 'Orange Lake,FL',
'32683': 'Otter Creek,FL',
'32686': 'Reddick,FL',
'32692': 'Suwannee,FL',
'32693': 'Trenton,FL',
'32694': 'Waldo,FL',
'32696': 'Williston,FL',
'32697': 'Worthington Springs,FL',
'32701': 'Altamonte Springs,FL',
'32702': 'Altoona,FL',
'32703': 'Apopka,FL',
'32704': 'Apopka,FL',
'32706': 'Cassadaga,FL',
'32707': 'Casselberry,FL',
'32708': 'Winter Springs,FL',
'32709': 'Christmas,FL',
'32710': 'Clarcona,FL',
'32712': 'Apopka,FL',
'32713': 'Debary,FL',
'32714': 'Altamonte Springs,FL',
'32715': 'Altamonte Springs,FL',
'32716': 'Altamonte Springs,FL',
'32718': 'Casselberry,FL',
'32719': 'Winter Springs,FL',
'32720': 'Deland,FL',
'32721': 'Deland,FL',
'32722': 'Glenwood,FL',
'32723': 'Stetson University,FL',
'32724': 'Deland,FL',
'32725': 'Deltona,FL',
'32726': 'Eustis,FL',
'32727': 'Eustis,FL',
'32728': 'Deltona,FL',
'32730': 'Casselberry,FL',
'32732': 'Geneva,FL',
'32733': 'Goldenrod,FL',
'32735': 'Grand Island,FL',
'32736': 'Eustis,FL',
'32738': 'Deltona,FL',
'32739': 'Deltona,FL',
'32744': 'Lake Helen,FL',
'32745': 'Mid Florida,FL',
'32746': 'Lake Mary,FL',
'32747': 'Lake Monroe,FL',
'32750': 'Longwood,FL',
'32751': 'Maitland,FL',
'32752': 'Longwood,FL',
'32753': 'Debary,FL',
'32754': 'Mims,FL',
'32756': 'Mount Dora,FL',
'32757': 'Mount Dora,FL',
'32759': 'Oak Hill,FL',
'32762': 'Oviedo,FL',
'32763': 'Orange City,FL',
'32764': 'Osteen,FL',
'32765': 'Oviedo,FL',
'32766': 'Oviedo,FL',
'32767': 'Paisley,FL',
'32768': 'Plymouth,FL',
'32771': 'Sanford,FL',
'32772': 'Sanford,FL',
'32773': 'Sanford,FL',
'32774': 'Orange City,FL',
'32775': 'Scottsmoor,FL',
'32776': 'Sorrento,FL',
'32777': 'Tangerine,FL',
'32778': 'Tavares,FL',
'32779': 'Longwood,FL',
'32780': 'Titusville,FL',
'32781': 'Titusville,FL',
'32782': 'Titusville,FL',
'32783': 'Titusville,FL',
'32784': 'Umatilla,FL',
'32789': 'Winter Park,FL',
'32790': 'Winter Park,FL',
'32791': 'Longwood,FL',
'32792': 'Winter Park,FL',
'32793': 'Winter Park,FL',
'32794': 'Maitland,FL',
'32795': 'Lake Mary,FL',
'32796': 'Titusville,FL',
'32798': 'Zellwood,FL',
'32799': 'Mid Florida,FL',
'32801': 'Orlando,FL',
'32802': 'Orlando,FL',
'32803': 'Orlando,FL',
'32804': 'Orlando,FL',
'32805': 'Orlando,FL',
'32806': 'Orlando,FL',
'32807': 'Orlando,FL',
'32808': 'Orlando,FL',
'32809': 'Orlando,FL',
'32810': 'Orlando,FL',
'32811': 'Orlando,FL',
'32812': 'Orlando,FL',
'32814': 'Orlando,FL',
'32815': 'Orlando,FL',
'32816': 'Orlando,FL',
'32817': 'Orlando,FL',
'32818': 'Orlando,FL',
'32819': 'Orlando,FL',
'32820': 'Orlando,FL',
'32821': 'Orlando,FL',
'32822': 'Orlando,FL',
'32824': 'Orlando,FL',
'32825': 'Orlando,FL',
'32826': 'Orlando,FL',
'32827': 'Orlando,FL',
'32828': 'Orlando,FL',
'32829': 'Orlando,FL',
'32830': 'Orlando,FL',
'32831': 'Orlando,FL',
'32832': 'Orlando,FL',
'32833': 'Orlando,FL',
'32834': 'Orlando,FL',
'32835': 'Orlando,FL',
'32836': 'Orlando,FL',
'32837': 'Orlando,FL',
'32839': 'Orlando,FL',
'32853': 'Orlando,FL',
'32854': 'Orlando,FL',
'32855': 'Orlando,FL',
'32856': 'Orlando,FL',
'32857': 'Orlando,FL',
'32858': 'Orlando,FL',
'32859': 'Orlando,FL',
'32860': 'Orlando,FL',
'32861': 'Orlando,FL',
'32862': 'Orlando,FL',
'32867': 'Orlando,FL',
'32868': 'Orlando,FL',
'32869': 'Orlando,FL',
'32872': 'Orlando,FL',
'32877': 'Orlando,FL',
'32878': 'Orlando,FL',
'32885': 'Orlando,FL',
'32886': 'Orlando,FL',
'32887': 'Orlando,FL',
'32890': 'Orlando,FL',
'32891': 'Orlando,FL',
'32893': 'Orlando,FL',
'32896': 'Orlando,FL',
'32897': 'Orlando,FL',
'32898': 'Orlando,FL',
'32899': 'Orlando,FL',
'32901': 'Melbourne,FL',
'32902': 'Melbourne,FL',
'32903': 'Indialantic,FL',
'32904': 'Melbourne,FL',
'32905': 'Palm Bay,FL',
'32906': 'Palm Bay,FL',
'32907': 'Palm Bay,FL',
'32908': 'Palm Bay,FL',
'32909': 'Palm Bay,FL',
'32910': 'Palm Bay,FL',
'32911': 'Palm Bay,FL',
'32912': 'Melbourne,FL',
'32919': 'Melbourne,FL',
'32920': 'Cape Canaveral,FL',
'32922': 'Cocoa,FL',
'32923': 'Cocoa,FL',
'32924': 'Cocoa,FL',
'32925': 'Patrick Afb,FL',
'32926': 'Cocoa,FL',
'32927': 'Cocoa,FL',
'32931': 'Cocoa Beach,FL',
'32932': 'Cocoa Beach,FL',
'32934': 'Melbourne,FL',
'32935': 'Melbourne,FL',
'32936': 'Melbourne,FL',
'32937': 'Satellite Beach,FL',
'32940': 'Melbourne,FL',
'32941': 'Melbourne,FL',
'32948': 'Fellsmere,FL',
'32949': 'Grant,FL',
'32950': 'Malabar,FL',
'32951': 'Melbourne Beach,FL',
'32952': 'Merritt Island,FL',
'32953': 'Merritt Island,FL',
'32954': 'Merritt Island,FL',
'32955': 'Rockledge,FL',
'32956': 'Rockledge,FL',
'32957': 'Roseland,FL',
'32958': 'Sebastian,FL',
'32959': 'Sharpes,FL',
'32960': 'Vero Beach,FL',
'32961': 'Vero Beach,FL',
'32962': 'Vero Beach,FL',
'32963': 'Vero Beach,FL',
'32964': 'Vero Beach,FL',
'32965': 'Vero Beach,FL',
'32966': 'Vero Beach,FL',
'32967': 'Vero Beach,FL',
'32968': 'Vero Beach,FL',
'32969': 'Vero Beach,FL',
'32970': 'Wabasso,FL',
'32971': 'Winter Beach,FL',
'32976': 'Sebastian,FL',
'32978': 'Sebastian,FL',
'33001': 'Long Key,FL',
'33002': 'Hialeah,FL',
'33004': 'Dania,FL',
'33008': 'Hallandale,FL',
'33009': 'Hallandale,FL',
'33010': 'Hialeah,FL',
'33011': 'Hialeah,FL',
'33012': 'Hialeah,FL',
'33013': 'Hialeah,FL',
'33014': 'Hialeah,FL',
'33015': 'Hialeah,FL',
'33016': 'Hialeah,FL',
'33017': 'Hialeah,FL',
'33018': 'Hialeah,FL',
'33019': 'Hollywood,FL',
'33020': 'Hollywood,FL',
'33021': 'Hollywood,FL',
'33022': 'Hollywood,FL',
'33023': 'Hollywood,FL',
'33024': 'Hollywood,FL',
'33025': 'Hollywood,FL',
'33026': 'Hollywood,FL',
'33027': 'Hollywood,FL',
'33028': 'Hollywood,FL',
'33029': 'Hollywood,FL',
'33030': 'Homestead,FL',
'33031': 'Homestead,FL',
'33032': 'Homestead,FL',
'33033': 'Homestead,FL',
'33034': 'Homestead,FL',
'33035': 'Homestead,FL',
'33036': 'Islamorada,FL',
'33037': 'Key Largo,FL',
'33039': 'Homestead,FL',
'33040': 'Key West,FL',
'33041': 'Key West,FL',
'33042': 'Summerland Key,FL',
'33043': 'Big Pine Key,FL',
'33044': 'Sugarloaf Shores,FL',
'33045': 'Key West,FL',
'33050': 'Marathon,FL',
'33051': 'Key Colony Beach,FL',
'33052': 'Marathon Shores,FL',
'33054': 'Opa Locka,FL',
'33055': 'Opa Locka,FL',
'33056': 'Opa Locka,FL',
'33060': 'Pompano Beach,FL',
'33061': 'Pompano Beach,FL',
'33062': 'Pompano Beach,FL',
'33063': 'Pompano Beach,FL',
'33064': 'Pompano Beach,FL',
'33065': 'Pompano Beach,FL',
'33066': 'Pompano Beach,FL',
'33067': 'Pompano Beach,FL',
'33068': 'Pompano Beach,FL',
'33069': 'Pompano Beach,FL',
'33070': 'Tavernier,FL',
'33071': 'Pompano Beach,FL',
'33072': 'Pompano Beach,FL',
'33073': 'Pompano Beach,FL',
'33074': 'Pompano Beach,FL',
'33075': 'Pompano Beach,FL',
'33076': 'Pompano Beach,FL',
'33077': 'Pompano Beach,FL',
'33081': 'Hollywood,FL',
'33082': 'Pembroke Pines,FL',
'33083': 'Hollywood,FL',
'33084': 'Hollywood,FL',
'33090': 'Homestead,FL',
'33092': 'Homestead,FL',
'33093': 'Pompano Beach,FL',
'33097': 'Pompano Beach,FL',
'33101': 'Miami,FL',
'33102': 'Miami,FL',
'33107': 'Miami,FL',
'33109': 'Miami Beach,FL',
'33110': 'Miami,FL',
'33111': 'Miami,FL',
'33112': 'Miami,FL',
'33114': 'Miami,FL',
'33116': 'Miami,FL',
'33119': 'Miami Beach,FL',
'33121': 'Miami,FL',
'33122': 'Miami,FL',
'33124': 'Miami,FL',
'33125': 'Miami,FL',
'33126': 'Miami,FL',
'33127': 'Miami,FL',
'33128': 'Miami,FL',
'33129': 'Miami,FL',
'33130': 'Miami,FL',
'33131': 'Miami,FL',
'33132': 'Miami,FL',
'33133': 'Miami,FL',
'33134': 'Miami,FL',
'33135': 'Miami,FL',
'33136': 'Miami,FL',
'33137': 'Miami,FL',
'33138': 'Miami,FL',
'33139': 'Miami Beach,FL',
'33140': 'Miami Beach,FL',
'33141': 'Miami Beach,FL',
'33142': 'Miami,FL',
'33143': 'Miami,FL',
'33144': 'Miami,FL',
'33145': 'Miami,FL',
'33146': 'Miami,FL',
'33147': 'Miami,FL',
'33148': 'Miami,FL',
'33149': 'Key Biscayne,FL',
'33150': 'Miami,FL',
'33151': 'Miami,FL',
'33152': 'Miami,FL',
'33153': 'Miami,FL',
'33154': 'Miami,FL',
'33155': 'Miami,FL',
'33156': 'Miami,FL',
'33157': 'Miami,FL',
'33158': 'Miami,FL',
'33159': 'Miami,FL',
'33160': 'North Miami Beach,FL',
'33161': 'Miami,FL',
'33162': 'Miami,FL',
'33163': 'Miami,FL',
'33164': 'Miami,FL',
'33165': 'Miami,FL',
'33166': 'Miami,FL',
'33167': 'Miami,FL',
'33168': 'Miami,FL',
'33169': 'Miami,FL',
'33170': 'Miami,FL',
'33172': 'Miami,FL',
'33173': 'Miami,FL',
'33174': 'Miami,FL',
'33175': 'Miami,FL',
'33176': 'Miami,FL',
'33177': 'Miami,FL',
'33178': 'Miami,FL',
'33179': 'Miami,FL',
'33180': 'Miami,FL',
'33181': 'Miami,FL',
'33182': 'Miami,FL',
'33183': 'Miami,FL',
'33184': 'Miami,FL',
'33185': 'Miami,FL',
'33186': 'Miami,FL',
'33187': 'Miami,FL',
'33188': 'Miami,FL',
'33189': 'Miami,FL',
'33190': 'Miami,FL',
'33193': 'Miami,FL',
'33194': 'Miami,FL',
'33195': 'Miami,FL',
'33196': 'Miami,FL',
'33197': 'Miami,FL',
'33199': 'Miami,FL',
'33231': 'Miami,FL',
'33233': 'Miami,FL',
'33234': 'Miami,FL',
'33238': 'Miami,FL',
'33239': 'Miami Beach,FL',
'33242': 'Miami,FL',
'33243': 'Miami,FL',
'33245': 'Miami,FL',
'33247': 'Miami,FL',
'33255': 'Miami,FL',
'33256': 'Miami,FL',
'33257': 'Miami,FL',
'33261': 'Miami,FL',
'33265': 'Miami,FL',
'33266': 'Miami,FL',
'33269': 'Miami,FL',
'33280': 'Miami,FL',
'33283': 'Miami,FL',
'33296': 'Miami,FL',
'33299': 'Miami,FL',
'33301': 'Fort Lauderdale,FL',
'33302': 'Fort Lauderdale,FL',
'33303': 'Fort Lauderdale,FL',
'33304': 'Fort Lauderdale,FL',
'33305': 'Fort Lauderdale,FL',
'33306': 'Fort Lauderdale,FL',
'33307': 'Fort Lauderdale,FL',
'33308': 'Fort Lauderdale,FL',
'33309': 'Fort Lauderdale,FL',
'33310': 'Fort Lauderdale,FL',
'33311': 'Fort Lauderdale,FL',
'33312': 'Fort Lauderdale,FL',
'33313': 'Fort Lauderdale,FL',
'33314': 'Fort Lauderdale,FL',
'33315': 'Fort Lauderdale,FL',
'33316': 'Fort Lauderdale,FL',
'33317': 'Fort Lauderdale,FL',
'33318': 'Fort Lauderdale,FL',
'33319': 'Fort Lauderdale,FL',
'33320': 'Fort Lauderdale,FL',
'33321': 'Fort Lauderdale,FL',
'33322': 'Fort Lauderdale,FL',
'33323': 'Fort Lauderdale,FL',
'33324': 'Fort Lauderdale,FL',
'33325': 'Fort Lauderdale,FL',
'33326': 'Fort Lauderdale,FL',
'33327': 'Fort Lauderdale,FL',
'33328': 'Fort Lauderdale,FL',
'33329': 'Fort Lauderdale,FL',
'33330': 'Fort Lauderdale,FL',
'33331': 'Fort Lauderdale,FL',
'33332': 'Fort Lauderdale,FL',
'33334': 'Fort Lauderdale,FL',
'33335': 'Fort Lauderdale,FL',
'33336': 'Ft Lauderdale,FL',
'33337': 'Fort Lauderdale,FL',
'33338': 'Fort Lauderdale,FL',
'33339': 'Fort Lauderdale,FL',
'33340': 'Fort Lauderdale,FL',
'33345': 'Fort Lauderdale,FL',
'33346': 'Fort Lauderdale,FL',
'33348': 'Fort Lauderdale,FL',
'33349': 'Fort Lauderdale,FL',
'33351': 'Fort Lauderdale,FL',
'33355': 'Fort Lauderdale,FL',
'33359': 'Fort Lauderdale,FL',
'33388': 'Fort Lauderdale,FL',
'33394': 'Fort Lauderdale,FL',
'33401': 'West Palm Beach,FL',
'33402': 'West Palm Beach,FL',
'33403': 'West Palm Beach,FL',
'33404': 'West Palm Beach,FL',
'33405': 'West Palm Beach,FL',
'33406': 'West Palm Beach,FL',
'33407': 'West Palm Beach,FL',
'33408': 'North Palm Beach,FL',
'33409': 'West Palm Beach,FL',
'33410': 'West Palm Beach,FL',
'33411': 'West Palm Beach,FL',
'33412': 'West Palm Beach,FL',
'33413': 'West Palm Beach,FL',
'33414': 'West Palm Beach,FL',
'33415': 'West Palm Beach,FL',
'33416': 'West Palm Beach,FL',
'33417': 'West Palm Beach,FL',
'33418': 'West Palm Beach,FL',
'33419': 'West Palm Beach,FL',
'33420': 'West Palm Beach,FL',
'33421': 'West Palm Beach,FL',
'33422': 'West Palm Beach,FL',
'33424': 'Boynton Beach,FL',
'33425': 'Boynton Beach,FL',
'33426': 'Boynton Beach,FL',
'33427': 'Boca Raton,FL',
'33428': 'Boca Raton,FL',
'33429': 'Boca Raton,FL',
'33430': 'Belle Glade,FL',
'33431': 'Boca Raton,FL',
'33432': 'Boca Raton,FL',
'33433': 'Boca Raton,FL',
'33434': 'Boca Raton,FL',
'33435': 'Boynton Beach,FL',
'33436': 'Boynton Beach,FL',
'33437': 'Boynton Beach,FL',
'33438': 'Canal Point,FL',
'33439': 'Bryant,FL',
'33440': 'Clewiston,FL',
'33441': 'Deerfield Beach,FL',
'33442': 'Deerfield Beach,FL',
'33443': 'Deerfield Beach,FL',
'33444': 'Delray Beach,FL',
'33445': 'Delray Beach,FL',
'33446': 'Delray Beach,FL',
'33447': 'Delray Beach,FL',
'33448': 'Delray Beach,FL',
'33454': 'Lake Worth,FL',
'33455': 'Hobe Sound,FL',
'33458': 'Jupiter,FL',
'33459': 'Lake Harbor,FL',
'33460': 'Lake Worth,FL',
'33461': 'Lake Worth,FL',
'33462': 'Lake Worth,FL',
'33463': 'Lake Worth,FL',
'33464': 'Boca Raton,FL',
'33465': 'Lake Worth,FL',
'33466': 'Lake Worth,FL',
'33467': 'Lake Worth,FL',
'33468': 'Jupiter,FL',
'33469': 'Jupiter,FL',
'33470': 'Loxahatchee,FL',
'33471': 'Moore Haven,FL',
'33474': 'Boynton Beach,FL',
'33475': 'Hobe Sound,FL',
'33476': 'Pahokee,FL',
'33477': 'Jupiter,FL',
'33478': 'Jupiter,FL',
'33480': 'Palm Beach,FL',
'33481': 'Boca Raton,FL',
'33482': 'Delray Beach,FL',
'33483': 'Delray Beach,FL',
'33484': 'Delray Beach,FL',
'33486': 'Boca Raton,FL',
'33487': 'Boca Raton,FL',
'33488': 'Boca Raton,FL',
'33493': 'South Bay,FL',
'33496': 'Boca Raton,FL',
'33497': 'Boca Raton,FL',
'33498': 'Boca Raton,FL',
'33499': 'Boca Raton,FL',
'33503': 'Balm,FL',
'33508': 'Brandon,FL',
'33509': 'Brandon,FL',
'33510': 'Brandon,FL',
'33511': 'Brandon,FL',
'33513': 'Bushnell,FL',
'33514': 'Center Hill,FL',
'33521': 'Coleman,FL',
'33523': 'Dade City,FL',
'33524': 'Crystal Springs,FL',
'33525': 'Dade City,FL',
'33526': 'Dade City,FL',
'33527': 'Dover,FL',
'33530': 'Durant,FL',
'33534': 'Gibsonton,FL',
'33537': 'Lacoochee,FL',
'33538': 'Lake Panasoffkee,FL',
'33539': 'Zephyrhills,FL',
'33540': 'Zephyrhills,FL',
'33541': 'Zephyrhills,FL',
'33542': 'Zephyrhills,FL',
'33543': 'Zephyrhills,FL',
'33544': 'Zephyrhills,FL',
'33547': 'Lithia,FL',
'33548': 'Lutz,FL',
'33549': 'Lutz,FL',
'33550': 'Mango,FL',
'33556': 'Odessa,FL',
'33558': 'Lutz,FL',
'33559': 'Lutz,FL',
'33563': 'Plant City,FL',
'33564': 'Plant City,FL',
'33565': 'Plant City,FL',
'33566': 'Plant City,FL',
'33567': 'Plant City,FL',
'33568': 'Riverview,FL',
'33569': 'Riverview,FL',
'33570': 'Ruskin,FL',
'33571': 'Sun City Center,FL',
'33572': 'Apollo Beach,FL',
'33573': 'Sun City Center,FL',
'33574': 'Saint Leo,FL',
'33575': 'Sun City Ctr,FL',
'33576': 'San Antonio,FL',
'33583': 'Seffner,FL',
'33584': 'Seffner,FL',
'33585': 'Sumterville,FL',
'33586': 'Sun City,FL',
'33587': 'Sydney,FL',
'33592': 'Thonotosassa,FL',
'33593': 'Trilby,FL',
'33594': 'Valrico,FL',
'33595': 'Valrico,FL',
'33597': 'Webster,FL',
'33598': 'Wimauma,FL',
'33601': 'Tampa,FL',
'33602': 'Tampa,FL',
'33603': 'Tampa,FL',
'33604': 'Tampa,FL',
'33605': 'Tampa,FL',
'33606': 'Tampa,FL',
'33607': 'Tampa,FL',
'33608': 'Tampa,FL',
'33609': 'Tampa,FL',
'33610': 'Tampa,FL',
'33611': 'Tampa,FL',
'33612': 'Tampa,FL',
'33613': 'Tampa,FL',
'33614': 'Tampa,FL',
'33615': 'Tampa,FL',
'33616': 'Tampa,FL',
'33617': 'Tampa,FL',
'33618': 'Tampa,FL',
'33619': 'Tampa,FL',
'33620': 'Tampa,FL',
'33621': 'Tampa,FL',
'33622': 'Tampa,FL',
'33623': 'Tampa,FL',
'33624': 'Tampa,FL',
'33625': 'Tampa,FL',
'33626': 'Tampa,FL',
'33629': 'Tampa,FL',
'33630': 'Tampa,FL',
'33631': 'Tampa,FL',
'33633': 'Tampa,FL',
'33634': 'Tampa,FL',
'33635': 'Tampa,FL',
'33637': 'Tampa,FL',
'33647': 'Tampa,FL',
'33650': 'Tampa,FL',
'33651': 'Tampa,FL',
'33655': 'Tampa,FL',
'33660': 'Tampa,FL',
'33661': 'Tampa,FL',
'33662': 'Tampa,FL',
'33663': 'Tampa,FL',
'33664': 'Tampa,FL',
'33672': 'Tampa,FL',
'33673': 'Tampa,FL',
'33674': 'Tampa,FL',
'33675': 'Tampa,FL',
'33677': 'Tampa,FL',
'33679': 'Tampa,FL',
'33680': 'Tampa,FL',
'33681': 'Tampa,FL',
'33682': 'Tampa,FL',
'33684': 'Tampa,FL',
'33685': 'Tampa,FL',
'33686': 'Tampa,FL',
'33687': 'Tampa,FL',
'33688': 'Tampa,FL',
'33689': 'Tampa,FL',
'33690': 'Tampa,FL',
'33694': 'Tampa,FL',
'33697': 'Tampa,FL',
'33701': 'Saint Petersburg,FL',
'33702': 'Saint Petersburg,FL',
'33703': 'Saint Petersburg,FL',
'33704': 'Saint Petersburg,FL',
'33705': 'Saint Petersburg,FL',
'33706': 'Saint Petersburg,FL',
'33707': 'Saint Petersburg,FL',
'33708': 'Saint Petersburg,FL',
'33709': 'Saint Petersburg,FL',
'33710': 'Saint Petersburg,FL',
'33711': 'Saint Petersburg,FL',
'33712': 'Saint Petersburg,FL',
'33713': 'Saint Petersburg,FL',
'33714': 'Saint Petersburg,FL',
'33715': 'Saint Petersburg,FL',
'33716': 'Saint Petersburg,FL',
'33728': 'Saint Petersburg,FL',
'33729': 'Saint Petersburg,FL',
'33730': 'Saint Petersburg,FL',
'33731': 'Saint Petersburg,FL',
'33732': 'Saint Petersburg,FL',
'33733': 'Saint Petersburg,FL',
'33734': 'Saint Petersburg,FL',
'33736': 'Saint Petersburg,FL',
'33737': 'Saint Petersburg,FL',
'33738': 'Saint Petersburg,FL',
'33740': 'Saint Petersburg,FL',
'33741': 'Saint Petersburg,FL',
'33742': 'Saint Petersburg,FL',
'33743': 'Saint Petersburg,FL',
'33744': 'Bay Pines,FL',
'33747': 'Saint Petersburg,FL',
'33755': 'Clearwater,FL',
'33756': 'Clearwater,FL',
'33757': 'Clearwater,FL',
'33758': 'Clearwater,FL',
'33759': 'Clearwater,FL',
'33760': 'Clearwater,FL',
'33761': 'Clearwater,FL',
'33762': 'Clearwater,FL',
'33763': 'Clearwater,FL',
'33764': 'Clearwater,FL',
'33765': 'Clearwater,FL',
'33766': 'Clearwater,FL',
'33767': 'Clearwater Beach,FL',
'33769': 'Clearwater,FL',
'33770': 'Largo,FL',
'33771': 'Largo,FL',
'33772': 'Seminole,FL',
'33773': 'Largo,FL',
'33774': 'Largo,FL',
'33775': 'Seminole,FL',
'33776': 'Seminole,FL',
'33777': 'Seminole,FL',
'33778': 'Largo,FL',
'33779': 'Largo,FL',
'33780': 'Pinellas Park,FL',
'33781': 'Pinellas Park,FL',
'33782': 'Pinellas Park,FL',
'33784': 'Saint Petersburg,FL',
'33785': 'Indian Rocks Beach,FL',
'33786': 'Belleair Beach,FL',
'33801': 'Lakeland,FL',
'33802': 'Lakeland,FL',
'33803': 'Lakeland,FL',
'33804': 'Lakeland,FL',
'33805': 'Lakeland,FL',
'33806': 'Lakeland,FL',
'33807': 'Lakeland,FL',
'33809': 'Lakeland,FL',
'33810': 'Lakeland,FL',
'33811': 'Lakeland,FL',
'33812': 'Lakeland,FL',
'33813': 'Lakeland,FL',
'33815': 'Lakeland,FL',
'33820': 'Alturas,FL',
'33823': 'Auburndale,FL',
'33825': 'Avon Park,FL',
'33826': 'Avon Park,FL',
'33827': 'Babson Park,FL',
'33830': 'Bartow,FL',
'33831': 'Bartow,FL',
'33834': 'Bowling Green,FL',
'33835': 'Bradley,FL',
'33836': 'Davenport,FL',
'33837': 'Davenport,FL',
'33838': 'Dundee,FL',
'33839': 'Eagle Lake,FL',
'33840': 'Eaton Park,FL',
'33841': 'Fort Meade,FL',
'33843': 'Frostproof,FL',
'33844': 'Haines City,FL',
'33845': 'Haines City,FL',
'33846': 'Highland City,FL',
'33847': 'Homeland,FL',
'33848': 'Intercession City,FL',
'33849': 'Kathleen,FL',
'33850': 'Lake Alfred,FL',
'33851': 'Lake Hamilton,FL',
'33852': 'Lake Placid,FL',
'33853': 'Lake Wales,FL',
'33854': 'Fedhaven,FL',
'33855': 'Indian Lake Estates,FL',
'33856': 'Nalcrest,FL',
'33857': 'Lorida,FL',
'33858': 'Loughman,FL',
'33859': 'Lake Wales,FL',
'33860': 'Mulberry,FL',
'33862': 'Lake Placid,FL',
'33863': 'Nichols,FL',
'33865': 'Ona,FL',
'33867': 'River Ranch,FL',
'33868': 'Polk City,FL',
'33870': 'Sebring,FL',
'33871': 'Sebring,FL',
'33872': 'Sebring,FL',
'33873': 'Wauchula,FL',
'33875': 'Sebring,FL',
'33876': 'Sebring,FL',
'33877': 'Waverly,FL',
'33880': 'Winter Haven,FL',
'33881': 'Winter Haven,FL',
'33882': 'Winter Haven,FL',
'33883': 'Winter Haven,FL',
'33884': 'Winter Haven,FL',
'33885': 'Winter Haven,FL',
'33888': 'Winter Haven,FL',
'33890': 'Zolfo Springs,FL',
'33896': 'Davenport,FL',
'33897': 'Davenport,FL',
'33898': 'Lake Wales,FL',
'33900': 'Fort Myers,FL',
'33901': 'Fort Myers,FL',
'33902': 'Fort Myers,FL',
'33903': 'North Fort Myers,FL',
'33904': 'Cape Coral,FL',
'33905': 'Fort Myers,FL',
'33906': 'Fort Myers,FL',
'33907': 'Fort Myers,FL',
'33908': 'Fort Myers,FL',
'33909': 'Cape Coral,FL',
'33910': 'Cape Coral,FL',
'33911': 'Fort Myers,FL',
'33912': 'Fort Myers,FL',
'33913': 'Fort Myers,FL',
'33914': 'Cape Coral,FL',
'33915': 'Cape Coral,FL',
'33916': 'Fort Myers,FL',
'33917': 'North Fort Myers,FL',
'33918': 'North Fort Myers,FL',
'33919': 'Fort Myers,FL',
'33920': 'Alva,FL',
'33921': 'Boca Grande,FL',
'33922': 'Bokeelia,FL',
'33924': 'Captiva,FL',
'33927': 'El Jobean,FL',
'33928': 'Estero,FL',
'33929': 'Estero,FL',
'33930': 'Felda,FL',
'33931': 'Fort Myers Beach,FL',
'33932': 'Fort Myers Beach,FL',
'33935': 'Labelle,FL',
'33936': 'Lehigh Acres,FL',
'33938': 'Murdock,FL',
'33944': 'Palmdale,FL',
'33945': 'Pineland,FL',
'33946': 'Placida,FL',
'33947': 'Rotonda West,FL',
'33948': 'Port Charlotte,FL',
'33949': 'Port Charlotte,FL',
'33950': 'Punta Gorda,FL',
'33951': 'Punta Gorda,FL',
'33952': 'Port Charlotte,FL',
'33953': 'Port Charlotte,FL',
'33954': 'Port Charlotte,FL',
'33955': 'Punta Gorda,FL',
'33956': 'Saint James City,FL',
'33957': 'Sanibel,FL',
'33960': 'Venus,FL',
'33965': 'Fort Myers,FL',
'33966': 'Ft Myers,FL',
'33967': 'San Carlos Park,FL',
'33970': 'Lehigh Acres,FL',
'33971': 'Lehigh Acres,FL',
'33972': 'Lehigh Acres,FL',
'33975': 'Labelle,FL',
'33980': 'Port Charlotte,FL',
'33981': 'Port Charlotte,FL',
'33982': 'Punta Gorda,FL',
'33983': 'Punta Gorda,FL',
'33990': 'Cape Coral,FL',
'33991': 'Cape Coral,FL',
'33993': 'Cape Coral,FL',
'33994': 'Fort Myers,FL',
'34101': 'Naples,FL',
'34102': 'Naples,FL',
'34103': 'Naples,FL',
'34104': 'Naples,FL',
'34105': 'Naples,FL',
'34106': 'Naples,FL',
'34107': 'Vanderbilt Beach,FL',
'34108': 'Naples,FL',
'34109': 'Naples,FL',
'34110': 'Naples,FL',
'34112': 'Naples,FL',
'34113': 'Naples,FL',
'34114': 'Naples,FL',
'34116': 'Naples,FL',
'34117': 'Naples,FL',
'34119': 'Naples,FL',
'34120': 'Naples,FL',
'34133': 'Bonita Springs,FL',
'34134': 'Bonita Springs,FL',
'34135': 'Bonita Springs,FL',
'34136': 'Bonita Springs,FL',
'34137': 'Copeland,FL',
'34138': 'Chokoloskee,FL',
'34139': 'Everglades City,FL',
'34140': 'Goodland,FL',
'34141': 'Ochopee,FL',
'34142': 'Immokalee,FL',
'34143': 'Immokalee,FL',
'34145': 'Marco Island,FL',
'34146': 'Marco Island,FL',
'34201': 'Bradenton,FL',
'34202': 'Bradenton,FL',
'34203': 'Bradenton,FL',
'34204': 'Bradenton,FL',
'34205': 'Bradenton,FL',
'34206': 'Bradenton,FL',
'34207': 'Bradenton,FL',
'34208': 'Bradenton,FL',
'34209': 'Bradenton,FL',
'34210': 'Bradenton,FL',
'34211': 'Bradenton,FL',
'34212': 'Bradenton,FL',
'34215': 'Cortez,FL',
'34216': 'Anna Maria,FL',
'34217': 'Bradenton Beach,FL',
'34218': 'Holmes Beach,FL',
'34219': 'Parrish,FL',
'34220': 'Palmetto,FL',
'34221': 'Palmetto,FL',
'34222': 'Ellenton,FL',
'34223': 'Englewood,FL',
'34224': 'Englewood,FL',
'34228': 'Longboat Key,FL',
'34229': 'Osprey,FL',
'34230': 'Sarasota,FL',
'34231': 'Sarasota,FL',
'34232': 'Sarasota,FL',
'34233': 'Sarasota,FL',
'34234': 'Sarasota,FL',
'34235': 'Sarasota,FL',
'34236': 'Sarasota,FL',
'34237': 'Sarasota,FL',
'34238': 'Sarasota,FL',
'34239': 'Sarasota,FL',
'34240': 'Sarasota,FL',
'34241': 'Sarasota,FL',
'34242': 'Sarasota,FL',
'34243': 'Sarasota,FL',
'34250': 'Terra Ceia,FL',
'34251': 'Myakka City,FL',
'34260': 'Manasota,FL',
'34264': 'Oneco,FL',
'34265': 'Arcadia,FL',
'34266': 'Arcadia,FL',
'34267': 'Fort Ogden,FL',
'34268': 'Nocatee,FL',
'34269': 'Arcadia,FL',
'34270': 'Tallevast,FL',
'34272': 'Laurel,FL',
'34274': 'Nokomis,FL',
'34275': 'Nokomis,FL',
'34276': 'Sarasota,FL',
'34277': 'Sarasota,FL',
'34278': 'Sarasota,FL',
'34280': 'Bradenton,FL',
'34281': 'Bradenton,FL',
'34282': 'Bradenton,FL',
'34284': 'Venice,FL',
'34285': 'Venice,FL',
'34286': 'North Port,FL',
'34287': 'North Port,FL',
'34288': 'North Port,FL',
'34289': 'North Port,FL',
'34292': 'Venice,FL',
'34293': 'Venice,FL',
'34295': 'Englewood,FL',
'34420': 'Belleview,FL',
'34421': 'Belleview,FL',
'34423': 'Crystal River,FL',
'34428': 'Crystal River,FL',
'34429': 'Crystal River,FL',
'34430': 'Dunnellon,FL',
'34431': 'Dunnellon,FL',
'34432': 'Dunnellon,FL',
'34433': 'Dunnellon,FL',
'34434': 'Dunnellon,FL',
'34436': 'Floral City,FL',
'34442': 'Hernando,FL',
'34445': 'Holder,FL',
'34446': 'Homosassa,FL',
'34447': 'Homosassa Springs,FL',
'34448': 'Homosassa,FL',
'34449': 'Inglis,FL',
'34450': 'Inverness,FL',
'34451': 'Inverness,FL',
'34452': 'Inverness,FL',
'34453': 'Inverness,FL',
'34460': 'Lecanto,FL',
'34461': 'Lecanto,FL',
'34464': 'Beverly Hills,FL',
'34465': 'Beverly Hills,FL',
'34470': 'Ocala,FL',
'34471': 'Ocala,FL',
'34472': 'Ocala,FL',
'34473': 'Ocala,FL',
'34474': 'Ocala,FL',
'34475': 'Ocala,FL',
'34476': 'Ocala,FL',
'34477': 'Ocala,FL',
'34478': 'Ocala,FL',
'34479': 'Ocala,FL',
'34480': 'Ocala,FL',
'34481': 'Ocala,FL',
'34482': 'Ocala,FL',
'34483': 'Ocala,FL',
'34484': 'Oxford,FL',
'34487': 'Homosassa,FL',
'34488': 'Silver Springs,FL',
'34489': 'Silver Springs,FL',
'34491': 'Summerfield,FL',
'34492': 'Summerfield,FL',
'34498': 'Yankeetown,FL',
'34601': 'Brooksville,FL',
'34602': 'Brooksville,FL',
'34603': 'Brooksville,FL',
'34604': 'Brooksville,FL',
'34605': 'Brooksville,FL',
'34606': 'Spring Hill,FL',
'34607': 'Spring Hill,FL',
'34608': 'Spring Hill,FL',
'34609': 'Spring Hill,FL',
'34610': 'Spring Hill,FL',
'34611': 'Spring Hill,FL',
'34613': 'Brooksville,FL',
'34614': 'Brooksville,FL',
'34636': 'Istachatta,FL',
'34637': 'Land O Lakes,FL',
'34638': 'Land O Lakes,FL',
'34639': 'Land O Lakes,FL',
'34652': 'New Port Richey,FL',
'34653': 'New Port Richey,FL',
'34654': 'New Port Richey,FL',
'34655': 'New Port Richey,FL',
'34656': 'New Port Richey,FL',
'34660': 'Ozona,FL',
'34661': 'Nobleton,FL',
'34667': 'Hudson,FL',
'34668': 'Port Richey,FL',
'34669': 'Hudson,FL',
'34673': 'Port Richey,FL',
'34674': 'Hudson,FL',
'34677': 'Oldsmar,FL',
'34679': 'Aripeka,FL',
'34680': 'Elfers,FL',
'34681': 'Crystal Beach,FL',
'34682': 'Palm Harbor,FL',
'34683': 'Palm Harbor,FL',
'34684': 'Palm Harbor,FL',
'34685': 'Palm Harbor,FL',
'34688': 'Tarpon Springs,FL',
'34689': 'Tarpon Springs,FL',
'34690': 'Holiday,FL',
'34691': 'Holiday,FL',
'34692': 'Tarpon Springs,FL',
'34695': 'Safety Harbor,FL',
'34697': 'Dunedin,FL',
'34698': 'Dunedin,FL',
'34705': 'Astatula,FL',
'34711': 'Clermont,FL',
'34712': 'Clermont,FL',
'34713': 'Clermont,FL',
'34714': 'Clermont South Branch Postal,FL',
'34715': 'Minneola,FL',
'34729': 'Ferndale,FL',
'34731': 'Fruitland Park,FL',
'34734': 'Gotha,FL',
'34736': 'Groveland,FL',
'34737': 'Howey In The Hills,FL',
'34739': 'Kenansville,FL',
'34740': 'Killarney,FL',
'34741': 'Kissimmee,FL',
'34742': 'Kissimmee,FL',
'34743': 'Kissimmee,FL',
'34744': 'Kissimmee,FL',
'34745': 'Kissimmee,FL',
'34746': 'Kissimmee,FL',
'34747': 'Kissimmee,FL',
'34748': 'Leesburg,FL',
'34749': 'Leesburg,FL',
'34753': 'Mascotte,FL',
'34755': 'Minneola,FL',
'34756': 'Montverde,FL',
'34758': 'Kissimmee,FL',
'34759': 'Kissimmee,FL',
'34760': 'Oakland,FL',
'34761': 'Ocoee,FL',
'34762': 'Okahumpka,FL',
'34769': 'Saint Cloud,FL',
'34770': 'Saint Cloud,FL',
'34771': 'Saint Cloud,FL',
'34772': 'Saint Cloud,FL',
'34773': 'Saint Cloud,FL',
'34777': 'Winter Garden,FL',
'34778': 'Winter Garden,FL',
'34785': 'Wildwood,FL',
'34786': 'Windermere,FL',
'34787': 'Winter Garden,FL',
'34788': 'Leesburg,FL',
'34789': 'Leesburg,FL',
'34797': 'Yalaha,FL',
'34945': 'Fort Pierce,FL',
'34946': 'Fort Pierce,FL',
'34947': 'Fort Pierce,FL',
'34948': 'Fort Pierce,FL',
'34949': 'Fort Pierce,FL',
'34950': 'Fort Pierce,FL',
'34951': 'Fort Pierce,FL',
'34952': 'Port Saint Lucie,FL',
'34953': 'Port Saint Lucie,FL',
'34954': 'Fort Pierce,FL',
'34956': 'Indiantown,FL',
'34957': 'Jensen Beach,FL',
'34958': 'Jensen Beach,FL',
'34972': 'Okeechobee,FL',
'34973': 'Okeechobee,FL',
'34974': 'Okeechobee,FL',
'34979': 'Fort Pierce,FL',
'34981': 'Fort Pierce,FL',
'34982': 'Fort Pierce,FL',
'34983': 'Port Saint Lucie,FL',
'34984': 'Port Saint Lucie,FL',
'34985': 'Port Saint Lucie,FL',
'34986': 'Port Saint Lucie,FL',
'34987': 'Port Saint Lucie,FL',
'34988': 'Port Saint Lucie,FL',
'34990': 'Palm City,FL',
'34991': 'Palm City,FL',
'34992': 'Port Salerno,FL',
'34994': 'Stuart,FL',
'34995': 'Stuart,FL',
'34996': 'Stuart,FL',
'34997': 'Stuart,FL',
'35004': 'Moody,AL',
'35005': 'Adamsville,AL',
'35006': 'Adger,AL',
'35007': 'Alabaster,AL',
'35010': 'Alexander City,AL',
'35011': 'Alexander City,AL',
'35013': 'Allgood,AL',
'35014': 'Alpine,AL',
'35015': 'Alton,AL',
'35016': 'Arab,AL',
'35019': 'Baileyton,AL',
'35020': 'Bessemer,AL',
'35021': 'Bessemer,AL',
'35022': 'Bessemer,AL',
'35023': 'Bessemer,AL',
'35031': 'Blountsville,AL',
'35032': 'Bon Air,AL',
'35033': 'Bremen,AL',
'35034': 'Brent,AL',
'35035': 'Brierfield,AL',
'35036': 'Brookside,AL',
'35038': 'Burnwell,AL',
'35040': 'Calera,AL',
'35041': 'Cardiff,AL',
'35042': 'Centreville,AL',
'35043': 'Chelsea,AL',
'35044': 'Childersburg,AL',
'35045': 'Clanton,AL',
'35046': 'Clanton,AL',
'35048': 'Clay,AL',
'35049': 'Cleveland,AL',
'35051': 'Columbiana,AL',
'35052': 'Cook Springs,AL',
'35053': 'Crane Hill,AL',
'35054': 'Cropwell,AL',
'35055': 'Cullman,AL',
'35056': 'Cullman,AL',
'35057': 'Cullman,AL',
'35058': 'Cullman,AL',
'35060': 'Docena,AL',
'35061': 'Dolomite,AL',
'35062': 'Dora,AL',
'35063': 'Empire,AL',
'35064': 'Fairfield,AL',
'35068': 'Fultondale,AL',
'35070': 'Garden City,AL',
'35071': 'Gardendale,AL',
'35072': 'Goodwater,AL',
'35073': 'Graysville,AL',
'35074': 'Green Pond,AL',
'35077': 'Hanceville,AL',
'35078': 'Harpersville,AL',
'35079': 'Hayden,AL',
'35080': 'Helena,AL',
'35082': 'Hollins,AL',
'35083': 'Holly Pond,AL',
'35085': 'Jemison,AL',
'35087': 'Joppa,AL',
'35089': 'Kellyton,AL',
'35091': 'Kimberly,AL',
'35094': 'Leeds,AL',
'35096': 'Lincoln,AL',
'35097': 'Locust Fork,AL',
'35098': 'Logan,AL',
'35111': 'Mc Calla,AL',
'35112': 'Margaret,AL',
'35114': 'Maylene,AL',
'35115': 'Montevallo,AL',
'35116': 'Morris,AL',
'35117': 'Mount Olive,AL',
'35118': 'Mulga,AL',
'35119': 'New Castle,AL',
'35120': 'Odenville,AL',
'35121': 'Oneonta,AL',
'35123': 'Palmerdale,AL',
'35124': 'Pelham,AL',
'35125': 'Pell City,AL',
'35126': 'Pinson,AL',
'35127': 'Pleasant Grove,AL',
'35128': 'Pell City,AL',
'35130': 'Quinton,AL',
'35131': 'Ragland,AL',
'35133': 'Remlap,AL',
'35135': 'Riverside,AL',
'35136': 'Rockford,AL',
'35137': 'Saginaw,AL',
'35139': 'Sayre,AL',
'35142': 'Shannon,AL',
'35143': 'Shelby,AL',
'35144': 'Siluria,AL',
'35146': 'Springville,AL',
'35147': 'Sterrett,AL',
'35148': 'Sumiton,AL',
'35149': 'Sycamore,AL',
'35150': 'Sylacauga,AL',
'35151': 'Sylacauga,AL',
'35160': 'Talladega,AL',
'35161': 'Talladega,AL',
'35171': 'Thorsby,AL',
'35172': 'Trafford,AL',
'35173': 'Trussville,AL',
'35175': 'Union Grove,AL',
'35176': 'Vandiver,AL',
'35178': 'Vincent,AL',
'35179': 'Vinemont,AL',
'35180': 'Warrior,AL',
'35181': 'Watson,AL',
'35182': 'Wattsville,AL',
'35183': 'Weogufka,AL',
'35184': 'West Blocton,AL',
'35185': 'Westover,AL',
'35186': 'Wilsonville,AL',
'35187': 'Wilton,AL',
'35188': 'Woodstock,AL',
'35201': 'Birmingham,AL',
'35202': 'Birmingham,AL',
'35203': 'Birmingham,AL',
'35204': 'Birmingham,AL',
'35205': 'Birmingham,AL',
'35206': 'Birmingham,AL',
'35207': 'Birmingham,AL',
'35208': 'Birmingham,AL',
'35209': 'Birmingham,AL',
'35210': 'Birmingham,AL',
'35211': 'Birmingham,AL',
'35212': 'Birmingham,AL',
'35213': 'Birmingham,AL',
'35214': 'Birmingham,AL',
'35215': 'Birmingham,AL',
'35216': 'Birmingham,AL',
'35217': 'Birmingham,AL',
'35218': 'Birmingham,AL',
'35219': 'Birmingham,AL',
'35220': 'Birmingham,AL',
'35221': 'Birmingham,AL',
'35222': 'Birmingham,AL',
'35223': 'Birmingham,AL',
'35224': 'Birmingham,AL',
'35225': 'Birmingham,AL',
'35226': 'Birmingham,AL',
'35228': 'Birmingham,AL',
'35229': 'Birmingham,AL',
'35230': 'Birmingham,AL',
'35231': 'Birmingham,AL',
'35232': 'Birmingham,AL',
'35233': 'Birmingham,AL',
'35234': 'Birmingham,AL',
'35235': 'Birmingham,AL',
'35236': 'Birmingham,AL',
'35237': 'Birmingham,AL',
'35238': 'Birmingham,AL',
'35240': 'Birmingham,AL',
'35242': 'Birmingham,AL',
'35243': 'Birmingham,AL',
'35244': 'Birmingham,AL',
'35245': 'Birmingham,AL',
'35246': 'Birmingham,AL',
'35249': 'Birmingham,AL',
'35253': 'Birmingham,AL',
'35254': 'Birmingham,AL',
'35255': 'Birmingham,AL',
'35259': 'Birmingham,AL',
'35260': 'Birmingham,AL',
'35261': 'Birmingham,AL',
'35263': 'Birmingham,AL',
'35266': 'Birmingham,AL',
'35277': 'Birmingham,AL',
'35278': 'Birmingham,AL',
'35279': 'Birmingham,AL',
'35280': 'Birmingham,AL',
'35281': 'Birmingham,AL',
'35282': 'Birmingham,AL',
'35283': 'Birmingham,AL',
'35285': 'Birmingham,AL',
'35286': 'Birmingham,AL',
'35287': 'Birmingham,AL',
'35288': 'Birmingham,AL',
'35289': 'Birmingham,AL',
'35290': 'Birmingham,AL',
'35291': 'Birmingham,AL',
'35292': 'Birmingham,AL',
'35293': 'Birmingham,AL',
'35294': 'Birmingham,AL',
'35295': 'Birmingham,AL',
'35296': 'Birmingham,AL',
'35297': 'Birmingham,AL',
'35298': 'Birmingham,AL',
'35299': 'Birmingham,AL',
'35401': 'Tuscaloosa,AL',
'35402': 'Tuscaloosa,AL',
'35403': 'Tuscaloosa,AL',
'35404': 'Tuscaloosa,AL',
'35405': 'Tuscaloosa,AL',
'35406': 'Tuscaloosa,AL',
'35407': 'Tuscaloosa,AL',
'35440': 'Abernant,AL',
'35441': 'Akron,AL',
'35442': 'Aliceville,AL',
'35443': 'Boligee,AL',
'35444': 'Brookwood,AL',
'35446': 'Buhl,AL',
'35447': 'Carrollton,AL',
'35448': 'Clinton,AL',
'35449': 'Coaling,AL',
'35452': 'Coker,AL',
'35453': 'Cottondale,AL',
'35456': 'Duncanville,AL',
'35457': 'Echola,AL',
'35458': 'Elrod,AL',
'35459': 'Emelle,AL',
'35460': 'Epes,AL',
'35461': 'Ethelsville,AL',
'35462': 'Eutaw,AL',
'35463': 'Fosters,AL',
'35464': 'Gainesville,AL',
'35466': 'Gordo,AL',
'35468': 'Kellerman,AL',
'35469': 'Knoxville,AL',
'35470': 'Livingston,AL',
'35471': 'Mc Shan,AL',
'35473': 'Northport,AL',
'35474': 'Moundville,AL',
'35475': 'Northport,AL',
'35476': 'Northport,AL',
'35477': 'Panola,AL',
'35478': 'Peterson,AL',
'35480': 'Ralph,AL',
'35481': 'Reform,AL',
'35482': 'Samantha,AL',
'35485': 'Tuscaloosa,AL',
'35486': 'Tuscaloosa,AL',
'35487': 'Tuscaloosa,AL',
'35490': 'Vance,AL',
'35491': 'West Greene,AL',
'35501': 'Jasper,AL',
'35502': 'Jasper,AL',
'35503': 'Jasper,AL',
'35504': 'Jasper,AL',
'35540': 'Addison,AL',
'35541': 'Arley,AL',
'35542': 'Bankston,AL',
'35543': 'Bear Creek,AL',
'35544': 'Beaverton,AL',
'35545': 'Belk,AL',
'35546': 'Berry,AL',
'35548': 'Brilliant,AL',
'35549': 'Carbon Hill,AL',
'35550': 'Cordova,AL',
'35551': 'Delmar,AL',
'35552': 'Detroit,AL',
'35553': 'Double Springs,AL',
'35554': 'Eldridge,AL',
'35555': 'Fayette,AL',
'35559': 'Glen Allen,AL',
'35560': 'Goodsprings,AL',
'35563': 'Guin,AL',
'35564': 'Hackleburg,AL',
'35565': 'Haleyville,AL',
'35570': 'Hamilton,AL',
'35571': 'Hodges,AL',
'35572': 'Houston,AL',
'35573': 'Kansas,AL',
'35574': 'Kennedy,AL',
'35575': 'Lynn,AL',
'35576': 'Millport,AL',
'35577': 'Natural Bridge,AL',
'35578': 'Nauvoo,AL',
'35579': 'Oakman,AL',
'35580': 'Parrish,AL',
'35581': 'Phil Campbell,AL',
'35582': 'Red Bay,AL',
'35584': 'Sipsey,AL',
'35585': 'Spruce Pine,AL',
'35586': 'Sulligent,AL',
'35587': 'Townley,AL',
'35592': 'Vernon,AL',
'35593': 'Vina,AL',
'35594': 'Winfield,AL',
'35601': 'Decatur,AL',
'35602': 'Decatur,AL',
'35603': 'Decatur,AL',
'35609': 'Decatur,AL',
'35610': 'Anderson,AL',
'35611': 'Athens,AL',
'35612': 'Athens,AL',
'35613': 'Athens,AL',
'35614': 'Athens,AL',
'35615': 'Belle Mina,AL',
'35616': 'Cherokee,AL',
'35617': 'Cloverdale,AL',
'35618': 'Courtland,AL',
'35619': 'Danville,AL',
'35620': 'Elkmont,AL',
'35621': 'Eva,AL',
'35622': 'Falkville,AL',
'35630': 'Florence,AL',
'35631': 'Florence,AL',
'35632': 'Florence,AL',
'35633': 'Florence,AL',
'35634': 'Florence,AL',
'35640': 'Hartselle,AL',
'35643': 'Hillsboro,AL',
'35645': 'Killen,AL',
'35646': 'Leighton,AL',
'35647': 'Lester,AL',
'35648': 'Lexington,AL',
'35649': 'Mooresville,AL',
'35650': 'Moulton,AL',
'35651': 'Mount Hope,AL',
'35652': 'Rogersville,AL',
'35653': 'Russellville,AL',
'35654': 'Russellville,AL',
'35660': 'Sheffield,AL',
'35661': 'Muscle Shoals,AL',
'35662': 'Muscle Shoals,AL',
'35670': 'Somerville,AL',
'35671': 'Tanner,AL',
'35672': 'Town Creek,AL',
'35673': 'Trinity,AL',
'35674': 'Tuscumbia,AL',
'35677': 'Waterloo,AL',
'35699': 'Decatur,AL',
'35739': 'Ardmore,AL',
'35740': 'Bridgeport,AL',
'35741': 'Brownsboro,AL',
'35742': 'Capshaw,AL',
'35744': 'Dutton,AL',
'35745': 'Estillfork,AL',
'35746': 'Fackler,AL',
'35747': 'Grant,AL',
'35748': 'Gurley,AL',
'35749': 'Harvest,AL',
'35750': 'Hazel Green,AL',
'35751': 'Hollytree,AL',
'35752': 'Hollywood,AL',
'35754': 'Laceys Spring,AL',
'35755': 'Langston,AL',
'35756': 'Madison,AL',
'35757': 'Madison,AL',
'35758': 'Madison,AL',
'35759': 'Meridianville,AL',
'35760': 'New Hope,AL',
'35761': 'New Market,AL',
'35762': 'Normal,AL',
'35763': 'Owens Cross Roads,AL',
'35764': 'Paint Rock,AL',
'35765': 'Pisgah,AL',
'35766': 'Princeton,AL',
'35767': 'Ryland,AL',
'35768': 'Scottsboro,AL',
'35769': 'Scottsboro,AL',
'35771': 'Section,AL',
'35772': 'Stevenson,AL',
'35773': 'Toney,AL',
'35774': 'Trenton,AL',
'35775': 'Valhermoso Springs,AL',
'35776': 'Woodville,AL',
'35801': 'Huntsville,AL',
'35802': 'Huntsville,AL',
'35803': 'Huntsville,AL',
'35804': 'Huntsville,AL',
'35805': 'Huntsville,AL',
'35806': 'Huntsville,AL',
'35807': 'Huntsville,AL',
'35808': 'Huntsville,AL',
'35809': 'Huntsville,AL',
'35810': 'Huntsville,AL',
'35811': 'Huntsville,AL',
'35812': 'Huntsville,AL',
'35813': 'Huntsville,AL',
'35814': 'Huntsville,AL',
'35815': 'Huntsville,AL',
'35816': 'Huntsville,AL',
'35824': 'Huntsville,AL',
'35893': 'Huntsville,AL',
'35894': 'Huntsville,AL',
'35895': 'Huntsville,AL',
'35896': 'Huntsville,AL',
'35897': 'Huntsville,AL',
'35898': 'Huntsville,AL',
'35899': 'Huntsville,AL',
'35901': 'Gadsden,AL',
'35902': 'Gadsden,AL',
'35903': 'Gadsden,AL',
'35904': 'Gadsden,AL',
'35905': 'Gadsden,AL',
'35906': 'Rainbow City,AL',
'35907': 'Gadsden,AL',
'35950': 'Albertville,AL',
'35951': 'Albertville,AL',
'35952': 'Altoona,AL',
'35953': 'Ashville,AL',
'35954': 'Attalla,AL',
'35956': 'Boaz,AL',
'35957': 'Boaz,AL',
'35958': 'Bryant,AL',
'35959': 'Cedar Bluff,AL',
'35960': 'Centre,AL',
'35961': 'Collinsville,AL',
'35962': 'Crossville,AL',
'35963': 'Dawson,AL',
'35964': 'Douglas,AL',
'35966': 'Flat Rock,AL',
'35967': 'Fort Payne,AL',
'35968': 'Fort Payne,AL',
'35971': 'Fyffe,AL',
'35972': 'Gallant,AL',
'35973': 'Gaylesville,AL',
'35974': 'Geraldine,AL',
'35975': 'Groveoak,AL',
'35976': 'Guntersville,AL',
'35978': 'Henagar,AL',
'35979': 'Higdon,AL',
'35980': 'Horton,AL',
'35981': 'Ider,AL',
'35983': 'Leesburg,AL',
'35984': 'Mentone,AL',
'35986': 'Rainsville,AL',
'35987': 'Steele,AL',
'35988': 'Sylvania,AL',
'35989': 'Valley Head,AL',
'35990': 'Walnut Grove,AL',
'36003': 'Autaugaville,AL',
'36005': 'Banks,AL',
'36006': 'Billingsley,AL',
'36008': 'Booth,AL',
'36009': 'Brantley,AL',
'36010': 'Brundidge,AL',
'36013': 'Cecil,AL',
'36015': 'Chapman,AL',
'36016': 'Clayton,AL',
'36017': 'Clio,AL',
'36020': 'Coosada,AL',
'36022': 'Deatsville,AL',
'36023': 'East Tallassee,AL',
'36024': 'Eclectic,AL',
'36025': 'Elmore,AL',
'36026': 'Equality,AL',
'36027': 'Eufaula,AL',
'36028': 'Dozier,AL',
'36029': 'Fitzpatrick,AL',
'36030': 'Forest Home,AL',
'36031': 'Fort Davis,AL',
'36032': 'Fort Deposit,AL',
'36033': 'Georgiana,AL',
'36034': 'Glenwood,AL',
'36035': 'Goshen,AL',
'36036': 'Grady,AL',
'36037': 'Greenville,AL',
'36038': 'Gantt,AL',
'36039': 'Hardaway,AL',
'36040': 'Hayneville,AL',
'36041': 'Highland Home,AL',
'36042': 'Honoraville,AL',
'36043': 'Hope Hull,AL',
'36045': 'Kent,AL',
'36046': 'Lapine,AL',
'36047': 'Letohatchee,AL',
'36048': 'Louisville,AL',
'36049': 'Luverne,AL',
'36051': 'Marbury,AL',
'36052': 'Mathews,AL',
'36053': 'Midway,AL',
'36054': 'Millbrook,AL',
'36057': 'Mount Meigs,AL',
'36061': 'Perote,AL',
'36062': 'Petrey,AL',
'36064': 'Pike Road,AL',
'36065': 'Pine Level,AL',
'36066': 'Prattville,AL',
'36067': 'Prattville,AL',
'36068': 'Prattville,AL',
'36069': 'Ramer,AL',
'36071': 'Rutledge,AL',
'36072': 'Eufaula,AL',
'36075': 'Shorter,AL',
'36078': 'Tallassee,AL',
'36079': 'Troy,AL',
'36080': 'Titus,AL',
'36081': 'Troy,AL',
'36082': 'Troy,AL',
'36083': 'Tuskegee,AL',
'36087': 'Tuskegee Institute,AL',
'36088': 'Tuskegee Institute,AL',
'36089': 'Union Springs,AL',
'36091': 'Verbena,AL',
'36092': 'Wetumpka,AL',
'36093': 'Wetumpka,AL',
'36101': 'Montgomery,AL',
'36102': 'Montgomery,AL',
'36103': 'Montgomery,AL',
'36104': 'Montgomery,AL',
'36105': 'Montgomery,AL',
'36106': 'Montgomery,AL',
'36107': 'Montgomery,AL',
'36108': 'Montgomery,AL',
'36109': 'Montgomery,AL',
'36110': 'Montgomery,AL',
'36111': 'Montgomery,AL',
'36112': 'Montgomery,AL',
'36113': 'Montgomery,AL',
'36114': 'Montgomery,AL',
'36115': 'Montgomery,AL',
'36116': 'Montgomery,AL',
'36117': 'Montgomery,AL',
'36118': 'Montgomery,AL',
'36119': 'Montgomery,AL',
'36120': 'Montgomery,AL',
'36121': 'Montgomery,AL',
'36123': 'Montgomery,AL',
'36124': 'Montgomery,AL',
'36125': 'Montgomery,AL',
'36130': 'Montgomery,AL',
'36131': 'Montgomery,AL',
'36132': 'Montgomery,AL',
'36133': 'Montgomery,AL',
'36134': 'Montgomery,AL',
'36135': 'Montgomery,AL',
'36140': 'Montgomery,AL',
'36141': 'Montgomery,AL',
'36142': 'Montgomery,AL',
'36177': 'Montgomery,AL',
'36191': 'Montgomery,AL',
'36201': 'Anniston,AL',
'36202': 'Anniston,AL',
'36203': 'Oxford,AL',
'36204': 'Anniston,AL',
'36205': 'Anniston,AL',
'36206': 'Anniston,AL',
'36207': 'Anniston,AL',
'36210': 'Anniston,AL',
'36250': 'Alexandria,AL',
'36251': 'Ashland,AL',
'36253': 'Bynum,AL',
'36254': 'Choccolocco,AL',
'36255': 'Cragford,AL',
'36256': 'Daviston,AL',
'36257': 'De Armanville,AL',
'36258': 'Delta,AL',
'36260': 'Eastaboga,AL',
'36261': 'Edwardsville,AL',
'36262': 'Fruithurst,AL',
'36263': 'Graham,AL',
'36264': 'Heflin,AL',
'36265': 'Jacksonville,AL',
'36266': 'Lineville,AL',
'36267': 'Millerville,AL',
'36268': 'Munford,AL',
'36269': 'Muscadine,AL',
'36270': 'Newell,AL',
'36271': 'Ohatchee,AL',
'36272': 'Piedmont,AL',
'36273': 'Ranburne,AL',
'36274': 'Roanoke,AL',
'36275': 'Spring Garden,AL',
'36276': 'Wadley,AL',
'36277': 'Weaver,AL',
'36278': 'Wedowee,AL',
'36279': 'Wellington,AL',
'36280': 'Woodland,AL',
'36301': 'Dothan,AL',
'36302': 'Dothan,AL',
'36303': 'Dothan,AL',
'36304': 'Dothan,AL',
'36305': 'Dothan,AL',
'36310': 'Abbeville,AL',
'36311': 'Ariton,AL',
'36312': 'Ashford,AL',
'36313': 'Bellwood,AL',
'36314': 'Black,AL',
'36316': 'Chancellor,AL',
'36317': 'Clopton,AL',
'36318': 'Coffee Springs,AL',
'36319': 'Columbia,AL',
'36320': 'Cottonwood,AL',
'36321': 'Cowarts,AL',
'36322': 'Daleville,AL',
'36323': 'Elba,AL',
'36330': 'Enterprise,AL',
'36331': 'Enterprise,AL',
'36340': 'Geneva,AL',
'36343': 'Gordon,AL',
'36344': 'Hartford,AL',
'36345': 'Headland,AL',
'36346': 'Jack,AL',
'36349': 'Malvern,AL',
'36350': 'Midland City,AL',
'36351': 'New Brockton,AL',
'36352': 'Newton,AL',
'36353': 'Newville,AL',
'36360': 'Ozark,AL',
'36361': 'Ozark,AL',
'36362': 'Fort Rucker,AL',
'36370': 'Pansey,AL',
'36371': 'Pinckard,AL',
'36373': 'Shorterville,AL',
'36374': 'Skipperville,AL',
'36375': 'Slocomb,AL',
'36376': 'Webb,AL',
'36401': 'Evergreen,AL',
'36420': 'Andalusia,AL',
'36421': 'Andalusia,AL',
'36425': 'Beatrice,AL',
'36426': 'Brewton,AL',
'36427': 'Brewton,AL',
'36429': 'Brooklyn,AL',
'36431': 'Burnt Corn,AL',
'36432': 'Castleberry,AL',
'36435': 'Coy,AL',
'36436': 'Dickinson,AL',
'36439': 'Excel,AL',
'36441': 'Flomaton,AL',
'36442': 'Florala,AL',
'36444': 'Franklin,AL',
'36445': 'Frisco City,AL',
'36446': 'Fulton,AL',
'36449': 'Goodway,AL',
'36451': 'Grove Hill,AL',
'36453': 'Kinston,AL',
'36454': 'Lenox,AL',
'36455': 'Lockhart,AL',
'36456': 'Mc Kenzie,AL',
'36457': 'Megargel,AL',
'36458': 'Mexia,AL',
'36460': 'Monroeville,AL',
'36461': 'Monroeville,AL',
'36462': 'Monroeville,AL',
'36467': 'Opp,AL',
'36470': 'Perdue Hill,AL',
'36471': 'Peterman,AL',
'36473': 'Range,AL',
'36474': 'Red Level,AL',
'36475': 'Repton,AL',
'36476': 'River Falls,AL',
'36477': 'Samson,AL',
'36480': 'Uriah,AL',
'36481': 'Vredenburgh,AL',
'36482': 'Whatley,AL',
'36483': 'Wing,AL',
'36501': 'Alma,AL',
'36502': 'Atmore,AL',
'36503': 'Atmore,AL',
'36504': 'Atmore,AL',
'36505': 'Axis,AL',
'36507': 'Bay Minette,AL',
'36509': 'Bayou La Batre,AL',
'36511': 'Bon Secour,AL',
'36512': 'Bucks,AL',
'36513': 'Calvert,AL',
'36515': 'Carlton,AL',
'36518': 'Chatom,AL',
'36521': 'Chunchula,AL',
'36522': 'Citronelle,AL',
'36523': 'Coden,AL',
'36524': 'Coffeeville,AL',
'36525': 'Creola,AL',
'36526': 'Daphne,AL',
'36527': 'Spanish Fort,AL',
'36528': 'Dauphin Island,AL',
'36529': 'Deer Park,AL',
'36530': 'Elberta,AL',
'36532': 'Fairhope,AL',
'36533': 'Fairhope,AL',
'36535': 'Foley,AL',
'36536': 'Foley,AL',
'36538': 'Frankville,AL',
'36539': 'Fruitdale,AL',
'36540': 'Gainestown,AL',
'36541': 'Grand Bay,AL',
'36542': 'Gulf Shores,AL',
'36543': 'Huxford,AL',
'36544': 'Irvington,AL',
'36545': 'Jackson,AL',
'36547': 'Gulf Shores,AL',
'36548': 'Leroy,AL',
'36549': 'Lillian,AL',
'36550': 'Little River,AL',
'36551': 'Loxley,AL',
'36553': 'Mc Intosh,AL',
'36555': 'Magnolia Springs,AL',
'36556': 'Malcolm,AL',
'36558': 'Millry,AL',
'36559': 'Montrose,AL',
'36560': 'Mount Vernon,AL',
'36561': 'Orange Beach,AL',
'36562': 'Perdido,AL',
'36564': 'Point Clear,AL',
'36567': 'Robertsdale,AL',
'36568': 'Saint Elmo,AL',
'36569': 'Saint Stephens,AL',
'36570': 'Salitpa,AL',
'36571': 'Saraland,AL',
'36572': 'Satsuma,AL',
'36574': 'Seminole,AL',
'36575': 'Semmes,AL',
'36576': 'Silverhill,AL',
'36577': 'Spanish Fort,AL',
'36578': 'Stapleton,AL',
'36579': 'Stockton,AL',
'36580': 'Summerdale,AL',
'36581': 'Sunflower,AL',
'36582': 'Theodore,AL',
'36583': 'Tibbie,AL',
'36584': 'Vinegar Bend,AL',
'36585': 'Wagarville,AL',
'36586': 'Walker Springs,AL',
'36587': 'Wilmer,AL',
'36590': 'Theodore,AL',
'36601': 'Mobile,AL',
'36602': 'Mobile,AL',
'36603': 'Mobile,AL',
'36604': 'Mobile,AL',
'36605': 'Mobile,AL',
'36606': 'Mobile,AL',
'36607': 'Mobile,AL',
'36608': 'Mobile,AL',
'36609': 'Mobile,AL',
'36610': 'Mobile,AL',
'36611': 'Mobile,AL',
'36612': 'Mobile,AL',
'36613': 'Eight Mile,AL',
'36614': 'Mobile,AL',
'36615': 'Mobile,AL',
'36616': 'Mobile,AL',
'36617': 'Mobile,AL',
'36618': 'Mobile,AL',
'36619': 'Mobile,AL',
'36621': 'Mobile,AL',
'36622': 'Mobile,AL',
'36623': 'Mobile,AL',
'36625': 'Mobile,AL',
'36626': 'Mobile,AL',
'36628': 'Mobile,AL',
'36630': 'Mobile,AL',
'36631': 'Mobile,AL',
'36633': 'Mobile,AL',
'36640': 'Mobile,AL',
'36641': 'Mobile,AL',
'36644': 'Mobile,AL',
'36652': 'Mobile,AL',
'36660': 'Mobile,AL',
'36663': 'Mobile,AL',
'36670': 'Mobile,AL',
'36671': 'Mobile,AL',
'36675': 'Mobile,AL',
'36685': 'Mobile,AL',
'36688': 'Mobile,AL',
'36689': 'Mobile,AL',
'36690': 'Mobile,AL',
'36691': 'Mobile,AL',
'36693': 'Mobile,AL',
'36695': 'Mobile,AL',
'36701': 'Selma,AL',
'36702': 'Selma,AL',
'36703': 'Selma,AL',
'36720': 'Alberta,AL',
'36721': 'Annemanie,AL',
'36722': 'Arlington,AL',
'36723': 'Boykin,AL',
'36726': 'Camden,AL',
'36727': 'Campbell,AL',
'36728': 'Catherine,AL',
'36732': 'Demopolis,AL',
'36736': 'Dixons Mills,AL',
'36738': 'Faunsdale,AL',
'36740': 'Forkland,AL',
'36741': 'Furman,AL',
'36742': 'Gallion,AL',
'36744': 'Greensboro,AL',
'36745': 'Jefferson,AL',
'36748': 'Linden,AL',
'36749': 'Jones,AL',
'36750': 'Maplesville,AL',
'36751': 'Lower Peach Tree,AL',
'36752': 'Lowndesboro,AL',
'36753': 'Mc Williams,AL',
'36754': 'Magnolia,AL',
'36756': 'Marion,AL',
'36758': 'Plantersville,AL',
'36759': 'Marion Junction,AL',
'36761': 'Minter,AL',
'36762': 'Morvin,AL',
'36763': 'Myrtlewood,AL',
'36764': 'Nanafalia,AL',
'36765': 'Newbern,AL',
'36766': 'Oak Hill,AL',
'36767': 'Orrville,AL',
'36768': 'Pine Apple,AL',
'36769': 'Pine Hill,AL',
'36773': 'Safford,AL',
'36775': 'Sardis,AL',
'36776': 'Sawyerville,AL',
'36778': 'Snow Hill,AL',
'36779': 'Sprott,AL',
'36782': 'Sweet Water,AL',
'36783': 'Thomaston,AL',
'36784': 'Thomasville,AL',
'36785': 'Tyler,AL',
'36786': 'Uniontown,AL',
'36790': 'Stanton,AL',
'36792': 'Randolph,AL',
'36793': 'Lawley,AL',
'36801': 'Opelika,AL',
'36802': 'Opelika,AL',
'36803': 'Opelika,AL',
'36804': 'Opelika,AL',
'36830': 'Auburn,AL',
'36831': 'Auburn,AL',
'36832': 'Auburn,AL',
'36849': 'Auburn University,AL',
'36850': 'Camp Hill,AL',
'36851': 'Cottonton,AL',
'36852': 'Cusseta,AL',
'36853': 'Dadeville,AL',
'36854': 'Valley,AL',
'36855': 'Five Points,AL',
'36856': 'Fort Mitchell,AL',
'36858': 'Hatchechubbee,AL',
'36859': 'Holy Trinity,AL',
'36860': 'Hurtsboro,AL',
'36861': 'Jacksons Gap,AL',
'36862': 'Lafayette,AL',
'36863': 'Lanett,AL',
'36865': 'Loachapoka,AL',
'36866': 'Notasulga,AL',
'36867': 'Phenix City,AL',
'36868': 'Phenix City,AL',
'36869': 'Phenix City,AL',
'36870': 'Phenix City,AL',
'36871': 'Pittsview,AL',
'36872': 'Valley,AL',
'36874': 'Salem,AL',
'36875': 'Seale,AL',
'36877': 'Smiths,AL',
'36879': 'Waverly,AL',
'36901': 'Bellamy,AL',
'36904': 'Butler,AL',
'36906': 'Cromwell,AL',
'36907': 'Cuba,AL',
'36908': 'Gilbertown,AL',
'36910': 'Jachin,AL',
'36912': 'Lisman,AL',
'36913': 'Melvin,AL',
'36915': 'Needham,AL',
'36916': 'Pennington,AL',
'36919': 'Silas,AL',
'36921': 'Toxey,AL',
'36922': 'Ward,AL',
'36925': 'York,AL',
'37010': 'Adams,TN',
'37011': 'Antioch,TN',
'37012': 'Alexandria,TN',
'37013': 'Antioch,TN',
'37014': 'Arrington,TN',
'37015': 'Ashland City,TN',
'37016': 'Auburntown,TN',
'37018': 'Beechgrove,TN',
'37019': 'Belfast,TN',
'37020': 'Bell Buckle,TN',
'37022': 'Bethpage,TN',
'37023': 'Big Rock,TN',
'37024': 'Brentwood,TN',
'37025': 'Bon Aqua,TN',
'37026': 'Bradyville,TN',
'37027': 'Brentwood,TN',
'37028': 'Bumpus Mills,TN',
'37029': 'Burns,TN',
'37030': 'Carthage,TN',
'37031': 'Castalian Springs,TN',
'37032': 'Cedar Hill,TN',
'37033': 'Centerville,TN',
'37034': 'Chapel Hill,TN',
'37035': 'Chapmansboro,TN',
'37036': 'Charlotte,TN',
'37037': 'Christiana,TN',
'37040': 'Clarksville,TN',
'37041': 'Clarksville,TN',
'37042': 'Clarksville,TN',
'37043': 'Clarksville,TN',
'37044': 'Clarksville,TN',
'37046': 'College Grove,TN',
'37047': 'Cornersville,TN',
'37048': 'Cottontown,TN',
'37049': 'Cross Plains,TN',
'37050': 'Cumberland City,TN',
'37051': 'Cumberland Furnace,TN',
'37052': 'Cunningham,TN',
'37055': 'Dickson,TN',
'37056': 'Dickson,TN',
'37057': 'Dixon Springs,TN',
'37058': 'Dover,TN',
'37059': 'Dowelltown,TN',
'37060': 'Eagleville,TN',
'37061': 'Erin,TN',
'37062': 'Fairview,TN',
'37063': 'Fosterville,TN',
'37064': 'Franklin,TN',
'37065': 'Franklin,TN',
'37066': 'Gallatin,TN',
'37067': 'Franklin,TN',
'37068': 'Franklin,TN',
'37069': 'Franklin,TN',
'37070': 'Goodlettsville,TN',
'37071': 'Gladeville,TN',
'37072': 'Goodlettsville,TN',
'37073': 'Greenbrier,TN',
'37074': 'Hartsville,TN',
'37075': 'Hendersonville,TN',
'37076': 'Hermitage,TN',
'37077': 'Hendersonville,TN',
'37078': 'Hurricane Mills,TN',
'37079': 'Indian Mound,TN',
'37080': 'Joelton,TN',
'37082': 'Kingston Springs,TN',
'37083': 'Lafayette,TN',
'37085': 'Lascassas,TN',
'37086': 'La Vergne,TN',
'37087': 'Lebanon,TN',
'37088': 'Lebanon,TN',
'37089': 'La Vergne,TN',
'37090': 'Lebanon,TN',
'37091': 'Lewisburg,TN',
'37095': 'Liberty,TN',
'37096': 'Linden,TN',
'37097': 'Lobelville,TN',
'37098': 'Lyles,TN',
'37101': 'Mc Ewen,TN',
'37110': 'Mc Minnville,TN',
'37111': 'Mc Minnville,TN',
'37115': 'Madison,TN',
'37116': 'Madison,TN',
'37118': 'Milton,TN',
'37119': 'Mitchellville,TN',
'37121': 'Mount Juliet,TN',
'37122': 'Mount Juliet,TN',
'37127': 'Murfreesboro,TN',
'37128': 'Murfreesboro,TN',
'37129': 'Murfreesboro,TN',
'37130': 'Murfreesboro,TN',
'37131': 'Murfreesboro,TN',
'37132': 'Murfreesboro,TN',
'37133': 'Murfreesboro,TN',
'37134': 'New Johnsonville,TN',
'37135': 'Nolensville,TN',
'37136': 'Norene,TN',
'37137': 'Nunnelly,TN',
'37138': 'Old Hickory,TN',
'37140': 'Only,TN',
'37141': 'Orlinda,TN',
'37142': 'Palmyra,TN',
'37143': 'Pegram,TN',
'37144': 'Petersburg,TN',
'37145': 'Pleasant Shade,TN',
'37146': 'Pleasant View,TN',
'37147': 'Pleasantville,TN',
'37148': 'Portland,TN',
'37149': 'Readyville,TN',
'37150': 'Red Boiling Springs,TN',
'37151': 'Riddleton,TN',
'37152': 'Ridgetop,TN',
'37153': 'Rockvale,TN',
'37155': 'Saint Bethlehem,TN',
'37160': 'Shelbyville,TN',
'37161': 'Shelbyville,TN',
'37162': 'Shelbyville,TN',
'37165': 'Slayden,TN',
'37166': 'Smithville,TN',
'37167': 'Smyrna,TN',
'37171': 'Southside,TN',
'37172': 'Springfield,TN',
'37174': 'Spring Hill,TN',
'37175': 'Stewart,TN',
'37178': 'Tennessee Ridge,TN',
'37179': 'Thompsons Station,TN',
'37180': 'Unionville,TN',
'37181': 'Vanleer,TN',
'37183': 'Wartrace,TN',
'37184': 'Watertown,TN',
'37185': 'Waverly,TN',
'37186': 'Westmoreland,TN',
'37187': 'White Bluff,TN',
'37188': 'White House,TN',
'37189': 'Whites Creek,TN',
'37190': 'Woodbury,TN',
'37191': 'Woodlawn,TN',
'37201': 'Nashville,TN',
'37202': 'Nashville,TN',
'37203': 'Nashville,TN',
'37204': 'Nashville,TN',
'37205': 'Nashville,TN',
'37206': 'Nashville,TN',
'37207': 'Nashville,TN',
'37208': 'Nashville,TN',
'37209': 'Nashville,TN',
'37210': 'Nashville,TN',
'37211': 'Nashville,TN',
'37212': 'Nashville,TN',
'37213': 'Nashville,TN',
'37214': 'Nashville,TN',
'37215': 'Nashville,TN',
'37216': 'Nashville,TN',
'37217': 'Nashville,TN',
'37218': 'Nashville,TN',
'37219': 'Nashville,TN',
'37220': 'Nashville,TN',
'37221': 'Nashville,TN',
'37222': 'Nashville,TN',
'37224': 'Nashville,TN',
'37227': 'Nashville,TN',
'37228': 'Nashville,TN',
'37229': 'Nashville,TN',
'37230': 'Nashville,TN',
'37232': 'Nashville,TN',
'37234': 'Nashville,TN',
'37235': 'Nashville,TN',
'37236': 'Nashville,TN',
'37237': 'Nashville,TN',
'37238': 'Nashville,TN',
'37239': 'Nashville,TN',
'37240': 'Nashville,TN',
'37241': 'Nashville,TN',
'37242': 'Nashville,TN',
'37243': 'Nashville,TN',
'37244': 'Nashville,TN',
'37245': 'Nashville,TN',
'37246': 'Nashville,TN',
'37247': 'Nashville,TN',
'37248': 'Nashville,TN',
'37249': 'Nashville,TN',
'37250': 'Nashville,TN',
'37301': 'Altamont,TN',
'37302': 'Apison,TN',
'37303': 'Athens,TN',
'37304': 'Bakewell,TN',
'37305': 'Beersheba Springs,TN',
'37306': 'Belvidere,TN',
'37307': 'Benton,TN',
'37308': 'Birchwood,TN',
'37309': 'Calhoun,TN',
'37310': 'Charleston,TN',
'37311': 'Cleveland,TN',
'37312': 'Cleveland,TN',
'37313': 'Coalmont,TN',
'37314': 'Cokercreek,TN',
'37315': 'Collegedale,TN',
'37316': 'Conasauga,TN',
'37317': 'Copperhill,TN',
'37318': 'Cowan,TN',
'37320': 'Cleveland,TN',
'37321': 'Dayton,TN',
'37322': 'Decatur,TN',
'37323': 'Cleveland,TN',
'37324': 'Decherd,TN',
'37325': 'Delano,TN',
'37326': 'Ducktown,TN',
'37327': 'Dunlap,TN',
'37328': 'Elora,TN',
'37329': 'Englewood,TN',
'37330': 'Estill Springs,TN',
'37331': 'Etowah,TN',
'37332': 'Evensville,TN',
'37333': 'Farner,TN',
'37334': 'Fayetteville,TN',
'37335': 'Flintville,TN',
'37336': 'Georgetown,TN',
'37337': 'Grandview,TN',
'37338': 'Graysville,TN',
'37339': 'Gruetli Laager,TN',
'37340': 'Guild,TN',
'37341': 'Harrison,TN',
'37342': 'Hillsboro,TN',
'37343': 'Hixson,TN',
'37345': 'Huntland,TN',
'37347': 'Jasper,TN',
'37348': 'Kelso,TN',
'37349': 'Manchester,TN',
'37350': 'Lookout Mountain,TN',
'37351': 'Lupton City,TN',
'37352': 'Lynchburg,TN',
'37353': 'Mc Donald,TN',
'37354': 'Madisonville,TN',
'37355': 'Manchester,TN',
'37356': 'Monteagle,TN',
'37357': 'Morrison,TN',
'37359': 'Mulberry,TN',
'37360': 'Normandy,TN',
'37361': 'Ocoee,TN',
'37362': 'Oldfort,TN',
'37363': 'Ooltewah,TN',
'37364': 'Cleveland,TN',
'37365': 'Palmer,TN',
'37366': 'Pelham,TN',
'37367': 'Pikeville,TN',
'37369': 'Reliance,TN',
'37370': 'Riceville,TN',
'37371': 'Athens,TN',
'37372': 'Saint Andrews,TN',
'37373': 'Sale Creek,TN',
'37374': 'Sequatchie,TN',
'37375': 'Sewanee,TN',
'37376': 'Sherwood,TN',
'37377': 'Signal Mountain,TN',
'37378': 'Smartt,TN',
'37379': 'Soddy Daisy,TN',
'37380': 'South Pittsburg,TN',
'37381': 'Spring City,TN',
'37382': 'Summitville,TN',
'37383': 'Sewanee,TN',
'37384': 'Soddy Daisy,TN',
'37385': 'Tellico Plains,TN',
'37387': 'Tracy City,TN',
'37388': 'Tullahoma,TN',
'37389': 'Arnold Afb,TN',
'37391': 'Turtletown,TN',
'37394': 'Viola,TN',
'37395': 'Watts Bar Dam,TN',
'37396': 'Whiteside,TN',
'37397': 'Whitwell,TN',
'37398': 'Winchester,TN',
'37401': 'Chattanooga,TN',
'37402': 'Chattanooga,TN',
'37403': 'Chattanooga,TN',
'37404': 'Chattanooga,TN',
'37405': 'Chattanooga,TN',
'37406': 'Chattanooga,TN',
'37407': 'Chattanooga,TN',
'37408': 'Chattanooga,TN',
'37409': 'Chattanooga,TN',
'37410': 'Chattanooga,TN',
'37411': 'Chattanooga,TN',
'37412': 'Chattanooga,TN',
'37414': 'Chattanooga,TN',
'37415': 'Chattanooga,TN',
'37416': 'Chattanooga,TN',
'37419': 'Chattanooga,TN',
'37421': 'Chattanooga,TN',
'37422': 'Chattanooga,TN',
'37424': 'Chattanooga,TN',
'37450': 'Chattanooga,TN',
'37501': 'Memphis,TN',
'37544': 'Memphis,TN',
'37601': 'Johnson City,TN',
'37602': 'Johnson City,TN',
'37604': 'Johnson City,TN',
'37605': 'Johnson City,TN',
'37614': 'Johnson City,TN',
'37615': 'Johnson City,TN',
'37616': 'Afton,TN',
'37617': 'Blountville,TN',
'37618': 'Bluff City,TN',
'37620': 'Bristol,TN',
'37621': 'Bristol,TN',
'37625': 'Bristol,TN',
'37640': 'Butler,TN',
'37641': 'Chuckey,TN',
'37642': 'Church Hill,TN',
'37643': 'Elizabethton,TN',
'37644': 'Elizabethton,TN',
'37645': 'Mount Carmel,TN',
'37650': 'Erwin,TN',
'37656': 'Fall Branch,TN',
'37657': 'Flag Pond,TN',
'37658': 'Hampton,TN',
'37659': 'Jonesborough,TN',
'37660': 'Kingsport,TN',
'37662': 'Kingsport,TN',
'37663': 'Kingsport,TN',
'37664': 'Kingsport,TN',
'37665': 'Kingsport,TN',
'37669': 'Kingsport,TN',
'37680': 'Laurel Bloomery,TN',
'37681': 'Limestone,TN',
'37682': 'Milligan College,TN',
'37683': 'Mountain City,TN',
'37684': 'Mountain Home,TN',
'37686': 'Piney Flats,TN',
'37687': 'Roan Mountain,TN',
'37688': 'Shady Valley,TN',
'37690': 'Telford,TN',
'37691': 'Trade,TN',
'37692': 'Unicoi,TN',
'37694': 'Watauga,TN',
'37699': 'Piney Flats,TN',
'37701': 'Alcoa,TN',
'37705': 'Andersonville,TN',
'37707': 'Arthur,TN',
'37708': 'Bean Station,TN',
'37709': 'Blaine,TN',
'37710': 'Briceville,TN',
'37711': 'Bulls Gap,TN',
'37713': 'Bybee,TN',
'37714': 'Caryville,TN',
'37715': 'Clairfield,TN',
'37716': 'Clinton,TN',
'37717': 'Clinton,TN',
'37719': 'Coalfield,TN',
'37721': 'Corryton,TN',
'37722': 'Cosby,TN',
'37723': 'Crab Orchard,TN',
'37724': 'Cumberland Gap,TN',
'37725': 'Dandridge,TN',
'37726': 'Deer Lodge,TN',
'37727': 'Del Rio,TN',
'37729': 'Duff,TN',
'37730': 'Eagan,TN',
'37731': 'Eidson,TN',
'37732': 'Elgin,TN',
'37733': 'Rugby,TN',
'37737': 'Friendsville,TN',
'37738': 'Gatlinburg,TN',
'37742': 'Greenback,TN',
'37743': 'Greeneville,TN',
'37744': 'Greeneville,TN',
'37745': 'Greeneville,TN',
'37748': 'Harriman,TN',
'37752': 'Harrogate,TN',
'37753': 'Hartford,TN',
'37754': 'Heiskell,TN',
'37755': 'Helenwood,TN',
'37756': 'Huntsville,TN',
'37757': 'Jacksboro,TN',
'37760': 'Jefferson City,TN',
'37762': 'Jellico,TN',
'37763': 'Kingston,TN',
'37764': 'Kodak,TN',
'37765': 'Kyles Ford,TN',
'37766': 'La Follette,TN',
'37769': 'Lake City,TN',
'37770': 'Lancing,TN',
'37771': 'Lenoir City,TN',
'37772': 'Lenoir City,TN',
'37773': 'Lone Mountain,TN',
'37774': 'Loudon,TN',
'37777': 'Louisville,TN',
'37778': 'Lowland,TN',
'37779': 'Luttrell,TN',
'37801': 'Maryville,TN',
'37802': 'Maryville,TN',
'37803': 'Maryville,TN',
'37804': 'Maryville,TN',
'37806': 'Mascot,TN',
'37807': 'Maynardville,TN',
'37809': 'Midway,TN',
'37810': 'Mohawk,TN',
'37811': 'Mooresburg,TN',
'37813': 'Morristown,TN',
'37814': 'Morristown,TN',
'37815': 'Morristown,TN',
'37816': 'Morristown,TN',
'37818': 'Mosheim,TN',
'37819': 'Newcomb,TN',
'37820': 'New Market,TN',
'37821': 'Newport,TN',
'37822': 'Newport,TN',
'37824': 'New Tazewell,TN',
'37825': 'New Tazewell,TN',
'37826': 'Niota,TN',
'37828': 'Norris,TN',
'37829': 'Oakdale,TN',
'37830': 'Oak Ridge,TN',
'37831': 'Oak Ridge,TN',
'37840': 'Oliver Springs,TN',
'37841': 'Oneida,TN',
'37842': 'Ozone,TN',
'37843': 'Parrottsville,TN',
'37845': 'Petros,TN',
'37846': 'Philadelphia,TN',
'37847': 'Pioneer,TN',
'37848': 'Powder Springs,TN',
'37849': 'Powell,TN',
'37851': 'Pruden,TN',
'37852': 'Robbins,TN',
'37853': 'Rockford,TN',
'37854': 'Rockwood,TN',
'37857': 'Rogersville,TN',
'37860': 'Russellville,TN',
'37861': 'Rutledge,TN',
'37862': 'Sevierville,TN',
'37863': 'Pigeon Forge,TN',
'37864': 'Sevierville,TN',
'37865': 'Seymour,TN',
'37866': 'Sharps Chapel,TN',
'37867': 'Shawanee,TN',
'37868': 'Pigeon Forge,TN',
'37869': 'Sneedville,TN',
'37870': 'Speedwell,TN',
'37871': 'Strawberry Plains,TN',
'37872': 'Sunbright,TN',
'37873': 'Surgoinsville,TN',
'37874': 'Sweetwater,TN',
'37876': 'Sevierville,TN',
'37877': 'Talbott,TN',
'37878': 'Tallassee,TN',
'37879': 'Tazewell,TN',
'37880': 'Ten Mile,TN',
'37881': 'Thorn Hill,TN',
'37882': 'Townsend,TN',
'37885': 'Vonore,TN',
'37886': 'Walland,TN',
'37887': 'Wartburg,TN',
'37888': 'Washburn,TN',
'37890': 'White Pine,TN',
'37891': 'Whitesburg,TN',
'37892': 'Winfield,TN',
'37901': 'Knoxville,TN',
'37902': 'Knoxville,TN',
'37909': 'Knoxville,TN',
'37912': 'Knoxville,TN',
'37914': 'Knoxville,TN',
'37915': 'Knoxville,TN',
'37916': 'Knoxville,TN',
'37917': 'Knoxville,TN',
'37918': 'Knoxville,TN',
'37919': 'Knoxville,TN',
'37920': 'Knoxville,TN',
'37921': 'Knoxville,TN',
'37922': 'Knoxville,TN',
'37923': 'Knoxville,TN',
'37924': 'Knoxville,TN',
'37927': 'Knoxville,TN',
'37928': 'Knoxville,TN',
'37929': 'Knoxville,TN',
'37930': 'Knoxville,TN',
'37931': 'Knoxville,TN',
'37932': 'Knoxville,TN',
'37933': 'Knoxville,TN',
'37934': 'Kville,TN',
'37938': 'Knoxville,TN',
'37939': 'Knoxville,TN',
'37940': 'Knoxville,TN',
'37950': 'Knoxville,TN',
'37990': 'Knoxville,TN',
'37995': 'Knoxville,TN',
'37996': 'Knoxville,TN',
'37997': 'Knoxville,TN',
'37998': 'Knoxville,TN',
'38001': 'Alamo,TN',
'38002': 'Arlington,TN',
'38004': 'Atoka,TN',
'38006': 'Bells,TN',
'38007': 'Bogota,TN',
'38008': 'Bolivar,TN',
'38010': 'Braden,TN',
'38011': 'Brighton,TN',
'38012': 'Brownsville,TN',
'38014': 'Brunswick,TN',
'38015': 'Burlison,TN',
'38016': 'Cordova,TN',
'38017': 'Collierville,TN',
'38018': 'Cordova,TN',
'38019': 'Covington,TN',
'38021': 'Crockett Mills,TN',
'38023': 'Drummonds,TN',
'38024': 'Dyersburg,TN',
'38025': 'Dyersburg,TN',
'38027': 'Collierville,TN',
'38028': 'Eads,TN',
'38029': 'Ellendale,TN',
'38030': 'Finley,TN',
'38034': 'Friendship,TN',
'38036': 'Gallaway,TN',
'38037': 'Gates,TN',
'38039': 'Grand Junction,TN',
'38040': 'Halls,TN',
'38041': 'Henning,TN',
'38042': 'Hickory Valley,TN',
'38044': 'Hornsby,TN',
'38045': 'Laconia,TN',
'38046': 'La Grange,TN',
'38047': 'Lenox,TN',
'38048': 'Macon,TN',
'38049': 'Mason,TN',
'38050': 'Maury City,TN',
'38052': 'Middleton,TN',
'38053': 'Millington,TN',
'38054': 'Millington,TN',
'38055': 'Millington,TN',
'38056': 'Miston,TN',
'38057': 'Moscow,TN',
'38058': 'Munford,TN',
'38059': 'Newbern,TN',
'38060': 'Oakland,TN',
'38061': 'Pocahontas,TN',
'38063': 'Ripley,TN',
'38066': 'Rossville,TN',
'38067': 'Saulsbury,TN',
'38068': 'Somerville,TN',
'38069': 'Stanton,TN',
'38070': 'Tigrett,TN',
'38071': 'Tipton,TN',
'38074': 'Bolivar,TN',
'38075': 'Whiteville,TN',
'38076': 'Williston,TN',
'38077': 'Wynnburg,TN',
'38079': 'Tiptonville,TN',
'38080': 'Ridgely,TN',
'38083': 'Millington,TN',
'38088': 'Cordova,TN',
'38101': 'Memphis,TN',
'38103': 'Memphis,TN',
'38104': 'Memphis,TN',
'38105': 'Memphis,TN',
'38106': 'Memphis,TN',
'38107': 'Memphis,TN',
'38108': 'Memphis,TN',
'38109': 'Memphis,TN',
'38110': 'Memphis,TN',
'38111': 'Memphis,TN',
'38112': 'Memphis,TN',
'38113': 'Memphis,TN',
'38114': 'Memphis,TN',
'38115': 'Memphis,TN',
'38116': 'Memphis,TN',
'38117': 'Memphis,TN',
'38118': 'Memphis,TN',
'38119': 'Memphis,TN',
'38120': 'Memphis,TN',
'38122': 'Memphis,TN',
'38124': 'Memphis,TN',
'38125': 'Memphis,TN',
'38126': 'Memphis,TN',
'38127': 'Memphis,TN',
'38128': 'Memphis,TN',
'38130': 'Memphis,TN',
'38131': 'Memphis,TN',
'38132': 'Memphis,TN',
'38133': 'Memphis,TN',
'38134': 'Memphis,TN',
'38135': 'Memphis,TN',
'38136': 'Memphis,TN',
'38137': 'Memphis,TN',
'38138': 'Germantown,TN',
'38139': 'Germantown,TN',
'38140': 'Memphis,TN',
'38141': 'Memphis,TN',
'38142': 'Memphis,TN',
'38143': 'Memphis,TN',
'38145': 'Memphis,TN',
'38146': 'Memphis,TN',
'38147': 'Memphis,TN',
'38148': 'Memphis,TN',
'38150': 'Memphis,TN',
'38151': 'Memphis,TN',
'38152': 'Memphis,TN',
'38157': 'Memphis,TN',
'38159': 'Memphis,TN',
'38161': 'Memphis,TN',
'38163': 'Memphis,TN',
'38165': 'Memphis,TN',
'38166': 'Memphis,TN',
'38167': 'Memphis,TN',
'38168': 'Memphis,TN',
'38173': 'Memphis,TN',
'38174': 'Memphis,TN',
'38175': 'Memphis,TN',
'38177': 'Memphis,TN',
'38181': 'Memphis,TN',
'38182': 'Memphis,TN',
'38183': 'Germantown,TN',
'38184': 'Memphis,TN',
'38186': 'Memphis,TN',
'38187': 'Memphis,TN',
'38188': 'Memphis,TN',
'38190': 'Memphis,TN',
'38193': 'Memphis,TN',
'38194': 'Memphis,TN',
'38195': 'Memphis,TN',
'38197': 'Memphis,TN',
'38201': 'Mc Kenzie,TN',
'38220': 'Atwood,TN',
'38221': 'Big Sandy,TN',
'38222': 'Buchanan,TN',
'38223': 'Como,TN',
'38224': 'Cottage Grove,TN',
'38225': 'Dresden,TN',
'38226': 'Dukedom,TN',
'38227': 'Elbridge,TN',
'38229': 'Gleason,TN',
'38230': 'Greenfield,TN',
'38231': 'Henry,TN',
'38232': 'Hornbeak,TN',
'38233': 'Kenton,TN',
'38235': 'Mc Lemoresville,TN',
'38236': 'Mansfield,TN',
'38237': 'Martin,TN',
'38238': 'Martin,TN',
'38240': 'Obion,TN',
'38241': 'Palmersville,TN',
'38242': 'Paris,TN',
'38251': 'Puryear,TN',
'38253': 'Rives,TN',
'38254': 'Samburg,TN',
'38255': 'Sharon,TN',
'38256': 'Springville,TN',
'38257': 'South Fulton,TN',
'38258': 'Trezevant,TN',
'38259': 'Trimble,TN',
'38260': 'Troy,TN',
'38261': 'Union City,TN',
'38271': 'Woodland Mills,TN',
'38281': 'Union City,TN',
'38301': 'Jackson,TN',
'38302': 'Jackson,TN',
'38303': 'Jackson,TN',
'38305': 'Jackson,TN',
'38308': 'Jackson,TN',
'38310': 'Adamsville,TN',
'38311': 'Bath Springs,TN',
'38313': 'Beech Bluff,TN',
'38314': 'Jackson,TN',
'38315': 'Bethel Springs,TN',
'38316': 'Bradford,TN',
'38317': 'Bruceton,TN',
'38318': 'Buena Vista,TN',
'38320': 'Camden,TN',
'38321': 'Cedar Grove,TN',
'38324': 'Clarksburg,TN',
'38326': 'Counce,TN',
'38327': 'Crump,TN',
'38328': 'Darden,TN',
'38329': 'Decaturville,TN',
'38330': 'Dyer,TN',
'38331': 'Eaton,TN',
'38332': 'Enville,TN',
'38333': 'Eva,TN',
'38334': 'Finger,TN',
'38336': 'Fruitvale,TN',
'38337': 'Gadsden,TN',
'38338': 'Gibson,TN',
'38339': 'Guys,TN',
'38340': 'Henderson,TN',
'38341': 'Holladay,TN',
'38342': 'Hollow Rock,TN',
'38343': 'Humboldt,TN',
'38344': 'Huntingdon,TN',
'38345': 'Huron,TN',
'38346': 'Idlewild,TN',
'38347': 'Jacks Creek,TN',
'38348': 'Lavinia,TN',
'38351': 'Lexington,TN',
'38352': 'Luray,TN',
'38355': 'Medina,TN',
'38356': 'Medon,TN',
'38357': 'Michie,TN',
'38358': 'Milan,TN',
'38359': 'Milledgeville,TN',
'38361': 'Morris Chapel,TN',
'38362': 'Oakfield,TN',
'38363': 'Parsons,TN',
'38365': 'Pickwick Dam,TN',
'38366': 'Pinson,TN',
'38367': 'Ramer,TN',
'38368': 'Reagan,TN',
'38369': 'Rutherford,TN',
'38370': 'Saltillo,TN',
'38371': 'Sardis,TN',
'38372': 'Savannah,TN',
'38374': 'Scotts Hill,TN',
'38375': 'Selmer,TN',
'38376': 'Shiloh,TN',
'38377': 'Silerton,TN',
'38378': 'Spring Creek,TN',
'38379': 'Stantonville,TN',
'38380': 'Sugar Tree,TN',
'38381': 'Toone,TN',
'38382': 'Trenton,TN',
'38387': 'Westport,TN',
'38388': 'Wildersville,TN',
'38389': 'Yorkville,TN',
'38390': 'Yuma,TN',
'38391': 'Denmark,TN',
'38392': 'Mercer,TN',
'38393': 'Chewalla,TN',
'38401': 'Columbia,TN',
'38402': 'Columbia,TN',
'38425': 'Clifton,TN',
'38449': 'Ardmore,TN',
'38450': 'Collinwood,TN',
'38451': 'Culleoka,TN',
'38452': 'Cypress Inn,TN',
'38453': 'Dellrose,TN',
'38454': 'Duck River,TN',
'38455': 'Elkton,TN',
'38456': 'Ethridge,TN',
'38457': 'Five Points,TN',
'38459': 'Frankewing,TN',
'38460': 'Goodspring,TN',
'38461': 'Hampshire,TN',
'38462': 'Hohenwald,TN',
'38463': 'Iron City,TN',
'38464': 'Lawrenceburg,TN',
'38468': 'Leoma,TN',
'38469': 'Loretto,TN',
'38471': 'Lutts,TN',
'38472': 'Lynnville,TN',
'38473': 'Minor Hill,TN',
'38474': 'Mount Pleasant,TN',
'38475': 'Olivehill,TN',
'38476': 'Primm Springs,TN',
'38477': 'Prospect,TN',
'38478': 'Pulaski,TN',
'38481': 'Saint Joseph,TN',
'38482': 'Santa Fe,TN',
'38483': 'Summertown,TN',
'38485': 'Waynesboro,TN',
'38486': 'Westpoint,TN',
'38487': 'Williamsport,TN',
'38488': 'Taft,TN',
'38501': 'Cookeville,TN',
'38502': 'Cookeville,TN',
'38503': 'Cookeville,TN',
'38504': 'Allardt,TN',
'38505': 'Cookeville,TN',
'38506': 'Cookeville,TN',
'38541': 'Allons,TN',
'38542': 'Allred,TN',
'38543': 'Alpine,TN',
'38544': 'Baxter,TN',
'38545': 'Bloomington Springs,TN',
'38547': 'Brush Creek,TN',
'38548': 'Buffalo Valley,TN',
'38549': 'Byrdstown,TN',
'38550': 'Campaign,TN',
'38551': 'Celina,TN',
'38552': 'Chestnut Mound,TN',
'38553': 'Clarkrange,TN',
'38554': 'Crawford,TN',
'38555': 'Crossville,TN',
'38556': 'Jamestown,TN',
'38557': 'Crossville,TN',
'38558': 'Crossville,TN',
'38559': 'Doyle,TN',
'38560': 'Elmwood,TN',
'38562': 'Gainesboro,TN',
'38563': 'Gordonsville,TN',
'38564': 'Granville,TN',
'38565': 'Grimsley,TN',
'38567': 'Hickman,TN',
'38568': 'Hilham,TN',
'38569': 'Lancaster,TN',
'38570': 'Livingston,TN',
'38571': 'Crossville,TN',
'38572': 'Crossville,TN',
'38573': 'Monroe,TN',
'38574': 'Monterey,TN',
'38575': 'Moss,TN',
'38577': 'Pall Mall,TN',
'38578': 'Pleasant Hill,TN',
'38579': 'Quebeck,TN',
'38580': 'Rickman,TN',
'38581': 'Rock Island,TN',
'38582': 'Silver Point,TN',
'38583': 'Sparta,TN',
'38585': 'Spencer,TN',
'38587': 'Walling,TN',
'38588': 'Whitleyville,TN',
'38589': 'Wilder,TN',
'38601': 'Abbeville,MS',
'38602': 'Arkabutla,MS',
'38603': 'Ashland,MS',
'38606': 'Batesville,MS',
'38609': 'Belen,MS',
'38610': 'Blue Mountain,MS',
'38611': 'Byhalia,MS',
'38614': 'Clarksdale,MS',
'38617': 'Coahoma,MS',
'38618': 'Coldwater,MS',
'38619': 'Como,MS',
'38620': 'Courtland,MS',
'38621': 'Crenshaw,MS',
'38622': 'Crowder,MS',
'38623': 'Darling,MS',
'38625': 'Dumas,MS',
'38626': 'Dundee,MS',
'38627': 'Etta,MS',
'38628': 'Falcon,MS',
'38629': 'Falkner,MS',
'38630': 'Farrell,MS',
'38631': 'Friars Point,MS',
'38632': 'Hernando,MS',
'38633': 'Hickory Flat,MS',
'38634': 'Holly Springs,MS',
'38635': 'Holly Springs,MS',
'38637': 'Horn Lake,MS',
'38638': 'Independence,MS',
'38639': 'Jonestown,MS',
'38641': 'Lake Cormorant,MS',
'38642': 'Lamar,MS',
'38643': 'Lambert,MS',
'38644': 'Lula,MS',
'38645': 'Lyon,MS',
'38646': 'Marks,MS',
'38647': 'Michigan City,MS',
'38649': 'Mount Pleasant,MS',
'38650': 'Myrtle,MS',
'38651': 'Nesbit,MS',
'38652': 'New Albany,MS',
'38654': 'Olive Branch,MS',
'38655': 'Oxford,MS',
'38658': 'Pope,MS',
'38659': 'Potts Camp,MS',
'38661': 'Red Banks,MS',
'38663': 'Ripley,MS',
'38664': 'Robinsonville,MS',
'38665': 'Sarah,MS',
'38666': 'Sardis,MS',
'38668': 'Senatobia,MS',
'38669': 'Sherard,MS',
'38670': 'Sledge,MS',
'38671': 'Southaven,MS',
'38672': 'Southaven,MS',
'38673': 'Taylor,MS',
'38674': 'Tiplersville,MS',
'38675': 'Tula,MS',
'38676': 'Tunica,MS',
'38677': 'University,MS',
'38679': 'Victoria,MS',
'38680': 'Walls,MS',
'38683': 'Walnut,MS',
'38685': 'Waterford,MS',
'38686': 'Walls,MS',
'38701': 'Greenville,MS',
'38702': 'Greenville,MS',
'38703': 'Greenville,MS',
'38704': 'Greenville,MS',
'38720': 'Alligator,MS',
'38721': 'Anguilla,MS',
'38722': 'Arcola,MS',
'38723': 'Avon,MS',
'38725': 'Benoit,MS',
'38726': 'Beulah,MS',
'38730': 'Boyle,MS',
'38731': 'Chatham,MS',
'38732': 'Cleveland,MS',
'38733': 'Cleveland,MS',
'38736': 'Doddsville,MS',
'38737': 'Drew,MS',
'38738': 'Parchman,MS',
'38739': 'Dublin,MS',
'38740': 'Duncan,MS',
'38744': 'Glen Allan,MS',
'38745': 'Grace,MS',
'38746': 'Gunnison,MS',
'38748': 'Hollandale,MS',
'38749': 'Holly Ridge,MS',
'38751': 'Indianola,MS',
'38753': 'Inverness,MS',
'38754': 'Isola,MS',
'38756': 'Leland,MS',
'38758': 'Mattson,MS',
'38759': 'Merigold,MS',
'38760': 'Metcalfe,MS',
'38761': 'Moorhead,MS',
'38762': 'Mound Bayou,MS',
'38763': 'Nitta Yuma,MS',
'38764': 'Pace,MS',
'38765': 'Panther Burn,MS',
'38767': 'Rena Lara,MS',
'38768': 'Rome,MS',
'38769': 'Rosedale,MS',
'38771': 'Ruleville,MS',
'38772': 'Scott,MS',
'38773': 'Shaw,MS',
'38774': 'Shelby,MS',
'38776': 'Stoneville,MS',
'38778': 'Sunflower,MS',
'38780': 'Wayside,MS',
'38781': 'Winstonville,MS',
'38782': 'Winterville,MS',
'38801': 'Tupelo,MS',
'38802': 'Tupelo,MS',
'38803': 'Tupelo,MS',
'38804': 'Tupelo,MS',
'38820': 'Algoma,MS',
'38821': 'Amory,MS',
'38824': 'Baldwyn,MS',
'38825': 'Becker,MS',
'38826': 'Belden,MS',
'38827': 'Belmont,MS',
'38828': 'Blue Springs,MS',
'38829': 'Booneville,MS',
'38833': 'Burnsville,MS',
'38834': 'Corinth,MS',
'38835': 'Corinth,MS',
'38838': 'Dennis,MS',
'38839': 'Derma,MS',
'38841': 'Ecru,MS',
'38843': 'Fulton,MS',
'38844': 'Gattman,MS',
'38846': 'Glen,MS',
'38847': 'Golden,MS',
'38848': 'Greenwood Springs,MS',
'38849': 'Guntown,MS',
'38850': 'Houlka,MS',
'38851': 'Houston,MS',
'38852': 'Iuka,MS',
'38854': 'Mc Condy,MS',
'38855': 'Mantachie,MS',
'38856': 'Marietta,MS',
'38857': 'Mooreville,MS',
'38858': 'Nettleton,MS',
'38859': 'New Site,MS',
'38860': 'Okolona,MS',
'38862': 'Plantersville,MS',
'38863': 'Pontotoc,MS',
'38864': 'Randolph,MS',
'38865': 'Rienzi,MS',
'38866': 'Saltillo,MS',
'38868': 'Shannon,MS',
'38869': 'Sherman,MS',
'38870': 'Smithville,MS',
'38871': 'Thaxton,MS',
'38873': 'Tishomingo,MS',
'38874': 'Toccopola,MS',
'38875': 'Trebloc,MS',
'38876': 'Tremont,MS',
'38877': 'Van Vleet,MS',
'38878': 'Vardaman,MS',
'38879': 'Verona,MS',
'38880': 'Wheeler,MS',
'38901': 'Grenada,MS',
'38902': 'Grenada,MS',
'38912': 'Avalon,MS',
'38913': 'Banner,MS',
'38914': 'Big Creek,MS',
'38915': 'Bruce,MS',
'38916': 'Calhoun City,MS',
'38917': 'Carrollton,MS',
'38920': 'Cascilla,MS',
'38921': 'Charleston,MS',
'38922': 'Coffeeville,MS',
'38923': 'Coila,MS',
'38924': 'Cruger,MS',
'38925': 'Duck Hill,MS',
'38926': 'Elliott,MS',
'38927': 'Enid,MS',
'38928': 'Glendora,MS',
'38929': 'Gore Springs,MS',
'38930': 'Greenwood,MS',
'38935': 'Greenwood,MS',
'38940': 'Holcomb,MS',
'38941': 'Itta Bena,MS',
'38943': 'Mc Carley,MS',
'38944': 'Minter City,MS',
'38945': 'Money,MS',
'38946': 'Morgan City,MS',
'38947': 'North Carrollton,MS',
'38948': 'Oakland,MS',
'38949': 'Paris,MS',
'38950': 'Philipp,MS',
'38951': 'Pittsboro,MS',
'38952': 'Schlater,MS',
'38953': 'Scobey,MS',
'38954': 'Sidon,MS',
'38955': 'Slate Spring,MS',
'38957': 'Sumner,MS',
'38958': 'Swan Lake,MS',
'38959': 'Swiftown,MS',
'38960': 'Tie Plant,MS',
'38961': 'Tillatoba,MS',
'38962': 'Tippo,MS',
'38963': 'Tutwiler,MS',
'38964': 'Vance,MS',
'38965': 'Water Valley,MS',
'38966': 'Webb,MS',
'38967': 'Winona,MS',
'39038': 'Belzoni,MS',
'39039': 'Benton,MS',
'39040': 'Bentonia,MS',
'39041': 'Bolton,MS',
'39042': 'Brandon,MS',
'39043': 'Brandon,MS',
'39044': 'Braxton,MS',
'39045': 'Camden,MS',
'39046': 'Canton,MS',
'39047': 'Brandon,MS',
'39051': 'Carthage,MS',
'39054': 'Cary,MS',
'39056': 'Clinton,MS',
'39057': 'Conehatta,MS',
'39058': 'Clinton,MS',
'39059': 'Crystal Springs,MS',
'39060': 'Clinton,MS',
'39061': 'Delta City,MS',
'39062': 'D Lo,MS',
'39063': 'Durant,MS',
'39066': 'Edwards,MS',
'39067': 'Ethel,MS',
'39069': 'Fayette,MS',
'39071': 'Flora,MS',
'39072': 'Pocahontas,MS',
'39073': 'Florence,MS',
'39074': 'Forest,MS',
'39077': 'Gallman,MS',
'39078': 'Georgetown,MS',
'39079': 'Goodman,MS',
'39080': 'Harperville,MS',
'39081': 'Harriston,MS',
'39082': 'Harrisville,MS',
'39083': 'Hazlehurst,MS',
'39086': 'Hermanville,MS',
'39087': 'Hillsboro,MS',
'39088': 'Holly Bluff,MS',
'39090': 'Kosciusko,MS',
'39092': 'Lake,MS',
'39094': 'Lena,MS',
'39095': 'Lexington,MS',
'39096': 'Lorman,MS',
'39097': 'Louise,MS',
'39098': 'Ludlow,MS',
'39107': 'Mc Adams,MS',
'39108': 'Mc Cool,MS',
'39109': 'Madden,MS',
'39110': 'Madison,MS',
'39111': 'Magee,MS',
'39112': 'Sanatorium,MS',
'39113': 'Mayersville,MS',
'39114': 'Mendenhall,MS',
'39115': 'Midnight,MS',
'39116': 'Mize,MS',
'39117': 'Morton,MS',
'39119': 'Mount Olive,MS',
'39120': 'Natchez,MS',
'39121': 'Natchez,MS',
'39122': 'Natchez,MS',
'39130': 'Madison,MS',
'39140': 'Newhebron,MS',
'39144': 'Pattison,MS',
'39145': 'Pelahatchie,MS',
'39146': 'Pickens,MS',
'39148': 'Piney Woods,MS',
'39149': 'Pinola,MS',
'39150': 'Port Gibson,MS',
'39151': 'Puckett,MS',
'39152': 'Pulaski,MS',
'39153': 'Raleigh,MS',
'39154': 'Raymond,MS',
'39156': 'Redwood,MS',
'39157': 'Ridgeland,MS',
'39158': 'Ridgeland,MS',
'39159': 'Rolling Fork,MS',
'39160': 'Sallis,MS',
'39161': 'Sandhill,MS',
'39162': 'Satartia,MS',
'39163': 'Sharon,MS',
'39165': 'Sibley,MS',
'39166': 'Silver City,MS',
'39167': 'Star,MS',
'39168': 'Taylorsville,MS',
'39169': 'Tchula,MS',
'39170': 'Terry,MS',
'39171': 'Thomastown,MS',
'39173': 'Tinsley,MS',
'39174': 'Tougaloo,MS',
'39175': 'Utica,MS',
'39176': 'Vaiden,MS',
'39177': 'Valley Park,MS',
'39179': 'Vaughan,MS',
'39180': 'Vicksburg,MS',
'39181': 'Vicksburg,MS',
'39182': 'Vicksburg,MS',
'39183': 'Vicksburg,MS',
'39189': 'Walnut Grove,MS',
'39190': 'Washington,MS',
'39191': 'Wesson,MS',
'39192': 'West,MS',
'39193': 'Whitfield,MS',
'39194': 'Yazoo City,MS',
'39201': 'Jackson,MS',
'39202': 'Jackson,MS',
'39203': 'Jackson,MS',
'39204': 'Jackson,MS',
'39205': 'Jackson,MS',
'39206': 'Jackson,MS',
'39207': 'Jackson,MS',
'39208': 'Pearl,MS',
'39209': 'Jackson,MS',
'39210': 'Jackson,MS',
'39211': 'Jackson,MS',
'39212': 'Jackson,MS',
'39213': 'Jackson,MS',
'39215': 'Jackson,MS',
'39216': 'Jackson,MS',
'39217': 'Jackson,MS',
'39218': 'Richland,MS',
'39225': 'Jackson,MS',
'39232': 'Flowood,MS',
'39235': 'Jackson,MS',
'39236': 'Jackson,MS',
'39250': 'Jackson,MS',
'39269': 'Jackson,MS',
'39271': 'Jackson,MS',
'39272': 'Byram,MS',
'39282': 'Jackson,MS',
'39283': 'Jackson,MS',
'39284': 'Jackson,MS',
'39286': 'Jackson,MS',
'39288': 'Pearl,MS',
'39289': 'Jackson,MS',
'39296': 'Jackson,MS',
'39298': 'Jackson,MS',
'39301': 'Meridian,MS',
'39302': 'Meridian,MS',
'39303': 'Meridian,MS',
'39304': 'Meridian,MS',
'39305': 'Meridian,MS',
'39307': 'Meridian,MS',
'39309': 'Meridian,MS',
'39320': 'Bailey,MS',
'39322': 'Buckatunna,MS',
'39323': 'Chunky,MS',
'39324': 'Clara,MS',
'39325': 'Collinsville,MS',
'39326': 'Daleville,MS',
'39327': 'Decatur,MS',
'39328': 'De Kalb,MS',
'39330': 'Enterprise,MS',
'39332': 'Hickory,MS',
'39335': 'Lauderdale,MS',
'39336': 'Lawrence,MS',
'39337': 'Little Rock,MS',
'39338': 'Louin,MS',
'39339': 'Louisville,MS',
'39341': 'Macon,MS',
'39342': 'Marion,MS',
'39345': 'Newton,MS',
'39346': 'Noxapater,MS',
'39347': 'Pachuta,MS',
'39348': 'Paulding,MS',
'39350': 'Philadelphia,MS',
'39352': 'Porterville,MS',
'39354': 'Preston,MS',
'39355': 'Quitman,MS',
'39356': 'Rose Hill,MS',
'39358': 'Scooba,MS',
'39359': 'Sebastopol,MS',
'39360': 'Shubuta,MS',
'39361': 'Shuqualak,MS',
'39362': 'State Line,MS',
'39363': 'Stonewall,MS',
'39364': 'Toomsuba,MS',
'39365': 'Union,MS',
'39366': 'Vossburg,MS',
'39367': 'Waynesboro,MS',
'39401': 'Hattiesburg,MS',
'39402': 'Hattiesburg,MS',
'39403': 'Hattiesburg,MS',
'39404': 'Hattiesburg,MS',
'39406': 'Hattiesburg,MS',
'39407': 'Hattiesburg,MS',
'39421': 'Bassfield,MS',
'39422': 'Bay Springs,MS',
'39423': 'Beaumont,MS',
'39425': 'Brooklyn,MS',
'39426': 'Carriere,MS',
'39427': 'Carson,MS',
'39428': 'Collins,MS',
'39429': 'Columbia,MS',
'39436': 'Eastabuchie,MS',
'39437': 'Ellisville,MS',
'39439': 'Heidelberg,MS',
'39440': 'Laurel,MS',
'39441': 'Laurel,MS',
'39442': 'Laurel,MS',
'39443': 'Laurel,MS',
'39451': 'Leakesville,MS',
'39452': 'Lucedale,MS',
'39455': 'Lumberton,MS',
'39456': 'Mc Lain,MS',
'39457': 'Mc Neill,MS',
'39459': 'Moselle,MS',
'39460': 'Moss,MS',
'39461': 'Neely,MS',
'39462': 'New Augusta,MS',
'39463': 'Nicholson,MS',
'39464': 'Ovett,MS',
'39465': 'Petal,MS',
'39466': 'Picayune,MS',
'39470': 'Poplarville,MS',
'39474': 'Prentiss,MS',
'39475': 'Purvis,MS',
'39476': 'Richton,MS',
'39477': 'Sandersville,MS',
'39478': 'Sandy Hook,MS',
'39479': 'Seminary,MS',
'39480': 'Soso,MS',
'39481': 'Stringer,MS',
'39482': 'Sumrall,MS',
'39483': 'Foxworth,MS',
'39501': 'Gulfport,MS',
'39502': 'Gulfport,MS',
'39503': 'Gulfport,MS',
'39505': 'Gulfport,MS',
'39506': 'Gulfport,MS',
'39507': 'Gulfport,MS',
'39520': 'Bay Saint Louis,MS',
'39521': 'Bay Saint Louis,MS',
'39522': 'Stennis Space Center,MS',
'39525': 'Diamondhead,MS',
'39529': 'Stennis Space Center,MS',
'39530': 'Biloxi,MS',
'39531': 'Biloxi,MS',
'39532': 'Biloxi,MS',
'39533': 'Biloxi,MS',
'39534': 'Biloxi,MS',
'39535': 'Biloxi,MS',
'39540': 'Diberville,MS',
'39552': 'Escatawpa,MS',
'39553': 'Gautier,MS',
'39555': 'Hurley,MS',
'39556': 'Kiln,MS',
'39558': 'Lakeshore,MS',
'39560': 'Long Beach,MS',
'39561': 'Mc Henry,MS',
'39562': 'Moss Point,MS',
'39563': 'Moss Point,MS',
'39564': 'Ocean Springs,MS',
'39565': 'Ocean Springs,MS',
'39566': 'Ocean Springs,MS',
'39567': 'Pascagoula,MS',
'39568': 'Pascagoula,MS',
'39569': 'Pascagoula,MS',
'39571': 'Pass Christian,MS',
'39572': 'Pearlington,MS',
'39573': 'Perkinston,MS',
'39574': 'Saucier,MS',
'39576': 'Waveland,MS',
'39577': 'Wiggins,MS',
'39581': 'Pascagoula,MS',
'39595': 'Pascagoula,MS',
'39601': 'Brookhaven,MS',
'39602': 'Brookhaven,MS',
'39603': 'Brookhaven,MS',
'39629': 'Bogue Chitto,MS',
'39630': 'Bude,MS',
'39631': 'Centreville,MS',
'39632': 'Chatawa,MS',
'39633': 'Crosby,MS',
'39635': 'Fernwood,MS',
'39638': 'Gloster,MS',
'39641': 'Jayess,MS',
'39643': 'Kokomo,MS',
'39645': 'Liberty,MS',
'39647': 'Mc Call Creek,MS',
'39648': 'Mccomb,MS',
'39649': 'Mccomb,MS',
'39652': 'Magnolia,MS',
'39653': 'Meadville,MS',
'39654': 'Monticello,MS',
'39656': 'Oak Vale,MS',
'39657': 'Osyka,MS',
'39661': 'Roxie,MS',
'39662': 'Ruth,MS',
'39663': 'Silver Creek,MS',
'39664': 'Smithdale,MS',
'39665': 'Sontag,MS',
'39666': 'Summit,MS',
'39667': 'Tylertown,MS',
'39668': 'Union Church,MS',
'39669': 'Woodville,MS',
'39701': 'Columbus,MS',
'39702': 'Columbus,MS',
'39703': 'Columbus,MS',
'39704': 'Columbus,MS',
'39705': 'Columbus,MS',
'39710': 'Columbus,MS',
'39730': 'Aberdeen,MS',
'39735': 'Ackerman,MS',
'39736': 'Artesia,MS',
'39737': 'Bellefontaine,MS',
'39739': 'Brooksville,MS',
'39740': 'Caledonia,MS',
'39741': 'Cedarbluff,MS',
'39743': 'Crawford,MS',
'39744': 'Eupora,MS',
'39745': 'French Camp,MS',
'39746': 'Hamilton,MS',
'39747': 'Kilmichael,MS',
'39750': 'Maben,MS',
'39751': 'Mantee,MS',
'39752': 'Mathiston,MS',
'39753': 'Mayhew,MS',
'39754': 'Montpelier,MS',
'39755': 'Pheba,MS',
'39756': 'Prairie,MS',
'39759': 'Starkville,MS',
'39760': 'Starkville,MS',
'39762': 'Mississippi State,MS',
'39766': 'Steens,MS',
'39767': 'Stewart,MS',
'39769': 'Sturgis,MS',
'39771': 'Walthall,MS',
'39772': 'Weir,MS',
'39773': 'West Point,MS',
'39776': 'Woodland,MS',
'39813': 'Arlington,GA',
'39815': 'Attapulgus,GA',
'39817': 'West Bainbridge,GA',
'39818': 'Bdge,GA',
'39823': 'Blakely,GA',
'39824': 'Bluffton,GA',
'39825': 'Brinson,GA',
'39826': 'Bronwood,GA',
'39827': 'Karo,GA',
'39828': 'Karo,GA',
'39829': 'Calvary,GA',
'39832': 'Cedar Springs,GA',
'39834': 'Climax,GA',
'39836': 'Coleman,GA',
'39841': 'Damascus,GA',
'39842': 'Dawson,GA',
'39845': 'Dville,GA',
'39846': 'Edison,GA',
'39851': 'Fort Gaines,GA',
'39852': 'Fowlstown,GA',
'39854': 'Georgetown,GA',
'39859': 'Iron City,GA',
'39861': 'Jakin,GA',
'39862': 'Leary,GA',
'39866': 'Morgan,GA',
'39867': 'Morris,GA',
'39870': 'Newton,GA',
'39877': 'Parrott,GA',
'39885': 'Sasser,GA',
'39886': 'Shellman,GA',
'39897': 'Whigham,GA',
'39901': 'Atlanta,GA',
'40003': 'Bagdad,KY',
'40004': 'Bardstown,KY',
'40006': 'Bedford,KY',
'40007': 'Bethlehem,KY',
'40008': 'Bloomfield,KY',
'40009': 'Bradfordsville,KY',
'40010': 'Buckner,KY',
'40011': 'Campbellsburg,KY',
'40012': 'Chaplin,KY',
'40013': 'Coxs Creek,KY',
'40014': 'Crestwood,KY',
'40018': 'Eastwood,KY',
'40019': 'Eminence,KY',
'40020': 'Fairfield,KY',
'40022': 'Finchville,KY',
'40023': 'Fisherville,KY',
'40025': 'Glenview,KY',
'40026': 'Goshen,KY',
'40027': 'Harrods Creek,KY',
'40031': 'La Grange,KY',
'40032': 'La Grange,KY',
'40033': 'Lebanon,KY',
'40036': 'Lockport,KY',
'40037': 'Loretto,KY',
'40040': 'Mackville,KY',
'40041': 'Masonic Home,KY',
'40045': 'Milton,KY',
'40046': 'Mount Eden,KY',
'40047': 'Mount Washington,KY',
'40048': 'Nazareth,KY',
'40049': 'Nerinx,KY',
'40050': 'New Castle,KY',
'40051': 'New Haven,KY',
'40052': 'New Hope,KY',
'40055': 'Pendleton,KY',
'40056': 'Pewee Valley,KY',
'40057': 'Pleasureville,KY',
'40058': 'Port Royal,KY',
'40059': 'Prospect,KY',
'40060': 'Raywick,KY',
'40061': 'Saint Catharine,KY',
'40062': 'Saint Francis,KY',
'40063': 'Saint Mary,KY',
'40065': 'Shelbyville,KY',
'40066': 'Shelbyville,KY',
'40067': 'Simpsonville,KY',
'40068': 'Smithfield,KY',
'40069': 'Springfield,KY',
'40070': 'Sulphur,KY',
'40071': 'Taylorsville,KY',
'40075': 'Turners Station,KY',
'40076': 'Waddy,KY',
'40077': 'Westport,KY',
'40078': 'Willisburg,KY',
'40104': 'Battletown,KY',
'40107': 'Boston,KY',
'40108': 'Brandenburg,KY',
'40109': 'Brooks,KY',
'40110': 'Clermont,KY',
'40111': 'Cloverport,KY',
'40115': 'Custer,KY',
'40117': 'Ekron,KY',
'40118': 'Fairdale,KY',
'40119': 'Falls Of Rough,KY',
'40121': 'Fort Knox,KY',
'40122': 'Fort Knox,KY',
'40129': 'Hillview,KY',
'40140': 'Garfield,KY',
'40142': 'Guston,KY',
'40143': 'Hardinsburg,KY',
'40144': 'Harned,KY',
'40145': 'Hudson,KY',
'40146': 'Irvington,KY',
'40150': 'Lebanon Junction,KY',
'40152': 'Mc Daniels,KY',
'40153': 'Mc Quady,KY',
'40155': 'Muldraugh,KY',
'40157': 'Payneville,KY',
'40159': 'Radcliff,KY',
'40160': 'Radcliff,KY',
'40161': 'Rhodelia,KY',
'40162': 'Rineyville,KY',
'40164': 'Se Ree,KY',
'40165': 'Shepherdsville,KY',
'40170': 'Stephensport,KY',
'40171': 'Union Star,KY',
'40175': 'Vine Grove,KY',
'40176': 'Webster,KY',
'40177': 'West Point,KY',
'40178': 'Westview,KY',
'40201': 'Louisville,KY',
'40202': 'Louisville,KY',
'40203': 'Louisville,KY',
'40204': 'Louisville,KY',
'40205': 'Louisville,KY',
'40206': 'Louisville,KY',
'40207': 'Louisville,KY',
'40208': 'Louisville,KY',
'40209': 'Louisville,KY',
'40210': 'Louisville,KY',
'40211': 'Louisville,KY',
'40212': 'Louisville,KY',
'40213': 'Louisville,KY',
'40214': 'Louisville,KY',
'40215': 'Louisville,KY',
'40216': 'Louisville,KY',
'40217': 'Louisville,KY',
'40218': 'Louisville,KY',
'40219': 'Louisville,KY',
'40220': 'Louisville,KY',
'40221': 'Louisville,KY',
'40222': 'Louisville,KY',
'40223': 'Louisville,KY',
'40224': 'Louisville,KY',
'40225': 'Louisville,KY',
'40228': 'Louisville,KY',
'40229': 'Louisville,KY',
'40231': 'Louisville,KY',
'40232': 'Louisville,KY',
'40233': 'Louisville,KY',
'40241': 'Louisville,KY',
'40242': 'Louisville,KY',
'40243': 'Louisville,KY',
'40245': 'Louisville,KY',
'40250': 'Louisville,KY',
'40251': 'Louisville,KY',
'40252': 'Louisville,KY',
'40253': 'Louisville,KY',
'40255': 'Louisville,KY',
'40256': 'Louisville,KY',
'40257': 'Louisville,KY',
'40258': 'Louisville,KY',
'40259': 'Louisville,KY',
'40261': 'Louisville,KY',
'40266': 'Louisville,KY',
'40268': 'Louisville,KY',
'40269': 'Louisville,KY',
'40270': 'Louisville,KY',
'40272': 'Louisville,KY',
'40280': 'Louisville,KY',
'40281': 'Louisville,KY',
'40282': 'Louisville,KY',
'40283': 'Louisville,KY',
'40285': 'Louisville,KY',
'40287': 'Louisville,KY',
'40289': 'Louisville,KY',
'40290': 'Louisville,KY',
'40291': 'Louisville,KY',
'40292': 'Louisville,KY',
'40293': 'Louisville,KY',
'40294': 'Louisville,KY',
'40295': 'Louisville,KY',
'40296': 'Louisville,KY',
'40297': 'Louisville,KY',
'40298': 'Louisville,KY',
'40299': 'Louisville,KY',
'40310': 'Burgin,KY',
'40311': 'Carlisle,KY',
'40312': 'Clay City,KY',
'40313': 'Clearfield,KY',
'40316': 'Denniston,KY',
'40317': 'Elliottville,KY',
'40319': 'Farmers,KY',
'40320': 'Ford,KY',
'40322': 'Frenchburg,KY',
'40324': 'Georgetown,KY',
'40328': 'Gravel Switch,KY',
'40329': 'Haldeman,KY',
'40330': 'Harrodsburg,KY',
'40334': 'Hope,KY',
'40336': 'Irvine,KY',
'40337': 'Jeffersonville,KY',
'40339': 'Keene,KY',
'40340': 'Nicholasville,KY',
'40342': 'Lawrenceburg,KY',
'40346': 'Means,KY',
'40347': 'Midway,KY',
'40348': 'Millersburg,KY',
'40350': 'Moorefield,KY',
'40351': 'Morehead,KY',
'40353': 'Mount Sterling,KY',
'40355': 'New Liberty,KY',
'40356': 'Nicholasville,KY',
'40357': 'North Middletown,KY',
'40358': 'Olympia,KY',
'40359': 'Owenton,KY',
'40360': 'Owingsville,KY',
'40361': 'Paris,KY',
'40362': 'Paris,KY',
'40363': 'Perry Park,KY',
'40366': 'Preston,KY',
'40370': 'Sadieville,KY',
'40371': 'Salt Lick,KY',
'40372': 'Salvisa,KY',
'40374': 'Sharpsburg,KY',
'40376': 'Slade,KY',
'40379': 'Stamping Ground,KY',
'40380': 'Stanton,KY',
'40383': 'Versailles,KY',
'40384': 'Versailles,KY',
'40385': 'Waco,KY',
'40386': 'Versailles,KY',
'40387': 'Wellington,KY',
'40390': 'Wilmore,KY',
'40391': 'Winchester,KY',
'40392': 'Winchester,KY',
'40402': 'Annville,KY',
'40403': 'Berea,KY',
'40404': 'Berea,KY',
'40405': 'Bighill,KY',
'40409': 'Brodhead,KY',
'40410': 'Bryantsville,KY',
'40419': 'Crab Orchard,KY',
'40421': 'Dabolt,KY',
'40422': 'Danville,KY',
'40423': 'Danville,KY',
'40434': 'Gray Hawk,KY',
'40437': 'Hustonville,KY',
'40440': 'Junction City,KY',
'40442': 'Kings Mountain,KY',
'40444': 'Lancaster,KY',
'40445': 'Livingston,KY',
'40446': 'Lancaster,KY',
'40447': 'Mc Kee,KY',
'40448': 'Mc Kinney,KY',
'40452': 'Mitchellsburg,KY',
'40456': 'Mount Vernon,KY',
'40460': 'Orlando,KY',
'40461': 'Paint Lick,KY',
'40464': 'Parksville,KY',
'40467': 'Peoples,KY',
'40468': 'Perryville,KY',
'40472': 'Ravenna,KY',
'40473': 'Renfro Valley,KY',
'40475': 'Richmond,KY',
'40476': 'Richmond,KY',
'40481': 'Sandgap,KY',
'40484': 'Stanford,KY',
'40486': 'Tyner,KY',
'40488': 'Waneta,KY',
'40489': 'Waynesburg,KY',
'40492': 'Wildie,KY',
'40495': 'Winston,KY',
'40502': 'Lexington,KY',
'40503': 'Lexington,KY',
'40504': 'Lexington,KY',
'40505': 'Lexington,KY',
'40506': 'Lexington,KY',
'40507': 'Lexington,KY',
'40508': 'Lexington,KY',
'40509': 'Lexington,KY',
'40510': 'Lexington,KY',
'40511': 'Lexington,KY',
'40512': 'Lexington,KY',
'40513': 'Lexington,KY',
'40514': 'Lexington,KY',
'40515': 'Lexington,KY',
'40516': 'Lexington,KY',
'40517': 'Lexington,KY',
'40522': 'Lexington,KY',
'40523': 'Lexington,KY',
'40524': 'Lexington,KY',
'40526': 'Lexington,KY',
'40533': 'Lexington,KY',
'40536': 'Lexington,KY',
'40544': 'Lexington,KY',
'40546': 'Lexington,KY',
'40550': 'Lexington,KY',
'40555': 'Lexington,KY',
'40574': 'Lexington,KY',
'40575': 'Lexington,KY',
'40576': 'Lexington,KY',
'40577': 'Lexington,KY',
'40578': 'Lexington,KY',
'40579': 'Lexington,KY',
'40580': 'Lexington,KY',
'40581': 'Lexington,KY',
'40582': 'Lexington,KY',
'40583': 'Lexington,KY',
'40584': 'Lexington,KY',
'40585': 'Lexington,KY',
'40586': 'Lexington,KY',
'40587': 'Lexington,KY',
'40588': 'Lexington,KY',
'40589': 'Lexington,KY',
'40590': 'Lexington,KY',
'40591': 'Lexington,KY',
'40592': 'Lexington,KY',
'40593': 'Lexington,KY',
'40594': 'Lexington,KY',
'40595': 'Lexington,KY',
'40596': 'Lexington,KY',
'40598': 'Lexington,KY',
'40601': 'Frankfort,KY',
'40602': 'Frankfort,KY',
'40603': 'Frankfort,KY',
'40604': 'Frankfort,KY',
'40618': 'Frankfort,KY',
'40619': 'Frankfort,KY',
'40620': 'Frankfort,KY',
'40621': 'Frankfort,KY',
'40622': 'Frankfort,KY',
'40701': 'Corbin,KY',
'40702': 'Corbin,KY',
'40724': 'Bush,KY',
'40729': 'East Bernstadt,KY',
'40730': 'Emlyn,KY',
'40734': 'Gray,KY',
'40737': 'Keavy,KY',
'40740': 'Lily,KY',
'40741': 'London,KY',
'40742': 'London,KY',
'40743': 'London,KY',
'40744': 'London,KY',
'40745': 'London,KY',
'40751': 'Marydell,KY',
'40754': 'Nevisdale,KY',
'40755': 'Pittsburg,KY',
'40759': 'Rockholds,KY',
'40763': 'Siler,KY',
'40769': 'Williamsburg,KY',
'40771': 'Woodbine,KY',
'40801': 'Ages Brookside,KY',
'40803': 'Asher,KY',
'40806': 'Baxter,KY',
'40807': 'Benham,KY',
'40808': 'Big Laurel,KY',
'40810': 'Bledsoe,KY',
'40813': 'Calvin,KY',
'40815': 'Cawood,KY',
'40816': 'Chappell,KY',
'40818': 'Coalgood,KY',
'40819': 'Coldiron,KY',
'40820': 'Cranks,KY',
'40823': 'Cumberland,KY',
'40824': 'Dayhoit,KY',
'40826': 'Eolia,KY',
'40827': 'Essie,KY',
'40828': 'Evarts,KY',
'40829': 'Grays Knob,KY',
'40830': 'Gulston,KY',
'40831': 'Harlan,KY',
'40840': 'Helton,KY',
'40843': 'Holmes Mill,KY',
'40844': 'Hoskinston,KY',
'40845': 'Hulen,KY',
'40847': 'Kenvir,KY',
'40849': 'Lejunior,KY',
'40854': 'Loyall,KY',
'40855': 'Lynch,KY',
'40856': 'Miracle,KY',
'40858': 'Mozelle,KY',
'40862': 'Partridge,KY',
'40863': 'Pathfork,KY',
'40865': 'Putney,KY',
'40868': 'Stinnett,KY',
'40870': 'Totz,KY',
'40873': 'Wallins Creek,KY',
'40874': 'Warbranch,KY',
'40902': 'Arjay,KY',
'40903': 'Artemus,KY',
'40906': 'Barbourville,KY',
'40913': 'Beverly,KY',
'40914': 'Big Creek,KY',
'40915': 'Bimble,KY',
'40921': 'Bryants Store,KY',
'40923': 'Cannon,KY',
'40927': 'Closplint,KY',
'40930': 'Dewitt,KY',
'40931': 'Eriline,KY',
'40932': 'Fall Rock,KY',
'40935': 'Flat Lick,KY',
'40939': 'Fourmile,KY',
'40940': 'Frakes,KY',
'40941': 'Garrard,KY',
'40943': 'Girdler,KY',
'40944': 'Goose Rock,KY',
'40946': 'Green Road,KY',
'40949': 'Heidrick,KY',
'40951': 'Hima,KY',
'40953': 'Hinkle,KY',
'40955': 'Ingram,KY',
'40958': 'Kettle Island,KY',
'40962': 'Manchester,KY',
'40964': 'Mary Alice,KY',
'40965': 'Middlesboro,KY',
'40972': 'Oneida,KY',
'40977': 'Pineville,KY',
'40979': 'Roark,KY',
'40981': 'Saul,KY',
'40982': 'Scalf,KY',
'40983': 'Sextons Creek,KY',
'40988': 'Stoney Fork,KY',
'40995': 'Trosper,KY',
'40997': 'Walker,KY',
'40999': 'Woollum,KY',
'41001': 'Alexandria,KY',
'41002': 'Augusta,KY',
'41003': 'Berry,KY',
'41004': 'Brooksville,KY',
'41005': 'Burlington,KY',
'41006': 'Butler,KY',
'41007': 'California,KY',
'41008': 'Carrollton,KY',
'41010': 'Corinth,KY',
'41011': 'Covington,KY',
'41012': 'Covington,KY',
'41014': 'Covington,KY',
'41015': 'Latonia,KY',
'41016': 'Covington,KY',
'41017': 'Ft Mitchell,KY',
'41018': 'Erlanger,KY',
'41019': 'Covington,KY',
'41022': 'Florence,KY',
'41030': 'Crittenden,KY',
'41031': 'Cynthiana,KY',
'41033': 'De Mossville,KY',
'41034': 'Dover,KY',
'41035': 'Dry Ridge,KY',
'41037': 'Elizaville,KY',
'41039': 'Ewing,KY',
'41040': 'Falmouth,KY',
'41041': 'Flemingsburg,KY',
'41042': 'Florence,KY',
'41043': 'Foster,KY',
'41044': 'Germantown,KY',
'41045': 'Ghent,KY',
'41046': 'Glencoe,KY',
'41048': 'Hebron,KY',
'41049': 'Hillsboro,KY',
'41051': 'Independence,KY',
'41052': 'Jonesville,KY',
'41053': 'Kenton,KY',
'41054': 'Mason,KY',
'41055': 'Mayslick,KY',
'41056': 'Maysville,KY',
'41059': 'Melbourne,KY',
'41061': 'Milford,KY',
'41062': 'Minerva,KY',
'41063': 'Morning View,KY',
'41064': 'Mount Olivet,KY',
'41065': 'Muses Mills,KY',
'41071': 'Newport,KY',
'41072': 'Newport,KY',
'41073': 'Bellevue,KY',
'41074': 'Dayton,KY',
'41075': 'Fort Thomas,KY',
'41076': 'Newport,KY',
'41080': 'Petersburg,KY',
'41081': 'Plummers Landing,KY',
'41083': 'Sanders,KY',
'41085': 'Silver Grove,KY',
'41086': 'Sparta,KY',
'41091': 'Union,KY',
'41092': 'Verona,KY',
'41093': 'Wallingford,KY',
'41094': 'Walton,KY',
'41095': 'Warsaw,KY',
'41096': 'Washington,KY',
'41097': 'Williamstown,KY',
'41098': 'Worthville,KY',
'41099': 'Newport,KY',
'41101': 'Ashland,KY',
'41102': 'Ashland,KY',
'41105': 'Ashland,KY',
'41114': 'Ashland,KY',
'41121': 'Argillite,KY',
'41124': 'Blaine,KY',
'41127': 'Camp Dix,KY',
'41128': 'Carter,KY',
'41129': 'Catlettsburg,KY',
'41132': 'Denton,KY',
'41135': 'Emerson,KY',
'41137': 'Firebrick,KY',
'41139': 'Flatwoods,KY',
'41141': 'Garrison,KY',
'41142': 'Grahn,KY',
'41143': 'Grayson,KY',
'41144': 'Greenup,KY',
'41146': 'Hitchins,KY',
'41149': 'Isonville,KY',
'41150': 'Jacobs,KY',
'41156': 'Lloyd,KY',
'41159': 'Martha,KY',
'41160': 'Mazie,KY',
'41164': 'Olive Hill,KY',
'41166': 'Quincy,KY',
'41168': 'Rush,KY',
'41169': 'Russell,KY',
'41170': 'Saint Paul,KY',
'41171': 'Sandy Hook,KY',
'41173': 'Soldier,KY',
'41174': 'South Portsmouth,KY',
'41175': 'South Shore,KY',
'41179': 'Vanceburg,KY',
'41180': 'Webbville,KY',
'41181': 'Willard,KY',
'41183': 'Worthington,KY',
'41189': 'Tollesboro,KY',
'41201': 'Adams,KY',
'41203': 'Beauty,KY',
'41204': 'Boons Camp,KY',
'41214': 'Debord,KY',
'41215': 'Denver,KY',
'41216': 'East Point,KY',
'41219': 'Flatgap,KY',
'41222': 'Hagerhill,KY',
'41224': 'Inez,KY',
'41226': 'Keaton,KY',
'41228': 'Leander,KY',
'41230': 'Louisa,KY',
'41231': 'Lovely,KY',
'41232': 'Lowmansville,KY',
'41234': 'Meally,KY',
'41238': 'Oil Springs,KY',
'41240': 'Paintsville,KY',
'41250': 'Pilgrim,KY',
'41254': 'River,KY',
'41255': 'Sitka,KY',
'41256': 'Staffordsville,KY',
'41257': 'Stambaugh,KY',
'41260': 'Thelma,KY',
'41262': 'Tomahawk,KY',
'41263': 'Tutor Key,KY',
'41264': 'Ulysses,KY',
'41265': 'Van Lear,KY',
'41267': 'Warfield,KY',
'41268': 'West Van Lear,KY',
'41271': 'Williamsport,KY',
'41274': 'Wittensville,KY',
'41301': 'Campton,KY',
'41307': 'Athol,KY',
'41310': 'Bays,KY',
'41311': 'Beattyville,KY',
'41313': 'Bethany,KY',
'41314': 'Booneville,KY',
'41317': 'Clayhole,KY',
'41332': 'Hazel Green,KY',
'41333': 'Heidelberg,KY',
'41338': 'Island City,KY',
'41339': 'Jackson,KY',
'41342': 'Lee City,KY',
'41344': 'Lerose,KY',
'41347': 'Lone,KY',
'41348': 'Lost Creek,KY',
'41351': 'Mistletoe,KY',
'41352': 'Mize,KY',
'41360': 'Pine Ridge,KY',
'41362': 'Primrose,KY',
'41364': 'Ricetown,KY',
'41365': 'Rogers,KY',
'41366': 'Rousseau,KY',
'41367': 'Rowdy,KY',
'41368': 'Saint Helens,KY',
'41377': 'Talbert,KY',
'41385': 'Vancleve,KY',
'41386': 'Vincent,KY',
'41390': 'Whick,KY',
'41397': 'Zoe,KY',
'41408': 'Cannel City,KY',
'41410': 'Cisco,KY',
'41413': 'Crockett,KY',
'41419': 'Edna,KY',
'41421': 'Elkfork,KY',
'41422': 'Elsie,KY',
'41425': 'Ezel,KY',
'41426': 'Falcon,KY',
'41433': 'Gapville,KY',
'41444': 'Ivyton,KY',
'41451': 'Malone,KY',
'41459': 'Ophir,KY',
'41464': 'Royalton,KY',
'41465': 'Salyersville,KY',
'41472': 'West Liberty,KY',
'41477': 'Wrigley,KY',
'41501': 'Pikeville,KY',
'41502': 'Pikeville,KY',
'41503': 'South Williamson,KY',
'41512': 'Ashcamp,KY',
'41513': 'Belcher,KY',
'41514': 'Belfry,KY',
'41517': 'Burdine,KY',
'41519': 'Canada,KY',
'41520': 'Dorton,KY',
'41522': 'Elkhorn City,KY',
'41524': 'Fedscreek,KY',
'41526': 'Fords Branch,KY',
'41527': 'Forest Hills,KY',
'41528': 'Freeburn,KY',
'41531': 'Hardy,KY',
'41534': 'Hellier,KY',
'41535': 'Huddy,KY',
'41537': 'Jenkins,KY',
'41538': 'Jonancy,KY',
'41539': 'Kimper,KY',
'41540': 'Lick Creek,KY',
'41542': 'Lookout,KY',
'41543': 'Mc Andrews,KY',
'41544': 'Mc Carr,KY',
'41546': 'Mc Veigh,KY',
'41547': 'Majestic,KY',
'41548': 'Mouthcard,KY',
'41549': 'Myra,KY',
'41553': 'Phelps,KY',
'41554': 'Phyllis,KY',
'41555': 'Pinsonfork,KY',
'41557': 'Raccoon,KY',
'41558': 'Ransom,KY',
'41559': 'Regina,KY',
'41560': 'Robinson Creek,KY',
'41561': 'Rockhouse,KY',
'41562': 'Shelbiana,KY',
'41563': 'Shelby Gap,KY',
'41564': 'Sidney,KY',
'41566': 'Steele,KY',
'41567': 'Stone,KY',
'41568': 'Stopover,KY',
'41569': 'Toler,KY',
'41571': 'Varney,KY',
'41572': 'Virgie,KY',
'41601': 'Allen,KY',
'41602': 'Auxier,KY',
'41603': 'Banner,KY',
'41604': 'Beaver,KY',
'41605': 'Betsy Layne,KY',
'41606': 'Bevinsville,KY',
'41607': 'Blue River,KY',
'41612': 'Bypro,KY',
'41615': 'Dana,KY',
'41616': 'David,KY',
'41619': 'Drift,KY',
'41621': 'Dwale,KY',
'41622': 'Eastern,KY',
'41630': 'Garrett,KY',
'41631': 'Grethel,KY',
'41632': 'Gunlock,KY',
'41635': 'Harold,KY',
'41636': 'Hi Hat,KY',
'41640': 'Hueysville,KY',
'41642': 'Ivel,KY',
'41643': 'Lackey,KY',
'41645': 'Langley,KY',
'41647': 'Mc Dowell,KY',
'41649': 'Martin,KY',
'41650': 'Melvin,KY',
'41651': 'Minnie,KY',
'41653': 'Prestonsburg,KY',
'41655': 'Printer,KY',
'41659': 'Stanville,KY',
'41660': 'Teaberry,KY',
'41663': 'Tram,KY',
'41666': 'Wayland,KY',
'41667': 'Weeksbury,KY',
'41669': 'Wheelwright,KY',
'41701': 'Hazard,KY',
'41702': 'Hazard,KY',
'41712': 'Ary,KY',
'41713': 'Avawam,KY',
'41714': 'Bear Branch,KY',
'41719': 'Bonnyman,KY',
'41721': 'Buckhorn,KY',
'41722': 'Bulan,KY',
'41723': 'Busy,KY',
'41725': 'Carrie,KY',
'41727': 'Chavies,KY',
'41729': 'Combs,KY',
'41730': 'Confluence,KY',
'41731': 'Cornettsville,KY',
'41735': 'Delphia,KY',
'41736': 'Dice,KY',
'41739': 'Dwarf,KY',
'41740': 'Emmalena,KY',
'41743': 'Fisty,KY',
'41745': 'Gays Creek,KY',
'41746': 'Happy,KY',
'41747': 'Hardburly,KY',
'41749': 'Hyden,KY',
'41751': 'Jeff,KY',
'41754': 'Krypton,KY',
'41759': 'Sassafras,KY',
'41760': 'Scuddy,KY',
'41762': 'Sizerock,KY',
'41763': 'Slemp,KY',
'41764': 'Smilax,KY',
'41766': 'Thousandsticks,KY',
'41772': 'Vest,KY',
'41773': 'Vicco,KY',
'41774': 'Viper,KY',
'41775': 'Wendover,KY',
'41776': 'Wooton,KY',
'41777': 'Yeaddiss,KY',
'41778': 'Yerkes,KY',
'41804': 'Blackey,KY',
'41810': 'Cromona,KY',
'41812': 'Deane,KY',
'41815': 'Ermine,KY',
'41817': 'Garner,KY',
'41819': 'Gordon,KY',
'41821': 'Hallie,KY',
'41822': 'Hindman,KY',
'41824': 'Isom,KY',
'41825': 'Jackhorn,KY',
'41826': 'Jeremiah,KY',
'41828': 'Kite,KY',
'41831': 'Leburn,KY',
'41832': 'Letcher,KY',
'41833': 'Linefork,KY',
'41834': 'Littcarr,KY',
'41835': 'Mc Roberts,KY',
'41836': 'Mallie,KY',
'41837': 'Mayking,KY',
'41838': 'Millstone,KY',
'41839': 'Mousie,KY',
'41840': 'Neon,KY',
'41843': 'Pine Top,KY',
'41844': 'Pippa Passes,KY',
'41845': 'Premium,KY',
'41847': 'Redfox,KY',
'41848': 'Roxana,KY',
'41849': 'Seco,KY',
'41855': 'Thornton,KY',
'41858': 'Whitesburg,KY',
'41859': 'Dema,KY',
'41861': 'Raven,KY',
'41862': 'Topmost,KY',
'41901': 'Migrate,KY',
'41902': 'Migrate,KY',
'41903': 'Migrate,KY',
'41904': 'Migrate,KY',
'41905': 'Migrate,KY',
'41906': 'Migrate,KY',
'42001': 'Paducah,KY',
'42002': 'Paducah,KY',
'42003': 'Paducah,KY',
'42020': 'Almo,KY',
'42021': 'Arlington,KY',
'42022': 'Bandana,KY',
'42023': 'Bardwell,KY',
'42024': 'Barlow,KY',
'42025': 'Benton,KY',
'42027': 'Boaz,KY',
'42028': 'Burna,KY',
'42029': 'Calvert City,KY',
'42031': 'Clinton,KY',
'42032': 'Columbus,KY',
'42033': 'Crayne,KY',
'42035': 'Cunningham,KY',
'42036': 'Dexter,KY',
'42037': 'Dycusburg,KY',
'42038': 'Eddyville,KY',
'42039': 'Fancy Farm,KY',
'42040': 'Farmington,KY',
'42041': 'Fulton,KY',
'42044': 'Gilbertsville,KY',
'42045': 'Grand Rivers,KY',
'42046': 'Hamlin,KY',
'42047': 'Hampton,KY',
'42048': 'Hardin,KY',
'42049': 'Hazel,KY',
'42050': 'Hickman,KY',
'42051': 'Hickory,KY',
'42053': 'Kevil,KY',
'42054': 'Kirksey,KY',
'42055': 'Kuttawa,KY',
'42056': 'La Center,KY',
'42058': 'Ledbetter,KY',
'42060': 'Lovelaceville,KY',
'42061': 'Lowes,KY',
'42063': 'Lynnville,KY',
'42064': 'Marion,KY',
'42066': 'Mayfield,KY',
'42069': 'Melber,KY',
'42070': 'Milburn,KY',
'42071': 'Murray,KY',
'42076': 'New Concord,KY',
'42078': 'Salem,KY',
'42079': 'Sedalia,KY',
'42081': 'Smithland,KY',
'42082': 'Symsonia,KY',
'42083': 'Tiline,KY',
'42084': 'Tolu,KY',
'42085': 'Water Valley,KY',
'42086': 'West Paducah,KY',
'42087': 'Wickliffe,KY',
'42088': 'Wingo,KY',
'42101': 'Bowling Green,KY',
'42102': 'Bowling Green,KY',
'42103': 'Bowling Green,KY',
'42104': 'Bowling Green,KY',
'42120': 'Adolphus,KY',
'42122': 'Alvaton,KY',
'42123': 'Austin,KY',
'42124': 'Beaumont,KY',
'42127': 'Cave City,KY',
'42128': 'Drake,KY',
'42129': 'Edmonton,KY',
'42130': 'Eighty Eight,KY',
'42131': 'Etoile,KY',
'42133': 'Fountain Run,KY',
'42134': 'Franklin,KY',
'42135': 'Franklin,KY',
'42140': 'Gamaliel,KY',
'42141': 'Glasgow,KY',
'42142': 'Glasgow,KY',
'42150': 'Halfway,KY',
'42151': 'Hestand,KY',
'42152': 'Hiseville,KY',
'42153': 'Holland,KY',
'42154': 'Knob Lick,KY',
'42156': 'Lucas,KY',
'42157': 'Mount Hermon,KY',
'42159': 'Oakland,KY',
'42160': 'Park City,KY',
'42163': 'Rocky Hill,KY',
'42164': 'Scottsville,KY',
'42166': 'Summer Shade,KY',
'42167': 'Tompkinsville,KY',
'42170': 'Woodburn,KY',
'42171': 'Smiths Grove,KY',
'42201': 'Aberdeen,KY',
'42202': 'Adairville,KY',
'42203': 'Allegre,KY',
'42204': 'Allensville,KY',
'42206': 'Auburn,KY',
'42207': 'Bee Spring,KY',
'42209': 'Brooklyn,KY',
'42210': 'Brownsville,KY',
'42211': 'Cadiz,KY',
'42214': 'Center,KY',
'42215': 'Cerulean,KY',
'42216': 'Clifty,KY',
'42217': 'Crofton,KY',
'42219': 'Dunbar,KY',
'42220': 'Elkton,KY',
'42221': 'Fairview,KY',
'42223': 'Fort Campbell,KY',
'42232': 'Gracey,KY',
'42234': 'Guthrie,KY',
'42235': 'Hadley,KY',
'42236': 'Herndon,KY',
'42240': 'Hopkinsville,KY',
'42241': 'Hopkinsville,KY',
'42251': 'Huntsville,KY',
'42252': 'Jetson,KY',
'42254': 'La Fayette,KY',
'42256': 'Lewisburg,KY',
'42257': 'Lindseyville,KY',
'42259': 'Mammoth Cave,KY',
'42261': 'Morgantown,KY',
'42262': 'Oak Grove,KY',
'42265': 'Olmstead,KY',
'42266': 'Pembroke,KY',
'42267': 'Provo,KY',
'42270': 'Richardsville,KY',
'42273': 'Rochester,KY',
'42274': 'Rockfield,KY',
'42275': 'Roundhill,KY',
'42276': 'Russellville,KY',
'42280': 'Sharon Grove,KY',
'42283': 'South Union,KY',
'42285': 'Sweeden,KY',
'42286': 'Trenton,KY',
'42287': 'Welchs Creek,KY',
'42288': 'Woodbury,KY',
'42301': 'Owensboro,KY',
'42302': 'Owensboro,KY',
'42303': 'Owensboro,KY',
'42304': 'Owensboro,KY',
'42320': 'Beaver Dam,KY',
'42321': 'Beech Creek,KY',
'42322': 'Beech Grove,KY',
'42323': 'Beechmont,KY',
'42324': 'Belton,KY',
'42325': 'Bremen,KY',
'42326': 'Browder,KY',
'42327': 'Calhoun,KY',
'42328': 'Centertown,KY',
'42330': 'Central City,KY',
'42332': 'Cleaton,KY',
'42333': 'Cromwell,KY',
'42334': 'Curdsville,KY',
'42337': 'Drakesboro,KY',
'42338': 'Dundee,KY',
'42339': 'Dunmor,KY',
'42343': 'Fordsville,KY',
'42344': 'Graham,KY',
'42345': 'Greenville,KY',
'42347': 'Hartford,KY',
'42348': 'Hawesville,KY',
'42349': 'Horse Branch,KY',
'42350': 'Island,KY',
'42351': 'Lewisport,KY',
'42352': 'Livermore,KY',
'42354': 'Mc Henry,KY',
'42355': 'Maceo,KY',
'42356': 'Maple Mount,KY',
'42361': 'Olaton,KY',
'42364': 'Pellville,KY',
'42365': 'Penrod,KY',
'42366': 'Philpot,KY',
'42367': 'Powderly,KY',
'42368': 'Reynolds Station,KY',
'42369': 'Rockport,KY',
'42370': 'Rosine,KY',
'42371': 'Rumsey,KY',
'42372': 'Sacramento,KY',
'42374': 'South Carrollton,KY',
'42375': 'Stanley,KY',
'42376': 'Utica,KY',
'42377': 'West Louisville,KY',
'42378': 'Whitesville,KY',
'42402': 'Baskett,KY',
'42403': 'Blackford,KY',
'42404': 'Clay,KY',
'42406': 'Corydon,KY',
'42408': 'Dawson Springs,KY',
'42409': 'Dixon,KY',
'42410': 'Earlington,KY',
'42411': 'Fredonia,KY',
'42413': 'Hanson,KY',
'42419': 'Henderson,KY',
'42420': 'Henderson,KY',
'42431': 'Madisonville,KY',
'42436': 'Manitou,KY',
'42437': 'Morganfield,KY',
'42440': 'Mortons Gap,KY',
'42441': 'Nebo,KY',
'42442': 'Nortonville,KY',
'42444': 'Poole,KY',
'42445': 'Princeton,KY',
'42450': 'Providence,KY',
'42451': 'Reed,KY',
'42452': 'Robards,KY',
'42453': 'Saint Charles,KY',
'42455': 'Sebree,KY',
'42456': 'Slaughters,KY',
'42457': 'Smith Mills,KY',
'42458': 'Spottsville,KY',
'42459': 'Sturgis,KY',
'42460': 'Sullivan,KY',
'42461': 'Uniontown,KY',
'42462': 'Waverly,KY',
'42463': 'Wheatcroft,KY',
'42464': 'White Plains,KY',
'42501': 'Somerset,KY',
'42502': 'Somerset,KY',
'42503': 'Somerset,KY',
'42516': 'Bethelridge,KY',
'42518': 'Bronston,KY',
'42519': 'Burnside,KY',
'42528': 'Dunnville,KY',
'42533': 'Ferguson,KY',
'42539': 'Liberty,KY',
'42541': 'Middleburg,KY',
'42544': 'Nancy,KY',
'42553': 'Science Hill,KY',
'42558': 'Tateville,KY',
'42564': 'West Somerset,KY',
'42565': 'Windsor,KY',
'42566': 'Yosemite,KY',
'42567': 'Eubank,KY',
'42602': 'Albany,KY',
'42603': 'Alpha,KY',
'42629': 'Jamestown,KY',
'42631': 'Marshes Siding,KY',
'42632': 'Mill Springs,KY',
'42633': 'Monticello,KY',
'42634': 'Parkers Lake,KY',
'42635': 'Pine Knot,KY',
'42638': 'Revelo,KY',
'42642': 'Russell Springs,KY',
'42647': 'Stearns,KY',
'42649': 'Strunk,KY',
'42653': 'Whitley City,KY',
'42701': 'Elizabethtown,KY',
'42702': 'Elizabethtown,KY',
'42711': 'Bakerton,KY',
'42712': 'Big Clifty,KY',
'42713': 'Bonnieville,KY',
'42715': 'Breeding,KY',
'42716': 'Buffalo,KY',
'42717': 'Burkesville,KY',
'42718': 'Campbellsville,KY',
'42719': 'Campbellsville,KY',
'42720': 'Cane Valley,KY',
'42721': 'Caneyville,KY',
'42722': 'Canmer,KY',
'42724': 'Cecilia,KY',
'42726': 'Clarkson,KY',
'42728': 'Columbia,KY',
'42729': 'Cub Run,KY',
'42731': 'Dubre,KY',
'42732': 'Eastview,KY',
'42733': 'Elk Horn,KY',
'42735': 'Fairplay,KY',
'42740': 'Glendale,KY',
'42741': 'Glens Fork,KY',
'42742': 'Gradyville,KY',
'42743': 'Greensburg,KY',
'42746': 'Hardyville,KY',
'42748': 'Hodgenville,KY',
'42749': 'Horse Cave,KY',
'42753': 'Knifley,KY',
'42754': 'Leitchfield,KY',
'42755': 'Leitchfield,KY',
'42757': 'Magnolia,KY',
'42758': 'Mannsville,KY',
'42759': 'Marrowbone,KY',
'42761': 'Milltown,KY',
'42762': 'Millwood,KY',
'42764': 'Mount Sherman,KY',
'42765': 'Munfordville,KY',
'42776': 'Sonora,KY',
'42782': 'Summersville,KY',
'42783': 'Summit,KY',
'42784': 'Upton,KY',
'42786': 'Waterview,KY',
'42788': 'White Mills,KY',
'43001': 'Alexandria,OH',
'43002': 'Amlin,OH',
'43003': 'Ashley,OH',
'43004': 'Blacklick,OH',
'43005': 'Bladensburg,OH',
'43006': 'Brinkhaven,OH',
'43007': 'Broadway,OH',
'43008': 'Buckeye Lake,OH',
'43009': 'Cable,OH',
'43010': 'Catawba,OH',
'43011': 'Centerburg,OH',
'43013': 'Croton,OH',
'43014': 'Danville,OH',
'43015': 'Delaware,OH',
'43016': 'Dublin,OH',
'43017': 'Dublin,OH',
'43018': 'Etna,OH',
'43019': 'Fredericktown,OH',
'43021': 'Galena,OH',
'43022': 'Gambier,OH',
'43023': 'Granville,OH',
'43025': 'Hebron,OH',
'43026': 'Hilliard,OH',
'43027': 'Homer,OH',
'43028': 'Howard,OH',
'43029': 'Irwin,OH',
'43030': 'Jacksontown,OH',
'43031': 'Johnstown,OH',
'43032': 'Kilbourne,OH',
'43033': 'Kirkersville,OH',
'43035': 'Lewis Center,OH',
'43036': 'Magnetic Springs,OH',
'43037': 'Martinsburg,OH',
'43040': 'Marysville,OH',
'43041': 'Marysville,OH',
'43044': 'Mechanicsburg,OH',
'43045': 'Milford Center,OH',
'43046': 'Millersport,OH',
'43047': 'Mingo,OH',
'43048': 'Mount Liberty,OH',
'43050': 'Mount Vernon,OH',
'43054': 'New Albany,OH',
'43055': 'Newark,OH',
'43056': 'Heath,OH',
'43058': 'Newark,OH',
'43060': 'North Lewisburg,OH',
'43061': 'Ostrander,OH',
'43062': 'Pataskala,OH',
'43064': 'Plain City,OH',
'43065': 'Powell,OH',
'43066': 'Radnor,OH',
'43067': 'Raymond,OH',
'43068': 'Reynoldsburg,OH',
'43070': 'Rosewood,OH',
'43071': 'Saint Louisville,OH',
'43072': 'Saint Paris,OH',
'43073': 'Summit Station,OH',
'43074': 'Sunbury,OH',
'43076': 'Thornville,OH',
'43077': 'Unionville Center,OH',
'43078': 'Urbana,OH',
'43080': 'Utica,OH',
'43081': 'Westerville,OH',
'43082': 'Westerville,OH',
'43083': 'Westville,OH',
'43084': 'Woodstock,OH',
'43085': 'Columbus,OH',
'43086': 'Westerville,OH',
'43093': 'Newark,OH',
'43098': 'Hebron,OH',
'43101': 'Adelphi,OH',
'43102': 'Amanda,OH',
'43103': 'Ashville,OH',
'43105': 'Baltimore,OH',
'43106': 'Bloomingburg,OH',
'43107': 'Bremen,OH',
'43109': 'Brice,OH',
'43110': 'Canal Winchester,OH',
'43111': 'Carbon Hill,OH',
'43112': 'Carroll,OH',
'43113': 'Circleville,OH',
'43115': 'Clarksburg,OH',
'43116': 'Commercial Point,OH',
'43117': 'Derby,OH',
'43119': 'Galloway,OH',
'43123': 'Grove City,OH',
'43125': 'Groveport,OH',
'43126': 'Harrisburg,OH',
'43127': 'Haydenville,OH',
'43128': 'Jeffersonville,OH',
'43130': 'Lancaster,OH',
'43135': 'Laurelville,OH',
'43136': 'Lithopolis,OH',
'43137': 'Lockbourne,OH',
'43138': 'Logan,OH',
'43140': 'London,OH',
'43142': 'Milledgeville,OH',
'43143': 'Mount Sterling,OH',
'43144': 'Murray City,OH',
'43145': 'New Holland,OH',
'43146': 'Orient,OH',
'43147': 'Pickerington,OH',
'43148': 'Pleasantville,OH',
'43149': 'Rockbridge,OH',
'43150': 'Rushville,OH',
'43151': 'Sedalia,OH',
'43152': 'South Bloomingville,OH',
'43153': 'South Solon,OH',
'43154': 'Stoutsville,OH',
'43155': 'Sugar Grove,OH',
'43156': 'Tarlton,OH',
'43157': 'Thurston,OH',
'43158': 'Union Furnace,OH',
'43160': 'Washington Court House,OH',
'43162': 'West Jefferson,OH',
'43163': 'West Rushville,OH',
'43164': 'Williamsport,OH',
'43194': 'Lockbourne,OH',
'43195': 'Groveport,OH',
'43196': 'Groveport,OH',
'43198': 'Groveport,OH',
'43199': 'Groveport,OH',
'43201': 'Columbus,OH',
'43202': 'Columbus,OH',
'43203': 'Columbus,OH',
'43204': 'Columbus,OH',
'43205': 'Columbus,OH',
'43206': 'Columbus,OH',
'43207': 'Columbus,OH',
'43209': 'Columbus,OH',
'43210': 'Columbus,OH',
'43211': 'Columbus,OH',
'43212': 'Columbus,OH',
'43213': 'Columbus,OH',
'43214': 'Columbus,OH',
'43215': 'Columbus,OH',
'43216': 'Columbus,OH',
'43217': 'Columbus,OH',
'43218': 'Columbus,OH',
'43219': 'Columbus,OH',
'43220': 'Columbus,OH',
'43221': 'Columbus,OH',
'43222': 'Columbus,OH',
'43223': 'Columbus,OH',
'43224': 'Columbus,OH',
'43226': 'Columbus,OH',
'43227': 'Columbus,OH',
'43228': 'Columbus,OH',
'43229': 'Columbus,OH',
'43230': 'Columbus,OH',
'43231': 'Columbus,OH',
'43232': 'Columbus,OH',
'43234': 'Columbus,OH',
'43235': 'Columbus,OH',
'43236': 'Columbus,OH',
'43240': 'Columbus,OH',
'43251': 'Columbus,OH',
'43260': 'Columbus,OH',
'43265': 'Columbus,OH',
'43266': 'Columbus,OH',
'43268': 'Columbus,OH',
'43270': 'Columbus,OH',
'43271': 'Columbus,OH',
'43272': 'Columbus,OH',
'43279': 'Columbus,OH',
'43287': 'Columbus,OH',
'43291': 'Columbus,OH',
'43299': 'Columbus,OH',
'43301': 'Marion,OH',
'43302': 'Marion,OH',
'43306': 'Marion,OH',
'43307': 'Marion,OH',
'43310': 'Belle Center,OH',
'43311': 'Bellefontaine,OH',
'43314': 'Caledonia,OH',
'43315': 'Cardington,OH',
'43316': 'Carey,OH',
'43317': 'Chesterville,OH',
'43318': 'De Graff,OH',
'43319': 'East Liberty,OH',
'43320': 'Edison,OH',
'43321': 'Fulton,OH',
'43322': 'Green Camp,OH',
'43323': 'Harpster,OH',
'43324': 'Huntsville,OH',
'43325': 'Iberia,OH',
'43326': 'Kenton,OH',
'43330': 'Kirby,OH',
'43331': 'Lakeview,OH',
'43332': 'La Rue,OH',
'43333': 'Lewistown,OH',
'43334': 'Marengo,OH',
'43335': 'Martel,OH',
'43336': 'Middleburg,OH',
'43337': 'Morral,OH',
'43338': 'Mount Gilead,OH',
'43340': 'Mount Victory,OH',
'43341': 'New Bloomington,OH',
'43342': 'Prospect,OH',
'43343': 'Quincy,OH',
'43344': 'Richwood,OH',
'43345': 'Ridgeway,OH',
'43346': 'Roundhead,OH',
'43347': 'Rushsylvania,OH',
'43348': 'Russells Point,OH',
'43349': 'Shauck,OH',
'43350': 'Sparta,OH',
'43351': 'Upper Sandusky,OH',
'43356': 'Waldo,OH',
'43357': 'West Liberty,OH',
'43358': 'West Mansfield,OH',
'43359': 'Wharton,OH',
'43360': 'Zanesfield,OH',
'43402': 'Bowling Green,OH',
'43403': 'Bowling Green,OH',
'43406': 'Bradner,OH',
'43407': 'Burgoon,OH',
'43408': 'Clay Center,OH',
'43410': 'Clyde,OH',
'43412': 'Curtice,OH',
'43413': 'Cygnet,OH',
'43414': 'Dunbridge,OH',
'43416': 'Elmore,OH',
'43420': 'Fremont,OH',
'43430': 'Genoa,OH',
'43431': 'Gibsonburg,OH',
'43432': 'Graytown,OH',
'43433': 'Gypsum,OH',
'43434': 'Harbor View,OH',
'43435': 'Helena,OH',
'43436': 'Isle Saint George,OH',
'43437': 'Jerry City,OH',
'43438': 'Kelleys Island,OH',
'43439': 'Lacarne,OH',
'43440': 'Lakeside Marblehead,OH',
'43441': 'Lemoyne,OH',
'43442': 'Lindsey,OH',
'43443': 'Luckey,OH',
'43445': 'Martin,OH',
'43446': 'Middle Bass,OH',
'43447': 'Millbury,OH',
'43449': 'Oak Harbor,OH',
'43450': 'Pemberville,OH',
'43451': 'Portage,OH',
'43452': 'Port Clinton,OH',
'43456': 'Put In Bay,OH',
'43457': 'Risingsun,OH',
'43458': 'Rocky Ridge,OH',
'43460': 'Rossford,OH',
'43462': 'Rudolph,OH',
'43463': 'Stony Ridge,OH',
'43464': 'Vickery,OH',
'43465': 'Walbridge,OH',
'43466': 'Wayne,OH',
'43467': 'West Millgrove,OH',
'43468': 'Williston,OH',
'43469': 'Woodville,OH',
'43501': 'Alvordton,OH',
'43502': 'Archbold,OH',
'43504': 'Berkey,OH',
'43505': 'Blakeslee,OH',
'43506': 'Bryan,OH',
'43510': 'Colton,OH',
'43511': 'Custar,OH',
'43512': 'Defiance,OH',
'43515': 'Delta,OH',
'43516': 'Deshler,OH',
'43517': 'Edgerton,OH',
'43518': 'Edon,OH',
'43519': 'Evansport,OH',
'43520': 'Farmer,OH',
'43521': 'Fayette,OH',
'43522': 'Grand Rapids,OH',
'43523': 'Grelton,OH',
'43524': 'Hamler,OH',
'43525': 'Haskins,OH',
'43526': 'Hicksville,OH',
'43527': 'Holgate,OH',
'43528': 'Holland,OH',
'43529': 'Hoytville,OH',
'43530': 'Jewell,OH',
'43531': 'Kunkle,OH',
'43532': 'Liberty Center,OH',
'43533': 'Lyons,OH',
'43534': 'Mc Clure,OH',
'43535': 'Malinta,OH',
'43536': 'Mark Center,OH',
'43537': 'Maumee,OH',
'43540': 'Metamora,OH',
'43541': 'Milton Center,OH',
'43542': 'Monclova,OH',
'43543': 'Montpelier,OH',
'43545': 'Napoleon,OH',
'43547': 'Neapolis,OH',
'43548': 'New Bavaria,OH',
'43549': 'Ney,OH',
'43550': 'Okolona,OH',
'43551': 'Perrysburg,OH',
'43552': 'Perrysburg,OH',
'43553': 'Pettisville,OH',
'43554': 'Pioneer,OH',
'43555': 'Ridgeville Corners,OH',
'43556': 'Sherwood,OH',
'43557': 'Stryker,OH',
'43558': 'Swanton,OH',
'43560': 'Sylvania,OH',
'43565': 'Tontogany,OH',
'43566': 'Waterville,OH',
'43567': 'Wauseon,OH',
'43569': 'Weston,OH',
'43570': 'West Unity,OH',
'43571': 'Whitehouse,OH',
'43601': 'Toledo,OH',
'43602': 'Toledo,OH',
'43603': 'Toledo,OH',
'43604': 'Toledo,OH',
'43605': 'Toledo,OH',
'43606': 'Toledo,OH',
'43607': 'Toledo,OH',
'43608': 'Toledo,OH',
'43609': 'Toledo,OH',
'43610': 'Toledo,OH',
'43611': 'Toledo,OH',
'43612': 'Toledo,OH',
'43613': 'Toledo,OH',
'43614': 'Toledo,OH',
'43615': 'Toledo,OH',
'43616': 'Oregon,OH',
'43617': 'Toledo,OH',
'43618': 'Oregon,OH',
'43619': 'Northwood,OH',
'43620': 'Toledo,OH',
'43623': 'Toledo,OH',
'43624': 'Toledo,OH',
'43635': 'Toledo,OH',
'43652': 'Toledo,OH',
'43653': 'Toledo,OH',
'43654': 'Toledo,OH',
'43655': 'Toledo,OH',
'43656': 'Toledo,OH',
'43657': 'Toledo,OH',
'43659': 'Toledo,OH',
'43660': 'Toledo,OH',
'43661': 'Toledo,OH',
'43666': 'Toledo,OH',
'43667': 'Toledo,OH',
'43681': 'Toledo,OH',
'43682': 'Toledo,OH',
'43697': 'Toledo,OH',
'43699': 'Toledo,OH',
'43701': 'Zanesville,OH',
'43702': 'Zanesville,OH',
'43711': 'Ava,OH',
'43713': 'Barnesville,OH',
'43716': 'Beallsville,OH',
'43717': 'Belle Valley,OH',
'43718': 'Belmont,OH',
'43719': 'Bethesda,OH',
'43720': 'Blue Rock,OH',
'43721': 'Brownsville,OH',
'43722': 'Buffalo,OH',
'43723': 'Byesville,OH',
'43724': 'Caldwell,OH',
'43725': 'Cambridge,OH',
'43727': 'Chandlersville,OH',
'43728': 'Chesterhill,OH',
'43730': 'Corning,OH',
'43731': 'Crooksville,OH',
'43732': 'Cumberland,OH',
'43733': 'Derwent,OH',
'43734': 'Duncan Falls,OH',
'43735': 'East Fultonham,OH',
'43736': 'Fairview,OH',
'43738': 'Fultonham,OH',
'43739': 'Glenford,OH',
'43740': 'Gratiot,OH',
'43746': 'Hopewell,OH',
'43747': 'Jerusalem,OH',
'43748': 'Junction City,OH',
'43749': 'Kimbolton,OH',
'43750': 'Kipling,OH',
'43752': 'Laings,OH',
'43754': 'Lewisville,OH',
'43755': 'Lore City,OH',
'43756': 'Mc Connelsville,OH',
'43757': 'Malaga,OH',
'43758': 'Malta,OH',
'43759': 'Morristown,OH',
'43760': 'Mount Perry,OH',
'43761': 'Moxahala,OH',
'43762': 'New Concord,OH',
'43764': 'New Lexington,OH',
'43766': 'New Straitsville,OH',
'43767': 'Norwich,OH',
'43768': 'Old Washington,OH',
'43771': 'Philo,OH',
'43772': 'Pleasant City,OH',
'43773': 'Quaker City,OH',
'43777': 'Roseville,OH',
'43778': 'Salesville,OH',
'43779': 'Sarahsville,OH',
'43780': 'Senecaville,OH',
'43782': 'Shawnee,OH',
'43783': 'Somerset,OH',
'43786': 'Stafford,OH',
'43787': 'Stockport,OH',
'43788': 'Summerfield,OH',
'43789': 'Sycamore Valley,OH',
'43791': 'White Cottage,OH',
'43793': 'Woodsfield,OH',
'43802': 'Adamsville,OH',
'43803': 'Bakersville,OH',
'43804': 'Baltic,OH',
'43805': 'Blissfield,OH',
'43811': 'Conesville,OH',
'43812': 'Coshocton,OH',
'43821': 'Dresden,OH',
'43822': 'Frazeysburg,OH',
'43824': 'Fresno,OH',
'43828': 'Keene,OH',
'43830': 'Nashport,OH',
'43832': 'Newcomerstown,OH',
'43836': 'Plainfield,OH',
'43837': 'Port Washington,OH',
'43840': 'Stone Creek,OH',
'43842': 'Trinway,OH',
'43843': 'Walhonding,OH',
'43844': 'Warsaw,OH',
'43845': 'West Lafayette,OH',
'43901': 'Adena,OH',
'43902': 'Alledonia,OH',
'43903': 'Amsterdam,OH',
'43905': 'Barton,OH',
'43906': 'Bellaire,OH',
'43907': 'Cadiz,OH',
'43908': 'Bergholz,OH',
'43909': 'Blaine,OH',
'43910': 'Bloomingdale,OH',
'43912': 'Bridgeport,OH',
'43913': 'Brilliant,OH',
'43914': 'Cameron,OH',
'43915': 'Clarington,OH',
'43916': 'Colerain,OH',
'43917': 'Dillonvale,OH',
'43920': 'East Liverpool,OH',
'43925': 'East Springfield,OH',
'43926': 'Empire,OH',
'43927': 'Fairpoint,OH',
'43928': 'Glencoe,OH',
'43930': 'Hammondsville,OH',
'43931': 'Hannibal,OH',
'43932': 'Irondale,OH',
'43933': 'Jacobsburg,OH',
'43934': 'Lansing,OH',
'43935': 'Martins Ferry,OH',
'43937': 'Maynard,OH',
'43938': 'Mingo Junction,OH',
'43939': 'Mount Pleasant,OH',
'43940': 'Neffs,OH',
'43941': 'Piney Fork,OH',
'43942': 'Powhatan Point,OH',
'43943': 'Rayland,OH',
'43944': 'Richmond,OH',
'43945': 'Salineville,OH',
'43946': 'Sardis,OH',
'43947': 'Shadyside,OH',
'43948': 'Smithfield,OH',
'43950': 'Saint Clairsville,OH',
'43951': 'Lafferty,OH',
'43952': 'Steubenville,OH',
'43953': 'Steubenville,OH',
'43961': 'Stratton,OH',
'43962': 'Summitville,OH',
'43963': 'Tiltonsville,OH',
'43964': 'Toronto,OH',
'43966': 'Unionport,OH',
'43967': 'Warnock,OH',
'43968': 'Wellsville,OH',
'43970': 'Wolf Run,OH',
'43971': 'Yorkville,OH',
'43972': 'Bannock,OH',
'43973': 'Freeport,OH',
'43974': 'Harrisville,OH',
'43976': 'Hopedale,OH',
'43977': 'Flushing,OH',
'43981': 'New Athens,OH',
'43983': 'Piedmont,OH',
'43984': 'New Rumley,OH',
'43985': 'Holloway,OH',
'43986': 'Jewett,OH',
'43988': 'Scio,OH',
'43989': 'Short Creek,OH',
'44001': 'Amherst,OH',
'44003': 'Andover,OH',
'44004': 'Ashtabula,OH',
'44005': 'Ashtabula,OH',
'44010': 'Austinburg,OH',
'44011': 'Avon,OH',
'44012': 'Avon Lake,OH',
'44017': 'Berea,OH',
'44021': 'Burton,OH',
'44022': 'Chagrin Falls,OH',
'44023': 'Chagrin Falls,OH',
'44024': 'Chardon,OH',
'44026': 'Chesterland,OH',
'44028': 'Columbia Station,OH',
'44030': 'Conneaut,OH',
'44032': 'Dorset,OH',
'44033': 'East Claridon,OH',
'44035': 'Elyria,OH',
'44036': 'Elyria,OH',
'44039': 'North Ridgeville,OH',
'44040': 'Gates Mills,OH',
'44041': 'Geneva,OH',
'44044': 'Grafton,OH',
'44045': 'Grand River,OH',
'44046': 'Huntsburg,OH',
'44047': 'Jefferson,OH',
'44048': 'Kingsville,OH',
'44049': 'Kipton,OH',
'44050': 'Lagrange,OH',
'44052': 'Lorain,OH',
'44053': 'Lorain,OH',
'44054': 'Sheffield Lake,OH',
'44055': 'Lorain,OH',
'44056': 'Macedonia,OH',
'44057': 'Madison,OH',
'44060': 'Mentor,OH',
'44061': 'Mentor,OH',
'44062': 'Middlefield,OH',
'44064': 'Montville,OH',
'44065': 'Newbury,OH',
'44067': 'Northfield,OH',
'44068': 'North Kingsville,OH',
'44070': 'North Olmsted,OH',
'44072': 'Novelty,OH',
'44073': 'Novelty,OH',
'44074': 'Oberlin,OH',
'44076': 'Orwell,OH',
'44077': 'Painesville,OH',
'44080': 'Parkman,OH',
'44081': 'Perry,OH',
'44082': 'Pierpont,OH',
'44084': 'Rock Creek,OH',
'44085': 'Rome,OH',
'44086': 'Thompson,OH',
'44087': 'Twinsburg,OH',
'44088': 'Unionville,OH',
'44089': 'Vermilion,OH',
'44090': 'Wellington,OH',
'44092': 'Wickliffe,OH',
'44093': 'Williamsfield,OH',
'44094': 'Willoughby,OH',
'44095': 'Eastlake,OH',
'44096': 'Willoughby,OH',
'44097': 'Eastlake,OH',
'44099': 'Windsor,OH',
'44101': 'Cleveland,OH',
'44102': 'Cleveland,OH',
'44103': 'Cleveland,OH',
'44104': 'Cleveland,OH',
'44105': 'Cleveland,OH',
'44106': 'Cleveland,OH',
'44107': 'Lakewood,OH',
'44108': 'Cleveland,OH',
'44109': 'Cleveland,OH',
'44110': 'Cleveland,OH',
'44111': 'Cleveland,OH',
'44112': 'Cleveland,OH',
'44113': 'Cleveland,OH',
'44114': 'Cleveland,OH',
'44115': 'Cleveland,OH',
'44116': 'Rocky River,OH',
'44117': 'Euclid,OH',
'44118': 'Cleveland,OH',
'44119': 'Cleveland,OH',
'44120': 'Cleveland,OH',
'44121': 'Cleveland,OH',
'44122': 'Beachwood,OH',
'44123': 'Euclid,OH',
'44124': 'Cleveland,OH',
'44125': 'Cleveland,OH',
'44126': 'Cleveland,OH',
'44127': 'Cleveland,OH',
'44128': 'Cleveland,OH',
'44129': 'Cleveland,OH',
'44130': 'Cleveland,OH',
'44131': 'Independence,OH',
'44132': 'Euclid,OH',
'44133': 'North Royalton,OH',
'44134': 'Cleveland,OH',
'44135': 'Cleveland,OH',
'44136': 'Strongsville,OH',
'44137': 'Maple Heights,OH',
'44138': 'Olmsted Falls,OH',
'44139': 'Solon,OH',
'44140': 'Bay Village,OH',
'44141': 'Brecksville,OH',
'44142': 'Brookpark,OH',
'44143': 'Cleveland,OH',
'44144': 'Cleveland,OH',
'44145': 'Westlake,OH',
'44146': 'Bedford,OH',
'44147': 'Broadview Heights,OH',
'44149': 'Strongsville,OH',
'44177': 'Cleveland,OH',
'44178': 'Cleveland,OH',
'44179': 'Cleveland,OH',
'44181': 'Cleveland,OH',
'44184': 'Cleveland,OH',
'44185': 'Cleveland,OH',
'44186': 'Cleveland,OH',
'44188': 'Cleveland,OH',
'44189': 'Cleveland,OH',
'44190': 'Cleveland,OH',
'44191': 'Cleveland,OH',
'44192': 'Cleveland,OH',
'44193': 'Cleveland,OH',
'44194': 'Cleveland,OH',
'44195': 'Cleveland,OH',
'44197': 'Cleveland,OH',
'44198': 'Cleveland,OH',
'44199': 'Cleveland,OH',
'44201': 'Atwater,OH',
'44202': 'Aurora,OH',
'44203': 'Barberton,OH',
'44210': 'Bath,OH',
'44211': 'Brady Lake,OH',
'44212': 'Brunswick,OH',
'44214': 'Burbank,OH',
'44215': 'Chippewa Lake,OH',
'44216': 'Clinton,OH',
'44217': 'Creston,OH',
'44221': 'Cuyahoga Falls,OH',
'44222': 'Cuyahoga Falls,OH',
'44223': 'Cuyahoga Falls,OH',
'44224': 'Stow,OH',
'44230': 'Doylestown,OH',
'44231': 'Garrettsville,OH',
'44232': 'Green,OH',
'44233': 'Hinckley,OH',
'44234': 'Hiram,OH',
'44235': 'Homerville,OH',
'44236': 'Hudson,OH',
'44237': 'Hudson,OH',
'44238': 'Hudson,OH',
'44240': 'Kent,OH',
'44241': 'Streetsboro,OH',
'44242': 'Kent,OH',
'44243': 'Kent,OH',
'44250': 'Lakemore,OH',
'44251': 'Westfield Center,OH',
'44253': 'Litchfield,OH',
'44254': 'Lodi,OH',
'44255': 'Mantua,OH',
'44256': 'Medina,OH',
'44258': 'Medina,OH',
'44260': 'Mogadore,OH',
'44262': 'Munroe Falls,OH',
'44264': 'Peninsula,OH',
'44265': 'Randolph,OH',
'44266': 'Ravenna,OH',
'44270': 'Rittman,OH',
'44272': 'Rootstown,OH',
'44273': 'Seville,OH',
'44274': 'Sharon Center,OH',
'44275': 'Spencer,OH',
'44276': 'Sterling,OH',
'44278': 'Tallmadge,OH',
'44280': 'Valley City,OH',
'44281': 'Wadsworth,OH',
'44282': 'Wadsworth,OH',
'44285': 'Wayland,OH',
'44286': 'Richfield,OH',
'44287': 'West Salem,OH',
'44288': 'Windham,OH',
'44301': 'Akron,OH',
'44302': 'Akron,OH',
'44303': 'Akron,OH',
'44304': 'Akron,OH',
'44305': 'Akron,OH',
'44306': 'Akron,OH',
'44307': 'Akron,OH',
'44308': 'Akron,OH',
'44309': 'Akron,OH',
'44310': 'Akron,OH',
'44311': 'Akron,OH',
'44312': 'Akron,OH',
'44313': 'Akron,OH',
'44314': 'Akron,OH',
'44315': 'Akron,OH',
'44316': 'Akron,OH',
'44317': 'Akron,OH',
'44319': 'Akron,OH',
'44320': 'Akron,OH',
'44321': 'Akron,OH',
'44322': 'Akron,OH',
'44325': 'Akron,OH',
'44326': 'Akron,OH',
'44328': 'Akron,OH',
'44333': 'Akron,OH',
'44334': 'Fairlawn,OH',
'44372': 'Akron,OH',
'44393': 'Akron,OH',
'44396': 'Akron,OH',
'44397': 'Akron,OH',
'44398': 'Akron,OH',
'44399': 'Akron,OH',
'44401': 'Berlin Center,OH',
'44402': 'Bristolville,OH',
'44403': 'Brookfield,OH',
'44404': 'Burghill,OH',
'44405': 'Campbell,OH',
'44406': 'Canfield,OH',
'44408': 'Columbiana,OH',
'44410': 'Cortland,OH',
'44411': 'Deerfield,OH',
'44412': 'Diamond,OH',
'44413': 'East Palestine,OH',
'44415': 'Elkton,OH',
'44416': 'Ellsworth,OH',
'44417': 'Farmdale,OH',
'44418': 'Fowler,OH',
'44420': 'Girard,OH',
'44422': 'Greenford,OH',
'44423': 'Hanoverton,OH',
'44424': 'Hartford,OH',
'44425': 'Hubbard,OH',
'44427': 'Kensington,OH',
'44428': 'Kinsman,OH',
'44429': 'Lake Milton,OH',
'44430': 'Leavittsburg,OH',
'44431': 'Leetonia,OH',
'44432': 'Lisbon,OH',
'44436': 'Lowellville,OH',
'44437': 'Mc Donald,OH',
'44438': 'Masury,OH',
'44439': 'Mesopotamia,OH',
'44440': 'Mineral Ridge,OH',
'44441': 'Negley,OH',
'44442': 'New Middletown,OH',
'44443': 'New Springfield,OH',
'44444': 'Newton Falls,OH',
'44445': 'New Waterford,OH',
'44446': 'Niles,OH',
'44449': 'North Benton,OH',
'44450': 'North Bloomfield,OH',
'44451': 'North Jackson,OH',
'44452': 'North Lima,OH',
'44453': 'Orangeville,OH',
'44454': 'Petersburg,OH',
'44455': 'Rogers,OH',
'44460': 'Salem,OH',
'44470': 'Southington,OH',
'44471': 'Struthers,OH',
'44473': 'Vienna,OH',
'44481': 'Warren,OH',
'44482': 'Warren,OH',
'44483': 'Warren,OH',
'44484': 'Warren,OH',
'44485': 'Warren,OH',
'44486': 'Warren,OH',
'44487': 'Warren,OH',
'44488': 'Warren,OH',
'44490': 'Washingtonville,OH',
'44491': 'West Farmington,OH',
'44492': 'West Point,OH',
'44493': 'Winona,OH',
'44501': 'Youngstown,OH',
'44502': 'Youngstown,OH',
'44503': 'Youngstown,OH',
'44504': 'Youngstown,OH',
'44505': 'Youngstown,OH',
'44506': 'Youngstown,OH',
'44507': 'Youngstown,OH',
'44509': 'Youngstown,OH',
'44510': 'Youngstown,OH',
'44511': 'Youngstown,OH',
'44512': 'Youngstown,OH',
'44513': 'Youngstown,OH',
'44514': 'Youngstown,OH',
'44515': 'Youngstown,OH',
'44555': 'Youngstown,OH',
'44598': 'Youngstown,OH',
'44599': 'Youngstown,OH',
'44601': 'Alliance,OH',
'44606': 'Apple Creek,OH',
'44607': 'Augusta,OH',
'44608': 'Beach City,OH',
'44609': 'Beloit,OH',
'44610': 'Berlin,OH',
'44611': 'Big Prairie,OH',
'44612': 'Bolivar,OH',
'44613': 'Brewster,OH',
'44614': 'Canal Fulton,OH',
'44615': 'Carrollton,OH',
'44617': 'Charm,OH',
'44618': 'Dalton,OH',
'44619': 'Damascus,OH',
'44620': 'Dellroy,OH',
'44621': 'Dennison,OH',
'44622': 'Dover,OH',
'44624': 'Dundee,OH',
'44625': 'East Rochester,OH',
'44626': 'East Sparta,OH',
'44627': 'Fredericksburg,OH',
'44628': 'Glenmont,OH',
'44629': 'Gnadenhutten,OH',
'44630': 'Greentown,OH',
'44631': 'Harlem Springs,OH',
'44632': 'Hartville,OH',
'44633': 'Holmesville,OH',
'44634': 'Homeworth,OH',
'44636': 'Kidron,OH',
'44637': 'Killbuck,OH',
'44638': 'Lakeville,OH',
'44639': 'Leesville,OH',
'44640': 'Limaville,OH',
'44641': 'Louisville,OH',
'44643': 'Magnolia,OH',
'44644': 'Malvern,OH',
'44645': 'Marshallville,OH',
'44646': 'Massillon,OH',
'44647': 'Massillon,OH',
'44648': 'Massillon,OH',
'44650': 'Maximo,OH',
'44651': 'Mechanicstown,OH',
'44652': 'Middlebranch,OH',
'44653': 'Midvale,OH',
'44654': 'Millersburg,OH',
'44656': 'Mineral City,OH',
'44657': 'Minerva,OH',
'44659': 'Mount Eaton,OH',
'44660': 'Mount Hope,OH',
'44661': 'Nashville,OH',
'44662': 'Navarre,OH',
'44663': 'New Philadelphia,OH',
'44665': 'North Georgetown,OH',
'44666': 'North Lawrence,OH',
'44667': 'Orrville,OH',
'44669': 'Paris,OH',
'44670': 'Robertsville,OH',
'44671': 'Sandyville,OH',
'44672': 'Sebring,OH',
'44675': 'Sherrodsville,OH',
'44676': 'Shreve,OH',
'44677': 'Smithville,OH',
'44678': 'Somerdale,OH',
'44679': 'Stillwater,OH',
'44680': 'Strasburg,OH',
'44681': 'Sugarcreek,OH',
'44682': 'Tuscarawas,OH',
'44683': 'Uhrichsville,OH',
'44685': 'Uniontown,OH',
'44687': 'Walnut Creek,OH',
'44688': 'Waynesburg,OH',
'44689': 'Wilmot,OH',
'44690': 'Winesburg,OH',
'44691': 'Wooster,OH',
'44693': 'Deersville,OH',
'44695': 'Bowerston,OH',
'44697': 'Zoar,OH',
'44699': 'Tippecanoe,OH',
'44701': 'Canton,OH',
'44702': 'Canton,OH',
'44703': 'Canton,OH',
'44704': 'Canton,OH',
'44705': 'Canton,OH',
'44706': 'Canton,OH',
'44707': 'Canton,OH',
'44708': 'Canton,OH',
'44709': 'Canton,OH',
'44710': 'Canton,OH',
'44711': 'Canton,OH',
'44712': 'Canton,OH',
'44714': 'Canton,OH',
'44718': 'Canton,OH',
'44720': 'Canton,OH',
'44721': 'Canton,OH',
'44730': 'Canton,OH',
'44735': 'Canton,OH',
'44750': 'Canton,OH',
'44760': 'Canton,OH',
'44767': 'Canton,OH',
'44798': 'Canton,OH',
'44799': 'Canton,OH',
'44801': 'Adrian,OH',
'44802': 'Alvada,OH',
'44803': 'Amsden,OH',
'44804': 'Arcadia,OH',
'44805': 'Ashland,OH',
'44807': 'Attica,OH',
'44809': 'Bascom,OH',
'44811': 'Bellevue,OH',
'44813': 'Bellville,OH',
'44814': 'Berlin Heights,OH',
'44815': 'Bettsville,OH',
'44816': 'Birmingham,OH',
'44817': 'Bloomdale,OH',
'44818': 'Bloomville,OH',
'44820': 'Bucyrus,OH',
'44822': 'Butler,OH',
'44824': 'Castalia,OH',
'44825': 'Chatfield,OH',
'44826': 'Collins,OH',
'44827': 'Crestline,OH',
'44828': 'Flat Rock,OH',
'44830': 'Fostoria,OH',
'44833': 'Galion,OH',
'44836': 'Green Springs,OH',
'44837': 'Greenwich,OH',
'44838': 'Hayesville,OH',
'44839': 'Huron,OH',
'44840': 'Jeromesville,OH',
'44841': 'Kansas,OH',
'44842': 'Loudonville,OH',
'44843': 'Lucas,OH',
'44844': 'Mc Cutchenville,OH',
'44845': 'Melmore,OH',
'44846': 'Milan,OH',
'44847': 'Monroeville,OH',
'44848': 'Nankin,OH',
'44849': 'Nevada,OH',
'44850': 'New Haven,OH',
'44851': 'New London,OH',
'44853': 'New Riegel,OH',
'44854': 'New Washington,OH',
'44855': 'North Fairfield,OH',
'44856': 'North Robinson,OH',
'44857': 'Norwalk,OH',
'44859': 'Nova,OH',
'44860': 'Oceola,OH',
'44861': 'Old Fort,OH',
'44862': 'Ontario,OH',
'44864': 'Perrysville,OH',
'44865': 'Plymouth,OH',
'44866': 'Polk,OH',
'44867': 'Republic,OH',
'44870': 'Sandusky,OH',
'44871': 'Sandusky,OH',
'44874': 'Savannah,OH',
'44875': 'Shelby,OH',
'44878': 'Shiloh,OH',
'44880': 'Sullivan,OH',
'44881': 'Sulphur Springs,OH',
'44882': 'Sycamore,OH',
'44883': 'Tiffin,OH',
'44887': 'Tiro,OH',
'44888': 'Willard,OH',
'44889': 'Wakeman,OH',
'44890': 'Willard,OH',
'44901': 'Mansfield,OH',
'44902': 'Mansfield,OH',
'44903': 'Mansfield,OH',
'44904': 'Mansfield,OH',
'44905': 'Mansfield,OH',
'44906': 'Mansfield,OH',
'44907': 'Mansfield,OH',
'44999': 'Mansfield,OH',
'45001': 'Addyston,OH',
'45002': 'Cleves,OH',
'45003': 'College Corner,OH',
'45004': 'Collinsville,OH',
'45005': 'Franklin,OH',
'45011': 'Hamilton,OH',
'45012': 'Hamilton,OH',
'45013': 'Hamilton,OH',
'45014': 'Fairfield,OH',
'45015': 'Hamilton,OH',
'45018': 'Fairfield,OH',
'45020': 'Hamilton,OH',
'45023': 'Hamilton,OH',
'45025': 'Hamilton,OH',
'45026': 'Hamilton,OH',
'45030': 'Harrison,OH',
'45032': 'Harveysburg,OH',
'45033': 'Hooven,OH',
'45034': 'Kings Mills,OH',
'45036': 'Lebanon,OH',
'45039': 'Maineville,OH',
'45040': 'Mason,OH',
'45041': 'Miamitown,OH',
'45042': 'Middletown,OH',
'45043': 'Middletown,OH',
'45044': 'Middletown,OH',
'45050': 'Monroe,OH',
'45051': 'Mount Saint Joseph,OH',
'45052': 'North Bend,OH',
'45053': 'Okeana,OH',
'45054': 'Oregonia,OH',
'45055': 'Overpeck,OH',
'45056': 'Oxford,OH',
'45061': 'Ross,OH',
'45062': 'Seven Mile,OH',
'45063': 'Shandon,OH',
'45064': 'Somerville,OH',
'45065': 'South Lebanon,OH',
'45066': 'Springboro,OH',
'45067': 'Trenton,OH',
'45068': 'Waynesville,OH',
'45069': 'West Chester,OH',
'45070': 'West Elkton,OH',
'45071': 'West Chester,OH',
'45073': 'Monroe,OH',
'45099': 'Monroe,OH',
'45101': 'Aberdeen,OH',
'45102': 'Amelia,OH',
'45103': 'Batavia,OH',
'45105': 'Bentonville,OH',
'45106': 'Bethel,OH',
'45107': 'Blanchester,OH',
'45110': 'Buford,OH',
'45111': 'Camp Dennison,OH',
'45112': 'Chilo,OH',
'45113': 'Clarksville,OH',
'45114': 'Cuba,OH',
'45115': 'Decatur,OH',
'45118': 'Fayetteville,OH',
'45119': 'Feesburg,OH',
'45120': 'Felicity,OH',
'45121': 'Georgetown,OH',
'45122': 'Goshen,OH',
'45123': 'Greenfield,OH',
'45130': 'Hamersville,OH',
'45131': 'Higginsport,OH',
'45132': 'Highland,OH',
'45133': 'Hillsboro,OH',
'45135': 'Leesburg,OH',
'45138': 'Lees Creek,OH',
'45140': 'Loveland,OH',
'45142': 'Lynchburg,OH',
'45144': 'Manchester,OH',
'45145': 'Marathon,OH',
'45146': 'Martinsville,OH',
'45147': 'Miamiville,OH',
'45148': 'Midland,OH',
'45150': 'Milford,OH',
'45152': 'Morrow,OH',
'45153': 'Moscow,OH',
'45154': 'Mount Orab,OH',
'45155': 'Mowrystown,OH',
'45156': 'Neville,OH',
'45157': 'New Richmond,OH',
'45158': 'Newtonsville,OH',
'45159': 'New Vienna,OH',
'45160': 'Owensville,OH',
'45162': 'Pleasant Plain,OH',
'45164': 'Port William,OH',
'45165': 'Greenfield,OH',
'45166': 'Reesville,OH',
'45167': 'Ripley,OH',
'45168': 'Russellville,OH',
'45169': 'Sabina,OH',
'45171': 'Sardinia,OH',
'45172': 'Sinking Spring,OH',
'45174': 'Terrace Park,OH',
'45176': 'Williamsburg,OH',
'45177': 'Wilmington,OH',
'45201': 'Cincinnati,OH',
'45202': 'Cincinnati,OH',
'45203': 'Cincinnati,OH',
'45204': 'Cincinnati,OH',
'45205': 'Cincinnati,OH',
'45206': 'Cincinnati,OH',
'45207': 'Cincinnati,OH',
'45208': 'Cincinnati,OH',
'45209': 'Cincinnati,OH',
'45210': 'Cincinnati,OH',
'45211': 'Cincinnati,OH',
'45212': 'Cincinnati,OH',
'45213': 'Cincinnati,OH',
'45214': 'Cincinnati,OH',
'45215': 'Cincinnati,OH',
'45216': 'Cincinnati,OH',
'45217': 'Cincinnati,OH',
'45218': 'Cincinnati,OH',
'45219': 'Cincinnati,OH',
'45220': 'Cincinnati,OH',
'45221': 'Cincinnati,OH',
'45222': 'Cincinnati,OH',
'45223': 'Cincinnati,OH',
'45224': 'Cincinnati,OH',
'45225': 'Cincinnati,OH',
'45226': 'Cincinnati,OH',
'45227': 'Cincinnati,OH',
'45228': 'Cincinnati,OH',
'45229': 'Cincinnati,OH',
'45230': 'Cincinnati,OH',
'45231': 'Cincinnati,OH',
'45232': 'Cincinnati,OH',
'45233': 'Cincinnati,OH',
'45234': 'Cincinnati,OH',
'45235': 'Cincinnati,OH',
'45236': 'Cincinnati,OH',
'45237': 'Cincinnati,OH',
'45238': 'Cincinnati,OH',
'45239': 'Cincinnati,OH',
'45240': 'Cincinnati,OH',
'45241': 'Cincinnati,OH',
'45242': 'Cincinnati,OH',
'45243': 'Cincinnati,OH',
'45244': 'Cincinnati,OH',
'45245': 'Cincinnati,OH',
'45246': 'Cincinnati,OH',
'45247': 'Cincinnati,OH',
'45248': 'Cincinnati,OH',
'45249': 'Cincinnati,OH',
'45250': 'Cincinnati,OH',
'45251': 'Cincinnati,OH',
'45252': 'Cincinnati,OH',
'45253': 'Cincinnati,OH',
'45254': 'Cincinnati,OH',
'45255': 'Cincinnati,OH',
'45258': 'Cincinnati,OH',
'45262': 'Cincinnati,OH',
'45263': 'Cincinnati,OH',
'45264': 'Cincinnati,OH',
'45267': 'Cincinnati,OH',
'45268': 'Cincinnati,OH',
'45269': 'Cincinnati,OH',
'45270': 'Cincinnati,OH',
'45271': 'Cincinnati,OH',
'45273': 'Cincinnati,OH',
'45274': 'Cincinnati,OH',
'45275': 'Cincinnati,OH',
'45277': 'Cincinnati,OH',
'45280': 'Cincinnati,OH',
'45296': 'Cincinnati,OH',
'45298': 'Cincinnati,OH',
'45299': 'Cincinnati,OH',
'45301': 'Alpha,OH',
'45302': 'Anna,OH',
'45303': 'Ansonia,OH',
'45304': 'Arcanum,OH',
'45305': 'Bellbrook,OH',
'45306': 'Botkins,OH',
'45307': 'Bowersville,OH',
'45308': 'Bradford,OH',
'45309': 'Brookville,OH',
'45310': 'Burkettsville,OH',
'45311': 'Camden,OH',
'45312': 'Casstown,OH',
'45314': 'Cedarville,OH',
'45315': 'Clayton,OH',
'45316': 'Clifton,OH',
'45317': 'Conover,OH',
'45318': 'Covington,OH',
'45319': 'Donnelsville,OH',
'45320': 'Eaton,OH',
'45321': 'Eldorado,OH',
'45322': 'Englewood,OH',
'45323': 'Enon,OH',
'45324': 'Fairborn,OH',
'45325': 'Farmersville,OH',
'45326': 'Fletcher,OH',
'45327': 'Germantown,OH',
'45328': 'Gettysburg,OH',
'45330': 'Gratis,OH',
'45331': 'Greenville,OH',
'45332': 'Hollansburg,OH',
'45333': 'Houston,OH',
'45334': 'Jackson Center,OH',
'45335': 'Jamestown,OH',
'45336': 'Kettlersville,OH',
'45337': 'Laura,OH',
'45338': 'Lewisburg,OH',
'45339': 'Ludlow Falls,OH',
'45340': 'Maplewood,OH',
'45341': 'Medway,OH',
'45342': 'Miamisburg,OH',
'45343': 'Miamisburg,OH',
'45344': 'New Carlisle,OH',
'45345': 'New Lebanon,OH',
'45346': 'New Madison,OH',
'45347': 'New Paris,OH',
'45348': 'New Weston,OH',
'45349': 'North Hampton,OH',
'45350': 'North Star,OH',
'45351': 'Osgood,OH',
'45352': 'Palestine,OH',
'45353': 'Pemberton,OH',
'45354': 'Phillipsburg,OH',
'45356': 'Piqua,OH',
'45358': 'Pitsburg,OH',
'45359': 'Pleasant Hill,OH',
'45360': 'Port Jefferson,OH',
'45361': 'Potsdam,OH',
'45362': 'Rossburg,OH',
'45363': 'Russia,OH',
'45365': 'Sidney,OH',
'45367': 'Sidney,OH',
'45368': 'South Charleston,OH',
'45369': 'South Vienna,OH',
'45370': 'Spring Valley,OH',
'45371': 'Tipp City,OH',
'45372': 'Tremont City,OH',
'45373': 'Troy,OH',
'45374': 'Troy,OH',
'45377': 'Vandalia,OH',
'45378': 'Verona,OH',
'45380': 'Versailles,OH',
'45381': 'West Alexandria,OH',
'45382': 'West Manchester,OH',
'45383': 'West Milton,OH',
'45384': 'Wilberforce,OH',
'45385': 'Xenia,OH',
'45387': 'Yellow Springs,OH',
'45388': 'Yorkshire,OH',
'45389': 'Christiansburg,OH',
'45390': 'Union City,OH',
'45400': 'Dayton,OH',
'45401': 'Dayton,OH',
'45402': 'Dayton,OH',
'45403': 'Dayton,OH',
'45404': 'Dayton,OH',
'45405': 'Dayton,OH',
'45406': 'Dayton,OH',
'45407': 'Dayton,OH',
'45408': 'Dayton,OH',
'45409': 'Dayton,OH',
'45410': 'Dayton,OH',
'45412': 'Dayton,OH',
'45413': 'Dayton,OH',
'45414': 'Dayton,OH',
'45415': 'Dayton,OH',
'45416': 'Dayton,OH',
'45417': 'Dayton,OH',
'45418': 'Dayton,OH',
'45419': 'Dayton,OH',
'45420': 'Dayton,OH',
'45422': 'Dayton,OH',
'45423': 'Dayton,OH',
'45424': 'Dayton,OH',
'45426': 'Dayton,OH',
'45427': 'Dayton,OH',
'45428': 'Dayton,OH',
'45429': 'Dayton,OH',
'45430': 'Dayton,OH',
'45431': 'Dayton,OH',
'45432': 'Dayton,OH',
'45433': 'Dayton,OH',
'45434': 'Dayton,OH',
'45435': 'Dayton,OH',
'45437': 'Dayton,OH',
'45439': 'Dayton,OH',
'45440': 'Dayton,OH',
'45441': 'Dayton,OH',
'45448': 'Dayton,OH',
'45449': 'Dayton,OH',
'45454': 'Dayton,OH',
'45458': 'Dayton,OH',
'45459': 'Dayton,OH',
'45463': 'Dayton,OH',
'45469': 'Dayton,OH',
'45470': 'Dayton,OH',
'45475': 'Dayton,OH',
'45479': 'Dayton,OH',
'45481': 'Dayton,OH',
'45482': 'Dayton,OH',
'45490': 'Dayton,OH',
'45501': 'Springfield,OH',
'45502': 'Springfield,OH',
'45503': 'Springfield,OH',
'45504': 'Springfield,OH',
'45505': 'Springfield,OH',
'45506': 'Springfield,OH',
'45601': 'Chillicothe,OH',
'45612': 'Bainbridge,OH',
'45613': 'Beaver,OH',
'45614': 'Bidwell,OH',
'45616': 'Blue Creek,OH',
'45617': 'Bourneville,OH',
'45618': 'Cherry Fork,OH',
'45619': 'Chesapeake,OH',
'45620': 'Cheshire,OH',
'45621': 'Coalton,OH',
'45622': 'Creola,OH',
'45623': 'Crown City,OH',
'45624': 'Cynthiana,OH',
'45628': 'Frankfort,OH',
'45629': 'Franklin Furnace,OH',
'45630': 'Friendship,OH',
'45631': 'Gallipolis,OH',
'45633': 'Hallsville,OH',
'45634': 'Hamden,OH',
'45636': 'Haverhill,OH',
'45638': 'Ironton,OH',
'45640': 'Jackson,OH',
'45642': 'Jasper,OH',
'45643': 'Kerr,OH',
'45644': 'Kingston,OH',
'45645': 'Kitts Hill,OH',
'45646': 'Latham,OH',
'45647': 'Londonderry,OH',
'45648': 'Lucasville,OH',
'45650': 'Lynx,OH',
'45651': 'Mc Arthur,OH',
'45652': 'Mc Dermott,OH',
'45653': 'Minford,OH',
'45654': 'New Plymouth,OH',
'45656': 'Oak Hill,OH',
'45657': 'Otway,OH',
'45658': 'Patriot,OH',
'45659': 'Pedro,OH',
'45660': 'Peebles,OH',
'45661': 'Piketon,OH',
'45662': 'Portsmouth,OH',
'45663': 'West Portsmouth,OH',
'45669': 'Proctorville,OH',
'45671': 'Rarden,OH',
'45672': 'Ray,OH',
'45673': 'Richmond Dale,OH',
'45674': 'Rio Grande,OH',
'45675': 'Rock Camp,OH',
'45677': 'Scioto Furnace,OH',
'45678': 'Scottown,OH',
'45679': 'Seaman,OH',
'45680': 'South Point,OH',
'45681': 'South Salem,OH',
'45682': 'South Webster,OH',
'45683': 'Stockdale,OH',
'45684': 'Stout,OH',
'45685': 'Thurman,OH',
'45686': 'Vinton,OH',
'45687': 'Wakefield,OH',
'45688': 'Waterloo,OH',
'45690': 'Waverly,OH',
'45692': 'Wellston,OH',
'45693': 'West Union,OH',
'45694': 'Wheelersburg,OH',
'45695': 'Wilkesville,OH',
'45696': 'Willow Wood,OH',
'45697': 'Winchester,OH',
'45698': 'Zaleski,OH',
'45699': 'Lucasville,OH',
'45701': 'Athens,OH',
'45710': 'Albany,OH',
'45711': 'Amesville,OH',
'45712': 'Barlow,OH',
'45713': 'Bartlett,OH',
'45714': 'Belpre,OH',
'45715': 'Beverly,OH',
'45716': 'Buchtel,OH',
'45717': 'Carbondale,OH',
'45719': 'Chauncey,OH',
'45720': 'Chester,OH',
'45721': 'Coal Run,OH',
'45723': 'Coolville,OH',
'45724': 'Cutler,OH',
'45727': 'Dexter City,OH',
'45729': 'Fleming,OH',
'45732': 'Glouster,OH',
'45734': 'Graysville,OH',
'45735': 'Guysville,OH',
'45739': 'Hockingport,OH',
'45740': 'Jacksonville,OH',
'45741': 'Langsville,OH',
'45742': 'Little Hocking,OH',
'45743': 'Long Bottom,OH',
'45744': 'Lowell,OH',
'45745': 'Lower Salem,OH',
'45746': 'Macksburg,OH',
'45750': 'Marietta,OH',
'45760': 'Middleport,OH',
'45761': 'Millfield,OH',
'45764': 'Nelsonville,OH',
'45766': 'New Marshfield,OH',
'45767': 'New Matamoras,OH',
'45768': 'Newport,OH',
'45769': 'Pomeroy,OH',
'45770': 'Portland,OH',
'45771': 'Racine,OH',
'45772': 'Reedsville,OH',
'45773': 'Reno,OH',
'45775': 'Rutland,OH',
'45776': 'Shade,OH',
'45777': 'Sharpsburg,OH',
'45778': 'Stewart,OH',
'45779': 'Syracuse,OH',
'45780': 'The Plains,OH',
'45781': 'Torch,OH',
'45782': 'Trimble,OH',
'45783': 'Tuppers Plains,OH',
'45784': 'Vincent,OH',
'45786': 'Waterford,OH',
'45787': 'Watertown,OH',
'45788': 'Whipple,OH',
'45789': 'Wingett Run,OH',
'45801': 'Lima,OH',
'45802': 'Lima,OH',
'45804': 'Lima,OH',
'45805': 'Lima,OH',
'45806': 'Lima,OH',
'45807': 'Lima,OH',
'45808': 'Beaverdam,OH',
'45809': 'Gomer,OH',
'45810': 'Ada,OH',
'45812': 'Alger,OH',
'45813': 'Antwerp,OH',
'45814': 'Arlington,OH',
'45815': 'Belmore,OH',
'45816': 'Benton Ridge,OH',
'45817': 'Bluffton,OH',
'45819': 'Buckland,OH',
'45820': 'Cairo,OH',
'45821': 'Cecil,OH',
'45822': 'Celina,OH',
'45826': 'Chickasaw,OH',
'45827': 'Cloverdale,OH',
'45828': 'Coldwater,OH',
'45830': 'Columbus Grove,OH',
'45831': 'Continental,OH',
'45832': 'Convoy,OH',
'45833': 'Delphos,OH',
'45835': 'Dola,OH',
'45836': 'Dunkirk,OH',
'45837': 'Dupont,OH',
'45838': 'Elgin,OH',
'45839': 'Findlay,OH',
'45840': 'Findlay,OH',
'45841': 'Jenera,OH',
'45843': 'Forest,OH',
'45844': 'Fort Jennings,OH',
'45845': 'Fort Loramie,OH',
'45846': 'Fort Recovery,OH',
'45848': 'Glandorf,OH',
'45849': 'Grover Hill,OH',
'45850': 'Harrod,OH',
'45851': 'Haviland,OH',
'45853': 'Kalida,OH',
'45854': 'Lafayette,OH',
'45855': 'Latty,OH',
'45856': 'Leipsic,OH',
'45858': 'Mc Comb,OH',
'45859': 'Mc Guffey,OH',
'45860': 'Maria Stein,OH',
'45861': 'Melrose,OH',
'45862': 'Mendon,OH',
'45863': 'Middle Point,OH',
'45864': 'Miller City,OH',
'45865': 'Minster,OH',
'45866': 'Montezuma,OH',
'45867': 'Mount Blanchard,OH',
'45868': 'Mount Cory,OH',
'45869': 'New Bremen,OH',
'45870': 'New Hampshire,OH',
'45871': 'New Knoxville,OH',
'45872': 'North Baltimore,OH',
'45873': 'Oakwood,OH',
'45874': 'Ohio City,OH',
'45875': 'Ottawa,OH',
'45876': 'Ottoville,OH',
'45877': 'Pandora,OH',
'45879': 'Paulding,OH',
'45880': 'Payne,OH',
'45881': 'Rawson,OH',
'45882': 'Rockford,OH',
'45883': 'Saint Henry,OH',
'45884': 'Saint Johns,OH',
'45885': 'Saint Marys,OH',
'45886': 'Scott,OH',
'45887': 'Spencerville,OH',
'45888': 'Uniopolis,OH',
'45889': 'Van Buren,OH',
'45890': 'Vanlue,OH',
'45891': 'Van Wert,OH',
'45893': 'Vaughnsville,OH',
'45894': 'Venedocia,OH',
'45895': 'Wapakoneta,OH',
'45896': 'Waynesfield,OH',
'45897': 'Williamstown,OH',
'45898': 'Willshire,OH',
'45899': 'Wren,OH',
'45944': 'Cincinnati,OH',
'45999': 'Cincinnati,OH',
'46001': 'Alexandria,IN',
'46011': 'Anderson,IN',
'46012': 'Anderson,IN',
'46013': 'Anderson,IN',
'46014': 'Anderson,IN',
'46015': 'Anderson,IN',
'46016': 'Anderson,IN',
'46017': 'Anderson,IN',
'46018': 'Anderson,IN',
'46030': 'Arcadia,IN',
'46031': 'Atlanta,IN',
'46032': 'Carmel,IN',
'46033': 'Carmel,IN',
'46034': 'Cicero,IN',
'46035': 'Colfax,IN',
'46036': 'Elwood,IN',
'46037': 'Fishers,IN',
'46038': 'Fishers,IN',
'46039': 'Forest,IN',
'46040': 'Fortville,IN',
'46041': 'Frankfort,IN',
'46044': 'Frankton,IN',
'46045': 'Goldsmith,IN',
'46046': 'Hillisburg,IN',
'46047': 'Hobbs,IN',
'46048': 'Ingalls,IN',
'46049': 'Kempton,IN',
'46050': 'Kirklin,IN',
'46051': 'Lapel,IN',
'46052': 'Lebanon,IN',
'46055': 'Mc Cordsville,IN',
'46056': 'Markleville,IN',
'46057': 'Michigantown,IN',
'46058': 'Mulberry,IN',
'46060': 'Noblesville,IN',
'46061': 'Noblesville,IN',
'46062': 'Noblesville,IN',
'46063': 'Orestes,IN',
'46064': 'Pendleton,IN',
'46065': 'Rossville,IN',
'46067': 'Sedalia,IN',
'46068': 'Sharpsville,IN',
'46069': 'Sheridan,IN',
'46070': 'Summitville,IN',
'46071': 'Thorntown,IN',
'46072': 'Tipton,IN',
'46074': 'Westfield,IN',
'46075': 'Whitestown,IN',
'46076': 'Windfall,IN',
'46077': 'Zionsville,IN',
'46082': 'Carmel,IN',
'46102': 'Advance,IN',
'46103': 'Amo,IN',
'46104': 'Arlington,IN',
'46105': 'Bainbridge,IN',
'46106': 'Bargersville,IN',
'46107': 'Beech Grove,IN',
'46110': 'Boggstown,IN',
'46111': 'Brooklyn,IN',
'46112': 'Brownsburg,IN',
'46113': 'Camby,IN',
'46114': 'Cartersburg,IN',
'46115': 'Carthage,IN',
'46117': 'Charlottesville,IN',
'46118': 'Clayton,IN',
'46120': 'Cloverdale,IN',
'46121': 'Coatesville,IN',
'46122': 'Danville,IN',
'46123': 'Avon,IN',
'46124': 'Edinburgh,IN',
'46125': 'Eminence,IN',
'46126': 'Fairland,IN',
'46127': 'Falmouth,IN',
'46128': 'Fillmore,IN',
'46129': 'Finly,IN',
'46130': 'Fountaintown,IN',
'46131': 'Franklin,IN',
'46133': 'Glenwood,IN',
'46135': 'Greencastle,IN',
'46140': 'Greenfield,IN',
'46142': 'Greenwood,IN',
'46143': 'Greenwood,IN',
'46144': 'Gwynneville,IN',
'46146': 'Homer,IN',
'46147': 'Jamestown,IN',
'46148': 'Knightstown,IN',
'46149': 'Lizton,IN',
'46150': 'Manilla,IN',
'46151': 'Martinsville,IN',
'46154': 'Maxwell,IN',
'46155': 'Mays,IN',
'46156': 'Milroy,IN',
'46157': 'Monrovia,IN',
'46158': 'Mooresville,IN',
'46160': 'Morgantown,IN',
'46161': 'Morristown,IN',
'46162': 'Needham,IN',
'46163': 'New Palestine,IN',
'46164': 'Nineveh,IN',
'46165': 'North Salem,IN',
'46166': 'Paragon,IN',
'46167': 'Pittsboro,IN',
'46168': 'Plainfield,IN',
'46170': 'Putnamville,IN',
'46171': 'Reelsville,IN',
'46172': 'Roachdale,IN',
'46173': 'Rushville,IN',
'46175': 'Russellville,IN',
'46176': 'Shelbyville,IN',
'46180': 'Stilesville,IN',
'46181': 'Trafalgar,IN',
'46182': 'Waldron,IN',
'46183': 'West Newton,IN',
'46184': 'Whiteland,IN',
'46186': 'Wilkinson,IN',
'46201': 'Indianapolis,IN',
'46202': 'Indianapolis,IN',
'46203': 'Indianapolis,IN',
'46204': 'Indianapolis,IN',
'46205': 'Indianapolis,IN',
'46206': 'Indianapolis,IN',
'46207': 'Indianapolis,IN',
'46208': 'Indianapolis,IN',
'46209': 'Indianapolis,IN',
'46211': 'Indianapolis,IN',
'46214': 'Indianapolis,IN',
'46216': 'Indianapolis,IN',
'46217': 'Indianapolis,IN',
'46218': 'Indianapolis,IN',
'46219': 'Indianapolis,IN',
'46220': 'Indianapolis,IN',
'46221': 'Indianapolis,IN',
'46222': 'Indianapolis,IN',
'46223': 'Indianapolis,IN',
'46224': 'Indianapolis,IN',
'46225': 'Indianapolis,IN',
'46226': 'Indianapolis,IN',
'46227': 'Indianapolis,IN',
'46228': 'Indianapolis,IN',
'46229': 'Indianapolis,IN',
'46230': 'Indianapolis,IN',
'46231': 'Indianapolis,IN',
'46234': 'Indianapolis,IN',
'46235': 'Indianapolis,IN',
'46236': 'Indianapolis,IN',
'46237': 'Indianapolis,IN',
'46239': 'Indianapolis,IN',
'46240': 'Indianapolis,IN',
'46241': 'Indianapolis,IN',
'46242': 'Indianapolis,IN',
'46244': 'Indianapolis,IN',
'46247': 'Indianapolis,IN',
'46249': 'Indianapolis,IN',
'46250': 'Indianapolis,IN',
'46251': 'Indianapolis,IN',
'46253': 'Indianapolis,IN',
'46254': 'Indianapolis,IN',
'46255': 'Indianapolis,IN',
'46256': 'Indianapolis,IN',
'46259': 'Indianapolis,IN',
'46260': 'Indianapolis,IN',
'46262': 'Union Federal Bank,IN',
'46266': 'Indianapolis,IN',
'46268': 'Indianapolis,IN',
'46274': 'Indianapolis,IN',
'46275': 'Indianapolis,IN',
'46277': 'Indianapolis,IN',
'46278': 'Indianapolis,IN',
'46280': 'Indianapolis,IN',
'46282': 'Indianapolis,IN',
'46283': 'Indianapolis,IN',
'46285': 'Indianapolis,IN',
'46290': 'Indianapolis,IN',
'46291': 'Indianapolis,IN',
'46295': 'Indianapolis,IN',
'46296': 'Indianapolis,IN',
'46298': 'Indianapolis,IN',
'46301': 'Beverly Shores,IN',
'46302': 'Boone Grove,IN',
'46303': 'Cedar Lake,IN',
'46304': 'Chesterton,IN',
'46307': 'Crown Point,IN',
'46308': 'Crown Point,IN',
'46310': 'Demotte,IN',
'46311': 'Dyer,IN',
'46312': 'East Chicago,IN',
'46319': 'Griffith,IN',
'46320': 'Hammond,IN',
'46321': 'Munster,IN',
'46322': 'Highland,IN',
'46323': 'Hammond,IN',
'46324': 'Hammond,IN',
'46325': 'Hammond,IN',
'46327': 'Hammond,IN',
'46340': 'Hanna,IN',
'46341': 'Hebron,IN',
'46342': 'Hobart,IN',
'46345': 'Kingsbury,IN',
'46346': 'Kingsford Heights,IN',
'46347': 'Kouts,IN',
'46348': 'La Crosse,IN',
'46349': 'Lake Village,IN',
'46350': 'La Porte,IN',
'46352': 'La Porte,IN',
'46355': 'Leroy,IN',
'46356': 'Lowell,IN',
'46360': 'Michigan City,IN',
'46361': 'Michigan City,IN',
'46365': 'Mill Creek,IN',
'46366': 'North Judson,IN',
'46368': 'Portage,IN',
'46371': 'Rolling Prairie,IN',
'46372': 'Roselawn,IN',
'46373': 'Saint John,IN',
'46374': 'San Pierre,IN',
'46375': 'Schererville,IN',
'46376': 'Schneider,IN',
'46377': 'Shelby,IN',
'46379': 'Sumava Resorts,IN',
'46380': 'Tefft,IN',
'46381': 'Thayer,IN',
'46382': 'Union Mills,IN',
'46383': 'Valparaiso,IN',
'46384': 'Valparaiso,IN',
'46385': 'Valparaiso,IN',
'46390': 'Wanatah,IN',
'46391': 'Westville,IN',
'46392': 'Wheatfield,IN',
'46393': 'Wheeler,IN',
'46394': 'Whiting,IN',
'46401': 'Gary,IN',
'46402': 'Gary,IN',
'46403': 'Gary,IN',
'46404': 'Gary,IN',
'46405': 'Lake Station,IN',
'46406': 'Gary,IN',
'46407': 'Gary,IN',
'46408': 'Gary,IN',
'46409': 'Gary,IN',
'46410': 'Merrillville,IN',
'46411': 'Merrillville,IN',
'46501': 'Argos,IN',
'46502': 'Atwood,IN',
'46504': 'Bourbon,IN',
'46506': 'Bremen,IN',
'46507': 'Bristol,IN',
'46508': 'Burket,IN',
'46510': 'Claypool,IN',
'46511': 'Culver,IN',
'46513': 'Donaldson,IN',
'46514': 'Elkhart,IN',
'46515': 'Elkhart,IN',
'46516': 'Elkhart,IN',
'46517': 'Elkhart,IN',
'46524': 'Etna Green,IN',
'46526': 'Goshen,IN',
'46527': 'Goshen,IN',
'46528': 'Goshen,IN',
'46530': 'Granger,IN',
'46531': 'Grovertown,IN',
'46532': 'Hamlet,IN',
'46534': 'Knox,IN',
'46536': 'Lakeville,IN',
'46537': 'Lapaz,IN',
'46538': 'Leesburg,IN',
'46539': 'Mentone,IN',
'46540': 'Middlebury,IN',
'46542': 'Milford,IN',
'46543': 'Millersburg,IN',
'46544': 'Mishawaka,IN',
'46545': 'Mishawaka,IN',
'46546': 'Mishawaka,IN',
'46550': 'Nappanee,IN',
'46552': 'New Carlisle,IN',
'46553': 'New Paris,IN',
'46554': 'North Liberty,IN',
'46555': 'North Webster,IN',
'46556': 'Notre Dame,IN',
'46561': 'Osceola,IN',
'46562': 'Pierceton,IN',
'46563': 'Plymouth,IN',
'46565': 'Shipshewana,IN',
'46566': 'Sidney,IN',
'46567': 'Syracuse,IN',
'46570': 'Tippecanoe,IN',
'46571': 'Topeka,IN',
'46572': 'Tyner,IN',
'46573': 'Wakarusa,IN',
'46574': 'Walkerton,IN',
'46580': 'Warsaw,IN',
'46581': 'Warsaw,IN',
'46582': 'Warsaw,IN',
'46590': 'Winona Lake,IN',
'46595': 'Wyatt,IN',
'46601': 'South Bend,IN',
'46604': 'South Bend,IN',
'46612': 'South Bend,IN',
'46613': 'South Bend,IN',
'46614': 'South Bend,IN',
'46615': 'South Bend,IN',
'46616': 'South Bend,IN',
'46617': 'South Bend,IN',
'46619': 'South Bend,IN',
'46620': 'South Bend,IN',
'46624': 'South Bend,IN',
'46626': 'South Bend,IN',
'46628': 'South Bend,IN',
'46629': 'South Bend,IN',
'46634': 'South Bend,IN',
'46635': 'South Bend,IN',
'46637': 'South Bend,IN',
'46660': 'South Bend,IN',
'46680': 'South Bend,IN',
'46699': 'South Bend,IN',
'46701': 'Albion,IN',
'46702': 'Andrews,IN',
'46703': 'Angola,IN',
'46704': 'Arcola,IN',
'46705': 'Ashley,IN',
'46706': 'Auburn,IN',
'46710': 'Avilla,IN',
'46711': 'Berne,IN',
'46713': 'Bippus,IN',
'46714': 'Bluffton,IN',
'46720': 'Brimfield,IN',
'46721': 'Butler,IN',
'46723': 'Churubusco,IN',
'46725': 'Columbia City,IN',
'46730': 'Corunna,IN',
'46731': 'Craigville,IN',
'46732': 'Cromwell,IN',
'46733': 'Decatur,IN',
'46737': 'Fremont,IN',
'46738': 'Garrett,IN',
'46740': 'Geneva,IN',
'46741': 'Grabill,IN',
'46742': 'Hamilton,IN',
'46743': 'Harlan,IN',
'46745': 'Hoagland,IN',
'46746': 'Howe,IN',
'46747': 'Hudson,IN',
'46748': 'Huntertown,IN',
'46750': 'Huntington,IN',
'46755': 'Kendallville,IN',
'46759': 'Keystone,IN',
'46760': 'Kimmell,IN',
'46761': 'Lagrange,IN',
'46763': 'Laotto,IN',
'46764': 'Larwill,IN',
'46765': 'Leo,IN',
'46766': 'Liberty Center,IN',
'46767': 'Ligonier,IN',
'46769': 'Linn Grove,IN',
'46770': 'Markle,IN',
'46771': 'Mongo,IN',
'46772': 'Monroe,IN',
'46773': 'Monroeville,IN',
'46774': 'New Haven,IN',
'46776': 'Orland,IN',
'46777': 'Ossian,IN',
'46778': 'Petroleum,IN',
'46779': 'Pleasant Lake,IN',
'46780': 'Pleasant Mills,IN',
'46781': 'Poneto,IN',
'46782': 'Preble,IN',
'46783': 'Roanoke,IN',
'46784': 'Rome City,IN',
'46785': 'Saint Joe,IN',
'46786': 'South Milford,IN',
'46787': 'South Whitley,IN',
'46788': 'Spencerville,IN',
'46789': 'Stroh,IN',
'46791': 'Uniondale,IN',
'46792': 'Warren,IN',
'46793': 'Waterloo,IN',
'46794': 'Wawaka,IN',
'46795': 'Wolcottville,IN',
'46796': 'Wolflake,IN',
'46797': 'Woodburn,IN',
'46798': 'Yoder,IN',
'46799': 'Zanesville,IN',
'46801': 'Fort Wayne,IN',
'46802': 'Fort Wayne,IN',
'46803': 'Fort Wayne,IN',
'46804': 'Fort Wayne,IN',
'46805': 'Fort Wayne,IN',
'46806': 'Fort Wayne,IN',
'46807': 'Fort Wayne,IN',
'46808': 'Fort Wayne,IN',
'46809': 'Fort Wayne,IN',
'46814': 'Fort Wayne,IN',
'46815': 'Fort Wayne,IN',
'46816': 'Fort Wayne,IN',
'46818': 'Fort Wayne,IN',
'46819': 'Fort Wayne,IN',
'46825': 'Fort Wayne,IN',
'46835': 'Fort Wayne,IN',
'46845': 'Fort Wayne,IN',
'46850': 'Fort Wayne,IN',
'46851': 'Fort Wayne,IN',
'46852': 'Fort Wayne,IN',
'46853': 'Fort Wayne,IN',
'46854': 'Fort Wayne,IN',
'46855': 'Fort Wayne,IN',
'46856': 'Fort Wayne,IN',
'46857': 'Fort Wayne,IN',
'46858': 'Fort Wayne,IN',
'46859': 'Fort Wayne,IN',
'46860': 'Fort Wayne,IN',
'46861': 'Fort Wayne,IN',
'46862': 'Fort Wayne,IN',
'46863': 'Fort Wayne,IN',
'46864': 'Fort Wayne,IN',
'46865': 'Fort Wayne,IN',
'46866': 'Fort Wayne,IN',
'46867': 'Fort Wayne,IN',
'46868': 'Fort Wayne,IN',
'46869': 'Fort Wayne,IN',
'46885': 'Fort Wayne,IN',
'46895': 'Fort Wayne,IN',
'46896': 'Fort Wayne,IN',
'46897': 'Fort Wayne,IN',
'46898': 'Fort Wayne,IN',
'46899': 'Fort Wayne,IN',
'46901': 'Kokomo,IN',
'46902': 'Kokomo,IN',
'46903': 'Kokomo,IN',
'46904': 'Kokomo,IN',
'46910': 'Akron,IN',
'46911': 'Amboy,IN',
'46912': 'Athens,IN',
'46913': 'Bringhurst,IN',
'46914': 'Bunker Hill,IN',
'46915': 'Burlington,IN',
'46916': 'Burrows,IN',
'46917': 'Camden,IN',
'46919': 'Converse,IN',
'46920': 'Cutler,IN',
'46921': 'Deedsville,IN',
'46922': 'Delong,IN',
'46923': 'Delphi,IN',
'46926': 'Denver,IN',
'46928': 'Fairmount,IN',
'46929': 'Flora,IN',
'46930': 'Fowlerton,IN',
'46931': 'Fulton,IN',
'46932': 'Galveston,IN',
'46933': 'Gas City,IN',
'46935': 'Grass Creek,IN',
'46936': 'Greentown,IN',
'46937': 'Hemlock,IN',
'46938': 'Jonesboro,IN',
'46939': 'Kewanna,IN',
'46940': 'La Fontaine,IN',
'46941': 'Lagro,IN',
'46942': 'Lake Cicott,IN',
'46943': 'Laketon,IN',
'46945': 'Leiters Ford,IN',
'46946': 'Liberty Mills,IN',
'46947': 'Logansport,IN',
'46950': 'Lucerne,IN',
'46951': 'Macy,IN',
'46952': 'Marion,IN',
'46953': 'Marion,IN',
'46957': 'Matthews,IN',
'46958': 'Mexico,IN',
'46959': 'Miami,IN',
'46960': 'Monterey,IN',
'46961': 'New Waverly,IN',
'46962': 'North Manchester,IN',
'46965': 'Oakford,IN',
'46967': 'Onward,IN',
'46968': 'Ora,IN',
'46970': 'Peru,IN',
'46971': 'Grissom Arb,IN',
'46974': 'Roann,IN',
'46975': 'Rochester,IN',
'46977': 'Rockfield,IN',
'46978': 'Royal Center,IN',
'46979': 'Russiaville,IN',
'46980': 'Servia,IN',
'46982': 'Silver Lake,IN',
'46984': 'Somerset,IN',
'46985': 'Star City,IN',
'46986': 'Swayzee,IN',
'46987': 'Sweetser,IN',
'46988': 'Twelve Mile,IN',
'46989': 'Upland,IN',
'46990': 'Urbana,IN',
'46991': 'Van Buren,IN',
'46992': 'Wabash,IN',
'46994': 'Walton,IN',
'46995': 'West Middleton,IN',
'46996': 'Winamac,IN',
'46998': 'Young America,IN',
'47001': 'Aurora,IN',
'47003': 'West College Corner,IN',
'47006': 'Batesville,IN',
'47010': 'Bath,IN',
'47011': 'Bennington,IN',
'47012': 'Brookville,IN',
'47016': 'Cedar Grove,IN',
'47017': 'Cross Plains,IN',
'47018': 'Dillsboro,IN',
'47019': 'East Enterprise,IN',
'47020': 'Florence,IN',
'47021': 'Friendship,IN',
'47022': 'Guilford,IN',
'47023': 'Holton,IN',
'47024': 'Laurel,IN',
'47025': 'Lawrenceburg,IN',
'47030': 'Metamora,IN',
'47031': 'Milan,IN',
'47032': 'Moores Hill,IN',
'47033': 'Morris,IN',
'47034': 'Napoleon,IN',
'47035': 'New Trenton,IN',
'47036': 'Oldenburg,IN',
'47037': 'Osgood,IN',
'47038': 'Patriot,IN',
'47039': 'Pierceville,IN',
'47040': 'Rising Sun,IN',
'47041': 'Sunman,IN',
'47042': 'Versailles,IN',
'47043': 'Vevay,IN',
'47060': 'West Harrison,IN',
'47102': 'Austin,IN',
'47104': 'Bethlehem,IN',
'47106': 'Borden,IN',
'47107': 'Bradford,IN',
'47108': 'Campbellsburg,IN',
'47110': 'Central,IN',
'47111': 'Charlestown,IN',
'47112': 'Corydon,IN',
'47114': 'Crandall,IN',
'47115': 'Depauw,IN',
'47116': 'Eckerty,IN',
'47117': 'Elizabeth,IN',
'47118': 'English,IN',
'47119': 'Floyds Knobs,IN',
'47120': 'Fredericksburg,IN',
'47122': 'Georgetown,IN',
'47123': 'Grantsburg,IN',
'47124': 'Greenville,IN',
'47125': 'Hardinsburg,IN',
'47126': 'Henryville,IN',
'47129': 'Clarksville,IN',
'47130': 'Jeffersonville,IN',
'47131': 'Jeffersonville,IN',
'47132': 'Jeffersonville,IN',
'47133': 'Jeffersonville,IN',
'47134': 'Jeffersonville,IN',
'47135': 'Laconia,IN',
'47136': 'Lanesville,IN',
'47137': 'Leavenworth,IN',
'47138': 'Lexington,IN',
'47139': 'Little York,IN',
'47140': 'Marengo,IN',
'47141': 'Marysville,IN',
'47142': 'Mauckport,IN',
'47143': 'Memphis,IN',
'47144': 'Jeffersonville,IN',
'47145': 'Milltown,IN',
'47146': 'Mount Saint Francis,IN',
'47147': 'Nabb,IN',
'47150': 'New Albany,IN',
'47151': 'New Albany,IN',
'47160': 'New Middletown,IN',
'47161': 'New Salisbury,IN',
'47162': 'New Washington,IN',
'47163': 'Otisco,IN',
'47164': 'Palmyra,IN',
'47165': 'Pekin,IN',
'47166': 'Ramsey,IN',
'47167': 'Salem,IN',
'47170': 'Scottsburg,IN',
'47172': 'Sellersburg,IN',
'47174': 'Sulphur,IN',
'47175': 'Taswell,IN',
'47177': 'Underwood,IN',
'47190': 'Jeffersonvlle,IN',
'47199': 'Jeffersonville,IN',
'47201': 'Columbus,IN',
'47202': 'Columbus,IN',
'47203': 'Columbus,IN',
'47220': 'Brownstown,IN',
'47223': 'Butlerville,IN',
'47224': 'Canaan,IN',
'47225': 'Clarksburg,IN',
'47226': 'Clifford,IN',
'47227': 'Commiskey,IN',
'47228': 'Cortland,IN',
'47229': 'Crothersville,IN',
'47230': 'Deputy,IN',
'47231': 'Dupont,IN',
'47232': 'Elizabethtown,IN',
'47234': 'Flat Rock,IN',
'47235': 'Freetown,IN',
'47236': 'Grammer,IN',
'47240': 'Greensburg,IN',
'47243': 'Hanover,IN',
'47244': 'Hartsville,IN',
'47245': 'Hayden,IN',
'47246': 'Hope,IN',
'47247': 'Jonesville,IN',
'47249': 'Kurtz,IN',
'47250': 'Madison,IN',
'47260': 'Medora,IN',
'47261': 'Millhousen,IN',
'47262': 'Nebraska,IN',
'47263': 'New Point,IN',
'47264': 'Norman,IN',
'47265': 'North Vernon,IN',
'47270': 'Paris Crossing,IN',
'47272': 'Saint Paul,IN',
'47273': 'Scipio,IN',
'47274': 'Seymour,IN',
'47280': 'Taylorsville,IN',
'47281': 'Vallonia,IN',
'47282': 'Vernon,IN',
'47283': 'Westport,IN',
'47302': 'Muncie,IN',
'47303': 'Muncie,IN',
'47304': 'Muncie,IN',
'47305': 'Muncie,IN',
'47306': 'Muncie,IN',
'47307': 'Muncie,IN',
'47308': 'Muncie,IN',
'47320': 'Albany,IN',
'47322': 'Bentonville,IN',
'47324': 'Boston,IN',
'47325': 'Brownsville,IN',
'47326': 'Bryant,IN',
'47327': 'Cambridge City,IN',
'47330': 'Centerville,IN',
'47331': 'Connersville,IN',
'47334': 'Daleville,IN',
'47335': 'Dublin,IN',
'47336': 'Dunkirk,IN',
'47337': 'Dunreith,IN',
'47338': 'Eaton,IN',
'47339': 'Economy,IN',
'47340': 'Farmland,IN',
'47341': 'Fountain City,IN',
'47342': 'Gaston,IN',
'47344': 'Greensboro,IN',
'47345': 'Greens Fork,IN',
'47346': 'Hagerstown,IN',
'47348': 'Hartford City,IN',
'47351': 'Kennard,IN',
'47352': 'Lewisville,IN',
'47353': 'Liberty,IN',
'47354': 'Losantville,IN',
'47355': 'Lynn,IN',
'47356': 'Middletown,IN',
'47357': 'Milton,IN',
'47358': 'Modoc,IN',
'47359': 'Montpelier,IN',
'47360': 'Mooreland,IN',
'47361': 'Mount Summit,IN',
'47362': 'New Castle,IN',
'47366': 'New Lisbon,IN',
'47367': 'Oakville,IN',
'47368': 'Parker City,IN',
'47369': 'Pennville,IN',
'47370': 'Pershing,IN',
'47371': 'Portland,IN',
'47373': 'Redkey,IN',
'47374': 'Richmond,IN',
'47375': 'Richmond,IN',
'47380': 'Ridgeville,IN',
'47381': 'Salamonia,IN',
'47382': 'Saratoga,IN',
'47383': 'Selma,IN',
'47384': 'Shirley,IN',
'47385': 'Spiceland,IN',
'47386': 'Springport,IN',
'47387': 'Straughn,IN',
'47388': 'Sulphur Springs,IN',
'47390': 'Union City,IN',
'47392': 'Webster,IN',
'47393': 'Williamsburg,IN',
'47394': 'Winchester,IN',
'47396': 'Yorktown,IN',
'47401': 'Bloomington,IN',
'47402': 'Bloomington,IN',
'47403': 'Bloomington,IN',
'47404': 'Bloomington,IN',
'47405': 'Bloomington,IN',
'47406': 'Bloomington,IN',
'47407': 'Bloomington,IN',
'47408': 'Bloomington,IN',
'47420': 'Avoca,IN',
'47421': 'Bedford,IN',
'47424': 'Bloomfield,IN',
'47426': 'Clear Creek,IN',
'47427': 'Coal City,IN',
'47429': 'Ellettsville,IN',
'47430': 'Fort Ritner,IN',
'47431': 'Freedom,IN',
'47432': 'French Lick,IN',
'47433': 'Gosport,IN',
'47434': 'Harrodsburg,IN',
'47435': 'Helmsburg,IN',
'47436': 'Heltonville,IN',
'47437': 'Huron,IN',
'47438': 'Jasonville,IN',
'47439': 'Koleen,IN',
'47441': 'Linton,IN',
'47443': 'Lyons,IN',
'47445': 'Midland,IN',
'47446': 'Mitchell,IN',
'47448': 'Nashville,IN',
'47449': 'Newberry,IN',
'47451': 'Oolitic,IN',
'47452': 'Orleans,IN',
'47453': 'Owensburg,IN',
'47454': 'Paoli,IN',
'47455': 'Patricksburg,IN',
'47456': 'Quincy,IN',
'47457': 'Scotland,IN',
'47458': 'Smithville,IN',
'47459': 'Solsberry,IN',
'47460': 'Spencer,IN',
'47462': 'Springville,IN',
'47463': 'Stanford,IN',
'47464': 'Stinesville,IN',
'47465': 'Switz City,IN',
'47467': 'Tunnelton,IN',
'47468': 'Unionville,IN',
'47469': 'West Baden Springs,IN',
'47470': 'Williams,IN',
'47471': 'Worthington,IN',
'47490': 'Bloomington,IN',
'47501': 'Washington,IN',
'47512': 'Bicknell,IN',
'47513': 'Birdseye,IN',
'47514': 'Branchville,IN',
'47515': 'Bristow,IN',
'47516': 'Bruceville,IN',
'47519': 'Cannelburg,IN',
'47520': 'Cannelton,IN',
'47521': 'Celestine,IN',
'47522': 'Crane,IN',
'47523': 'Dale,IN',
'47524': 'Decker,IN',
'47525': 'Derby,IN',
'47527': 'Dubois,IN',
'47528': 'Edwardsport,IN',
'47529': 'Elnora,IN',
'47531': 'Evanston,IN',
'47532': 'Ferdinand,IN',
'47535': 'Freelandville,IN',
'47536': 'Fulda,IN',
'47537': 'Gentryville,IN',
'47541': 'Holland,IN',
'47542': 'Huntingburg,IN',
'47545': 'Ireland,IN',
'47546': 'Jasper,IN',
'47547': 'Jasper,IN',
'47549': 'Jasper,IN',
'47550': 'Lamar,IN',
'47551': 'Leopold,IN',
'47552': 'Lincoln City,IN',
'47553': 'Loogootee,IN',
'47556': 'Mariah Hill,IN',
'47557': 'Monroe City,IN',
'47558': 'Montgomery,IN',
'47561': 'Oaktown,IN',
'47562': 'Odon,IN',
'47564': 'Otwell,IN',
'47567': 'Petersburg,IN',
'47568': 'Plainville,IN',
'47573': 'Ragsdale,IN',
'47574': 'Rome,IN',
'47575': 'Saint Anthony,IN',
'47576': 'Saint Croix,IN',
'47577': 'Saint Meinrad,IN',
'47578': 'Sandborn,IN',
'47579': 'Santa Claus,IN',
'47580': 'Schnellville,IN',
'47581': 'Shoals,IN',
'47584': 'Spurgeon,IN',
'47585': 'Stendal,IN',
'47586': 'Tell City,IN',
'47588': 'Troy,IN',
'47590': 'Velpen,IN',
'47591': 'Vincennes,IN',
'47596': 'Westphalia,IN',
'47597': 'Wheatland,IN',
'47598': 'Winslow,IN',
'47601': 'Boonville,IN',
'47610': 'Chandler,IN',
'47611': 'Chrisney,IN',
'47612': 'Cynthiana,IN',
'47613': 'Elberfeld,IN',
'47614': 'Folsomville,IN',
'47615': 'Grandview,IN',
'47616': 'Griffin,IN',
'47617': 'Hatfield,IN',
'47618': 'Inglefield,IN',
'47619': 'Lynnville,IN',
'47620': 'Mount Vernon,IN',
'47629': 'Newburgh,IN',
'47630': 'Newburgh,IN',
'47631': 'New Harmony,IN',
'47633': 'Poseyville,IN',
'47634': 'Richland,IN',
'47635': 'Rockport,IN',
'47637': 'Tennyson,IN',
'47638': 'Wadesville,IN',
'47639': 'Haubstadt,IN',
'47640': 'Hazleton,IN',
'47647': 'Buckskin,IN',
'47648': 'Fort Branch,IN',
'47649': 'Francisco,IN',
'47654': 'Mackey,IN',
'47660': 'Oakland City,IN',
'47665': 'Owensville,IN',
'47666': 'Patoka,IN',
'47670': 'Princeton,IN',
'47683': 'Somerville,IN',
'47701': 'Evansville,IN',
'47702': 'Evansville,IN',
'47703': 'Evansville,IN',
'47704': 'Evansville,IN',
'47705': 'Evansville,IN',
'47706': 'Evansville,IN',
'47708': 'Evansville,IN',
'47710': 'Evansville,IN',
'47711': 'Evansville,IN',
'47712': 'Evansville,IN',
'47713': 'Evansville,IN',
'47714': 'Evansville,IN',
'47715': 'Evansville,IN',
'47716': 'Evansville,IN',
'47719': 'Evansville,IN',
'47720': 'Evansville,IN',
'47721': 'Evansville,IN',
'47722': 'Evansville,IN',
'47724': 'Evansville,IN',
'47725': 'Evansville,IN',
'47727': 'Evansville,IN',
'47728': 'Evansville,IN',
'47730': 'Evansville,IN',
'47731': 'Evansville,IN',
'47732': 'Evansville,IN',
'47733': 'Evansville,IN',
'47734': 'Evansville,IN',
'47735': 'Evansville,IN',
'47736': 'Evansville,IN',
'47737': 'Evansville,IN',
'47739': 'Evansville,IN',
'47740': 'Evansville,IN',
'47741': 'Evansville,IN',
'47744': 'Evansville,IN',
'47747': 'Evansville,IN',
'47750': 'Evansville,IN',
'47801': 'Terre Haute,IN',
'47802': 'Terre Haute,IN',
'47803': 'Terre Haute,IN',
'47804': 'Terre Haute,IN',
'47805': 'Terre Haute,IN',
'47807': 'Terre Haute,IN',
'47808': 'Terre Haute,IN',
'47809': 'Terre Haute,IN',
'47811': 'Terre Haute,IN',
'47812': 'Terre Haute,IN',
'47813': 'Terre Haute,IN',
'47814': 'Terre Haute,IN',
'47830': 'Bellmore,IN',
'47831': 'Blanford,IN',
'47832': 'Bloomingdale,IN',
'47833': 'Bowling Green,IN',
'47834': 'Brazil,IN',
'47836': 'Bridgeton,IN',
'47837': 'Carbon,IN',
'47838': 'Carlisle,IN',
'47840': 'Centerpoint,IN',
'47841': 'Clay City,IN',
'47842': 'Clinton,IN',
'47845': 'Coalmont,IN',
'47846': 'Cory,IN',
'47847': 'Dana,IN',
'47848': 'Dugger,IN',
'47849': 'Fairbanks,IN',
'47850': 'Farmersburg,IN',
'47851': 'Fontanet,IN',
'47852': 'Graysville,IN',
'47853': 'Harmony,IN',
'47854': 'Hillsdale,IN',
'47855': 'Hymera,IN',
'47856': 'Judson,IN',
'47857': 'Knightsville,IN',
'47858': 'Lewis,IN',
'47859': 'Marshall,IN',
'47860': 'Mecca,IN',
'47861': 'Merom,IN',
'47862': 'Montezuma,IN',
'47863': 'New Goshen,IN',
'47864': 'New Lebanon,IN',
'47865': 'Paxton,IN',
'47866': 'Pimento,IN',
'47868': 'Poland,IN',
'47869': 'Prairie Creek,IN',
'47870': 'Prairieton,IN',
'47871': 'Riley,IN',
'47872': 'Rockville,IN',
'47874': 'Rosedale,IN',
'47875': 'Saint Bernice,IN',
'47876': 'Saint Mary Of The Woods,IN',
'47878': 'Seelyville,IN',
'47879': 'Shelburn,IN',
'47880': 'Shepardsville,IN',
'47881': 'Staunton,IN',
'47882': 'Sullivan,IN',
'47884': 'Universal,IN',
'47885': 'West Terre Haute,IN',
'47901': 'Lafayette,IN',
'47902': 'Lafayette,IN',
'47903': 'Lafayette,IN',
'47904': 'Lafayette,IN',
'47905': 'Lafayette,IN',
'47906': 'West Lafayette,IN',
'47907': 'West Lafayette,IN',
'47909': 'Lafayette,IN',
'47916': 'Alamo,IN',
'47917': 'Ambia,IN',
'47918': 'Attica,IN',
'47920': 'Battle Ground,IN',
'47921': 'Boswell,IN',
'47922': 'Brook,IN',
'47923': 'Brookston,IN',
'47924': 'Buck Creek,IN',
'47925': 'Buffalo,IN',
'47926': 'Burnettsville,IN',
'47928': 'Cayuga,IN',
'47929': 'Chalmers,IN',
'47930': 'Clarks Hill,IN',
'47932': 'Covington,IN',
'47933': 'Crawfordsville,IN',
'47934': 'Crawfordsville,IN',
'47935': 'Crawfordsville,IN',
'47936': 'Crawfordsville,IN',
'47937': 'Crawfordsville,IN',
'47938': 'Crawfordsville,IN',
'47939': 'Crawfordsville,IN',
'47940': 'Darlington,IN',
'47941': 'Dayton,IN',
'47942': 'Earl Park,IN',
'47943': 'Fair Oaks,IN',
'47944': 'Fowler,IN',
'47946': 'Francesville,IN',
'47948': 'Goodland,IN',
'47949': 'Hillsboro,IN',
'47950': 'Idaville,IN',
'47951': 'Kentland,IN',
'47952': 'Kingman,IN',
'47954': 'Ladoga,IN',
'47955': 'Linden,IN',
'47957': 'Medaryville,IN',
'47958': 'Mellott,IN',
'47959': 'Monon,IN',
'47960': 'Monticello,IN',
'47962': 'Montmorenci,IN',
'47963': 'Morocco,IN',
'47964': 'Mount Ayr,IN',
'47965': 'New Market,IN',
'47966': 'Newport,IN',
'47967': 'New Richmond,IN',
'47968': 'New Ross,IN',
'47969': 'Newtown,IN',
'47970': 'Otterbein,IN',
'47971': 'Oxford,IN',
'47974': 'Perrysville,IN',
'47975': 'Pine Village,IN',
'47977': 'Remington,IN',
'47978': 'Rensselaer,IN',
'47980': 'Reynolds,IN',
'47981': 'Romney,IN',
'47982': 'State Line,IN',
'47983': 'Stockwell,IN',
'47984': 'Talbot,IN',
'47986': 'Templeton,IN',
'47987': 'Veedersburg,IN',
'47988': 'Wallace,IN',
'47989': 'Waveland,IN',
'47990': 'Waynetown,IN',
'47991': 'West Lebanon,IN',
'47992': 'Westpoint,IN',
'47993': 'Williamsport,IN',
'47994': 'Wingate,IN',
'47995': 'Wolcott,IN',
'47996': 'West Lafayette,IN',
'47997': 'Yeoman,IN',
'48001': 'Algonac,MI',
'48002': 'Allenton,MI',
'48003': 'Almont,MI',
'48004': 'Anchorville,MI',
'48005': 'Armada,MI',
'48006': 'Avoca,MI',
'48007': 'Troy,MI',
'48009': 'Birmingham,MI',
'48012': 'Birmingham,MI',
'48014': 'Capac,MI',
'48015': 'Center Line,MI',
'48017': 'Clawson,MI',
'48021': 'Eastpointe,MI',
'48022': 'Emmett,MI',
'48023': 'Fair Haven,MI',
'48025': 'Franklin,MI',
'48026': 'Fraser,MI',
'48027': 'Goodells,MI',
'48028': 'Harsens Island,MI',
'48030': 'Hazel Park,MI',
'48032': 'Jeddo,MI',
'48033': 'Southfield,MI',
'48034': 'Southfield,MI',
'48035': 'Clinton Township,MI',
'48036': 'Clinton Township,MI',
'48037': 'Southfield,MI',
'48038': 'Clinton Township,MI',
'48039': 'Marine City,MI',
'48040': 'Marysville,MI',
'48041': 'Memphis,MI',
'48042': 'Macomb,MI',
'48043': 'Mount Clemens,MI',
'48044': 'Macomb,MI',
'48045': 'Harrison Township,MI',
'48046': 'Mount Clemens,MI',
'48047': 'New Baltimore,MI',
'48048': 'New Haven,MI',
'48049': 'North Street,MI',
'48050': 'New Haven,MI',
'48051': 'New Baltimore,MI',
'48054': 'East China,MI',
'48059': 'Fort Gratiot,MI',
'48060': 'Port Huron,MI',
'48061': 'Port Huron,MI',
'48062': 'Richmond,MI',
'48063': 'Columbus,MI',
'48064': 'Casco,MI',
'48065': 'Romeo,MI',
'48066': 'Roseville,MI',
'48067': 'Royal Oak,MI',
'48068': 'Royal Oak,MI',
'48069': 'Pleasant Ridge,MI',
'48070': 'Huntington Woods,MI',
'48071': 'Madison Heights,MI',
'48072': 'Berkley,MI',
'48073': 'Royal Oak,MI',
'48074': 'Smiths Creek,MI',
'48075': 'Southfield,MI',
'48076': 'Southfield,MI',
'48079': 'Saint Clair,MI',
'48080': 'Saint Clair Shores,MI',
'48081': 'Saint Clair Shores,MI',
'48082': 'Saint Clair Shores,MI',
'48083': 'Troy,MI',
'48084': 'Troy,MI',
'48085': 'Troy,MI',
'48086': 'Southfield,MI',
'48088': 'Warren,MI',
'48089': 'Warren,MI',
'48090': 'Warren,MI',
'48091': 'Warren,MI',
'48092': 'Warren,MI',
'48093': 'Warren,MI',
'48094': 'Washington,MI',
'48095': 'Washington,MI',
'48096': 'Ray,MI',
'48097': 'Yale,MI',
'48098': 'Troy,MI',
'48099': 'Troy,MI',
'48101': 'Allen Park,MI',
'48103': 'Ann Arbor,MI',
'48104': 'Ann Arbor,MI',
'48105': 'Ann Arbor,MI',
'48106': 'Ann Arbor,MI',
'48107': 'Ann Arbor,MI',
'48108': 'Ann Arbor,MI',
'48109': 'Ann Arbor,MI',
'48110': 'Azalia,MI',
'48111': 'Belleville,MI',
'48112': 'Belleville,MI',
'48113': 'Ann Arbor,MI',
'48114': 'Brighton,MI',
'48115': 'Bridgewater,MI',
'48116': 'Brighton,MI',
'48117': 'Carleton,MI',
'48118': 'Chelsea,MI',
'48120': 'Dearborn,MI',
'48121': 'Dearborn,MI',
'48122': 'Melvindale,MI',
'48123': 'Dearborn,MI',
'48124': 'Dearborn,MI',
'48125': 'Dearborn Heights,MI',
'48126': 'Dearborn,MI',
'48127': 'Dearborn Heights,MI',
'48128': 'Dearborn,MI',
'48130': 'Dexter,MI',
'48131': 'Dundee,MI',
'48133': 'Erie,MI',
'48134': 'Flat Rock,MI',
'48135': 'Garden City,MI',
'48136': 'Garden City,MI',
'48137': 'Gregory,MI',
'48138': 'Grosse Ile,MI',
'48139': 'Hamburg,MI',
'48140': 'Ida,MI',
'48141': 'Inkster,MI',
'48143': 'Lakeland,MI',
'48144': 'Lambertville,MI',
'48145': 'La Salle,MI',
'48146': 'Lincoln Park,MI',
'48150': 'Livonia,MI',
'48151': 'Livonia,MI',
'48152': 'Livonia,MI',
'48153': 'Livonia,MI',
'48154': 'Livonia,MI',
'48157': 'Luna Pier,MI',
'48158': 'Manchester,MI',
'48159': 'Maybee,MI',
'48160': 'Milan,MI',
'48161': 'Monroe,MI',
'48162': 'Monroe,MI',
'48164': 'New Boston,MI',
'48165': 'New Hudson,MI',
'48166': 'Newport,MI',
'48167': 'Northville,MI',
'48168': 'Northville,MI',
'48169': 'Pinckney,MI',
'48170': 'Plymouth,MI',
'48173': 'Rockwood,MI',
'48174': 'Romulus,MI',
'48175': 'Salem,MI',
'48176': 'Saline,MI',
'48177': 'Samaria,MI',
'48178': 'South Lyon,MI',
'48179': 'South Rockwood,MI',
'48180': 'Taylor,MI',
'48182': 'Temperance,MI',
'48183': 'Trenton,MI',
'48184': 'Wayne,MI',
'48185': 'Westland,MI',
'48186': 'Westland,MI',
'48187': 'Canton,MI',
'48188': 'Canton,MI',
'48189': 'Whitmore Lake,MI',
'48190': 'Whittaker,MI',
'48191': 'Willis,MI',
'48192': 'Wyandotte,MI',
'48193': 'Wyandotte,MI',
'48195': 'Southgate,MI',
'48197': 'Ypsilanti,MI',
'48198': 'Ypsilanti,MI',
'48201': 'Detroit,MI',
'48202': 'Detroit,MI',
'48203': 'Highland Park,MI',
'48204': 'Detroit,MI',
'48205': 'Detroit,MI',
'48206': 'Detroit,MI',
'48207': 'Detroit,MI',
'48208': 'Detroit,MI',
'48209': 'Detroit,MI',
'48210': 'Detroit,MI',
'48211': 'Detroit,MI',
'48212': 'Hamtramck,MI',
'48213': 'Detroit,MI',
'48214': 'Detroit,MI',
'48215': 'Detroit,MI',
'48216': 'Detroit,MI',
'48217': 'Detroit,MI',
'48218': 'River Rouge,MI',
'48219': 'Detroit,MI',
'48220': 'Ferndale,MI',
'48221': 'Detroit,MI',
'48222': 'Detroit,MI',
'48223': 'Detroit,MI',
'48224': 'Detroit,MI',
'48225': 'Harper Woods,MI',
'48226': 'Detroit,MI',
'48227': 'Detroit,MI',
'48228': 'Detroit,MI',
'48229': 'Ecorse,MI',
'48230': 'Grosse Pointe,MI',
'48231': 'Detroit,MI',
'48232': 'Detroit,MI',
'48233': 'Detroit,MI',
'48234': 'Detroit,MI',
'48235': 'Detroit,MI',
'48236': 'Grosse Pointe,MI',
'48237': 'Oak Park,MI',
'48238': 'Detroit,MI',
'48239': 'Redford,MI',
'48240': 'Redford,MI',
'48242': 'Detroit,MI',
'48243': 'Detroit,MI',
'48244': 'Detroit,MI',
'48255': 'Detroit,MI',
'48260': 'Detroit,MI',
'48264': 'Detroit,MI',
'48265': 'Detroit,MI',
'48266': 'Detroit,MI',
'48267': 'Detroit,MI',
'48268': 'Detroit,MI',
'48269': 'Detroit,MI',
'48272': 'Detroit,MI',
'48275': 'Detroit,MI',
'48277': 'Detroit,MI',
'48278': 'Detroit,MI',
'48279': 'Detroit,MI',
'48288': 'Detroit,MI',
'48301': 'Bloomfield Hills,MI',
'48302': 'Bloomfield Hills,MI',
'48303': 'Bloomfield Hills,MI',
'48304': 'Bloomfield Hills,MI',
'48306': 'Rochester,MI',
'48307': 'Rochester,MI',
'48308': 'Rochester,MI',
'48309': 'Rochester,MI',
'48310': 'Sterling Heights,MI',
'48311': 'Sterling Heights,MI',
'48312': 'Sterling Heights,MI',
'48313': 'Sterling Heights,MI',
'48314': 'Sterling Heights,MI',
'48315': 'Utica,MI',
'48316': 'Utica,MI',
'48317': 'Utica,MI',
'48318': 'Utica,MI',
'48320': 'Keego Harbor,MI',
'48321': 'Auburn Hills,MI',
'48322': 'West Bloomfield,MI',
'48323': 'West Bloomfield,MI',
'48324': 'West Bloomfield,MI',
'48325': 'West Bloomfield,MI',
'48326': 'Auburn Hills,MI',
'48327': 'Waterford,MI',
'48328': 'Waterford,MI',
'48329': 'Waterford,MI',
'48330': 'Drayton Plains,MI',
'48331': 'Farmington,MI',
'48332': 'Farmington,MI',
'48333': 'Farmington,MI',
'48334': 'Farmington,MI',
'48335': 'Farmington,MI',
'48336': 'Farmington,MI',
'48340': 'Pontiac,MI',
'48341': 'Pontiac,MI',
'48342': 'Pontiac,MI',
'48343': 'Pontiac,MI',
'48346': 'Clarkston,MI',
'48347': 'Clarkston,MI',
'48348': 'Clarkston,MI',
'48350': 'Davisburg,MI',
'48353': 'Hartland,MI',
'48356': 'Highland,MI',
'48357': 'Highland,MI',
'48359': 'Lake Orion,MI',
'48360': 'Lake Orion,MI',
'48361': 'Lake Orion,MI',
'48362': 'Lake Orion,MI',
'48363': 'Oakland,MI',
'48366': 'Lakeville,MI',
'48367': 'Leonard,MI',
'48370': 'Oxford,MI',
'48371': 'Oxford,MI',
'48374': 'Novi,MI',
'48375': 'Novi,MI',
'48376': 'Novi,MI',
'48377': 'Novi,MI',
'48380': 'Milford,MI',
'48381': 'Milford,MI',
'48382': 'Commerce Township,MI',
'48383': 'White Lake,MI',
'48386': 'White Lake,MI',
'48387': 'Union Lake,MI',
'48390': 'Walled Lake,MI',
'48391': 'Walled Lake,MI',
'48393': 'Wixom,MI',
'48397': 'Warren,MI',
'48398': 'Clawson,MI',
'48401': 'Applegate,MI',
'48410': 'Argyle,MI',
'48411': 'Atlas,MI',
'48412': 'Attica,MI',
'48413': 'Bad Axe,MI',
'48414': 'Bancroft,MI',
'48415': 'Birch Run,MI',
'48416': 'Brown City,MI',
'48417': 'Burt,MI',
'48418': 'Byron,MI',
'48419': 'Carsonville,MI',
'48420': 'Clio,MI',
'48421': 'Columbiaville,MI',
'48422': 'Croswell,MI',
'48423': 'Davison,MI',
'48426': 'Decker,MI',
'48427': 'Deckerville,MI',
'48428': 'Dryden,MI',
'48429': 'Durand,MI',
'48430': 'Fenton,MI',
'48432': 'Filion,MI',
'48433': 'Flushing,MI',
'48434': 'Forestville,MI',
'48435': 'Fostoria,MI',
'48436': 'Gaines,MI',
'48437': 'Genesee,MI',
'48438': 'Goodrich,MI',
'48439': 'Grand Blanc,MI',
'48440': 'Hadley,MI',
'48441': 'Harbor Beach,MI',
'48442': 'Holly,MI',
'48444': 'Imlay City,MI',
'48445': 'Kinde,MI',
'48446': 'Lapeer,MI',
'48449': 'Lennon,MI',
'48450': 'Lexington,MI',
'48451': 'Linden,MI',
'48453': 'Marlette,MI',
'48454': 'Melvin,MI',
'48455': 'Metamora,MI',
'48456': 'Minden City,MI',
'48457': 'Montrose,MI',
'48458': 'Mount Morris,MI',
'48460': 'New Lothrop,MI',
'48461': 'North Branch,MI',
'48462': 'Ortonville,MI',
'48463': 'Otisville,MI',
'48464': 'Otter Lake,MI',
'48465': 'Palms,MI',
'48466': 'Peck,MI',
'48467': 'Port Austin,MI',
'48468': 'Port Hope,MI',
'48469': 'Port Sanilac,MI',
'48470': 'Ruth,MI',
'48471': 'Sandusky,MI',
'48472': 'Snover,MI',
'48473': 'Swartz Creek,MI',
'48475': 'Ubly,MI',
'48476': 'Vernon,MI',
'48480': 'Grand Blanc,MI',
'48501': 'Flint,MI',
'48502': 'Flint,MI',
'48503': 'Flint,MI',
'48504': 'Flint,MI',
'48505': 'Flint,MI',
'48506': 'Flint,MI',
'48507': 'Flint,MI',
'48509': 'Burton,MI',
'48519': 'Burton,MI',
'48529': 'Burton,MI',
'48531': 'Flint,MI',
'48532': 'Flint,MI',
'48550': 'Flint,MI',
'48551': 'Flint,MI',
'48552': 'Flint,MI',
'48553': 'Flint,MI',
'48554': 'Flint,MI',
'48555': 'Flint,MI',
'48556': 'Flint,MI',
'48557': 'Flint,MI',
'48559': 'Flint,MI',
'48601': 'Saginaw,MI',
'48602': 'Saginaw,MI',
'48603': 'Saginaw,MI',
'48604': 'Saginaw,MI',
'48605': 'Saginaw,MI',
'48606': 'Saginaw,MI',
'48607': 'Saginaw,MI',
'48608': 'Saginaw,MI',
'48609': 'Saginaw,MI',
'48610': 'Alger,MI',
'48611': 'Auburn,MI',
'48612': 'Beaverton,MI',
'48613': 'Bentley,MI',
'48614': 'Brant,MI',
'48615': 'Breckenridge,MI',
'48616': 'Chesaning,MI',
'48617': 'Clare,MI',
'48618': 'Coleman,MI',
'48619': 'Comins,MI',
'48620': 'Edenville,MI',
'48621': 'Fairview,MI',
'48622': 'Farwell,MI',
'48623': 'Freeland,MI',
'48624': 'Gladwin,MI',
'48625': 'Harrison,MI',
'48626': 'Hemlock,MI',
'48627': 'Higgins Lake,MI',
'48628': 'Hope,MI',
'48629': 'Houghton Lake,MI',
'48630': 'Houghton Lake Heights,MI',
'48631': 'Kawkawlin,MI',
'48632': 'Lake,MI',
'48633': 'Lake George,MI',
'48634': 'Linwood,MI',
'48635': 'Lupton,MI',
'48636': 'Luzerne,MI',
'48637': 'Merrill,MI',
'48638': 'Saginaw,MI',
'48640': 'Midland,MI',
'48641': 'Midland,MI',
'48642': 'Midland,MI',
'48647': 'Mio,MI',
'48649': 'Oakley,MI',
'48650': 'Pinconning,MI',
'48651': 'Prudenville,MI',
'48652': 'Rhodes,MI',
'48653': 'Roscommon,MI',
'48654': 'Rose City,MI',
'48655': 'Saint Charles,MI',
'48656': 'Saint Helen,MI',
'48657': 'Sanford,MI',
'48658': 'Standish,MI',
'48659': 'Sterling,MI',
'48661': 'West Branch,MI',
'48662': 'Wheeler,MI',
'48663': 'Saginaw,MI',
'48667': 'Midland,MI',
'48670': 'Midland,MI',
'48674': 'Midland,MI',
'48686': 'Midland,MI',
'48701': 'Akron,MI',
'48703': 'Au Gres,MI',
'48705': 'Barton City,MI',
'48706': 'Bay City,MI',
'48707': 'Bay City,MI',
'48708': 'Bay City,MI',
'48710': 'University Center,MI',
'48720': 'Bay Port,MI',
'48721': 'Black River,MI',
'48722': 'Bridgeport,MI',
'48723': 'Caro,MI',
'48724': 'Carrollton,MI',
'48725': 'Caseville,MI',
'48726': 'Cass City,MI',
'48727': 'Clifford,MI',
'48728': 'Curran,MI',
'48729': 'Deford,MI',
'48730': 'East Tawas,MI',
'48731': 'Elkton,MI',
'48732': 'Essexville,MI',
'48733': 'Fairgrove,MI',
'48734': 'Frankenmuth,MI',
'48735': 'Gagetown,MI',
'48736': 'Gilford,MI',
'48737': 'Glennie,MI',
'48738': 'Greenbush,MI',
'48739': 'Hale,MI',
'48740': 'Harrisville,MI',
'48741': 'Kingston,MI',
'48742': 'Lincoln,MI',
'48743': 'Long Lake,MI',
'48744': 'Mayville,MI',
'48745': 'Mikado,MI',
'48746': 'Millington,MI',
'48747': 'Munger,MI',
'48748': 'National City,MI',
'48749': 'Omer,MI',
'48750': 'Oscoda,MI',
'48754': 'Owendale,MI',
'48755': 'Pigeon,MI',
'48756': 'Prescott,MI',
'48757': 'Reese,MI',
'48758': 'Richville,MI',
'48759': 'Sebewaing,MI',
'48760': 'Silverwood,MI',
'48761': 'South Branch,MI',
'48762': 'Spruce,MI',
'48763': 'Tawas City,MI',
'48764': 'Tawas City,MI',
'48765': 'Turner,MI',
'48766': 'Twining,MI',
'48767': 'Unionville,MI',
'48768': 'Vassar,MI',
'48769': 'Tuscola,MI',
'48770': 'Whittemore,MI',
'48787': 'Frankenmuth,MI',
'48801': 'Alma,MI',
'48802': 'Alma,MI',
'48804': 'Mount Pleasant,MI',
'48805': 'Okemos,MI',
'48806': 'Ashley,MI',
'48807': 'Bannister,MI',
'48808': 'Bath,MI',
'48809': 'Belding,MI',
'48811': 'Carson City,MI',
'48812': 'Cedar Lake,MI',
'48813': 'Charlotte,MI',
'48815': 'Clarksville,MI',
'48816': 'Cohoctah,MI',
'48817': 'Corunna,MI',
'48818': 'Crystal,MI',
'48819': 'Dansville,MI',
'48820': 'Dewitt,MI',
'48821': 'Dimondale,MI',
'48822': 'Eagle,MI',
'48823': 'East Lansing,MI',
'48824': 'East Lansing,MI',
'48825': 'East Lansing,MI',
'48826': 'East Lansing,MI',
'48827': 'Eaton Rapids,MI',
'48829': 'Edmore,MI',
'48830': 'Elm Hall,MI',
'48831': 'Elsie,MI',
'48832': 'Elwell,MI',
'48833': 'Eureka,MI',
'48834': 'Fenwick,MI',
'48835': 'Fowler,MI',
'48836': 'Fowlerville,MI',
'48837': 'Grand Ledge,MI',
'48838': 'Greenville,MI',
'48840': 'Haslett,MI',
'48841': 'Henderson,MI',
'48842': 'Holt,MI',
'48843': 'Howell,MI',
'48844': 'Howell,MI',
'48845': 'Hubbardston,MI',
'48846': 'Ionia,MI',
'48847': 'Ithaca,MI',
'48848': 'Laingsburg,MI',
'48849': 'Lake Odessa,MI',
'48850': 'Lakeview,MI',
'48851': 'Lyons,MI',
'48852': 'Mcbrides,MI',
'48853': 'Maple Rapids,MI',
'48854': 'Mason,MI',
'48855': 'Howell,MI',
'48856': 'Middleton,MI',
'48857': 'Morrice,MI',
'48858': 'Mount Pleasant,MI',
'48859': 'Mount Pleasant,MI',
'48860': 'Muir,MI',
'48861': 'Mulliken,MI',
'48862': 'North Star,MI',
'48863': 'Oak Grove,MI',
'48864': 'Okemos,MI',
'48865': 'Orleans,MI',
'48866': 'Ovid,MI',
'48867': 'Owosso,MI',
'48870': 'Palo,MI',
'48871': 'Perrinton,MI',
'48872': 'Perry,MI',
'48873': 'Pewamo,MI',
'48874': 'Pompeii,MI',
'48875': 'Portland,MI',
'48876': 'Potterville,MI',
'48877': 'Riverdale,MI',
'48878': 'Rosebush,MI',
'48879': 'Saint Johns,MI',
'48880': 'Saint Louis,MI',
'48881': 'Saranac,MI',
'48882': 'Shaftsburg,MI',
'48883': 'Shepherd,MI',
'48884': 'Sheridan,MI',
'48885': 'Sidney,MI',
'48886': 'Six Lakes,MI',
'48887': 'Smyrna,MI',
'48888': 'Stanton,MI',
'48889': 'Sumner,MI',
'48890': 'Sunfield,MI',
'48891': 'Vestaburg,MI',
'48892': 'Webberville,MI',
'48893': 'Weidman,MI',
'48894': 'Westphalia,MI',
'48895': 'Williamston,MI',
'48896': 'Winn,MI',
'48897': 'Woodland,MI',
'48901': 'Lansing,MI',
'48906': 'Lansing,MI',
'48907': 'Lansing,MI',
'48908': 'Lansing,MI',
'48909': 'Lansing,MI',
'48910': 'Lansing,MI',
'48911': 'Lansing,MI',
'48912': 'Lansing,MI',
'48913': 'Lansing,MI',
'48915': 'Lansing,MI',
'48916': 'Lansing,MI',
'48917': 'Lansing,MI',
'48918': 'Lansing,MI',
'48919': 'Lansing,MI',
'48921': 'Lansing,MI',
'48922': 'Lansing,MI',
'48924': 'Lansing,MI',
'48929': 'Lansing,MI',
'48930': 'Lansing,MI',
'48933': 'Lansing,MI',
'48937': 'Lansing,MI',
'48950': 'Lansing,MI',
'48951': 'Lansing,MI',
'48956': 'Lansing,MI',
'48980': 'Lansing,MI',
'49001': 'Kalamazoo,MI',
'49002': 'Portage,MI',
'49003': 'Kalamazoo,MI',
'49004': 'Kalamazoo,MI',
'49005': 'Kalamazoo,MI',
'49006': 'Kalamazoo,MI',
'49007': 'Kalamazoo,MI',
'49008': 'Kalamazoo,MI',
'49009': 'Kalamazoo,MI',
'49010': 'Allegan,MI',
'49011': 'Athens,MI',
'49012': 'Augusta,MI',
'49013': 'Bangor,MI',
'49014': 'Battle Creek,MI',
'49015': 'Battle Creek,MI',
'49016': 'Battle Creek,MI',
'49017': 'Battle Creek,MI',
'49018': 'Battle Creek,MI',
'49019': 'Kalamazoo,MI',
'49020': 'Bedford,MI',
'49021': 'Bellevue,MI',
'49022': 'Benton Harbor,MI',
'49023': 'Benton Harbor,MI',
'49024': 'Portage,MI',
'49026': 'Bloomingdale,MI',
'49027': 'Breedsville,MI',
'49028': 'Bronson,MI',
'49029': 'Burlington,MI',
'49030': 'Burr Oak,MI',
'49031': 'Cassopolis,MI',
'49032': 'Centreville,MI',
'49033': 'Ceresco,MI',
'49034': 'Climax,MI',
'49035': 'Cloverdale,MI',
'49036': 'Coldwater,MI',
'49038': 'Coloma,MI',
'49039': 'Hagar Shores,MI',
'49040': 'Colon,MI',
'49041': 'Comstock,MI',
'49042': 'Constantine,MI',
'49043': 'Covert,MI',
'49045': 'Decatur,MI',
'49046': 'Delton,MI',
'49047': 'Dowagiac,MI',
'49048': 'Kalamazoo,MI',
'49050': 'Dowling,MI',
'49051': 'East Leroy,MI',
'49052': 'Fulton,MI',
'49053': 'Galesburg,MI',
'49055': 'Gobles,MI',
'49056': 'Grand Junction,MI',
'49057': 'Hartford,MI',
'49058': 'Hastings,MI',
'49060': 'Hickory Corners,MI',
'49061': 'Jones,MI',
'49062': 'Kendall,MI',
'49063': 'Lacota,MI',
'49064': 'Lawrence,MI',
'49065': 'Lawton,MI',
'49066': 'Leonidas,MI',
'49067': 'Marcellus,MI',
'49068': 'Marshall,MI',
'49069': 'Marshall,MI',
'49070': 'Martin,MI',
'49071': 'Mattawan,MI',
'49072': 'Mendon,MI',
'49073': 'Nashville,MI',
'49074': 'Nazareth,MI',
'49075': 'Nottawa,MI',
'49076': 'Olivet,MI',
'49077': 'Oshtemo,MI',
'49078': 'Otsego,MI',
'49079': 'Paw Paw,MI',
'49080': 'Plainwell,MI',
'49081': 'Portage,MI',
'49082': 'Quincy,MI',
'49083': 'Richland,MI',
'49084': 'Riverside,MI',
'49085': 'Saint Joseph,MI',
'49087': 'Schoolcraft,MI',
'49088': 'Scotts,MI',
'49089': 'Sherwood,MI',
'49090': 'South Haven,MI',
'49091': 'Sturgis,MI',
'49092': 'Tekonsha,MI',
'49093': 'Three Rivers,MI',
'49094': 'Union City,MI',
'49095': 'Vandalia,MI',
'49096': 'Vermontville,MI',
'49097': 'Vicksburg,MI',
'49098': 'Watervliet,MI',
'49099': 'White Pigeon,MI',
'49101': 'Baroda,MI',
'49102': 'Berrien Center,MI',
'49103': 'Berrien Springs,MI',
'49104': 'Berrien Springs,MI',
'49106': 'Bridgman,MI',
'49107': 'Buchanan,MI',
'49111': 'Eau Claire,MI',
'49112': 'Edwardsburg,MI',
'49113': 'Galien,MI',
'49115': 'Harbert,MI',
'49116': 'Lakeside,MI',
'49117': 'New Buffalo,MI',
'49119': 'New Troy,MI',
'49120': 'Niles,MI',
'49121': 'Niles,MI',
'49125': 'Sawyer,MI',
'49126': 'Sodus,MI',
'49127': 'Stevensville,MI',
'49128': 'Three Oaks,MI',
'49129': 'Union Pier,MI',
'49130': 'Union,MI',
'49201': 'Jackson,MI',
'49202': 'Jackson,MI',
'49203': 'Jackson,MI',
'49204': 'Jackson,MI',
'49220': 'Addison,MI',
'49221': 'Adrian,MI',
'49224': 'Albion,MI',
'49227': 'Allen,MI',
'49228': 'Blissfield,MI',
'49229': 'Britton,MI',
'49230': 'Brooklyn,MI',
'49232': 'Camden,MI',
'49233': 'Cement City,MI',
'49234': 'Clarklake,MI',
'49235': 'Clayton,MI',
'49236': 'Clinton,MI',
'49237': 'Concord,MI',
'49238': 'Deerfield,MI',
'49239': 'Frontier,MI',
'49240': 'Grass Lake,MI',
'49241': 'Hanover,MI',
'49242': 'Hillsdale,MI',
'49245': 'Homer,MI',
'49246': 'Horton,MI',
'49247': 'Hudson,MI',
'49248': 'Jasper,MI',
'49249': 'Jerome,MI',
'49250': 'Jonesville,MI',
'49251': 'Leslie,MI',
'49252': 'Litchfield,MI',
'49253': 'Manitou Beach,MI',
'49254': 'Michigan Center,MI',
'49255': 'Montgomery,MI',
'49256': 'Morenci,MI',
'49257': 'Moscow,MI',
'49258': 'Mosherville,MI',
'49259': 'Munith,MI',
'49261': 'Napoleon,MI',
'49262': 'North Adams,MI',
'49263': 'Norvell,MI',
'49264': 'Onondaga,MI',
'49265': 'Onsted,MI',
'49266': 'Osseo,MI',
'49267': 'Ottawa Lake,MI',
'49268': 'Palmyra,MI',
'49269': 'Parma,MI',
'49270': 'Petersburg,MI',
'49271': 'Pittsford,MI',
'49272': 'Pleasant Lake,MI',
'49274': 'Reading,MI',
'49275': 'Ridgeway,MI',
'49276': 'Riga,MI',
'49277': 'Rives Junction,MI',
'49278': 'Rollin,MI',
'49279': 'Sand Creek,MI',
'49280': 'Seneca,MI',
'49281': 'Somerset,MI',
'49282': 'Somerset Center,MI',
'49283': 'Spring Arbor,MI',
'49284': 'Springport,MI',
'49285': 'Stockbridge,MI',
'49286': 'Tecumseh,MI',
'49287': 'Tipton,MI',
'49288': 'Waldron,MI',
'49289': 'Weston,MI',
'49301': 'Ada,MI',
'49302': 'Alto,MI',
'49303': 'Bailey,MI',
'49304': 'Baldwin,MI',
'49305': 'Barryton,MI',
'49306': 'Belmont,MI',
'49307': 'Big Rapids,MI',
'49309': 'Bitely,MI',
'49310': 'Blanchard,MI',
'49311': 'Bradley,MI',
'49312': 'Brohman,MI',
'49314': 'Burnips,MI',
'49315': 'Byron Center,MI',
'49316': 'Caledonia,MI',
'49317': 'Cannonsburg,MI',
'49318': 'Casnovia,MI',
'49319': 'Cedar Springs,MI',
'49320': 'Chippewa Lake,MI',
'49321': 'Comstock Park,MI',
'49322': 'Coral,MI',
'49323': 'Dorr,MI',
'49325': 'Freeport,MI',
'49326': 'Gowen,MI',
'49327': 'Grant,MI',
'49328': 'Hopkins,MI',
'49329': 'Howard City,MI',
'49330': 'Kent City,MI',
'49331': 'Lowell,MI',
'49332': 'Mecosta,MI',
'49333': 'Middleville,MI',
'49335': 'Moline,MI',
'49336': 'Morley,MI',
'49337': 'Newaygo,MI',
'49338': 'Paris,MI',
'49339': 'Pierson,MI',
'49340': 'Remus,MI',
'49341': 'Rockford,MI',
'49342': 'Rodney,MI',
'49343': 'Sand Lake,MI',
'49344': 'Shelbyville,MI',
'49345': 'Sparta,MI',
'49346': 'Stanwood,MI',
'49347': 'Trufant,MI',
'49348': 'Wayland,MI',
'49349': 'White Cloud,MI',
'49351': 'Rockford,MI',
'49355': 'Ada,MI',
'49356': 'Ada,MI',
'49357': 'Ada,MI',
'49401': 'Allendale,MI',
'49402': 'Branch,MI',
'49403': 'Conklin,MI',
'49404': 'Coopersville,MI',
'49405': 'Custer,MI',
'49406': 'Douglas,MI',
'49408': 'Fennville,MI',
'49409': 'Ferrysburg,MI',
'49410': 'Fountain,MI',
'49411': 'Free Soil,MI',
'49412': 'Fremont,MI',
'49413': 'Fremont,MI',
'49415': 'Fruitport,MI',
'49416': 'Glenn,MI',
'49417': 'Grand Haven,MI',
'49418': 'Grandville,MI',
'49419': 'Hamilton,MI',
'49420': 'Hart,MI',
'49421': 'Hesperia,MI',
'49422': 'Holland,MI',
'49423': 'Holland,MI',
'49424': 'Holland,MI',
'49425': 'Holton,MI',
'49426': 'Hudsonville,MI',
'49427': 'Jamestown,MI',
'49428': 'Jenison,MI',
'49429': 'Jenison,MI',
'49430': 'Lamont,MI',
'49431': 'Ludington,MI',
'49434': 'Macatawa,MI',
'49435': 'Marne,MI',
'49436': 'Mears,MI',
'49437': 'Montague,MI',
'49440': 'Muskegon,MI',
'49441': 'Muskegon,MI',
'49442': 'Muskegon,MI',
'49443': 'Muskegon,MI',
'49444': 'Muskegon,MI',
'49445': 'Muskegon,MI',
'49446': 'New Era,MI',
'49448': 'Nunica,MI',
'49449': 'Pentwater,MI',
'49450': 'Pullman,MI',
'49451': 'Ravenna,MI',
'49452': 'Rothbury,MI',
'49453': 'Saugatuck,MI',
'49454': 'Scottville,MI',
'49455': 'Shelby,MI',
'49456': 'Spring Lake,MI',
'49457': 'Twin Lake,MI',
'49458': 'Walhalla,MI',
'49459': 'Walkerville,MI',
'49460': 'West Olive,MI',
'49461': 'Whitehall,MI',
'49463': 'Wabaningo,MI',
'49464': 'Zeeland,MI',
'49468': 'Grandville,MI',
'49501': 'Grand Rapids,MI',
'49502': 'Grand Rapids,MI',
'49503': 'Grand Rapids,MI',
'49504': 'Grand Rapids,MI',
'49505': 'Grand Rapids,MI',
'49506': 'Grand Rapids,MI',
'49507': 'Grand Rapids,MI',
'49508': 'Grand Rapids,MI',
'49509': 'Grand Rapids,MI',
'49510': 'Grand Rapids,MI',
'49512': 'Grand Rapids,MI',
'49514': 'Grand Rapids,MI',
'49515': 'Grand Rapids,MI',
'49516': 'Grand Rapids,MI',
'49518': 'Grand Rapids,MI',
'49519': 'Wyoming,MI',
'49523': 'Grand Rapids,MI',
'49525': 'Grand Rapids,MI',
'49528': 'Kentwood Brch,MI',
'49530': 'Grand Rapids,MI',
'49534': 'Walker,MI',
'49544': 'Grand Rapids,MI',
'49546': 'Grand Rapids,MI',
'49548': 'Grand Rapids,MI',
'49550': 'Grand Rapids,MI',
'49555': 'Grand Rapids,MI',
'49560': 'Grand Rapids,MI',
'49588': 'Grand Rapids,MI',
'49599': 'Grand Rapids,MI',
'49601': 'Cadillac,MI',
'49610': 'Acme,MI',
'49611': 'Alba,MI',
'49612': 'Alden,MI',
'49613': 'Arcadia,MI',
'49614': 'Bear Lake,MI',
'49615': 'Bellaire,MI',
'49616': 'Benzonia,MI',
'49617': 'Beulah,MI',
'49618': 'Boon,MI',
'49619': 'Brethren,MI',
'49620': 'Buckley,MI',
'49621': 'Cedar,MI',
'49622': 'Central Lake,MI',
'49623': 'Chase,MI',
'49625': 'Copemish,MI',
'49626': 'Eastlake,MI',
'49627': 'Eastport,MI',
'49628': 'Elberta,MI',
'49629': 'Elk Rapids,MI',
'49630': 'Empire,MI',
'49631': 'Evart,MI',
'49632': 'Falmouth,MI',
'49633': 'Fife Lake,MI',
'49634': 'Filer City,MI',
'49635': 'Frankfort,MI',
'49636': 'Glen Arbor,MI',
'49637': 'Grawn,MI',
'49638': 'Harrietta,MI',
'49639': 'Hersey,MI',
'49640': 'Honor,MI',
'49642': 'Idlewild,MI',
'49643': 'Interlochen,MI',
'49644': 'Irons,MI',
'49645': 'Kaleva,MI',
'49646': 'Kalkaska,MI',
'49648': 'Kewadin,MI',
'49649': 'Kingsley,MI',
'49650': 'Lake Ann,MI',
'49651': 'Lake City,MI',
'49653': 'Lake Leelanau,MI',
'49654': 'Leland,MI',
'49655': 'Leroy,MI',
'49656': 'Luther,MI',
'49657': 'Mc Bain,MI',
'49659': 'Mancelona,MI',
'49660': 'Manistee,MI',
'49663': 'Manton,MI',
'49664': 'Maple City,MI',
'49665': 'Marion,MI',
'49666': 'Mayfield,MI',
'49667': 'Merritt,MI',
'49668': 'Mesick,MI',
'49670': 'Northport,MI',
'49673': 'Old Mission,MI',
'49674': 'Omena,MI',
'49675': 'Onekama,MI',
'49676': 'Rapid City,MI',
'49677': 'Reed City,MI',
'49679': 'Sears,MI',
'49680': 'South Boardman,MI',
'49682': 'Suttons Bay,MI',
'49683': 'Thompsonville,MI',
'49684': 'Traverse City,MI',
'49685': 'Traverse City,MI',
'49686': 'Traverse City,MI',
'49688': 'Tustin,MI',
'49689': 'Wellston,MI',
'49690': 'Williamsburg,MI',
'49696': 'Traverse City,MI',
'49701': 'Mackinaw City,MI',
'49705': 'Afton,MI',
'49706': 'Alanson,MI',
'49707': 'Alpena,MI',
'49709': 'Atlanta,MI',
'49710': 'Barbeau,MI',
'49711': 'Bay Shore,MI',
'49712': 'Boyne City,MI',
'49713': 'Boyne Falls,MI',
'49715': 'Brimley,MI',
'49716': 'Brutus,MI',
'49717': 'Burt Lake,MI',
'49718': 'Carp Lake,MI',
'49719': 'Cedarville,MI',
'49720': 'Charlevoix,MI',
'49721': 'Cheboygan,MI',
'49722': 'Conway,MI',
'49723': 'Cross Village,MI',
'49724': 'Dafter,MI',
'49725': 'De Tour Village,MI',
'49726': 'Drummond Island,MI',
'49727': 'East Jordan,MI',
'49728': 'Eckerman,MI',
'49729': 'Ellsworth,MI',
'49730': 'Elmira,MI',
'49733': 'Frederic,MI',
'49734': 'Gaylord,MI',
'49735': 'Gaylord,MI',
'49736': 'Goetzville,MI',
'49737': 'Good Hart,MI',
'49738': 'Grayling,MI',
'49739': 'Grayling,MI',
'49740': 'Harbor Springs,MI',
'49743': 'Hawks,MI',
'49744': 'Herron,MI',
'49745': 'Hessel,MI',
'49746': 'Hillman,MI',
'49747': 'Hubbard Lake,MI',
'49748': 'Hulbert,MI',
'49749': 'Indian River,MI',
'49751': 'Johannesburg,MI',
'49752': 'Kinross,MI',
'49753': 'Lachine,MI',
'49755': 'Levering,MI',
'49756': 'Lewiston,MI',
'49757': 'Mackinac Island,MI',
'49759': 'Millersburg,MI',
'49760': 'Moran,MI',
'49761': 'Mullett Lake,MI',
'49762': 'Naubinway,MI',
'49764': 'Oden,MI',
'49765': 'Onaway,MI',
'49766': 'Ossineke,MI',
'49768': 'Paradise,MI',
'49769': 'Pellston,MI',
'49770': 'Petoskey,MI',
'49774': 'Pickford,MI',
'49775': 'Pointe Aux Pins,MI',
'49776': 'Posen,MI',
'49777': 'Presque Isle,MI',
'49778': 'Brimley,MI',
'49779': 'Rogers City,MI',
'49780': 'Rudyard,MI',
'49781': 'Saint Ignace,MI',
'49782': 'Beaver Island,MI',
'49783': 'Sault Sainte Marie,MI',
'49784': 'Kincheloe,MI',
'49785': 'Kincheloe,MI',
'49786': 'Kincheloe,MI',
'49788': 'Kincheloe,MI',
'49790': 'Strongs,MI',
'49791': 'Topinabee,MI',
'49792': 'Tower,MI',
'49793': 'Trout Lake,MI',
'49795': 'Vanderbilt,MI',
'49796': 'Walloon Lake,MI',
'49797': 'Waters,MI',
'49799': 'Wolverine,MI',
'49801': 'Iron Mountain,MI',
'49802': 'Kingsford,MI',
'49805': 'Allouez,MI',
'49806': 'Au Train,MI',
'49807': 'Bark River,MI',
'49808': 'Big Bay,MI',
'49812': 'Carney,MI',
'49813': 'Cedar River,MI',
'49814': 'Champion,MI',
'49815': 'Channing,MI',
'49816': 'Chatham,MI',
'49817': 'Cooks,MI',
'49818': 'Cornell,MI',
'49819': 'Arnold,MI',
'49820': 'Curtis,MI',
'49821': 'Daggett,MI',
'49822': 'Deerton,MI',
'49825': 'Eben Junction,MI',
'49826': 'Rumely,MI',
'49827': 'Engadine,MI',
'49829': 'Escanaba,MI',
'49831': 'Felch,MI',
'49833': 'Little Lake,MI',
'49834': 'Foster City,MI',
'49835': 'Garden,MI',
'49836': 'Germfask,MI',
'49837': 'Gladstone,MI',
'49838': 'Gould City,MI',
'49839': 'Grand Marais,MI',
'49840': 'Gulliver,MI',
'49841': 'Gwinn,MI',
'49845': 'Harris,MI',
'49847': 'Hermansville,MI',
'49848': 'Ingalls,MI',
'49849': 'Ishpeming,MI',
'49852': 'Loretto,MI',
'49853': 'Mc Millan,MI',
'49854': 'Manistique,MI',
'49855': 'Marquette,MI',
'49858': 'Menominee,MI',
'49861': 'Michigamme,MI',
'49862': 'Munising,MI',
'49863': 'Nadeau,MI',
'49864': 'Nahma,MI',
'49865': 'National Mine,MI',
'49866': 'Negaunee,MI',
'49868': 'Newberry,MI',
'49870': 'Norway,MI',
'49871': 'Palmer,MI',
'49872': 'Perkins,MI',
'49873': 'Perronville,MI',
'49874': 'Powers,MI',
'49876': 'Quinnesec,MI',
'49877': 'Ralph,MI',
'49878': 'Rapid River,MI',
'49879': 'Republic,MI',
'49880': 'Rock,MI',
'49881': 'Sagola,MI',
'49883': 'Seney,MI',
'49884': 'Shingleton,MI',
'49885': 'Skandia,MI',
'49886': 'Spalding,MI',
'49887': 'Stephenson,MI',
'49891': 'Trenary,MI',
'49892': 'Vulcan,MI',
'49893': 'Wallace,MI',
'49894': 'Wells,MI',
'49895': 'Wetmore,MI',
'49896': 'Wilson,MI',
'49901': 'Ahmeek,MI',
'49902': 'Alpha,MI',
'49903': 'Amasa,MI',
'49905': 'Atlantic Mine,MI',
'49908': 'Baraga,MI',
'49910': 'Bergland,MI',
'49911': 'Bessemer,MI',
'49912': 'Bruce Crossing,MI',
'49913': 'Calumet,MI',
'49915': 'Caspian,MI',
'49916': 'Chassell,MI',
'49917': 'Copper City,MI',
'49918': 'Copper Harbor,MI',
'49919': 'Covington,MI',
'49920': 'Crystal Falls,MI',
'49921': 'Dodgeville,MI',
'49922': 'Dollar Bay,MI',
'49925': 'Ewen,MI',
'49927': 'Gaastra,MI',
'49929': 'Greenland,MI',
'49930': 'Hancock,MI',
'49931': 'Houghton,MI',
'49934': 'Hubbell,MI',
'49935': 'Iron River,MI',
'49938': 'Ironwood,MI',
'49942': 'Kearsarge,MI',
'49945': 'Lake Linden,MI',
'49946': 'Lanse,MI',
'49947': 'Marenisco,MI',
'49948': 'Mass City,MI',
'49950': 'Mohawk,MI',
'49952': 'Nisula,MI',
'49953': 'Ontonagon,MI',
'49955': 'Painesdale,MI',
'49958': 'Pelkie,MI',
'49959': 'Ramsay,MI',
'49960': 'Rockland,MI',
'49961': 'Sidnaw,MI',
'49962': 'Skanee,MI',
'49963': 'South Range,MI',
'49964': 'Stambaugh,MI',
'49965': 'Toivola,MI',
'49967': 'Trout Creek,MI',
'49968': 'Wakefield,MI',
'49969': 'Watersmeet,MI',
'49970': 'Watton,MI',
'49971': 'White Pine,MI',
'50001': 'Ackworth,IA',
'50002': 'Adair,IA',
'50003': 'Adel,IA',
'50005': 'Albion,IA',
'50006': 'Alden,IA',
'50007': 'Alleman,IA',
'50008': 'Allerton,IA',
'50009': 'Altoona,IA',
'50010': 'Ames,IA',
'50011': 'Ames,IA',
'50012': 'Ames,IA',
'50013': 'Ames,IA',
'50014': 'Ames,IA',
'50015': 'Ankeny,IA',
'50020': 'Anita,IA',
'50021': 'Ankeny,IA',
'50022': 'Atlantic,IA',
'50023': 'Ankeny,IA',
'50025': 'Audubon,IA',
'50026': 'Bagley,IA',
'50027': 'Barnes City,IA',
'50028': 'Baxter,IA',
'50029': 'Bayard,IA',
'50031': 'Beaver,IA',
'50032': 'Berwick,IA',
'50033': 'Bevington,IA',
'50034': 'Blairsburg,IA',
'50035': 'Bondurant,IA',
'50036': 'Boone,IA',
'50037': 'Boone,IA',
'50038': 'Booneville,IA',
'50039': 'Bouton,IA',
'50040': 'Boxholm,IA',
'50041': 'Bradford,IA',
'50042': 'Brayton,IA',
'50043': 'Buckeye,IA',
'50044': 'Bussey,IA',
'50046': 'Cambridge,IA',
'50047': 'Carlisle,IA',
'50048': 'Casey,IA',
'50049': 'Chariton,IA',
'50050': 'Churdan,IA',
'50051': 'Clemons,IA',
'50052': 'Clio,IA',
'50054': 'Colfax,IA',
'50055': 'Collins,IA',
'50056': 'Colo,IA',
'50057': 'Columbia,IA',
'50058': 'Coon Rapids,IA',
'50059': 'Cooper,IA',
'50060': 'Corydon,IA',
'50061': 'Cumming,IA',
'50062': 'Dallas,IA',
'50063': 'Dallas Center,IA',
'50064': 'Dana,IA',
'50065': 'Davis City,IA',
'50066': 'Dawson,IA',
'50067': 'Decatur,IA',
'50068': 'Derby,IA',
'50069': 'De Soto,IA',
'50070': 'Dexter,IA',
'50071': 'Dows,IA',
'50072': 'Earlham,IA',
'50073': 'Elkhart,IA',
'50074': 'Ellston,IA',
'50075': 'Ellsworth,IA',
'50076': 'Exira,IA',
'50078': 'Ferguson,IA',
'50099': 'Boone,IA',
'50101': 'Galt,IA',
'50102': 'Garden City,IA',
'50103': 'Garden Grove,IA',
'50104': 'Gibson,IA',
'50105': 'Gilbert,IA',
'50106': 'Gilman,IA',
'50107': 'Grand Junction,IA',
'50108': 'Grand River,IA',
'50109': 'Granger,IA',
'50110': 'Gray,IA',
'50111': 'Grimes,IA',
'50112': 'Grinnell,IA',
'50115': 'Guthrie Center,IA',
'50116': 'Hamilton,IA',
'50117': 'Hamlin,IA',
'50118': 'Hartford,IA',
'50119': 'Harvey,IA',
'50120': 'Haverhill,IA',
'50122': 'Hubbard,IA',
'50123': 'Humeston,IA',
'50124': 'Huxley,IA',
'50125': 'Indianola,IA',
'50126': 'Iowa Falls,IA',
'50127': 'Ira,IA',
'50128': 'Jamaica,IA',
'50129': 'Jefferson,IA',
'50130': 'Jewell,IA',
'50131': 'Johnston,IA',
'50132': 'Kamrar,IA',
'50133': 'Kellerton,IA',
'50134': 'Kelley,IA',
'50135': 'Kellogg,IA',
'50136': 'Keswick,IA',
'50137': 'Killduff,IA',
'50138': 'Knoxville,IA',
'50139': 'Lacona,IA',
'50140': 'Lamoni,IA',
'50141': 'Laurel,IA',
'50142': 'Le Grand,IA',
'50143': 'Leighton,IA',
'50144': 'Leon,IA',
'50145': 'Liberty Center,IA',
'50146': 'Linden,IA',
'50147': 'Lineville,IA',
'50148': 'Liscomb,IA',
'50149': 'Lorimor,IA',
'50150': 'Lovilia,IA',
'50151': 'Lucas,IA',
'50152': 'Luther,IA',
'50153': 'Lynnville,IA',
'50154': 'Mc Callsburg,IA',
'50155': 'Macksburg,IA',
'50156': 'Madrid,IA',
'50157': 'Malcom,IA',
'50158': 'Marshalltown,IA',
'50160': 'Martensdale,IA',
'50161': 'Maxwell,IA',
'50162': 'Melbourne,IA',
'50163': 'Melcher,IA',
'50164': 'Menlo,IA',
'50165': 'Millerton,IA',
'50166': 'Milo,IA',
'50167': 'Minburn,IA',
'50168': 'Mingo,IA',
'50169': 'Mitchellville,IA',
'50170': 'Monroe,IA',
'50171': 'Montezuma,IA',
'50173': 'Montour,IA',
'50174': 'Murray,IA',
'50177': 'Grinnell,IA',
'50197': 'Knoxville,IA',
'50198': 'Knoxville,IA',
'50201': 'Nevada,IA',
'50206': 'New Providence,IA',
'50207': 'New Sharon,IA',
'50208': 'Newton,IA',
'50210': 'New Virginia,IA',
'50211': 'Norwalk,IA',
'50212': 'Ogden,IA',
'50213': 'Osceola,IA',
'50214': 'Otley,IA',
'50216': 'Panora,IA',
'50217': 'Paton,IA',
'50218': 'Patterson,IA',
'50219': 'Pella,IA',
'50220': 'Perry,IA',
'50222': 'Peru,IA',
'50223': 'Pilot Mound,IA',
'50225': 'Pleasantville,IA',
'50226': 'Polk City,IA',
'50227': 'Popejoy,IA',
'50228': 'Prairie City,IA',
'50229': 'Prole,IA',
'50230': 'Radcliffe,IA',
'50231': 'Randall,IA',
'50232': 'Reasnor,IA',
'50233': 'Redfield,IA',
'50234': 'Rhodes,IA',
'50235': 'Rippey,IA',
'50236': 'Roland,IA',
'50237': 'Runnells,IA',
'50238': 'Russell,IA',
'50239': 'Saint Anthony,IA',
'50240': 'Saint Charles,IA',
'50241': 'Saint Marys,IA',
'50242': 'Searsboro,IA',
'50243': 'Sheldahl,IA',
'50244': 'Slater,IA',
'50246': 'Stanhope,IA',
'50247': 'State Center,IA',
'50248': 'Story City,IA',
'50249': 'Stratford,IA',
'50250': 'Stuart,IA',
'50251': 'Sully,IA',
'50252': 'Swan,IA',
'50254': 'Thayer,IA',
'50255': 'Thornburg,IA',
'50256': 'Tracy,IA',
'50257': 'Truro,IA',
'50258': 'Union,IA',
'50259': 'Gifford,IA',
'50261': 'Van Meter,IA',
'50262': 'Van Wert,IA',
'50263': 'Waukee,IA',
'50264': 'Weldon,IA',
'50265': 'West Des Moines,IA',
'50266': 'West Des Moines,IA',
'50268': 'What Cheer,IA',
'50269': 'Whitten,IA',
'50271': 'Williams,IA',
'50272': 'Williamson,IA',
'50273': 'Winterset,IA',
'50274': 'Wiota,IA',
'50275': 'Woodburn,IA',
'50276': 'Woodward,IA',
'50277': 'Yale,IA',
'50278': 'Zearing,IA',
'50301': 'Des Moines,IA',
'50302': 'Des Moines,IA',
'50303': 'Des Moines,IA',
'50304': 'Des Moines,IA',
'50305': 'Des Moines,IA',
'50306': 'Des Moines,IA',
'50307': 'Des Moines,IA',
'50308': 'Des Moines,IA',
'50309': 'Des Moines,IA',
'50310': 'Des Moines,IA',
'50311': 'Des Moines,IA',
'50312': 'Des Moines,IA',
'50313': 'Des Moines,IA',
'50314': 'Des Moines,IA',
'50315': 'Des Moines,IA',
'50316': 'Des Moines,IA',
'50317': 'Des Moines,IA',
'50318': 'Des Moines,IA',
'50319': 'Des Moines,IA',
'50320': 'Des Moines,IA',
'50321': 'Des Moines,IA',
'50322': 'Urbandale,IA',
'50323': 'Urbandale,IA',
'50324': 'Windsor Hts,IA',
'50325': 'Clive,IA',
'50327': 'Des Moines,IA',
'50328': 'Des Moines,IA',
'50329': 'Des Moines,IA',
'50330': 'Des Moines,IA',
'50331': 'Des Moines,IA',
'50332': 'Des Moines,IA',
'50333': 'Des Moines,IA',
'50334': 'Des Moines,IA',
'50335': 'Des Moines,IA',
'50336': 'Des Moines,IA',
'50338': 'Des Moines,IA',
'50339': 'Des Moines,IA',
'50340': 'Des Moines,IA',
'50347': 'Des Moines,IA',
'50350': 'Des Moines,IA',
'50359': 'Des Moines,IA',
'50360': 'Des Moines,IA',
'50361': 'Des Moines,IA',
'50362': 'Des Moines,IA',
'50363': 'Des Moines,IA',
'50364': 'Des Moines,IA',
'50367': 'Des Moines,IA',
'50368': 'Des Moines,IA',
'50369': 'Des Moines,IA',
'50380': 'Des Moines,IA',
'50381': 'Des Moines,IA',
'50391': 'Des Moines,IA',
'50392': 'Des Moines,IA',
'50393': 'Des Moines,IA',
'50394': 'Des Moines,IA',
'50395': 'Des Moines,IA',
'50396': 'Des Moines,IA',
'50397': 'Des Moines,IA',
'50398': 'West Des Moines,IA',
'50401': 'Mason City,IA',
'50402': 'Mason City,IA',
'50420': 'Alexander,IA',
'50421': 'Belmond,IA',
'50423': 'Britt,IA',
'50424': 'Buffalo Center,IA',
'50426': 'Carpenter,IA',
'50427': 'Chapin,IA',
'50428': 'Clear Lake,IA',
'50430': 'Corwith,IA',
'50431': 'Coulter,IA',
'50432': 'Crystal Lake,IA',
'50433': 'Dougherty,IA',
'50434': 'Fertile,IA',
'50435': 'Floyd,IA',
'50436': 'Forest City,IA',
'50438': 'Garner,IA',
'50439': 'Goodell,IA',
'50440': 'Grafton,IA',
'50441': 'Hampton,IA',
'50444': 'Hanlontown,IA',
'50446': 'Joice,IA',
'50447': 'Kanawha,IA',
'50448': 'Kensett,IA',
'50449': 'Klemme,IA',
'50450': 'Lake Mills,IA',
'50451': 'Lakota,IA',
'50452': 'Latimer,IA',
'50453': 'Leland,IA',
'50454': 'Little Cedar,IA',
'50455': 'Mc Intire,IA',
'50456': 'Manly,IA',
'50457': 'Meservey,IA',
'50458': 'Nora Springs,IA',
'50459': 'Northwood,IA',
'50460': 'Orchard,IA',
'50461': 'Osage,IA',
'50464': 'Plymouth,IA',
'50465': 'Rake,IA',
'50466': 'Riceville,IA',
'50467': 'Rock Falls,IA',
'50468': 'Rockford,IA',
'50469': 'Rockwell,IA',
'50470': 'Rowan,IA',
'50471': 'Rudd,IA',
'50472': 'Saint Ansgar,IA',
'50473': 'Scarville,IA',
'50475': 'Sheffield,IA',
'50476': 'Stacyville,IA',
'50477': 'Swaledale,IA',
'50478': 'Thompson,IA',
'50479': 'Thornton,IA',
'50480': 'Titonka,IA',
'50481': 'Toeterville,IA',
'50482': 'Ventura,IA',
'50483': 'Wesley,IA',
'50484': 'Woden,IA',
'50501': 'Fort Dodge,IA',
'50510': 'Albert City,IA',
'50511': 'Algona,IA',
'50514': 'Armstrong,IA',
'50515': 'Ayrshire,IA',
'50516': 'Badger,IA',
'50517': 'Bancroft,IA',
'50518': 'Barnum,IA',
'50519': 'Bode,IA',
'50520': 'Bradgate,IA',
'50521': 'Burnside,IA',
'50522': 'Burt,IA',
'50523': 'Callender,IA',
'50524': 'Clare,IA',
'50525': 'Clarion,IA',
'50526': 'Clarion,IA',
'50527': 'Curlew,IA',
'50528': 'Cylinder,IA',
'50529': 'Dakota City,IA',
'50530': 'Dayton,IA',
'50531': 'Dolliver,IA',
'50532': 'Duncombe,IA',
'50533': 'Eagle Grove,IA',
'50535': 'Early,IA',
'50536': 'Emmetsburg,IA',
'50538': 'Farnhamville,IA',
'50539': 'Fenton,IA',
'50540': 'Fonda,IA',
'50541': 'Gilmore City,IA',
'50542': 'Goldfield,IA',
'50543': 'Gowrie,IA',
'50544': 'Harcourt,IA',
'50545': 'Hardy,IA',
'50546': 'Havelock,IA',
'50548': 'Humboldt,IA',
'50551': 'Jolley,IA',
'50552': 'Knierim,IA',
'50554': 'Laurens,IA',
'50556': 'Ledyard,IA',
'50557': 'Lehigh,IA',
'50558': 'Livermore,IA',
'50559': 'Lone Rock,IA',
'50560': 'Lu Verne,IA',
'50561': 'Lytton,IA',
'50562': 'Mallard,IA',
'50563': 'Manson,IA',
'50565': 'Marathon,IA',
'50566': 'Moorland,IA',
'50567': 'Nemaha,IA',
'50568': 'Newell,IA',
'50569': 'Otho,IA',
'50570': 'Ottosen,IA',
'50571': 'Palmer,IA',
'50573': 'Plover,IA',
'50574': 'Pocahontas,IA',
'50575': 'Pomeroy,IA',
'50576': 'Rembrandt,IA',
'50577': 'Renwick,IA',
'50578': 'Ringsted,IA',
'50579': 'Rockwell City,IA',
'50581': 'Rolfe,IA',
'50582': 'Rutland,IA',
'50583': 'Sac City,IA',
'50585': 'Sioux Rapids,IA',
'50586': 'Somers,IA',
'50588': 'Storm Lake,IA',
'50590': 'Swea City,IA',
'50591': 'Thor,IA',
'50592': 'Truesdale,IA',
'50593': 'Varina,IA',
'50594': 'Vincent,IA',
'50595': 'Webster City,IA',
'50597': 'West Bend,IA',
'50598': 'Whittemore,IA',
'50599': 'Woolstock,IA',
'50601': 'Ackley,IA',
'50602': 'Allison,IA',
'50603': 'Alta Vista,IA',
'50604': 'Aplington,IA',
'50605': 'Aredale,IA',
'50606': 'Arlington,IA',
'50607': 'Aurora,IA',
'50608': 'Austinville,IA',
'50609': 'Beaman,IA',
'50611': 'Bristow,IA',
'50612': 'Buckingham,IA',
'50613': 'Cedar Falls,IA',
'50614': 'Cedar Falls,IA',
'50616': 'Charles City,IA',
'50619': 'Clarksville,IA',
'50620': 'Colwell,IA',
'50621': 'Conrad,IA',
'50622': 'Denver,IA',
'50623': 'Dewar,IA',
'50624': 'Dike,IA',
'50625': 'Dumont,IA',
'50626': 'Dunkerton,IA',
'50627': 'Eldora,IA',
'50628': 'Elma,IA',
'50629': 'Fairbank,IA',
'50630': 'Fredericksburg,IA',
'50631': 'Frederika,IA',
'50632': 'Garwin,IA',
'50633': 'Geneva,IA',
'50634': 'Gilbertville,IA',
'50635': 'Gladbrook,IA',
'50636': 'Greene,IA',
'50638': 'Grundy Center,IA',
'50641': 'Hazleton,IA',
'50642': 'Holland,IA',
'50643': 'Hudson,IA',
'50644': 'Independence,IA',
'50645': 'Ionia,IA',
'50647': 'Janesville,IA',
'50648': 'Jesup,IA',
'50649': 'Kesley,IA',
'50650': 'Lamont,IA',
'50651': 'La Porte City,IA',
'50652': 'Lincoln,IA',
'50653': 'Marble Rock,IA',
'50654': 'Masonville,IA',
'50655': 'Maynard,IA',
'50657': 'Morrison,IA',
'50658': 'Nashua,IA',
'50659': 'New Hampton,IA',
'50660': 'New Hartford,IA',
'50661': 'North Washington,IA',
'50662': 'Oelwein,IA',
'50664': 'Oran,IA',
'50665': 'Parkersburg,IA',
'50666': 'Plainfield,IA',
'50667': 'Raymond,IA',
'50668': 'Readlyn,IA',
'50669': 'Reinbeck,IA',
'50670': 'Shell Rock,IA',
'50671': 'Stanley,IA',
'50672': 'Steamboat Rock,IA',
'50673': 'Stout,IA',
'50674': 'Sumner,IA',
'50675': 'Traer,IA',
'50676': 'Tripoli,IA',
'50677': 'Waverly,IA',
'50680': 'Wellsburg,IA',
'50681': 'Westgate,IA',
'50682': 'Winthrop,IA',
'50701': 'Waterloo,IA',
'50702': 'Waterloo,IA',
'50703': 'Waterloo,IA',
'50704': 'Waterloo,IA',
'50706': 'Waterloo,IA',
'50707': 'Evansdale,IA',
'50799': 'Waterloo,IA',
'50801': 'Creston,IA',
'50830': 'Afton,IA',
'50831': 'Arispe,IA',
'50833': 'Bedford,IA',
'50835': 'Benton,IA',
'50836': 'Blockton,IA',
'50837': 'Bridgewater,IA',
'50839': 'Carbon,IA',
'50840': 'Clearfield,IA',
'50841': 'Corning,IA',
'50842': 'Cromwell,IA',
'50843': 'Cumberland,IA',
'50845': 'Diagonal,IA',
'50846': 'Fontanelle,IA',
'50847': 'Grant,IA',
'50848': 'Gravity,IA',
'50849': 'Greenfield,IA',
'50851': 'Lenox,IA',
'50853': 'Massena,IA',
'50854': 'Mount Ayr,IA',
'50857': 'Nodaway,IA',
'50858': 'Orient,IA',
'50859': 'Prescott,IA',
'50860': 'Redding,IA',
'50861': 'Shannon City,IA',
'50862': 'Sharpsburg,IA',
'50863': 'Tingley,IA',
'50864': 'Villisca,IA',
'50936': 'Des Moines,IA',
'50940': 'Des Moines,IA',
'50947': 'Des Moines,IA',
'50950': 'Des Moines,IA',
'50980': 'Des Moines,IA',
'50981': 'Des Moines,IA',
'50982': 'Hp Enterprise Services,IA',
'50983': 'Des Moines,IA',
'51001': 'Akron,IA',
'51002': 'Alta,IA',
'51003': 'Alton,IA',
'51004': 'Anthon,IA',
'51005': 'Aurelia,IA',
'51006': 'Battle Creek,IA',
'51007': 'Bronson,IA',
'51008': 'Brunsville,IA',
'51009': 'Calumet,IA',
'51010': 'Castana,IA',
'51011': 'Chatsworth,IA',
'51012': 'Cherokee,IA',
'51014': 'Cleghorn,IA',
'51015': 'Climbing Hill,IA',
'51016': 'Correctionville,IA',
'51017': 'Craig,IA',
'51018': 'Cushing,IA',
'51019': 'Danbury,IA',
'51020': 'Galva,IA',
'51022': 'Granville,IA',
'51023': 'Hawarden,IA',
'51024': 'Hinton,IA',
'51025': 'Holstein,IA',
'51026': 'Hornick,IA',
'51027': 'Ireton,IA',
'51028': 'Kingsley,IA',
'51029': 'Larrabee,IA',
'51030': 'Lawton,IA',
'51031': 'Le Mars,IA',
'51033': 'Linn Grove,IA',
'51034': 'Mapleton,IA',
'51035': 'Marcus,IA',
'51036': 'Maurice,IA',
'51037': 'Meriden,IA',
'51038': 'Merrill,IA',
'51039': 'Moville,IA',
'51040': 'Onawa,IA',
'51041': 'Orange City,IA',
'51044': 'Oto,IA',
'51045': 'Oyens,IA',
'51046': 'Paullina,IA',
'51047': 'Peterson,IA',
'51048': 'Pierson,IA',
'51049': 'Quimby,IA',
'51050': 'Remsen,IA',
'51051': 'Rodney,IA',
'51052': 'Salix,IA',
'51053': 'Schaller,IA',
'51054': 'Sergeant Bluff,IA',
'51055': 'Sloan,IA',
'51056': 'Smithland,IA',
'51058': 'Sutherland,IA',
'51059': 'Turin,IA',
'51060': 'Ute,IA',
'51061': 'Washta,IA',
'51062': 'Westfield,IA',
'51063': 'Whiting,IA',
'51101': 'Sioux City,IA',
'51102': 'Sioux City,IA',
'51103': 'Sioux City,IA',
'51104': 'Sioux City,IA',
'51105': 'Sioux City,IA',
'51106': 'Sioux City,IA',
'51108': 'Sioux City,IA',
'51109': 'Sioux City,IA',
'51111': 'Sioux City,IA',
'51201': 'Sheldon,IA',
'51230': 'Alvord,IA',
'51231': 'Archer,IA',
'51232': 'Ashton,IA',
'51234': 'Boyden,IA',
'51235': 'Doon,IA',
'51237': 'George,IA',
'51238': 'Hospers,IA',
'51239': 'Hull,IA',
'51240': 'Inwood,IA',
'51241': 'Larchwood,IA',
'51242': 'Lester,IA',
'51243': 'Little Rock,IA',
'51244': 'Matlock,IA',
'51245': 'Primghar,IA',
'51246': 'Rock Rapids,IA',
'51247': 'Rock Valley,IA',
'51248': 'Sanborn,IA',
'51249': 'Sibley,IA',
'51250': 'Sioux Center,IA',
'51301': 'Spencer,IA',
'51330': 'Allendorf,IA',
'51331': 'Arnolds Park,IA',
'51333': 'Dickens,IA',
'51334': 'Estherville,IA',
'51338': 'Everly,IA',
'51340': 'Fostoria,IA',
'51341': 'Gillett Grove,IA',
'51342': 'Graettinger,IA',
'51343': 'Greenville,IA',
'51344': 'Gruver,IA',
'51345': 'Harris,IA',
'51346': 'Hartley,IA',
'51347': 'Lake Park,IA',
'51349': 'May City,IA',
'51350': 'Melvin,IA',
'51351': 'Milford,IA',
'51354': 'Ocheyedan,IA',
'51355': 'Okoboji,IA',
'51357': 'Royal,IA',
'51358': 'Ruthven,IA',
'51360': 'Spirit Lake,IA',
'51363': 'Superior,IA',
'51364': 'Terril,IA',
'51365': 'Wallingford,IA',
'51366': 'Webb,IA',
'51401': 'Carroll,IA',
'51430': 'Arcadia,IA',
'51431': 'Arthur,IA',
'51432': 'Aspinwall,IA',
'51433': 'Auburn,IA',
'51436': 'Breda,IA',
'51439': 'Charter Oak,IA',
'51440': 'Dedham,IA',
'51441': 'Deloit,IA',
'51442': 'Denison,IA',
'51443': 'Glidden,IA',
'51444': 'Halbur,IA',
'51445': 'Ida Grove,IA',
'51446': 'Irwin,IA',
'51447': 'Kirkman,IA',
'51448': 'Kiron,IA',
'51449': 'Lake City,IA',
'51450': 'Lake View,IA',
'51451': 'Lanesboro,IA',
'51452': 'Lidderdale,IA',
'51453': 'Lohrville,IA',
'51454': 'Manilla,IA',
'51455': 'Manning,IA',
'51458': 'Odebolt,IA',
'51459': 'Ralston,IA',
'51460': 'Ricketts,IA',
'51461': 'Schleswig,IA',
'51462': 'Scranton,IA',
'51463': 'Templeton,IA',
'51465': 'Vail,IA',
'51466': 'Wall Lake,IA',
'51467': 'Westside,IA',
'51501': 'Council Bluffs,IA',
'51502': 'Council Bluffs,IA',
'51503': 'Council Bluffs,IA',
'51510': 'Carter Lake,IA',
'51520': 'Arion,IA',
'51521': 'Avoca,IA',
'51523': 'Blencoe,IA',
'51525': 'Carson,IA',
'51526': 'Crescent,IA',
'51527': 'Defiance,IA',
'51528': 'Dow City,IA',
'51529': 'Dunlap,IA',
'51530': 'Earling,IA',
'51531': 'Elk Horn,IA',
'51532': 'Elliott,IA',
'51533': 'Emerson,IA',
'51534': 'Glenwood,IA',
'51535': 'Griswold,IA',
'51536': 'Hancock,IA',
'51537': 'Harlan,IA',
'51540': 'Hastings,IA',
'51541': 'Henderson,IA',
'51542': 'Honey Creek,IA',
'51543': 'Kimballton,IA',
'51544': 'Lewis,IA',
'51545': 'Little Sioux,IA',
'51546': 'Logan,IA',
'51548': 'Mc Clelland,IA',
'51549': 'Macedonia,IA',
'51550': 'Magnolia,IA',
'51551': 'Malvern,IA',
'51552': 'Marne,IA',
'51553': 'Minden,IA',
'51554': 'Mineola,IA',
'51555': 'Missouri Valley,IA',
'51556': 'Modale,IA',
'51557': 'Mondamin,IA',
'51558': 'Moorhead,IA',
'51559': 'Neola,IA',
'51560': 'Oakland,IA',
'51561': 'Pacific Junction,IA',
'51562': 'Panama,IA',
'51563': 'Persia,IA',
'51564': 'Pisgah,IA',
'51565': 'Portsmouth,IA',
'51566': 'Red Oak,IA',
'51570': 'Shelby,IA',
'51571': 'Silver City,IA',
'51572': 'Soldier,IA',
'51573': 'Stanton,IA',
'51574': 'Tennant,IA',
'51575': 'Treynor,IA',
'51576': 'Underwood,IA',
'51577': 'Walnut,IA',
'51578': 'Westphalia,IA',
'51579': 'Woodbine,IA',
'51591': 'Red Oak,IA',
'51593': 'Harlan,IA',
'51601': 'Shenandoah,IA',
'51602': 'Shenandoah,IA',
'51603': 'Shenandoah,IA',
'51630': 'Blanchard,IA',
'51631': 'Braddyville,IA',
'51632': 'Clarinda,IA',
'51636': 'Coin,IA',
'51637': 'College Springs,IA',
'51638': 'Essex,IA',
'51639': 'Farragut,IA',
'51640': 'Hamburg,IA',
'51645': 'Imogene,IA',
'51646': 'New Market,IA',
'51647': 'Northboro,IA',
'51648': 'Percival,IA',
'51649': 'Randolph,IA',
'51650': 'Riverton,IA',
'51651': 'Shambaugh,IA',
'51652': 'Sidney,IA',
'51653': 'Tabor,IA',
'51654': 'Thurman,IA',
'51656': 'Yorktown,IA',
'52001': 'Dubuque,IA',
'52002': 'Dubuque,IA',
'52003': 'Dubuque,IA',
'52004': 'Dubuque,IA',
'52030': 'Andrew,IA',
'52031': 'Bellevue,IA',
'52032': 'Bernard,IA',
'52033': 'Cascade,IA',
'52035': 'Colesburg,IA',
'52036': 'Delaware,IA',
'52037': 'Delmar,IA',
'52038': 'Dundee,IA',
'52039': 'Durango,IA',
'52040': 'Dyersville,IA',
'52041': 'Earlville,IA',
'52042': 'Edgewood,IA',
'52043': 'Elkader,IA',
'52044': 'Elkport,IA',
'52045': 'Epworth,IA',
'52046': 'Farley,IA',
'52047': 'Farmersburg,IA',
'52048': 'Garber,IA',
'52049': 'Garnavillo,IA',
'52050': 'Greeley,IA',
'52052': 'Guttenberg,IA',
'52053': 'Holy Cross,IA',
'52054': 'La Motte,IA',
'52055': 'Littleport,IA',
'52056': 'Luxemburg,IA',
'52057': 'Manchester,IA',
'52060': 'Maquoketa,IA',
'52064': 'Miles,IA',
'52065': 'New Vienna,IA',
'52066': 'North Buena Vista,IA',
'52068': 'Peosta,IA',
'52069': 'Preston,IA',
'52070': 'Sabula,IA',
'52071': 'Saint Donatus,IA',
'52072': 'Saint Olaf,IA',
'52073': 'Sherrill,IA',
'52074': 'Spragueville,IA',
'52075': 'Springbrook,IA',
'52076': 'Strawberry Point,IA',
'52077': 'Volga,IA',
'52078': 'Worthington,IA',
'52079': 'Zwingle,IA',
'52099': 'Dubuque,IA',
'52101': 'Decorah,IA',
'52132': 'Calmar,IA',
'52133': 'Castalia,IA',
'52134': 'Chester,IA',
'52135': 'Clermont,IA',
'52136': 'Cresco,IA',
'52140': 'Dorchester,IA',
'52141': 'Elgin,IA',
'52142': 'Fayette,IA',
'52144': 'Fort Atkinson,IA',
'52146': 'Harpers Ferry,IA',
'52147': 'Hawkeye,IA',
'52149': 'Highlandville,IA',
'52151': 'Lansing,IA',
'52154': 'Lawler,IA',
'52155': 'Lime Springs,IA',
'52156': 'Luana,IA',
'52157': 'Mc Gregor,IA',
'52158': 'Marquette,IA',
'52159': 'Monona,IA',
'52160': 'New Albin,IA',
'52161': 'Ossian,IA',
'52162': 'Postville,IA',
'52163': 'Protivin,IA',
'52164': 'Randalia,IA',
'52165': 'Ridgeway,IA',
'52166': 'Saint Lucas,IA',
'52168': 'Spillville,IA',
'52169': 'Wadena,IA',
'52170': 'Waterville,IA',
'52171': 'Waucoma,IA',
'52172': 'Waukon,IA',
'52175': 'West Union,IA',
'52201': 'Ainsworth,IA',
'52202': 'Alburnett,IA',
'52203': 'Amana,IA',
'52204': 'Amana,IA',
'52205': 'Anamosa,IA',
'52206': 'Atkins,IA',
'52207': 'Baldwin,IA',
'52208': 'Belle Plaine,IA',
'52209': 'Blairstown,IA',
'52210': 'Brandon,IA',
'52211': 'Brooklyn,IA',
'52212': 'Center Junction,IA',
'52213': 'Center Point,IA',
'52214': 'Central City,IA',
'52215': 'Chelsea,IA',
'52216': 'Clarence,IA',
'52217': 'Clutier,IA',
'52218': 'Coggon,IA',
'52219': 'Prairieburg,IA',
'52220': 'Conroy,IA',
'52221': 'Guernsey,IA',
'52222': 'Deep River,IA',
'52223': 'Delhi,IA',
'52224': 'Dysart,IA',
'52225': 'Elberon,IA',
'52226': 'Elwood,IA',
'52227': 'Ely,IA',
'52228': 'Fairfax,IA',
'52229': 'Garrison,IA',
'52231': 'Harper,IA',
'52232': 'Hartwick,IA',
'52233': 'Hiawatha,IA',
'52235': 'Hills,IA',
'52236': 'Homestead,IA',
'52237': 'Hopkinton,IA',
'52240': 'Iowa City,IA',
'52241': 'Coralville,IA',
'52242': 'Iowa City,IA',
'52243': 'Iowa City,IA',
'52244': 'Iowa City,IA',
'52245': 'Iowa City,IA',
'52246': 'Iowa City,IA',
'52247': 'Kalona,IA',
'52248': 'Keota,IA',
'52249': 'Keystone,IA',
'52251': 'Ladora,IA',
'52252': 'Langworthy,IA',
'52253': 'Lisbon,IA',
'52254': 'Lost Nation,IA',
'52255': 'Lowden,IA',
'52257': 'Luzerne,IA',
'52301': 'Marengo,IA',
'52302': 'Marion,IA',
'52305': 'Martelle,IA',
'52306': 'Mechanicsville,IA',
'52307': 'Middle Amana,IA',
'52308': 'Millersburg,IA',
'52309': 'Monmouth,IA',
'52310': 'Monticello,IA',
'52312': 'Morley,IA',
'52313': 'Mount Auburn,IA',
'52314': 'Mount Vernon,IA',
'52315': 'Newhall,IA',
'52316': 'North English,IA',
'52317': 'North Liberty,IA',
'52318': 'Norway,IA',
'52319': 'Oakdale,IA',
'52320': 'Olin,IA',
'52321': 'Onslow,IA',
'52322': 'Oxford,IA',
'52323': 'Oxford Junction,IA',
'52324': 'Palo,IA',
'52325': 'Parnell,IA',
'52326': 'Quasqueton,IA',
'52327': 'Riverside,IA',
'52328': 'Robins,IA',
'52329': 'Rowley,IA',
'52330': 'Ryan,IA',
'52332': 'Shellsburg,IA',
'52333': 'Solon,IA',
'52334': 'South Amana,IA',
'52335': 'South English,IA',
'52336': 'Springville,IA',
'52337': 'Stanwood,IA',
'52338': 'Swisher,IA',
'52339': 'Tama,IA',
'52340': 'Tiffin,IA',
'52341': 'Toddville,IA',
'52342': 'Toledo,IA',
'52344': 'Troy Mills,IA',
'52345': 'Urbana,IA',
'52346': 'Van Horne,IA',
'52347': 'Victor,IA',
'52348': 'Vining,IA',
'52349': 'Vinton,IA',
'52350': 'Viola,IA',
'52351': 'Walford,IA',
'52352': 'Walker,IA',
'52353': 'Washington,IA',
'52354': 'Watkins,IA',
'52355': 'Webster,IA',
'52356': 'Wellman,IA',
'52358': 'West Branch,IA',
'52359': 'West Chester,IA',
'52361': 'Williamsburg,IA',
'52362': 'Wyoming,IA',
'52401': 'Cedar Rapids,IA',
'52402': 'Cedar Rapids,IA',
'52403': 'Cedar Rapids,IA',
'52404': 'Cedar Rapids,IA',
'52405': 'Cedar Rapids,IA',
'52406': 'Cedar Rapids,IA',
'52407': 'Cedar Rapids,IA',
'52408': 'Cedar Rapids,IA',
'52409': 'Cedar Rapids,IA',
'52410': 'Cedar Rapids,IA',
'52411': 'Cedar Rapids,IA',
'52497': 'Cedar Rapids,IA',
'52498': 'Cedar Rapids,IA',
'52499': 'Cedar Rapids,IA',
'52501': 'Ottumwa,IA',
'52530': 'Agency,IA',
'52531': 'Albia,IA',
'52533': 'Batavia,IA',
'52534': 'Beacon,IA',
'52535': 'Birmingham,IA',
'52536': 'Blakesburg,IA',
'52537': 'Bloomfield,IA',
'52538': 'West Grove,IA',
'52540': 'Brighton,IA',
'52542': 'Cantril,IA',
'52543': 'Cedar,IA',
'52544': 'Centerville,IA',
'52548': 'Chillicothe,IA',
'52549': 'Cincinnati,IA',
'52550': 'Delta,IA',
'52551': 'Douds,IA',
'52552': 'Drakesville,IA',
'52553': 'Eddyville,IA',
'52554': 'Eldon,IA',
'52555': 'Exline,IA',
'52556': 'Fairfield,IA',
'52557': 'Fairfield,IA',
'52560': 'Floris,IA',
'52561': 'Fremont,IA',
'52562': 'Hayesville,IA',
'52563': 'Hedrick,IA',
'52565': 'Keosauqua,IA',
'52566': 'Kirkville,IA',
'52567': 'Libertyville,IA',
'52568': 'Martinsburg,IA',
'52569': 'Melrose,IA',
'52570': 'Milton,IA',
'52571': 'Moravia,IA',
'52572': 'Moulton,IA',
'52573': 'Mount Sterling,IA',
'52574': 'Mystic,IA',
'52576': 'Ollie,IA',
'52577': 'Oskaloosa,IA',
'52580': 'Packwood,IA',
'52581': 'Plano,IA',
'52583': 'Promise City,IA',
'52584': 'Pulaski,IA',
'52585': 'Richland,IA',
'52586': 'Rose Hill,IA',
'52588': 'Selma,IA',
'52590': 'Seymour,IA',
'52591': 'Sigourney,IA',
'52593': 'Udell,IA',
'52594': 'Unionville,IA',
'52595': 'University Park,IA',
'52601': 'Burlington,IA',
'52619': 'Argyle,IA',
'52620': 'Bonaparte,IA',
'52621': 'Crawfordsville,IA',
'52623': 'Danville,IA',
'52624': 'Denmark,IA',
'52625': 'Donnellson,IA',
'52626': 'Farmington,IA',
'52627': 'Fort Madison,IA',
'52630': 'Hillsboro,IA',
'52631': 'Houghton,IA',
'52632': 'Keokuk,IA',
'52635': 'Lockridge,IA',
'52637': 'Mediapolis,IA',
'52638': 'Middletown,IA',
'52639': 'Montrose,IA',
'52640': 'Morning Sun,IA',
'52641': 'Mount Pleasant,IA',
'52642': 'Rome,IA',
'52644': 'Mount Union,IA',
'52645': 'New London,IA',
'52646': 'Oakville,IA',
'52647': 'Olds,IA',
'52648': 'Pilot Grove,IA',
'52649': 'Salem,IA',
'52650': 'Sperry,IA',
'52651': 'Stockport,IA',
'52652': 'Swedesburg,IA',
'52653': 'Wapello,IA',
'52654': 'Wayland,IA',
'52655': 'West Burlington,IA',
'52656': 'West Point,IA',
'52657': 'Saint Paul,IA',
'52658': 'Wever,IA',
'52659': 'Winfield,IA',
'52660': 'Yarmouth,IA',
'52701': 'Andover,IA',
'52720': 'Atalissa,IA',
'52721': 'Bennett,IA',
'52722': 'Bettendorf,IA',
'52726': 'Blue Grass,IA',
'52727': 'Bryant,IA',
'52728': 'Buffalo,IA',
'52729': 'Calamus,IA',
'52730': 'Camanche,IA',
'52731': 'Charlotte,IA',
'52732': 'Clinton,IA',
'52733': 'Clinton,IA',
'52734': 'Seventh Avenue,IA',
'52736': 'Clinton,IA',
'52737': 'Columbus City,IA',
'52738': 'Columbus Junction,IA',
'52739': 'Conesville,IA',
'52742': 'De Witt,IA',
'52745': 'Dixon,IA',
'52746': 'Donahue,IA',
'52747': 'Durant,IA',
'52748': 'Eldridge,IA',
'52749': 'Fruitland,IA',
'52750': 'Goose Lake,IA',
'52751': 'Grand Mound,IA',
'52752': 'Grandview,IA',
'52753': 'Le Claire,IA',
'52754': 'Letts,IA',
'52755': 'Lone Tree,IA',
'52756': 'Long Grove,IA',
'52757': 'Low Moor,IA',
'52758': 'Mc Causland,IA',
'52759': 'Montpelier,IA',
'52760': 'Moscow,IA',
'52761': 'Muscatine,IA',
'52765': 'New Liberty,IA',
'52766': 'Nichols,IA',
'52767': 'Pleasant Valley,IA',
'52768': 'Princeton,IA',
'52769': 'Stockton,IA',
'52771': 'Teeds Grove,IA',
'52772': 'Tipton,IA',
'52773': 'Walcott,IA',
'52774': 'Welton,IA',
'52776': 'West Liberty,IA',
'52777': 'Wheatland,IA',
'52778': 'Wilton,IA',
'52801': 'Davenport,IA',
'52802': 'Davenport,IA',
'52803': 'Davenport,IA',
'52804': 'Davenport,IA',
'52805': 'Davenport,IA',
'52806': 'Davenport,IA',
'52807': 'Davenport,IA',
'52808': 'Davenport,IA',
'52809': 'Davenport,IA',
'53001': 'Adell,WI',
'53002': 'Allenton,WI',
'53003': 'Ashippun,WI',
'53004': 'Belgium,WI',
'53005': 'Brookfield,WI',
'53006': 'Brownsville,WI',
'53007': 'Butler,WI',
'53008': 'Brookfield,WI',
'53010': 'Campbellsport,WI',
'53011': 'Cascade,WI',
'53012': 'Cedarburg,WI',
'53013': 'Cedar Grove,WI',
'53014': 'Chilton,WI',
'53015': 'Cleveland,WI',
'53016': 'Clyman,WI',
'53017': 'Colgate,WI',
'53018': 'Delafield,WI',
'53019': 'Eden,WI',
'53020': 'Elkhart Lake,WI',
'53021': 'Fredonia,WI',
'53022': 'Germantown,WI',
'53023': 'Glenbeulah,WI',
'53024': 'Grafton,WI',
'53026': 'Greenbush,WI',
'53027': 'Hartford,WI',
'53029': 'Hartland,WI',
'53031': 'Hingham,WI',
'53032': 'Horicon,WI',
'53033': 'Hubertus,WI',
'53034': 'Hustisford,WI',
'53035': 'Iron Ridge,WI',
'53036': 'Ixonia,WI',
'53037': 'Jackson,WI',
'53038': 'Johnson Creek,WI',
'53039': 'Juneau,WI',
'53040': 'Kewaskum,WI',
'53042': 'Kiel,WI',
'53044': 'Kohler,WI',
'53045': 'Brookfield,WI',
'53046': 'Lannon,WI',
'53047': 'Lebanon,WI',
'53048': 'Lomira,WI',
'53049': 'Malone,WI',
'53050': 'Mayville,WI',
'53051': 'Menomonee Falls,WI',
'53052': 'Menomonee Falls,WI',
'53056': 'Merton,WI',
'53057': 'Mount Calvary,WI',
'53058': 'Nashotah,WI',
'53059': 'Neosho,WI',
'53060': 'Newburg,WI',
'53061': 'New Holstein,WI',
'53062': 'New Holstein,WI',
'53063': 'Newton,WI',
'53064': 'North Lake,WI',
'53065': 'Oakfield,WI',
'53066': 'Oconomowoc,WI',
'53069': 'Okauchee,WI',
'53070': 'Oostburg,WI',
'53072': 'Pewaukee,WI',
'53073': 'Plymouth,WI',
'53074': 'Port Washington,WI',
'53075': 'Random Lake,WI',
'53076': 'Richfield,WI',
'53078': 'Rubicon,WI',
'53079': 'Saint Cloud,WI',
'53080': 'Saukville,WI',
'53081': 'Sheboygan,WI',
'53082': 'Sheboygan,WI',
'53083': 'Sheboygan,WI',
'53085': 'Sheboygan Falls,WI',
'53086': 'Slinger,WI',
'53088': 'Stockbridge,WI',
'53089': 'Sussex,WI',
'53090': 'West Bend,WI',
'53091': 'Theresa,WI',
'53092': 'Thiensville,WI',
'53093': 'Waldo,WI',
'53094': 'Watertown,WI',
'53095': 'West Bend,WI',
'53097': 'Mequon,WI',
'53098': 'Watertown,WI',
'53099': 'Woodland,WI',
'53101': 'Bassett,WI',
'53102': 'Benet Lake,WI',
'53103': 'Big Bend,WI',
'53104': 'Bristol,WI',
'53105': 'Burlington,WI',
'53108': 'Caledonia,WI',
'53109': 'Camp Lake,WI',
'53110': 'Cudahy,WI',
'53114': 'Darien,WI',
'53115': 'Delavan,WI',
'53118': 'Dousman,WI',
'53119': 'Eagle,WI',
'53120': 'East Troy,WI',
'53121': 'Elkhorn,WI',
'53122': 'Elm Grove,WI',
'53125': 'Fontana,WI',
'53126': 'Franksville,WI',
'53127': 'Genesee Depot,WI',
'53128': 'Genoa City,WI',
'53129': 'Greendale,WI',
'53130': 'Hales Corners,WI',
'53132': 'Franklin,WI',
'53137': 'Helenville,WI',
'53138': 'Honey Creek,WI',
'53139': 'Kansasville,WI',
'53140': 'Kenosha,WI',
'53141': 'Kenosha,WI',
'53142': 'Kenosha,WI',
'53143': 'Kenosha,WI',
'53144': 'Kenosha,WI',
'53146': 'New Berlin,WI',
'53147': 'Lake Geneva,WI',
'53148': 'Lyons,WI',
'53149': 'Mukwonago,WI',
'53150': 'Muskego,WI',
'53151': 'New Berlin,WI',
'53152': 'New Munster,WI',
'53153': 'North Prairie,WI',
'53154': 'Oak Creek,WI',
'53156': 'Palmyra,WI',
'53157': 'Pell Lake,WI',
'53158': 'Pleasant Prairie,WI',
'53159': 'Powers Lake,WI',
'53167': 'Rochester,WI',
'53168': 'Salem,WI',
'53170': 'Silver Lake,WI',
'53171': 'Somers,WI',
'53172': 'South Milwaukee,WI',
'53176': 'Springfield,WI',
'53177': 'Sturtevant,WI',
'53178': 'Sullivan,WI',
'53179': 'Trevor,WI',
'53181': 'Twin Lakes,WI',
'53182': 'Union Grove,WI',
'53183': 'Wales,WI',
'53184': 'Walworth,WI',
'53185': 'Waterford,WI',
'53186': 'Waukesha,WI',
'53187': 'Waukesha,WI',
'53188': 'Waukesha,WI',
'53189': 'Waukesha,WI',
'53190': 'Whitewater,WI',
'53191': 'Williams Bay,WI',
'53192': 'Wilmot,WI',
'53194': 'Woodworth,WI',
'53195': 'Zenda,WI',
'53199': 'Silver Lake,WI',
'53201': 'Milwaukee,WI',
'53202': 'Milwaukee,WI',
'53203': 'Milwaukee,WI',
'53204': 'Milwaukee,WI',
'53205': 'Milwaukee,WI',
'53206': 'Milwaukee,WI',
'53207': 'Milwaukee,WI',
'53208': 'Milwaukee,WI',
'53209': 'Milwaukee,WI',
'53210': 'Milwaukee,WI',
'53211': 'Milwaukee,WI',
'53212': 'Milwaukee,WI',
'53213': 'Milwaukee,WI',
'53214': 'Milwaukee,WI',
'53215': 'Milwaukee,WI',
'53216': 'Milwaukee,WI',
'53217': 'Milwaukee,WI',
'53218': 'Milwaukee,WI',
'53219': 'Milwaukee,WI',
'53220': 'Milwaukee,WI',
'53221': 'Milwaukee,WI',
'53222': 'Milwaukee,WI',
'53223': 'Milwaukee,WI',
'53224': 'Milwaukee,WI',
'53225': 'Milwaukee,WI',
'53226': 'Milwaukee,WI',
'53227': 'Milwaukee,WI',
'53228': 'Milwaukee,WI',
'53233': 'Milwaukee,WI',
'53234': 'Milwaukee,WI',
'53235': 'Milwaukee,WI',
'53237': 'Milwaukee,WI',
'53244': 'Milwaukee,WI',
'53259': 'Milwaukee,WI',
'53263': 'Milwaukee,WI',
'53267': 'Milwaukee,WI',
'53268': 'Milwaukee,WI',
'53270': 'Milwaukee,WI',
'53274': 'Milwaukee,WI',
'53277': 'Milwaukee,WI',
'53278': 'Milwaukee,WI',
'53280': 'Milwaukee,WI',
'53281': 'Milwaukee,WI',
'53284': 'Milwaukee,WI',
'53285': 'Milwaukee,WI',
'53288': 'Milwaukee,WI',
'53290': 'Milwaukee,WI',
'53293': 'Milwaukee,WI',
'53295': 'Milwaukee,WI',
'53401': 'Racine,WI',
'53402': 'Racine,WI',
'53403': 'Racine,WI',
'53404': 'Racine,WI',
'53405': 'Racine,WI',
'53406': 'Racine,WI',
'53407': 'Racine,WI',
'53408': 'Racine,WI',
'53490': 'Racine,WI',
'53501': 'Afton,WI',
'53502': 'Albany,WI',
'53503': 'Arena,WI',
'53504': 'Argyle,WI',
'53505': 'Avalon,WI',
'53506': 'Avoca,WI',
'53507': 'Barneveld,WI',
'53508': 'Belleville,WI',
'53510': 'Belmont,WI',
'53511': 'Beloit,WI',
'53512': 'Beloit,WI',
'53515': 'Black Earth,WI',
'53516': 'Blanchardville,WI',
'53517': 'Blue Mounds,WI',
'53518': 'Blue River,WI',
'53520': 'Brodhead,WI',
'53521': 'Brooklyn,WI',
'53522': 'Browntown,WI',
'53523': 'Cambridge,WI',
'53525': 'Clinton,WI',
'53526': 'Cobb,WI',
'53527': 'Cottage Grove,WI',
'53528': 'Cross Plains,WI',
'53529': 'Dane,WI',
'53530': 'Darlington,WI',
'53531': 'Deerfield,WI',
'53532': 'De Forest,WI',
'53533': 'Dodgeville,WI',
'53534': 'Edgerton,WI',
'53535': 'Edmund,WI',
'53536': 'Evansville,WI',
'53537': 'Footville,WI',
'53538': 'Fort Atkinson,WI',
'53540': 'Gotham,WI',
'53541': 'Gratiot,WI',
'53542': 'Hanover,WI',
'53543': 'Highland,WI',
'53544': 'Hollandale,WI',
'53545': 'Janesville,WI',
'53546': 'Janesville,WI',
'53547': 'Janesville,WI',
'53549': 'Jefferson,WI',
'53550': 'Juda,WI',
'53551': 'Lake Mills,WI',
'53553': 'Linden,WI',
'53554': 'Livingston,WI',
'53555': 'Lodi,WI',
'53556': 'Lone Rock,WI',
'53557': 'Lowell,WI',
'53558': 'Mc Farland,WI',
'53559': 'Marshall,WI',
'53560': 'Mazomanie,WI',
'53561': 'Merrimac,WI',
'53562': 'Middleton,WI',
'53563': 'Milton,WI',
'53565': 'Mineral Point,WI',
'53566': 'Monroe,WI',
'53569': 'Montfort,WI',
'53570': 'Monticello,WI',
'53571': 'Morrisonville,WI',
'53572': 'Mount Horeb,WI',
'53573': 'Muscoda,WI',
'53574': 'New Glarus,WI',
'53575': 'Oregon,WI',
'53576': 'Orfordville,WI',
'53577': 'Plain,WI',
'53578': 'Prairie Du Sac,WI',
'53579': 'Reeseville,WI',
'53580': 'Rewey,WI',
'53581': 'Richland Center,WI',
'53582': 'Ridgeway,WI',
'53583': 'Sauk City,WI',
'53584': 'Sextonville,WI',
'53585': 'Sharon,WI',
'53586': 'Shullsburg,WI',
'53587': 'South Wayne,WI',
'53588': 'Spring Green,WI',
'53589': 'Stoughton,WI',
'53590': 'Sun Prairie,WI',
'53591': 'Sun Prairie,WI',
'53593': 'Verona,WI',
'53594': 'Waterloo,WI',
'53595': 'Dodgeville,WI',
'53596': 'Sun Prairie,WI',
'53597': 'Waunakee,WI',
'53598': 'Windsor,WI',
'53599': 'Woodford,WI',
'53701': 'Madison,WI',
'53702': 'Madison,WI',
'53703': 'Madison,WI',
'53704': 'Madison,WI',
'53705': 'Madison,WI',
'53706': 'Madison,WI',
'53707': 'Madison,WI',
'53708': 'Madison,WI',
'53709': 'Madison,WI',
'53710': 'Madison,WI',
'53711': 'Madison,WI',
'53713': 'Madison,WI',
'53714': 'Madison,WI',
'53715': 'Madison,WI',
'53716': 'Madison,WI',
'53717': 'Madison,WI',
'53718': 'Madison,WI',
'53719': 'Madison,WI',
'53725': 'Madison,WI',
'53726': 'Madison,WI',
'53744': 'Madison,WI',
'53774': 'Wisconsin Lottery,WI',
'53777': 'Madison,WI',
'53778': 'Madison,WI',
'53779': 'Madison,WI',
'53780': 'Madison,WI',
'53782': 'Madison,WI',
'53783': 'Madison,WI',
'53784': 'Madison,WI',
'53785': 'Madison,WI',
'53786': 'Madison,WI',
'53787': 'Madison,WI',
'53788': 'Madison,WI',
'53789': 'Madison,WI',
'53790': 'Madison,WI',
'53791': 'Madison,WI',
'53792': 'Madison,WI',
'53793': 'Madison,WI',
'53794': 'Madison,WI',
'53801': 'Bagley,WI',
'53802': 'Beetown,WI',
'53803': 'Benton,WI',
'53804': 'Bloomington,WI',
'53805': 'Boscobel,WI',
'53806': 'Cassville,WI',
'53807': 'Cuba City,WI',
'53808': 'Dickeyville,WI',
'53809': 'Fennimore,WI',
'53810': 'Glen Haven,WI',
'53811': 'Hazel Green,WI',
'53812': 'Kieler,WI',
'53813': 'Lancaster,WI',
'53816': 'Mount Hope,WI',
'53817': 'Patch Grove,WI',
'53818': 'Platteville,WI',
'53820': 'Potosi,WI',
'53821': 'Prairie Du Chien,WI',
'53824': 'Sinsinawa,WI',
'53825': 'Stitzer,WI',
'53826': 'Wauzeka,WI',
'53827': 'Woodman,WI',
'53901': 'Portage,WI',
'53910': 'Adams,WI',
'53911': 'Arlington,WI',
'53913': 'Baraboo,WI',
'53916': 'Beaver Dam,WI',
'53917': 'Beaver Dam,WI',
'53919': 'Brandon,WI',
'53920': 'Briggsville,WI',
'53922': 'Burnett,WI',
'53923': 'Cambria,WI',
'53924': 'Cazenovia,WI',
'53925': 'Columbus,WI',
'53926': 'Dalton,WI',
'53927': 'Dellwood,WI',
'53928': 'Doylestown,WI',
'53929': 'Elroy,WI',
'53930': 'Endeavor,WI',
'53931': 'Fairwater,WI',
'53932': 'Fall River,WI',
'53933': 'Fox Lake,WI',
'53934': 'Friendship,WI',
'53935': 'Friesland,WI',
'53936': 'Grand Marsh,WI',
'53937': 'Hillpoint,WI',
'53939': 'Kingston,WI',
'53940': 'Lake Delton,WI',
'53941': 'La Valle,WI',
'53942': 'Lime Ridge,WI',
'53943': 'Loganville,WI',
'53944': 'Lyndon Station,WI',
'53946': 'Markesan,WI',
'53947': 'Marquette,WI',
'53948': 'Mauston,WI',
'53949': 'Montello,WI',
'53950': 'New Lisbon,WI',
'53951': 'North Freedom,WI',
'53952': 'Oxford,WI',
'53953': 'Packwaukee,WI',
'53954': 'Pardeeville,WI',
'53955': 'Poynette,WI',
'53956': 'Randolph,WI',
'53957': 'Randolph,WI',
'53958': 'Reedsburg,WI',
'53959': 'Reedsburg,WI',
'53960': 'Rio,WI',
'53961': 'Rock Springs,WI',
'53962': 'Union Center,WI',
'53963': 'Waupun,WI',
'53964': 'Westfield,WI',
'53965': 'Wisconsin Dells,WI',
'53968': 'Wonewoc,WI',
'53969': 'Wyocena,WI',
'54001': 'Amery,WI',
'54002': 'Baldwin,WI',
'54003': 'Beldenville,WI',
'54004': 'Clayton,WI',
'54005': 'Clear Lake,WI',
'54006': 'Cushing,WI',
'54007': 'Deer Park,WI',
'54009': 'Dresser,WI',
'54010': 'East Ellsworth,WI',
'54011': 'Ellsworth,WI',
'54012': 'Emerald,WI',
'54013': 'Glenwood City,WI',
'54014': 'Hager City,WI',
'54015': 'Hammond,WI',
'54016': 'Hudson,WI',
'54017': 'New Richmond,WI',
'54020': 'Osceola,WI',
'54021': 'Prescott,WI',
'54022': 'River Falls,WI',
'54023': 'Roberts,WI',
'54024': 'Saint Croix Falls,WI',
'54025': 'Somerset,WI',
'54026': 'Star Prairie,WI',
'54027': 'Wilson,WI',
'54028': 'Woodville,WI',
'54082': 'Houlton,WI',
'54101': 'Abrams,WI',
'54102': 'Amberg,WI',
'54103': 'Armstrong Creek,WI',
'54104': 'Athelstane,WI',
'54106': 'Black Creek,WI',
'54107': 'Bonduel,WI',
'54110': 'Brillion,WI',
'54111': 'Cecil,WI',
'54112': 'Coleman,WI',
'54113': 'Combined Locks,WI',
'54114': 'Crivitz,WI',
'54115': 'De Pere,WI',
'54119': 'Dunbar,WI',
'54120': 'Fence,WI',
'54121': 'Florence,WI',
'54123': 'Forest Junction,WI',
'54124': 'Gillett,WI',
'54125': 'Goodman,WI',
'54126': 'Greenleaf,WI',
'54127': 'Green Valley,WI',
'54128': 'Gresham,WI',
'54129': 'Hilbert,WI',
'54130': 'Kaukauna,WI',
'54131': 'Freedom,WI',
'54135': 'Keshena,WI',
'54136': 'Kimberly,WI',
'54137': 'Krakow,WI',
'54138': 'Lakewood,WI',
'54139': 'Lena,WI',
'54140': 'Little Chute,WI',
'54141': 'Little Suamico,WI',
'54143': 'Marinette,WI',
'54149': 'Mountain,WI',
'54150': 'Neopit,WI',
'54151': 'Niagara,WI',
'54152': 'Nichols,WI',
'54153': 'Oconto,WI',
'54154': 'Oconto Falls,WI',
'54155': 'Oneida,WI',
'54156': 'Pembine,WI',
'54157': 'Peshtigo,WI',
'54159': 'Porterfield,WI',
'54160': 'Potter,WI',
'54161': 'Pound,WI',
'54162': 'Pulaski,WI',
'54165': 'Seymour,WI',
'54166': 'Shawano,WI',
'54169': 'Sherwood,WI',
'54170': 'Shiocton,WI',
'54171': 'Sobieski,WI',
'54173': 'Suamico,WI',
'54174': 'Suring,WI',
'54175': 'Townsend,WI',
'54177': 'Wausaukee,WI',
'54180': 'Wrightstown,WI',
'54182': 'Zachow,WI',
'54201': 'Algoma,WI',
'54202': 'Baileys Harbor,WI',
'54203': 'Branch,WI',
'54204': 'Brussels,WI',
'54205': 'Casco,WI',
'54207': 'Collins,WI',
'54208': 'Denmark,WI',
'54209': 'Egg Harbor,WI',
'54210': 'Ellison Bay,WI',
'54211': 'Ephraim,WI',
'54212': 'Fish Creek,WI',
'54213': 'Forestville,WI',
'54214': 'Francis Creek,WI',
'54215': 'Kellnersville,WI',
'54216': 'Kewaunee,WI',
'54217': 'Luxemburg,WI',
'54220': 'Manitowoc,WI',
'54221': 'Manitowoc,WI',
'54226': 'Maplewood,WI',
'54227': 'Maribel,WI',
'54228': 'Mishicot,WI',
'54229': 'New Franken,WI',
'54230': 'Reedsville,WI',
'54232': 'Saint Nazianz,WI',
'54234': 'Sister Bay,WI',
'54235': 'Sturgeon Bay,WI',
'54240': 'Tisch Mills,WI',
'54241': 'Two Rivers,WI',
'54245': 'Valders,WI',
'54246': 'Washington Island,WI',
'54247': 'Whitelaw,WI',
'54301': 'Green Bay,WI',
'54302': 'Green Bay,WI',
'54303': 'Green Bay,WI',
'54304': 'Green Bay,WI',
'54305': 'Green Bay,WI',
'54306': 'Green Bay,WI',
'54307': 'Green Bay,WI',
'54308': 'Green Bay,WI',
'54311': 'Green Bay,WI',
'54313': 'Green Bay,WI',
'54324': 'Green Bay,WI',
'54344': 'Green Bay,WI',
'54401': 'Wausau,WI',
'54402': 'Wausau,WI',
'54403': 'Wausau,WI',
'54404': 'Marshfield,WI',
'54405': 'Abbotsford,WI',
'54406': 'Amherst,WI',
'54407': 'Amherst Junction,WI',
'54408': 'Aniwa,WI',
'54409': 'Antigo,WI',
'54410': 'Arpin,WI',
'54411': 'Athens,WI',
'54412': 'Auburndale,WI',
'54413': 'Babcock,WI',
'54414': 'Birnamwood,WI',
'54415': 'Blenker,WI',
'54416': 'Bowler,WI',
'54417': 'Brokaw,WI',
'54418': 'Bryant,WI',
'54420': 'Chili,WI',
'54421': 'Colby,WI',
'54422': 'Curtiss,WI',
'54423': 'Custer,WI',
'54424': 'Deerbrook,WI',
'54425': 'Dorchester,WI',
'54426': 'Edgar,WI',
'54427': 'Eland,WI',
'54428': 'Elcho,WI',
'54429': 'Elderon,WI',
'54430': 'Elton,WI',
'54432': 'Galloway,WI',
'54433': 'Gilman,WI',
'54434': 'Jump River,WI',
'54435': 'Gleason,WI',
'54436': 'Granton,WI',
'54437': 'Greenwood,WI',
'54439': 'Hannibal,WI',
'54440': 'Hatley,WI',
'54441': 'Hewitt,WI',
'54442': 'Irma,WI',
'54443': 'Junction City,WI',
'54444': 'Kempster,WI',
'54446': 'Loyal,WI',
'54447': 'Lublin,WI',
'54448': 'Marathon,WI',
'54449': 'Marshfield,WI',
'54450': 'Mattoon,WI',
'54451': 'Medford,WI',
'54452': 'Merrill,WI',
'54454': 'Milladore,WI',
'54455': 'Mosinee,WI',
'54456': 'Neillsville,WI',
'54457': 'Nekoosa,WI',
'54458': 'Nelsonville,WI',
'54459': 'Ogema,WI',
'54460': 'Owen,WI',
'54462': 'Pearson,WI',
'54463': 'Pelican Lake,WI',
'54464': 'Phlox,WI',
'54465': 'Pickerel,WI',
'54466': 'Pittsville,WI',
'54467': 'Plover,WI',
'54469': 'Port Edwards,WI',
'54470': 'Rib Lake,WI',
'54471': 'Ringle,WI',
'54472': 'Marshfield,WI',
'54473': 'Rosholt,WI',
'54474': 'Rothschild,WI',
'54475': 'Rudolph,WI',
'54476': 'Schofield,WI',
'54479': 'Spencer,WI',
'54480': 'Stetsonville,WI',
'54481': 'Stevens Point,WI',
'54482': 'Stevens Point,WI',
'54484': 'Stratford,WI',
'54485': 'Summit Lake,WI',
'54486': 'Tigerton,WI',
'54487': 'Tomahawk,WI',
'54488': 'Unity,WI',
'54489': 'Vesper,WI',
'54490': 'Westboro,WI',
'54491': 'White Lake,WI',
'54492': 'Stevens Point,WI',
'54493': 'Willard,WI',
'54494': 'Wisconsin Rapids,WI',
'54495': 'Wisconsin Rapids,WI',
'54498': 'Withee,WI',
'54499': 'Wittenberg,WI',
'54501': 'Rhinelander,WI',
'54511': 'Argonne,WI',
'54512': 'Boulder Junction,WI',
'54513': 'Brantwood,WI',
'54514': 'Butternut,WI',
'54515': 'Catawba,WI',
'54517': 'Clam Lake,WI',
'54519': 'Conover,WI',
'54520': 'Crandon,WI',
'54521': 'Eagle River,WI',
'54524': 'Fifield,WI',
'54525': 'Gile,WI',
'54526': 'Glen Flora,WI',
'54527': 'Glidden,WI',
'54529': 'Harshaw,WI',
'54530': 'Hawkins,WI',
'54531': 'Hazelhurst,WI',
'54532': 'Heafford Junction,WI',
'54534': 'Hurley,WI',
'54536': 'Iron Belt,WI',
'54537': 'Kennan,WI',
'54538': 'Lac Du Flambeau,WI',
'54539': 'Lake Tomahawk,WI',
'54540': 'Land O Lakes,WI',
'54541': 'Laona,WI',
'54542': 'Long Lake,WI',
'54543': 'Mc Naughton,WI',
'54545': 'Manitowish Waters,WI',
'54546': 'Mellen,WI',
'54547': 'Mercer,WI',
'54548': 'Minocqua,WI',
'54550': 'Montreal,WI',
'54552': 'Park Falls,WI',
'54554': 'Phelps,WI',
'54555': 'Phillips,WI',
'54556': 'Prentice,WI',
'54557': 'Presque Isle,WI',
'54558': 'Saint Germain,WI',
'54559': 'Saxon,WI',
'54560': 'Sayner,WI',
'54561': 'Star Lake,WI',
'54562': 'Three Lakes,WI',
'54563': 'Tony,WI',
'54564': 'Tripoli,WI',
'54565': 'Upson,WI',
'54566': 'Wabeno,WI',
'54568': 'Woodruff,WI',
'54601': 'La Crosse,WI',
'54602': 'La Crosse,WI',
'54603': 'La Crosse,WI',
'54610': 'Alma,WI',
'54611': 'Alma Center,WI',
'54612': 'Arcadia,WI',
'54613': 'Arkdale,WI',
'54614': 'Bangor,WI',
'54615': 'Black River Falls,WI',
'54616': 'Blair,WI',
'54618': 'Camp Douglas,WI',
'54619': 'Cashton,WI',
'54620': 'Cataract,WI',
'54621': 'Chaseburg,WI',
'54622': 'Cochrane,WI',
'54623': 'Coon Valley,WI',
'54624': 'De Soto,WI',
'54625': 'Dodge,WI',
'54626': 'Eastman,WI',
'54627': 'Ettrick,WI',
'54628': 'Ferryville,WI',
'54629': 'Fountain City,WI',
'54630': 'Galesville,WI',
'54631': 'Gays Mills,WI',
'54632': 'Genoa,WI',
'54634': 'Hillsboro,WI',
'54635': 'Hixton,WI',
'54636': 'Holmen,WI',
'54637': 'Hustler,WI',
'54638': 'Kendall,WI',
'54639': 'La Farge,WI',
'54640': 'Lynxville,WI',
'54641': 'Mather,WI',
'54642': 'Melrose,WI',
'54643': 'Millston,WI',
'54644': 'Mindoro,WI',
'54645': 'Mount Sterling,WI',
'54646': 'Necedah,WI',
'54648': 'Norwalk,WI',
'54649': 'Oakdale,WI',
'54650': 'Onalaska,WI',
'54651': 'Ontario,WI',
'54652': 'Readstown,WI',
'54653': 'Rockland,WI',
'54654': 'Seneca,WI',
'54655': 'Soldiers Grove,WI',
'54656': 'Sparta,WI',
'54657': 'Steuben,WI',
'54658': 'Stoddard,WI',
'54659': 'Taylor,WI',
'54660': 'Tomah,WI',
'54661': 'Trempealeau,WI',
'54662': 'Tunnel City,WI',
'54664': 'Viola,WI',
'54665': 'Viroqua,WI',
'54666': 'Warrens,WI',
'54667': 'Westby,WI',
'54669': 'West Salem,WI',
'54670': 'Wilton,WI',
'54701': 'Eau Claire,WI',
'54702': 'Eau Claire,WI',
'54703': 'Eau Claire,WI',
'54720': 'Altoona,WI',
'54721': 'Arkansaw,WI',
'54722': 'Augusta,WI',
'54723': 'Bay City,WI',
'54724': 'Bloomer,WI',
'54725': 'Boyceville,WI',
'54726': 'Boyd,WI',
'54727': 'Cadott,WI',
'54728': 'Chetek,WI',
'54729': 'Chippewa Falls,WI',
'54730': 'Colfax,WI',
'54731': 'Conrath,WI',
'54732': 'Cornell,WI',
'54733': 'Dallas,WI',
'54734': 'Downing,WI',
'54735': 'Downsville,WI',
'54736': 'Durand,WI',
'54737': 'Eau Galle,WI',
'54738': 'Eleva,WI',
'54739': 'Elk Mound,WI',
'54740': 'Elmwood,WI',
'54741': 'Fairchild,WI',
'54742': 'Fall Creek,WI',
'54743': 'Gilmanton,WI',
'54744': 'Hillsdale,WI',
'54745': 'Holcombe,WI',
'54746': 'Humbird,WI',
'54747': 'Independence,WI',
'54748': 'Jim Falls,WI',
'54749': 'Knapp,WI',
'54750': 'Maiden Rock,WI',
'54751': 'Menomonie,WI',
'54754': 'Merrillan,WI',
'54755': 'Mondovi,WI',
'54756': 'Nelson,WI',
'54757': 'New Auburn,WI',
'54758': 'Osseo,WI',
'54759': 'Pepin,WI',
'54760': 'Pigeon Falls,WI',
'54761': 'Plum City,WI',
'54762': 'Prairie Farm,WI',
'54763': 'Ridgeland,WI',
'54764': 'Rock Falls,WI',
'54765': 'Sand Creek,WI',
'54766': 'Sheldon,WI',
'54767': 'Spring Valley,WI',
'54768': 'Stanley,WI',
'54769': 'Stockholm,WI',
'54770': 'Strum,WI',
'54771': 'Thorp,WI',
'54772': 'Wheeler,WI',
'54773': 'Whitehall,WI',
'54774': 'Chippewa Falls,WI',
'54801': 'Spooner,WI',
'54805': 'Almena,WI',
'54806': 'Ashland,WI',
'54810': 'Balsam Lake,WI',
'54812': 'Barron,WI',
'54813': 'Barronett,WI',
'54814': 'Bayfield,WI',
'54816': 'Benoit,WI',
'54817': 'Birchwood,WI',
'54818': 'Brill,WI',
'54819': 'Bruce,WI',
'54820': 'Brule,WI',
'54821': 'Cable,WI',
'54822': 'Cameron,WI',
'54824': 'Centuria,WI',
'54826': 'Comstock,WI',
'54827': 'Cornucopia,WI',
'54828': 'Couderay,WI',
'54829': 'Cumberland,WI',
'54830': 'Danbury,WI',
'54832': 'Drummond,WI',
'54834': 'Edgewater,WI',
'54835': 'Exeland,WI',
'54836': 'Foxboro,WI',
'54837': 'Frederic,WI',
'54838': 'Gordon,WI',
'54839': 'Grand View,WI',
'54840': 'Grantsburg,WI',
'54841': 'Haugen,WI',
'54842': 'Hawthorne,WI',
'54843': 'Hayward,WI',
'54844': 'Herbster,WI',
'54845': 'Hertel,WI',
'54846': 'High Bridge,WI',
'54847': 'Iron River,WI',
'54848': 'Ladysmith,WI',
'54849': 'Lake Nebagamon,WI',
'54850': 'La Pointe,WI',
'54851': 'Lewis,WI',
'54853': 'Luck,WI',
'54854': 'Maple,WI',
'54855': 'Marengo,WI',
'54856': 'Mason,WI',
'54857': 'Mikana,WI',
'54858': 'Milltown,WI',
'54859': 'Minong,WI',
'54861': 'Odanah,WI',
'54862': 'Ojibwa,WI',
'54864': 'Poplar,WI',
'54865': 'Port Wing,WI',
'54867': 'Radisson,WI',
'54868': 'Rice Lake,WI',
'54870': 'Sarona,WI',
'54871': 'Shell Lake,WI',
'54872': 'Siren,WI',
'54873': 'Solon Springs,WI',
'54874': 'South Range,WI',
'54875': 'Springbrook,WI',
'54876': 'Stone Lake,WI',
'54880': 'Superior,WI',
'54888': 'Trego,WI',
'54889': 'Turtle Lake,WI',
'54890': 'Wascott,WI',
'54891': 'Washburn,WI',
'54893': 'Webster,WI',
'54895': 'Weyerhaeuser,WI',
'54896': 'Winter,WI',
'54901': 'Oshkosh,WI',
'54902': 'Oshkosh,WI',
'54903': 'Oshkosh,WI',
'54904': 'Oshkosh,WI',
'54906': 'Oshkosh,WI',
'54909': 'Almond,WI',
'54911': 'Appleton,WI',
'54912': 'Appleton,WI',
'54913': 'Appleton,WI',
'54914': 'Appleton,WI',
'54915': 'Appleton,WI',
'54919': 'Appleton,WI',
'54921': 'Bancroft,WI',
'54922': 'Bear Creek,WI',
'54923': 'Berlin,WI',
'54926': 'Big Falls,WI',
'54927': 'Butte Des Morts,WI',
'54928': 'Caroline,WI',
'54929': 'Clintonville,WI',
'54930': 'Coloma,WI',
'54931': 'Dale,WI',
'54932': 'Eldorado,WI',
'54933': 'Embarrass,WI',
'54934': 'Eureka,WI',
'54935': 'Fond Du Lac,WI',
'54936': 'Fond Du Lac,WI',
'54937': 'Fond Du Lac,WI',
'54940': 'Fremont,WI',
'54941': 'Green Lake,WI',
'54942': 'Greenville,WI',
'54943': 'Hancock,WI',
'54944': 'Hortonville,WI',
'54945': 'Iola,WI',
'54946': 'King,WI',
'54947': 'Larsen,WI',
'54948': 'Leopolis,WI',
'54949': 'Manawa,WI',
'54950': 'Marion,WI',
'54951': 'Medina,WI',
'54952': 'Menasha,WI',
'54956': 'Neenah,WI',
'54957': 'Neenah,WI',
'54960': 'Neshkoro,WI',
'54961': 'New London,WI',
'54962': 'Ogdensburg,WI',
'54963': 'Omro,WI',
'54964': 'Pickett,WI',
'54965': 'Pine River,WI',
'54966': 'Plainfield,WI',
'54967': 'Poy Sippi,WI',
'54968': 'Princeton,WI',
'54969': 'Readfield,WI',
'54970': 'Redgranite,WI',
'54971': 'Ripon,WI',
'54974': 'Rosendale,WI',
'54975': 'Royalton,WI',
'54976': 'Saxeville,WI',
'54977': 'Scandinavia,WI',
'54978': 'Tilleda,WI',
'54979': 'Van Dyne,WI',
'54980': 'Waukau,WI',
'54981': 'Waupaca,WI',
'54982': 'Wautoma,WI',
'54983': 'Weyauwega,WI',
'54984': 'Wild Rose,WI',
'54985': 'Winnebago,WI',
'54986': 'Winneconne,WI',
'54990': 'Iola,WI',
'55001': 'Afton,MN',
'55002': 'Almelund,MN',
'55003': 'Bayport,MN',
'55005': 'Bethel,MN',
'55006': 'Braham,MN',
'55007': 'Brook Park,MN',
'55008': 'Cambridge,MN',
'55009': 'Cannon Falls,MN',
'55010': 'Castle Rock,MN',
'55011': 'Cedar,MN',
'55012': 'Center City,MN',
'55013': 'Chisago City,MN',
'55014': 'Circle Pines,MN',
'55016': 'Cottage Grove,MN',
'55017': 'Dalbo,MN',
'55018': 'Dennison,MN',
'55019': 'Dundas,MN',
'55020': 'Elko,MN',
'55021': 'Faribault,MN',
'55024': 'Farmington,MN',
'55025': 'Forest Lake,MN',
'55026': 'Frontenac,MN',
'55027': 'Goodhue,MN',
'55029': 'Grandy,MN',
'55030': 'Grasston,MN',
'55031': 'Hampton,MN',
'55032': 'Harris,MN',
'55033': 'Hastings,MN',
'55036': 'Henriette,MN',
'55037': 'Hinckley,MN',
'55038': 'Hugo,MN',
'55040': 'Isanti,MN',
'55041': 'Lake City,MN',
'55042': 'Lake Elmo,MN',
'55043': 'Lakeland,MN',
'55044': 'Lakeville,MN',
'55045': 'Lindstrom,MN',
'55046': 'Lonsdale,MN',
'55047': 'Marine On Saint Croix,MN',
'55049': 'Medford,MN',
'55051': 'Mora,MN',
'55052': 'Morristown,MN',
'55053': 'Nerstrand,MN',
'55054': 'New Market,MN',
'55055': 'Newport,MN',
'55056': 'North Branch,MN',
'55057': 'Northfield,MN',
'55060': 'Owatonna,MN',
'55063': 'Pine City,MN',
'55065': 'Randolph,MN',
'55066': 'Red Wing,MN',
'55067': 'Rock Creek,MN',
'55068': 'Rosemount,MN',
'55069': 'Rush City,MN',
'55070': 'Saint Francis,MN',
'55071': 'Saint Paul Park,MN',
'55072': 'Sandstone,MN',
'55073': 'Scandia,MN',
'55074': 'Shafer,MN',
'55075': 'South Saint Paul,MN',
'55076': 'Inver Grove Heights,MN',
'55077': 'Inver Grove Heights,MN',
'55078': 'Stacy,MN',
'55079': 'Stacy,MN',
'55080': 'Stanchfield,MN',
'55082': 'Stillwater,MN',
'55083': 'Stillwater,MN',
'55084': 'Taylors Falls,MN',
'55085': 'Vermillion,MN',
'55087': 'Warsaw,MN',
'55088': 'Webster,MN',
'55089': 'Welch,MN',
'55090': 'Willernie,MN',
'55092': 'Wyoming,MN',
'55101': 'Saint Paul,MN',
'55102': 'Saint Paul,MN',
'55103': 'Saint Paul,MN',
'55104': 'Saint Paul,MN',
'55105': 'Saint Paul,MN',
'55106': 'Saint Paul,MN',
'55107': 'Saint Paul,MN',
'55108': 'Saint Paul,MN',
'55109': 'Saint Paul,MN',
'55110': 'Saint Paul,MN',
'55111': 'Saint Paul,MN',
'55112': 'Saint Paul,MN',
'55113': 'Saint Paul,MN',
'55114': 'Saint Paul,MN',
'55115': 'Saint Paul,MN',
'55116': 'Saint Paul,MN',
'55117': 'Saint Paul,MN',
'55118': 'Saint Paul,MN',
'55119': 'Saint Paul,MN',
'55120': 'Saint Paul,MN',
'55121': 'Saint Paul,MN',
'55122': 'Saint Paul,MN',
'55123': 'Saint Paul,MN',
'55124': 'Saint Paul,MN',
'55125': 'Saint Paul,MN',
'55126': 'Saint Paul,MN',
'55127': 'Saint Paul,MN',
'55128': 'Saint Paul,MN',
'55129': 'Saint Paul,MN',
'55130': 'Saint Paul,MN',
'55133': 'Saint Paul,MN',
'55144': 'Saint Paul,MN',
'55145': 'Saint Paul,MN',
'55146': 'Saint Paul,MN',
'55150': 'Mendota,MN',
'55155': 'Saint Paul,MN',
'55161': 'Saint Paul,MN',
'55164': 'Saint Paul,MN',
'55165': 'Saint Paul,MN',
'55166': 'Saint Paul,MN',
'55168': 'Saint Paul,MN',
'55169': 'Saint Paul,MN',
'55170': 'Saint Paul,MN',
'55171': 'Saint Paul,MN',
'55172': 'Saint Paul,MN',
'55175': 'Saint Paul,MN',
'55177': 'Saint Paul,MN',
'55182': 'Saint Paul,MN',
'55187': 'Saint Paul,MN',
'55188': 'Saint Paul,MN',
'55190': 'Saint Paul,MN',
'55191': 'Saint Paul,MN',
'55301': 'Albertville,MN',
'55302': 'Annandale,MN',
'55303': 'Anoka,MN',
'55304': 'Andover,MN',
'55305': 'Hopkins,MN',
'55306': 'Burnsville,MN',
'55307': 'Arlington,MN',
'55308': 'Becker,MN',
'55309': 'Big Lake,MN',
'55310': 'Bird Island,MN',
'55311': 'Osseo,MN',
'55312': 'Brownton,MN',
'55313': 'Buffalo,MN',
'55314': 'Buffalo Lake,MN',
'55315': 'Carver,MN',
'55316': 'Champlin,MN',
'55317': 'Chanhassen,MN',
'55318': 'Chaska,MN',
'55319': 'Clear Lake,MN',
'55320': 'Clearwater,MN',
'55321': 'Cokato,MN',
'55322': 'Cologne,MN',
'55323': 'Crystal Bay,MN',
'55324': 'Darwin,MN',
'55325': 'Dassel,MN',
'55327': 'Dayton,MN',
'55328': 'Delano,MN',
'55329': 'Eden Valley,MN',
'55330': 'Elk River,MN',
'55331': 'Excelsior,MN',
'55332': 'Fairfax,MN',
'55333': 'Franklin,MN',
'55334': 'Gaylord,MN',
'55335': 'Gibbon,MN',
'55336': 'Glencoe,MN',
'55337': 'Burnsville,MN',
'55338': 'Green Isle,MN',
'55339': 'Hamburg,MN',
'55340': 'Hamel,MN',
'55341': 'Hanover,MN',
'55342': 'Hector,MN',
'55343': 'Hopkins,MN',
'55344': 'Eden Prairie,MN',
'55345': 'Minnetonka,MN',
'55346': 'Eden Prairie,MN',
'55347': 'Eden Prairie,MN',
'55348': 'Maple Plain,MN',
'55349': 'Howard Lake,MN',
'55350': 'Hutchinson,MN',
'55352': 'Jordan,MN',
'55353': 'Kimball,MN',
'55354': 'Lester Prairie,MN',
'55355': 'Litchfield,MN',
'55356': 'Long Lake,MN',
'55357': 'Loretto,MN',
'55358': 'Maple Lake,MN',
'55359': 'Maple Plain,MN',
'55360': 'Mayer,MN',
'55361': 'Minnetonka Beach,MN',
'55362': 'Monticello,MN',
'55363': 'Montrose,MN',
'55364': 'Mound,MN',
'55365': 'Monticello,MN',
'55366': 'New Auburn,MN',
'55367': 'New Germany,MN',
'55368': 'Norwood,MN',
'55369': 'Osseo,MN',
'55370': 'Plato,MN',
'55371': 'Princeton,MN',
'55372': 'Prior Lake,MN',
'55373': 'Rockford,MN',
'55374': 'Rogers,MN',
'55375': 'Saint Bonifacius,MN',
'55376': 'Saint Michael,MN',
'55377': 'Santiago,MN',
'55378': 'Savage,MN',
'55379': 'Shakopee,MN',
'55380': 'Silver Creek,MN',
'55381': 'Silver Lake,MN',
'55382': 'South Haven,MN',
'55383': 'Norwood,MN',
'55384': 'Spring Park,MN',
'55385': 'Stewart,MN',
'55386': 'Victoria,MN',
'55387': 'Waconia,MN',
'55388': 'Watertown,MN',
'55389': 'Watkins,MN',
'55390': 'Waverly,MN',
'55391': 'Wayzata,MN',
'55392': 'Navarre,MN',
'55393': 'Maple Plain,MN',
'55394': 'Young America,MN',
'55395': 'Winsted,MN',
'55396': 'Winthrop,MN',
'55397': 'Young America,MN',
'55398': 'Zimmerman,MN',
'55399': 'Young America,MN',
'55401': 'Minneapolis,MN',
'55402': 'Minneapolis,MN',
'55403': 'Minneapolis,MN',
'55404': 'Minneapolis,MN',
'55405': 'Minneapolis,MN',
'55406': 'Minneapolis,MN',
'55407': 'Minneapolis,MN',
'55408': 'Minneapolis,MN',
'55409': 'Minneapolis,MN',
'55410': 'Minneapolis,MN',
'55411': 'Minneapolis,MN',
'55412': 'Minneapolis,MN',
'55413': 'Minneapolis,MN',
'55414': 'Minneapolis,MN',
'55415': 'Minneapolis,MN',
'55416': 'Minneapolis,MN',
'55417': 'Minneapolis,MN',
'55418': 'Minneapolis,MN',
'55419': 'Minneapolis,MN',
'55420': 'Minneapolis,MN',
'55421': 'Minneapolis,MN',
'55422': 'Minneapolis,MN',
'55423': 'Minneapolis,MN',
'55424': 'Minneapolis,MN',
'55425': 'Minneapolis,MN',
'55426': 'Minneapolis,MN',
'55427': 'Minneapolis,MN',
'55428': 'Minneapolis,MN',
'55429': 'Minneapolis,MN',
'55430': 'Minneapolis,MN',
'55431': 'Minneapolis,MN',
'55432': 'Minneapolis,MN',
'55433': 'Minneapolis,MN',
'55434': 'Minneapolis,MN',
'55435': 'Minneapolis,MN',
'55436': 'Minneapolis,MN',
'55437': 'Minneapolis,MN',
'55438': 'Minneapolis,MN',
'55439': 'Minneapolis,MN',
'55440': 'Minneapolis,MN',
'55441': 'Minneapolis,MN',
'55442': 'Minneapolis,MN',
'55443': 'Minneapolis,MN',
'55444': 'Minneapolis,MN',
'55445': 'Minneapolis,MN',
'55446': 'Minneapolis,MN',
'55447': 'Minneapolis,MN',
'55448': 'Minneapolis,MN',
'55449': 'Minneapolis,MN',
'55450': 'Minneapolis,MN',
'55454': 'Minneapolis,MN',
'55455': 'Minneapolis,MN',
'55458': 'Minneapolis,MN',
'55459': 'Minneapolis,MN',
'55460': 'Minneapolis,MN',
'55467': 'Wells Fargo Home Mortgage,MN',
'55468': 'Minneapolis,MN',
'55470': 'Minneapolis,MN',
'55472': 'Minneapolis,MN',
'55473': 'Minneapolis,MN',
'55474': 'Minneapolis,MN',
'55478': 'Minneapolis,MN',
'55479': 'Minneapolis,MN',
'55480': 'Minneapolis,MN',
'55483': 'Minneapolis,MN',
'55484': 'Minneapolis,MN',
'55485': 'Minneapolis,MN',
'55486': 'Minneapolis,MN',
'55487': 'Minneapolis,MN',
'55488': 'Minneapolis,MN',
'55550': 'Young America,MN',
'55551': 'Young America,MN',
'55552': 'Young America,MN',
'55553': 'Young America,MN',
'55554': 'Norwood,MN',
'55555': 'Young America,MN',
'55556': 'Young America,MN',
'55557': 'Young America,MN',
'55558': 'Young America,MN',
'55559': 'Young America,MN',
'55560': 'Young America,MN',
'55561': 'Monticello,MN',
'55562': 'Young America,MN',
'55563': 'Monticello,MN',
'55564': 'Young America,MN',
'55565': 'Monticello,MN',
'55566': 'Young America,MN',
'55567': 'Young America,MN',
'55568': 'Young America,MN',
'55569': 'Osseo,MN',
'55570': 'Maple Plain,MN',
'55571': 'Maple Plain,MN',
'55572': 'Maple Plain,MN',
'55573': 'Young America,MN',
'55574': 'Maple Plain,MN',
'55575': 'Howard Lake,MN',
'55576': 'Maple Plain,MN',
'55577': 'Maple Plain,MN',
'55578': 'Maple Plain,MN',
'55579': 'Maple Plain,MN',
'55580': 'Monticello,MN',
'55581': 'Monticello,MN',
'55582': 'Monticello,MN',
'55583': 'Norwood,MN',
'55584': 'Monticello,MN',
'55585': 'Monticello,MN',
'55586': 'Monticello,MN',
'55587': 'Monticello,MN',
'55588': 'Monticello,MN',
'55589': 'Monticello,MN',
'55590': 'Monticello,MN',
'55591': 'Monticello,MN',
'55592': 'Maple Plain,MN',
'55593': 'Maple Plain,MN',
'55594': 'Young America,MN',
'55595': 'Loretto,MN',
'55596': 'Loretto,MN',
'55597': 'Loretto,MN',
'55598': 'Loretto,MN',
'55599': 'Loretto,MN',
'55601': 'Beaver Bay,MN',
'55602': 'Brimson,MN',
'55603': 'Finland,MN',
'55604': 'Grand Marais,MN',
'55605': 'Grand Portage,MN',
'55606': 'Hovland,MN',
'55607': 'Isabella,MN',
'55609': 'Knife River,MN',
'55612': 'Lutsen,MN',
'55613': 'Schroeder,MN',
'55614': 'Silver Bay,MN',
'55615': 'Tofte,MN',
'55616': 'Two Harbors,MN',
'55701': 'Adolph,MN',
'55702': 'Alborn,MN',
'55703': 'Angora,MN',
'55704': 'Askov,MN',
'55705': 'Aurora,MN',
'55706': 'Babbitt,MN',
'55707': 'Barnum,MN',
'55708': 'Biwabik,MN',
'55709': 'Bovey,MN',
'55710': 'Britt,MN',
'55711': 'Brookston,MN',
'55712': 'Bruno,MN',
'55713': 'Buhl,MN',
'55716': 'Calumet,MN',
'55717': 'Canyon,MN',
'55718': 'Carlton,MN',
'55719': 'Chisholm,MN',
'55720': 'Cloquet,MN',
'55721': 'Cohasset,MN',
'55722': 'Coleraine,MN',
'55723': 'Cook,MN',
'55724': 'Cotton,MN',
'55725': 'Crane Lake,MN',
'55726': 'Cromwell,MN',
'55730': 'Grand Rapids,MN',
'55731': 'Ely,MN',
'55732': 'Embarrass,MN',
'55733': 'Esko,MN',
'55734': 'Eveleth,MN',
'55735': 'Finlayson,MN',
'55736': 'Floodwood,MN',
'55738': 'Forbes,MN',
'55741': 'Gilbert,MN',
'55742': 'Goodland,MN',
'55744': 'Grand Rapids,MN',
'55745': 'Grand Rapids,MN',
'55746': 'Hibbing,MN',
'55747': 'Hibbing,MN',
'55748': 'Hill City,MN',
'55749': 'Holyoke,MN',
'55750': 'Hoyt Lakes,MN',
'55751': 'Iron,MN',
'55752': 'Jacobson,MN',
'55753': 'Keewatin,MN',
'55756': 'Kerrick,MN',
'55757': 'Kettle River,MN',
'55758': 'Kinney,MN',
'55760': 'Mcgregor,MN',
'55763': 'Makinen,MN',
'55764': 'Marble,MN',
'55765': 'Meadowlands,MN',
'55766': 'Melrude,MN',
'55767': 'Moose Lake,MN',
'55768': 'Mountain Iron,MN',
'55769': 'Nashwauk,MN',
'55771': 'Orr,MN',
'55772': 'Nett Lake,MN',
'55775': 'Pengilly,MN',
'55777': 'Virginia,MN',
'55779': 'Saginaw,MN',
'55780': 'Sawyer,MN',
'55781': 'Side Lake,MN',
'55782': 'Soudan,MN',
'55783': 'Sturgeon Lake,MN',
'55784': 'Swan River,MN',
'55785': 'Swatara,MN',
'55786': 'Taconite,MN',
'55787': 'Tamarack,MN',
'55790': 'Tower,MN',
'55791': 'Twig,MN',
'55792': 'Virginia,MN',
'55793': 'Warba,MN',
'55795': 'Willow River,MN',
'55796': 'Winton,MN',
'55797': 'Wrenshall,MN',
'55798': 'Wright,MN',
'55801': 'Duluth,MN',
'55802': 'Duluth,MN',
'55803': 'Duluth,MN',
'55804': 'Duluth,MN',
'55805': 'Duluth,MN',
'55806': 'Duluth,MN',
'55807': 'Duluth,MN',
'55808': 'Duluth,MN',
'55810': 'Duluth,MN',
'55811': 'Duluth,MN',
'55812': 'Duluth,MN',
'55814': 'Duluth,MN',
'55815': 'Duluth,MN',
'55816': 'Duluth,MN',
'55901': 'Rochester,MN',
'55902': 'Rochester,MN',
'55903': 'Rochester,MN',
'55904': 'Rochester,MN',
'55905': 'Rochester,MN',
'55906': 'Rochester,MN',
'55909': 'Adams,MN',
'55910': 'Altura,MN',
'55912': 'Austin,MN',
'55917': 'Blooming Prairie,MN',
'55918': 'Brownsdale,MN',
'55919': 'Brownsville,MN',
'55920': 'Byron,MN',
'55921': 'Caledonia,MN',
'55922': 'Canton,MN',
'55923': 'Chatfield,MN',
'55924': 'Claremont,MN',
'55925': 'Dakota,MN',
'55926': 'Dexter,MN',
'55927': 'Dodge Center,MN',
'55929': 'Dover,MN',
'55931': 'Eitzen,MN',
'55932': 'Elgin,MN',
'55933': 'Elkton,MN',
'55934': 'Eyota,MN',
'55935': 'Fountain,MN',
'55936': 'Grand Meadow,MN',
'55939': 'Harmony,MN',
'55940': 'Hayfield,MN',
'55941': 'Hokah,MN',
'55942': 'Homer,MN',
'55943': 'Houston,MN',
'55944': 'Kasson,MN',
'55945': 'Kellogg,MN',
'55946': 'Kenyon,MN',
'55947': 'La Crescent,MN',
'55949': 'Lanesboro,MN',
'55950': 'Lansing,MN',
'55951': 'Le Roy,MN',
'55952': 'Lewiston,MN',
'55953': 'Lyle,MN',
'55954': 'Mabel,MN',
'55955': 'Mantorville,MN',
'55956': 'Mazeppa,MN',
'55957': 'Millville,MN',
'55959': 'Minnesota City,MN',
'55960': 'Oronoco,MN',
'55961': 'Ostrander,MN',
'55962': 'Peterson,MN',
'55963': 'Pine Island,MN',
'55964': 'Plainview,MN',
'55965': 'Preston,MN',
'55967': 'Racine,MN',
'55968': 'Reads Landing,MN',
'55969': 'Rollingstone,MN',
'55970': 'Rose Creek,MN',
'55971': 'Rushford,MN',
'55972': 'Saint Charles,MN',
'55973': 'Sargeant,MN',
'55974': 'Spring Grove,MN',
'55975': 'Spring Valley,MN',
'55976': 'Stewartville,MN',
'55977': 'Taopi,MN',
'55979': 'Utica,MN',
'55981': 'Wabasha,MN',
'55982': 'Waltham,MN',
'55983': 'Wanamingo,MN',
'55985': 'West Concord,MN',
'55987': 'Winona,MN',
'55988': 'Stockton,MN',
'55990': 'Wykoff,MN',
'55991': 'Zumbro Falls,MN',
'55992': 'Zumbrota,MN',
'56001': 'Mankato,MN',
'56002': 'Mankato,MN',
'56003': 'Mankato,MN',
'56006': 'Mankato,MN',
'56007': 'Albert Lea,MN',
'56009': 'Alden,MN',
'56010': 'Amboy,MN',
'56011': 'Belle Plaine,MN',
'56013': 'Blue Earth,MN',
'56014': 'Bricelyn,MN',
'56016': 'Clarks Grove,MN',
'56017': 'Cleveland,MN',
'56019': 'Comfrey,MN',
'56020': 'Conger,MN',
'56021': 'Courtland,MN',
'56022': 'Darfur,MN',
'56023': 'Delavan,MN',
'56024': 'Eagle Lake,MN',
'56025': 'Easton,MN',
'56026': 'Ellendale,MN',
'56027': 'Elmore,MN',
'56028': 'Elysian,MN',
'56029': 'Emmons,MN',
'56030': 'Essig,MN',
'56031': 'Fairmont,MN',
'56032': 'Freeborn,MN',
'56033': 'Frost,MN',
'56034': 'Garden City,MN',
'56035': 'Geneva,MN',
'56036': 'Glenville,MN',
'56037': 'Good Thunder,MN',
'56039': 'Granada,MN',
'56041': 'Hanska,MN',
'56042': 'Hartland,MN',
'56043': 'Hayward,MN',
'56044': 'Henderson,MN',
'56045': 'Hollandale,MN',
'56046': 'Hope,MN',
'56047': 'Huntley,MN',
'56048': 'Janesville,MN',
'56050': 'Kasota,MN',
'56051': 'Kiester,MN',
'56052': 'Kilkenny,MN',
'56054': 'Lafayette,MN',
'56055': 'Lake Crystal,MN',
'56056': 'La Salle,MN',
'56057': 'Le Center,MN',
'56058': 'Le Sueur,MN',
'56060': 'Lewisville,MN',
'56062': 'Madelia,MN',
'56063': 'Madison Lake,MN',
'56064': 'Manchester,MN',
'56065': 'Mapleton,MN',
'56068': 'Minnesota Lake,MN',
'56069': 'Montgomery,MN',
'56071': 'New Prague,MN',
'56072': 'New Richland,MN',
'56073': 'New Ulm,MN',
'56074': 'Nicollet,MN',
'56075': 'Northrop,MN',
'56076': 'Oakland,MN',
'56078': 'Pemberton,MN',
'56080': 'Saint Clair,MN',
'56081': 'Saint James,MN',
'56082': 'Saint Peter,MN',
'56083': 'Sanborn,MN',
'56084': 'Searles,MN',
'56085': 'Sleepy Eye,MN',
'56087': 'Springfield,MN',
'56088': 'Truman,MN',
'56089': 'Twin Lakes,MN',
'56090': 'Vernon Center,MN',
'56091': 'Waldorf,MN',
'56093': 'Waseca,MN',
'56096': 'Waterville,MN',
'56097': 'Wells,MN',
'56098': 'Winnebago,MN',
'56101': 'Windom,MN',
'56110': 'Adrian,MN',
'56111': 'Alpha,MN',
'56113': 'Arco,MN',
'56114': 'Avoca,MN',
'56115': 'Balaton,MN',
'56116': 'Beaver Creek,MN',
'56117': 'Bigelow,MN',
'56118': 'Bingham Lake,MN',
'56119': 'Brewster,MN',
'56120': 'Butterfield,MN',
'56121': 'Ceylon,MN',
'56122': 'Chandler,MN',
'56123': 'Currie,MN',
'56125': 'Dovray,MN',
'56127': 'Dunnell,MN',
'56128': 'Edgerton,MN',
'56129': 'Ellsworth,MN',
'56131': 'Fulda,MN',
'56132': 'Garvin,MN',
'56134': 'Hardwick,MN',
'56136': 'Hendricks,MN',
'56137': 'Heron Lake,MN',
'56138': 'Hills,MN',
'56139': 'Holland,MN',
'56140': 'Ihlen,MN',
'56141': 'Iona,MN',
'56142': 'Ivanhoe,MN',
'56143': 'Jackson,MN',
'56144': 'Jasper,MN',
'56145': 'Jeffers,MN',
'56146': 'Kanaranzi,MN',
'56147': 'Kenneth,MN',
'56149': 'Lake Benton,MN',
'56150': 'Lakefield,MN',
'56151': 'Lake Wilson,MN',
'56152': 'Lamberton,MN',
'56153': 'Leota,MN',
'56155': 'Lismore,MN',
'56156': 'Luverne,MN',
'56157': 'Lynd,MN',
'56158': 'Magnolia,MN',
'56159': 'Mountain Lake,MN',
'56160': 'Odin,MN',
'56161': 'Okabena,MN',
'56162': 'Ormsby,MN',
'56164': 'Pipestone,MN',
'56165': 'Reading,MN',
'56166': 'Revere,MN',
'56167': 'Round Lake,MN',
'56168': 'Rushmore,MN',
'56169': 'Russell,MN',
'56170': 'Ruthton,MN',
'56171': 'Sherburn,MN',
'56172': 'Slayton,MN',
'56173': 'Steen,MN',
'56174': 'Storden,MN',
'56175': 'Tracy,MN',
'56176': 'Trimont,MN',
'56177': 'Trosky,MN',
'56178': 'Tyler,MN',
'56180': 'Walnut Grove,MN',
'56181': 'Welcome,MN',
'56183': 'Westbrook,MN',
'56185': 'Wilmont,MN',
'56186': 'Woodstock,MN',
'56187': 'Worthington,MN',
'56201': 'Willmar,MN',
'56207': 'Alberta,MN',
'56208': 'Appleton,MN',
'56209': 'Atwater,MN',
'56210': 'Barry,MN',
'56211': 'Beardsley,MN',
'56212': 'Bellingham,MN',
'56214': 'Belview,MN',
'56215': 'Benson,MN',
'56216': 'Blomkest,MN',
'56218': 'Boyd,MN',
'56219': 'Browns Valley,MN',
'56220': 'Canby,MN',
'56221': 'Chokio,MN',
'56222': 'Clara City,MN',
'56223': 'Clarkfield,MN',
'56224': 'Clements,MN',
'56225': 'Clinton,MN',
'56226': 'Clontarf,MN',
'56227': 'Correll,MN',
'56228': 'Cosmos,MN',
'56229': 'Cottonwood,MN',
'56230': 'Danube,MN',
'56231': 'Danvers,MN',
'56232': 'Dawson,MN',
'56235': 'Donnelly,MN',
'56236': 'Dumont,MN',
'56237': 'Echo,MN',
'56239': 'Ghent,MN',
'56240': 'Graceville,MN',
'56241': 'Granite Falls,MN',
'56243': 'Grove City,MN',
'56244': 'Hancock,MN',
'56245': 'Hanley Falls,MN',
'56246': 'Hawick,MN',
'56248': 'Herman,MN',
'56249': 'Holloway,MN',
'56251': 'Kandiyohi,MN',
'56252': 'Kerkhoven,MN',
'56253': 'Lake Lillian,MN',
'56255': 'Lucan,MN',
'56256': 'Madison,MN',
'56257': 'Marietta,MN',
'56258': 'Marshall,MN',
'56260': 'Maynard,MN',
'56262': 'Milan,MN',
'56263': 'Milroy,MN',
'56264': 'Minneota,MN',
'56265': 'Montevideo,MN',
'56266': 'Morgan,MN',
'56267': 'Morris,MN',
'56270': 'Morton,MN',
'56271': 'Murdock,MN',
'56273': 'New London,MN',
'56274': 'Norcross,MN',
'56276': 'Odessa,MN',
'56277': 'Olivia,MN',
'56278': 'Ortonville,MN',
'56279': 'Pennock,MN',
'56280': 'Porter,MN',
'56281': 'Prinsburg,MN',
'56282': 'Raymond,MN',
'56283': 'Redwood Falls,MN',
'56284': 'Renville,MN',
'56285': 'Sacred Heart,MN',
'56287': 'Seaforth,MN',
'56288': 'Spicer,MN',
'56289': 'Sunburg,MN',
'56291': 'Taunton,MN',
'56292': 'Vesta,MN',
'56293': 'Wabasso,MN',
'56294': 'Wanda,MN',
'56295': 'Watson,MN',
'56296': 'Wheaton,MN',
'56297': 'Wood Lake,MN',
'56301': 'Saint Cloud,MN',
'56302': 'Saint Cloud,MN',
'56303': 'Saint Cloud,MN',
'56304': 'Saint Cloud,MN',
'56307': 'Albany,MN',
'56308': 'Alexandria,MN',
'56309': 'Ashby,MN',
'56310': 'Avon,MN',
'56311': 'Barrett,MN',
'56312': 'Belgrade,MN',
'56313': 'Bock,MN',
'56314': 'Bowlus,MN',
'56315': 'Brandon,MN',
'56316': 'Brooten,MN',
'56317': 'Buckman,MN',
'56318': 'Burtrum,MN',
'56319': 'Carlos,MN',
'56320': 'Cold Spring,MN',
'56321': 'Collegeville,MN',
'56323': 'Cyrus,MN',
'56324': 'Dalton,MN',
'56325': 'Elrosa,MN',
'56326': 'Evansville,MN',
'56327': 'Farwell,MN',
'56328': 'Flensburg,MN',
'56329': 'Foley,MN',
'56330': 'Foreston,MN',
'56331': 'Freeport,MN',
'56332': 'Garfield,MN',
'56333': 'Gilman,MN',
'56334': 'Glenwood,MN',
'56335': 'Greenwald,MN',
'56336': 'Grey Eagle,MN',
'56338': 'Hillman,MN',
'56339': 'Hoffman,MN',
'56340': 'Holdingford,MN',
'56341': 'Holmes City,MN',
'56342': 'Isle,MN',
'56343': 'Kensington,MN',
'56344': 'Lastrup,MN',
'56345': 'Little Falls,MN',
'56347': 'Long Prairie,MN',
'56349': 'Lowry,MN',
'56350': 'Mc Grath,MN',
'56352': 'Melrose,MN',
'56353': 'Milaca,MN',
'56354': 'Miltona,MN',
'56355': 'Nelson,MN',
'56356': 'New Munich,MN',
'56357': 'Oak Park,MN',
'56358': 'Ogilvie,MN',
'56359': 'Onamia,MN',
'56360': 'Osakis,MN',
'56361': 'Parkers Prairie,MN',
'56362': 'Paynesville,MN',
'56363': 'Pease,MN',
'56364': 'Pierz,MN',
'56367': 'Rice,MN',
'56368': 'Richmond,MN',
'56369': 'Rockville,MN',
'56371': 'Roscoe,MN',
'56372': 'Saint Cloud,MN',
'56373': 'Royalton,MN',
'56374': 'Saint Joseph,MN',
'56375': 'Saint Stephen,MN',
'56376': 'Saint Martin,MN',
'56377': 'Sartell,MN',
'56378': 'Sauk Centre,MN',
'56379': 'Sauk Rapids,MN',
'56381': 'Starbuck,MN',
'56382': 'Swanville,MN',
'56384': 'Upsala,MN',
'56385': 'Villard,MN',
'56386': 'Wahkon,MN',
'56387': 'Waite Park,MN',
'56388': 'Waite Park,MN',
'56389': 'West Union,MN',
'56393': 'Saint Cloud,MN',
'56395': 'Saint Cloud,MN',
'56396': 'Saint Cloud,MN',
'56397': 'Saint Cloud,MN',
'56398': 'Saint Cloud,MN',
'56399': 'Saint Cloud,MN',
'56401': 'Brainerd,MN',
'56425': 'Baxter,MN',
'56430': 'Ah Gwah Ching,MN',
'56431': 'Aitkin,MN',
'56433': 'Akeley,MN',
'56434': 'Aldrich,MN',
'56435': 'Backus,MN',
'56436': 'Benedict,MN',
'56437': 'Bertha,MN',
'56438': 'Browerville,MN',
'56440': 'Clarissa,MN',
'56441': 'Crosby,MN',
'56442': 'Crosslake,MN',
'56443': 'Cushing,MN',
'56444': 'Deerwood,MN',
'56446': 'Eagle Bend,MN',
'56447': 'Emily,MN',
'56448': 'Fifty Lakes,MN',
'56449': 'Fort Ripley,MN',
'56450': 'Garrison,MN',
'56452': 'Hackensack,MN',
'56453': 'Hewitt,MN',
'56455': 'Ironton,MN',
'56456': 'Jenkins,MN',
'56458': 'Lake George,MN',
'56459': 'Lake Hubert,MN',
'56461': 'Laporte,MN',
'56464': 'Menahga,MN',
'56465': 'Merrifield,MN',
'56466': 'Motley,MN',
'56467': 'Nevis,MN',
'56468': 'Nisswa,MN',
'56469': 'Palisade,MN',
'56470': 'Park Rapids,MN',
'56472': 'Pequot Lakes,MN',
'56473': 'Pillager,MN',
'56474': 'Pine River,MN',
'56475': 'Randall,MN',
'56477': 'Sebeka,MN',
'56478': 'Nimrod,MN',
'56479': 'Staples,MN',
'56481': 'Verndale,MN',
'56482': 'Wadena,MN',
'56484': 'Walker,MN',
'56501': 'Detroit Lakes,MN',
'56502': 'Detroit Lakes,MN',
'56510': 'Ada,MN',
'56511': 'Audubon,MN',
'56513': 'Baker,MN',
'56514': 'Barnesville,MN',
'56515': 'Battle Lake,MN',
'56516': 'Bejou,MN',
'56517': 'Beltrami,MN',
'56518': 'Bluffton,MN',
'56519': 'Borup,MN',
'56520': 'Breckenridge,MN',
'56521': 'Callaway,MN',
'56522': 'Campbell,MN',
'56523': 'Climax,MN',
'56524': 'Clitherall,MN',
'56525': 'Comstock,MN',
'56527': 'Deer Creek,MN',
'56528': 'Dent,MN',
'56529': 'Dilworth,MN',
'56531': 'Elbow Lake,MN',
'56533': 'Elizabeth,MN',
'56534': 'Erhard,MN',
'56535': 'Erskine,MN',
'56536': 'Felton,MN',
'56537': 'Fergus Falls,MN',
'56538': 'Fergus Falls,MN',
'56540': 'Fertile,MN',
'56541': 'Flom,MN',
'56542': 'Fosston,MN',
'56543': 'Foxhome,MN',
'56544': 'Frazee,MN',
'56545': 'Gary,MN',
'56546': 'Georgetown,MN',
'56547': 'Glyndon,MN',
'56548': 'Halstad,MN',
'56549': 'Hawley,MN',
'56550': 'Hendrum,MN',
'56551': 'Henning,MN',
'56552': 'Hitterdal,MN',
'56553': 'Kent,MN',
'56554': 'Lake Park,MN',
'56556': 'Mcintosh,MN',
'56557': 'Mahnomen,MN',
'56560': 'Moorhead,MN',
'56561': 'Moorhead,MN',
'56562': 'Moorhead,MN',
'56563': 'Moorhead,MN',
'56565': 'Nashua,MN',
'56566': 'Naytahwaush,MN',
'56567': 'New York Mills,MN',
'56568': 'Nielsville,MN',
'56569': 'Ogema,MN',
'56570': 'Osage,MN',
'56571': 'Ottertail,MN',
'56572': 'Pelican Rapids,MN',
'56573': 'Perham,MN',
'56574': 'Perley,MN',
'56575': 'Ponsford,MN',
'56576': 'Richville,MN',
'56577': 'Richwood,MN',
'56578': 'Rochert,MN',
'56579': 'Rothsay,MN',
'56580': 'Sabin,MN',
'56581': 'Shelly,MN',
'56583': 'Tintah,MN',
'56584': 'Twin Valley,MN',
'56585': 'Ulen,MN',
'56586': 'Underwood,MN',
'56587': 'Vergas,MN',
'56588': 'Vining,MN',
'56589': 'Waubun,MN',
'56590': 'Wendell,MN',
'56591': 'White Earth,MN',
'56592': 'Winger,MN',
'56593': 'Wolf Lake,MN',
'56594': 'Wolverton,MN',
'56601': 'Bemidji,MN',
'56619': 'Bemidji,MN',
'56621': 'Bagley,MN',
'56623': 'Baudette,MN',
'56626': 'Bena,MN',
'56627': 'Big Falls,MN',
'56628': 'Bigfork,MN',
'56629': 'Birchdale,MN',
'56630': 'Blackduck,MN',
'56631': 'Bowstring,MN',
'56633': 'Cass Lake,MN',
'56634': 'Clearbrook,MN',
'56636': 'Deer River,MN',
'56637': 'Talmoon,MN',
'56639': 'Effie,MN',
'56641': 'Federal Dam,MN',
'56644': 'Gonvick,MN',
'56646': 'Gully,MN',
'56647': 'Hines,MN',
'56649': 'International Falls,MN',
'56650': 'Kelliher,MN',
'56651': 'Lengby,MN',
'56652': 'Leonard,MN',
'56653': 'Littlefork,MN',
'56654': 'Loman,MN',
'56655': 'Longville,MN',
'56657': 'Marcell,MN',
'56658': 'Margie,MN',
'56659': 'Max,MN',
'56660': 'Mizpah,MN',
'56661': 'Northome,MN',
'56662': 'Outing,MN',
'56663': 'Pennington,MN',
'56666': 'Ponemah,MN',
'56667': 'Puposky,MN',
'56668': 'Ranier,MN',
'56669': 'Ray,MN',
'56670': 'Redby,MN',
'56671': 'Redlake,MN',
'56672': 'Remer,MN',
'56673': 'Roosevelt,MN',
'56676': 'Shevlin,MN',
'56678': 'Solway,MN',
'56679': 'South International Falls,MN',
'56680': 'Spring Lake,MN',
'56681': 'Squaw Lake,MN',
'56682': 'Swift,MN',
'56683': 'Tenstrike,MN',
'56684': 'Trail,MN',
'56685': 'Waskish,MN',
'56686': 'Williams,MN',
'56687': 'Wilton,MN',
'56688': 'Wirt,MN',
'56701': 'Thief River Falls,MN',
'56710': 'Alvarado,MN',
'56711': 'Angle Inlet,MN',
'56712': 'Angus,MN',
'56713': 'Argyle,MN',
'56714': 'Badger,MN',
'56715': 'Brooks,MN',
'56716': 'Crookston,MN',
'56720': 'Donaldson,MN',
'56721': 'East Grand Forks,MN',
'56722': 'Euclid,MN',
'56723': 'Fisher,MN',
'56724': 'Gatzke,MN',
'56725': 'Goodridge,MN',
'56726': 'Greenbush,MN',
'56727': 'Grygla,MN',
'56728': 'Hallock,MN',
'56729': 'Halma,MN',
'56731': 'Humboldt,MN',
'56732': 'Karlstad,MN',
'56733': 'Kennedy,MN',
'56734': 'Lake Bronson,MN',
'56735': 'Lancaster,MN',
'56736': 'Mentor,MN',
'56737': 'Middle River,MN',
'56738': 'Newfolden,MN',
'56740': 'Noyes,MN',
'56741': 'Oak Island,MN',
'56742': 'Oklee,MN',
'56744': 'Oslo,MN',
'56748': 'Plummer,MN',
'56750': 'Red Lake Falls,MN',
'56751': 'Roseau,MN',
'56754': 'Saint Hilaire,MN',
'56755': 'Saint Vincent,MN',
'56756': 'Salol,MN',
'56757': 'Stephen,MN',
'56758': 'Strandquist,MN',
'56759': 'Strathcona,MN',
'56760': 'Viking,MN',
'56761': 'Wannaska,MN',
'56762': 'Warren,MN',
'56763': 'Warroad,MN',
'56901': 'Washington,DC',
'56902': 'Parcel Return Svc,DC',
'56904': 'Parcel Return Svc,DC',
'56915': 'Washington,DC',
'56920': 'Washington,DC',
'56933': 'Washington,DC',
'56944': 'Washington,DC',
'56945': 'Hp Enterprise Services,IA',
'56950': 'Parcel Return Svc,DC',
'56965': 'Parcel Return Service,DC',
'56972': 'Washington,DC',
'57001': 'Alcester,SD',
'57002': 'Aurora,SD',
'57003': 'Baltic,SD',
'57004': 'Beresford,SD',
'57005': 'Brandon,SD',
'57006': 'Brookings,SD',
'57007': 'Brookings,SD',
'57010': 'Burbank,SD',
'57012': 'Canistota,SD',
'57013': 'Canton,SD',
'57014': 'Centerville,SD',
'57015': 'Chancellor,SD',
'57016': 'Chester,SD',
'57017': 'Colman,SD',
'57018': 'Colton,SD',
'57020': 'Crooks,SD',
'57021': 'Davis,SD',
'57022': 'Dell Rapids,SD',
'57024': 'Egan,SD',
'57025': 'Elk Point,SD',
'57026': 'Elkton,SD',
'57027': 'Fairview,SD',
'57028': 'Flandreau,SD',
'57029': 'Freeman,SD',
'57030': 'Garretson,SD',
'57031': 'Gayville,SD',
'57032': 'Harrisburg,SD',
'57033': 'Hartford,SD',
'57034': 'Hudson,SD',
'57035': 'Humboldt,SD',
'57036': 'Hurley,SD',
'57037': 'Irene,SD',
'57038': 'Jefferson,SD',
'57039': 'Lennox,SD',
'57040': 'Lesterville,SD',
'57041': 'Lyons,SD',
'57042': 'Madison,SD',
'57043': 'Marion,SD',
'57044': 'Meckling,SD',
'57045': 'Menno,SD',
'57046': 'Mission Hill,SD',
'57047': 'Monroe,SD',
'57048': 'Montrose,SD',
'57049': 'North Sioux City,SD',
'57050': 'Nunda,SD',
'57051': 'Oldham,SD',
'57052': 'Olivet,SD',
'57053': 'Parker,SD',
'57054': 'Ramona,SD',
'57055': 'Renner,SD',
'57056': 'Rowena,SD',
'57057': 'Rutland,SD',
'57058': 'Salem,SD',
'57059': 'Scotland,SD',
'57061': 'Sinai,SD',
'57062': 'Springfield,SD',
'57063': 'Tabor,SD',
'57064': 'Tea,SD',
'57065': 'Trent,SD',
'57066': 'Tyndall,SD',
'57067': 'Utica,SD',
'57068': 'Valley Springs,SD',
'57069': 'Vermillion,SD',
'57070': 'Viborg,SD',
'57071': 'Volga,SD',
'57072': 'Volin,SD',
'57073': 'Wakonda,SD',
'57075': 'Wentworth,SD',
'57076': 'Winfred,SD',
'57077': 'Worthing,SD',
'57078': 'Yankton,SD',
'57079': 'Yankton,SD',
'57101': 'Sioux Falls,SD',
'57103': 'Sioux Falls,SD',
'57104': 'Sioux Falls,SD',
'57105': 'Sioux Falls,SD',
'57106': 'Sioux Falls,SD',
'57107': 'Sioux Falls,SD',
'57108': 'Sioux Falls,SD',
'57109': 'Sioux Falls,SD',
'57110': 'Sioux Falls,SD',
'57115': 'Buffalo Ridge,SD',
'57117': 'Sioux Falls,SD',
'57118': 'Sioux Falls,SD',
'57186': 'Sioux Falls,SD',
'57188': 'Sioux Falls,SD',
'57189': 'Sioux Falls,SD',
'57192': 'Sioux Falls,SD',
'57193': 'Sioux Falls,SD',
'57194': 'Sioux Falls,SD',
'57195': 'Sioux Falls,SD',
'57196': 'Sioux Falls,SD',
'57197': 'Sioux Falls,SD',
'57198': 'Sioux Falls,SD',
'57201': 'Watertown,SD',
'57202': 'Waverly,SD',
'57212': 'Arlington,SD',
'57213': 'Astoria,SD',
'57214': 'Badger,SD',
'57216': 'Big Stone City,SD',
'57217': 'Bradley,SD',
'57218': 'Brandt,SD',
'57219': 'Bristol,SD',
'57220': 'Bruce,SD',
'57221': 'Bryant,SD',
'57223': 'Castlewood,SD',
'57224': 'Claire City,SD',
'57225': 'Clark,SD',
'57226': 'Clear Lake,SD',
'57227': 'Corona,SD',
'57231': 'De Smet,SD',
'57232': 'Eden,SD',
'57233': 'Erwin,SD',
'57234': 'Estelline,SD',
'57235': 'Florence,SD',
'57236': 'Garden City,SD',
'57237': 'Gary,SD',
'57238': 'Goodwin,SD',
'57239': 'Grenville,SD',
'57241': 'Hayti,SD',
'57242': 'Hazel,SD',
'57243': 'Henry,SD',
'57244': 'Hetland,SD',
'57245': 'Kranzburg,SD',
'57246': 'Labolt,SD',
'57247': 'Lake City,SD',
'57248': 'Lake Norden,SD',
'57249': 'Lake Preston,SD',
'57251': 'Marvin,SD',
'57252': 'Milbank,SD',
'57253': 'Milbank,SD',
'57255': 'New Effington,SD',
'57256': 'Ortley,SD',
'57257': 'Peever,SD',
'57258': 'Raymond,SD',
'57259': 'Revillo,SD',
'57260': 'Rosholt,SD',
'57261': 'Roslyn,SD',
'57262': 'Sisseton,SD',
'57263': 'South Shore,SD',
'57264': 'Stockholm,SD',
'57265': 'Strandburg,SD',
'57266': 'Summit,SD',
'57268': 'Toronto,SD',
'57269': 'Twin Brooks,SD',
'57270': 'Veblen,SD',
'57271': 'Vienna,SD',
'57272': 'Wallace,SD',
'57273': 'Waubay,SD',
'57274': 'Webster,SD',
'57276': 'White,SD',
'57278': 'Willow Lake,SD',
'57279': 'Wilmot,SD',
'57301': 'Mitchell,SD',
'57311': 'Alexandria,SD',
'57312': 'Alpena,SD',
'57313': 'Armour,SD',
'57314': 'Artesian,SD',
'57315': 'Avon,SD',
'57317': 'Bonesteel,SD',
'57319': 'Bridgewater,SD',
'57321': 'Canova,SD',
'57322': 'Carpenter,SD',
'57323': 'Carthage,SD',
'57324': 'Cavour,SD',
'57325': 'Chamberlain,SD',
'57326': 'Chamberlain,SD',
'57328': 'Corsica,SD',
'57329': 'Dante,SD',
'57330': 'Delmont,SD',
'57331': 'Dimock,SD',
'57332': 'Emery,SD',
'57334': 'Ethan,SD',
'57335': 'Fairfax,SD',
'57337': 'Fedora,SD',
'57339': 'Fort Thompson,SD',
'57340': 'Fulton,SD',
'57341': 'Gann Valley,SD',
'57342': 'Geddes,SD',
'57344': 'Harrison,SD',
'57345': 'Highmore,SD',
'57346': 'Stephan,SD',
'57348': 'Hitchcock,SD',
'57349': 'Howard,SD',
'57350': 'Huron,SD',
'57353': 'Iroquois,SD',
'57354': 'Kaylor,SD',
'57355': 'Kimball,SD',
'57356': 'Lake Andes,SD',
'57357': 'Ravinia,SD',
'57358': 'Lane,SD',
'57359': 'Letcher,SD',
'57361': 'Marty,SD',
'57362': 'Miller,SD',
'57363': 'Mount Vernon,SD',
'57364': 'New Holland,SD',
'57365': 'Oacoma,SD',
'57366': 'Parkston,SD',
'57367': 'Pickstown,SD',
'57368': 'Plankinton,SD',
'57369': 'Platte,SD',
'57370': 'Pukwana,SD',
'57371': 'Ree Heights,SD',
'57373': 'Saint Lawrence,SD',
'57374': 'Spencer,SD',
'57375': 'Stickney,SD',
'57376': 'Tripp,SD',
'57379': 'Virgil,SD',
'57380': 'Wagner,SD',
'57381': 'Wessington,SD',
'57382': 'Wessington Springs,SD',
'57383': 'White Lake,SD',
'57384': 'Wolsey,SD',
'57385': 'Woonsocket,SD',
'57386': 'Yale,SD',
'57399': 'Huron,SD',
'57401': 'Aberdeen,SD',
'57402': 'Aberdeen,SD',
'57420': 'Akaska,SD',
'57421': 'Amherst,SD',
'57422': 'Andover,SD',
'57424': 'Ashton,SD',
'57426': 'Barnard,SD',
'57427': 'Bath,SD',
'57428': 'Bowdle,SD',
'57429': 'Brentford,SD',
'57430': 'Britton,SD',
'57432': 'Claremont,SD',
'57433': 'Columbia,SD',
'57434': 'Conde,SD',
'57435': 'Cresbard,SD',
'57436': 'Doland,SD',
'57437': 'Eureka,SD',
'57438': 'Faulkton,SD',
'57439': 'Ferney,SD',
'57440': 'Frankfort,SD',
'57441': 'Frederick,SD',
'57442': 'Gettysburg,SD',
'57445': 'Groton,SD',
'57446': 'Hecla,SD',
'57448': 'Hosmer,SD',
'57449': 'Houghton,SD',
'57450': 'Hoven,SD',
'57451': 'Ipswich,SD',
'57452': 'Java,SD',
'57454': 'Langford,SD',
'57455': 'Lebanon,SD',
'57456': 'Leola,SD',
'57457': 'Longlake,SD',
'57460': 'Mansfield,SD',
'57461': 'Mellette,SD',
'57462': 'Mina,SD',
'57465': 'Northville,SD',
'57466': 'Onaka,SD',
'57467': 'Orient,SD',
'57468': 'Pierpont,SD',
'57469': 'Redfield,SD',
'57470': 'Rockham,SD',
'57471': 'Roscoe,SD',
'57472': 'Selby,SD',
'57473': 'Seneca,SD',
'57474': 'Stratford,SD',
'57475': 'Tolstoy,SD',
'57476': 'Tulare,SD',
'57477': 'Turton,SD',
'57479': 'Warner,SD',
'57481': 'Westport,SD',
'57501': 'Pierre,SD',
'57520': 'Agar,SD',
'57521': 'Belvidere,SD',
'57522': 'Blunt,SD',
'57523': 'Burke,SD',
'57526': 'Carter,SD',
'57528': 'Colome,SD',
'57529': 'Dallas,SD',
'57531': 'Draper,SD',
'57532': 'Fort Pierre,SD',
'57533': 'Gregory,SD',
'57534': 'Hamill,SD',
'57536': 'Harrold,SD',
'57537': 'Hayes,SD',
'57538': 'Herrick,SD',
'57540': 'Holabird,SD',
'57541': 'Ideal,SD',
'57542': 'Iona,SD',
'57543': 'Kadoka,SD',
'57544': 'Kennebec,SD',
'57547': 'Long Valley,SD',
'57548': 'Lower Brule,SD',
'57551': 'Martin,SD',
'57552': 'Midland,SD',
'57553': 'Milesville,SD',
'57555': 'Mission,SD',
'57557': 'Mission Ridge,SD',
'57559': 'Murdo,SD',
'57560': 'Norris,SD',
'57562': 'Okaton,SD',
'57563': 'Okreek,SD',
'57564': 'Onida,SD',
'57566': 'Parmelee,SD',
'57567': 'Philip,SD',
'57568': 'Presho,SD',
'57569': 'Reliance,SD',
'57570': 'Rosebud,SD',
'57571': 'Saint Charles,SD',
'57572': 'Saint Francis,SD',
'57574': 'Tuthill,SD',
'57576': 'Vivian,SD',
'57577': 'Wanblee,SD',
'57578': 'Wewela,SD',
'57579': 'White River,SD',
'57580': 'Winner,SD',
'57584': 'Witten,SD',
'57585': 'Wood,SD',
'57601': 'Mobridge,SD',
'57620': 'Bison,SD',
'57621': 'Bullhead,SD',
'57622': 'Cherry Creek,SD',
'57623': 'Dupree,SD',
'57625': 'Eagle Butte,SD',
'57626': 'Faith,SD',
'57628': 'Firesteel,SD',
'57629': 'Glad Valley,SD',
'57630': 'Glencross,SD',
'57631': 'Glenham,SD',
'57632': 'Herreid,SD',
'57633': 'Isabel,SD',
'57634': 'Keldron,SD',
'57636': 'Lantry,SD',
'57638': 'Lemmon,SD',
'57639': 'Little Eagle,SD',
'57640': 'Lodgepole,SD',
'57641': 'Mc Intosh,SD',
'57642': 'Mc Laughlin,SD',
'57643': 'Mahto,SD',
'57644': 'Meadow,SD',
'57645': 'Morristown,SD',
'57646': 'Mound City,SD',
'57647': 'Parade,SD',
'57648': 'Pollock,SD',
'57649': 'Prairie City,SD',
'57650': 'Ralph,SD',
'57651': 'Reva,SD',
'57652': 'Ridgeview,SD',
'57653': 'Shadehill,SD',
'57656': 'Timber Lake,SD',
'57657': 'Trail City,SD',
'57658': 'Wakpala,SD',
'57659': 'Walker,SD',
'57660': 'Watauga,SD',
'57661': 'Whitehorse,SD',
'57701': 'Rapid City,SD',
'57702': 'Rapid City,SD',
'57703': 'Rapid City,SD',
'57706': 'Ellsworth Afb,SD',
'57709': 'Rapid City,SD',
'57714': 'Allen,SD',
'57716': 'Batesland,SD',
'57717': 'Belle Fourche,SD',
'57718': 'Black Hawk,SD',
'57719': 'Box Elder,SD',
'57720': 'Buffalo,SD',
'57722': 'Buffalo Gap,SD',
'57724': 'Camp Crook,SD',
'57725': 'Caputa,SD',
'57729': 'Creighton,SD',
'57730': 'Custer,SD',
'57732': 'Deadwood,SD',
'57735': 'Edgemont,SD',
'57736': 'Elm Springs,SD',
'57737': 'Enning,SD',
'57738': 'Fairburn,SD',
'57741': 'Fort Meade,SD',
'57742': 'Fruitdale,SD',
'57744': 'Hermosa,SD',
'57745': 'Hill City,SD',
'57747': 'Hot Springs,SD',
'57748': 'Howes,SD',
'57750': 'Interior,SD',
'57751': 'Keystone,SD',
'57752': 'Kyle,SD',
'57754': 'Lead,SD',
'57755': 'Ludlow,SD',
'57756': 'Manderson,SD',
'57758': 'Mud Butte,SD',
'57759': 'Nemo,SD',
'57760': 'Newell,SD',
'57761': 'New Underwood,SD',
'57762': 'Nisland,SD',
'57763': 'Oelrichs,SD',
'57764': 'Oglala,SD',
'57765': 'Opal,SD',
'57766': 'Oral,SD',
'57767': 'Owanka,SD',
'57769': 'Piedmont,SD',
'57770': 'Pine Ridge,SD',
'57772': 'Porcupine,SD',
'57773': 'Pringle,SD',
'57774': 'Provo,SD',
'57775': 'Quinn,SD',
'57776': 'Redig,SD',
'57777': 'Red Owl,SD',
'57778': 'Rochford,SD',
'57779': 'Saint Onge,SD',
'57780': 'Scenic,SD',
'57782': 'Smithwick,SD',
'57783': 'Spearfish,SD',
'57785': 'Sturgis,SD',
'57787': 'Union Center,SD',
'57788': 'Vale,SD',
'57790': 'Wall,SD',
'57791': 'Wasta,SD',
'57792': 'White Owl,SD',
'57793': 'Whitewood,SD',
'57794': 'Wounded Knee,SD',
'57799': 'Spearfish,SD',
'58001': 'Abercrombie,ND',
'58002': 'Absaraka,ND',
'58004': 'Amenia,ND',
'58005': 'Argusville,ND',
'58006': 'Arthur,ND',
'58007': 'Ayr,ND',
'58008': 'Barney,ND',
'58009': 'Blanchard,ND',
'58011': 'Buffalo,ND',
'58012': 'Casselton,ND',
'58013': 'Cayuga,ND',
'58014': 'Chaffee,ND',
'58015': 'Christine,ND',
'58016': 'Clifford,ND',
'58017': 'Cogswell,ND',
'58018': 'Colfax,ND',
'58021': 'Davenport,ND',
'58027': 'Enderlin,ND',
'58029': 'Erie,ND',
'58030': 'Fairmount,ND',
'58031': 'Fingal,ND',
'58032': 'Forman,ND',
'58033': 'Fort Ransom,ND',
'58035': 'Galesburg,ND',
'58036': 'Gardner,ND',
'58038': 'Grandin,ND',
'58039': 'Great Bend,ND',
'58040': 'Gwinner,ND',
'58041': 'Hankinson,ND',
'58042': 'Harwood,ND',
'58043': 'Havana,ND',
'58045': 'Hillsboro,ND',
'58046': 'Hope,ND',
'58047': 'Horace,ND',
'58048': 'Hunter,ND',
'58049': 'Kathryn,ND',
'58051': 'Kindred,ND',
'58052': 'Leonard,ND',
'58053': 'Lidgerwood,ND',
'58054': 'Lisbon,ND',
'58056': 'Luverne,ND',
'58057': 'Mcleod,ND',
'58058': 'Mantador,ND',
'58059': 'Mapleton,ND',
'58060': 'Milnor,ND',
'58061': 'Mooreton,ND',
'58062': 'Nome,ND',
'58063': 'Oriska,ND',
'58064': 'Page,ND',
'58065': 'Pillsbury,ND',
'58067': 'Rutland,ND',
'58068': 'Sheldon,ND',
'58069': 'Stirum,ND',
'58071': 'Tower City,ND',
'58072': 'Valley City,ND',
'58074': 'Wahpeton,ND',
'58075': 'Wahpeton,ND',
'58076': 'Wahpeton,ND',
'58077': 'Walcott,ND',
'58078': 'West Fargo,ND',
'58079': 'Wheatland,ND',
'58081': 'Wyndmere,ND',
'58102': 'Fargo,ND',
'58103': 'Fargo,ND',
'58104': 'Fargo,ND',
'58105': 'Fargo,ND',
'58106': 'Fargo,ND',
'58107': 'Fargo,ND',
'58108': 'Fargo,ND',
'58109': 'Fargo,ND',
'58121': 'Fargo,ND',
'58122': 'Fargo,ND',
'58123': 'Fargo,ND',
'58124': 'Fargo,ND',
'58125': 'Fargo,ND',
'58126': 'Fargo,ND',
'58201': 'Grand Forks,ND',
'58202': 'Grand Forks,ND',
'58203': 'Grand Forks,ND',
'58204': 'Grand Forks Afb,ND',
'58205': 'Grand Forks Afb,ND',
'58206': 'Grand Forks,ND',
'58207': 'Grand Forks,ND',
'58208': 'Grand Forks,ND',
'58210': 'Adams,ND',
'58212': 'Aneta,ND',
'58213': 'Ardoch,ND',
'58214': 'Arvilla,ND',
'58216': 'Bathgate,ND',
'58218': 'Buxton,ND',
'58219': 'Caledonia,ND',
'58220': 'Cavalier,ND',
'58222': 'Crystal,ND',
'58223': 'Cummings,ND',
'58224': 'Dahlen,ND',
'58225': 'Drayton,ND',
'58227': 'Edinburg,ND',
'58228': 'Emerado,ND',
'58229': 'Fairdale,ND',
'58230': 'Finley,ND',
'58231': 'Fordville,ND',
'58233': 'Forest River,ND',
'58235': 'Gilby,ND',
'58236': 'Glasston,ND',
'58237': 'Grafton,ND',
'58238': 'Hamilton,ND',
'58239': 'Hannah,ND',
'58240': 'Hatton,ND',
'58241': 'Hensel,ND',
'58243': 'Hoople,ND',
'58244': 'Inkster,ND',
'58249': 'Langdon,ND',
'58250': 'Lankin,ND',
'58251': 'Larimore,ND',
'58254': 'Mcville,ND',
'58255': 'Maida,ND',
'58256': 'Manvel,ND',
'58257': 'Mayville,ND',
'58258': 'Mekinock,ND',
'58259': 'Michigan,ND',
'58260': 'Milton,ND',
'58261': 'Minto,ND',
'58262': 'Mountain,ND',
'58265': 'Neche,ND',
'58266': 'Niagara,ND',
'58267': 'Northwood,ND',
'58269': 'Osnabrock,ND',
'58270': 'Park River,ND',
'58271': 'Pembina,ND',
'58272': 'Petersburg,ND',
'58273': 'Pisek,ND',
'58274': 'Portland,ND',
'58275': 'Reynolds,ND',
'58276': 'Saint Thomas,ND',
'58277': 'Sharon,ND',
'58278': 'Thompson,ND',
'58281': 'Wales,ND',
'58282': 'Walhalla,ND',
'58301': 'Devils Lake,ND',
'58310': 'Agate,ND',
'58311': 'Alsen,ND',
'58313': 'Balta,ND',
'58316': 'Belcourt,ND',
'58317': 'Bisbee,ND',
'58318': 'Bottineau,ND',
'58319': 'Bremen,ND',
'58320': 'Brinsmade,ND',
'58321': 'Brocket,ND',
'58323': 'Calvin,ND',
'58324': 'Cando,ND',
'58325': 'Churchs Ferry,ND',
'58327': 'Crary,ND',
'58329': 'Dunseith,ND',
'58330': 'Edmore,ND',
'58331': 'Egeland,ND',
'58332': 'Esmond,ND',
'58335': 'Fort Totten,ND',
'58337': 'Hamberg,ND',
'58338': 'Hampden,ND',
'58339': 'Hansboro,ND',
'58341': 'Harvey,ND',
'58343': 'Knox,ND',
'58344': 'Lakota,ND',
'58345': 'Lawton,ND',
'58346': 'Leeds,ND',
'58348': 'Maddock,ND',
'58351': 'Minnewaukan,ND',
'58352': 'Munich,ND',
'58353': 'Mylo,ND',
'58355': 'Nekoma,ND',
'58356': 'New Rockford,ND',
'58357': 'Oberon,ND',
'58359': 'Orrin,ND',
'58361': 'Pekin,ND',
'58362': 'Penn,ND',
'58363': 'Perth,ND',
'58365': 'Rocklake,ND',
'58366': 'Rolette,ND',
'58367': 'Rolla,ND',
'58368': 'Rugby,ND',
'58369': 'Saint John,ND',
'58370': 'Saint Michael,ND',
'58372': 'Sarles,ND',
'58374': 'Sheyenne,ND',
'58377': 'Starkweather,ND',
'58379': 'Tokio,ND',
'58380': 'Tolna,ND',
'58381': 'Warwick,ND',
'58382': 'Webster,ND',
'58384': 'Willow City,ND',
'58385': 'Wolford,ND',
'58386': 'York,ND',
'58401': 'Jamestown,ND',
'58402': 'Jamestown,ND',
'58405': 'Jamestown,ND',
'58413': 'Ashley,ND',
'58415': 'Berlin,ND',
'58416': 'Binford,ND',
'58418': 'Bowdon,ND',
'58420': 'Buchanan,ND',
'58421': 'Carrington,ND',
'58422': 'Cathay,ND',
'58423': 'Chaseley,ND',
'58424': 'Cleveland,ND',
'58425': 'Cooperstown,ND',
'58426': 'Courtenay,ND',
'58428': 'Dawson,ND',
'58429': 'Dazey,ND',
'58430': 'Denhoff,ND',
'58431': 'Dickey,ND',
'58432': 'Eckelson,ND',
'58433': 'Edgeley,ND',
'58436': 'Ellendale,ND',
'58438': 'Fessenden,ND',
'58439': 'Forbes,ND',
'58440': 'Fredonia,ND',
'58441': 'Fullerton,ND',
'58442': 'Gackle,ND',
'58443': 'Glenfield,ND',
'58444': 'Goodrich,ND',
'58445': 'Grace City,ND',
'58448': 'Hannaford,ND',
'58451': 'Hurdsfield,ND',
'58452': 'Jessie,ND',
'58454': 'Jud,ND',
'58455': 'Kensal,ND',
'58456': 'Kulm,ND',
'58458': 'Lamoure,ND',
'58460': 'Lehr,ND',
'58461': 'Litchville,ND',
'58463': 'Mcclusky,ND',
'58464': 'Mchenry,ND',
'58466': 'Marion,ND',
'58467': 'Medina,ND',
'58472': 'Montpelier,ND',
'58474': 'Oakes,ND',
'58475': 'Pettibone,ND',
'58476': 'Pingree,ND',
'58477': 'Regan,ND',
'58478': 'Robinson,ND',
'58479': 'Rogers,ND',
'58480': 'Sanborn,ND',
'58481': 'Spiritwood,ND',
'58482': 'Steele,ND',
'58483': 'Streeter,ND',
'58484': 'Sutton,ND',
'58486': 'Sykeston,ND',
'58487': 'Tappen,ND',
'58488': 'Tuttle,ND',
'58489': 'Venturia,ND',
'58490': 'Verona,ND',
'58492': 'Wimbledon,ND',
'58494': 'Wing,ND',
'58495': 'Wishek,ND',
'58496': 'Woodworth,ND',
'58497': 'Ypsilanti,ND',
'58501': 'Bismarck,ND',
'58502': 'Bismarck,ND',
'58503': 'Bismarck,ND',
'58504': 'Bismarck,ND',
'58505': 'Bismarck,ND',
'58506': 'Bismarck,ND',
'58507': 'Bismarck,ND',
'58520': 'Almont,ND',
'58521': 'Baldwin,ND',
'58523': 'Beulah,ND',
'58524': 'Braddock,ND',
'58528': 'Cannon Ball,ND',
'58529': 'Carson,ND',
'58530': 'Center,ND',
'58531': 'Coleharbor,ND',
'58532': 'Driscoll,ND',
'58533': 'Elgin,ND',
'58535': 'Flasher,ND',
'58538': 'Fort Yates,ND',
'58540': 'Garrison,ND',
'58541': 'Golden Valley,ND',
'58542': 'Hague,ND',
'58544': 'Hazelton,ND',
'58545': 'Hazen,ND',
'58549': 'Kintyre,ND',
'58552': 'Linton,ND',
'58553': 'Mckenzie,ND',
'58554': 'Mandan,ND',
'58558': 'Menoken,ND',
'58559': 'Mercer,ND',
'58560': 'Moffit,ND',
'58561': 'Napoleon,ND',
'58562': 'New Leipzig,ND',
'58563': 'New Salem,ND',
'58564': 'Raleigh,ND',
'58565': 'Riverdale,ND',
'58566': 'Saint Anthony,ND',
'58568': 'Selfridge,ND',
'58569': 'Shields,ND',
'58570': 'Solen,ND',
'58571': 'Stanton,ND',
'58572': 'Sterling,ND',
'58573': 'Strasburg,ND',
'58575': 'Turtle Lake,ND',
'58576': 'Underwood,ND',
'58577': 'Washburn,ND',
'58579': 'Wilton,ND',
'58580': 'Zap,ND',
'58581': 'Zeeland,ND',
'58601': 'Dickinson,ND',
'58602': 'Dickinson,ND',
'58620': 'Amidon,ND',
'58621': 'Beach,ND',
'58622': 'Belfield,ND',
'58623': 'Bowman,ND',
'58625': 'Dodge,ND',
'58626': 'Dunn Center,ND',
'58627': 'Fairfield,ND',
'58630': 'Gladstone,ND',
'58631': 'Glen Ullin,ND',
'58632': 'Golva,ND',
'58634': 'Grassy Butte,ND',
'58636': 'Halliday,ND',
'58638': 'Hebron,ND',
'58639': 'Hettinger,ND',
'58640': 'Killdeer,ND',
'58641': 'Lefor,ND',
'58642': 'Manning,ND',
'58643': 'Marmarth,ND',
'58644': 'Marshall,ND',
'58645': 'Medora,ND',
'58646': 'Mott,ND',
'58647': 'New England,ND',
'58649': 'Reeder,ND',
'58650': 'Regent,ND',
'58651': 'Rhame,ND',
'58652': 'Richardton,ND',
'58653': 'Scranton,ND',
'58654': 'Sentinel Butte,ND',
'58655': 'South Heart,ND',
'58656': 'Taylor,ND',
'58701': 'Minot,ND',
'58702': 'Minot,ND',
'58703': 'Minot,ND',
'58704': 'Minot Afb,ND',
'58705': 'Minot Afb,ND',
'58707': 'Minot,ND',
'58710': 'Anamoose,ND',
'58711': 'Antler,ND',
'58712': 'Balfour,ND',
'58713': 'Bantry,ND',
'58716': 'Benedict,ND',
'58718': 'Berthold,ND',
'58721': 'Bowbells,ND',
'58722': 'Burlington,ND',
'58723': 'Butte,ND',
'58725': 'Carpio,ND',
'58727': 'Columbus,ND',
'58730': 'Crosby,ND',
'58731': 'Deering,ND',
'58733': 'Des Lacs,ND',
'58734': 'Donnybrook,ND',
'58735': 'Douglas,ND',
'58736': 'Drake,ND',
'58737': 'Flaxton,ND',
'58740': 'Glenburn,ND',
'58741': 'Granville,ND',
'58744': 'Karlsruhe,ND',
'58746': 'Kenmare,ND',
'58747': 'Kief,ND',
'58748': 'Kramer,ND',
'58750': 'Lansford,ND',
'58752': 'Lignite,ND',
'58755': 'Mcgregor,ND',
'58756': 'Makoti,ND',
'58757': 'Mandaree,ND',
'58758': 'Martin,ND',
'58759': 'Max,ND',
'58760': 'Maxbass,ND',
'58761': 'Mohall,ND',
'58762': 'Newburg,ND',
'58763': 'New Town,ND',
'58765': 'Noonan,ND',
'58768': 'Norwich,ND',
'58769': 'Palermo,ND',
'58770': 'Parshall,ND',
'58771': 'Plaza,ND',
'58772': 'Portal,ND',
'58773': 'Powers Lake,ND',
'58775': 'Roseglen,ND',
'58776': 'Ross,ND',
'58778': 'Ruso,ND',
'58779': 'Ryder,ND',
'58781': 'Sawyer,ND',
'58782': 'Sherwood,ND',
'58783': 'Souris,ND',
'58784': 'Stanley,ND',
'58785': 'Surrey,ND',
'58787': 'Tolley,ND',
'58788': 'Towner,ND',
'58789': 'Upham,ND',
'58790': 'Velva,ND',
'58792': 'Voltaire,ND',
'58793': 'Westhope,ND',
'58794': 'White Earth,ND',
'58795': 'Wildrose,ND',
'58801': 'Williston,ND',
'58802': 'Williston,ND',
'58830': 'Alamo,ND',
'58831': 'Alexander,ND',
'58833': 'Ambrose,ND',
'58835': 'Arnegard,ND',
'58838': 'Cartwright,ND',
'58843': 'Epping,ND',
'58844': 'Fortuna,ND',
'58845': 'Grenora,ND',
'58847': 'Keene,ND',
'58849': 'Ray,ND',
'58852': 'Tioga,ND',
'58853': 'Trenton,ND',
'58854': 'Watford City,ND',
'58856': 'Zahl,ND',
'59001': 'Absarokee,MT',
'59002': 'Acton,MT',
'59003': 'Ashland,MT',
'59004': 'Ashland,MT',
'59006': 'Ballantine,MT',
'59007': 'Bearcreek,MT',
'59008': 'Belfry,MT',
'59010': 'Bighorn,MT',
'59011': 'Big Timber,MT',
'59012': 'Birney,MT',
'59013': 'Boyd,MT',
'59014': 'Bridger,MT',
'59015': 'Broadview,MT',
'59016': 'Busby,MT',
'59018': 'Clyde Park,MT',
'59019': 'Columbus,MT',
'59020': 'Cooke City,MT',
'59022': 'Crow Agency,MT',
'59024': 'Custer,MT',
'59025': 'Decker,MT',
'59026': 'Edgar,MT',
'59027': 'Emigrant,MT',
'59028': 'Fishtail,MT',
'59029': 'Fromberg,MT',
'59030': 'Gardiner,MT',
'59031': 'Garryowen,MT',
'59032': 'Grass Range,MT',
'59033': 'Greycliff,MT',
'59034': 'Hardin,MT',
'59035': 'Yellowtail,MT',
'59036': 'Harlowton,MT',
'59037': 'Huntley,MT',
'59038': 'Hysham,MT',
'59039': 'Ingomar,MT',
'59041': 'Joliet,MT',
'59043': 'Lame Deer,MT',
'59044': 'Laurel,MT',
'59046': 'Lavina,MT',
'59047': 'Livingston,MT',
'59050': 'Lodge Grass,MT',
'59052': 'Mc Leod,MT',
'59053': 'Martinsdale,MT',
'59054': 'Melstone,MT',
'59055': 'Melville,MT',
'59057': 'Molt,MT',
'59058': 'Mosby,MT',
'59059': 'Musselshell,MT',
'59061': 'Nye,MT',
'59062': 'Otter,MT',
'59063': 'Park City,MT',
'59064': 'Pompeys Pillar,MT',
'59065': 'Pray,MT',
'59066': 'Pryor,MT',
'59067': 'Rapelje,MT',
'59068': 'Red Lodge,MT',
'59069': 'Reed Point,MT',
'59070': 'Roberts,MT',
'59071': 'Roscoe,MT',
'59072': 'Roundup,MT',
'59073': 'Roundup,MT',
'59074': 'Ryegate,MT',
'59075': 'Saint Xavier,MT',
'59076': 'Sanders,MT',
'59077': 'Sand Springs,MT',
'59078': 'Shawmut,MT',
'59079': 'Shepherd,MT',
'59081': 'Silver Gate,MT',
'59082': 'Springdale,MT',
'59083': 'Sumatra,MT',
'59084': 'Teigen,MT',
'59085': 'Two Dot,MT',
'59086': 'Wilsall,MT',
'59087': 'Winnett,MT',
'59088': 'Worden,MT',
'59089': 'Wyola,MT',
'59101': 'Billings,MT',
'59102': 'Billings,MT',
'59103': 'Billings,MT',
'59104': 'Billings,MT',
'59105': 'Billings,MT',
'59106': 'Billings,MT',
'59107': 'Billings,MT',
'59108': 'Billings,MT',
'59111': 'Billings,MT',
'59112': 'Billings,MT',
'59114': 'Billings,MT',
'59115': 'Billings,MT',
'59116': 'Billings,MT',
'59117': 'Billings,MT',
'59201': 'Wolf Point,MT',
'59211': 'Antelope,MT',
'59212': 'Bainville,MT',
'59213': 'Brockton,MT',
'59214': 'Brockway,MT',
'59215': 'Circle,MT',
'59217': 'Crane,MT',
'59218': 'Culbertson,MT',
'59219': 'Dagmar,MT',
'59221': 'Fairview,MT',
'59222': 'Flaxville,MT',
'59223': 'Fort Peck,MT',
'59225': 'Frazer,MT',
'59226': 'Froid,MT',
'59230': 'Glasgow,MT',
'59231': 'Saint Marie,MT',
'59240': 'Glentana,MT',
'59241': 'Hinsdale,MT',
'59242': 'Homestead,MT',
'59243': 'Lambert,MT',
'59244': 'Larslan,MT',
'59245': 'Mc Cabe,MT',
'59247': 'Medicine Lake,MT',
'59248': 'Nashua,MT',
'59250': 'Opheim,MT',
'59252': 'Outlook,MT',
'59253': 'Peerless,MT',
'59254': 'Plentywood,MT',
'59255': 'Poplar,MT',
'59256': 'Raymond,MT',
'59257': 'Redstone,MT',
'59258': 'Reserve,MT',
'59259': 'Richey,MT',
'59260': 'Richland,MT',
'59261': 'Saco,MT',
'59262': 'Savage,MT',
'59263': 'Scobey,MT',
'59270': 'Sidney,MT',
'59273': 'Vandalia,MT',
'59274': 'Vida,MT',
'59275': 'Westby,MT',
'59276': 'Whitetail,MT',
'59301': 'Miles City,MT',
'59311': 'Alzada,MT',
'59312': 'Angela,MT',
'59313': 'Baker,MT',
'59314': 'Biddle,MT',
'59315': 'Bloomfield,MT',
'59316': 'Boyes,MT',
'59317': 'Broadus,MT',
'59318': 'Brusett,MT',
'59319': 'Capitol,MT',
'59322': 'Cohagen,MT',
'59323': 'Colstrip,MT',
'59324': 'Ekalaka,MT',
'59326': 'Fallon,MT',
'59327': 'Forsyth,MT',
'59330': 'Glendive,MT',
'59332': 'Hammond,MT',
'59333': 'Hathaway,MT',
'59336': 'Ismay,MT',
'59337': 'Jordan,MT',
'59338': 'Kinsey,MT',
'59339': 'Lindsay,MT',
'59341': 'Mildred,MT',
'59343': 'Olive,MT',
'59344': 'Plevna,MT',
'59345': 'Powderville,MT',
'59347': 'Rosebud,MT',
'59348': 'Sonnette,MT',
'59349': 'Terry,MT',
'59351': 'Volborg,MT',
'59353': 'Wibaux,MT',
'59354': 'Willard,MT',
'59401': 'Great Falls,MT',
'59402': 'Malmstrom A F B,MT',
'59403': 'Great Falls,MT',
'59404': 'Great Falls,MT',
'59405': 'Great Falls,MT',
'59406': 'Great Falls,MT',
'59410': 'Augusta,MT',
'59411': 'Babb,MT',
'59412': 'Belt,MT',
'59414': 'Black Eagle,MT',
'59416': 'Brady,MT',
'59417': 'Browning,MT',
'59418': 'Buffalo,MT',
'59419': 'Bynum,MT',
'59420': 'Carter,MT',
'59421': 'Cascade,MT',
'59422': 'Choteau,MT',
'59424': 'Coffee Creek,MT',
'59425': 'Conrad,MT',
'59427': 'Cut Bank,MT',
'59430': 'Denton,MT',
'59432': 'Dupuyer,MT',
'59433': 'Dutton,MT',
'59434': 'East Glacier Park,MT',
'59435': 'Ethridge,MT',
'59436': 'Fairfield,MT',
'59440': 'Floweree,MT',
'59441': 'Forestgrove,MT',
'59442': 'Fort Benton,MT',
'59443': 'Fort Shaw,MT',
'59444': 'Galata,MT',
'59445': 'Garneill,MT',
'59446': 'Geraldine,MT',
'59447': 'Geyser,MT',
'59448': 'Heart Butte,MT',
'59450': 'Highwood,MT',
'59451': 'Hilger,MT',
'59452': 'Hobson,MT',
'59453': 'Judith Gap,MT',
'59454': 'Kevin,MT',
'59456': 'Ledger,MT',
'59457': 'Lewistown,MT',
'59460': 'Loma,MT',
'59461': 'Lothair,MT',
'59462': 'Moccasin,MT',
'59463': 'Monarch,MT',
'59464': 'Moore,MT',
'59465': 'Neihart,MT',
'59466': 'Oilmont,MT',
'59467': 'Pendroy,MT',
'59468': 'Power,MT',
'59469': 'Raynesford,MT',
'59471': 'Roy,MT',
'59472': 'Sand Coulee,MT',
'59473': 'Santa Rita,MT',
'59474': 'Shelby,MT',
'59477': 'Simms,MT',
'59479': 'Stanford,MT',
'59480': 'Stockett,MT',
'59482': 'Sunburst,MT',
'59483': 'Sun River,MT',
'59484': 'Sweet Grass,MT',
'59485': 'Ulm,MT',
'59486': 'Valier,MT',
'59487': 'Vaughn,MT',
'59489': 'Winifred,MT',
'59501': 'Havre,MT',
'59520': 'Big Sandy,MT',
'59521': 'Box Elder,MT',
'59522': 'Chester,MT',
'59523': 'Chinook,MT',
'59524': 'Dodson,MT',
'59525': 'Gildford,MT',
'59526': 'Harlem,MT',
'59527': 'Hays,MT',
'59528': 'Hingham,MT',
'59529': 'Hogeland,MT',
'59530': 'Inverness,MT',
'59531': 'Joplin,MT',
'59532': 'Kremlin,MT',
'59535': 'Lloyd,MT',
'59537': 'Loring,MT',
'59538': 'Malta,MT',
'59540': 'Rudyard,MT',
'59542': 'Turner,MT',
'59544': 'Whitewater,MT',
'59545': 'Whitlash,MT',
'59546': 'Zortman,MT',
'59547': 'Zurich,MT',
'59601': 'Helena,MT',
'59602': 'Helena,MT',
'59604': 'Helena,MT',
'59620': 'Helena,MT',
'59623': 'Helena,MT',
'59624': 'Helena,MT',
'59625': 'Helena,MT',
'59626': 'Helena,MT',
'59631': 'Basin,MT',
'59632': 'Boulder,MT',
'59633': 'Canyon Creek,MT',
'59634': 'Clancy,MT',
'59635': 'East Helena,MT',
'59636': 'Fort Harrison,MT',
'59638': 'Jefferson City,MT',
'59639': 'Lincoln,MT',
'59640': 'Marysville,MT',
'59641': 'Radersburg,MT',
'59642': 'Ringling,MT',
'59643': 'Toston,MT',
'59644': 'Townsend,MT',
'59645': 'White Sulphur Springs,MT',
'59647': 'Winston,MT',
'59648': 'Wolf Creek,MT',
'59701': 'Butte,MT',
'59702': 'Butte,MT',
'59703': 'Butte,MT',
'59707': 'Butte,MT',
'59710': 'Alder,MT',
'59711': 'Anaconda,MT',
'59713': 'Avon,MT',
'59714': 'Belgrade,MT',
'59715': 'Bozeman,MT',
'59716': 'Big Sky,MT',
'59717': 'Bozeman,MT',
'59718': 'Bozeman,MT',
'59719': 'Bozeman,MT',
'59720': 'Cameron,MT',
'59721': 'Cardwell,MT',
'59722': 'Deer Lodge,MT',
'59724': 'Dell,MT',
'59725': 'Dillon,MT',
'59727': 'Divide,MT',
'59728': 'Elliston,MT',
'59729': 'Ennis,MT',
'59730': 'Gallatin Gateway,MT',
'59731': 'Garrison,MT',
'59732': 'Glen,MT',
'59733': 'Gold Creek,MT',
'59735': 'Harrison,MT',
'59736': 'Jackson,MT',
'59739': 'Lima,MT',
'59740': 'Mc Allister,MT',
'59741': 'Manhattan,MT',
'59743': 'Melrose,MT',
'59745': 'Norris,MT',
'59746': 'Polaris,MT',
'59747': 'Pony,MT',
'59748': 'Ramsay,MT',
'59749': 'Sheridan,MT',
'59750': 'Butte,MT',
'59751': 'Silver Star,MT',
'59752': 'Three Forks,MT',
'59754': 'Twin Bridges,MT',
'59755': 'Virginia City,MT',
'59756': 'Warm Springs,MT',
'59758': 'West Yellowstone,MT',
'59759': 'Whitehall,MT',
'59760': 'Willow Creek,MT',
'59761': 'Wisdom,MT',
'59762': 'Wise River,MT',
'59771': 'Bozeman,MT',
'59772': 'Bozeman,MT',
'59773': 'Bozeman,MT',
'59801': 'Missoula,MT',
'59802': 'Missoula,MT',
'59803': 'Missoula,MT',
'59804': 'Missoula,MT',
'59806': 'Missoula,MT',
'59807': 'Missoula,MT',
'59808': 'Missoula,MT',
'59812': 'Missoula,MT',
'59820': 'Alberton,MT',
'59821': 'Arlee,MT',
'59823': 'Bonner,MT',
'59824': 'Charlo,MT',
'59825': 'Clinton,MT',
'59826': 'Condon,MT',
'59827': 'Conner,MT',
'59828': 'Corvallis,MT',
'59829': 'Darby,MT',
'59830': 'De Borgia,MT',
'59831': 'Dixon,MT',
'59832': 'Drummond,MT',
'59833': 'Florence,MT',
'59834': 'Frenchtown,MT',
'59835': 'Grantsdale,MT',
'59836': 'Greenough,MT',
'59837': 'Hall,MT',
'59840': 'Hamilton,MT',
'59841': 'Pinesdale,MT',
'59842': 'Haugan,MT',
'59843': 'Helmville,MT',
'59844': 'Heron,MT',
'59845': 'Hot Springs,MT',
'59846': 'Huson,MT',
'59847': 'Lolo,MT',
'59848': 'Lonepine,MT',
'59851': 'Milltown,MT',
'59853': 'Noxon,MT',
'59854': 'Ovando,MT',
'59855': 'Pablo,MT',
'59856': 'Paradise,MT',
'59858': 'Philipsburg,MT',
'59859': 'Plains,MT',
'59860': 'Polson,MT',
'59863': 'Ravalli,MT',
'59864': 'Ronan,MT',
'59865': 'Saint Ignatius,MT',
'59866': 'Saint Regis,MT',
'59867': 'Saltese,MT',
'59868': 'Seeley Lake,MT',
'59870': 'Stevensville,MT',
'59871': 'Sula,MT',
'59872': 'Superior,MT',
'59873': 'Thompson Falls,MT',
'59874': 'Trout Creek,MT',
'59875': 'Victor,MT',
'59901': 'Kalispell,MT',
'59902': 'Kalispell,MT',
'59903': 'Kalispell,MT',
'59904': 'Kalispell,MT',
'59910': 'Big Arm,MT',
'59911': 'Bigfork,MT',
'59912': 'Columbia Falls,MT',
'59913': 'Coram,MT',
'59914': 'Dayton,MT',
'59915': 'Elmo,MT',
'59916': 'Essex,MT',
'59917': 'Eureka,MT',
'59918': 'Fortine,MT',
'59919': 'Hungry Horse,MT',
'59920': 'Kila,MT',
'59921': 'Lake Mc Donald,MT',
'59922': 'Lakeside,MT',
'59923': 'Libby,MT',
'59925': 'Marion,MT',
'59926': 'Martin City,MT',
'59927': 'Olney,MT',
'59928': 'Polebridge,MT',
'59929': 'Proctor,MT',
'59930': 'Rexford,MT',
'59931': 'Rollins,MT',
'59932': 'Somers,MT',
'59933': 'Stryker,MT',
'59934': 'Trego,MT',
'59935': 'Troy,MT',
'59936': 'West Glacier,MT',
'59937': 'Whitefish,MT',
'60001': 'Alden,IL',
'60002': 'Antioch,IL',
'60004': 'Arlington Heights,IL',
'60005': 'Arlington Heights,IL',
'60006': 'Arlington Heights,IL',
'60007': 'Elk Grove Village,IL',
'60008': 'Rolling Meadows,IL',
'60009': 'Elk Grove Village,IL',
'60010': 'Barrington,IL',
'60011': 'Barrington,IL',
'60012': 'Crystal Lake,IL',
'60013': 'Cary,IL',
'60014': 'Crystal Lake,IL',
'60015': 'Deerfield,IL',
'60016': 'Des Plaines,IL',
'60017': 'Des Plaines,IL',
'60018': 'Des Plaines,IL',
'60019': 'Des Plaines,IL',
'60020': 'Fox Lake,IL',
'60021': 'Fox River Grove,IL',
'60022': 'Glencoe,IL',
'60025': 'Glenview,IL',
'60026': 'Glenview Nas,IL',
'60029': 'Golf,IL',
'60030': 'Grayslake,IL',
'60031': 'Gurnee,IL',
'60033': 'Harvard,IL',
'60034': 'Hebron,IL',
'60035': 'Highland Park,IL',
'60037': 'Fort Sheridan,IL',
'60038': 'Palatine,IL',
'60039': 'Crystal Lake,IL',
'60040': 'Highwood,IL',
'60041': 'Ingleside,IL',
'60042': 'Island Lake,IL',
'60043': 'Kenilworth,IL',
'60044': 'Lake Bluff,IL',
'60045': 'Lake Forest,IL',
'60046': 'Lake Villa,IL',
'60047': 'Lake Zurich,IL',
'60048': 'Libertyville,IL',
'60049': 'Long Grove,IL',
'60050': 'Mchenry,IL',
'60051': 'Mchenry,IL',
'60053': 'Morton Grove,IL',
'60055': 'Palatine,IL',
'60056': 'Mount Prospect,IL',
'60060': 'Mundelein,IL',
'60061': 'Vernon Hills,IL',
'60062': 'Northbrook,IL',
'60064': 'North Chicago,IL',
'60065': 'Northbrook,IL',
'60067': 'Palatine,IL',
'60068': 'Park Ridge,IL',
'60069': 'Lincolnshire,IL',
'60070': 'Prospect Heights,IL',
'60071': 'Richmond,IL',
'60072': 'Ringwood,IL',
'60073': 'Round Lake,IL',
'60074': 'Palatine,IL',
'60075': 'Russell,IL',
'60076': 'Skokie,IL',
'60077': 'Skokie,IL',
'60078': 'Palatine,IL',
'60079': 'Waukegan,IL',
'60080': 'Solon Mills,IL',
'60081': 'Spring Grove,IL',
'60082': 'Techny,IL',
'60083': 'Wadsworth,IL',
'60084': 'Wauconda,IL',
'60085': 'Waukegan,IL',
'60086': 'North Chicago,IL',
'60087': 'Waukegan,IL',
'60088': 'Great Lakes,IL',
'60089': 'Buffalo Grove,IL',
'60090': 'Wheeling,IL',
'60091': 'Wilmette,IL',
'60092': 'Libertyville,IL',
'60093': 'Winnetka,IL',
'60094': 'Palatine,IL',
'60095': 'Palatine,IL',
'60096': 'Winthrop Harbor,IL',
'60097': 'Wonder Lake,IL',
'60098': 'Woodstock,IL',
'60099': 'Zion,IL',
'60101': 'Addison,IL',
'60102': 'Algonquin,IL',
'60103': 'Bartlett,IL',
'60104': 'Bellwood,IL',
'60105': 'Bensenville,IL',
'60106': 'Bensenville,IL',
'60107': 'Streamwood,IL',
'60108': 'Bloomingdale,IL',
'60109': 'Burlington,IL',
'60110': 'Carpentersville,IL',
'60111': 'Clare,IL',
'60112': 'Cortland,IL',
'60113': 'Creston,IL',
'60115': 'Dekalb,IL',
'60116': 'Carol Stream,IL',
'60117': 'Bloomingdale,IL',
'60118': 'Dundee,IL',
'60119': 'Elburn,IL',
'60120': 'Elgin,IL',
'60121': 'Elgin,IL',
'60122': 'Elgin,IL',
'60123': 'Elgin,IL',
'60124': 'Plato Center,IL',
'60125': 'Carol Stream,IL',
'60126': 'Elmhurst,IL',
'60128': 'Carol Stream,IL',
'60129': 'Esmond,IL',
'60130': 'Forest Park,IL',
'60131': 'Franklin Park,IL',
'60132': 'Carol Stream,IL',
'60133': 'Hanover Park,IL',
'60134': 'Geneva,IL',
'60135': 'Genoa,IL',
'60136': 'Gilberts,IL',
'60137': 'Glen Ellyn,IL',
'60138': 'Glen Ellyn,IL',
'60139': 'Glendale Heights,IL',
'60140': 'Hampshire,IL',
'60141': 'Hines,IL',
'60142': 'Huntley,IL',
'60143': 'Itasca,IL',
'60144': 'Kaneville,IL',
'60145': 'Kingston,IL',
'60146': 'Kirkland,IL',
'60147': 'Lafox,IL',
'60148': 'Lombard,IL',
'60150': 'Malta,IL',
'60151': 'Maple Park,IL',
'60152': 'Marengo,IL',
'60153': 'Maywood,IL',
'60154': 'Westchester,IL',
'60155': 'Broadview,IL',
'60156': 'Lake In The Hills,IL',
'60157': 'Medinah,IL',
'60159': 'Schaumburg,IL',
'60160': 'Melrose Park,IL',
'60161': 'Melrose Park,IL',
'60162': 'Hillside,IL',
'60163': 'Berkeley,IL',
'60164': 'Melrose Park,IL',
'60165': 'Stone Park,IL',
'60168': 'Schaumburg,IL',
'60169': 'Hoffman Estates,IL',
'60170': 'Plato Center,IL',
'60171': 'River Grove,IL',
'60172': 'Roselle,IL',
'60173': 'Schaumburg,IL',
'60174': 'Saint Charles,IL',
'60175': 'Saint Charles,IL',
'60176': 'Schiller Park,IL',
'60177': 'South Elgin,IL',
'60178': 'Sycamore,IL',
'60179': 'Hoffman Estates,IL',
'60180': 'Union,IL',
'60181': 'Villa Park,IL',
'60182': 'Virgil,IL',
'60183': 'Wasco,IL',
'60184': 'Wayne,IL',
'60185': 'West Chicago,IL',
'60186': 'West Chicago,IL',
'60187': 'Wheaton,IL',
'60188': 'Carol Stream,IL',
'60189': 'Wheaton,IL',
'60190': 'Winfield,IL',
'60191': 'Wood Dale,IL',
'60192': 'Schaumburg,IL',
'60193': 'Schaumburg,IL',
'60194': 'Schaumburg,IL',
'60195': 'Schaumburg,IL',
'60196': 'Schaumburg,IL',
'60197': 'Carol Stream,IL',
'60199': 'Carol Stream,IL',
'60201': 'Evanston,IL',
'60202': 'Evanston,IL',
'60203': 'Evanston,IL',
'60204': 'Evanston,IL',
'60208': 'Evanston,IL',
'60209': 'Evanston,IL',
'60301': 'Oak Park,IL',
'60302': 'Oak Park,IL',
'60303': 'Oak Park,IL',
'60304': 'Oak Park,IL',
'60305': 'River Forest,IL',
'60399': 'Bensenville,IL',
'60401': 'Beecher,IL',
'60402': 'Berwyn,IL',
'60403': 'Joliet,IL',
'60404': 'Shorewood,IL',
'60406': 'Blue Island,IL',
'60407': 'Braceville,IL',
'60408': 'Braidwood,IL',
'60409': 'Calumet City,IL',
'60410': 'Channahon,IL',
'60411': 'Chicago Heights,IL',
'60412': 'Chicago Heights,IL',
'60415': 'Chicago Ridge,IL',
'60416': 'Coal City,IL',
'60417': 'Crete,IL',
'60419': 'Dolton,IL',
'60420': 'Dwight,IL',
'60421': 'Elwood,IL',
'60422': 'Flossmoor,IL',
'60423': 'Frankfort,IL',
'60424': 'Gardner,IL',
'60425': 'Glenwood,IL',
'60426': 'Harvey,IL',
'60428': 'Markham,IL',
'60429': 'Hazel Crest,IL',
'60430': 'Homewood,IL',
'60431': 'Joliet,IL',
'60432': 'Joliet,IL',
'60433': 'Joliet,IL',
'60434': 'Joliet,IL',
'60435': 'Joliet,IL',
'60436': 'Joliet,IL',
'60437': 'Kinsman,IL',
'60438': 'Lansing,IL',
'60439': 'Lemont,IL',
'60440': 'Bolingbrook,IL',
'60441': 'Lockport,IL',
'60442': 'Manhattan,IL',
'60443': 'Matteson,IL',
'60444': 'Mazon,IL',
'60445': 'Midlothian,IL',
'60446': 'Romeoville,IL',
'60447': 'Minooka,IL',
'60448': 'Mokena,IL',
'60449': 'Monee,IL',
'60450': 'Morris,IL',
'60451': 'New Lenox,IL',
'60452': 'Oak Forest,IL',
'60453': 'Oak Lawn,IL',
'60454': 'Oak Lawn,IL',
'60455': 'Bridgeview,IL',
'60456': 'Hometown,IL',
'60457': 'Hickory Hills,IL',
'60458': 'Justice,IL',
'60459': 'Burbank,IL',
'60460': 'Odell,IL',
'60461': 'Olympia Fields,IL',
'60462': 'Orland Park,IL',
'60463': 'Palos Heights,IL',
'60464': 'Palos Park,IL',
'60465': 'Palos Hills,IL',
'60466': 'Park Forest,IL',
'60467': 'Orland Park,IL',
'60468': 'Peotone,IL',
'60469': 'Posen,IL',
'60470': 'Ransom,IL',
'60471': 'Richton Park,IL',
'60472': 'Robbins,IL',
'60473': 'South Holland,IL',
'60474': 'South Wilmington,IL',
'60475': 'Steger,IL',
'60476': 'Thornton,IL',
'60477': 'Tinley Park,IL',
'60478': 'Country Club Hills,IL',
'60479': 'Verona,IL',
'60480': 'Willow Springs,IL',
'60481': 'Wilmington,IL',
'60482': 'Worth,IL',
'60484': 'University Pk,IL',
'60487': 'Tinley Park,IL',
'60490': 'Bolingbrook,IL',
'60491': 'Romeoville,IL',
'60499': 'Bedford Park,IL',
'60501': 'Summit Argo,IL',
'60502': 'Aurora,IL',
'60503': 'Aurora,IL',
'60504': 'Aurora,IL',
'60505': 'Aurora,IL',
'60506': 'Aurora,IL',
'60507': 'Aurora,IL',
'60510': 'Batavia,IL',
'60511': 'Big Rock,IL',
'60512': 'Bristol,IL',
'60513': 'Brookfield,IL',
'60514': 'Clarendon Hills,IL',
'60515': 'Downers Grove,IL',
'60516': 'Downers Grove,IL',
'60517': 'Woodridge,IL',
'60518': 'Earlville,IL',
'60519': 'Eola,IL',
'60520': 'Hinckley,IL',
'60521': 'Hinsdale,IL',
'60522': 'Hinsdale,IL',
'60523': 'Oak Brook,IL',
'60525': 'La Grange,IL',
'60526': 'La Grange Park,IL',
'60527': 'Willowbrook,IL',
'60530': 'Lee,IL',
'60531': 'Leland,IL',
'60532': 'Lisle,IL',
'60534': 'Lyons,IL',
'60536': 'Millbrook,IL',
'60537': 'Millington,IL',
'60538': 'Montgomery,IL',
'60539': 'Mooseheart,IL',
'60540': 'Naperville,IL',
'60541': 'Newark,IL',
'60542': 'North Aurora,IL',
'60543': 'Oswego,IL',
'60544': 'Plainfield,IL',
'60545': 'Plano,IL',
'60546': 'Riverside,IL',
'60548': 'Sandwich,IL',
'60549': 'Serena,IL',
'60550': 'Shabbona,IL',
'60551': 'Sheridan,IL',
'60552': 'Somonauk,IL',
'60553': 'Steward,IL',
'60554': 'Sugar Grove,IL',
'60555': 'Warrenville,IL',
'60556': 'Waterman,IL',
'60557': 'Wedron,IL',
'60558': 'Western Springs,IL',
'60559': 'Westmont,IL',
'60560': 'Yorkville,IL',
'60561': 'Darien,IL',
'60563': 'Naperville,IL',
'60564': 'Naperville,IL',
'60565': 'Naperville,IL',
'60566': 'Naperville,IL',
'60567': 'Naperville,IL',
'60568': 'Aurora,IL',
'60570': 'Hinsdale,IL',
'60572': 'Aurora,IL',
'60585': 'Plainfield,IL',
'60597': 'Fox Valley,IL',
'60598': 'Aurora,IL',
'60599': 'Fox Valley,IL',
'60601': 'Chicago,IL',
'60602': 'Chicago,IL',
'60603': 'Chicago,IL',
'60604': 'Chicago,IL',
'60605': 'Chicago,IL',
'60606': 'Chicago,IL',
'60607': 'Chicago,IL',
'60608': 'Chicago,IL',
'60609': 'Chicago,IL',
'60610': 'Chicago,IL',
'60611': 'Chicago,IL',
'60612': 'Chicago,IL',
'60613': 'Chicago,IL',
'60614': 'Chicago,IL',
'60615': 'Chicago,IL',
'60616': 'Chicago,IL',
'60617': 'Chicago,IL',
'60618': 'Chicago,IL',
'60619': 'Chicago,IL',
'60620': 'Chicago,IL',
'60621': 'Chicago,IL',
'60622': 'Chicago,IL',
'60623': 'Chicago,IL',
'60624': 'Chicago,IL',
'60625': 'Chicago,IL',
'60626': 'Chicago,IL',
'60628': 'Chicago,IL',
'60629': 'Chicago,IL',
'60630': 'Chicago,IL',
'60631': 'Chicago,IL',
'60632': 'Chicago,IL',
'60633': 'Chicago,IL',
'60634': 'Chicago,IL',
'60636': 'Chicago,IL',
'60637': 'Chicago,IL',
'60638': 'Chicago,IL',
'60639': 'Chicago,IL',
'60640': 'Chicago,IL',
'60641': 'Chicago,IL',
'60642': 'Evergreen Park,IL',
'60643': 'Chicago,IL',
'60644': 'Chicago,IL',
'60645': 'Chicago,IL',
'60646': 'Chicago,IL',
'60647': 'Chicago,IL',
'60649': 'Chicago,IL',
'60651': 'Chicago,IL',
'60652': 'Chicago,IL',
'60653': 'Chicago,IL',
'60654': 'Chicago,IL',
'60655': 'Chicago,IL',
'60656': 'Chicago,IL',
'60657': 'Chicago,IL',
'60659': 'Chicago,IL',
'60660': 'Chicago,IL',
'60661': 'Chicago,IL',
'60663': 'Chicago,IL',
'60664': 'Chicago,IL',
'60665': 'Chicago,IL',
'60666': 'Amf Ohare,IL',
'60667': 'Chicago,IL',
'60668': 'Chicago,IL',
'60669': 'Chicago,IL',
'60670': 'Chicago,IL',
'60671': 'Chicago,IL',
'60672': 'Chicago,IL',
'60673': 'Chicago,IL',
'60674': 'Chicago,IL',
'60675': 'Chicago,IL',
'60677': 'Chicago,IL',
'60678': 'Chicago,IL',
'60679': 'Chicago,IL',
'60680': 'Chicago,IL',
'60681': 'Chicago,IL',
'60682': 'La Salle National Bank,IL',
'60683': 'Chicago,IL',
'60684': 'Chicago,IL',
'60685': 'Chicago,IL',
'60686': 'National City Bank,IL',
'60687': 'Chicago,IL',
'60688': 'Chicago,IL',
'60689': 'Fifth Third Bank,IL',
'60690': 'Chicago,IL',
'60691': 'Chicago,IL',
'60693': 'Chicago,IL',
'60694': 'Chicago,IL',
'60695': 'Jp Morgan Chase,IL',
'60696': 'Chicago,IL',
'60697': 'Chicago,IL',
'60699': 'Chicago,IL',
'60701': 'Chicago,IL',
'60706': 'Harwood Heights,IL',
'60707': 'Elmwood Park,IL',
'60712': 'Lincolnwood,IL',
'60714': 'Niles,IL',
'60803': 'Alsip,IL',
'60804': 'Cicero,IL',
'60805': 'Evergreen Park,IL',
'60827': 'Riverdale,IL',
'60901': 'Kankakee,IL',
'60902': 'Kankakee,IL',
'60910': 'Aroma Park,IL',
'60911': 'Ashkum,IL',
'60912': 'Beaverville,IL',
'60913': 'Bonfield,IL',
'60914': 'Bourbonnais,IL',
'60915': 'Bradley,IL',
'60917': 'Buckingham,IL',
'60918': 'Buckley,IL',
'60919': 'Cabery,IL',
'60920': 'Campus,IL',
'60921': 'Chatsworth,IL',
'60922': 'Chebanse,IL',
'60924': 'Cissna Park,IL',
'60926': 'Claytonville,IL',
'60927': 'Clifton,IL',
'60928': 'Crescent City,IL',
'60929': 'Cullom,IL',
'60930': 'Danforth,IL',
'60931': 'Donovan,IL',
'60932': 'East Lynn,IL',
'60933': 'Elliott,IL',
'60934': 'Emington,IL',
'60935': 'Essex,IL',
'60936': 'Gibson City,IL',
'60938': 'Gilman,IL',
'60939': 'Goodwine,IL',
'60940': 'Grant Park,IL',
'60941': 'Herscher,IL',
'60942': 'Hoopeston,IL',
'60944': 'Hopkins Park,IL',
'60945': 'Iroquois,IL',
'60946': 'Kempton,IL',
'60948': 'Loda,IL',
'60949': 'Ludlow,IL',
'60950': 'Manteno,IL',
'60951': 'Martinton,IL',
'60952': 'Melvin,IL',
'60953': 'Milford,IL',
'60954': 'Momence,IL',
'60955': 'Onarga,IL',
'60956': 'Papineau,IL',
'60957': 'Paxton,IL',
'60958': 'Saint Anne,IL',
'60959': 'Piper City,IL',
'60960': 'Rankin,IL',
'60961': 'Reddick,IL',
'60962': 'Roberts,IL',
'60963': 'Rossville,IL',
'60964': 'Saint Anne,IL',
'60966': 'Sheldon,IL',
'60967': 'Stockland,IL',
'60968': 'Thawville,IL',
'60969': 'Union Hill,IL',
'60970': 'Watseka,IL',
'60973': 'Wellington,IL',
'60974': 'Woodland,IL',
'61001': 'Apple River,IL',
'61006': 'Ashton,IL',
'61007': 'Baileyville,IL',
'61008': 'Belvidere,IL',
'61010': 'Byron,IL',
'61011': 'Caledonia,IL',
'61012': 'Capron,IL',
'61013': 'Cedarville,IL',
'61014': 'Chadwick,IL',
'61015': 'Chana,IL',
'61016': 'Cherry Valley,IL',
'61018': 'Dakota,IL',
'61019': 'Davis,IL',
'61020': 'Davis Junction,IL',
'61021': 'Dixon,IL',
'61024': 'Durand,IL',
'61025': 'East Dubuque,IL',
'61027': 'Eleroy,IL',
'61028': 'Elizabeth,IL',
'61030': 'Forreston,IL',
'61031': 'Franklin Grove,IL',
'61032': 'Freeport,IL',
'61036': 'Galena,IL',
'61037': 'Galt,IL',
'61038': 'Garden Prairie,IL',
'61039': 'German Valley,IL',
'61041': 'Hanover,IL',
'61042': 'Harmon,IL',
'61043': 'Holcomb,IL',
'61044': 'Kent,IL',
'61046': 'Lanark,IL',
'61047': 'Leaf River,IL',
'61048': 'Lena,IL',
'61049': 'Lindenwood,IL',
'61050': 'Mc Connell,IL',
'61051': 'Milledgeville,IL',
'61052': 'Monroe Center,IL',
'61053': 'Mount Carroll,IL',
'61054': 'Mount Morris,IL',
'61057': 'Nachusa,IL',
'61058': 'Nelson,IL',
'61059': 'Nora,IL',
'61060': 'Orangeville,IL',
'61061': 'Oregon,IL',
'61062': 'Pearl City,IL',
'61063': 'Pecatonica,IL',
'61064': 'Polo,IL',
'61065': 'Poplar Grove,IL',
'61067': 'Ridott,IL',
'61068': 'Rochelle,IL',
'61070': 'Rock City,IL',
'61071': 'Rock Falls,IL',
'61072': 'Rockton,IL',
'61073': 'Roscoe,IL',
'61074': 'Savanna,IL',
'61075': 'Scales Mound,IL',
'61076': 'Scioto Mills,IL',
'61077': 'Seward,IL',
'61078': 'Shannon,IL',
'61079': 'Shirland,IL',
'61080': 'South Beloit,IL',
'61081': 'Sterling,IL',
'61084': 'Stillman Valley,IL',
'61085': 'Stockton,IL',
'61087': 'Warren,IL',
'61088': 'Winnebago,IL',
'61089': 'Winslow,IL',
'61091': 'Woosung,IL',
'61101': 'Rockford,IL',
'61102': 'Rockford,IL',
'61103': 'Rockford,IL',
'61104': 'Rockford,IL',
'61105': 'Rockford,IL',
'61106': 'Rockford,IL',
'61107': 'Rockford,IL',
'61108': 'Rockford,IL',
'61109': 'Rockford,IL',
'61110': 'Rockford,IL',
'61111': 'Loves Park,IL',
'61112': 'Rockford,IL',
'61114': 'Rockford,IL',
'61115': 'Machesney Park,IL',
'61125': 'Rockford,IL',
'61126': 'Rockford,IL',
'61130': 'Loves Park,IL',
'61131': 'Loves Park,IL',
'61132': 'Loves Park,IL',
'61201': 'Rock Island,IL',
'61204': 'Rock Island,IL',
'61230': 'Albany,IL',
'61231': 'Aledo,IL',
'61232': 'Andalusia,IL',
'61233': 'Andover,IL',
'61234': 'Annawan,IL',
'61235': 'Atkinson,IL',
'61236': 'Barstow,IL',
'61237': 'Buffalo Prairie,IL',
'61238': 'Cambridge,IL',
'61239': 'Carbon Cliff,IL',
'61240': 'Coal Valley,IL',
'61241': 'Colona,IL',
'61242': 'Cordova,IL',
'61243': 'Deer Grove,IL',
'61244': 'East Moline,IL',
'61250': 'Erie,IL',
'61251': 'Fenton,IL',
'61252': 'Fulton,IL',
'61254': 'Geneseo,IL',
'61256': 'Hampton,IL',
'61257': 'Hillsdale,IL',
'61258': 'Hooppole,IL',
'61259': 'Illinois City,IL',
'61260': 'Joy,IL',
'61261': 'Lyndon,IL',
'61262': 'Lynn Center,IL',
'61263': 'Matherville,IL',
'61264': 'Milan,IL',
'61265': 'Moline,IL',
'61266': 'Moline,IL',
'61270': 'Morrison,IL',
'61272': 'New Boston,IL',
'61273': 'Orion,IL',
'61274': 'Osco,IL',
'61275': 'Port Byron,IL',
'61276': 'Preemption,IL',
'61277': 'Prophetstown,IL',
'61278': 'Rapids City,IL',
'61279': 'Reynolds,IL',
'61281': 'Sherrard,IL',
'61282': 'Silvis,IL',
'61283': 'Tampico,IL',
'61284': 'Taylor Ridge,IL',
'61285': 'Thomson,IL',
'61299': 'Rock Island,IL',
'61301': 'La Salle,IL',
'61310': 'Amboy,IL',
'61311': 'Ancona,IL',
'61312': 'Arlington,IL',
'61313': 'Blackstone,IL',
'61314': 'Buda,IL',
'61315': 'Bureau,IL',
'61316': 'Cedar Point,IL',
'61317': 'Cherry,IL',
'61318': 'Compton,IL',
'61319': 'Cornell,IL',
'61320': 'Dalzell,IL',
'61321': 'Dana,IL',
'61322': 'Depue,IL',
'61323': 'Dover,IL',
'61324': 'Eldena,IL',
'61325': 'Grand Ridge,IL',
'61326': 'Granville,IL',
'61327': 'Hennepin,IL',
'61328': 'Kasbeer,IL',
'61329': 'Ladd,IL',
'61330': 'La Moille,IL',
'61331': 'Lee Center,IL',
'61332': 'Leonore,IL',
'61333': 'Long Point,IL',
'61334': 'Lostant,IL',
'61335': 'Mc Nabb,IL',
'61336': 'Magnolia,IL',
'61337': 'Malden,IL',
'61338': 'Manlius,IL',
'61340': 'Mark,IL',
'61341': 'Marseilles,IL',
'61342': 'Mendota,IL',
'61344': 'Mineral,IL',
'61345': 'Neponset,IL',
'61346': 'New Bedford,IL',
'61348': 'Oglesby,IL',
'61349': 'Ohio,IL',
'61350': 'Ottawa,IL',
'61353': 'Paw Paw,IL',
'61354': 'Peru,IL',
'61356': 'Princeton,IL',
'61358': 'Rutland,IL',
'61359': 'Seatonville,IL',
'61360': 'Seneca,IL',
'61361': 'Sheffield,IL',
'61362': 'Spring Valley,IL',
'61363': 'Standard,IL',
'61364': 'Streator,IL',
'61367': 'Sublette,IL',
'61368': 'Tiskilwa,IL',
'61369': 'Toluca,IL',
'61370': 'Tonica,IL',
'61371': 'Triumph,IL',
'61372': 'Troy Grove,IL',
'61373': 'Utica,IL',
'61374': 'Van Orin,IL',
'61375': 'Varna,IL',
'61376': 'Walnut,IL',
'61377': 'Wenona,IL',
'61378': 'West Brooklyn,IL',
'61379': 'Wyanet,IL',
'61401': 'Galesburg,IL',
'61402': 'Galesburg,IL',
'61410': 'Abingdon,IL',
'61411': 'Adair,IL',
'61412': 'Alexis,IL',
'61413': 'Alpha,IL',
'61414': 'Altona,IL',
'61415': 'Avon,IL',
'61416': 'Bardolph,IL',
'61417': 'Berwick,IL',
'61418': 'Biggsville,IL',
'61419': 'Bishop Hill,IL',
'61420': 'Blandinsville,IL',
'61421': 'Bradford,IL',
'61422': 'Bushnell,IL',
'61423': 'Cameron,IL',
'61424': 'Camp Grove,IL',
'61425': 'Carman,IL',
'61426': 'Castleton,IL',
'61427': 'Cuba,IL',
'61428': 'Dahinda,IL',
'61430': 'East Galesburg,IL',
'61431': 'Ellisville,IL',
'61432': 'Fairview,IL',
'61433': 'Fiatt,IL',
'61434': 'Galva,IL',
'61435': 'Gerlaw,IL',
'61436': 'Gilson,IL',
'61437': 'Gladstone,IL',
'61438': 'Good Hope,IL',
'61439': 'Henderson,IL',
'61440': 'Industry,IL',
'61441': 'Ipava,IL',
'61442': 'Keithsburg,IL',
'61443': 'Kewanee,IL',
'61447': 'Kirkwood,IL',
'61448': 'Knoxville,IL',
'61449': 'La Fayette,IL',
'61450': 'La Harpe,IL',
'61451': 'Laura,IL',
'61452': 'Littleton,IL',
'61453': 'Little York,IL',
'61454': 'Lomax,IL',
'61455': 'Macomb,IL',
'61458': 'Maquon,IL',
'61459': 'Marietta,IL',
'61460': 'Media,IL',
'61462': 'Monmouth,IL',
'61465': 'New Windsor,IL',
'61466': 'North Henderson,IL',
'61467': 'Oneida,IL',
'61468': 'Opheim,IL',
'61469': 'Oquawka,IL',
'61470': 'Prairie City,IL',
'61471': 'Raritan,IL',
'61472': 'Rio,IL',
'61473': 'Roseville,IL',
'61474': 'Saint Augustine,IL',
'61475': 'Sciota,IL',
'61476': 'Seaton,IL',
'61477': 'Smithfield,IL',
'61478': 'Smithshire,IL',
'61479': 'Speer,IL',
'61480': 'Stronghurst,IL',
'61482': 'Table Grove,IL',
'61483': 'Toulon,IL',
'61484': 'Vermont,IL',
'61485': 'Victoria,IL',
'61486': 'Viola,IL',
'61488': 'Wataga,IL',
'61489': 'Williamsfield,IL',
'61490': 'Woodhull,IL',
'61491': 'Wyoming,IL',
'61501': 'Astoria,IL',
'61516': 'Benson,IL',
'61517': 'Brimfield,IL',
'61519': 'Bryant,IL',
'61520': 'Canton,IL',
'61523': 'Chillicothe,IL',
'61524': 'Dunfermline,IL',
'61525': 'Dunlap,IL',
'61526': 'Edelstein,IL',
'61528': 'Edwards,IL',
'61529': 'Elmwood,IL',
'61530': 'Eureka,IL',
'61531': 'Farmington,IL',
'61532': 'Forest City,IL',
'61533': 'Glasford,IL',
'61534': 'Green Valley,IL',
'61535': 'Groveland,IL',
'61536': 'Hanna City,IL',
'61537': 'Henry,IL',
'61539': 'Kingston Mines,IL',
'61540': 'Lacon,IL',
'61541': 'La Rose,IL',
'61542': 'Lewistown,IL',
'61543': 'Liverpool,IL',
'61544': 'London Mills,IL',
'61545': 'Lowpoint,IL',
'61546': 'Manito,IL',
'61547': 'Mapleton,IL',
'61548': 'Metamora,IL',
'61550': 'Morton,IL',
'61552': 'Mossville,IL',
'61553': 'Norris,IL',
'61554': 'Pekin,IL',
'61555': 'Pekin,IL',
'61558': 'Pekin,IL',
'61559': 'Princeville,IL',
'61560': 'Putnam,IL',
'61561': 'Roanoke,IL',
'61562': 'Rome,IL',
'61563': 'Saint David,IL',
'61564': 'South Pekin,IL',
'61565': 'Sparland,IL',
'61567': 'Topeka,IL',
'61568': 'Tremont,IL',
'61569': 'Trivoli,IL',
'61570': 'Washburn,IL',
'61571': 'Washington,IL',
'61572': 'Yates City,IL',
'61601': 'Peoria,IL',
'61602': 'Peoria,IL',
'61603': 'Peoria,IL',
'61604': 'Peoria,IL',
'61605': 'Peoria,IL',
'61606': 'Peoria,IL',
'61607': 'Peoria,IL',
'61610': 'Creve Coeur,IL',
'61611': 'East Peoria,IL',
'61612': 'Peoria,IL',
'61613': 'Peoria,IL',
'61614': 'Peoria,IL',
'61615': 'Peoria,IL',
'61616': 'Peoria,IL',
'61625': 'Peoria,IL',
'61628': 'Peoria,IL',
'61629': 'Peoria,IL',
'61630': 'Peoria,IL',
'61632': 'Peoria,IL',
'61633': 'Peoria,IL',
'61634': 'Peoria,IL',
'61635': 'Peoria,IL',
'61636': 'Peoria,IL',
'61637': 'Peoria,IL',
'61638': 'Peoria,IL',
'61639': 'Peoria,IL',
'61640': 'Peoria,IL',
'61641': 'Peoria,IL',
'61643': 'Peoria,IL',
'61644': 'Peoria,IL',
'61650': 'Peoria,IL',
'61651': 'Peoria,IL',
'61652': 'Peoria,IL',
'61653': 'Peoria,IL',
'61654': 'Peoria,IL',
'61655': 'Peoria,IL',
'61656': 'Peoria,IL',
'61701': 'Bloomington,IL',
'61702': 'Bloomington,IL',
'61704': 'Bloomington,IL',
'61705': 'Bloomington,IL',
'61709': 'Bloomington,IL',
'61710': 'Bloomington,IL',
'61720': 'Anchor,IL',
'61721': 'Armington,IL',
'61722': 'Arrowsmith,IL',
'61723': 'Atlanta,IL',
'61724': 'Bellflower,IL',
'61725': 'Carlock,IL',
'61726': 'Chenoa,IL',
'61727': 'Clinton,IL',
'61728': 'Colfax,IL',
'61729': 'Congerville,IL',
'61730': 'Cooksville,IL',
'61731': 'Cropsey,IL',
'61732': 'Danvers,IL',
'61733': 'Deer Creek,IL',
'61734': 'Delavan,IL',
'61735': 'Dewitt,IL',
'61736': 'Downs,IL',
'61737': 'Ellsworth,IL',
'61738': 'El Paso,IL',
'61739': 'Fairbury,IL',
'61740': 'Flanagan,IL',
'61741': 'Forrest,IL',
'61742': 'Goodfield,IL',
'61743': 'Graymont,IL',
'61744': 'Gridley,IL',
'61745': 'Heyworth,IL',
'61747': 'Hopedale,IL',
'61748': 'Hudson,IL',
'61749': 'Kenney,IL',
'61750': 'Lane,IL',
'61751': 'Lawndale,IL',
'61752': 'Le Roy,IL',
'61753': 'Lexington,IL',
'61754': 'Mc Lean,IL',
'61755': 'Mackinaw,IL',
'61756': 'Maroa,IL',
'61758': 'Merna,IL',
'61759': 'Minier,IL',
'61760': 'Minonk,IL',
'61761': 'Normal,IL',
'61764': 'Pontiac,IL',
'61769': 'Saunemin,IL',
'61770': 'Saybrook,IL',
'61771': 'Secor,IL',
'61772': 'Shirley,IL',
'61773': 'Sibley,IL',
'61774': 'Stanford,IL',
'61775': 'Strawn,IL',
'61776': 'Towanda,IL',
'61777': 'Wapella,IL',
'61778': 'Waynesville,IL',
'61790': 'Normal,IL',
'61791': 'Bloomington,IL',
'61799': 'Bloomington,IL',
'61801': 'Urbana,IL',
'61802': 'Urbana,IL',
'61803': 'Urbana,IL',
'61810': 'Allerton,IL',
'61811': 'Alvin,IL',
'61812': 'Armstrong,IL',
'61813': 'Bement,IL',
'61814': 'Bismarck,IL',
'61815': 'Bondville,IL',
'61816': 'Broadlands,IL',
'61817': 'Catlin,IL',
'61818': 'Cerro Gordo,IL',
'61820': 'Champaign,IL',
'61821': 'Champaign,IL',
'61822': 'Champaign,IL',
'61824': 'Champaign,IL',
'61825': 'Champaign,IL',
'61826': 'Champaign,IL',
'61830': 'Cisco,IL',
'61831': 'Collison,IL',
'61832': 'Danville,IL',
'61833': 'Tilton,IL',
'61834': 'Danville,IL',
'61839': 'De Land,IL',
'61840': 'Dewey,IL',
'61841': 'Fairmount,IL',
'61842': 'Farmer City,IL',
'61843': 'Fisher,IL',
'61844': 'Fithian,IL',
'61845': 'Foosland,IL',
'61846': 'Georgetown,IL',
'61847': 'Gifford,IL',
'61848': 'Henning,IL',
'61849': 'Homer,IL',
'61850': 'Indianola,IL',
'61851': 'Ivesdale,IL',
'61852': 'Longview,IL',
'61853': 'Mahomet,IL',
'61854': 'Mansfield,IL',
'61855': 'Milmine,IL',
'61856': 'Monticello,IL',
'61857': 'Muncie,IL',
'61858': 'Oakwood,IL',
'61859': 'Ogden,IL',
'61862': 'Penfield,IL',
'61863': 'Pesotum,IL',
'61864': 'Philo,IL',
'61865': 'Potomac,IL',
'61866': 'Rantoul,IL',
'61870': 'Ridge Farm,IL',
'61871': 'Royal,IL',
'61872': 'Sadorus,IL',
'61873': 'Saint Joseph,IL',
'61874': 'Savoy,IL',
'61875': 'Seymour,IL',
'61876': 'Sidell,IL',
'61877': 'Sidney,IL',
'61878': 'Thomasboro,IL',
'61880': 'Tolono,IL',
'61882': 'Weldon,IL',
'61883': 'Westville,IL',
'61884': 'White Heath,IL',
'61910': 'Arcola,IL',
'61911': 'Arthur,IL',
'61912': 'Ashmore,IL',
'61913': 'Atwood,IL',
'61914': 'Bethany,IL',
'61917': 'Brocton,IL',
'61919': 'Camargo,IL',
'61920': 'Charleston,IL',
'61924': 'Chrisman,IL',
'61925': 'Dalton City,IL',
'61928': 'Gays,IL',
'61929': 'Hammond,IL',
'61930': 'Hindsboro,IL',
'61931': 'Humboldt,IL',
'61932': 'Hume,IL',
'61933': 'Kansas,IL',
'61936': 'La Place,IL',
'61937': 'Lovington,IL',
'61938': 'Mattoon,IL',
'61940': 'Metcalf,IL',
'61941': 'Murdock,IL',
'61942': 'Newman,IL',
'61943': 'Oakland,IL',
'61944': 'Paris,IL',
'61949': 'Redmon,IL',
'61951': 'Sullivan,IL',
'61953': 'Tuscola,IL',
'61955': 'Vermilion,IL',
'61956': 'Villa Grove,IL',
'61957': 'Windsor,IL',
'62001': 'Alhambra,IL',
'62002': 'Alton,IL',
'62006': 'Batchtown,IL',
'62009': 'Benld,IL',
'62010': 'Bethalto,IL',
'62011': 'Bingham,IL',
'62012': 'Brighton,IL',
'62013': 'Brussels,IL',
'62014': 'Bunker Hill,IL',
'62015': 'Butler,IL',
'62016': 'Carrollton,IL',
'62017': 'Coffeen,IL',
'62018': 'Cottage Hills,IL',
'62019': 'Donnellson,IL',
'62021': 'Dorsey,IL',
'62022': 'Dow,IL',
'62023': 'Eagarville,IL',
'62024': 'East Alton,IL',
'62025': 'Edwardsville,IL',
'62026': 'Edwardsville,IL',
'62027': 'Eldred,IL',
'62028': 'Elsah,IL',
'62030': 'Fidelity,IL',
'62031': 'Fieldon,IL',
'62032': 'Fillmore,IL',
'62033': 'Gillespie,IL',
'62034': 'Glen Carbon,IL',
'62035': 'Godfrey,IL',
'62036': 'Golden Eagle,IL',
'62037': 'Grafton,IL',
'62040': 'Granite City,IL',
'62044': 'Greenfield,IL',
'62045': 'Hamburg,IL',
'62046': 'Hamel,IL',
'62047': 'Hardin,IL',
'62048': 'Hartford,IL',
'62049': 'Hillsboro,IL',
'62050': 'Hillview,IL',
'62051': 'Irving,IL',
'62052': 'Jerseyville,IL',
'62053': 'Kampsville,IL',
'62054': 'Kane,IL',
'62056': 'Litchfield,IL',
'62058': 'Livingston,IL',
'62059': 'Lovejoy,IL',
'62060': 'Madison,IL',
'62061': 'Marine,IL',
'62062': 'Maryville,IL',
'62063': 'Medora,IL',
'62065': 'Michael,IL',
'62067': 'Moro,IL',
'62069': 'Mount Olive,IL',
'62070': 'Mozier,IL',
'62071': 'National Stock Yards,IL',
'62074': 'New Douglas,IL',
'62075': 'Nokomis,IL',
'62076': 'Ohlman,IL',
'62077': 'Panama,IL',
'62078': 'Patterson,IL',
'62079': 'Piasa,IL',
'62080': 'Ramsey,IL',
'62081': 'Rockbridge,IL',
'62082': 'Roodhouse,IL',
'62083': 'Rosamond,IL',
'62084': 'Roxana,IL',
'62085': 'Sawyerville,IL',
'62086': 'Sorento,IL',
'62087': 'South Roxana,IL',
'62088': 'Staunton,IL',
'62089': 'Taylor Springs,IL',
'62090': 'Venice,IL',
'62091': 'Walshville,IL',
'62092': 'White Hall,IL',
'62093': 'Wilsonville,IL',
'62094': 'Witt,IL',
'62095': 'Wood River,IL',
'62097': 'Worden,IL',
'62098': 'Wrights,IL',
'62201': 'East Saint Louis,IL',
'62202': 'East Saint Louis,IL',
'62203': 'East Saint Louis,IL',
'62204': 'East Saint Louis,IL',
'62205': 'East Saint Louis,IL',
'62206': 'East Saint Louis,IL',
'62207': 'East Saint Louis,IL',
'62208': 'Fairview Heights,IL',
'62214': 'Addieville,IL',
'62215': 'Albers,IL',
'62216': 'Aviston,IL',
'62217': 'Baldwin,IL',
'62218': 'Bartelso,IL',
'62219': 'Beckemeyer,IL',
'62220': 'Belleville,IL',
'62221': 'Belleville,IL',
'62222': 'Belleville,IL',
'62223': 'Belleville,IL',
'62224': 'Mascoutah,IL',
'62225': 'Scott Air Force Base,IL',
'62226': 'Belleville,IL',
'62230': 'Breese,IL',
'62231': 'Carlyle,IL',
'62232': 'Caseyville,IL',
'62233': 'Chester,IL',
'62234': 'Collinsville,IL',
'62236': 'Columbia,IL',
'62237': 'Coulterville,IL',
'62238': 'Cutler,IL',
'62239': 'Dupo,IL',
'62240': 'East Carondelet,IL',
'62241': 'Ellis Grove,IL',
'62242': 'Evansville,IL',
'62243': 'Freeburg,IL',
'62244': 'Fults,IL',
'62245': 'Germantown,IL',
'62246': 'Greenville,IL',
'62247': 'Hagarstown,IL',
'62248': 'Hecker,IL',
'62249': 'Highland,IL',
'62250': 'Hoffman,IL',
'62252': 'Huey,IL',
'62253': 'Keyesport,IL',
'62254': 'Lebanon,IL',
'62255': 'Lenzburg,IL',
'62256': 'Maeystown,IL',
'62257': 'Marissa,IL',
'62258': 'Mascoutah,IL',
'62259': 'Menard,IL',
'62260': 'Millstadt,IL',
'62261': 'Modoc,IL',
'62262': 'Mulberry Grove,IL',
'62263': 'Nashville,IL',
'62264': 'New Athens,IL',
'62265': 'New Baden,IL',
'62266': 'New Memphis,IL',
'62268': 'Oakdale,IL',
'62269': 'O Fallon,IL',
'62271': 'Okawville,IL',
'62272': 'Percy,IL',
'62273': 'Pierron,IL',
'62274': 'Pinckneyville,IL',
'62275': 'Pocahontas,IL',
'62277': 'Prairie Du Rocher,IL',
'62278': 'Red Bud,IL',
'62279': 'Renault,IL',
'62280': 'Rockwood,IL',
'62281': 'Saint Jacob,IL',
'62282': 'Saint Libory,IL',
'62283': 'Shattuc,IL',
'62284': 'Smithboro,IL',
'62285': 'Smithton,IL',
'62286': 'Sparta,IL',
'62288': 'Steeleville,IL',
'62289': 'Summerfield,IL',
'62292': 'Tilden,IL',
'62293': 'Trenton,IL',
'62294': 'Troy,IL',
'62295': 'Valmeyer,IL',
'62297': 'Walsh,IL',
'62298': 'Waterloo,IL',
'62301': 'Quincy,IL',
'62305': 'Quincy,IL',
'62306': 'Quincy,IL',
'62310': 'Adrian,IL',
'62311': 'Augusta,IL',
'62312': 'Barry,IL',
'62313': 'Basco,IL',
'62314': 'Baylis,IL',
'62316': 'Bowen,IL',
'62318': 'Burnside,IL',
'62319': 'Camden,IL',
'62320': 'Camp Point,IL',
'62321': 'Carthage,IL',
'62323': 'Chambersburg,IL',
'62324': 'Clayton,IL',
'62325': 'Coatsburg,IL',
'62326': 'Colchester,IL',
'62329': 'Colusa,IL',
'62330': 'Dallas City,IL',
'62334': 'Elvaston,IL',
'62336': 'Ferris,IL',
'62338': 'Fowler,IL',
'62339': 'Golden,IL',
'62340': 'Griggsville,IL',
'62341': 'Hamilton,IL',
'62343': 'Hull,IL',
'62344': 'Huntsville,IL',
'62345': 'Kinderhook,IL',
'62346': 'La Prairie,IL',
'62347': 'Liberty,IL',
'62348': 'Lima,IL',
'62349': 'Loraine,IL',
'62351': 'Mendon,IL',
'62352': 'Milton,IL',
'62353': 'Mount Sterling,IL',
'62354': 'Nauvoo,IL',
'62355': 'Nebo,IL',
'62356': 'New Canton,IL',
'62357': 'New Salem,IL',
'62358': 'Niota,IL',
'62359': 'Paloma,IL',
'62360': 'Payson,IL',
'62361': 'Pearl,IL',
'62362': 'Perry,IL',
'62363': 'Pittsfield,IL',
'62365': 'Plainville,IL',
'62366': 'Pleasant Hill,IL',
'62367': 'Plymouth,IL',
'62370': 'Rockport,IL',
'62373': 'Sutter,IL',
'62374': 'Tennessee,IL',
'62375': 'Timewell,IL',
'62376': 'Ursa,IL',
'62378': 'Versailles,IL',
'62379': 'Warsaw,IL',
'62380': 'West Point,IL',
'62401': 'Effingham,IL',
'62410': 'Allendale,IL',
'62411': 'Altamont,IL',
'62413': 'Annapolis,IL',
'62414': 'Beecher City,IL',
'62415': 'Birds,IL',
'62417': 'Bridgeport,IL',
'62418': 'Brownstown,IL',
'62419': 'Calhoun,IL',
'62420': 'Casey,IL',
'62421': 'Claremont,IL',
'62422': 'Cowden,IL',
'62423': 'Dennison,IL',
'62424': 'Dieterich,IL',
'62425': 'Dundas,IL',
'62426': 'Edgewood,IL',
'62427': 'Flat Rock,IL',
'62428': 'Greenup,IL',
'62431': 'Herrick,IL',
'62432': 'Hidalgo,IL',
'62433': 'Hutsonville,IL',
'62434': 'Ingraham,IL',
'62435': 'Janesville,IL',
'62436': 'Jewett,IL',
'62438': 'Lakewood,IL',
'62439': 'Lawrenceville,IL',
'62440': 'Lerna,IL',
'62441': 'Marshall,IL',
'62442': 'Martinsville,IL',
'62443': 'Mason,IL',
'62444': 'Mode,IL',
'62445': 'Montrose,IL',
'62446': 'Mount Erie,IL',
'62447': 'Neoga,IL',
'62448': 'Newton,IL',
'62449': 'Oblong,IL',
'62450': 'Olney,IL',
'62451': 'Palestine,IL',
'62452': 'Parkersburg,IL',
'62454': 'Robinson,IL',
'62458': 'Saint Elmo,IL',
'62459': 'Sainte Marie,IL',
'62460': 'Saint Francisville,IL',
'62461': 'Shumway,IL',
'62462': 'Sigel,IL',
'62463': 'Stewardson,IL',
'62464': 'Stoy,IL',
'62465': 'Strasburg,IL',
'62466': 'Sumner,IL',
'62467': 'Teutopolis,IL',
'62468': 'Toledo,IL',
'62469': 'Trilla,IL',
'62471': 'Vandalia,IL',
'62473': 'Watson,IL',
'62474': 'Westfield,IL',
'62475': 'West Liberty,IL',
'62476': 'West Salem,IL',
'62477': 'West Union,IL',
'62478': 'West York,IL',
'62479': 'Wheeler,IL',
'62480': 'Willow Hill,IL',
'62481': 'Yale,IL',
'62501': 'Argenta,IL',
'62510': 'Assumption,IL',
'62511': 'Atwater,IL',
'62512': 'Beason,IL',
'62513': 'Blue Mound,IL',
'62514': 'Boody,IL',
'62515': 'Buffalo,IL',
'62517': 'Bulpitt,IL',
'62518': 'Chestnut,IL',
'62519': 'Cornland,IL',
'62520': 'Dawson,IL',
'62521': 'Decatur,IL',
'62522': 'Decatur,IL',
'62523': 'Decatur,IL',
'62524': 'Decatur,IL',
'62525': 'Decatur,IL',
'62526': 'Decatur,IL',
'62527': 'Decatur,IL',
'62530': 'Divernon,IL',
'62531': 'Edinburg,IL',
'62532': 'Elwin,IL',
'62533': 'Farmersville,IL',
'62534': 'Findlay,IL',
'62535': 'Forsyth,IL',
'62536': 'Glenarm,IL',
'62537': 'Harristown,IL',
'62538': 'Harvel,IL',
'62539': 'Illiopolis,IL',
'62540': 'Kincaid,IL',
'62541': 'Lake Fork,IL',
'62543': 'Latham,IL',
'62544': 'Macon,IL',
'62545': 'Mechanicsburg,IL',
'62546': 'Morrisonville,IL',
'62547': 'Mount Auburn,IL',
'62548': 'Mount Pulaski,IL',
'62549': 'Mt Zion,IL',
'62550': 'Moweaqua,IL',
'62551': 'Niantic,IL',
'62552': 'Oakley,IL',
'62553': 'Oconee,IL',
'62554': 'Oreana,IL',
'62555': 'Owaneco,IL',
'62556': 'Palmer,IL',
'62557': 'Pana,IL',
'62558': 'Pawnee,IL',
'62560': 'Raymond,IL',
'62561': 'Riverton,IL',
'62563': 'Rochester,IL',
'62565': 'Shelbyville,IL',
'62567': 'Stonington,IL',
'62568': 'Taylorville,IL',
'62570': 'Tovey,IL',
'62571': 'Tower Hill,IL',
'62572': 'Waggoner,IL',
'62573': 'Warrensburg,IL',
'62601': 'Alexander,IL',
'62610': 'Alsey,IL',
'62611': 'Arenzville,IL',
'62612': 'Ashland,IL',
'62613': 'Athens,IL',
'62615': 'Auburn,IL',
'62617': 'Bath,IL',
'62618': 'Beardstown,IL',
'62621': 'Bluffs,IL',
'62622': 'Bluff Springs,IL',
'62624': 'Browning,IL',
'62625': 'Cantrall,IL',
'62626': 'Carlinville,IL',
'62627': 'Chandlerville,IL',
'62628': 'Chapin,IL',
'62629': 'Chatham,IL',
'62630': 'Chesterfield,IL',
'62631': 'Concord,IL',
'62633': 'Easton,IL',
'62634': 'Elkhart,IL',
'62635': 'Emden,IL',
'62638': 'Franklin,IL',
'62639': 'Frederick,IL',
'62640': 'Girard,IL',
'62642': 'Greenview,IL',
'62643': 'Hartsburg,IL',
'62644': 'Havana,IL',
'62649': 'Hettick,IL',
'62650': 'Jacksonville,IL',
'62651': 'Jacksonville,IL',
'62655': 'Kilbourne,IL',
'62656': 'Lincoln,IL',
'62659': 'Lincoln\'s New Salem,IL',
'62660': 'Literberry,IL',
'62661': 'Loami,IL',
'62662': 'Lowder,IL',
'62663': 'Manchester,IL',
'62664': 'Mason City,IL',
'62665': 'Meredosia,IL',
'62666': 'Middletown,IL',
'62667': 'Modesto,IL',
'62668': 'Murrayville,IL',
'62670': 'New Berlin,IL',
'62671': 'New Holland,IL',
'62672': 'Nilwood,IL',
'62673': 'Oakford,IL',
'62674': 'Palmyra,IL',
'62675': 'Petersburg,IL',
'62677': 'Pleasant Plains,IL',
'62681': 'Rushville,IL',
'62682': 'San Jose,IL',
'62683': 'Scottville,IL',
'62684': 'Sherman,IL',
'62685': 'Shipman,IL',
'62686': 'Standard City,IL',
'62688': 'Tallula,IL',
'62689': 'Thayer,IL',
'62690': 'Virden,IL',
'62691': 'Virginia,IL',
'62692': 'Waverly,IL',
'62693': 'Williamsville,IL',
'62694': 'Winchester,IL',
'62695': 'Woodson,IL',
'62701': 'Springfield,IL',
'62702': 'Springfield,IL',
'62703': 'Springfield,IL',
'62704': 'Springfield,IL',
'62705': 'Springfield,IL',
'62706': 'Springfield,IL',
'62707': 'Springfield,IL',
'62708': 'Springfield,IL',
'62709': 'Springfield,IL',
'62711': 'Springfield,IL',
'62712': 'Springfield,IL',
'62713': 'Springfield,IL',
'62715': 'Springfield,IL',
'62716': 'Springfield,IL',
'62718': 'Springfield,IL',
'62719': 'Springfield,IL',
'62720': 'Springfield,IL',
'62721': 'Springfield,IL',
'62722': 'Springfield,IL',
'62723': 'Springfield,IL',
'62726': 'Springfield,IL',
'62736': 'Springfield,IL',
'62739': 'Springfield,IL',
'62746': 'Springfield,IL',
'62756': 'Springfield,IL',
'62757': 'Springfield,IL',
'62761': 'Springfield,IL',
'62762': 'Springfield,IL',
'62763': 'Springfield,IL',
'62764': 'Springfield,IL',
'62765': 'Springfield,IL',
'62766': 'Springfield,IL',
'62767': 'Springfield,IL',
'62769': 'Springfield,IL',
'62776': 'Springfield,IL',
'62777': 'Springfield,IL',
'62781': 'Springfield,IL',
'62786': 'Springfield,IL',
'62791': 'Springfield,IL',
'62794': 'Springfield,IL',
'62796': 'Springfield,IL',
'62801': 'Centralia,IL',
'62803': 'Hoyleton,IL',
'62805': 'Akin,IL',
'62806': 'Albion,IL',
'62807': 'Alma,IL',
'62808': 'Ashley,IL',
'62809': 'Barnhill,IL',
'62810': 'Belle Rive,IL',
'62811': 'Bellmont,IL',
'62812': 'Benton,IL',
'62814': 'Bluford,IL',
'62815': 'Bone Gap,IL',
'62816': 'Bonnie,IL',
'62817': 'Broughton,IL',
'62818': 'Browns,IL',
'62819': 'Buckner,IL',
'62820': 'Burnt Prairie,IL',
'62821': 'Carmi,IL',
'62822': 'Christopher,IL',
'62823': 'Cisne,IL',
'62824': 'Clay City,IL',
'62825': 'Coello,IL',
'62827': 'Crossville,IL',
'62828': 'Dahlgren,IL',
'62829': 'Dale,IL',
'62830': 'Dix,IL',
'62831': 'Du Bois,IL',
'62832': 'Du Quoin,IL',
'62833': 'Ellery,IL',
'62834': 'Emma,IL',
'62835': 'Enfield,IL',
'62836': 'Ewing,IL',
'62837': 'Fairfield,IL',
'62838': 'Farina,IL',
'62839': 'Flora,IL',
'62840': 'Frankfort Heights,IL',
'62841': 'Freeman Spur,IL',
'62842': 'Geff,IL',
'62843': 'Golden Gate,IL',
'62844': 'Grayville,IL',
'62845': 'Herald,IL',
'62846': 'Ina,IL',
'62847': 'Iola,IL',
'62848': 'Irvington,IL',
'62849': 'Iuka,IL',
'62850': 'Johnsonville,IL',
'62851': 'Keenes,IL',
'62852': 'Keensburg,IL',
'62853': 'Kell,IL',
'62854': 'Kinmundy,IL',
'62855': 'Lancaster,IL',
'62856': 'Logan,IL',
'62857': 'Loogootee,IL',
'62858': 'Louisville,IL',
'62859': 'Mc Leansboro,IL',
'62860': 'Macedonia,IL',
'62861': 'Maunie,IL',
'62862': 'Mill Shoals,IL',
'62863': 'Mount Carmel,IL',
'62864': 'Mount Vernon,IL',
'62865': 'Mulkeytown,IL',
'62866': 'Nason,IL',
'62867': 'New Haven,IL',
'62868': 'Noble,IL',
'62869': 'Norris City,IL',
'62870': 'Odin,IL',
'62871': 'Omaha,IL',
'62872': 'Opdyke,IL',
'62874': 'Orient,IL',
'62875': 'Patoka,IL',
'62876': 'Radom,IL',
'62877': 'Richview,IL',
'62878': 'Rinard,IL',
'62879': 'Sailor Springs,IL',
'62880': 'Saint Peter,IL',
'62881': 'Salem,IL',
'62882': 'Sandoval,IL',
'62883': 'Scheller,IL',
'62884': 'Sesser,IL',
'62885': 'Shobonier,IL',
'62886': 'Sims,IL',
'62887': 'Springerton,IL',
'62888': 'Tamaroa,IL',
'62889': 'Texico,IL',
'62890': 'Thompsonville,IL',
'62891': 'Valier,IL',
'62892': 'Vernon,IL',
'62893': 'Walnut Hill,IL',
'62894': 'Waltonville,IL',
'62895': 'Wayne City,IL',
'62896': 'West Frankfort,IL',
'62897': 'Whittington,IL',
'62898': 'Woodlawn,IL',
'62899': 'Xenia,IL',
'62901': 'Carbondale,IL',
'62902': 'Carbondale,IL',
'62903': 'Carbondale,IL',
'62905': 'Alto Pass,IL',
'62906': 'Anna,IL',
'62907': 'Ava,IL',
'62908': 'Belknap,IL',
'62909': 'Boles,IL',
'62910': 'Brookport,IL',
'62912': 'Buncombe,IL',
'62913': 'Cache,IL',
'62914': 'Cairo,IL',
'62915': 'Cambria,IL',
'62916': 'Campbell Hill,IL',
'62917': 'Carrier Mills,IL',
'62918': 'Carterville,IL',
'62919': 'Cave In Rock,IL',
'62920': 'Cobden,IL',
'62921': 'Colp,IL',
'62922': 'Creal Springs,IL',
'62923': 'Cypress,IL',
'62924': 'De Soto,IL',
'62926': 'Dongola,IL',
'62927': 'Dowell,IL',
'62928': 'Eddyville,IL',
'62930': 'Eldorado,IL',
'62931': 'Elizabethtown,IL',
'62932': 'Elkville,IL',
'62933': 'Energy,IL',
'62934': 'Equality,IL',
'62935': 'Galatia,IL',
'62938': 'Golconda,IL',
'62939': 'Goreville,IL',
'62940': 'Gorham,IL',
'62941': 'Grand Chain,IL',
'62942': 'Grand Tower,IL',
'62943': 'Grantsburg,IL',
'62944': 'Hamletsburg,IL',
'62946': 'Harrisburg,IL',
'62947': 'Herod,IL',
'62948': 'Herrin,IL',
'62949': 'Hurst,IL',
'62950': 'Jacob,IL',
'62951': 'Johnston City,IL',
'62952': 'Jonesboro,IL',
'62953': 'Joppa,IL',
'62954': 'Junction,IL',
'62955': 'Karbers Ridge,IL',
'62956': 'Karnak,IL',
'62957': 'Mc Clure,IL',
'62958': 'Makanda,IL',
'62959': 'Marion,IL',
'62960': 'Metropolis,IL',
'62961': 'Millcreek,IL',
'62962': 'Miller City,IL',
'62963': 'Mound City,IL',
'62964': 'Mounds,IL',
'62965': 'Muddy,IL',
'62966': 'Murphysboro,IL',
'62967': 'New Burnside,IL',
'62969': 'Olive Branch,IL',
'62970': 'Olmsted,IL',
'62971': 'Oraville,IL',
'62972': 'Ozark,IL',
'62973': 'Perks,IL',
'62974': 'Pittsburg,IL',
'62975': 'Pomona,IL',
'62976': 'Pulaski,IL',
'62977': 'Raleigh,IL',
'62979': 'Ridgway,IL',
'62982': 'Rosiclare,IL',
'62983': 'Royalton,IL',
'62984': 'Shawneetown,IL',
'62985': 'Simpson,IL',
'62987': 'Stonefort,IL',
'62988': 'Tamms,IL',
'62990': 'Thebes,IL',
'62991': 'Tunnel Hill,IL',
'62992': 'Ullin,IL',
'62993': 'Unity,IL',
'62994': 'Vergennes,IL',
'62995': 'Vienna,IL',
'62996': 'Villa Ridge,IL',
'62997': 'Willisville,IL',
'62998': 'Wolf Lake,IL',
'62999': 'Zeigler,IL',
'63001': 'Allenton,MO',
'63005': 'Chesterfield,MO',
'63006': 'Chesterfield,MO',
'63010': 'Arnold,MO',
'63011': 'Ballwin,MO',
'63012': 'Barnhart,MO',
'63013': 'Beaufort,MO',
'63014': 'Berger,MO',
'63015': 'Catawissa,MO',
'63016': 'Cedar Hill,MO',
'63017': 'Chesterfield,MO',
'63019': 'Crystal City,MO',
'63020': 'De Soto,MO',
'63021': 'Ballwin,MO',
'63022': 'Ballwin,MO',
'63023': 'Dittmer,MO',
'63024': 'Ballwin,MO',
'63025': 'Eureka,MO',
'63026': 'Fenton,MO',
'63028': 'Festus,MO',
'63030': 'Fletcher,MO',
'63031': 'Florissant,MO',
'63032': 'Florissant,MO',
'63033': 'Florissant,MO',
'63034': 'Florissant,MO',
'63036': 'French Village,MO',
'63037': 'Gerald,MO',
'63038': 'Glencoe,MO',
'63039': 'Gray Summit,MO',
'63040': 'Grover,MO',
'63041': 'Grubville,MO',
'63042': 'Hazelwood,MO',
'63043': 'Maryland Heights,MO',
'63044': 'Bridgeton,MO',
'63045': 'Earth City,MO',
'63047': 'Hematite,MO',
'63048': 'Herculaneum,MO',
'63049': 'High Ridge,MO',
'63050': 'Hillsboro,MO',
'63051': 'House Springs,MO',
'63052': 'Imperial,MO',
'63053': 'Kimmswick,MO',
'63055': 'Labadie,MO',
'63056': 'Leslie,MO',
'63057': 'Liguori,MO',
'63060': 'Lonedell,MO',
'63061': 'Luebbering,MO',
'63065': 'Mapaville,MO',
'63066': 'Morse Mill,MO',
'63068': 'New Haven,MO',
'63069': 'Pacific,MO',
'63070': 'Pevely,MO',
'63071': 'Richwoods,MO',
'63072': 'Robertsville,MO',
'63073': 'Saint Albans,MO',
'63074': 'Saint Ann,MO',
'63077': 'Saint Clair,MO',
'63079': 'Stanton,MO',
'63080': 'Sullivan,MO',
'63084': 'Union,MO',
'63087': 'Valles Mines,MO',
'63088': 'Valley Park,MO',
'63089': 'Villa Ridge,MO',
'63090': 'Washington,MO',
'63091': 'Rosebud,MO',
'63099': 'Fenton,MO',
'63101': 'Saint Louis,MO',
'63102': 'Saint Louis,MO',
'63103': 'Saint Louis,MO',
'63104': 'Saint Louis,MO',
'63105': 'Saint Louis,MO',
'63106': 'Saint Louis,MO',
'63107': 'Saint Louis,MO',
'63108': 'Saint Louis,MO',
'63109': 'Saint Louis,MO',
'63110': 'Saint Louis,MO',
'63111': 'Saint Louis,MO',
'63112': 'Saint Louis,MO',
'63113': 'Saint Louis,MO',
'63114': 'Saint Louis,MO',
'63115': 'Saint Louis,MO',
'63116': 'Saint Louis,MO',
'63117': 'Saint Louis,MO',
'63118': 'Saint Louis,MO',
'63119': 'Saint Louis,MO',
'63120': 'Saint Louis,MO',
'63121': 'Saint Louis,MO',
'63122': 'Saint Louis,MO',
'63123': 'Saint Louis,MO',
'63124': 'Saint Louis,MO',
'63125': 'Saint Louis,MO',
'63126': 'Saint Louis,MO',
'63127': 'Saint Louis,MO',
'63128': 'Saint Louis,MO',
'63129': 'Saint Louis,MO',
'63130': 'Saint Louis,MO',
'63131': 'Saint Louis,MO',
'63132': 'Saint Louis,MO',
'63133': 'Saint Louis,MO',
'63134': 'Saint Louis,MO',
'63135': 'Saint Louis,MO',
'63136': 'Saint Louis,MO',
'63137': 'Saint Louis,MO',
'63138': 'Saint Louis,MO',
'63139': 'Saint Louis,MO',
'63140': 'Saint Louis,MO',
'63141': 'Saint Louis,MO',
'63143': 'Saint Louis,MO',
'63144': 'Saint Louis,MO',
'63145': 'Saint Louis,MO',
'63146': 'Saint Louis,MO',
'63147': 'Saint Louis,MO',
'63150': 'Saint Louis,MO',
'63151': 'Saint Louis,MO',
'63155': 'Saint Louis,MO',
'63156': 'Saint Louis,MO',
'63157': 'Saint Louis,MO',
'63158': 'Saint Louis,MO',
'63160': 'Saint Louis,MO',
'63163': 'Saint Louis,MO',
'63164': 'Saint Louis,MO',
'63166': 'Saint Louis,MO',
'63167': 'Saint Louis,MO',
'63169': 'Saint Louis,MO',
'63171': 'Saint Louis,MO',
'63177': 'Saint Louis,MO',
'63178': 'Saint Louis,MO',
'63179': 'Saint Louis,MO',
'63180': 'Saint Louis,MO',
'63182': 'Saint Louis,MO',
'63188': 'Saint Louis,MO',
'63190': 'Saint Louis,MO',
'63195': 'Saint Louis,MO',
'63196': 'Saint Louis,MO',
'63197': 'Saint Louis,MO',
'63198': 'Saint Louis,MO',
'63199': 'Saint Louis,MO',
'63301': 'Saint Charles,MO',
'63302': 'Saint Charles,MO',
'63303': 'Saint Charles,MO',
'63304': 'Saint Charles,MO',
'63330': 'Annada,MO',
'63332': 'Augusta,MO',
'63333': 'Bellflower,MO',
'63334': 'Bowling Green,MO',
'63336': 'Clarksville,MO',
'63338': 'Cottleville,MO',
'63339': 'Curryville,MO',
'63341': 'Defiance,MO',
'63342': 'Dutzow,MO',
'63343': 'Elsberry,MO',
'63344': 'Eolia,MO',
'63345': 'Farber,MO',
'63346': 'Flinthill,MO',
'63347': 'Foley,MO',
'63348': 'Foristell,MO',
'63349': 'Hawk Point,MO',
'63350': 'High Hill,MO',
'63351': 'Jonesburg,MO',
'63352': 'Laddonia,MO',
'63353': 'Louisiana,MO',
'63357': 'Marthasville,MO',
'63359': 'Middletown,MO',
'63361': 'Montgomery City,MO',
'63362': 'Moscow Mills,MO',
'63363': 'New Florence,MO',
'63365': 'New Melle,MO',
'63366': 'O Fallon,MO',
'63367': 'Lake Saint Louis,MO',
'63368': 'Ofallon,MO',
'63369': 'Old Monroe,MO',
'63370': 'Olney,MO',
'63373': 'Portage Des Sioux,MO',
'63376': 'Saint Peters,MO',
'63377': 'Silex,MO',
'63378': 'Treloar,MO',
'63379': 'Troy,MO',
'63381': 'Truxton,MO',
'63382': 'Vandalia,MO',
'63383': 'Warrenton,MO',
'63384': 'Wellsville,MO',
'63385': 'Wentzville,MO',
'63386': 'West Alton,MO',
'63387': 'Whiteside,MO',
'63388': 'Williamsburg,MO',
'63389': 'Winfield,MO',
'63390': 'Wright City,MO',
'63401': 'Hannibal,MO',
'63430': 'Alexandria,MO',
'63431': 'Anabel,MO',
'63432': 'Arbela,MO',
'63433': 'Ashburn,MO',
'63434': 'Bethel,MO',
'63435': 'Canton,MO',
'63436': 'Center,MO',
'63437': 'Clarence,MO',
'63438': 'Durham,MO',
'63439': 'Emden,MO',
'63440': 'Ewing,MO',
'63441': 'Frankford,MO',
'63442': 'Granger,MO',
'63443': 'Hunnewell,MO',
'63445': 'Kahoka,MO',
'63446': 'Knox City,MO',
'63447': 'La Belle,MO',
'63448': 'La Grange,MO',
'63450': 'Lentner,MO',
'63451': 'Leonard,MO',
'63452': 'Lewistown,MO',
'63453': 'Luray,MO',
'63454': 'Maywood,MO',
'63456': 'Monroe City,MO',
'63457': 'Monticello,MO',
'63458': 'Newark,MO',
'63459': 'New London,MO',
'63460': 'Novelty,MO',
'63461': 'Palmyra,MO',
'63462': 'Perry,MO',
'63463': 'Philadelphia,MO',
'63464': 'Plevna,MO',
'63465': 'Revere,MO',
'63466': 'Saint Patrick,MO',
'63467': 'Saverton,MO',
'63468': 'Shelbina,MO',
'63469': 'Shelbyville,MO',
'63471': 'Taylor,MO',
'63472': 'Wayland,MO',
'63473': 'Williamstown,MO',
'63474': 'Wyaconda,MO',
'63501': 'Kirksville,MO',
'63530': 'Atlanta,MO',
'63531': 'Baring,MO',
'63532': 'Bevier,MO',
'63533': 'Brashear,MO',
'63534': 'Callao,MO',
'63535': 'Coatsville,MO',
'63536': 'Downing,MO',
'63537': 'Edina,MO',
'63538': 'Elmer,MO',
'63539': 'Ethel,MO',
'63540': 'Gibbs,MO',
'63541': 'Glenwood,MO',
'63543': 'Gorin,MO',
'63544': 'Green Castle,MO',
'63545': 'Green City,MO',
'63546': 'Greentop,MO',
'63547': 'Hurdland,MO',
'63548': 'Lancaster,MO',
'63549': 'La Plata,MO',
'63551': 'Livonia,MO',
'63552': 'Macon,MO',
'63555': 'Memphis,MO',
'63556': 'Milan,MO',
'63557': 'New Boston,MO',
'63558': 'New Cambria,MO',
'63559': 'Novinger,MO',
'63560': 'Pollock,MO',
'63561': 'Queen City,MO',
'63563': 'Rutledge,MO',
'63565': 'Unionville,MO',
'63566': 'Winigan,MO',
'63567': 'Worthington,MO',
'63601': 'Park Hills,MO',
'63620': 'Annapolis,MO',
'63621': 'Arcadia,MO',
'63622': 'Belgrade,MO',
'63623': 'Belleview,MO',
'63624': 'Bismarck,MO',
'63625': 'Black,MO',
'63626': 'Blackwell,MO',
'63627': 'Bloomsdale,MO',
'63628': 'Bonne Terre,MO',
'63629': 'Bunker,MO',
'63630': 'Cadet,MO',
'63631': 'Caledonia,MO',
'63632': 'Cascade,MO',
'63633': 'Centerville,MO',
'63636': 'Des Arc,MO',
'63637': 'Doe Run,MO',
'63638': 'Ellington,MO',
'63640': 'Farmington,MO',
'63645': 'Fredericktown,MO',
'63646': 'Glover,MO',
'63648': 'Irondale,MO',
'63650': 'Ironton,MO',
'63651': 'Knob Lick,MO',
'63653': 'Leadwood,MO',
'63654': 'Lesterville,MO',
'63655': 'Marquand,MO',
'63656': 'Middle Brook,MO',
'63660': 'Mineral Point,MO',
'63661': 'New Offenburg,MO',
'63662': 'Patton,MO',
'63663': 'Pilot Knob,MO',
'63664': 'Potosi,MO',
'63665': 'Redford,MO',
'63666': 'Reynolds,MO',
'63670': 'Sainte Genevieve,MO',
'63673': 'Saint Mary,MO',
'63674': 'Tiff,MO',
'63675': 'Vulcan,MO',
'63701': 'Cape Girardeau,MO',
'63702': 'Cape Girardeau,MO',
'63703': 'Cape Girardeau,MO',
'63705': 'Cape Girardeau,MO',
'63730': 'Advance,MO',
'63732': 'Altenburg,MO',
'63735': 'Bell City,MO',
'63736': 'Benton,MO',
'63737': 'Brazeau,MO',
'63738': 'Brownwood,MO',
'63739': 'Burfordville,MO',
'63740': 'Chaffee,MO',
'63742': 'Commerce,MO',
'63743': 'Daisy,MO',
'63744': 'Delta,MO',
'63745': 'Dutchtown,MO',
'63746': 'Farrar,MO',
'63747': 'Friedheim,MO',
'63748': 'Frohna,MO',
'63750': 'Gipsy,MO',
'63751': 'Glenallen,MO',
'63752': 'Gordonville,MO',
'63753': 'Grassy,MO',
'63755': 'Jackson,MO',
'63758': 'Kelso,MO',
'63760': 'Leopold,MO',
'63763': 'Mc Gee,MO',
'63764': 'Marble Hill,MO',
'63766': 'Millersville,MO',
'63767': 'Morley,MO',
'63769': 'Oak Ridge,MO',
'63770': 'Old Appleton,MO',
'63771': 'Oran,MO',
'63772': 'Painton,MO',
'63774': 'Perkins,MO',
'63775': 'Perryville,MO',
'63776': 'Mc Bride,MO',
'63779': 'Pocahontas,MO',
'63780': 'Scott City,MO',
'63781': 'Sedgewickville,MO',
'63782': 'Sturdivant,MO',
'63783': 'Uniontown,MO',
'63784': 'Vanduser,MO',
'63785': 'Whitewater,MO',
'63787': 'Zalma,MO',
'63801': 'Sikeston,MO',
'63820': 'Anniston,MO',
'63821': 'Arbyrd,MO',
'63822': 'Bernie,MO',
'63823': 'Bertrand,MO',
'63824': 'Blodgett,MO',
'63825': 'Bloomfield,MO',
'63826': 'Braggadocio,MO',
'63827': 'Bragg City,MO',
'63828': 'Canalou,MO',
'63829': 'Cardwell,MO',
'63830': 'Caruthersville,MO',
'63833': 'Catron,MO',
'63834': 'Charleston,MO',
'63837': 'Clarkton,MO',
'63838': 'Conran,MO',
'63839': 'Cooter,MO',
'63840': 'Deering,MO',
'63841': 'Dexter,MO',
'63845': 'East Prairie,MO',
'63846': 'Essex,MO',
'63847': 'Gibson,MO',
'63848': 'Gideon,MO',
'63849': 'Gobler,MO',
'63850': 'Grayridge,MO',
'63851': 'Hayti,MO',
'63852': 'Holcomb,MO',
'63853': 'Holland,MO',
'63855': 'Hornersville,MO',
'63857': 'Kennett,MO',
'63860': 'Kewanee,MO',
'63862': 'Lilbourn,MO',
'63863': 'Malden,MO',
'63866': 'Marston,MO',
'63867': 'Matthews,MO',
'63868': 'Morehouse,MO',
'63869': 'New Madrid,MO',
'63870': 'Parma,MO',
'63871': 'Pascola,MO',
'63873': 'Portageville,MO',
'63874': 'Risco,MO',
'63875': 'Rives,MO',
'63876': 'Senath,MO',
'63877': 'Steele,MO',
'63878': 'Tallapoosa,MO',
'63879': 'Wardell,MO',
'63880': 'Whiteoak,MO',
'63881': 'Wolf Island,MO',
'63882': 'Wyatt,MO',
'63901': 'Poplar Bluff,MO',
'63902': 'Poplar Bluff,MO',
'63931': 'Briar,MO',
'63932': 'Broseley,MO',
'63933': 'Campbell,MO',
'63934': 'Clubb,MO',
'63935': 'Doniphan,MO',
'63936': 'Dudley,MO',
'63937': 'Ellsinore,MO',
'63938': 'Fagus,MO',
'63939': 'Fairdealing,MO',
'63940': 'Fisk,MO',
'63941': 'Fremont,MO',
'63942': 'Gatewood,MO',
'63943': 'Grandin,MO',
'63944': 'Greenville,MO',
'63945': 'Harviell,MO',
'63947': 'Hiram,MO',
'63950': 'Lodi,MO',
'63951': 'Lowndes,MO',
'63952': 'Mill Spring,MO',
'63953': 'Naylor,MO',
'63954': 'Neelyville,MO',
'63955': 'Oxly,MO',
'63956': 'Patterson,MO',
'63957': 'Piedmont,MO',
'63960': 'Puxico,MO',
'63961': 'Qulin,MO',
'63962': 'Rombauer,MO',
'63963': 'Shook,MO',
'63964': 'Silva,MO',
'63965': 'Van Buren,MO',
'63966': 'Wappapello,MO',
'63967': 'Williamsville,MO',
'64001': 'Alma,MO',
'64002': 'Homeland Nbc,MO',
'64011': 'Bates City,MO',
'64012': 'Belton,MO',
'64013': 'Blue Springs,MO',
'64014': 'Blue Springs,MO',
'64015': 'Blue Springs,MO',
'64016': 'Buckner,MO',
'64017': 'Camden,MO',
'64018': 'Camden Point,MO',
'64019': 'Centerview,MO',
'64020': 'Concordia,MO',
'64021': 'Corder,MO',
'64022': 'Dover,MO',
'64024': 'Excelsior Springs,MO',
'64028': 'Farley,MO',
'64029': 'Grain Valley,MO',
'64030': 'Grandview,MO',
'64034': 'Greenwood,MO',
'64035': 'Hardin,MO',
'64036': 'Henrietta,MO',
'64037': 'Higginsville,MO',
'64040': 'Holden,MO',
'64048': 'Holt,MO',
'64050': 'Independence,MO',
'64051': 'Independence,MO',
'64052': 'Independence,MO',
'64053': 'Independence,MO',
'64054': 'Independence,MO',
'64055': 'Independence,MO',
'64056': 'Independence,MO',
'64057': 'Independence,MO',
'64058': 'Independence,MO',
'64060': 'Kearney,MO',
'64061': 'Kingsville,MO',
'64062': 'Lawson,MO',
'64063': 'Lees Summit,MO',
'64064': 'Lees Summit,MO',
'64065': 'Lees Summit,MO',
'64066': 'Levasy,MO',
'64067': 'Lexington,MO',
'64068': 'Liberty,MO',
'64069': 'Liberty,MO',
'64070': 'Lone Jack,MO',
'64071': 'Mayview,MO',
'64072': 'Missouri City,MO',
'64073': 'Mosby,MO',
'64074': 'Napoleon,MO',
'64075': 'Oak Grove,MO',
'64076': 'Odessa,MO',
'64077': 'Orrick,MO',
'64078': 'Peculiar,MO',
'64079': 'Platte City,MO',
'64080': 'Pleasant Hill,MO',
'64081': 'Lees Summit,MO',
'64082': 'Lees Summit,MO',
'64083': 'Raymore,MO',
'64084': 'Rayville,MO',
'64085': 'Richmond,MO',
'64086': 'Lees Summit,MO',
'64087': 'Liberty,MO',
'64088': 'Sibley,MO',
'64089': 'Smithville,MO',
'64090': 'Strasburg,MO',
'64092': 'Waldron,MO',
'64093': 'Warrensburg,MO',
'64096': 'Waverly,MO',
'64097': 'Wellington,MO',
'64098': 'Weston,MO',
'64101': 'Kansas City,MO',
'64102': 'Kansas City,MO',
'64105': 'Kansas City,MO',
'64106': 'Kansas City,MO',
'64108': 'Kansas City,MO',
'64109': 'Kansas City,MO',
'64110': 'Kansas City,MO',
'64111': 'Kansas City,MO',
'64112': 'Kansas City,MO',
'64113': 'Kansas City,MO',
'64114': 'Kansas City,MO',
'64116': 'Kansas City,MO',
'64117': 'Kansas City,MO',
'64118': 'Kansas City,MO',
'64119': 'Kansas City,MO',
'64120': 'Kansas City,MO',
'64121': 'Kansas City,MO',
'64123': 'Kansas City,MO',
'64124': 'Kansas City,MO',
'64125': 'Kansas City,MO',
'64126': 'Kansas City,MO',
'64127': 'Kansas City,MO',
'64128': 'Kansas City,MO',
'64129': 'Kansas City,MO',
'64130': 'Kansas City,MO',
'64131': 'Kansas City,MO',
'64132': 'Kansas City,MO',
'64133': 'Kansas City,MO',
'64134': 'Kansas City,MO',
'64136': 'Kansas City,MO',
'64137': 'Kansas City,MO',
'64138': 'Kansas City,MO',
'64139': 'Kansas City,MO',
'64141': 'Kansas City,MO',
'64142': 'Kansas City,MO',
'64144': 'Kansas City,MO',
'64145': 'Kansas City,MO',
'64146': 'Kansas City,MO',
'64147': 'Kansas City,MO',
'64148': 'Kansas City,MO',
'64149': 'Kansas City,MO',
'64150': 'Riverside,MO',
'64151': 'Kansas City,MO',
'64152': 'Kansas City,MO',
'64153': 'Kansas City,MO',
'64154': 'Kansas City,MO',
'64155': 'Kansas City,MO',
'64156': 'Kansas City,MO',
'64157': 'Kansas City,MO',
'64158': 'Kansas City,MO',
'64160': 'Kansas City,MO',
'64161': 'Kansas City,MO',
'64163': 'Kansas City,MO',
'64164': 'Kansas City,MO',
'64165': 'Kansas City,MO',
'64166': 'Kansas City,MO',
'64167': 'Kansas City,MO',
'64168': 'Kansas City,MO',
'64170': 'Kansas City,MO',
'64171': 'Kansas City,MO',
'64172': 'Kansas City,MO',
'64173': 'Kansas City,MO',
'64179': 'Kansas City,MO',
'64180': 'Kansas City,MO',
'64183': 'Kansas City,MO',
'64184': 'Kansas City,MO',
'64185': 'Kansas City,MO',
'64187': 'Kansas City,MO',
'64188': 'Kansas City,MO',
'64189': 'Kansas City,MO',
'64190': 'Kansas City,MO',
'64191': 'Kansas City,MO',
'64192': 'Kansas City,MO',
'64193': 'Kansas City,MO',
'64194': 'Kansas City,MO',
'64195': 'Kansas City,MO',
'64196': 'Kansas City,MO',
'64197': 'Kansas City,MO',
'64198': 'Kansas City,MO',
'64199': 'Kansas City,MO',
'64401': 'Agency,MO',
'64402': 'Albany,MO',
'64420': 'Allendale,MO',
'64421': 'Amazonia,MO',
'64422': 'Amity,MO',
'64423': 'Barnard,MO',
'64424': 'Bethany,MO',
'64426': 'Blythedale,MO',
'64427': 'Bolckow,MO',
'64428': 'Burlington Junction,MO',
'64429': 'Cameron,MO',
'64430': 'Clarksdale,MO',
'64431': 'Clearmont,MO',
'64432': 'Clyde,MO',
'64433': 'Conception,MO',
'64434': 'Conception Junction,MO',
'64436': 'Cosby,MO',
'64437': 'Craig,MO',
'64438': 'Darlington,MO',
'64439': 'Dearborn,MO',
'64440': 'De Kalb,MO',
'64441': 'Denver,MO',
'64442': 'Eagleville,MO',
'64443': 'Easton,MO',
'64444': 'Edgerton,MO',
'64445': 'Elmo,MO',
'64446': 'Fairfax,MO',
'64447': 'Fairport,MO',
'64448': 'Faucett,MO',
'64449': 'Fillmore,MO',
'64451': 'Forest City,MO',
'64453': 'Gentry,MO',
'64454': 'Gower,MO',
'64455': 'Graham,MO',
'64456': 'Grant City,MO',
'64457': 'Guilford,MO',
'64458': 'Hatfield,MO',
'64459': 'Helena,MO',
'64461': 'Hopkins,MO',
'64463': 'King City,MO',
'64465': 'Lathrop,MO',
'64466': 'Maitland,MO',
'64467': 'Martinsville,MO',
'64468': 'Maryville,MO',
'64469': 'Maysville,MO',
'64470': 'Mound City,MO',
'64471': 'New Hampton,MO',
'64473': 'Oregon,MO',
'64474': 'Osborn,MO',
'64475': 'Parnell,MO',
'64476': 'Pickering,MO',
'64477': 'Plattsburg,MO',
'64478': 'Quitman,MO',
'64479': 'Ravenwood,MO',
'64480': 'Rea,MO',
'64481': 'Ridgeway,MO',
'64482': 'Rock Port,MO',
'64483': 'Rosendale,MO',
'64484': 'Rushville,MO',
'64485': 'Savannah,MO',
'64486': 'Sheridan,MO',
'64487': 'Skidmore,MO',
'64489': 'Stanberry,MO',
'64490': 'Stewartsville,MO',
'64491': 'Tarkio,MO',
'64492': 'Trimble,MO',
'64493': 'Turney,MO',
'64494': 'Union Star,MO',
'64496': 'Watson,MO',
'64497': 'Weatherby,MO',
'64498': 'Westboro,MO',
'64499': 'Worth,MO',
'64501': 'Saint Joseph,MO',
'64502': 'Saint Joseph,MO',
'64503': 'Saint Joseph,MO',
'64504': 'Saint Joseph,MO',
'64505': 'Saint Joseph,MO',
'64506': 'Saint Joseph,MO',
'64507': 'Saint Joseph,MO',
'64508': 'Saint Joseph,MO',
'64601': 'Chillicothe,MO',
'64620': 'Altamont,MO',
'64622': 'Bogard,MO',
'64623': 'Bosworth,MO',
'64624': 'Braymer,MO',
'64625': 'Breckenridge,MO',
'64628': 'Brookfield,MO',
'64630': 'Browning,MO',
'64631': 'Bucklin,MO',
'64632': 'Cainsville,MO',
'64633': 'Carrollton,MO',
'64635': 'Chula,MO',
'64636': 'Coffey,MO',
'64637': 'Cowgill,MO',
'64638': 'Dawn,MO',
'64639': 'De Witt,MO',
'64640': 'Gallatin,MO',
'64641': 'Galt,MO',
'64642': 'Gilman City,MO',
'64643': 'Hale,MO',
'64644': 'Hamilton,MO',
'64645': 'Harris,MO',
'64646': 'Humphreys,MO',
'64647': 'Jameson,MO',
'64648': 'Jamesport,MO',
'64649': 'Kidder,MO',
'64650': 'Kingston,MO',
'64651': 'Laclede,MO',
'64652': 'Laredo,MO',
'64653': 'Linneus,MO',
'64654': 'Lock Springs,MO',
'64655': 'Lucerne,MO',
'64656': 'Ludlow,MO',
'64657': 'Mc Fall,MO',
'64658': 'Marceline,MO',
'64659': 'Meadville,MO',
'64660': 'Mendon,MO',
'64661': 'Mercer,MO',
'64664': 'Mooresville,MO',
'64667': 'Newtown,MO',
'64668': 'Norborne,MO',
'64670': 'Pattonsburg,MO',
'64671': 'Polo,MO',
'64672': 'Powersville,MO',
'64673': 'Princeton,MO',
'64674': 'Purdin,MO',
'64676': 'Rothville,MO',
'64679': 'Spickard,MO',
'64680': 'Stet,MO',
'64681': 'Sumner,MO',
'64682': 'Tina,MO',
'64683': 'Trenton,MO',
'64686': 'Utica,MO',
'64687': 'Wakenda,MO',
'64688': 'Wheeling,MO',
'64689': 'Winston,MO',
'64701': 'Harrisonville,MO',
'64720': 'Adrian,MO',
'64722': 'Amoret,MO',
'64723': 'Amsterdam,MO',
'64724': 'Appleton City,MO',
'64725': 'Archie,MO',
'64726': 'Blairstown,MO',
'64728': 'Bronaugh,MO',
'64730': 'Butler,MO',
'64733': 'Chilhowee,MO',
'64734': 'Cleveland,MO',
'64735': 'Clinton,MO',
'64738': 'Collins,MO',
'64739': 'Creighton,MO',
'64740': 'Deepwater,MO',
'64741': 'Deerfield,MO',
'64742': 'Drexel,MO',
'64743': 'East Lynne,MO',
'64744': 'El Dorado Springs,MO',
'64745': 'Foster,MO',
'64746': 'Freeman,MO',
'64747': 'Garden City,MO',
'64748': 'Golden City,MO',
'64750': 'Harwood,MO',
'64751': 'Horton,MO',
'64752': 'Hume,MO',
'64755': 'Jasper,MO',
'64756': 'Jerico Springs,MO',
'64759': 'Lamar,MO',
'64761': 'Leeton,MO',
'64762': 'Liberal,MO',
'64763': 'Lowry City,MO',
'64765': 'Metz,MO',
'64766': 'Milford,MO',
'64767': 'Milo,MO',
'64769': 'Mindenmines,MO',
'64770': 'Montrose,MO',
'64771': 'Moundville,MO',
'64772': 'Nevada,MO',
'64776': 'Osceola,MO',
'64777': 'Passaic,MO',
'64778': 'Richards,MO',
'64779': 'Rich Hill,MO',
'64780': 'Rockville,MO',
'64781': 'Roscoe,MO',
'64783': 'Schell City,MO',
'64784': 'Sheldon,MO',
'64788': 'Urich,MO',
'64789': 'Vista,MO',
'64790': 'Walker,MO',
'64801': 'Joplin,MO',
'64802': 'Joplin,MO',
'64803': 'Joplin,MO',
'64804': 'Joplin,MO',
'64830': 'Alba,MO',
'64831': 'Anderson,MO',
'64832': 'Asbury,MO',
'64833': 'Avilla,MO',
'64834': 'Carl Junction,MO',
'64835': 'Carterville,MO',
'64836': 'Carthage,MO',
'64840': 'Diamond,MO',
'64841': 'Duenweg,MO',
'64842': 'Fairview,MO',
'64843': 'Goodman,MO',
'64844': 'Granby,MO',
'64847': 'Lanagan,MO',
'64848': 'La Russell,MO',
'64849': 'Neck City,MO',
'64850': 'Neosho,MO',
'64853': 'Newtonia,MO',
'64854': 'Noel,MO',
'64855': 'Oronogo,MO',
'64856': 'Pineville,MO',
'64857': 'Purcell,MO',
'64858': 'Racine,MO',
'64859': 'Reeds,MO',
'64861': 'Rocky Comfort,MO',
'64862': 'Sarcoxie,MO',
'64863': 'South West City,MO',
'64864': 'Saginaw,MO',
'64865': 'Seneca,MO',
'64866': 'Stark City,MO',
'64867': 'Stella,MO',
'64868': 'Tiff City,MO',
'64869': 'Waco,MO',
'64870': 'Webb City,MO',
'64873': 'Wentworth,MO',
'64874': 'Wheaton,MO',
'64944': 'Kansas City,MO',
'64999': 'Kansas City,MO',
'65001': 'Argyle,MO',
'65010': 'Ashland,MO',
'65011': 'Barnett,MO',
'65013': 'Belle,MO',
'65014': 'Bland,MO',
'65016': 'Bonnots Mill,MO',
'65017': 'Brumley,MO',
'65018': 'California,MO',
'65020': 'Camdenton,MO',
'65022': 'Cedar City,MO',
'65023': 'Centertown,MO',
'65024': 'Chamois,MO',
'65025': 'Clarksburg,MO',
'65026': 'Eldon,MO',
'65031': 'Etterville,MO',
'65032': 'Eugene,MO',
'65034': 'Fortuna,MO',
'65035': 'Freeburg,MO',
'65036': 'Gasconade,MO',
'65037': 'Gravois Mills,MO',
'65038': 'Laurie,MO',
'65039': 'Hartsburg,MO',
'65040': 'Henley,MO',
'65041': 'Hermann,MO',
'65042': 'High Point,MO',
'65043': 'Holts Summit,MO',
'65046': 'Jamestown,MO',
'65047': 'Kaiser,MO',
'65048': 'Koeltztown,MO',
'65049': 'Lake Ozark,MO',
'65050': 'Latham,MO',
'65051': 'Linn,MO',
'65052': 'Linn Creek,MO',
'65053': 'Lohman,MO',
'65054': 'Loose Creek,MO',
'65055': 'Mc Girk,MO',
'65058': 'Meta,MO',
'65059': 'Mokane,MO',
'65061': 'Morrison,MO',
'65062': 'Mount Sterling,MO',
'65063': 'New Bloomfield,MO',
'65064': 'Olean,MO',
'65065': 'Osage Beach,MO',
'65066': 'Owensville,MO',
'65067': 'Portland,MO',
'65068': 'Prairie Home,MO',
'65069': 'Rhineland,MO',
'65072': 'Rocky Mount,MO',
'65074': 'Russellville,MO',
'65075': 'Saint Elizabeth,MO',
'65076': 'Saint Thomas,MO',
'65077': 'Steedman,MO',
'65078': 'Stover,MO',
'65079': 'Sunrise Beach,MO',
'65080': 'Tebbetts,MO',
'65081': 'Tipton,MO',
'65082': 'Tuscumbia,MO',
'65083': 'Ulman,MO',
'65084': 'Versailles,MO',
'65085': 'Westphalia,MO',
'65101': 'Jefferson City,MO',
'65102': 'Jefferson City,MO',
'65103': 'Jefferson City,MO',
'65104': 'Jefferson City,MO',
'65105': 'Jefferson City,MO',
'65106': 'Jefferson City,MO',
'65107': 'Jefferson City,MO',
'65108': 'Jefferson City,MO',
'65109': 'Jefferson City,MO',
'65110': 'Jefferson City,MO',
'65111': 'Jefferson City,MO',
'65201': 'Columbia,MO',
'65202': 'Columbia,MO',
'65203': 'Columbia,MO',
'65205': 'Columbia,MO',
'65211': 'Columbia,MO',
'65212': 'Columbia,MO',
'65215': 'Columbia,MO',
'65216': 'Columbia,MO',
'65217': 'Columbia,MO',
'65218': 'Columbia,MO',
'65230': 'Armstrong,MO',
'65231': 'Auxvasse,MO',
'65232': 'Benton City,MO',
'65233': 'Boonville,MO',
'65236': 'Brunswick,MO',
'65237': 'Bunceton,MO',
'65239': 'Cairo,MO',
'65240': 'Centralia,MO',
'65243': 'Clark,MO',
'65244': 'Clifton Hill,MO',
'65246': 'Dalton,MO',
'65247': 'Excello,MO',
'65248': 'Fayette,MO',
'65250': 'Franklin,MO',
'65251': 'Fulton,MO',
'65254': 'Glasgow,MO',
'65255': 'Hallsville,MO',
'65256': 'Harrisburg,MO',
'65257': 'Higbee,MO',
'65258': 'Holliday,MO',
'65259': 'Huntsville,MO',
'65260': 'Jacksonville,MO',
'65261': 'Keytesville,MO',
'65262': 'Kingdom City,MO',
'65263': 'Madison,MO',
'65264': 'Martinsburg,MO',
'65265': 'Mexico,MO',
'65270': 'Moberly,MO',
'65274': 'New Franklin,MO',
'65275': 'Paris,MO',
'65276': 'Pilot Grove,MO',
'65278': 'Renick,MO',
'65279': 'Rocheport,MO',
'65280': 'Rush Hill,MO',
'65281': 'Salisbury,MO',
'65282': 'Santa Fe,MO',
'65283': 'Stoutsville,MO',
'65284': 'Sturgeon,MO',
'65285': 'Thompson,MO',
'65286': 'Triplett,MO',
'65287': 'Wooldridge,MO',
'65299': 'Columbia,MO',
'65301': 'Sedalia,MO',
'65302': 'Sedalia,MO',
'65305': 'Whiteman Air Force Base,MO',
'65320': 'Arrow Rock,MO',
'65321': 'Blackburn,MO',
'65322': 'Blackwater,MO',
'65323': 'Calhoun,MO',
'65324': 'Climax Springs,MO',
'65325': 'Cole Camp,MO',
'65326': 'Edwards,MO',
'65327': 'Emma,MO',
'65329': 'Florence,MO',
'65330': 'Gilliam,MO',
'65332': 'Green Ridge,MO',
'65333': 'Houstonia,MO',
'65334': 'Hughesville,MO',
'65335': 'Ionia,MO',
'65336': 'Knob Noster,MO',
'65337': 'La Monte,MO',
'65338': 'Lincoln,MO',
'65339': 'Malta Bend,MO',
'65340': 'Marshall,MO',
'65344': 'Miami,MO',
'65345': 'Mora,MO',
'65347': 'Nelson,MO',
'65348': 'Otterville,MO',
'65349': 'Slater,MO',
'65350': 'Smithton,MO',
'65351': 'Sweet Springs,MO',
'65354': 'Syracuse,MO',
'65355': 'Warsaw,MO',
'65360': 'Windsor,MO',
'65401': 'Rolla,MO',
'65402': 'Rolla,MO',
'65409': 'Rolla,MO',
'65433': 'Bendavis,MO',
'65436': 'Beulah,MO',
'65438': 'Birch Tree,MO',
'65439': 'Bixby,MO',
'65440': 'Boss,MO',
'65441': 'Bourbon,MO',
'65443': 'Brinktown,MO',
'65444': 'Bucyrus,MO',
'65446': 'Cherryville,MO',
'65449': 'Cook Station,MO',
'65452': 'Crocker,MO',
'65453': 'Cuba,MO',
'65456': 'Davisville,MO',
'65457': 'Devils Elbow,MO',
'65459': 'Dixon,MO',
'65461': 'Duke,MO',
'65462': 'Edgar Springs,MO',
'65463': 'Eldridge,MO',
'65464': 'Elk Creek,MO',
'65466': 'Eminence,MO',
'65468': 'Eunice,MO',
'65470': 'Falcon,MO',
'65473': 'Fort Leonard Wood,MO',
'65479': 'Hartshorn,MO',
'65483': 'Houston,MO',
'65484': 'Huggins,MO',
'65486': 'Iberia,MO',
'65501': 'Jadwin,MO',
'65529': 'Jerome,MO',
'65532': 'Lake Spring,MO',
'65534': 'Laquey,MO',
'65535': 'Leasburg,MO',
'65536': 'Lebanon,MO',
'65540': 'Lecoma,MO',
'65541': 'Lenox,MO',
'65542': 'Licking,MO',
'65543': 'Lynchburg,MO',
'65546': 'Montier,MO',
'65548': 'Mountain View,MO',
'65550': 'Newburg,MO',
'65552': 'Plato,MO',
'65555': 'Raymondville,MO',
'65556': 'Richland,MO',
'65557': 'Roby,MO',
'65559': 'Saint James,MO',
'65560': 'Salem,MO',
'65564': 'Solo,MO',
'65565': 'Steelville,MO',
'65566': 'Viburnum,MO',
'65567': 'Stoutland,MO',
'65570': 'Success,MO',
'65571': 'Summersville,MO',
'65572': 'Swedeborg,MO',
'65573': 'Teresita,MO',
'65580': 'Vichy,MO',
'65582': 'Vienna,MO',
'65583': 'Waynesville,MO',
'65584': 'Saint Robert,MO',
'65586': 'Wesco,MO',
'65588': 'Winona,MO',
'65589': 'Yukon,MO',
'65590': 'Long Lane,MO',
'65591': 'Montreal,MO',
'65601': 'Aldrich,MO',
'65603': 'Arcola,MO',
'65604': 'Ash Grove,MO',
'65605': 'Aurora,MO',
'65606': 'Alton,MO',
'65607': 'Caplinger Mills,MO',
'65608': 'Ava,MO',
'65609': 'Bakersfield,MO',
'65610': 'Billings,MO',
'65611': 'Blue Eye,MO',
'65612': 'Bois D Arc,MO',
'65613': 'Bolivar,MO',
'65614': 'Bradleyville,MO',
'65615': 'Branson,MO',
'65616': 'Branson,MO',
'65617': 'Brighton,MO',
'65618': 'Brixey,MO',
'65619': 'Brookline Station,MO',
'65620': 'Bruner,MO',
'65622': 'Buffalo,MO',
'65623': 'Butterfield,MO',
'65624': 'Cape Fair,MO',
'65625': 'Cassville,MO',
'65626': 'Caulfield,MO',
'65627': 'Cedarcreek,MO',
'65629': 'Chadwick,MO',
'65630': 'Chestnutridge,MO',
'65631': 'Clever,MO',
'65632': 'Conway,MO',
'65633': 'Crane,MO',
'65634': 'Cross Timbers,MO',
'65635': 'Dadeville,MO',
'65636': 'Diggins,MO',
'65637': 'Dora,MO',
'65638': 'Drury,MO',
'65640': 'Dunnegan,MO',
'65641': 'Eagle Rock,MO',
'65644': 'Elkland,MO',
'65645': 'Eudora,MO',
'65646': 'Everton,MO',
'65647': 'Exeter,MO',
'65648': 'Fair Grove,MO',
'65649': 'Fair Play,MO',
'65650': 'Flemington,MO',
'65652': 'Fordland,MO',
'65653': 'Forsyth,MO',
'65654': 'Freistatt,MO',
'65655': 'Gainesville,MO',
'65656': 'Galena,MO',
'65657': 'Garrison,MO',
'65658': 'Golden,MO',
'65659': 'Goodson,MO',
'65660': 'Graff,MO',
'65661': 'Greenfield,MO',
'65662': 'Grovespring,MO',
'65663': 'Half Way,MO',
'65664': 'Halltown,MO',
'65666': 'Hardenville,MO',
'65667': 'Hartville,MO',
'65668': 'Hermitage,MO',
'65669': 'Highlandville,MO',
'65672': 'Hollister,MO',
'65673': 'Hollister,MO',
'65674': 'Humansville,MO',
'65675': 'Hurley,MO',
'65676': 'Isabella,MO',
'65679': 'Kirbyville,MO',
'65680': 'Kissee Mills,MO',
'65681': 'Lampe,MO',
'65682': 'Lockwood,MO',
'65685': 'Louisburg,MO',
'65686': 'Kimberling City,MO',
'65688': 'Brandsville,MO',
'65689': 'Cabool,MO',
'65690': 'Couch,MO',
'65692': 'Koshkonong,MO',
'65701': 'Mc Clurg,MO',
'65702': 'Macomb,MO',
'65704': 'Mansfield,MO',
'65705': 'Marionville,MO',
'65706': 'Marshfield,MO',
'65707': 'Miller,MO',
'65708': 'Monett,MO',
'65710': 'Morrisville,MO',
'65711': 'Mountain Grove,MO',
'65712': 'Mount Vernon,MO',
'65713': 'Niangua,MO',
'65714': 'Nixa,MO',
'65715': 'Noble,MO',
'65717': 'Norwood,MO',
'65720': 'Oldfield,MO',
'65721': 'Ozark,MO',
'65722': 'Phillipsburg,MO',
'65723': 'Pierce City,MO',
'65724': 'Pittsburg,MO',
'65725': 'Pleasant Hope,MO',
'65726': 'Point Lookout,MO',
'65727': 'Polk,MO',
'65728': 'Ponce De Leon,MO',
'65729': 'Pontiac,MO',
'65730': 'Powell,MO',
'65731': 'Powersite,MO',
'65732': 'Preston,MO',
'65733': 'Protem,MO',
'65734': 'Purdy,MO',
'65735': 'Quincy,MO',
'65737': 'Reeds Spring,MO',
'65738': 'Republic,MO',
'65739': 'Ridgedale,MO',
'65740': 'Rockaway Beach,MO',
'65741': 'Rockbridge,MO',
'65742': 'Rogersville,MO',
'65744': 'Rueter,MO',
'65745': 'Seligman,MO',
'65746': 'Seymour,MO',
'65747': 'Shell Knob,MO',
'65752': 'South Greenfield,MO',
'65753': 'Sparta,MO',
'65754': 'Spokane,MO',
'65755': 'Squires,MO',
'65756': 'Stotts City,MO',
'65757': 'Strafford,MO',
'65759': 'Taneyville,MO',
'65760': 'Tecumseh,MO',
'65761': 'Theodosia,MO',
'65762': 'Thornfield,MO',
'65764': 'Tunas,MO',
'65765': 'Turners,MO',
'65766': 'Udall,MO',
'65767': 'Urbana,MO',
'65768': 'Vanzant,MO',
'65769': 'Verona,MO',
'65770': 'Walnut Grove,MO',
'65771': 'Walnut Shade,MO',
'65772': 'Washburn,MO',
'65773': 'Wasola,MO',
'65774': 'Weaubleau,MO',
'65775': 'West Plains,MO',
'65776': 'South Fork,MO',
'65777': 'Moody,MO',
'65778': 'Myrtle,MO',
'65779': 'Wheatland,MO',
'65781': 'Willard,MO',
'65783': 'Windyville,MO',
'65784': 'Zanoni,MO',
'65785': 'Stockton,MO',
'65786': 'Macks Creek,MO',
'65787': 'Roach,MO',
'65788': 'Peace Valley,MO',
'65789': 'Pomona,MO',
'65790': 'Pottersville,MO',
'65791': 'Thayer,MO',
'65793': 'Willow Springs,MO',
'65801': 'Springfield,MO',
'65802': 'Springfield,MO',
'65803': 'Springfield,MO',
'65804': 'Springfield,MO',
'65805': 'Springfield,MO',
'65806': 'Springfield,MO',
'65807': 'Springfield,MO',
'65808': 'Springfield,MO',
'65809': 'Springfield,MO',
'65810': 'Springfield,MO',
'65814': 'Springfield,MO',
'65817': 'Springfield,MO',
'65890': 'Springfield,MO',
'65897': 'Sw Mo State,MO',
'65898': 'Springfield,MO',
'65899': 'Springfield,MO',
'66002': 'Atchison,KS',
'66006': 'Baldwin City,KS',
'66007': 'Basehor,KS',
'66008': 'Bendena,KS',
'66010': 'Blue Mound,KS',
'66012': 'Bonner Springs,KS',
'66013': 'Bucyrus,KS',
'66014': 'Centerville,KS',
'66015': 'Colony,KS',
'66016': 'Cummings,KS',
'66017': 'Denton,KS',
'66018': 'De Soto,KS',
'66019': 'Clearview City,KS',
'66020': 'Easton,KS',
'66021': 'Edgerton,KS',
'66023': 'Effingham,KS',
'66024': 'Elwood,KS',
'66025': 'Eudora,KS',
'66026': 'Fontana,KS',
'66027': 'Fort Leavenworth,KS',
'66030': 'Gardner,KS',
'66031': 'New Century,KS',
'66032': 'Garnett,KS',
'66033': 'Greeley,KS',
'66035': 'Highland,KS',
'66036': 'Hillsdale,KS',
'66039': 'Kincaid,KS',
'66040': 'La Cygne,KS',
'66041': 'Lancaster,KS',
'66042': 'Lane,KS',
'66043': 'Lansing,KS',
'66044': 'Lawrence,KS',
'66045': 'Lawrence,KS',
'66046': 'Lawrence,KS',
'66047': 'Lawrence,KS',
'66048': 'Leavenworth,KS',
'66049': 'Lawrence,KS',
'66050': 'Lecompton,KS',
'66051': 'Olathe,KS',
'66052': 'Linwood,KS',
'66053': 'Louisburg,KS',
'66054': 'Mc Louth,KS',
'66056': 'Mound City,KS',
'66058': 'Muscotah,KS',
'66060': 'Nortonville,KS',
'66061': 'Olathe,KS',
'66062': 'Olathe,KS',
'66063': 'Olathe,KS',
'66064': 'Osawatomie,KS',
'66066': 'Oskaloosa,KS',
'66067': 'Ottawa,KS',
'66070': 'Ozawkie,KS',
'66071': 'Paola,KS',
'66072': 'Parker,KS',
'66073': 'Perry,KS',
'66075': 'Pleasanton,KS',
'66076': 'Pomona,KS',
'66077': 'Potter,KS',
'66078': 'Princeton,KS',
'66079': 'Rantoul,KS',
'66080': 'Richmond,KS',
'66083': 'Spring Hill,KS',
'66085': 'Stilwell,KS',
'66086': 'Tonganoxie,KS',
'66087': 'Troy,KS',
'66088': 'Valley Falls,KS',
'66090': 'Wathena,KS',
'66091': 'Welda,KS',
'66092': 'Wellsville,KS',
'66093': 'Westphalia,KS',
'66094': 'White Cloud,KS',
'66095': 'Williamsburg,KS',
'66097': 'Winchester,KS',
'66101': 'Kansas City,KS',
'66102': 'Kansas City,KS',
'66103': 'Kansas City,KS',
'66104': 'Kansas City,KS',
'66105': 'Kansas City,KS',
'66106': 'Kansas City,KS',
'66109': 'Kansas City,KS',
'66110': 'Kansas City,KS',
'66111': 'Kansas City,KS',
'66112': 'Kansas City,KS',
'66113': 'Edwardsville,KS',
'66115': 'Kansas City,KS',
'66117': 'Kansas City,KS',
'66118': 'Kansas City,KS',
'66119': 'Kansas City,KS',
'66160': 'Kansas City,KS',
'66201': 'Shawnee Mission,KS',
'66202': 'Shawnee Mission,KS',
'66203': 'Shawnee Mission,KS',
'66204': 'Shawnee Mission,KS',
'66205': 'Shawnee Mission,KS',
'66206': 'Shawnee Mission,KS',
'66207': 'Shawnee Mission,KS',
'66208': 'Shawnee Mission,KS',
'66209': 'Shawnee Mission,KS',
'66210': 'Shawnee Mission,KS',
'66211': 'Shawnee Mission,KS',
'66212': 'Shawnee Mission,KS',
'66213': 'Shawnee Mission,KS',
'66214': 'Shawnee Mission,KS',
'66215': 'Shawnee Mission,KS',
'66216': 'Shawnee Mission,KS',
'66217': 'Shawnee Mission,KS',
'66218': 'Shawnee Mission,KS',
'66219': 'Shawnee Mission,KS',
'66220': 'Shawnee Mission,KS',
'66221': 'Shawnee Mission,KS',
'66222': 'Shawnee Mission,KS',
'66223': 'Shawnee Mission,KS',
'66224': 'Shawnee Mission,KS',
'66225': 'Shawnee Mission,KS',
'66226': 'Shawnee Mission,KS',
'66227': 'Shawnee Mission,KS',
'66250': 'Shawnee Mission,KS',
'66251': 'Shawnee Mission,KS',
'66276': 'Shawnee Mission,KS',
'66279': 'Shawnee Mission,KS',
'66282': 'Shawnee Mission,KS',
'66283': 'Shawnee Mission,KS',
'66285': 'Shawnee Mission,KS',
'66286': 'Shawnee Mission,KS',
'66401': 'Alma,KS',
'66402': 'Auburn,KS',
'66403': 'Axtell,KS',
'66404': 'Baileyville,KS',
'66406': 'Beattie,KS',
'66407': 'Belvue,KS',
'66408': 'Bern,KS',
'66409': 'Berryton,KS',
'66411': 'Blue Rapids,KS',
'66412': 'Bremen,KS',
'66413': 'Burlingame,KS',
'66414': 'Carbondale,KS',
'66415': 'Centralia,KS',
'66416': 'Circleville,KS',
'66417': 'Corning,KS',
'66418': 'Delia,KS',
'66419': 'Denison,KS',
'66420': 'Dover,KS',
'66422': 'Emmett,KS',
'66423': 'Eskridge,KS',
'66424': 'Everest,KS',
'66425': 'Fairview,KS',
'66426': 'Fostoria,KS',
'66427': 'Frankfort,KS',
'66428': 'Goff,KS',
'66429': 'Grantville,KS',
'66431': 'Harveyville,KS',
'66432': 'Havensville,KS',
'66434': 'Hiawatha,KS',
'66436': 'Holton,KS',
'66438': 'Home,KS',
'66439': 'Horton,KS',
'66440': 'Hoyt,KS',
'66441': 'Junction City,KS',
'66442': 'Fort Riley,KS',
'66449': 'Leonardville,KS',
'66450': 'Louisville,KS',
'66451': 'Lyndon,KS',
'66501': 'Mc Farland,KS',
'66502': 'Manhattan,KS',
'66503': 'Manhattan,KS',
'66505': 'Manhattan,KS',
'66506': 'Manhattan,KS',
'66507': 'Maple Hill,KS',
'66508': 'Marysville,KS',
'66509': 'Mayetta,KS',
'66510': 'Melvern,KS',
'66512': 'Meriden,KS',
'66514': 'Milford,KS',
'66515': 'Morrill,KS',
'66516': 'Netawaka,KS',
'66517': 'Ogden,KS',
'66518': 'Oketo,KS',
'66520': 'Olsburg,KS',
'66521': 'Onaga,KS',
'66522': 'Oneida,KS',
'66523': 'Osage City,KS',
'66524': 'Overbrook,KS',
'66526': 'Paxico,KS',
'66527': 'Powhattan,KS',
'66528': 'Quenemo,KS',
'66531': 'Riley,KS',
'66532': 'Robinson,KS',
'66533': 'Rossville,KS',
'66534': 'Sabetha,KS',
'66535': 'Saint George,KS',
'66536': 'Saint Marys,KS',
'66537': 'Scranton,KS',
'66538': 'Seneca,KS',
'66539': 'Silver Lake,KS',
'66540': 'Soldier,KS',
'66541': 'Summerfield,KS',
'66542': 'Tecumseh,KS',
'66543': 'Vassar,KS',
'66544': 'Vermillion,KS',
'66546': 'Wakarusa,KS',
'66547': 'Wamego,KS',
'66548': 'Waterville,KS',
'66549': 'Westmoreland,KS',
'66550': 'Wetmore,KS',
'66551': 'Wheaton,KS',
'66552': 'Whiting,KS',
'66554': 'Randolph,KS',
'66555': 'Marysville,KS',
'66601': 'Topeka,KS',
'66603': 'Topeka,KS',
'66604': 'Topeka,KS',
'66605': 'Topeka,KS',
'66606': 'Topeka,KS',
'66607': 'Topeka,KS',
'66608': 'Topeka,KS',
'66609': 'Topeka,KS',
'66610': 'Topeka,KS',
'66611': 'Topeka,KS',
'66612': 'Topeka,KS',
'66614': 'Topeka,KS',
'66615': 'Topeka,KS',
'66616': 'Topeka,KS',
'66617': 'Topeka,KS',
'66618': 'Topeka,KS',
'66619': 'Topeka,KS',
'66620': 'Topeka,KS',
'66621': 'Topeka,KS',
'66622': 'Topeka,KS',
'66624': 'Topeka,KS',
'66625': 'Topeka,KS',
'66626': 'Topeka,KS',
'66628': 'Topeka,KS',
'66629': 'Topeka,KS',
'66634': 'Topeka,KS',
'66636': 'Topeka,KS',
'66637': 'Topeka,KS',
'66638': 'Topeka,KS',
'66642': 'Topeka,KS',
'66647': 'Topeka,KS',
'66652': 'Topeka,KS',
'66653': 'Topeka,KS',
'66658': 'Topeka,KS',
'66667': 'Topeka,KS',
'66675': 'Topeka,KS',
'66683': 'Topeka,KS',
'66686': 'Topeka,KS',
'66692': 'Topeka,KS',
'66699': 'Topeka,KS',
'66701': 'Fort Scott,KS',
'66710': 'Altoona,KS',
'66711': 'Arcadia,KS',
'66712': 'Arma,KS',
'66713': 'Baxter Springs,KS',
'66714': 'Benedict,KS',
'66716': 'Bronson,KS',
'66717': 'Buffalo,KS',
'66720': 'Chanute,KS',
'66724': 'Cherokee,KS',
'66725': 'Columbus,KS',
'66727': 'Coyville,KS',
'66728': 'Crestline,KS',
'66732': 'Elsmore,KS',
'66733': 'Erie,KS',
'66734': 'Farlington,KS',
'66735': 'Franklin,KS',
'66736': 'Fredonia,KS',
'66738': 'Fulton,KS',
'66739': 'Galena,KS',
'66740': 'Galesburg,KS',
'66741': 'Garland,KS',
'66742': 'Gas,KS',
'66743': 'Girard,KS',
'66746': 'Hepler,KS',
'66748': 'Humboldt,KS',
'66749': 'Iola,KS',
'66751': 'La Harpe,KS',
'66753': 'Mc Cune,KS',
'66754': 'Mapleton,KS',
'66755': 'Moran,KS',
'66756': 'Mulberry,KS',
'66757': 'Neodesha,KS',
'66758': 'Neosho Falls,KS',
'66759': 'New Albany,KS',
'66760': 'Opolis,KS',
'66761': 'Piqua,KS',
'66762': 'Pittsburg,KS',
'66763': 'Frontenac,KS',
'66767': 'Prescott,KS',
'66769': 'Redfield,KS',
'66770': 'Riverton,KS',
'66771': 'Saint Paul,KS',
'66772': 'Savonburg,KS',
'66773': 'Scammon,KS',
'66775': 'Stark,KS',
'66776': 'Thayer,KS',
'66777': 'Toronto,KS',
'66778': 'Treece,KS',
'66779': 'Uniontown,KS',
'66780': 'Walnut,KS',
'66781': 'Weir,KS',
'66782': 'West Mineral,KS',
'66783': 'Yates Center,KS',
'66801': 'Emporia,KS',
'66830': 'Admire,KS',
'66833': 'Allen,KS',
'66834': 'Alta Vista,KS',
'66835': 'Americus,KS',
'66838': 'Burdick,KS',
'66839': 'Burlington,KS',
'66840': 'Burns,KS',
'66842': 'Cassoday,KS',
'66843': 'Cedar Point,KS',
'66845': 'Cottonwood Falls,KS',
'66846': 'Council Grove,KS',
'66849': 'Dwight,KS',
'66850': 'Elmdale,KS',
'66851': 'Florence,KS',
'66852': 'Gridley,KS',
'66853': 'Hamilton,KS',
'66854': 'Hartford,KS',
'66855': 'Lamont,KS',
'66856': 'Lebo,KS',
'66857': 'Le Roy,KS',
'66858': 'Lincolnville,KS',
'66859': 'Lost Springs,KS',
'66860': 'Madison,KS',
'66861': 'Marion,KS',
'66862': 'Matfield Green,KS',
'66863': 'Neal,KS',
'66864': 'Neosho Rapids,KS',
'66865': 'Olpe,KS',
'66866': 'Peabody,KS',
'66868': 'Reading,KS',
'66869': 'Strong City,KS',
'66870': 'Virgil,KS',
'66871': 'Waverly,KS',
'66872': 'White City,KS',
'66873': 'Wilsey,KS',
'66901': 'Concordia,KS',
'66930': 'Agenda,KS',
'66932': 'Athol,KS',
'66933': 'Barnes,KS',
'66935': 'Belleville,KS',
'66936': 'Burr Oak,KS',
'66937': 'Clifton,KS',
'66938': 'Clyde,KS',
'66939': 'Courtland,KS',
'66940': 'Cuba,KS',
'66941': 'Esbon,KS',
'66942': 'Formoso,KS',
'66943': 'Greenleaf,KS',
'66944': 'Haddam,KS',
'66945': 'Hanover,KS',
'66946': 'Hollenberg,KS',
'66948': 'Jamestown,KS',
'66949': 'Jewell,KS',
'66951': 'Kensington,KS',
'66952': 'Lebanon,KS',
'66953': 'Linn,KS',
'66955': 'Mahaska,KS',
'66956': 'Mankato,KS',
'66958': 'Morrowville,KS',
'66959': 'Munden,KS',
'66960': 'Narka,KS',
'66961': 'Norway,KS',
'66962': 'Palmer,KS',
'66963': 'Randall,KS',
'66964': 'Republic,KS',
'66966': 'Scandia,KS',
'66967': 'Smith Center,KS',
'66968': 'Washington,KS',
'66970': 'Webber,KS',
'67001': 'Andale,KS',
'67002': 'Andover,KS',
'67003': 'Anthony,KS',
'67004': 'Argonia,KS',
'67005': 'Arkansas City,KS',
'67008': 'Atlanta,KS',
'67009': 'Attica,KS',
'67010': 'Augusta,KS',
'67012': 'Beaumont,KS',
'67013': 'Belle Plaine,KS',
'67016': 'Bentley,KS',
'67017': 'Benton,KS',
'67018': 'Bluff City,KS',
'67019': 'Burden,KS',
'67020': 'Burrton,KS',
'67021': 'Byers,KS',
'67022': 'Caldwell,KS',
'67023': 'Cambridge,KS',
'67024': 'Cedar Vale,KS',
'67025': 'Cheney,KS',
'67026': 'Clearwater,KS',
'67028': 'Coats,KS',
'67029': 'Coldwater,KS',
'67030': 'Colwich,KS',
'67031': 'Conway Springs,KS',
'67035': 'Cunningham,KS',
'67036': 'Danville,KS',
'67037': 'Derby,KS',
'67038': 'Dexter,KS',
'67039': 'Douglass,KS',
'67041': 'Elbing,KS',
'67042': 'El Dorado,KS',
'67045': 'Eureka,KS',
'67047': 'Fall River,KS',
'67049': 'Freeport,KS',
'67050': 'Garden Plain,KS',
'67051': 'Geuda Springs,KS',
'67052': 'Goddard,KS',
'67053': 'Goessel,KS',
'67054': 'Greensburg,KS',
'67055': 'Greenwich,KS',
'67056': 'Halstead,KS',
'67057': 'Hardtner,KS',
'67058': 'Harper,KS',
'67059': 'Haviland,KS',
'67060': 'Haysville,KS',
'67061': 'Hazelton,KS',
'67062': 'Hesston,KS',
'67063': 'Hillsboro,KS',
'67065': 'Isabel,KS',
'67066': 'Iuka,KS',
'67067': 'Kechi,KS',
'67068': 'Kingman,KS',
'67070': 'Kiowa,KS',
'67071': 'Lake City,KS',
'67072': 'Latham,KS',
'67073': 'Lehigh,KS',
'67074': 'Leon,KS',
'67101': 'Maize,KS',
'67102': 'Maple City,KS',
'67103': 'Mayfield,KS',
'67104': 'Medicine Lodge,KS',
'67105': 'Milan,KS',
'67106': 'Milton,KS',
'67107': 'Moundridge,KS',
'67108': 'Mount Hope,KS',
'67109': 'Mullinville,KS',
'67110': 'Mulvane,KS',
'67111': 'Murdock,KS',
'67112': 'Nashville,KS',
'67114': 'Newton,KS',
'67117': 'North Newton,KS',
'67118': 'Norwich,KS',
'67119': 'Oxford,KS',
'67120': 'Peck,KS',
'67122': 'Piedmont,KS',
'67123': 'Potwin,KS',
'67124': 'Pratt,KS',
'67127': 'Protection,KS',
'67128': 'Rago,KS',
'67131': 'Rock,KS',
'67132': 'Rosalia,KS',
'67133': 'Rose Hill,KS',
'67134': 'Sawyer,KS',
'67135': 'Sedgwick,KS',
'67137': 'Severy,KS',
'67138': 'Sharon,KS',
'67140': 'South Haven,KS',
'67142': 'Spivey,KS',
'67143': 'Sun City,KS',
'67144': 'Towanda,KS',
'67146': 'Udall,KS',
'67147': 'Valley Center,KS',
'67149': 'Viola,KS',
'67150': 'Waldron,KS',
'67151': 'Walton,KS',
'67152': 'Wellington,KS',
'67154': 'Whitewater,KS',
'67155': 'Wilmore,KS',
'67156': 'Winfield,KS',
'67159': 'Zenda,KS',
'67201': 'Wichita,KS',
'67202': 'Wichita,KS',
'67203': 'Wichita,KS',
'67204': 'Wichita,KS',
'67205': 'Wichita,KS',
'67206': 'Wichita,KS',
'67207': 'Wichita,KS',
'67208': 'Wichita,KS',
'67209': 'Wichita,KS',
'67210': 'Wichita,KS',
'67211': 'Wichita,KS',
'67212': 'Wichita,KS',
'67213': 'Wichita,KS',
'67214': 'Wichita,KS',
'67215': 'Wichita,KS',
'67216': 'Wichita,KS',
'67217': 'Wichita,KS',
'67218': 'Wichita,KS',
'67219': 'Wichita,KS',
'67220': 'Wichita,KS',
'67221': 'Mcconnell Afb,KS',
'67223': 'Wichita,KS',
'67226': 'Wichita,KS',
'67227': 'Wichita,KS',
'67228': 'Wichita,KS',
'67230': 'Wichita,KS',
'67231': 'Wichita,KS',
'67232': 'Wichita,KS',
'67233': 'Wichita,KS',
'67235': 'Wichita,KS',
'67236': 'Wichita,KS',
'67251': 'Wichita,KS',
'67256': 'Wichita,KS',
'67257': 'Wichita,KS',
'67259': 'Wichita,KS',
'67260': 'Wichita,KS',
'67275': 'Wichita,KS',
'67276': 'Wichita,KS',
'67277': 'Wichita,KS',
'67278': 'Wichita,KS',
'67301': 'Independence,KS',
'67330': 'Altamont,KS',
'67332': 'Bartlett,KS',
'67333': 'Caney,KS',
'67334': 'Chautauqua,KS',
'67335': 'Cherryvale,KS',
'67336': 'Chetopa,KS',
'67337': 'Coffeyville,KS',
'67340': 'Dearing,KS',
'67341': 'Dennis,KS',
'67342': 'Edna,KS',
'67344': 'Elk City,KS',
'67345': 'Elk Falls,KS',
'67346': 'Grenola,KS',
'67347': 'Havana,KS',
'67349': 'Howard,KS',
'67351': 'Liberty,KS',
'67352': 'Longton,KS',
'67353': 'Moline,KS',
'67354': 'Mound Valley,KS',
'67355': 'Niotaze,KS',
'67356': 'Oswego,KS',
'67357': 'Parsons,KS',
'67360': 'Peru,KS',
'67361': 'Sedan,KS',
'67363': 'Sycamore,KS',
'67364': 'Tyro,KS',
'67401': 'Salina,KS',
'67402': 'Salina,KS',
'67410': 'Abilene,KS',
'67416': 'Assaria,KS',
'67417': 'Aurora,KS',
'67418': 'Barnard,KS',
'67420': 'Beloit,KS',
'67422': 'Bennington,KS',
'67423': 'Beverly,KS',
'67425': 'Brookville,KS',
'67427': 'Bushton,KS',
'67428': 'Canton,KS',
'67430': 'Cawker City,KS',
'67431': 'Chapman,KS',
'67432': 'Clay Center,KS',
'67436': 'Delphos,KS',
'67437': 'Downs,KS',
'67438': 'Durham,KS',
'67439': 'Ellsworth,KS',
'67441': 'Enterprise,KS',
'67442': 'Falun,KS',
'67443': 'Galva,KS',
'67444': 'Geneseo,KS',
'67445': 'Glasco,KS',
'67446': 'Glen Elder,KS',
'67447': 'Green,KS',
'67448': 'Gypsum,KS',
'67449': 'Herington,KS',
'67450': 'Holyrood,KS',
'67451': 'Hope,KS',
'67452': 'Hunter,KS',
'67454': 'Kanopolis,KS',
'67455': 'Lincoln,KS',
'67456': 'Lindsborg,KS',
'67457': 'Little River,KS',
'67458': 'Longford,KS',
'67459': 'Lorraine,KS',
'67460': 'Mcpherson,KS',
'67464': 'Marquette,KS',
'67466': 'Miltonvale,KS',
'67467': 'Minneapolis,KS',
'67468': 'Morganville,KS',
'67470': 'New Cambria,KS',
'67473': 'Osborne,KS',
'67474': 'Portis,KS',
'67475': 'Ramona,KS',
'67476': 'Roxbury,KS',
'67478': 'Simpson,KS',
'67480': 'Solomon,KS',
'67481': 'Sylvan Grove,KS',
'67482': 'Talmage,KS',
'67483': 'Tampa,KS',
'67484': 'Tescott,KS',
'67485': 'Tipton,KS',
'67487': 'Wakefield,KS',
'67490': 'Wilson,KS',
'67491': 'Windom,KS',
'67492': 'Woodbine,KS',
'67501': 'Hutchinson,KS',
'67502': 'Hutchinson,KS',
'67504': 'Hutchinson,KS',
'67505': 'South Hutchinson,KS',
'67510': 'Abbyville,KS',
'67511': 'Albert,KS',
'67512': 'Alden,KS',
'67513': 'Alexander,KS',
'67514': 'Arlington,KS',
'67515': 'Arnold,KS',
'67516': 'Bazine,KS',
'67518': 'Beeler,KS',
'67519': 'Belpre,KS',
'67520': 'Bison,KS',
'67521': 'Brownell,KS',
'67522': 'Buhler,KS',
'67523': 'Burdett,KS',
'67524': 'Chase,KS',
'67525': 'Claflin,KS',
'67526': 'Ellinwood,KS',
'67529': 'Garfield,KS',
'67530': 'Great Bend,KS',
'67543': 'Haven,KS',
'67544': 'Hoisington,KS',
'67545': 'Hudson,KS',
'67546': 'Inman,KS',
'67547': 'Kinsley,KS',
'67548': 'La Crosse,KS',
'67550': 'Larned,KS',
'67552': 'Lewis,KS',
'67553': 'Liebenthal,KS',
'67554': 'Lyons,KS',
'67556': 'Mc Cracken,KS',
'67557': 'Macksville,KS',
'67559': 'Nekoma,KS',
'67560': 'Ness City,KS',
'67561': 'Nickerson,KS',
'67563': 'Offerle,KS',
'67564': 'Olmitz,KS',
'67565': 'Otis,KS',
'67566': 'Partridge,KS',
'67567': 'Pawnee Rock,KS',
'67568': 'Plevna,KS',
'67570': 'Pretty Prairie,KS',
'67572': 'Ransom,KS',
'67573': 'Raymond,KS',
'67574': 'Rozel,KS',
'67575': 'Rush Center,KS',
'67576': 'Saint John,KS',
'67578': 'Stafford,KS',
'67579': 'Sterling,KS',
'67581': 'Sylvia,KS',
'67583': 'Turon,KS',
'67584': 'Utica,KS',
'67585': 'Yoder,KS',
'67601': 'Hays,KS',
'67621': 'Agra,KS',
'67622': 'Almena,KS',
'67623': 'Alton,KS',
'67625': 'Bogue,KS',
'67626': 'Bunker Hill,KS',
'67627': 'Catharine,KS',
'67628': 'Cedar,KS',
'67629': 'Clayton,KS',
'67631': 'Collyer,KS',
'67632': 'Damar,KS',
'67634': 'Dorrance,KS',
'67635': 'Dresden,KS',
'67637': 'Ellis,KS',
'67638': 'Gaylord,KS',
'67639': 'Glade,KS',
'67640': 'Gorham,KS',
'67642': 'Hill City,KS',
'67643': 'Jennings,KS',
'67644': 'Kirwin,KS',
'67645': 'Lenora,KS',
'67646': 'Logan,KS',
'67647': 'Long Island,KS',
'67648': 'Lucas,KS',
'67649': 'Luray,KS',
'67650': 'Morland,KS',
'67651': 'Natoma,KS',
'67653': 'Norcatur,KS',
'67654': 'Norton,KS',
'67656': 'Ogallah,KS',
'67657': 'Palco,KS',
'67658': 'Paradise,KS',
'67659': 'Penokee,KS',
'67660': 'Pfeifer,KS',
'67661': 'Phillipsburg,KS',
'67663': 'Plainville,KS',
'67664': 'Prairie View,KS',
'67665': 'Russell,KS',
'67667': 'Schoenchen,KS',
'67669': 'Stockton,KS',
'67670': 'Stuttgart,KS',
'67671': 'Victoria,KS',
'67672': 'Wa Keeney,KS',
'67673': 'Waldo,KS',
'67674': 'Walker,KS',
'67675': 'Woodston,KS',
'67701': 'Colby,KS',
'67730': 'Atwood,KS',
'67731': 'Bird City,KS',
'67732': 'Brewster,KS',
'67733': 'Edson,KS',
'67734': 'Gem,KS',
'67735': 'Goodland,KS',
'67736': 'Gove,KS',
'67737': 'Grainfield,KS',
'67738': 'Grinnell,KS',
'67739': 'Herndon,KS',
'67740': 'Hoxie,KS',
'67741': 'Kanorado,KS',
'67743': 'Levant,KS',
'67744': 'Ludell,KS',
'67745': 'Mc Donald,KS',
'67747': 'Monument,KS',
'67748': 'Oakley,KS',
'67749': 'Oberlin,KS',
'67751': 'Park,KS',
'67752': 'Quinter,KS',
'67753': 'Rexford,KS',
'67756': 'Saint Francis,KS',
'67757': 'Selden,KS',
'67758': 'Sharon Springs,KS',
'67761': 'Wallace,KS',
'67762': 'Weskan,KS',
'67764': 'Winona,KS',
'67801': 'Dodge City,KS',
'67831': 'Ashland,KS',
'67834': 'Bucklin,KS',
'67835': 'Cimarron,KS',
'67836': 'Coolidge,KS',
'67837': 'Copeland,KS',
'67838': 'Deerfield,KS',
'67839': 'Dighton,KS',
'67840': 'Englewood,KS',
'67841': 'Ensign,KS',
'67842': 'Ford,KS',
'67843': 'Fort Dodge,KS',
'67844': 'Fowler,KS',
'67846': 'Garden City,KS',
'67849': 'Hanston,KS',
'67850': 'Healy,KS',
'67851': 'Holcomb,KS',
'67853': 'Ingalls,KS',
'67854': 'Jetmore,KS',
'67855': 'Johnson,KS',
'67857': 'Kendall,KS',
'67859': 'Kismet,KS',
'67860': 'Lakin,KS',
'67861': 'Leoti,KS',
'67862': 'Manter,KS',
'67863': 'Marienthal,KS',
'67864': 'Meade,KS',
'67865': 'Minneola,KS',
'67867': 'Montezuma,KS',
'67868': 'Pierceville,KS',
'67869': 'Plains,KS',
'67870': 'Satanta,KS',
'67871': 'Scott City,KS',
'67876': 'Spearville,KS',
'67877': 'Sublette,KS',
'67878': 'Syracuse,KS',
'67879': 'Tribune,KS',
'67880': 'Ulysses,KS',
'67882': 'Wright,KS',
'67901': 'Liberal,KS',
'67905': 'Liberal,KS',
'67950': 'Elkhart,KS',
'67951': 'Hugoton,KS',
'67952': 'Moscow,KS',
'67953': 'Richfield,KS',
'67954': 'Rolla,KS',
'68001': 'Abie,NE',
'68002': 'Arlington,NE',
'68003': 'Ashland,NE',
'68004': 'Bancroft,NE',
'68005': 'Bellevue,NE',
'68007': 'Bennington,NE',
'68008': 'Blair,NE',
'68009': 'Blair,NE',
'68010': 'Boys Town,NE',
'68014': 'Bruno,NE',
'68015': 'Cedar Bluffs,NE',
'68016': 'Cedar Creek,NE',
'68017': 'Ceresco,NE',
'68018': 'Colon,NE',
'68019': 'Craig,NE',
'68020': 'Decatur,NE',
'68022': 'Elkhorn,NE',
'68023': 'Fort Calhoun,NE',
'68025': 'Fremont,NE',
'68026': 'Fremont,NE',
'68028': 'Gretna,NE',
'68029': 'Herman,NE',
'68030': 'Homer,NE',
'68031': 'Hooper,NE',
'68033': 'Ithaca,NE',
'68034': 'Kennard,NE',
'68035': 'Leshara,NE',
'68036': 'Linwood,NE',
'68037': 'Louisville,NE',
'68038': 'Lyons,NE',
'68039': 'Macy,NE',
'68040': 'Malmo,NE',
'68041': 'Mead,NE',
'68042': 'Memphis,NE',
'68044': 'Nickerson,NE',
'68045': 'Oakland,NE',
'68046': 'Papillion,NE',
'68047': 'Pender,NE',
'68048': 'Plattsmouth,NE',
'68050': 'Prague,NE',
'68054': 'Richfield,NE',
'68055': 'Rosalie,NE',
'68056': 'St Columbans,NE',
'68057': 'Scribner,NE',
'68058': 'South Bend,NE',
'68059': 'Springfield,NE',
'68061': 'Tekamah,NE',
'68062': 'Thurston,NE',
'68063': 'Uehling,NE',
'68064': 'Valley,NE',
'68065': 'Valparaiso,NE',
'68066': 'Wahoo,NE',
'68067': 'Walthill,NE',
'68068': 'Washington,NE',
'68069': 'Waterloo,NE',
'68070': 'Weston,NE',
'68071': 'Winnebago,NE',
'68072': 'Winslow,NE',
'68073': 'Yutan,NE',
'68101': 'Omaha,NE',
'68102': 'Omaha,NE',
'68103': 'Omaha,NE',
'68104': 'Omaha,NE',
'68105': 'Omaha,NE',
'68106': 'Omaha,NE',
'68107': 'Omaha,NE',
'68108': 'Omaha,NE',
'68109': 'Omaha,NE',
'68110': 'Omaha,NE',
'68111': 'Omaha,NE',
'68112': 'Omaha,NE',
'68113': 'Offutt A F B,NE',
'68114': 'Omaha,NE',
'68116': 'Omaha,NE',
'68117': 'Omaha,NE',
'68118': 'Omaha,NE',
'68119': 'Omaha,NE',
'68120': 'Omaha,NE',
'68122': 'Omaha,NE',
'68123': 'Bellevue,NE',
'68124': 'Omaha,NE',
'68127': 'Omaha,NE',
'68128': 'La Vista,NE',
'68130': 'Omaha,NE',
'68131': 'Omaha,NE',
'68132': 'Omaha,NE',
'68133': 'Papillion,NE',
'68134': 'Omaha,NE',
'68135': 'Omaha,NE',
'68136': 'Omaha,NE',
'68137': 'Omaha,NE',
'68138': 'Omaha,NE',
'68139': 'Omaha,NE',
'68142': 'Omaha,NE',
'68144': 'Omaha,NE',
'68145': 'Omaha,NE',
'68147': 'Bellevue,NE',
'68152': 'Omaha,NE',
'68154': 'Omaha,NE',
'68155': 'Omaha,NE',
'68157': 'Omaha,NE',
'68164': 'Omaha,NE',
'68172': 'Omaha,NE',
'68175': 'Omaha,NE',
'68176': 'Omaha,NE',
'68178': 'Omaha,NE',
'68179': 'Omaha,NE',
'68180': 'Omaha,NE',
'68181': 'Omaha,NE',
'68182': 'Omaha,NE',
'68183': 'Omaha,NE',
'68197': 'Omaha,NE',
'68198': 'Omaha,NE',
'68301': 'Adams,NE',
'68303': 'Alexandria,NE',
'68304': 'Alvo,NE',
'68305': 'Auburn,NE',
'68307': 'Avoca,NE',
'68309': 'Barneston,NE',
'68310': 'Beatrice,NE',
'68313': 'Beaver Crossing,NE',
'68314': 'Bee,NE',
'68315': 'Belvidere,NE',
'68316': 'Benedict,NE',
'68317': 'Bennet,NE',
'68318': 'Blue Springs,NE',
'68319': 'Bradshaw,NE',
'68320': 'Brock,NE',
'68321': 'Brownville,NE',
'68322': 'Bruning,NE',
'68323': 'Burchard,NE',
'68324': 'Burr,NE',
'68325': 'Byron,NE',
'68326': 'Carleton,NE',
'68327': 'Chester,NE',
'68328': 'Clatonia,NE',
'68329': 'Cook,NE',
'68330': 'Cordova,NE',
'68331': 'Cortland,NE',
'68332': 'Crab Orchard,NE',
'68333': 'Crete,NE',
'68335': 'Davenport,NE',
'68336': 'Davey,NE',
'68337': 'Dawson,NE',
'68338': 'Daykin,NE',
'68339': 'Denton,NE',
'68340': 'Deshler,NE',
'68341': 'De Witt,NE',
'68342': 'Diller,NE',
'68343': 'Dorchester,NE',
'68344': 'Douglas,NE',
'68345': 'Du Bois,NE',
'68346': 'Dunbar,NE',
'68347': 'Eagle,NE',
'68348': 'Elk Creek,NE',
'68349': 'Elmwood,NE',
'68350': 'Endicott,NE',
'68351': 'Exeter,NE',
'68352': 'Fairbury,NE',
'68354': 'Fairmont,NE',
'68355': 'Falls City,NE',
'68357': 'Filley,NE',
'68358': 'Firth,NE',
'68359': 'Friend,NE',
'68360': 'Garland,NE',
'68361': 'Geneva,NE',
'68362': 'Gilead,NE',
'68364': 'Goehner,NE',
'68365': 'Grafton,NE',
'68366': 'Greenwood,NE',
'68367': 'Gresham,NE',
'68368': 'Hallam,NE',
'68370': 'Hebron,NE',
'68371': 'Henderson,NE',
'68372': 'Hickman,NE',
'68375': 'Hubbell,NE',
'68376': 'Humboldt,NE',
'68377': 'Jansen,NE',
'68378': 'Johnson,NE',
'68379': 'Julian,NE',
'68380': 'Lewiston,NE',
'68381': 'Liberty,NE',
'68382': 'Lorton,NE',
'68401': 'Mc Cool Junction,NE',
'68402': 'Malcolm,NE',
'68403': 'Manley,NE',
'68404': 'Martell,NE',
'68405': 'Milford,NE',
'68406': 'Milligan,NE',
'68407': 'Murdock,NE',
'68409': 'Murray,NE',
'68410': 'Nebraska City,NE',
'68413': 'Nehawka,NE',
'68414': 'Nemaha,NE',
'68415': 'Odell,NE',
'68416': 'Ohiowa,NE',
'68417': 'Otoe,NE',
'68418': 'Palmyra,NE',
'68419': 'Panama,NE',
'68420': 'Pawnee City,NE',
'68421': 'Peru,NE',
'68422': 'Pickrell,NE',
'68423': 'Pleasant Dale,NE',
'68424': 'Plymouth,NE',
'68428': 'Raymond,NE',
'68429': 'Reynolds,NE',
'68430': 'Roca,NE',
'68431': 'Rulo,NE',
'68433': 'Salem,NE',
'68434': 'Seward,NE',
'68436': 'Shickley,NE',
'68437': 'Shubert,NE',
'68438': 'Sprague,NE',
'68439': 'Staplehurst,NE',
'68440': 'Steele City,NE',
'68441': 'Steinauer,NE',
'68442': 'Stella,NE',
'68443': 'Sterling,NE',
'68444': 'Strang,NE',
'68445': 'Swanton,NE',
'68446': 'Syracuse,NE',
'68447': 'Table Rock,NE',
'68448': 'Talmage,NE',
'68450': 'Tecumseh,NE',
'68452': 'Ong,NE',
'68453': 'Tobias,NE',
'68454': 'Unadilla,NE',
'68455': 'Union,NE',
'68456': 'Utica,NE',
'68457': 'Verdon,NE',
'68458': 'Virginia,NE',
'68460': 'Waco,NE',
'68461': 'Walton,NE',
'68462': 'Waverly,NE',
'68463': 'Weeping Water,NE',
'68464': 'Western,NE',
'68465': 'Wilber,NE',
'68466': 'Wymore,NE',
'68467': 'York,NE',
'68501': 'Lincoln,NE',
'68502': 'Lincoln,NE',
'68503': 'Lincoln,NE',
'68504': 'Lincoln,NE',
'68505': 'Lincoln,NE',
'68506': 'Lincoln,NE',
'68507': 'Lincoln,NE',
'68508': 'Lincoln,NE',
'68509': 'Lincoln,NE',
'68510': 'Lincoln,NE',
'68512': 'Lincoln,NE',
'68514': 'Lincoln,NE',
'68516': 'Lincoln,NE',
'68517': 'Lincoln,NE',
'68520': 'Lincoln,NE',
'68521': 'Lincoln,NE',
'68522': 'Lincoln,NE',
'68523': 'Lincoln,NE',
'68524': 'Lincoln,NE',
'68526': 'Lincoln,NE',
'68527': 'Lincoln,NE',
'68528': 'Lincoln,NE',
'68529': 'Lincoln,NE',
'68531': 'Lincoln,NE',
'68532': 'Lincoln,NE',
'68542': 'Lincoln,NE',
'68583': 'Lincoln,NE',
'68588': 'Lincoln,NE',
'68601': 'Columbus,NE',
'68602': 'Columbus,NE',
'68620': 'Albion,NE',
'68621': 'Ames,NE',
'68622': 'Bartlett,NE',
'68623': 'Belgrade,NE',
'68624': 'Bellwood,NE',
'68626': 'Brainard,NE',
'68627': 'Cedar Rapids,NE',
'68628': 'Clarks,NE',
'68629': 'Clarkson,NE',
'68631': 'Creston,NE',
'68632': 'David City,NE',
'68633': 'Dodge,NE',
'68634': 'Duncan,NE',
'68635': 'Dwight,NE',
'68636': 'Elgin,NE',
'68637': 'Ericson,NE',
'68638': 'Fullerton,NE',
'68640': 'Genoa,NE',
'68641': 'Howells,NE',
'68642': 'Humphrey,NE',
'68643': 'Leigh,NE',
'68644': 'Lindsay,NE',
'68647': 'Monroe,NE',
'68648': 'Morse Bluff,NE',
'68649': 'North Bend,NE',
'68651': 'Osceola,NE',
'68652': 'Petersburg,NE',
'68653': 'Platte Center,NE',
'68654': 'Polk,NE',
'68655': 'Primrose,NE',
'68658': 'Rising City,NE',
'68659': 'Rogers,NE',
'68660': 'Saint Edward,NE',
'68661': 'Schuyler,NE',
'68662': 'Shelby,NE',
'68663': 'Silver Creek,NE',
'68664': 'Snyder,NE',
'68665': 'Spalding,NE',
'68666': 'Stromsburg,NE',
'68667': 'Surprise,NE',
'68669': 'Ulysses,NE',
'68701': 'Norfolk,NE',
'68702': 'Norfolk,NE',
'68710': 'Allen,NE',
'68711': 'Amelia,NE',
'68713': 'Atkinson,NE',
'68714': 'Bassett,NE',
'68715': 'Battle Creek,NE',
'68716': 'Beemer,NE',
'68717': 'Belden,NE',
'68718': 'Bloomfield,NE',
'68719': 'Bristow,NE',
'68720': 'Brunswick,NE',
'68722': 'Butte,NE',
'68723': 'Carroll,NE',
'68724': 'Center,NE',
'68725': 'Chambers,NE',
'68726': 'Clearwater,NE',
'68727': 'Coleridge,NE',
'68728': 'Concord,NE',
'68729': 'Creighton,NE',
'68730': 'Crofton,NE',
'68731': 'Dakota City,NE',
'68732': 'Dixon,NE',
'68733': 'Emerson,NE',
'68734': 'Emmet,NE',
'68735': 'Ewing,NE',
'68736': 'Fordyce,NE',
'68737': 'Foster,NE',
'68738': 'Hadar,NE',
'68739': 'Hartington,NE',
'68740': 'Hoskins,NE',
'68741': 'Hubbard,NE',
'68742': 'Inman,NE',
'68743': 'Jackson,NE',
'68745': 'Laurel,NE',
'68746': 'Lynch,NE',
'68747': 'Mclean,NE',
'68748': 'Madison,NE',
'68749': 'Magnet,NE',
'68751': 'Maskell,NE',
'68752': 'Meadow Grove,NE',
'68753': 'Mills,NE',
'68755': 'Naper,NE',
'68756': 'Neligh,NE',
'68757': 'Newcastle,NE',
'68758': 'Newman Grove,NE',
'68759': 'Newport,NE',
'68760': 'Niobrara,NE',
'68761': 'Oakdale,NE',
'68763': 'Oneill,NE',
'68764': 'Orchard,NE',
'68765': 'Osmond,NE',
'68766': 'Page,NE',
'68767': 'Pierce,NE',
'68768': 'Pilger,NE',
'68769': 'Plainview,NE',
'68770': 'Ponca,NE',
'68771': 'Randolph,NE',
'68772': 'Rose,NE',
'68773': 'Royal,NE',
'68774': 'Saint Helena,NE',
'68776': 'South Sioux City,NE',
'68777': 'Spencer,NE',
'68778': 'Springview,NE',
'68779': 'Stanton,NE',
'68780': 'Stuart,NE',
'68781': 'Tilden,NE',
'68783': 'Verdigre,NE',
'68784': 'Wakefield,NE',
'68785': 'Waterbury,NE',
'68786': 'Wausa,NE',
'68787': 'Wayne,NE',
'68788': 'West Point,NE',
'68789': 'Winnetoon,NE',
'68790': 'Winside,NE',
'68791': 'Wisner,NE',
'68792': 'Wynot,NE',
'68801': 'Grand Island,NE',
'68802': 'Grand Island,NE',
'68803': 'Grand Island,NE',
'68810': 'Alda,NE',
'68812': 'Amherst,NE',
'68813': 'Anselmo,NE',
'68814': 'Ansley,NE',
'68815': 'Arcadia,NE',
'68816': 'Archer,NE',
'68817': 'Ashton,NE',
'68818': 'Aurora,NE',
'68819': 'Berwyn,NE',
'68820': 'Boelus,NE',
'68821': 'Brewster,NE',
'68822': 'Broken Bow,NE',
'68823': 'Burwell,NE',
'68824': 'Cairo,NE',
'68825': 'Callaway,NE',
'68826': 'Central City,NE',
'68827': 'Chapman,NE',
'68828': 'Comstock,NE',
'68831': 'Dannebrog,NE',
'68832': 'Doniphan,NE',
'68833': 'Dunning,NE',
'68834': 'Eddyville,NE',
'68835': 'Elba,NE',
'68836': 'Elm Creek,NE',
'68837': 'Elyria,NE',
'68838': 'Farwell,NE',
'68840': 'Gibbon,NE',
'68841': 'Giltner,NE',
'68842': 'Greeley,NE',
'68843': 'Hampton,NE',
'68844': 'Hazard,NE',
'68845': 'Kearney,NE',
'68846': 'Hordville,NE',
'68847': 'Kearney,NE',
'68848': 'Kearney,NE',
'68849': 'Kearney,NE',
'68850': 'Lexington,NE',
'68852': 'Litchfield,NE',
'68853': 'Loup City,NE',
'68854': 'Marquette,NE',
'68855': 'Mason City,NE',
'68856': 'Merna,NE',
'68858': 'Miller,NE',
'68859': 'North Loup,NE',
'68860': 'Oconto,NE',
'68861': 'Odessa,NE',
'68862': 'Ord,NE',
'68863': 'Overton,NE',
'68864': 'Palmer,NE',
'68865': 'Phillips,NE',
'68866': 'Pleasanton,NE',
'68869': 'Ravenna,NE',
'68870': 'Riverdale,NE',
'68871': 'Rockville,NE',
'68872': 'Saint Libory,NE',
'68873': 'Saint Paul,NE',
'68874': 'Sargent,NE',
'68875': 'Scotia,NE',
'68876': 'Shelton,NE',
'68878': 'Sumner,NE',
'68879': 'Taylor,NE',
'68880': 'Weissert,NE',
'68881': 'Westerville,NE',
'68882': 'Wolbach,NE',
'68883': 'Wood River,NE',
'68901': 'Hastings,NE',
'68902': 'Hastings,NE',
'68920': 'Alma,NE',
'68922': 'Arapahoe,NE',
'68923': 'Atlanta,NE',
'68924': 'Axtell,NE',
'68925': 'Ayr,NE',
'68926': 'Beaver City,NE',
'68927': 'Bertrand,NE',
'68928': 'Bladen,NE',
'68929': 'Bloomington,NE',
'68930': 'Blue Hill,NE',
'68932': 'Campbell,NE',
'68933': 'Clay Center,NE',
'68934': 'Deweese,NE',
'68935': 'Edgar,NE',
'68936': 'Edison,NE',
'68937': 'Elwood,NE',
'68938': 'Fairfield,NE',
'68939': 'Franklin,NE',
'68940': 'Funk,NE',
'68941': 'Glenvil,NE',
'68942': 'Guide Rock,NE',
'68943': 'Hardy,NE',
'68944': 'Harvard,NE',
'68945': 'Heartwell,NE',
'68946': 'Hendley,NE',
'68947': 'Hildreth,NE',
'68948': 'Holbrook,NE',
'68949': 'Holdrege,NE',
'68950': 'Holstein,NE',
'68952': 'Inavale,NE',
'68954': 'Inland,NE',
'68955': 'Juniata,NE',
'68956': 'Kenesaw,NE',
'68957': 'Lawrence,NE',
'68958': 'Loomis,NE',
'68959': 'Minden,NE',
'68960': 'Naponee,NE',
'68961': 'Nelson,NE',
'68963': 'Norman,NE',
'68964': 'Oak,NE',
'68966': 'Orleans,NE',
'68967': 'Oxford,NE',
'68969': 'Ragan,NE',
'68970': 'Red Cloud,NE',
'68971': 'Republican City,NE',
'68972': 'Riverton,NE',
'68973': 'Roseland,NE',
'68974': 'Ruskin,NE',
'68975': 'Saronville,NE',
'68976': 'Smithfield,NE',
'68977': 'Stamford,NE',
'68978': 'Superior,NE',
'68979': 'Sutton,NE',
'68980': 'Trumbull,NE',
'68981': 'Upland,NE',
'68982': 'Wilcox,NE',
'69001': 'Mc Cook,NE',
'69020': 'Bartley,NE',
'69021': 'Benkelman,NE',
'69022': 'Cambridge,NE',
'69023': 'Champion,NE',
'69024': 'Culbertson,NE',
'69025': 'Curtis,NE',
'69026': 'Danbury,NE',
'69027': 'Enders,NE',
'69028': 'Eustis,NE',
'69029': 'Farnam,NE',
'69030': 'Haigler,NE',
'69031': 'Hamlet,NE',
'69032': 'Hayes Center,NE',
'69033': 'Imperial,NE',
'69034': 'Indianola,NE',
'69036': 'Lebanon,NE',
'69037': 'Max,NE',
'69038': 'Maywood,NE',
'69039': 'Moorefield,NE',
'69040': 'Palisade,NE',
'69041': 'Parks,NE',
'69042': 'Stockville,NE',
'69043': 'Stratton,NE',
'69044': 'Trenton,NE',
'69045': 'Wauneta,NE',
'69046': 'Wilsonville,NE',
'69101': 'North Platte,NE',
'69103': 'North Platte,NE',
'69120': 'Arnold,NE',
'69121': 'Arthur,NE',
'69122': 'Big Springs,NE',
'69123': 'Brady,NE',
'69125': 'Broadwater,NE',
'69127': 'Brule,NE',
'69128': 'Bushnell,NE',
'69129': 'Chappell,NE',
'69130': 'Cozad,NE',
'69131': 'Dalton,NE',
'69132': 'Dickens,NE',
'69133': 'Dix,NE',
'69134': 'Elsie,NE',
'69135': 'Elsmere,NE',
'69138': 'Gothenburg,NE',
'69140': 'Grant,NE',
'69141': 'Gurley,NE',
'69142': 'Halsey,NE',
'69143': 'Hershey,NE',
'69144': 'Keystone,NE',
'69145': 'Kimball,NE',
'69146': 'Lemoyne,NE',
'69147': 'Lewellen,NE',
'69148': 'Lisco,NE',
'69149': 'Lodgepole,NE',
'69150': 'Madrid,NE',
'69151': 'Maxwell,NE',
'69152': 'Mullen,NE',
'69153': 'Ogallala,NE',
'69154': 'Oshkosh,NE',
'69155': 'Paxton,NE',
'69156': 'Potter,NE',
'69157': 'Purdum,NE',
'69160': 'Sidney,NE',
'69161': 'Seneca,NE',
'69162': 'Sidney,NE',
'69163': 'Stapleton,NE',
'69165': 'Sutherland,NE',
'69166': 'Thedford,NE',
'69167': 'Tryon,NE',
'69168': 'Venango,NE',
'69169': 'Wallace,NE',
'69170': 'Wellfleet,NE',
'69171': 'Willow Island,NE',
'69190': 'Oshkosh,NE',
'69201': 'Valentine,NE',
'69210': 'Ainsworth,NE',
'69211': 'Cody,NE',
'69212': 'Crookston,NE',
'69214': 'Johnstown,NE',
'69216': 'Kilgore,NE',
'69217': 'Long Pine,NE',
'69218': 'Merriman,NE',
'69219': 'Nenzel,NE',
'69220': 'Sparks,NE',
'69221': 'Wood Lake,NE',
'69301': 'Alliance,NE',
'69331': 'Angora,NE',
'69333': 'Ashby,NE',
'69334': 'Bayard,NE',
'69335': 'Bingham,NE',
'69336': 'Bridgeport,NE',
'69337': 'Chadron,NE',
'69339': 'Crawford,NE',
'69340': 'Ellsworth,NE',
'69341': 'Gering,NE',
'69343': 'Gordon,NE',
'69345': 'Harrisburg,NE',
'69346': 'Harrison,NE',
'69347': 'Hay Springs,NE',
'69348': 'Hemingford,NE',
'69349': 'Henry,NE',
'69350': 'Hyannis,NE',
'69351': 'Lakeside,NE',
'69352': 'Lyman,NE',
'69353': 'Mcgrew,NE',
'69354': 'Marsland,NE',
'69355': 'Melbeta,NE',
'69356': 'Minatare,NE',
'69357': 'Mitchell,NE',
'69358': 'Morrill,NE',
'69360': 'Rushville,NE',
'69361': 'Scottsbluff,NE',
'69363': 'Scottsbluff,NE',
'69365': 'Whiteclay,NE',
'69366': 'Whitman,NE',
'69367': 'Whitney,NE',
'70001': 'Metairie,LA',
'70002': 'Metairie,LA',
'70003': 'Metairie,LA',
'70004': 'Metairie,LA',
'70005': 'Metairie,LA',
'70006': 'Metairie,LA',
'70009': 'Metairie,LA',
'70010': 'Metairie,LA',
'70011': 'Metairie,LA',
'70030': 'Des Allemands,LA',
'70031': 'Ama,LA',
'70032': 'Arabi,LA',
'70033': 'Metairie,LA',
'70036': 'Barataria,LA',
'70037': 'Belle Chasse,LA',
'70038': 'Boothville,LA',
'70039': 'Boutte,LA',
'70040': 'Braithwaite,LA',
'70041': 'Buras,LA',
'70042': 'Carlisle,LA',
'70043': 'Chalmette,LA',
'70044': 'Chalmette,LA',
'70046': 'Davant,LA',
'70047': 'Destrehan,LA',
'70049': 'Edgard,LA',
'70050': 'Empire,LA',
'70051': 'Garyville,LA',
'70052': 'Gramercy,LA',
'70053': 'Gretna,LA',
'70054': 'Gretna,LA',
'70055': 'Metairie,LA',
'70056': 'Gretna,LA',
'70057': 'Hahnville,LA',
'70058': 'Harvey,LA',
'70059': 'Harvey,LA',
'70060': 'Metairie,LA',
'70062': 'Kenner,LA',
'70063': 'Kenner,LA',
'70064': 'Kenner,LA',
'70065': 'Kenner,LA',
'70066': 'Killona,LA',
'70067': 'Lafitte,LA',
'70068': 'La Place,LA',
'70069': 'La Place,LA',
'70070': 'Luling,LA',
'70071': 'Lutcher,LA',
'70072': 'Marrero,LA',
'70073': 'Marrero,LA',
'70075': 'Meraux,LA',
'70076': 'Mount Airy,LA',
'70078': 'New Sarpy,LA',
'70079': 'Norco,LA',
'70080': 'Paradis,LA',
'70081': 'Pilottown,LA',
'70082': 'Pointe A La Hache,LA',
'70083': 'Port Sulphur,LA',
'70084': 'Reserve,LA',
'70085': 'Saint Bernard,LA',
'70086': 'Saint James,LA',
'70087': 'Saint Rose,LA',
'70090': 'Vacherie,LA',
'70091': 'Venice,LA',
'70092': 'Violet,LA',
'70093': 'Belle Chasse,LA',
'70094': 'Westwego,LA',
'70096': 'Westwego,LA',
'70097': 'Kenner,LA',
'70112': 'New Orleans,LA',
'70113': 'New Orleans,LA',
'70114': 'New Orleans,LA',
'70115': 'New Orleans,LA',
'70116': 'New Orleans,LA',
'70117': 'New Orleans,LA',
'70118': 'New Orleans,LA',
'70119': 'New Orleans,LA',
'70121': 'New Orleans,LA',
'70122': 'New Orleans,LA',
'70123': 'New Orleans,LA',
'70124': 'New Orleans,LA',
'70125': 'New Orleans,LA',
'70126': 'New Orleans,LA',
'70127': 'New Orleans,LA',
'70128': 'New Orleans,LA',
'70129': 'New Orleans,LA',
'70130': 'New Orleans,LA',
'70131': 'New Orleans,LA',
'70139': 'New Orleans,LA',
'70140': 'New Orleans,LA',
'70141': 'New Orleans,LA',
'70142': 'New Orleans,LA',
'70143': 'New Orleans,LA',
'70145': 'New Orleans,LA',
'70146': 'New Orleans,LA',
'70148': 'New Orleans,LA',
'70149': 'New Orleans,LA',
'70150': 'New Orleans,LA',
'70151': 'New Orleans,LA',
'70152': 'New Orleans,LA',
'70153': 'New Orleans,LA',
'70154': 'New Orleans,LA',
'70156': 'New Orleans,LA',
'70157': 'New Orleans,LA',
'70158': 'New Orleans,LA',
'70159': 'New Orleans,LA',
'70160': 'New Orleans,LA',
'70161': 'New Orleans,LA',
'70162': 'New Orleans,LA',
'70163': 'New Orleans,LA',
'70164': 'New Orleans,LA',
'70165': 'New Orleans,LA',
'70166': 'New Orleans,LA',
'70167': 'New Orleans,LA',
'70170': 'New Orleans,LA',
'70172': 'New Orleans,LA',
'70174': 'New Orleans,LA',
'70175': 'New Orleans,LA',
'70176': 'New Orleans,LA',
'70177': 'New Orleans,LA',
'70178': 'New Orleans,LA',
'70179': 'New Orleans,LA',
'70181': 'New Orleans,LA',
'70182': 'New Orleans,LA',
'70183': 'New Orleans,LA',
'70184': 'New Orleans,LA',
'70185': 'New Orleans,LA',
'70186': 'New Orleans,LA',
'70187': 'New Orleans,LA',
'70189': 'New Orleans,LA',
'70190': 'New Orleans,LA',
'70195': 'New Orleans,LA',
'70301': 'Thibodaux,LA',
'70302': 'Thibodaux,LA',
'70310': 'Thibodaux,LA',
'70339': 'Pierre Part,LA',
'70340': 'Amelia,LA',
'70341': 'Belle Rose,LA',
'70342': 'Berwick,LA',
'70343': 'Bourg,LA',
'70344': 'Chauvin,LA',
'70345': 'Cut Off,LA',
'70346': 'Donaldsonville,LA',
'70352': 'Donner,LA',
'70353': 'Dulac,LA',
'70354': 'Galliano,LA',
'70355': 'Gheens,LA',
'70356': 'Gibson,LA',
'70357': 'Golden Meadow,LA',
'70358': 'Grand Isle,LA',
'70359': 'Gray,LA',
'70360': 'Houma,LA',
'70361': 'Houma,LA',
'70363': 'Houma,LA',
'70364': 'Houma,LA',
'70371': 'Kraemer,LA',
'70372': 'Labadieville,LA',
'70373': 'Larose,LA',
'70374': 'Lockport,LA',
'70375': 'Mathews,LA',
'70376': 'Modeste,LA',
'70377': 'Montegut,LA',
'70380': 'Morgan City,LA',
'70381': 'Morgan City,LA',
'70390': 'Napoleonville,LA',
'70391': 'Paincourtville,LA',
'70392': 'Patterson,LA',
'70393': 'Plattenville,LA',
'70394': 'Raceland,LA',
'70395': 'Schriever,LA',
'70397': 'Theriot,LA',
'70401': 'Hammond,LA',
'70402': 'Hammond,LA',
'70403': 'Hammond,LA',
'70404': 'Hammond,LA',
'70420': 'Abita Springs,LA',
'70421': 'Akers,LA',
'70422': 'Amite,LA',
'70426': 'Angie,LA',
'70427': 'Bogalusa,LA',
'70429': 'Bogalusa,LA',
'70431': 'Bush,LA',
'70433': 'Covington,LA',
'70434': 'Covington,LA',
'70435': 'Covington,LA',
'70436': 'Fluker,LA',
'70437': 'Folsom,LA',
'70438': 'Franklinton,LA',
'70441': 'Greensburg,LA',
'70442': 'Husser,LA',
'70443': 'Independence,LA',
'70444': 'Kentwood,LA',
'70445': 'Lacombe,LA',
'70446': 'Loranger,LA',
'70447': 'Madisonville,LA',
'70448': 'Mandeville,LA',
'70449': 'Maurepas,LA',
'70450': 'Mount Hermon,LA',
'70451': 'Natalbany,LA',
'70452': 'Pearl River,LA',
'70453': 'Pine Grove,LA',
'70454': 'Ponchatoula,LA',
'70455': 'Robert,LA',
'70456': 'Roseland,LA',
'70457': 'Saint Benedict,LA',
'70458': 'Slidell,LA',
'70459': 'Slidell,LA',
'70460': 'Slidell,LA',
'70461': 'Slidell,LA',
'70462': 'Springfield,LA',
'70463': 'Sun,LA',
'70464': 'Talisheek,LA',
'70465': 'Tangipahoa,LA',
'70466': 'Tickfaw,LA',
'70467': 'Angie,LA',
'70469': 'Slidell,LA',
'70470': 'Mandeville,LA',
'70471': 'Mandeville,LA',
'70500': 'Lafayette,LA',
'70501': 'Lafayette,LA',
'70502': 'Lafayette,LA',
'70503': 'Lafayette,LA',
'70504': 'Lafayette,LA',
'70505': 'Lafayette,LA',
'70506': 'Lafayette,LA',
'70507': 'Lafayette,LA',
'70508': 'Lafayette,LA',
'70509': 'Lafayette,LA',
'70510': 'Abbeville,LA',
'70511': 'Abbeville,LA',
'70512': 'Arnaudville,LA',
'70513': 'Avery Island,LA',
'70514': 'Baldwin,LA',
'70515': 'Basile,LA',
'70516': 'Branch,LA',
'70517': 'Breaux Bridge,LA',
'70518': 'Broussard,LA',
'70519': 'Cade,LA',
'70520': 'Carencro,LA',
'70521': 'Cecilia,LA',
'70522': 'Centerville,LA',
'70523': 'Charenton,LA',
'70524': 'Chataignier,LA',
'70525': 'Church Point,LA',
'70526': 'Crowley,LA',
'70527': 'Crowley,LA',
'70528': 'Delcambre,LA',
'70529': 'Duson,LA',
'70531': 'Egan,LA',
'70532': 'Elton,LA',
'70533': 'Erath,LA',
'70534': 'Estherwood,LA',
'70535': 'Eunice,LA',
'70537': 'Evangeline,LA',
'70538': 'Franklin,LA',
'70540': 'Garden City,LA',
'70541': 'Grand Coteau,LA',
'70542': 'Gueydan,LA',
'70543': 'Iota,LA',
'70544': 'Jeanerette,LA',
'70546': 'Jennings,LA',
'70548': 'Kaplan,LA',
'70549': 'Lake Arthur,LA',
'70550': 'Lawtell,LA',
'70551': 'Leonville,LA',
'70552': 'Loreauville,LA',
'70554': 'Mamou,LA',
'70555': 'Maurice,LA',
'70556': 'Mermentau,LA',
'70558': 'Milton,LA',
'70559': 'Morse,LA',
'70560': 'New Iberia,LA',
'70562': 'New Iberia,LA',
'70563': 'New Iberia,LA',
'70569': 'Lydia,LA',
'70570': 'Opelousas,LA',
'70571': 'Opelousas,LA',
'70575': 'Perry,LA',
'70576': 'Pine Prairie,LA',
'70577': 'Port Barre,LA',
'70578': 'Rayne,LA',
'70580': 'Reddell,LA',
'70581': 'Roanoke,LA',
'70582': 'Saint Martinville,LA',
'70583': 'Scott,LA',
'70584': 'Sunset,LA',
'70585': 'Turkey Creek,LA',
'70586': 'Ville Platte,LA',
'70589': 'Washington,LA',
'70591': 'Welsh,LA',
'70592': 'Youngsville,LA',
'70593': 'Lafayette,LA',
'70595': 'Lafayette,LA',
'70596': 'Lafayette,LA',
'70598': 'Lafayette,LA',
'70601': 'Lake Charles,LA',
'70602': 'Lake Charles,LA',
'70605': 'Lake Charles,LA',
'70606': 'Lake Charles,LA',
'70607': 'Lake Charles,LA',
'70609': 'Lake Charles,LA',
'70611': 'Lake Charles,LA',
'70612': 'Lake Charles,LA',
'70615': 'Lake Charles,LA',
'70616': 'Lake Charles,LA',
'70629': 'Lake Charles,LA',
'70630': 'Bell City,LA',
'70631': 'Cameron,LA',
'70632': 'Creole,LA',
'70633': 'Dequincy,LA',
'70634': 'Deridder,LA',
'70637': 'Dry Creek,LA',
'70638': 'Elizabeth,LA',
'70639': 'Evans,LA',
'70640': 'Fenton,LA',
'70642': 'Fullerton,LA',
'70643': 'Grand Chenier,LA',
'70644': 'Grant,LA',
'70645': 'Hackberry,LA',
'70646': 'Hayes,LA',
'70647': 'Iowa,LA',
'70648': 'Kinder,LA',
'70650': 'Lacassine,LA',
'70651': 'Leblanc,LA',
'70652': 'Longville,LA',
'70653': 'Merryville,LA',
'70654': 'Mittie,LA',
'70655': 'Oberlin,LA',
'70656': 'Pitkin,LA',
'70657': 'Ragley,LA',
'70658': 'Reeves,LA',
'70659': 'Rosepine,LA',
'70660': 'Singer,LA',
'70661': 'Starks,LA',
'70662': 'Sugartown,LA',
'70663': 'Sulphur,LA',
'70664': 'Sulphur,LA',
'70665': 'Sulphur,LA',
'70668': 'Vinton,LA',
'70669': 'Westlake,LA',
'70704': 'Baker,LA',
'70706': 'Denham Springs,LA',
'70707': 'Gonzales,LA',
'70710': 'Addis,LA',
'70711': 'Albany,LA',
'70712': 'Angola,LA',
'70714': 'Baker,LA',
'70715': 'Batchelor,LA',
'70716': 'Bayou Goula,LA',
'70717': 'Blanks,LA',
'70718': 'Brittany,LA',
'70719': 'Brusly,LA',
'70720': 'Bueche,LA',
'70721': 'Carville,LA',
'70722': 'Clinton,LA',
'70723': 'Convent,LA',
'70725': 'Darrow,LA',
'70726': 'Denham Springs,LA',
'70727': 'Denham Springs,LA',
'70728': 'Duplessis,LA',
'70729': 'Erwinville,LA',
'70730': 'Ethel,LA',
'70732': 'Fordoche,LA',
'70733': 'French Settlement,LA',
'70734': 'Geismar,LA',
'70736': 'Glynn,LA',
'70737': 'Gonzales,LA',
'70738': 'Burnside,LA',
'70739': 'Greenwell Springs,LA',
'70740': 'Grosse Tete,LA',
'70743': 'Hester,LA',
'70744': 'Holden,LA',
'70747': 'Innis,LA',
'70748': 'Jackson,LA',
'70749': 'Jarreau,LA',
'70750': 'Krotz Springs,LA',
'70751': 'Labarre,LA',
'70752': 'Lakeland,LA',
'70753': 'Lettsworth,LA',
'70754': 'Livingston,LA',
'70755': 'Livonia,LA',
'70756': 'Lottie,LA',
'70757': 'Maringouin,LA',
'70759': 'Morganza,LA',
'70760': 'New Roads,LA',
'70761': 'Norwood,LA',
'70762': 'Oscar,LA',
'70763': 'Paulina,LA',
'70764': 'Plaquemine,LA',
'70765': 'Plaquemine,LA',
'70767': 'Port Allen,LA',
'70769': 'Prairieville,LA',
'70770': 'Pride,LA',
'70772': 'Rosedale,LA',
'70773': 'Rougon,LA',
'70774': 'Saint Amant,LA',
'70775': 'Saint Francisville,LA',
'70776': 'Saint Gabriel,LA',
'70777': 'Slaughter,LA',
'70778': 'Sorrento,LA',
'70780': 'Sunshine,LA',
'70781': 'Torbert,LA',
'70782': 'Tunica,LA',
'70783': 'Ventress,LA',
'70784': 'Wakefield,LA',
'70785': 'Walker,LA',
'70786': 'Watson,LA',
'70787': 'Weyanoke,LA',
'70788': 'White Castle,LA',
'70789': 'Wilson,LA',
'70791': 'Zachary,LA',
'70792': 'Uncle Sam,LA',
'70801': 'Baton Rouge,LA',
'70802': 'Baton Rouge,LA',
'70803': 'Baton Rouge,LA',
'70804': 'Baton Rouge,LA',
'70805': 'Baton Rouge,LA',
'70806': 'Baton Rouge,LA',
'70807': 'Baton Rouge,LA',
'70808': 'Baton Rouge,LA',
'70809': 'Baton Rouge,LA',
'70810': 'Baton Rouge,LA',
'70811': 'Baton Rouge,LA',
'70812': 'Baton Rouge,LA',
'70813': 'Baton Rouge,LA',
'70814': 'Baton Rouge,LA',
'70815': 'Baton Rouge,LA',
'70816': 'Baton Rouge,LA',
'70817': 'Baton Rouge,LA',
'70818': 'Baton Rouge,LA',
'70819': 'Baton Rouge,LA',
'70820': 'Baton Rouge,LA',
'70821': 'Baton Rouge,LA',
'70822': 'Baton Rouge,LA',
'70823': 'Baton Rouge,LA',
'70825': 'Baton Rouge,LA',
'70826': 'Baton Rouge,LA',
'70827': 'Baton Rouge,LA',
'70831': 'Baton Rouge,LA',
'70833': 'Baton Rouge,LA',
'70835': 'Baton Rouge,LA',
'70836': 'Baton Rouge,LA',
'70837': 'Baton Rouge,LA',
'70873': 'Baton Rouge,LA',
'70874': 'Baton Rouge,LA',
'70879': 'Baton Rouge,LA',
'70883': 'Baton Rouge,LA',
'70884': 'Baton Rouge,LA',
'70891': 'Entergy Corp,LA',
'70892': 'Baton Rouge,LA',
'70893': 'Baton Rouge,LA',
'70894': 'Baton Rouge,LA',
'70895': 'Baton Rouge,LA',
'70896': 'Baton Rouge,LA',
'70898': 'Baton Rouge,LA',
'71001': 'Arcadia,LA',
'71002': 'Ashland,LA',
'71003': 'Athens,LA',
'71004': 'Belcher,LA',
'71006': 'Benton,LA',
'71007': 'Bethany,LA',
'71008': 'Bienville,LA',
'71009': 'Blanchard,LA',
'71016': 'Castor,LA',
'71018': 'Cotton Valley,LA',
'71019': 'Coushatta,LA',
'71021': 'Cullen,LA',
'71023': 'Doyline,LA',
'71024': 'Dubberly,LA',
'71025': 'East Point,LA',
'71027': 'Frierson,LA',
'71028': 'Gibsland,LA',
'71029': 'Gilliam,LA',
'71030': 'Gloster,LA',
'71031': 'Goldonna,LA',
'71032': 'Grand Cane,LA',
'71033': 'Greenwood,LA',
'71034': 'Hall Summit,LA',
'71036': 'Harmon,LA',
'71037': 'Haughton,LA',
'71038': 'Haynesville,LA',
'71039': 'Heflin,LA',
'71040': 'Homer,LA',
'71043': 'Hosston,LA',
'71044': 'Ida,LA',
'71045': 'Jamestown,LA',
'71046': 'Keatchie,LA',
'71047': 'Keithville,LA',
'71048': 'Lisbon,LA',
'71049': 'Logansport,LA',
'71050': 'Longstreet,LA',
'71051': 'Elm Grove,LA',
'71052': 'Mansfield,LA',
'71055': 'Minden,LA',
'71058': 'Minden,LA',
'71060': 'Mooringsport,LA',
'71061': 'Oil City,LA',
'71063': 'Pelican,LA',
'71064': 'Plain Dealing,LA',
'71065': 'Pleasant Hill,LA',
'71066': 'Powhatan,LA',
'71067': 'Princeton,LA',
'71068': 'Ringgold,LA',
'71069': 'Rodessa,LA',
'71070': 'Saline,LA',
'71071': 'Sarepta,LA',
'71072': 'Shongaloo,LA',
'71073': 'Sibley,LA',
'71075': 'Springhill,LA',
'71078': 'Stonewall,LA',
'71079': 'Summerfield,LA',
'71080': 'Taylor,LA',
'71082': 'Vivian,LA',
'71101': 'Shreveport,LA',
'71102': 'Shreveport,LA',
'71103': 'Shreveport,LA',
'71104': 'Shreveport,LA',
'71105': 'Shreveport,LA',
'71106': 'Shreveport,LA',
'71107': 'Shreveport,LA',
'71108': 'Shreveport,LA',
'71109': 'Shreveport,LA',
'71110': 'Barksdale Afb,LA',
'71111': 'Bossier City,LA',
'71112': 'Bossier City,LA',
'71113': 'Bossier City,LA',
'71115': 'Shreveport,LA',
'71118': 'Shreveport,LA',
'71119': 'Shreveport,LA',
'71120': 'Shreveport,LA',
'71129': 'Shreveport,LA',
'71130': 'Shreveport,LA',
'71133': 'Shreveport,LA',
'71134': 'Shreveport,LA',
'71135': 'Shreveport,LA',
'71136': 'Shreveport,LA',
'71137': 'Shreveport,LA',
'71138': 'Shreveport,LA',
'71148': 'Shreveport,LA',
'71149': 'Shreveport,LA',
'71150': 'Shreveport,LA',
'71151': 'Shreveport,LA',
'71152': 'Shreveport,LA',
'71153': 'Shreveport,LA',
'71154': 'Shreveport,LA',
'71156': 'Shreveport,LA',
'71161': 'Shreveport,LA',
'71162': 'Shreveport,LA',
'71163': 'Shreveport,LA',
'71164': 'Shreveport,LA',
'71165': 'Shreveport,LA',
'71166': 'Shreveport,LA',
'71171': 'Bossier City,LA',
'71172': 'Bossier City,LA',
'71201': 'Monroe,LA',
'71202': 'Monroe,LA',
'71203': 'Monroe,LA',
'71207': 'Monroe,LA',
'71208': 'Monroe,LA',
'71209': 'Monroe,LA',
'71210': 'Monroe,LA',
'71211': 'Monroe,LA',
'71212': 'Monroe,LA',
'71213': 'Monroe,LA',
'71217': 'Monroe,LA',
'71218': 'Archibald,LA',
'71219': 'Baskin,LA',
'71220': 'Bastrop,LA',
'71221': 'Bastrop,LA',
'71222': 'Bernice,LA',
'71223': 'Bonita,LA',
'71225': 'Calhoun,LA',
'71226': 'Chatham,LA',
'71227': 'Choudrant,LA',
'71229': 'Collinston,LA',
'71230': 'Crowville,LA',
'71232': 'Delhi,LA',
'71233': 'Delta,LA',
'71234': 'Downsville,LA',
'71235': 'Dubach,LA',
'71237': 'Epps,LA',
'71238': 'Eros,LA',
'71240': 'Fairbanks,LA',
'71241': 'Farmerville,LA',
'71242': 'Forest,LA',
'71243': 'Fort Necessity,LA',
'71245': 'Grambling,LA',
'71247': 'Hodge,LA',
'71249': 'Jigger,LA',
'71250': 'Jones,LA',
'71251': 'Jonesboro,LA',
'71253': 'Kilbourne,LA',
'71254': 'Lake Providence,LA',
'71256': 'Lillie,LA',
'71259': 'Mangham,LA',
'71260': 'Marion,LA',
'71261': 'Mer Rouge,LA',
'71263': 'Oak Grove,LA',
'71264': 'Oak Ridge,LA',
'71266': 'Pioneer,LA',
'71268': 'Quitman,LA',
'71269': 'Rayville,LA',
'71270': 'Ruston,LA',
'71272': 'Ruston,LA',
'71273': 'Ruston,LA',
'71275': 'Simsboro,LA',
'71276': 'Sondheimer,LA',
'71277': 'Spearsville,LA',
'71279': 'Start,LA',
'71280': 'Sterlington,LA',
'71281': 'Swartz,LA',
'71282': 'Tallulah,LA',
'71284': 'Tallulah,LA',
'71286': 'Transylvania,LA',
'71291': 'West Monroe,LA',
'71292': 'West Monroe,LA',
'71294': 'West Monroe,LA',
'71295': 'Winnsboro,LA',
'71301': 'Alexandria,LA',
'71302': 'Alexandria,LA',
'71303': 'Alexandria,LA',
'71306': 'Alexandria,LA',
'71307': 'Alexandria,LA',
'71309': 'Alexandria,LA',
'71315': 'Alexandria,LA',
'71316': 'Acme,LA',
'71320': 'Bordelonville,LA',
'71322': 'Bunkie,LA',
'71323': 'Center Point,LA',
'71324': 'Chase,LA',
'71325': 'Cheneyville,LA',
'71326': 'Clayton,LA',
'71327': 'Cottonport,LA',
'71328': 'Deville,LA',
'71329': 'Dupont,LA',
'71330': 'Echo,LA',
'71331': 'Effie,LA',
'71333': 'Evergreen,LA',
'71334': 'Ferriday,LA',
'71336': 'Gilbert,LA',
'71339': 'Hamburg,LA',
'71340': 'Harrisonburg,LA',
'71341': 'Hessmer,LA',
'71342': 'Jena,LA',
'71343': 'Jonesville,LA',
'71345': 'Lebeau,LA',
'71346': 'Lecompte,LA',
'71348': 'Libuse,LA',
'71350': 'Mansura,LA',
'71351': 'Marksville,LA',
'71353': 'Melville,LA',
'71354': 'Monterey,LA',
'71355': 'Moreauville,LA',
'71356': 'Morrow,LA',
'71357': 'Newellton,LA',
'71358': 'Palmetto,LA',
'71359': 'Pineville,LA',
'71360': 'Pineville,LA',
'71361': 'Pineville,LA',
'71362': 'Plaucheville,LA',
'71363': 'Rhinehart,LA',
'71365': 'Ruby,LA',
'71366': 'Saint Joseph,LA',
'71367': 'Saint Landry,LA',
'71368': 'Sicily Island,LA',
'71369': 'Simmesport,LA',
'71371': 'Trout,LA',
'71373': 'Vidalia,LA',
'71375': 'Waterproof,LA',
'71377': 'Wildsville,LA',
'71378': 'Wisner,LA',
'71401': 'Aimwell,LA',
'71403': 'Anacoco,LA',
'71404': 'Atlanta,LA',
'71405': 'Ball,LA',
'71406': 'Belmont,LA',
'71407': 'Bentley,LA',
'71409': 'Boyce,LA',
'71410': 'Calvin,LA',
'71411': 'Campti,LA',
'71414': 'Clarence,LA',
'71415': 'Clarks,LA',
'71416': 'Cloutierville,LA',
'71417': 'Colfax,LA',
'71418': 'Columbia,LA',
'71419': 'Converse,LA',
'71422': 'Dodson,LA',
'71423': 'Dry Prong,LA',
'71424': 'Elmer,LA',
'71425': 'Enterprise,LA',
'71426': 'Fisher,LA',
'71427': 'Flatwoods,LA',
'71428': 'Flora,LA',
'71429': 'Florien,LA',
'71430': 'Forest Hill,LA',
'71431': 'Gardner,LA',
'71432': 'Georgetown,LA',
'71433': 'Glenmora,LA',
'71434': 'Gorum,LA',
'71435': 'Grayson,LA',
'71438': 'Hineston,LA',
'71439': 'Hornbeck,LA',
'71440': 'Joyce,LA',
'71441': 'Kelly,LA',
'71443': 'Kurthwood,LA',
'71444': 'Lacamp,LA',
'71446': 'Leesville,LA',
'71447': 'Lena,LA',
'71448': 'Longleaf,LA',
'71449': 'Many,LA',
'71450': 'Marthaville,LA',
'71452': 'Melrose,LA',
'71454': 'Montgomery,LA',
'71455': 'Mora,LA',
'71456': 'Natchez,LA',
'71457': 'Natchitoches,LA',
'71458': 'Natchitoches,LA',
'71459': 'Leesville,LA',
'71460': 'Negreet,LA',
'71461': 'Newllano,LA',
'71462': 'Noble,LA',
'71463': 'Oakdale,LA',
'71465': 'Olla,LA',
'71466': 'Otis,LA',
'71467': 'Pollock,LA',
'71468': 'Provencal,LA',
'71469': 'Robeline,LA',
'71471': 'Saint Maurice,LA',
'71472': 'Sieper,LA',
'71473': 'Sikes,LA',
'71474': 'Simpson,LA',
'71475': 'Slagle,LA',
'71477': 'Tioga,LA',
'71479': 'Tullos,LA',
'71480': 'Urania,LA',
'71481': 'Verda,LA',
'71483': 'Winnfield,LA',
'71485': 'Woodworth,LA',
'71486': 'Zwolle,LA',
'71496': 'Leesville,LA',
'71497': 'Natchitoches,LA',
'71601': 'Pine Bluff,AR',
'71602': 'White Hall,AR',
'71603': 'Pine Bluff,AR',
'71611': 'Pine Bluff,AR',
'71612': 'White Hall,AR',
'71613': 'Pine Bluff,AR',
'71630': 'Arkansas City,AR',
'71631': 'Banks,AR',
'71635': 'Crossett,AR',
'71638': 'Dermott,AR',
'71639': 'Dumas,AR',
'71640': 'Eudora,AR',
'71642': 'Fountain Hill,AR',
'71643': 'Gould,AR',
'71644': 'Grady,AR',
'71646': 'Hamburg,AR',
'71647': 'Hermitage,AR',
'71649': 'Jennie,AR',
'71650': 'Jerome,AR',
'71651': 'Jersey,AR',
'71652': 'Kingsland,AR',
'71653': 'Lake Village,AR',
'71654': 'Mc Gehee,AR',
'71655': 'Monticello,AR',
'71656': 'Monticello,AR',
'71657': 'Monticello,AR',
'71658': 'Montrose,AR',
'71659': 'Moscow,AR',
'71660': 'New Edinburg,AR',
'71661': 'Parkdale,AR',
'71662': 'Pickens,AR',
'71663': 'Portland,AR',
'71665': 'Rison,AR',
'71666': 'Mc Gehee,AR',
'71667': 'Star City,AR',
'71670': 'Tillar,AR',
'71671': 'Warren,AR',
'71674': 'Watson,AR',
'71675': 'Wilmar,AR',
'71676': 'Wilmot,AR',
'71677': 'Winchester,AR',
'71678': 'Yorktown,AR',
'71701': 'Camden,AR',
'71711': 'Camden,AR',
'71720': 'Bearden,AR',
'71721': 'Beirne,AR',
'71722': 'Bluff City,AR',
'71724': 'Calion,AR',
'71725': 'Carthage,AR',
'71726': 'Chidester,AR',
'71728': 'Curtis,AR',
'71730': 'El Dorado,AR',
'71731': 'El Dorado,AR',
'71740': 'Emerson,AR',
'71742': 'Fordyce,AR',
'71743': 'Gurdon,AR',
'71744': 'Hampton,AR',
'71745': 'Harrell,AR',
'71747': 'Huttig,AR',
'71748': 'Ivan,AR',
'71749': 'Junction City,AR',
'71750': 'Lawson,AR',
'71751': 'Louann,AR',
'71752': 'Mc Neil,AR',
'71753': 'Magnolia,AR',
'71754': 'Magnolia,AR',
'71758': 'Mount Holly,AR',
'71759': 'Norphlet,AR',
'71762': 'Smackover,AR',
'71763': 'Sparkman,AR',
'71764': 'Stephens,AR',
'71765': 'Strong,AR',
'71766': 'Thornton,AR',
'71767': 'Hampton,AR',
'71768': 'Urbana,AR',
'71769': 'Village,AR',
'71770': 'Waldo,AR',
'71772': 'Whelen Springs,AR',
'71801': 'Hope,AR',
'71802': 'Hope,AR',
'71820': 'Alleene,AR',
'71822': 'Ashdown,AR',
'71823': 'Ben Lomond,AR',
'71825': 'Blevins,AR',
'71826': 'Bradley,AR',
'71827': 'Buckner,AR',
'71828': 'Cale,AR',
'71831': 'Columbus,AR',
'71832': 'De Queen,AR',
'71833': 'Dierks,AR',
'71834': 'Doddridge,AR',
'71835': 'Emmet,AR',
'71836': 'Foreman,AR',
'71837': 'Fouke,AR',
'71838': 'Fulton,AR',
'71839': 'Garland City,AR',
'71840': 'Genoa,AR',
'71841': 'Gillham,AR',
'71842': 'Horatio,AR',
'71844': 'Laneburg,AR',
'71845': 'Lewisville,AR',
'71846': 'Lockesburg,AR',
'71847': 'Mc Caskill,AR',
'71851': 'Mineral Springs,AR',
'71852': 'Nashville,AR',
'71853': 'Ogden,AR',
'71854': 'Texarkana,AR',
'71855': 'Ozan,AR',
'71857': 'Prescott,AR',
'71858': 'Rosston,AR',
'71859': 'Saratoga,AR',
'71860': 'Stamps,AR',
'71861': 'Taylor,AR',
'71862': 'Washington,AR',
'71864': 'Willisville,AR',
'71865': 'Wilton,AR',
'71866': 'Winthrop,AR',
'71901': 'Hot Springs National Park,AR',
'71902': 'Hot Springs National Park,AR',
'71903': 'Hot Springs National Park,AR',
'71909': 'Hot Springs Village,AR',
'71910': 'Hot Springs Village,AR',
'71913': 'Hot Springs National Park,AR',
'71914': 'Hot Springs National Park,AR',
'71920': 'Alpine,AR',
'71921': 'Amity,AR',
'71922': 'Antoine,AR',
'71923': 'Arkadelphia,AR',
'71929': 'Bismarck,AR',
'71932': 'Board Camp,AR',
'71933': 'Bonnerdale,AR',
'71935': 'Caddo Gap,AR',
'71937': 'Cove,AR',
'71940': 'Delight,AR',
'71941': 'Donaldson,AR',
'71942': 'Friendship,AR',
'71943': 'Glenwood,AR',
'71944': 'Grannis,AR',
'71945': 'Hatfield,AR',
'71946': 'Hatton,AR',
'71949': 'Jessieville,AR',
'71950': 'Kirby,AR',
'71951': 'Hot Springs National Park,AR',
'71952': 'Langley,AR',
'71953': 'Mena,AR',
'71956': 'Mountain Pine,AR',
'71957': 'Mount Ida,AR',
'71958': 'Murfreesboro,AR',
'71959': 'Newhope,AR',
'71960': 'Norman,AR',
'71961': 'Oden,AR',
'71962': 'Okolona,AR',
'71964': 'Pearcy,AR',
'71965': 'Pencil Bluff,AR',
'71966': 'Oden,AR',
'71968': 'Royal,AR',
'71969': 'Sims,AR',
'71970': 'Story,AR',
'71971': 'Umpire,AR',
'71972': 'Vandervoort,AR',
'71973': 'Wickes,AR',
'71998': 'Arkadelphia,AR',
'71999': 'Arkadelphia,AR',
'72001': 'Adona,AR',
'72002': 'Alexander,AR',
'72003': 'Almyra,AR',
'72004': 'Altheimer,AR',
'72005': 'Amagon,AR',
'72006': 'Augusta,AR',
'72007': 'Austin,AR',
'72010': 'Bald Knob,AR',
'72011': 'Bauxite,AR',
'72012': 'Beebe,AR',
'72013': 'Bee Branch,AR',
'72014': 'Beedeville,AR',
'72015': 'Benton,AR',
'72016': 'Bigelow,AR',
'72017': 'Biscoe,AR',
'72018': 'Benton,AR',
'72019': 'Benton,AR',
'72020': 'Bradford,AR',
'72021': 'Brinkley,AR',
'72022': 'Bryant,AR',
'72023': 'Cabot,AR',
'72024': 'Carlisle,AR',
'72025': 'Casa,AR',
'72026': 'Casscoe,AR',
'72027': 'Center Ridge,AR',
'72028': 'Choctaw,AR',
'72029': 'Clarendon,AR',
'72030': 'Cleveland,AR',
'72031': 'Clinton,AR',
'72032': 'Conway,AR',
'72033': 'Conway,AR',
'72034': 'Conway,AR',
'72035': 'Conway,AR',
'72036': 'Cotton Plant,AR',
'72037': 'Coy,AR',
'72038': 'Crocketts Bluff,AR',
'72039': 'Damascus,AR',
'72040': 'Des Arc,AR',
'72041': 'De Valls Bluff,AR',
'72042': 'De Witt,AR',
'72043': 'Diaz,AR',
'72044': 'Edgemont,AR',
'72045': 'El Paso,AR',
'72046': 'England,AR',
'72047': 'Enola,AR',
'72048': 'Ethel,AR',
'72051': 'Fox,AR',
'72052': 'Garner,AR',
'72053': 'College Station,AR',
'72055': 'Gillett,AR',
'72057': 'Grapevine,AR',
'72058': 'Greenbrier,AR',
'72059': 'Gregory,AR',
'72060': 'Griffithville,AR',
'72061': 'Guy,AR',
'72063': 'Hattieville,AR',
'72064': 'Hazen,AR',
'72065': 'Hensley,AR',
'72066': 'Hickory Plains,AR',
'72067': 'Higden,AR',
'72068': 'Higginson,AR',
'72069': 'Holly Grove,AR',
'72070': 'Houston,AR',
'72071': 'Howell,AR',
'72072': 'Humnoke,AR',
'72073': 'Humphrey,AR',
'72074': 'Hunter,AR',
'72075': 'Jacksonport,AR',
'72076': 'Jacksonville,AR',
'72078': 'Jacksonville,AR',
'72079': 'Jefferson,AR',
'72080': 'Jerusalem,AR',
'72081': 'Judsonia,AR',
'72082': 'Kensett,AR',
'72083': 'Keo,AR',
'72084': 'Leola,AR',
'72085': 'Letona,AR',
'72086': 'Lonoke,AR',
'72087': 'Lonsdale,AR',
'72088': 'Fairfield Bay,AR',
'72089': 'Bryant,AR',
'72099': 'Little Rock Air Force Base,AR',
'72101': 'Mc Crory,AR',
'72102': 'Mc Rae,AR',
'72103': 'Mabelvale,AR',
'72104': 'Malvern,AR',
'72105': 'Jones Mill,AR',
'72106': 'Mayflower,AR',
'72107': 'Menifee,AR',
'72108': 'Monroe,AR',
'72110': 'Morrilton,AR',
'72111': 'Mount Vernon,AR',
'72112': 'Newport,AR',
'72113': 'Maumelle,AR',
'72114': 'North Little Rock,AR',
'72115': 'North Little Rock,AR',
'72116': 'North Little Rock,AR',
'72117': 'North Little Rock,AR',
'72118': 'North Little Rock,AR',
'72119': 'North Little Rock,AR',
'72120': 'Sherwood,AR',
'72121': 'Pangburn,AR',
'72122': 'Paron,AR',
'72123': 'Patterson,AR',
'72124': 'North Little Rock,AR',
'72125': 'Perry,AR',
'72126': 'Perryville,AR',
'72127': 'Plumerville,AR',
'72128': 'Poyen,AR',
'72129': 'Prattsville,AR',
'72130': 'Prim,AR',
'72131': 'Quitman,AR',
'72132': 'Redfield,AR',
'72133': 'Reydell,AR',
'72134': 'Roe,AR',
'72135': 'Roland,AR',
'72136': 'Romance,AR',
'72137': 'Rose Bud,AR',
'72139': 'Russell,AR',
'72140': 'Saint Charles,AR',
'72141': 'Scotland,AR',
'72142': 'Scott,AR',
'72143': 'Searcy,AR',
'72145': 'Searcy,AR',
'72149': 'Searcy,AR',
'72150': 'Sheridan,AR',
'72152': 'Sherrill,AR',
'72153': 'Shirley,AR',
'72156': 'Solgohachia,AR',
'72157': 'Springfield,AR',
'72158': 'Benton,AR',
'72160': 'Stuttgart,AR',
'72164': 'Sweet Home,AR',
'72165': 'Thida,AR',
'72166': 'Tichnor,AR',
'72167': 'Traskwood,AR',
'72168': 'Tucker,AR',
'72169': 'Tupelo,AR',
'72170': 'Ulm,AR',
'72173': 'Vilonia,AR',
'72175': 'Wabbaseka,AR',
'72176': 'Ward,AR',
'72178': 'West Point,AR',
'72179': 'Wilburn,AR',
'72180': 'Woodson,AR',
'72181': 'Wooster,AR',
'72182': 'Wright,AR',
'72183': 'Wrightsville,AR',
'72189': 'Mc Crory,AR',
'72190': 'North Little Rock,AR',
'72198': 'Scholastic Parcels,AR',
'72199': 'North Little Rock,AR',
'72201': 'Little Rock,AR',
'72202': 'Little Rock,AR',
'72203': 'Little Rock,AR',
'72204': 'Little Rock,AR',
'72205': 'Little Rock,AR',
'72206': 'Little Rock,AR',
'72207': 'Little Rock,AR',
'72209': 'Little Rock,AR',
'72210': 'Little Rock,AR',
'72211': 'Little Rock,AR',
'72212': 'Little Rock,AR',
'72214': 'Little Rock,AR',
'72215': 'Little Rock,AR',
'72216': 'Little Rock,AR',
'72217': 'Little Rock,AR',
'72219': 'Little Rock,AR',
'72221': 'Little Rock,AR',
'72222': 'Little Rock,AR',
'72223': 'Little Rock,AR',
'72225': 'Little Rock,AR',
'72227': 'Little Rock,AR',
'72231': 'Little Rock,AR',
'72260': 'Little Rock,AR',
'72295': 'Little Rock,AR',
'72301': 'West Memphis,AR',
'72303': 'West Memphis,AR',
'72310': 'Armorel,AR',
'72311': 'Aubrey,AR',
'72312': 'Barton,AR',
'72313': 'Bassett,AR',
'72314': 'Birdeye,AR',
'72315': 'Blytheville,AR',
'72316': 'Blytheville,AR',
'72319': 'Gosnell,AR',
'72320': 'Brickeys,AR',
'72321': 'Burdette,AR',
'72322': 'Caldwell,AR',
'72324': 'Cherry Valley,AR',
'72325': 'Clarkedale,AR',
'72326': 'Colt,AR',
'72327': 'Crawfordsville,AR',
'72328': 'Crumrod,AR',
'72329': 'Driver,AR',
'72330': 'Dyess,AR',
'72331': 'Earle,AR',
'72332': 'Edmondson,AR',
'72333': 'Elaine,AR',
'72335': 'Forrest City,AR',
'72336': 'Forrest City,AR',
'72338': 'Frenchmans Bayou,AR',
'72339': 'Gilmore,AR',
'72340': 'Goodwin,AR',
'72341': 'Haynes,AR',
'72342': 'Helena,AR',
'72346': 'Heth,AR',
'72347': 'Hickory Ridge,AR',
'72348': 'Hughes,AR',
'72350': 'Joiner,AR',
'72351': 'Keiser,AR',
'72352': 'La Grange,AR',
'72353': 'Lambrook,AR',
'72354': 'Lepanto,AR',
'72355': 'Lexa,AR',
'72358': 'Luxora,AR',
'72359': 'Madison,AR',
'72360': 'Marianna,AR',
'72364': 'Marion,AR',
'72365': 'Marked Tree,AR',
'72366': 'Marvell,AR',
'72367': 'Mellwood,AR',
'72368': 'Moro,AR',
'72369': 'Oneida,AR',
'72370': 'Osceola,AR',
'72372': 'Palestine,AR',
'72373': 'Parkin,AR',
'72374': 'Poplar Grove,AR',
'72376': 'Proctor,AR',
'72377': 'Rivervale,AR',
'72379': 'Snow Lake,AR',
'72381': 'Tomato,AR',
'72383': 'Turner,AR',
'72384': 'Turrell,AR',
'72385': 'Twist,AR',
'72386': 'Tyronza,AR',
'72387': 'Vanndale,AR',
'72389': 'Wabash,AR',
'72390': 'West Helena,AR',
'72391': 'West Ridge,AR',
'72392': 'Wheatley,AR',
'72394': 'Widener,AR',
'72395': 'Wilson,AR',
'72396': 'Wynne,AR',
'72401': 'Jonesboro,AR',
'72402': 'Jonesboro,AR',
'72403': 'Jonesboro,AR',
'72404': 'Jonesboro,AR',
'72410': 'Alicia,AR',
'72411': 'Bay,AR',
'72412': 'Beech Grove,AR',
'72413': 'Biggers,AR',
'72414': 'Black Oak,AR',
'72415': 'Black Rock,AR',
'72416': 'Bono,AR',
'72417': 'Brookland,AR',
'72419': 'Caraway,AR',
'72421': 'Cash,AR',
'72422': 'Corning,AR',
'72424': 'Datto,AR',
'72425': 'Delaplaine,AR',
'72426': 'Dell,AR',
'72427': 'Egypt,AR',
'72428': 'Etowah,AR',
'72429': 'Fisher,AR',
'72430': 'Greenway,AR',
'72431': 'Grubbs,AR',
'72432': 'Harrisburg,AR',
'72433': 'Hoxie,AR',
'72434': 'Imboden,AR',
'72435': 'Knobel,AR',
'72436': 'Lafe,AR',
'72437': 'Lake City,AR',
'72438': 'Leachville,AR',
'72439': 'Light,AR',
'72440': 'Lynn,AR',
'72441': 'Mc Dougal,AR',
'72442': 'Manila,AR',
'72443': 'Marmaduke,AR',
'72444': 'Maynard,AR',
'72445': 'Minturn,AR',
'72447': 'Monette,AR',
'72449': 'O Kean,AR',
'72450': 'Paragould,AR',
'72451': 'Paragould,AR',
'72453': 'Peach Orchard,AR',
'72454': 'Piggott,AR',
'72455': 'Pocahontas,AR',
'72456': 'Pollard,AR',
'72457': 'Portia,AR',
'72458': 'Powhatan,AR',
'72459': 'Ravenden,AR',
'72460': 'Ravenden Springs,AR',
'72461': 'Rector,AR',
'72462': 'Reyno,AR',
'72464': 'Saint Francis,AR',
'72465': 'Sedgwick,AR',
'72466': 'Smithville,AR',
'72467': 'State University,AR',
'72469': 'Strawberry,AR',
'72470': 'Success,AR',
'72471': 'Swifton,AR',
'72472': 'Trumann,AR',
'72473': 'Tuckerman,AR',
'72474': 'Walcott,AR',
'72475': 'Waldenburg,AR',
'72476': 'Walnut Ridge,AR',
'72478': 'Warm Springs,AR',
'72479': 'Weiner,AR',
'72482': 'Williford,AR',
'72501': 'Batesville,AR',
'72503': 'Batesville,AR',
'72512': 'Horseshoe Bend,AR',
'72513': 'Ash Flat,AR',
'72515': 'Bexar,AR',
'72516': 'Boswell,AR',
'72517': 'Brockwell,AR',
'72519': 'Calico Rock,AR',
'72520': 'Camp,AR',
'72521': 'Cave City,AR',
'72522': 'Charlotte,AR',
'72523': 'Concord,AR',
'72524': 'Cord,AR',
'72525': 'Cherokee Village,AR',
'72526': 'Cushman,AR',
'72527': 'Desha,AR',
'72528': 'Dolph,AR',
'72529': 'Cherokee Village,AR',
'72530': 'Drasco,AR',
'72531': 'Elizabeth,AR',
'72532': 'Evening Shade,AR',
'72533': 'Fifty Six,AR',
'72534': 'Floral,AR',
'72536': 'Franklin,AR',
'72537': 'Gamaliel,AR',
'72538': 'Gepp,AR',
'72539': 'Glencoe,AR',
'72540': 'Guion,AR',
'72542': 'Hardy,AR',
'72543': 'Heber Springs,AR',
'72544': 'Henderson,AR',
'72545': 'Heber Springs,AR',
'72546': 'Ida,AR',
'72550': 'Locust Grove,AR',
'72553': 'Magness,AR',
'72554': 'Mammoth Spring,AR',
'72555': 'Marcella,AR',
'72556': 'Melbourne,AR',
'72557': 'Moko,AR',
'72560': 'Mountain View,AR',
'72561': 'Mount Pleasant,AR',
'72562': 'Newark,AR',
'72564': 'Oil Trough,AR',
'72565': 'Oxford,AR',
'72566': 'Pineville,AR',
'72567': 'Pleasant Grove,AR',
'72568': 'Pleasant Plains,AR',
'72569': 'Poughkeepsie,AR',
'72571': 'Rosie,AR',
'72572': 'Saffell,AR',
'72573': 'Sage,AR',
'72575': 'Salado,AR',
'72576': 'Salem,AR',
'72577': 'Sidney,AR',
'72578': 'Sturkie,AR',
'72579': 'Sulphur Rock,AR',
'72581': 'Tumbling Shoals,AR',
'72583': 'Viola,AR',
'72584': 'Violet Hill,AR',
'72585': 'Wideman,AR',
'72587': 'Wiseman,AR',
'72601': 'Harrison,AR',
'72602': 'Harrison,AR',
'72610': 'Alco,AR',
'72611': 'Alpena,AR',
'72613': 'Beaver,AR',
'72615': 'Bergman,AR',
'72616': 'Berryville,AR',
'72617': 'Big Flat,AR',
'72619': 'Bull Shoals,AR',
'72623': 'Clarkridge,AR',
'72624': 'Compton,AR',
'72626': 'Cotter,AR',
'72628': 'Deer,AR',
'72629': 'Dennard,AR',
'72630': 'Diamond City,AR',
'72631': 'Eureka Springs,AR',
'72632': 'Eureka Springs,AR',
'72633': 'Everton,AR',
'72634': 'Flippin,AR',
'72635': 'Gassville,AR',
'72636': 'Gilbert,AR',
'72638': 'Green Forest,AR',
'72639': 'Harriet,AR',
'72640': 'Hasty,AR',
'72641': 'Jasper,AR',
'72642': 'Lakeview,AR',
'72644': 'Lead Hill,AR',
'72645': 'Leslie,AR',
'72648': 'Marble Falls,AR',
'72650': 'Marshall,AR',
'72651': 'Midway,AR',
'72653': 'Mountain Home,AR',
'72654': 'Mountain Home,AR',
'72655': 'Mount Judea,AR',
'72657': 'Timbo,AR',
'72658': 'Norfork,AR',
'72659': 'Norfork,AR',
'72660': 'Oak Grove,AR',
'72661': 'Oakland,AR',
'72662': 'Omaha,AR',
'72663': 'Onia,AR',
'72666': 'Parthenon,AR',
'72668': 'Peel,AR',
'72669': 'Pindall,AR',
'72670': 'Ponca,AR',
'72672': 'Pyatt,AR',
'72675': 'Saint Joe,AR',
'72677': 'Summit,AR',
'72679': 'Tilly,AR',
'72680': 'Timbo,AR',
'72682': 'Valley Springs,AR',
'72683': 'Vendor,AR',
'72685': 'Western Grove,AR',
'72686': 'Witts Springs,AR',
'72687': 'Yellville,AR',
'72701': 'Fayetteville,AR',
'72702': 'Fayetteville,AR',
'72703': 'Fayetteville,AR',
'72704': 'Fayetteville,AR',
'72711': 'Avoca,AR',
'72712': 'Bentonville,AR',
'72714': 'Bella Vista,AR',
'72715': 'Bella Vista,AR',
'72716': 'Bentonville,AR',
'72717': 'Canehill,AR',
'72718': 'Cave Springs,AR',
'72719': 'Centerton,AR',
'72721': 'Combs,AR',
'72722': 'Decatur,AR',
'72727': 'Elkins,AR',
'72728': 'Elm Springs,AR',
'72729': 'Evansville,AR',
'72730': 'Farmington,AR',
'72732': 'Garfield,AR',
'72733': 'Gateway,AR',
'72734': 'Gentry,AR',
'72735': 'Goshen,AR',
'72736': 'Gravette,AR',
'72737': 'Greenland,AR',
'72738': 'Hindsville,AR',
'72739': 'Hiwasse,AR',
'72740': 'Huntsville,AR',
'72741': 'Johnson,AR',
'72742': 'Kingston,AR',
'72744': 'Lincoln,AR',
'72745': 'Lowell,AR',
'72747': 'Maysville,AR',
'72749': 'Morrow,AR',
'72751': 'Pea Ridge,AR',
'72752': 'Pettigrew,AR',
'72753': 'Prairie Grove,AR',
'72756': 'Rogers,AR',
'72757': 'Rogers,AR',
'72758': 'Rogers,AR',
'72760': 'Saint Paul,AR',
'72761': 'Siloam Springs,AR',
'72762': 'Springdale,AR',
'72764': 'Springdale,AR',
'72765': 'Springdale,AR',
'72766': 'Springdale,AR',
'72768': 'Sulphur Springs,AR',
'72769': 'Summers,AR',
'72770': 'Tontitown,AR',
'72773': 'Wesley,AR',
'72774': 'West Fork,AR',
'72776': 'Witter,AR',
'72801': 'Russellville,AR',
'72802': 'Russellville,AR',
'72811': 'Russellville,AR',
'72812': 'Russellville,AR',
'72820': 'Alix,AR',
'72821': 'Altus,AR',
'72823': 'Atkins,AR',
'72824': 'Belleville,AR',
'72826': 'Blue Mountain,AR',
'72827': 'Bluffton,AR',
'72828': 'Briggsville,AR',
'72829': 'Centerville,AR',
'72830': 'Clarksville,AR',
'72832': 'Coal Hill,AR',
'72833': 'Danville,AR',
'72834': 'Dardanelle,AR',
'72835': 'Delaware,AR',
'72837': 'Dover,AR',
'72838': 'Gravelly,AR',
'72839': 'Hagarville,AR',
'72840': 'Hartman,AR',
'72841': 'Harvey,AR',
'72842': 'Havana,AR',
'72843': 'Hector,AR',
'72845': 'Knoxville,AR',
'72846': 'Lamar,AR',
'72847': 'London,AR',
'72851': 'New Blaine,AR',
'72852': 'Oark,AR',
'72853': 'Ola,AR',
'72854': 'Ozone,AR',
'72855': 'Paris,AR',
'72856': 'Pelsor,AR',
'72857': 'Plainview,AR',
'72858': 'Pottsville,AR',
'72860': 'Rover,AR',
'72863': 'Scranton,AR',
'72865': 'Subiaco,AR',
'72901': 'Fort Smith,AR',
'72902': 'Fort Smith,AR',
'72903': 'Fort Smith,AR',
'72904': 'Fort Smith,AR',
'72905': 'Fort Smith,AR',
'72906': 'Fort Smith,AR',
'72908': 'Fort Smith,AR',
'72913': 'Fort Smith,AR',
'72914': 'Fort Smith,AR',
'72916': 'Fort Smith,AR',
'72917': 'Fort Smith,AR',
'72918': 'Fort Smith,AR',
'72919': 'Fort Smith,AR',
'72921': 'Alma,AR',
'72923': 'Barling,AR',
'72924': 'Bates,AR',
'72926': 'Boles,AR',
'72927': 'Booneville,AR',
'72928': 'Branch,AR',
'72930': 'Cecil,AR',
'72932': 'Cedarville,AR',
'72933': 'Charleston,AR',
'72934': 'Chester,AR',
'72935': 'Dyer,AR',
'72936': 'Greenwood,AR',
'72937': 'Hackett,AR',
'72938': 'Hartford,AR',
'72940': 'Huntington,AR',
'72941': 'Lavaca,AR',
'72943': 'Magazine,AR',
'72944': 'Mansfield,AR',
'72945': 'Midland,AR',
'72946': 'Mountainburg,AR',
'72947': 'Mulberry,AR',
'72948': 'Natural Dam,AR',
'72949': 'Ozark,AR',
'72950': 'Parks,AR',
'72951': 'Ratcliff,AR',
'72952': 'Rudy,AR',
'72955': 'Uniontown,AR',
'72956': 'Van Buren,AR',
'72957': 'Van Buren,AR',
'72958': 'Waldron,AR',
'72959': 'Winslow,AR',
'73001': 'Albert,OK',
'73002': 'Alex,OK',
'73003': 'Edmond,OK',
'73004': 'Amber,OK',
'73005': 'Anadarko,OK',
'73006': 'Apache,OK',
'73007': 'Arcadia,OK',
'73008': 'Bethany,OK',
'73009': 'Binger,OK',
'73010': 'Blanchard,OK',
'73011': 'Bradley,OK',
'73012': 'Bray,OK',
'73013': 'Edmond,OK',
'73014': 'Calumet,OK',
'73015': 'Carnegie,OK',
'73016': 'Cashion,OK',
'73017': 'Cement,OK',
'73018': 'Chickasha,OK',
'73019': 'Norman,OK',
'73020': 'Choctaw,OK',
'73021': 'Colony,OK',
'73022': 'Concho,OK',
'73023': 'Chickasha,OK',
'73024': 'Corn,OK',
'73026': 'Norman,OK',
'73027': 'Coyle,OK',
'73028': 'Crescent,OK',
'73029': 'Cyril,OK',
'73030': 'Davis,OK',
'73031': 'Dibble,OK',
'73032': 'Dougherty,OK',
'73033': 'Eakly,OK',
'73034': 'Edmond,OK',
'73036': 'El Reno,OK',
'73038': 'Fort Cobb,OK',
'73039': 'Foster,OK',
'73040': 'Geary,OK',
'73041': 'Gotebo,OK',
'73042': 'Gracemont,OK',
'73043': 'Greenfield,OK',
'73044': 'Guthrie,OK',
'73045': 'Harrah,OK',
'73047': 'Hinton,OK',
'73048': 'Hydro,OK',
'73049': 'Jones,OK',
'73050': 'Langston,OK',
'73051': 'Lexington,OK',
'73052': 'Lindsay,OK',
'73053': 'Lookeba,OK',
'73054': 'Luther,OK',
'73055': 'Marlow,OK',
'73056': 'Marshall,OK',
'73057': 'Maysville,OK',
'73058': 'Meridian,OK',
'73059': 'Minco,OK',
'73061': 'Morrison,OK',
'73062': 'Mountain View,OK',
'73063': 'Mulhall,OK',
'73064': 'Mustang,OK',
'73065': 'Newcastle,OK',
'73066': 'Nicoma Park,OK',
'73067': 'Ninnekah,OK',
'73068': 'Noble,OK',
'73069': 'Norman,OK',
'73070': 'Norman,OK',
'73071': 'Norman,OK',
'73072': 'Norman,OK',
'73073': 'Orlando,OK',
'73074': 'Paoli,OK',
'73075': 'Pauls Valley,OK',
'73077': 'Perry,OK',
'73078': 'Piedmont,OK',
'73079': 'Pocasset,OK',
'73080': 'Purcell,OK',
'73082': 'Rush Springs,OK',
'73083': 'Edmond,OK',
'73084': 'Spencer,OK',
'73085': 'Yukon,OK',
'73086': 'Sulphur,OK',
'73089': 'Tuttle,OK',
'73090': 'Union City,OK',
'73092': 'Verden,OK',
'73093': 'Washington,OK',
'73094': 'Washita,OK',
'73095': 'Wayne,OK',
'73096': 'Weatherford,OK',
'73097': 'Wheatland,OK',
'73098': 'Wynnewood,OK',
'73099': 'Yukon,OK',
'73101': 'Oklahoma City,OK',
'73102': 'Oklahoma City,OK',
'73103': 'Oklahoma City,OK',
'73104': 'Oklahoma City,OK',
'73105': 'Oklahoma City,OK',
'73106': 'Oklahoma City,OK',
'73107': 'Oklahoma City,OK',
'73108': 'Oklahoma City,OK',
'73109': 'Oklahoma City,OK',
'73110': 'Oklahoma City,OK',
'73111': 'Oklahoma City,OK',
'73112': 'Oklahoma City,OK',
'73113': 'Oklahoma City,OK',
'73114': 'Oklahoma City,OK',
'73115': 'Oklahoma City,OK',
'73116': 'Oklahoma City,OK',
'73117': 'Oklahoma City,OK',
'73118': 'Oklahoma City,OK',
'73119': 'Oklahoma City,OK',
'73120': 'Oklahoma City,OK',
'73121': 'Oklahoma City,OK',
'73122': 'Oklahoma City,OK',
'73123': 'Oklahoma City,OK',
'73124': 'Oklahoma City,OK',
'73125': 'Oklahoma City,OK',
'73126': 'Oklahoma City,OK',
'73127': 'Oklahoma City,OK',
'73128': 'Oklahoma City,OK',
'73129': 'Oklahoma City,OK',
'73130': 'Oklahoma City,OK',
'73131': 'Oklahoma City,OK',
'73132': 'Oklahoma City,OK',
'73134': 'Oklahoma City,OK',
'73135': 'Oklahoma City,OK',
'73136': 'Oklahoma City,OK',
'73137': 'Oklahoma City,OK',
'73139': 'Oklahoma City,OK',
'73140': 'Oklahoma City,OK',
'73141': 'Oklahoma City,OK',
'73142': 'Oklahoma City,OK',
'73143': 'Oklahoma City,OK',
'73144': 'Oklahoma City,OK',
'73145': 'Oklahoma City,OK',
'73146': 'Oklahoma City,OK',
'73147': 'Oklahoma City,OK',
'73148': 'Oklahoma City,OK',
'73149': 'Oklahoma City,OK',
'73150': 'Oklahoma City,OK',
'73151': 'Oklahoma City,OK',
'73152': 'Oklahoma City,OK',
'73153': 'Oklahoma City,OK',
'73154': 'Oklahoma City,OK',
'73155': 'Oklahoma City,OK',
'73156': 'Oklahoma City,OK',
'73157': 'Oklahoma City,OK',
'73159': 'Oklahoma City,OK',
'73160': 'Oklahoma City,OK',
'73162': 'Oklahoma City,OK',
'73163': 'Oklahoma City,OK',
'73164': 'Oklahoma City,OK',
'73165': 'Oklahoma City,OK',
'73167': 'Oklahoma City,OK',
'73169': 'Oklahoma City,OK',
'73170': 'Oklahoma City,OK',
'73172': 'Oklahoma City,OK',
'73173': 'Oklahoma City,OK',
'73177': 'Oklahoma City,OK',
'73178': 'Oklahoma City,OK',
'73179': 'Oklahoma City,OK',
'73180': 'Oklahoma City,OK',
'73184': 'Oklahoma City,OK',
'73185': 'Oklahoma City,OK',
'73189': 'Oklahoma City,OK',
'73190': 'Oklahoma City,OK',
'73193': 'Oklahoma City,OK',
'73194': 'Oklahoma City,OK',
'73195': 'Oklahoma City,OK',
'73196': 'Oklahoma City,OK',
'73197': 'Oklahoma City,OK',
'73198': 'Oklahoma City,OK',
'73199': 'Oklahoma City,OK',
'73301': 'Austin,TX',
'73344': 'Austin,TX',
'73401': 'Ardmore,OK',
'73402': 'Ardmore,OK',
'73403': 'Ardmore,OK',
'73425': 'Countyline,OK',
'73430': 'Burneyville,OK',
'73432': 'Coleman,OK',
'73433': 'Elmore City,OK',
'73434': 'Foster,OK',
'73435': 'Fox,OK',
'73436': 'Gene Autry,OK',
'73437': 'Graham,OK',
'73438': 'Healdton,OK',
'73439': 'Kingston,OK',
'73440': 'Lebanon,OK',
'73441': 'Leon,OK',
'73442': 'Loco,OK',
'73443': 'Lone Grove,OK',
'73444': 'Hennepin,OK',
'73446': 'Madill,OK',
'73447': 'Mannsville,OK',
'73448': 'Marietta,OK',
'73449': 'Mead,OK',
'73450': 'Milburn,OK',
'73451': 'Ardmore,OK',
'73453': 'Overbrook,OK',
'73454': 'Ardmore,OK',
'73455': 'Ravia,OK',
'73456': 'Ringling,OK',
'73458': 'Springer,OK',
'73459': 'Thackerville,OK',
'73460': 'Tishomingo,OK',
'73461': 'Wapanucka,OK',
'73463': 'Wilson,OK',
'73476': 'Pernell,OK',
'73481': 'Ratliff City,OK',
'73487': 'Tatums,OK',
'73488': 'Tussy,OK',
'73491': 'Velma,OK',
'73501': 'Lawton,OK',
'73502': 'Lawton,OK',
'73503': 'Fort Sill,OK',
'73505': 'Lawton,OK',
'73506': 'Lawton,OK',
'73507': 'Lawton,OK',
'73520': 'Addington,OK',
'73521': 'Altus,OK',
'73522': 'Altus,OK',
'73523': 'Altus Afb,OK',
'73526': 'Blair,OK',
'73527': 'Cache,OK',
'73528': 'Chattanooga,OK',
'73529': 'Comanche,OK',
'73530': 'Davidson,OK',
'73531': 'Devol,OK',
'73532': 'Duke,OK',
'73533': 'Duncan,OK',
'73534': 'Duncan,OK',
'73536': 'Duncan,OK',
'73537': 'Eldorado,OK',
'73538': 'Elgin,OK',
'73539': 'Elmer,OK',
'73540': 'Faxon,OK',
'73541': 'Fletcher,OK',
'73542': 'Frederick,OK',
'73543': 'Geronimo,OK',
'73544': 'Gould,OK',
'73546': 'Grandfield,OK',
'73547': 'Granite,OK',
'73548': 'Hastings,OK',
'73549': 'Headrick,OK',
'73550': 'Hollis,OK',
'73551': 'Hollister,OK',
'73552': 'Indiahoma,OK',
'73553': 'Loveland,OK',
'73554': 'Mangum,OK',
'73555': 'Manitou,OK',
'73556': 'Martha,OK',
'73557': 'Medicine Park,OK',
'73558': 'Meers,OK',
'73559': 'Mountain Park,OK',
'73560': 'Olustee,OK',
'73561': 'Oscar,OK',
'73562': 'Randlett,OK',
'73564': 'Roosevelt,OK',
'73565': 'Ryan,OK',
'73566': 'Snyder,OK',
'73567': 'Sterling,OK',
'73568': 'Temple,OK',
'73569': 'Terral,OK',
'73570': 'Tipton,OK',
'73571': 'Vinson,OK',
'73572': 'Walters,OK',
'73573': 'Waurika,OK',
'73575': 'Duncan,OK',
'73601': 'Clinton,OK',
'73620': 'Arapaho,OK',
'73622': 'Bessie,OK',
'73624': 'Burns Flat,OK',
'73625': 'Butler,OK',
'73626': 'Canute,OK',
'73627': 'Carter,OK',
'73628': 'Cheyenne,OK',
'73632': 'Cordell,OK',
'73638': 'Crawford,OK',
'73639': 'Custer City,OK',
'73641': 'Dill City,OK',
'73642': 'Durham,OK',
'73644': 'Elk City,OK',
'73645': 'Erick,OK',
'73646': 'Fay,OK',
'73647': 'Foss,OK',
'73648': 'Elk City,OK',
'73650': 'Hammon,OK',
'73651': 'Hobart,OK',
'73654': 'Leedey,OK',
'73655': 'Lone Wolf,OK',
'73658': 'Oakwood,OK',
'73659': 'Putnam,OK',
'73660': 'Reydon,OK',
'73661': 'Rocky,OK',
'73662': 'Sayre,OK',
'73663': 'Seiling,OK',
'73664': 'Sentinel,OK',
'73666': 'Sweetwater,OK',
'73667': 'Taloga,OK',
'73668': 'Texola,OK',
'73669': 'Thomas,OK',
'73673': 'Willow,OK',
'73701': 'Enid,OK',
'73702': 'Enid,OK',
'73703': 'Enid,OK',
'73705': 'Enid,OK',
'73706': 'Enid,OK',
'73716': 'Aline,OK',
'73717': 'Alva,OK',
'73718': 'Ames,OK',
'73719': 'Amorita,OK',
'73720': 'Bison,OK',
'73722': 'Burlington,OK',
'73724': 'Canton,OK',
'73726': 'Carmen,OK',
'73727': 'Carrier,OK',
'73728': 'Cherokee,OK',
'73729': 'Cleo Springs,OK',
'73730': 'Covington,OK',
'73731': 'Dacoma,OK',
'73733': 'Douglas,OK',
'73734': 'Dover,OK',
'73735': 'Drummond,OK',
'73736': 'Fairmont,OK',
'73737': 'Fairview,OK',
'73738': 'Garber,OK',
'73739': 'Goltry,OK',
'73741': 'Helena,OK',
'73742': 'Hennessey,OK',
'73743': 'Hillsdale,OK',
'73744': 'Hitchcock,OK',
'73746': 'Hopeton,OK',
'73747': 'Isabella,OK',
'73749': 'Jet,OK',
'73750': 'Kingfisher,OK',
'73753': 'Kremlin,OK',
'73754': 'Lahoma,OK',
'73755': 'Longdale,OK',
'73756': 'Loyal,OK',
'73757': 'Lucien,OK',
'73758': 'Manchester,OK',
'73759': 'Medford,OK',
'73760': 'Meno,OK',
'73761': 'Nash,OK',
'73762': 'Okarche,OK',
'73763': 'Okeene,OK',
'73764': 'Omega,OK',
'73766': 'Pond Creek,OK',
'73768': 'Ringwood,OK',
'73770': 'Southard,OK',
'73771': 'Wakita,OK',
'73772': 'Watonga,OK',
'73773': 'Waukomis,OK',
'73801': 'Woodward,OK',
'73802': 'Woodward,OK',
'73832': 'Arnett,OK',
'73834': 'Buffalo,OK',
'73835': 'Camargo,OK',
'73838': 'Chester,OK',
'73840': 'Fargo,OK',
'73841': 'Fort Supply,OK',
'73842': 'Freedom,OK',
'73843': 'Gage,OK',
'73844': 'Gate,OK',
'73847': 'Knowles,OK',
'73848': 'Laverne,OK',
'73851': 'May,OK',
'73852': 'Mooreland,OK',
'73853': 'Mutual,OK',
'73855': 'Rosston,OK',
'73857': 'Sharon,OK',
'73858': 'Shattuck,OK',
'73859': 'Vici,OK',
'73860': 'Waynoka,OK',
'73901': 'Adams,OK',
'73931': 'Balko,OK',
'73932': 'Beaver,OK',
'73933': 'Boise City,OK',
'73937': 'Felt,OK',
'73938': 'Forgan,OK',
'73939': 'Goodwell,OK',
'73942': 'Guymon,OK',
'73944': 'Hardesty,OK',
'73945': 'Hooker,OK',
'73946': 'Kenton,OK',
'73947': 'Keyes,OK',
'73949': 'Texhoma,OK',
'73950': 'Turpin,OK',
'73951': 'Tyrone,OK',
'74001': 'Avant,OK',
'74002': 'Barnsdall,OK',
'74003': 'Bartlesville,OK',
'74004': 'Bartlesville,OK',
'74005': 'Bartlesville,OK',
'74006': 'Bartlesville,OK',
'74008': 'Bixby,OK',
'74009': 'Bowring,OK',
'74010': 'Bristow,OK',
'74011': 'Broken Arrow,OK',
'74012': 'Broken Arrow,OK',
'74013': 'Broken Arrow,OK',
'74014': 'Broken Arrow,OK',
'74015': 'Catoosa,OK',
'74016': 'Chelsea,OK',
'74017': 'Claremore,OK',
'74018': 'Claremore,OK',
'74019': 'Claremore,OK',
'74020': 'Cleveland,OK',
'74021': 'Collinsville,OK',
'74022': 'Copan,OK',
'74023': 'Cushing,OK',
'74026': 'Davenport,OK',
'74027': 'Delaware,OK',
'74028': 'Depew,OK',
'74029': 'Dewey,OK',
'74030': 'Drumright,OK',
'74031': 'Foyil,OK',
'74032': 'Glencoe,OK',
'74033': 'Glenpool,OK',
'74034': 'Hallett,OK',
'74035': 'Hominy,OK',
'74036': 'Inola,OK',
'74037': 'Jenks,OK',
'74038': 'Jennings,OK',
'74039': 'Kellyville,OK',
'74041': 'Kiefer,OK',
'74042': 'Lenapah,OK',
'74043': 'Leonard,OK',
'74044': 'Mannford,OK',
'74045': 'Maramec,OK',
'74046': 'Milfay,OK',
'74047': 'Mounds,OK',
'74048': 'Nowata,OK',
'74050': 'Oakhurst,OK',
'74051': 'Ochelata,OK',
'74052': 'Oilton,OK',
'74053': 'Oologah,OK',
'74054': 'Osage,OK',
'74055': 'Owasso,OK',
'74056': 'Pawhuska,OK',
'74058': 'Pawnee,OK',
'74059': 'Perkins,OK',
'74060': 'Prue,OK',
'74061': 'Ramona,OK',
'74062': 'Ripley,OK',
'74063': 'Sand Springs,OK',
'74066': 'Sapulpa,OK',
'74067': 'Sapulpa,OK',
'74068': 'Shamrock,OK',
'74070': 'Skiatook,OK',
'74071': 'Slick,OK',
'74072': 'S Coffeyville,OK',
'74073': 'Sperry,OK',
'74074': 'Stillwater,OK',
'74075': 'Stillwater,OK',
'74076': 'Stillwater,OK',
'74077': 'Stillwater,OK',
'74078': 'Stillwater,OK',
'74079': 'Stroud,OK',
'74080': 'Talala,OK',
'74081': 'Terlton,OK',
'74082': 'Vera,OK',
'74083': 'Wann,OK',
'74084': 'Wynona,OK',
'74085': 'Yale,OK',
'74101': 'Tulsa,OK',
'74102': 'Tulsa,OK',
'74103': 'Tulsa,OK',
'74104': 'Tulsa,OK',
'74105': 'Tulsa,OK',
'74106': 'Tulsa,OK',
'74107': 'Tulsa,OK',
'74108': 'Tulsa,OK',
'74110': 'Tulsa,OK',
'74112': 'Tulsa,OK',
'74114': 'Tulsa,OK',
'74115': 'Tulsa,OK',
'74116': 'Tulsa,OK',
'74117': 'Tulsa,OK',
'74119': 'Tulsa,OK',
'74120': 'Tulsa,OK',
'74121': 'Tulsa,OK',
'74126': 'Tulsa,OK',
'74127': 'Tulsa,OK',
'74128': 'Tulsa,OK',
'74129': 'Tulsa,OK',
'74130': 'Tulsa,OK',
'74131': 'Tulsa,OK',
'74132': 'Tulsa,OK',
'74133': 'Tulsa,OK',
'74134': 'Tulsa,OK',
'74135': 'Tulsa,OK',
'74136': 'Tulsa,OK',
'74137': 'Tulsa,OK',
'74141': 'Tulsa,OK',
'74145': 'Tulsa,OK',
'74146': 'Tulsa,OK',
'74147': 'Tulsa,OK',
'74148': 'Tulsa,OK',
'74149': 'Tulsa,OK',
'74150': 'Tulsa,OK',
'74152': 'Tulsa,OK',
'74153': 'Tulsa,OK',
'74155': 'Tulsa,OK',
'74156': 'Tulsa,OK',
'74157': 'Tulsa,OK',
'74158': 'Tulsa,OK',
'74159': 'Tulsa,OK',
'74169': 'Tulsa,OK',
'74170': 'Tulsa,OK',
'74171': 'Tulsa,OK',
'74172': 'Tulsa,OK',
'74182': 'Tulsa,OK',
'74183': 'Tulsa,OK',
'74184': 'Tulsa,OK',
'74186': 'Tulsa,OK',
'74187': 'Tulsa,OK',
'74189': 'Tulsa,OK',
'74192': 'Tulsa,OK',
'74193': 'Tulsa,OK',
'74194': 'Tulsa,OK',
'74301': 'Vinita,OK',
'74330': 'Adair,OK',
'74331': 'Afton,OK',
'74332': 'Big Cabin,OK',
'74333': 'Bluejacket,OK',
'74335': 'Cardin,OK',
'74337': 'Chouteau,OK',
'74338': 'Colcord,OK',
'74339': 'Commerce,OK',
'74340': 'Disney,OK',
'74342': 'Eucha,OK',
'74343': 'Fairland,OK',
'74344': 'Grove,OK',
'74345': 'Grove,OK',
'74346': 'Jay,OK',
'74347': 'Kansas,OK',
'74349': 'Ketchum,OK',
'74350': 'Langley,OK',
'74352': 'Locust Grove,OK',
'74354': 'Miami,OK',
'74355': 'Miami,OK',
'74358': 'North Miami,OK',
'74359': 'Oaks,OK',
'74360': 'Picher,OK',
'74361': 'Pryor,OK',
'74362': 'Pryor,OK',
'74363': 'Quapaw,OK',
'74364': 'Rose,OK',
'74365': 'Salina,OK',
'74366': 'Spavinaw,OK',
'74367': 'Strang,OK',
'74368': 'Twin Oaks,OK',
'74369': 'Welch,OK',
'74370': 'Wyandotte,OK',
'74401': 'Muskogee,OK',
'74402': 'Muskogee,OK',
'74403': 'Muskogee,OK',
'74421': 'Beggs,OK',
'74422': 'Boynton,OK',
'74423': 'Braggs,OK',
'74425': 'Canadian,OK',
'74426': 'Checotah,OK',
'74427': 'Cookson,OK',
'74428': 'Council Hill,OK',
'74429': 'Coweta,OK',
'74430': 'Crowder,OK',
'74431': 'Dewar,OK',
'74432': 'Eufaula,OK',
'74434': 'Fort Gibson,OK',
'74435': 'Gore,OK',
'74436': 'Haskell,OK',
'74437': 'Henryetta,OK',
'74438': 'Hitchita,OK',
'74439': 'Braggs,OK',
'74440': 'Hoyt,OK',
'74441': 'Hulbert,OK',
'74442': 'Indianola,OK',
'74444': 'Moodys,OK',
'74445': 'Morris,OK',
'74446': 'Okay,OK',
'74447': 'Okmulgee,OK',
'74450': 'Oktaha,OK',
'74451': 'Park Hill,OK',
'74452': 'Peggs,OK',
'74454': 'Porter,OK',
'74455': 'Porum,OK',
'74456': 'Preston,OK',
'74457': 'Proctor,OK',
'74458': 'Redbird,OK',
'74459': 'Rentiesville,OK',
'74460': 'Schulter,OK',
'74461': 'Stidham,OK',
'74462': 'Stigler,OK',
'74463': 'Taft,OK',
'74464': 'Tahlequah,OK',
'74465': 'Tahlequah,OK',
'74466': 'Tullahassee,OK',
'74467': 'Wagoner,OK',
'74468': 'Wainwright,OK',
'74469': 'Warner,OK',
'74470': 'Webbers Falls,OK',
'74471': 'Welling,OK',
'74472': 'Whitefield,OK',
'74477': 'Wagoner,OK',
'74501': 'Mcalester,OK',
'74502': 'Mcalester,OK',
'74521': 'Albion,OK',
'74522': 'Alderson,OK',
'74523': 'Antlers,OK',
'74525': 'Atoka,OK',
'74528': 'Blanco,OK',
'74529': 'Blocker,OK',
'74530': 'Bromide,OK',
'74531': 'Calvin,OK',
'74533': 'Caney,OK',
'74534': 'Centrahoma,OK',
'74535': 'Clarita,OK',
'74536': 'Clayton,OK',
'74538': 'Coalgate,OK',
'74540': 'Daisy,OK',
'74542': 'Atoka,OK',
'74543': 'Finley,OK',
'74545': 'Gowen,OK',
'74546': 'Haileyville,OK',
'74547': 'Hartshorne,OK',
'74549': 'Honobia,OK',
'74552': 'Kinta,OK',
'74553': 'Kiowa,OK',
'74554': 'Krebs,OK',
'74555': 'Lane,OK',
'74556': 'Lehigh,OK',
'74557': 'Moyers,OK',
'74558': 'Nashoba,OK',
'74559': 'Panola,OK',
'74560': 'Pittsburg,OK',
'74561': 'Quinton,OK',
'74562': 'Rattan,OK',
'74563': 'Red Oak,OK',
'74565': 'Savanna,OK',
'74567': 'Snow,OK',
'74569': 'Stringtown,OK',
'74570': 'Stuart,OK',
'74571': 'Talihina,OK',
'74572': 'Tupelo,OK',
'74574': 'Tuskahoma,OK',
'74576': 'Wardville,OK',
'74577': 'Whitesboro,OK',
'74578': 'Wilburton,OK',
'74601': 'Ponca City,OK',
'74602': 'Ponca City,OK',
'74603': 'Ponca City,OK',
'74604': 'Ponca City,OK',
'74630': 'Billings,OK',
'74631': 'Blackwell,OK',
'74632': 'Braman,OK',
'74633': 'Burbank,OK',
'74636': 'Deer Creek,OK',
'74637': 'Fairfax,OK',
'74640': 'Hunter,OK',
'74641': 'Kaw City,OK',
'74643': 'Lamont,OK',
'74644': 'Marland,OK',
'74646': 'Nardin,OK',
'74647': 'Newkirk,OK',
'74650': 'Ralston,OK',
'74651': 'Red Rock,OK',
'74652': 'Shidler,OK',
'74653': 'Tonkawa,OK',
'74701': 'Durant,OK',
'74702': 'Durant,OK',
'74720': 'Achille,OK',
'74721': 'Albany,OK',
'74722': 'Battiest,OK',
'74723': 'Bennington,OK',
'74724': 'Bethel,OK',
'74726': 'Bokchito,OK',
'74727': 'Boswell,OK',
'74728': 'Broken Bow,OK',
'74729': 'Caddo,OK',
'74730': 'Calera,OK',
'74731': 'Cartwright,OK',
'74733': 'Colbert,OK',
'74734': 'Eagletown,OK',
'74735': 'Fort Towson,OK',
'74736': 'Garvin,OK',
'74737': 'Golden,OK',
'74738': 'Grant,OK',
'74740': 'Haworth,OK',
'74741': 'Hendrix,OK',
'74743': 'Hugo,OK',
'74745': 'Idabel,OK',
'74747': 'Kemp,OK',
'74748': 'Kenefic,OK',
'74750': 'Millerton,OK',
'74752': 'Pickens,OK',
'74753': 'Platter,OK',
'74754': 'Ringold,OK',
'74755': 'Rufe,OK',
'74756': 'Sawyer,OK',
'74759': 'Soper,OK',
'74760': 'Spencerville,OK',
'74761': 'Swink,OK',
'74764': 'Valliant,OK',
'74766': 'Wright City,OK',
'74801': 'Shawnee,OK',
'74802': 'Shawnee,OK',
'74804': 'Shawnee,OK',
'74818': 'Seminole,OK',
'74820': 'Ada,OK',
'74821': 'Ada,OK',
'74824': 'Agra,OK',
'74825': 'Allen,OK',
'74826': 'Asher,OK',
'74827': 'Atwood,OK',
'74829': 'Boley,OK',
'74830': 'Bowlegs,OK',
'74831': 'Byars,OK',
'74832': 'Carney,OK',
'74833': 'Castle,OK',
'74834': 'Chandler,OK',
'74836': 'Connerville,OK',
'74837': 'Cromwell,OK',
'74839': 'Dustin,OK',
'74840': 'Earlsboro,OK',
'74842': 'Fittstown,OK',
'74843': 'Fitzhugh,OK',
'74844': 'Francis,OK',
'74845': 'Hanna,OK',
'74848': 'Holdenville,OK',
'74849': 'Konawa,OK',
'74850': 'Lamar,OK',
'74851': 'Mcloud,OK',
'74852': 'Macomb,OK',
'74854': 'Maud,OK',
'74855': 'Meeker,OK',
'74856': 'Mill Creek,OK',
'74857': 'Newalla,OK',
'74859': 'Okemah,OK',
'74860': 'Paden,OK',
'74864': 'Prague,OK',
'74865': 'Roff,OK',
'74866': 'Saint Louis,OK',
'74867': 'Sasakwa,OK',
'74868': 'Seminole,OK',
'74869': 'Sparks,OK',
'74871': 'Stonewall,OK',
'74872': 'Stratford,OK',
'74873': 'Tecumseh,OK',
'74875': 'Tryon,OK',
'74878': 'Wanette,OK',
'74880': 'Weleetka,OK',
'74881': 'Wellston,OK',
'74883': 'Wetumka,OK',
'74884': 'Wewoka,OK',
'74901': 'Arkoma,OK',
'74902': 'Pocola,OK',
'74930': 'Bokoshe,OK',
'74931': 'Bunch,OK',
'74932': 'Cameron,OK',
'74935': 'Fanshawe,OK',
'74936': 'Gans,OK',
'74937': 'Heavener,OK',
'74939': 'Hodgen,OK',
'74940': 'Howe,OK',
'74941': 'Keota,OK',
'74942': 'Leflore,OK',
'74943': 'Lequire,OK',
'74944': 'Mccurtain,OK',
'74945': 'Marble City,OK',
'74946': 'Moffett,OK',
'74947': 'Monroe,OK',
'74948': 'Muldrow,OK',
'74949': 'Muse,OK',
'74951': 'Panama,OK',
'74953': 'Poteau,OK',
'74954': 'Roland,OK',
'74955': 'Sallisaw,OK',
'74956': 'Shady Point,OK',
'74957': 'Smithville,OK',
'74959': 'Spiro,OK',
'74960': 'Stilwell,OK',
'74962': 'Vian,OK',
'74963': 'Watson,OK',
'74964': 'Watts,OK',
'74965': 'Westville,OK',
'74966': 'Wister,OK',
'75001': 'Addison,TX',
'75002': 'Allen,TX',
'75006': 'Carrollton,TX',
'75007': 'Carrollton,TX',
'75008': 'Carrollton,TX',
'75009': 'Celina,TX',
'75010': 'Carrollton,TX',
'75011': 'Carrollton,TX',
'75013': 'Allen,TX',
'75014': 'Irving,TX',
'75015': 'Irving,TX',
'75016': 'Irving,TX',
'75017': 'Irving,TX',
'75019': 'Coppell,TX',
'75020': 'Denison,TX',
'75021': 'Denison,TX',
'75022': 'Flower Mound,TX',
'75023': 'Plano,TX',
'75024': 'Plano,TX',
'75025': 'Plano,TX',
'75026': 'Plano,TX',
'75027': 'Flower Mound,TX',
'75028': 'Flower Mound,TX',
'75029': 'Lewisville,TX',
'75030': 'Rowlett,TX',
'75032': 'Rockwall,TX',
'75034': 'Frisco,TX',
'75035': 'Frisco,TX',
'75037': 'Irving,TX',
'75038': 'Irving,TX',
'75039': 'Irving,TX',
'75040': 'Garland,TX',
'75041': 'Garland,TX',
'75042': 'Garland,TX',
'75043': 'Garland,TX',
'75044': 'Garland,TX',
'75045': 'Garland,TX',
'75046': 'Garland,TX',
'75047': 'Garland,TX',
'75048': 'Sachse,TX',
'75049': 'Garland,TX',
'75050': 'Grand Prairie,TX',
'75051': 'Grand Prairie,TX',
'75052': 'Grand Prairie,TX',
'75053': 'Grand Prairie,TX',
'75054': 'Grand Prairie,TX',
'75056': 'The Colony,TX',
'75057': 'Lewisville,TX',
'75058': 'Gunter,TX',
'75060': 'Irving,TX',
'75061': 'Irving,TX',
'75062': 'Irving,TX',
'75063': 'Irving,TX',
'75065': 'Lake Dallas,TX',
'75067': 'Lewisville,TX',
'75068': 'Little Elm,TX',
'75069': 'Mc Kinney,TX',
'75070': 'Mc Kinney,TX',
'75071': 'Mc Kinney,TX',
'75074': 'Plano,TX',
'75075': 'Plano,TX',
'75076': 'Pottsboro,TX',
'75077': 'Lewisville,TX',
'75078': 'Prosper,TX',
'75080': 'Richardson,TX',
'75081': 'Richardson,TX',
'75082': 'Richardson,TX',
'75083': 'Richardson,TX',
'75085': 'Richardson,TX',
'75086': 'Plano,TX',
'75087': 'Rockwall,TX',
'75088': 'Rowlett,TX',
'75089': 'Rowlett,TX',
'75090': 'Sherman,TX',
'75091': 'Sherman,TX',
'75092': 'Sherman,TX',
'75093': 'Plano,TX',
'75094': 'Plano,TX',
'75097': 'Weston,TX',
'75098': 'Wylie,TX',
'75099': 'Coppell,TX',
'75101': 'Bardwell,TX',
'75102': 'Barry,TX',
'75103': 'Canton,TX',
'75104': 'Cedar Hill,TX',
'75105': 'Chatfield,TX',
'75106': 'Cedar Hill,TX',
'75109': 'Corsicana,TX',
'75110': 'Corsicana,TX',
'75114': 'Crandall,TX',
'75115': 'Desoto,TX',
'75116': 'Duncanville,TX',
'75117': 'Edgewood,TX',
'75118': 'Elmo,TX',
'75119': 'Ennis,TX',
'75120': 'Ennis,TX',
'75121': 'Copeville,TX',
'75123': 'Desoto,TX',
'75124': 'Eustace,TX',
'75125': 'Ferris,TX',
'75126': 'Forney,TX',
'75127': 'Fruitvale,TX',
'75132': 'Fate,TX',
'75134': 'Lancaster,TX',
'75135': 'Caddo Mills,TX',
'75137': 'Duncanville,TX',
'75138': 'Duncanville,TX',
'75140': 'Grand Saline,TX',
'75141': 'Hutchins,TX',
'75142': 'Kaufman,TX',
'75143': 'Kemp,TX',
'75144': 'Kerens,TX',
'75146': 'Lancaster,TX',
'75147': 'Mabank,TX',
'75148': 'Malakoff,TX',
'75149': 'Mesquite,TX',
'75150': 'Mesquite,TX',
'75151': 'Corsicana,TX',
'75152': 'Palmer,TX',
'75153': 'Powell,TX',
'75154': 'Red Oak,TX',
'75155': 'Rice,TX',
'75156': 'Mabank,TX',
'75157': 'Rosser,TX',
'75158': 'Scurry,TX',
'75159': 'Seagoville,TX',
'75160': 'Terrell,TX',
'75161': 'Terrell,TX',
'75163': 'Trinidad,TX',
'75164': 'Josephine,TX',
'75165': 'Waxahachie,TX',
'75166': 'Lavon,TX',
'75167': 'Waxahachie,TX',
'75168': 'Waxahachie,TX',
'75169': 'Wills Point,TX',
'75172': 'Wilmer,TX',
'75173': 'Nevada,TX',
'75180': 'Mesquite,TX',
'75181': 'Mesquite,TX',
'75182': 'Sunnyvale,TX',
'75185': 'Mesquite,TX',
'75187': 'Mesquite,TX',
'75189': 'Royse City,TX',
'75201': 'Dallas,TX',
'75202': 'Dallas,TX',
'75203': 'Dallas,TX',
'75204': 'Dallas,TX',
'75205': 'Dallas,TX',
'75206': 'Dallas,TX',
'75207': 'Dallas,TX',
'75208': 'Dallas,TX',
'75209': 'Dallas,TX',
'75210': 'Dallas,TX',
'75211': 'Dallas,TX',
'75212': 'Dallas,TX',
'75214': 'Dallas,TX',
'75215': 'Dallas,TX',
'75216': 'Dallas,TX',
'75217': 'Dallas,TX',
'75218': 'Dallas,TX',
'75219': 'Dallas,TX',
'75220': 'Dallas,TX',
'75221': 'Dallas,TX',
'75222': 'Dallas,TX',
'75223': 'Dallas,TX',
'75224': 'Dallas,TX',
'75225': 'Dallas,TX',
'75226': 'Dallas,TX',
'75227': 'Dallas,TX',
'75228': 'Dallas,TX',
'75229': 'Dallas,TX',
'75230': 'Dallas,TX',
'75231': 'Dallas,TX',
'75232': 'Dallas,TX',
'75233': 'Dallas,TX',
'75234': 'Dallas,TX',
'75235': 'Dallas,TX',
'75236': 'Dallas,TX',
'75237': 'Dallas,TX',
'75238': 'Dallas,TX',
'75239': 'Dallas,TX',
'75240': 'Dallas,TX',
'75241': 'Dallas,TX',
'75242': 'Dallas,TX',
'75243': 'Dallas,TX',
'75244': 'Dallas,TX',
'75245': 'Dallas,TX',
'75246': 'Dallas,TX',
'75247': 'Dallas,TX',
'75248': 'Dallas,TX',
'75249': 'Dallas,TX',
'75250': 'Dallas,TX',
'75251': 'Dallas,TX',
'75252': 'Dallas,TX',
'75253': 'Dallas,TX',
'75254': 'Dallas,TX',
'75258': 'Dallas,TX',
'75260': 'Dallas,TX',
'75261': 'Dallas,TX',
'75262': 'Dallas,TX',
'75263': 'Dallas,TX',
'75264': 'Dallas,TX',
'75265': 'Dallas,TX',
'75266': 'Dallas,TX',
'75267': 'Dallas,TX',
'75270': 'Dallas,TX',
'75275': 'Dallas,TX',
'75277': 'Dallas,TX',
'75283': 'Dallas,TX',
'75284': 'Dallas,TX',
'75285': 'Dallas,TX',
'75286': 'Dallas,TX',
'75287': 'Dallas,TX',
'75295': 'Dallas,TX',
'75301': 'Dallas,TX',
'75303': 'Dallas,TX',
'75310': 'Dallas,TX',
'75312': 'Dallas,TX',
'75313': 'Dallas,TX',
'75315': 'Dallas,TX',
'75320': 'Dallas,TX',
'75323': 'Dallas,TX',
'75326': 'Dallas,TX',
'75334': 'Dallas,TX',
'75336': 'Dallas,TX',
'75339': 'Dallas,TX',
'75340': 'Dallas,TX',
'75342': 'Dallas,TX',
'75343': 'Dallas,TX',
'75344': 'Dallas,TX',
'75346': 'Dallas,TX',
'75353': 'Dallas,TX',
'75354': 'Dallas,TX',
'75355': 'Dallas,TX',
'75356': 'Dallas,TX',
'75357': 'Dallas,TX',
'75358': 'Lsi,TX',
'75359': 'Dallas,TX',
'75360': 'Dallas,TX',
'75363': 'Dallas,TX',
'75364': 'Dallas,TX',
'75367': 'Dallas,TX',
'75368': 'Dallas,TX',
'75370': 'Dallas,TX',
'75371': 'Dallas,TX',
'75372': 'Dallas,TX',
'75373': 'Dallas,TX',
'75374': 'Dallas,TX',
'75376': 'Dallas,TX',
'75378': 'Dallas,TX',
'75379': 'Dallas,TX',
'75380': 'Dallas,TX',
'75381': 'Dallas,TX',
'75382': 'Dallas,TX',
'75386': 'Dallas,TX',
'75387': 'Dallas,TX',
'75388': 'Dallas,TX',
'75389': 'Dallas,TX',
'75390': 'Dallas,TX',
'75391': 'Dallas,TX',
'75392': 'Dallas,TX',
'75393': 'Dallas,TX',
'75394': 'Dallas,TX',
'75395': 'Dallas,TX',
'75396': 'Dallas,TX',
'75397': 'Dallas,TX',
'75398': 'Dallas,TX',
'75401': 'Greenville,TX',
'75402': 'Greenville,TX',
'75403': 'Greenville,TX',
'75404': 'Greenville,TX',
'75407': 'Princeton,TX',
'75409': 'Anna,TX',
'75410': 'Alba,TX',
'75411': 'Arthur City,TX',
'75412': 'Bagwell,TX',
'75413': 'Bailey,TX',
'75414': 'Bells,TX',
'75415': 'Ben Franklin,TX',
'75416': 'Blossom,TX',
'75417': 'Bogata,TX',
'75418': 'Bonham,TX',
'75420': 'Brashear,TX',
'75421': 'Brookston,TX',
'75422': 'Campbell,TX',
'75423': 'Celeste,TX',
'75424': 'Blue Ridge,TX',
'75425': 'Chicota,TX',
'75426': 'Clarksville,TX',
'75428': 'Commerce,TX',
'75429': 'Commerce,TX',
'75431': 'Como,TX',
'75432': 'Cooper,TX',
'75433': 'Cumby,TX',
'75434': 'Cunningham,TX',
'75435': 'Deport,TX',
'75436': 'Detroit,TX',
'75437': 'Dike,TX',
'75438': 'Dodd City,TX',
'75439': 'Ector,TX',
'75440': 'Emory,TX',
'75441': 'Enloe,TX',
'75442': 'Farmersville,TX',
'75443': 'Gober,TX',
'75444': 'Golden,TX',
'75446': 'Honey Grove,TX',
'75447': 'Ivanhoe,TX',
'75448': 'Klondike,TX',
'75449': 'Ladonia,TX',
'75450': 'Lake Creek,TX',
'75451': 'Leesburg,TX',
'75452': 'Leonard,TX',
'75453': 'Lone Oak,TX',
'75454': 'Melissa,TX',
'75455': 'Mount Pleasant,TX',
'75456': 'Mount Pleasant,TX',
'75457': 'Mount Vernon,TX',
'75458': 'Merit,TX',
'75459': 'Howe,TX',
'75460': 'Paris,TX',
'75461': 'Paris,TX',
'75462': 'Paris,TX',
'75468': 'Pattonville,TX',
'75469': 'Pecan Gap,TX',
'75470': 'Petty,TX',
'75471': 'Pickton,TX',
'75472': 'Point,TX',
'75473': 'Powderly,TX',
'75474': 'Quinlan,TX',
'75475': 'Randolph,TX',
'75476': 'Ravenna,TX',
'75477': 'Roxton,TX',
'75478': 'Saltillo,TX',
'75479': 'Savoy,TX',
'75480': 'Scroggins,TX',
'75481': 'Sulphur Bluff,TX',
'75482': 'Sulphur Springs,TX',
'75483': 'Sulphur Springs,TX',
'75485': 'Westminster,TX',
'75486': 'Sumner,TX',
'75487': 'Talco,TX',
'75488': 'Telephone,TX',
'75489': 'Tom Bean,TX',
'75490': 'Trenton,TX',
'75491': 'Whitewright,TX',
'75492': 'Windom,TX',
'75493': 'Winfield,TX',
'75494': 'Winnsboro,TX',
'75495': 'Van Alstyne,TX',
'75496': 'Wolfe City,TX',
'75497': 'Yantis,TX',
'75501': 'Texarkana,TX',
'75503': 'Texarkana,TX',
'75504': 'Texarkana,TX',
'75505': 'Texarkana,TX',
'75507': 'Texarkana,TX',
'75550': 'Annona,TX',
'75551': 'Atlanta,TX',
'75554': 'Avery,TX',
'75555': 'Bivins,TX',
'75556': 'Bloomburg,TX',
'75558': 'Cookville,TX',
'75559': 'De Kalb,TX',
'75560': 'Douglassville,TX',
'75561': 'Hooks,TX',
'75562': 'Kildare,TX',
'75563': 'Linden,TX',
'75564': 'Lodi,TX',
'75565': 'Mc Leod,TX',
'75566': 'Marietta,TX',
'75567': 'Maud,TX',
'75568': 'Naples,TX',
'75569': 'Nash,TX',
'75570': 'New Boston,TX',
'75571': 'Omaha,TX',
'75572': 'Queen City,TX',
'75573': 'Redwater,TX',
'75574': 'Simms,TX',
'75599': 'Texarkana,TX',
'75601': 'Longview,TX',
'75602': 'Longview,TX',
'75603': 'Longview,TX',
'75604': 'Longview,TX',
'75605': 'Longview,TX',
'75606': 'Longview,TX',
'75607': 'Longview,TX',
'75608': 'Longview,TX',
'75615': 'Longview,TX',
'75630': 'Avinger,TX',
'75631': 'Beckville,TX',
'75633': 'Carthage,TX',
'75636': 'Cason,TX',
'75637': 'Clayton,TX',
'75638': 'Daingerfield,TX',
'75639': 'De Berry,TX',
'75640': 'Diana,TX',
'75641': 'Easton,TX',
'75642': 'Elysian Fields,TX',
'75643': 'Gary,TX',
'75644': 'Gilmer,TX',
'75645': 'Gilmer,TX',
'75647': 'Gladewater,TX',
'75650': 'Hallsville,TX',
'75651': 'Harleton,TX',
'75652': 'Henderson,TX',
'75653': 'Henderson,TX',
'75654': 'Henderson,TX',
'75656': 'Hughes Springs,TX',
'75657': 'Jefferson,TX',
'75658': 'Joinerville,TX',
'75659': 'Jonesville,TX',
'75660': 'Judson,TX',
'75661': 'Karnack,TX',
'75662': 'Kilgore,TX',
'75663': 'Kilgore,TX',
'75666': 'Laird Hill,TX',
'75667': 'Laneville,TX',
'75668': 'Lone Star,TX',
'75669': 'Long Branch,TX',
'75670': 'Marshall,TX',
'75671': 'Marshall,TX',
'75672': 'Marshall,TX',
'75680': 'Minden,TX',
'75681': 'Mount Enterprise,TX',
'75682': 'New London,TX',
'75683': 'Ore City,TX',
'75684': 'Overton,TX',
'75685': 'Panola,TX',
'75686': 'Pittsburg,TX',
'75687': 'Price,TX',
'75688': 'Scottsville,TX',
'75689': 'Selman City,TX',
'75691': 'Tatum,TX',
'75692': 'Waskom,TX',
'75693': 'White Oak,TX',
'75694': 'Woodlawn,TX',
'75701': 'Tyler,TX',
'75702': 'Tyler,TX',
'75703': 'Tyler,TX',
'75704': 'Tyler,TX',
'75705': 'Tyler,TX',
'75706': 'Tyler,TX',
'75707': 'Tyler,TX',
'75708': 'Tyler,TX',
'75709': 'Tyler,TX',
'75710': 'Tyler,TX',
'75711': 'Tyler,TX',
'75712': 'Tyler,TX',
'75713': 'Tyler,TX',
'75750': 'Arp,TX',
'75751': 'Athens,TX',
'75752': 'Athens,TX',
'75754': 'Ben Wheeler,TX',
'75755': 'Big Sandy,TX',
'75756': 'Brownsboro,TX',
'75757': 'Bullard,TX',
'75758': 'Chandler,TX',
'75759': 'Cuney,TX',
'75760': 'Cushing,TX',
'75762': 'Flint,TX',
'75763': 'Frankston,TX',
'75764': 'Gallatin,TX',
'75765': 'Hawkins,TX',
'75766': 'Jacksonville,TX',
'75770': 'Larue,TX',
'75771': 'Lindale,TX',
'75772': 'Maydelle,TX',
'75773': 'Mineola,TX',
'75778': 'Murchison,TX',
'75779': 'Neches,TX',
'75780': 'New Summerfield,TX',
'75782': 'Poynor,TX',
'75783': 'Quitman,TX',
'75784': 'Reklaw,TX',
'75785': 'Rusk,TX',
'75788': 'Sacul,TX',
'75789': 'Troup,TX',
'75790': 'Van,TX',
'75791': 'Whitehouse,TX',
'75792': 'Winona,TX',
'75797': 'Dynamic Resource Group,TX',
'75798': 'Tyler,TX',
'75799': 'Tyler,TX',
'75801': 'Palestine,TX',
'75802': 'Palestine,TX',
'75803': 'Palestine,TX',
'75831': 'Buffalo,TX',
'75832': 'Cayuga,TX',
'75833': 'Centerville,TX',
'75834': 'Centralia,TX',
'75835': 'Crockett,TX',
'75838': 'Donie,TX',
'75839': 'Elkhart,TX',
'75840': 'Fairfield,TX',
'75844': 'Grapeland,TX',
'75845': 'Groveton,TX',
'75846': 'Jewett,TX',
'75847': 'Kennard,TX',
'75848': 'Kirvin,TX',
'75849': 'Latexo,TX',
'75850': 'Leona,TX',
'75851': 'Lovelady,TX',
'75852': 'Midway,TX',
'75853': 'Montalba,TX',
'75855': 'Oakwood,TX',
'75856': 'Pennington,TX',
'75858': 'Ratcliff,TX',
'75859': 'Streetman,TX',
'75860': 'Teague,TX',
'75861': 'Tennessee Colony,TX',
'75862': 'Trinity,TX',
'75865': 'Woodlake,TX',
'75880': 'Tennessee Colony,TX',
'75882': 'Palestine,TX',
'75884': 'Tennessee Colony,TX',
'75886': 'Tennessee Colony,TX',
'75901': 'Lufkin,TX',
'75902': 'Lufkin,TX',
'75903': 'Lufkin,TX',
'75904': 'Lufkin,TX',
'75915': 'Lufkin,TX',
'75925': 'Alto,TX',
'75926': 'Apple Springs,TX',
'75928': 'Bon Wier,TX',
'75929': 'Broaddus,TX',
'75930': 'Bronson,TX',
'75931': 'Brookeland,TX',
'75932': 'Burkeville,TX',
'75933': 'Call,TX',
'75934': 'Camden,TX',
'75935': 'Center,TX',
'75936': 'Chester,TX',
'75937': 'Chireno,TX',
'75938': 'Colmesneil,TX',
'75939': 'Corrigan,TX',
'75941': 'Diboll,TX',
'75942': 'Doucette,TX',
'75943': 'Douglass,TX',
'75944': 'Etoile,TX',
'75946': 'Garrison,TX',
'75947': 'Geneva,TX',
'75948': 'Hemphill,TX',
'75949': 'Huntington,TX',
'75951': 'Jasper,TX',
'75954': 'Joaquin,TX',
'75956': 'Kirbyville,TX',
'75958': 'Martinsville,TX',
'75959': 'Milam,TX',
'75960': 'Moscow,TX',
'75961': 'Nacogdoches,TX',
'75962': 'Nacogdoches,TX',
'75963': 'Nacogdoches,TX',
'75964': 'Nacogdoches,TX',
'75965': 'Nacogdoches,TX',
'75966': 'Newton,TX',
'75968': 'Pineland,TX',
'75969': 'Pollok,TX',
'75972': 'San Augustine,TX',
'75973': 'Shelbyville,TX',
'75974': 'Tenaha,TX',
'75975': 'Timpson,TX',
'75976': 'Wells,TX',
'75977': 'Wiergate,TX',
'75978': 'Woden,TX',
'75979': 'Woodville,TX',
'75980': 'Zavalla,TX',
'75990': 'Woodville,TX',
'76001': 'Arlington,TX',
'76002': 'Arlington,TX',
'76003': 'Arlington,TX',
'76004': 'Arlington,TX',
'76005': 'Arlington,TX',
'76006': 'Arlington,TX',
'76007': 'Arlington,TX',
'76008': 'Aledo,TX',
'76009': 'Alvarado,TX',
'76010': 'Arlington,TX',
'76011': 'Arlington,TX',
'76012': 'Arlington,TX',
'76013': 'Arlington,TX',
'76014': 'Arlington,TX',
'76015': 'Arlington,TX',
'76016': 'Arlington,TX',
'76017': 'Arlington,TX',
'76018': 'Arlington,TX',
'76019': 'Arlington,TX',
'76020': 'Azle,TX',
'76021': 'Bedford,TX',
'76022': 'Bedford,TX',
'76023': 'Boyd,TX',
'76028': 'Burleson,TX',
'76031': 'Cleburne,TX',
'76033': 'Cleburne,TX',
'76034': 'Colleyville,TX',
'76035': 'Cresson,TX',
'76036': 'Crowley,TX',
'76039': 'Euless,TX',
'76040': 'Euless,TX',
'76041': 'Forreston,TX',
'76043': 'Glen Rose,TX',
'76044': 'Godley,TX',
'76048': 'Granbury,TX',
'76049': 'Granbury,TX',
'76050': 'Grandview,TX',
'76051': 'Grapevine,TX',
'76052': 'Haslet,TX',
'76053': 'Hurst,TX',
'76054': 'Hurst,TX',
'76055': 'Itasca,TX',
'76058': 'Joshua,TX',
'76059': 'Keene,TX',
'76060': 'Kennedale,TX',
'76061': 'Lillian,TX',
'76063': 'Mansfield,TX',
'76064': 'Maypearl,TX',
'76065': 'Midlothian,TX',
'76066': 'Millsap,TX',
'76067': 'Mineral Wells,TX',
'76068': 'Mineral Wells,TX',
'76070': 'Nemo,TX',
'76071': 'Newark,TX',
'76073': 'Paradise,TX',
'76077': 'Rainbow,TX',
'76078': 'Rhome,TX',
'76082': 'Springtown,TX',
'76084': 'Venus,TX',
'76085': 'Weatherford,TX',
'76086': 'Weatherford,TX',
'76087': 'Weatherford,TX',
'76088': 'Weatherford,TX',
'76092': 'Southlake,TX',
'76093': 'Rio Vista,TX',
'76094': 'Arlington,TX',
'76095': 'Bedford,TX',
'76096': 'Arlington,TX',
'76097': 'Burleson,TX',
'76098': 'Azle,TX',
'76099': 'Grapevine,TX',
'76101': 'Fort Worth,TX',
'76102': 'Fort Worth,TX',
'76103': 'Fort Worth,TX',
'76104': 'Fort Worth,TX',
'76105': 'Fort Worth,TX',
'76106': 'Fort Worth,TX',
'76107': 'Fort Worth,TX',
'76108': 'Fort Worth,TX',
'76109': 'Fort Worth,TX',
'76110': 'Fort Worth,TX',
'76111': 'Fort Worth,TX',
'76112': 'Fort Worth,TX',
'76113': 'Fort Worth,TX',
'76114': 'Fort Worth,TX',
'76115': 'Fort Worth,TX',
'76116': 'Fort Worth,TX',
'76117': 'Haltom City,TX',
'76118': 'Fort Worth,TX',
'76119': 'Fort Worth,TX',
'76120': 'Fort Worth,TX',
'76121': 'Fort Worth,TX',
'76122': 'Fort Worth,TX',
'76123': 'Fort Worth,TX',
'76124': 'Fort Worth,TX',
'76126': 'Fort Worth,TX',
'76127': 'Naval Air Station/ Jrb,TX',
'76129': 'Fort Worth,TX',
'76130': 'Fort Worth,TX',
'76131': 'Fort Worth,TX',
'76132': 'Fort Worth,TX',
'76133': 'Fort Worth,TX',
'76134': 'Fort Worth,TX',
'76135': 'Fort Worth,TX',
'76136': 'Fort Worth,TX',
'76137': 'Fort Worth,TX',
'76140': 'Fort Worth,TX',
'76147': 'Fort Worth,TX',
'76148': 'Fort Worth,TX',
'76150': 'Fort Worth,TX',
'76155': 'Fort Worth,TX',
'76161': 'Fort Worth,TX',
'76162': 'Fort Worth,TX',
'76163': 'Fort Worth,TX',
'76164': 'Fort Worth,TX',
'76177': 'Fort Worth,TX',
'76178': 'Fort Worth,TX',
'76179': 'Fort Worth,TX',
'76180': 'North Richland Hills,TX',
'76181': 'Fort Worth,TX',
'76182': 'North Richland Hills,TX',
'76185': 'Fort Worth,TX',
'76191': 'Fort Worth,TX',
'76192': 'Fort Worth,TX',
'76193': 'Fort Worth,TX',
'76195': 'Fort Worth,TX',
'76196': 'Fort Worth,TX',
'76197': 'Fort Worth,TX',
'76198': 'Fort Worth,TX',
'76199': 'Fort Worth,TX',
'76201': 'Denton,TX',
'76202': 'Denton,TX',
'76203': 'Denton,TX',
'76204': 'Denton,TX',
'76205': 'Denton,TX',
'76206': 'Denton,TX',
'76207': 'Denton,TX',
'76208': 'Denton,TX',
'76209': 'Denton,TX',
'76210': 'Denton,TX',
'76225': 'Alvord,TX',
'76226': 'Argyle,TX',
'76227': 'Aubrey,TX',
'76228': 'Bellevue,TX',
'76230': 'Bowie,TX',
'76233': 'Collinsville,TX',
'76234': 'Decatur,TX',
'76238': 'Era,TX',
'76239': 'Forestburg,TX',
'76240': 'Gainesville,TX',
'76241': 'Gainesville,TX',
'76244': 'Keller,TX',
'76245': 'Gordonville,TX',
'76246': 'Greenwood,TX',
'76247': 'Justin,TX',
'76248': 'Keller,TX',
'76249': 'Krum,TX',
'76250': 'Lindsay,TX',
'76251': 'Montague,TX',
'76252': 'Muenster,TX',
'76253': 'Myra,TX',
'76255': 'Nocona,TX',
'76258': 'Pilot Point,TX',
'76259': 'Ponder,TX',
'76261': 'Ringgold,TX',
'76262': 'Roanoke,TX',
'76263': 'Rosston,TX',
'76264': 'Sadler,TX',
'76265': 'Saint Jo,TX',
'76266': 'Sanger,TX',
'76267': 'Slidell,TX',
'76268': 'Southmayd,TX',
'76270': 'Sunset,TX',
'76271': 'Tioga,TX',
'76272': 'Valley View,TX',
'76273': 'Whitesboro,TX',
'76299': 'Roanoke,TX',
'76301': 'Wichita Falls,TX',
'76302': 'Wichita Falls,TX',
'76305': 'Wichita Falls,TX',
'76306': 'Wichita Falls,TX',
'76307': 'Wichita Falls,TX',
'76308': 'Wichita Falls,TX',
'76309': 'Wichita Falls,TX',
'76310': 'Wichita Falls,TX',
'76311': 'Sheppard Afb,TX',
'76351': 'Archer City,TX',
'76352': 'Bluegrove,TX',
'76354': 'Burkburnett,TX',
'76357': 'Byers,TX',
'76360': 'Electra,TX',
'76363': 'Goree,TX',
'76364': 'Harrold,TX',
'76365': 'Henrietta,TX',
'76366': 'Holliday,TX',
'76367': 'Iowa Park,TX',
'76369': 'Kamay,TX',
'76370': 'Megargel,TX',
'76371': 'Munday,TX',
'76372': 'Newcastle,TX',
'76373': 'Oklaunion,TX',
'76374': 'Olney,TX',
'76377': 'Petrolia,TX',
'76379': 'Scotland,TX',
'76380': 'Seymour,TX',
'76384': 'Vernon,TX',
'76385': 'Vernon,TX',
'76388': 'Weinert,TX',
'76389': 'Windthorst,TX',
'76401': 'Stephenville,TX',
'76402': 'Stephenville,TX',
'76424': 'Breckenridge,TX',
'76426': 'Bridgeport,TX',
'76427': 'Bryson,TX',
'76429': 'Caddo,TX',
'76430': 'Albany,TX',
'76431': 'Chico,TX',
'76432': 'Blanket,TX',
'76433': 'Bluff Dale,TX',
'76435': 'Carbon,TX',
'76436': 'Carlton,TX',
'76437': 'Cisco,TX',
'76439': 'Dennis,TX',
'76442': 'Comanche,TX',
'76443': 'Cross Plains,TX',
'76444': 'De Leon,TX',
'76445': 'Desdemona,TX',
'76446': 'Dublin,TX',
'76448': 'Eastland,TX',
'76449': 'Graford,TX',
'76450': 'Graham,TX',
'76452': 'Energy,TX',
'76453': 'Gordon,TX',
'76454': 'Gorman,TX',
'76455': 'Gustine,TX',
'76457': 'Hico,TX',
'76458': 'Jacksboro,TX',
'76459': 'Jermyn,TX',
'76460': 'Loving,TX',
'76461': 'Lingleville,TX',
'76462': 'Lipan,TX',
'76463': 'Mingus,TX',
'76464': 'Moran,TX',
'76465': 'Morgan Mill,TX',
'76466': 'Olden,TX',
'76467': 'Paluxy,TX',
'76468': 'Proctor,TX',
'76469': 'Putnam,TX',
'76470': 'Ranger,TX',
'76471': 'Rising Star,TX',
'76472': 'Santo,TX',
'76474': 'Sidney,TX',
'76475': 'Strawn,TX',
'76476': 'Tolar,TX',
'76481': 'South Bend,TX',
'76483': 'Throckmorton,TX',
'76484': 'Palo Pinto,TX',
'76485': 'Peaster,TX',
'76486': 'Perrin,TX',
'76487': 'Poolville,TX',
'76490': 'Whitt,TX',
'76491': 'Woodson,TX',
'76501': 'Temple,TX',
'76502': 'Temple,TX',
'76503': 'Temple,TX',
'76504': 'Temple,TX',
'76505': 'Temple,TX',
'76508': 'Temple,TX',
'76511': 'Bartlett,TX',
'76513': 'Belton,TX',
'76518': 'Buckholts,TX',
'76519': 'Burlington,TX',
'76520': 'Cameron,TX',
'76522': 'Copperas Cove,TX',
'76523': 'Davilla,TX',
'76524': 'Eddy,TX',
'76525': 'Evant,TX',
'76526': 'Flat,TX',
'76527': 'Florence,TX',
'76528': 'Gatesville,TX',
'76530': 'Granger,TX',
'76531': 'Hamilton,TX',
'76533': 'Heidenheimer,TX',
'76534': 'Holland,TX',
'76537': 'Jarrell,TX',
'76538': 'Jonesboro,TX',
'76539': 'Kempner,TX',
'76540': 'Killeen,TX',
'76541': 'Killeen,TX',
'76542': 'Killeen,TX',
'76543': 'Killeen,TX',
'76544': 'Killeen,TX',
'76545': 'Killeen,TX',
'76546': 'Killeen,TX',
'76547': 'Killeen,TX',
'76548': 'Harker Heights,TX',
'76549': 'Killeen,TX',
'76550': 'Lampasas,TX',
'76552': 'Leon Junction,TX',
'76554': 'Little River,TX',
'76555': 'Maysfield,TX',
'76556': 'Milano,TX',
'76557': 'Moody,TX',
'76558': 'Mound,TX',
'76559': 'Nolanville,TX',
'76561': 'Oglesby,TX',
'76564': 'Pendleton,TX',
'76565': 'Pottsville,TX',
'76566': 'Purmela,TX',
'76567': 'Rockdale,TX',
'76569': 'Rogers,TX',
'76570': 'Rosebud,TX',
'76571': 'Salado,TX',
'76573': 'Schwertner,TX',
'76574': 'Taylor,TX',
'76577': 'Thorndale,TX',
'76578': 'Thrall,TX',
'76579': 'Troy,TX',
'76596': 'Gatesville,TX',
'76597': 'Gatesville,TX',
'76598': 'Gatesville,TX',
'76599': 'Gatesville,TX',
'76621': 'Abbott,TX',
'76622': 'Aquilla,TX',
'76623': 'Avalon,TX',
'76624': 'Axtell,TX',
'76626': 'Blooming Grove,TX',
'76627': 'Blum,TX',
'76628': 'Brandon,TX',
'76629': 'Bremond,TX',
'76630': 'Bruceville,TX',
'76631': 'Bynum,TX',
'76632': 'Chilton,TX',
'76633': 'China Spring,TX',
'76634': 'Clifton,TX',
'76635': 'Coolidge,TX',
'76636': 'Covington,TX',
'76637': 'Cranfills Gap,TX',
'76638': 'Crawford,TX',
'76639': 'Dawson,TX',
'76640': 'Elm Mott,TX',
'76641': 'Frost,TX',
'76642': 'Groesbeck,TX',
'76643': 'Hewitt,TX',
'76644': 'Laguna Park,TX',
'76645': 'Hillsboro,TX',
'76648': 'Hubbard,TX',
'76649': 'Iredell,TX',
'76650': 'Irene,TX',
'76651': 'Italy,TX',
'76652': 'Kopperl,TX',
'76653': 'Kosse,TX',
'76654': 'Leroy,TX',
'76655': 'Lorena,TX',
'76656': 'Lott,TX',
'76657': 'Mc Gregor,TX',
'76660': 'Malone,TX',
'76661': 'Marlin,TX',
'76664': 'Mart,TX',
'76665': 'Meridian,TX',
'76666': 'Mertens,TX',
'76667': 'Mexia,TX',
'76670': 'Milford,TX',
'76671': 'Morgan,TX',
'76673': 'Mount Calm,TX',
'76675': 'Otto,TX',
'76676': 'Penelope,TX',
'76677': 'Perry,TX',
'76678': 'Prairie Hill,TX',
'76679': 'Purdon,TX',
'76680': 'Reagan,TX',
'76681': 'Richland,TX',
'76682': 'Riesel,TX',
'76684': 'Ross,TX',
'76685': 'Satin,TX',
'76686': 'Tehuacana,TX',
'76687': 'Thornton,TX',
'76689': 'Valley Mills,TX',
'76690': 'Walnut Springs,TX',
'76691': 'West,TX',
'76692': 'Whitney,TX',
'76693': 'Wortham,TX',
'76701': 'Waco,TX',
'76702': 'Waco,TX',
'76703': 'Waco,TX',
'76704': 'Waco,TX',
'76705': 'Waco,TX',
'76706': 'Waco,TX',
'76707': 'Waco,TX',
'76708': 'Waco,TX',
'76710': 'Waco,TX',
'76711': 'Waco,TX',
'76712': 'Woodway,TX',
'76714': 'Waco,TX',
'76715': 'Waco,TX',
'76716': 'Waco,TX',
'76795': 'Waco,TX',
'76797': 'Waco,TX',
'76798': 'Waco,TX',
'76799': 'Waco,TX',
'76801': 'Brownwood,TX',
'76802': 'Early,TX',
'76803': 'Brownwood,TX',
'76804': 'Brownwood,TX',
'76820': 'Art,TX',
'76821': 'Ballinger,TX',
'76823': 'Bangs,TX',
'76824': 'Bend,TX',
'76825': 'Brady,TX',
'76827': 'Brookesmith,TX',
'76828': 'Burkett,TX',
'76831': 'Castell,TX',
'76832': 'Cherokee,TX',
'76834': 'Coleman,TX',
'76836': 'Doole,TX',
'76837': 'Eden,TX',
'76841': 'Fort Mc Kavett,TX',
'76842': 'Fredonia,TX',
'76844': 'Goldthwaite,TX',
'76845': 'Gouldbusk,TX',
'76848': 'Hext,TX',
'76849': 'Junction,TX',
'76852': 'Lohn,TX',
'76853': 'Lometa,TX',
'76854': 'London,TX',
'76855': 'Lowake,TX',
'76856': 'Mason,TX',
'76857': 'May,TX',
'76858': 'Melvin,TX',
'76859': 'Menard,TX',
'76861': 'Miles,TX',
'76862': 'Millersview,TX',
'76864': 'Mullin,TX',
'76865': 'Norton,TX',
'76866': 'Paint Rock,TX',
'76867': 'Pear Valley,TX',
'76869': 'Pontotoc,TX',
'76870': 'Priddy,TX',
'76871': 'Richland Springs,TX',
'76872': 'Rochelle,TX',
'76873': 'Rockwood,TX',
'76874': 'Roosevelt,TX',
'76875': 'Rowena,TX',
'76877': 'San Saba,TX',
'76878': 'Santa Anna,TX',
'76880': 'Star,TX',
'76882': 'Talpa,TX',
'76883': 'Telegraph,TX',
'76884': 'Valera,TX',
'76885': 'Valley Spring,TX',
'76886': 'Veribest,TX',
'76887': 'Voca,TX',
'76888': 'Voss,TX',
'76890': 'Zephyr,TX',
'76901': 'San Angelo,TX',
'76902': 'San Angelo,TX',
'76903': 'San Angelo,TX',
'76904': 'San Angelo,TX',
'76905': 'San Angelo,TX',
'76906': 'San Angelo,TX',
'76908': 'Goodfellow Afb,TX',
'76909': 'San Angelo,TX',
'76930': 'Barnhart,TX',
'76932': 'Big Lake,TX',
'76933': 'Bronte,TX',
'76934': 'Carlsbad,TX',
'76935': 'Christoval,TX',
'76936': 'Eldorado,TX',
'76937': 'Eola,TX',
'76939': 'Knickerbocker,TX',
'76940': 'Mereta,TX',
'76941': 'Mertzon,TX',
'76943': 'Ozona,TX',
'76945': 'Robert Lee,TX',
'76949': 'Silver,TX',
'76950': 'Sonora,TX',
'76951': 'Sterling City,TX',
'76953': 'Tennyson,TX',
'76955': 'Vancourt,TX',
'76957': 'Wall,TX',
'76958': 'Water Valley,TX',
'77001': 'Houston,TX',
'77002': 'Houston,TX',
'77003': 'Houston,TX',
'77004': 'Houston,TX',
'77005': 'Houston,TX',
'77006': 'Houston,TX',
'77007': 'Houston,TX',
'77008': 'Houston,TX',
'77009': 'Houston,TX',
'77010': 'Houston,TX',
'77011': 'Houston,TX',
'77012': 'Houston,TX',
'77013': 'Houston,TX',
'77014': 'Houston,TX',
'77015': 'Houston,TX',
'77016': 'Houston,TX',
'77017': 'Houston,TX',
'77018': 'Houston,TX',
'77019': 'Houston,TX',
'77020': 'Houston,TX',
'77021': 'Houston,TX',
'77022': 'Houston,TX',
'77023': 'Houston,TX',
'77024': 'Houston,TX',
'77025': 'Houston,TX',
'77026': 'Houston,TX',
'77027': 'Houston,TX',
'77028': 'Houston,TX',
'77029': 'Houston,TX',
'77030': 'Houston,TX',
'77031': 'Houston,TX',
'77032': 'Houston,TX',
'77033': 'Houston,TX',
'77034': 'Houston,TX',
'77035': 'Houston,TX',
'77036': 'Houston,TX',
'77037': 'Houston,TX',
'77038': 'Houston,TX',
'77039': 'Houston,TX',
'77040': 'Houston,TX',
'77041': 'Houston,TX',
'77042': 'Houston,TX',
'77043': 'Houston,TX',
'77044': 'Houston,TX',
'77045': 'Houston,TX',
'77046': 'Houston,TX',
'77047': 'Houston,TX',
'77048': 'Houston,TX',
'77049': 'Houston,TX',
'77050': 'Houston,TX',
'77051': 'Houston,TX',
'77052': 'Houston,TX',
'77053': 'Houston,TX',
'77054': 'Houston,TX',
'77055': 'Houston,TX',
'77056': 'Houston,TX',
'77057': 'Houston,TX',
'77058': 'Houston,TX',
'77059': 'Houston,TX',
'77060': 'Houston,TX',
'77061': 'Houston,TX',
'77062': 'Houston,TX',
'77063': 'Houston,TX',
'77064': 'Houston,TX',
'77065': 'Houston,TX',
'77066': 'Houston,TX',
'77067': 'Houston,TX',
'77068': 'Houston,TX',
'77069': 'Houston,TX',
'77070': 'Houston,TX',
'77071': 'Houston,TX',
'77072': 'Houston,TX',
'77073': 'Houston,TX',
'77074': 'Houston,TX',
'77075': 'Houston,TX',
'77076': 'Houston,TX',
'77077': 'Houston,TX',
'77078': 'Houston,TX',
'77079': 'Houston,TX',
'77080': 'Houston,TX',
'77081': 'Houston,TX',
'77082': 'Houston,TX',
'77083': 'Houston,TX',
'77084': 'Houston,TX',
'77085': 'Houston,TX',
'77086': 'Houston,TX',
'77087': 'Houston,TX',
'77088': 'Houston,TX',
'77089': 'Houston,TX',
'77090': 'Houston,TX',
'77091': 'Houston,TX',
'77092': 'Houston,TX',
'77093': 'Houston,TX',
'77094': 'Houston,TX',
'77095': 'Houston,TX',
'77096': 'Houston,TX',
'77097': 'Houston,TX',
'77098': 'Houston,TX',
'77099': 'Houston,TX',
'77201': 'Houston,TX',
'77202': 'Houston,TX',
'77203': 'Houston,TX',
'77204': 'Houston,TX',
'77205': 'Houston,TX',
'77206': 'Houston,TX',
'77207': 'Houston,TX',
'77208': 'Houston,TX',
'77209': 'Houston,TX',
'77210': 'Houston,TX',
'77212': 'Houston,TX',
'77213': 'Houston,TX',
'77215': 'Houston,TX',
'77216': 'Houston,TX',
'77217': 'Houston,TX',
'77218': 'Houston,TX',
'77219': 'Houston,TX',
'77220': 'Houston,TX',
'77221': 'Houston,TX',
'77222': 'Houston,TX',
'77223': 'Houston,TX',
'77224': 'Houston,TX',
'77225': 'Houston,TX',
'77226': 'Houston,TX',
'77227': 'Houston,TX',
'77228': 'Houston,TX',
'77229': 'Houston,TX',
'77230': 'Houston,TX',
'77231': 'Houston,TX',
'77233': 'Houston,TX',
'77234': 'Houston,TX',
'77235': 'Houston,TX',
'77236': 'Houston,TX',
'77237': 'Houston,TX',
'77238': 'Houston,TX',
'77240': 'Houston,TX',
'77241': 'Houston,TX',
'77242': 'Houston,TX',
'77243': 'Houston,TX',
'77244': 'Houston,TX',
'77245': 'Houston,TX',
'77246': 'Houston,TX',
'77247': 'Houston,TX',
'77248': 'Houston,TX',
'77249': 'Houston,TX',
'77250': 'Houston,TX',
'77251': 'Houston,TX',
'77252': 'Houston,TX',
'77253': 'Houston,TX',
'77254': 'Houston,TX',
'77255': 'Houston,TX',
'77256': 'Houston,TX',
'77257': 'Houston,TX',
'77258': 'Houston,TX',
'77259': 'Houston,TX',
'77260': 'Houston,TX',
'77261': 'Houston,TX',
'77262': 'Houston,TX',
'77263': 'Houston,TX',
'77265': 'Houston,TX',
'77266': 'Houston,TX',
'77267': 'Houston,TX',
'77268': 'Houston,TX',
'77269': 'Houston,TX',
'77270': 'Houston,TX',
'77271': 'Houston,TX',
'77272': 'Houston,TX',
'77273': 'Houston,TX',
'77274': 'Houston,TX',
'77275': 'Houston,TX',
'77276': 'Houston,TX',
'77277': 'Houston,TX',
'77278': 'Houston,TX',
'77279': 'Houston,TX',
'77280': 'Houston,TX',
'77281': 'Houston,TX',
'77282': 'Houston,TX',
'77284': 'Houston,TX',
'77285': 'Houston,TX',
'77286': 'Houston,TX',
'77287': 'Houston,TX',
'77288': 'Houston,TX',
'77289': 'Houston,TX',
'77290': 'Houston,TX',
'77291': 'Houston,TX',
'77292': 'Houston,TX',
'77293': 'Houston,TX',
'77294': 'Houston,TX',
'77296': 'Houston,TX',
'77297': 'Houston,TX',
'77298': 'Houston,TX',
'77299': 'Houston,TX',
'77301': 'Conroe,TX',
'77302': 'Conroe,TX',
'77303': 'Conroe,TX',
'77304': 'Conroe,TX',
'77305': 'Conroe,TX',
'77306': 'Conroe,TX',
'77315': 'North Houston,TX',
'77316': 'Montgomery,TX',
'77318': 'Willis,TX',
'77320': 'Huntsville,TX',
'77325': 'Humble,TX',
'77326': 'Ace,TX',
'77327': 'Cleveland,TX',
'77328': 'Cleveland,TX',
'77331': 'Coldspring,TX',
'77332': 'Dallardsville,TX',
'77333': 'Dobbin,TX',
'77334': 'Dodge,TX',
'77335': 'Goodrich,TX',
'77336': 'Huffman,TX',
'77337': 'Hufsmith,TX',
'77338': 'Humble,TX',
'77339': 'Humble,TX',
'77340': 'Huntsville,TX',
'77341': 'Huntsville,TX',
'77342': 'Huntsville,TX',
'77343': 'Huntsville,TX',
'77344': 'Huntsville,TX',
'77345': 'Humble,TX',
'77346': 'Humble,TX',
'77347': 'Humble,TX',
'77348': 'Huntsville,TX',
'77349': 'Huntsville,TX',
'77350': 'Leggett,TX',
'77351': 'Livingston,TX',
'77353': 'Magnolia,TX',
'77354': 'Magnolia,TX',
'77355': 'Magnolia,TX',
'77356': 'Montgomery,TX',
'77357': 'New Caney,TX',
'77358': 'New Waverly,TX',
'77359': 'Oakhurst,TX',
'77360': 'Onalaska,TX',
'77362': 'Pinehurst,TX',
'77363': 'Plantersville,TX',
'77364': 'Pointblank,TX',
'77365': 'Porter,TX',
'77367': 'Riverside,TX',
'77368': 'Romayor,TX',
'77369': 'Rye,TX',
'77371': 'Shepherd,TX',
'77372': 'Splendora,TX',
'77373': 'Spring,TX',
'77374': 'Thicket,TX',
'77375': 'Tomball,TX',
'77376': 'Votaw,TX',
'77377': 'Tomball,TX',
'77378': 'Willis,TX',
'77379': 'Spring,TX',
'77380': 'Spring,TX',
'77381': 'Spring,TX',
'77382': 'Spring,TX',
'77383': 'Spring,TX',
'77384': 'Conroe,TX',
'77385': 'Conroe,TX',
'77386': 'Spring,TX',
'77387': 'Spring,TX',
'77388': 'Spring,TX',
'77389': 'Spring,TX',
'77391': 'Spring,TX',
'77393': 'Spring,TX',
'77396': 'Humble,TX',
'77399': 'Livingston,TX',
'77401': 'Bellaire,TX',
'77402': 'Bellaire,TX',
'77404': 'Bay City,TX',
'77406': 'Richmond,TX',
'77407': 'Richmond,TX',
'77410': 'Cypress,TX',
'77411': 'Alief,TX',
'77412': 'Altair,TX',
'77413': 'Barker,TX',
'77414': 'Bay City,TX',
'77415': 'Cedar Lane,TX',
'77417': 'Beasley,TX',
'77418': 'Bellville,TX',
'77419': 'Blessing,TX',
'77420': 'Boling,TX',
'77422': 'Brazoria,TX',
'77423': 'Brookshire,TX',
'77426': 'Chappell Hill,TX',
'77428': 'Collegeport,TX',
'77429': 'Cypress,TX',
'77430': 'Damon,TX',
'77431': 'Danciger,TX',
'77432': 'Danevang,TX',
'77433': 'Cypress,TX',
'77434': 'Eagle Lake,TX',
'77435': 'East Bernard,TX',
'77436': 'Egypt,TX',
'77437': 'El Campo,TX',
'77440': 'Elmaton,TX',
'77441': 'Fulshear,TX',
'77442': 'Garwood,TX',
'77443': 'Glen Flora,TX',
'77444': 'Guy,TX',
'77445': 'Hempstead,TX',
'77446': 'Prairie View,TX',
'77447': 'Hockley,TX',
'77448': 'Hungerford,TX',
'77449': 'Katy,TX',
'77450': 'Katy,TX',
'77451': 'Kendleton,TX',
'77452': 'Kenney,TX',
'77453': 'Lane City,TX',
'77454': 'Lissie,TX',
'77455': 'Louise,TX',
'77456': 'Markham,TX',
'77457': 'Matagorda,TX',
'77458': 'Midfield,TX',
'77459': 'Missouri City,TX',
'77460': 'Nada,TX',
'77461': 'Needville,TX',
'77462': 'Newgulf,TX',
'77463': 'Old Ocean,TX',
'77464': 'Orchard,TX',
'77465': 'Palacios,TX',
'77466': 'Pattison,TX',
'77467': 'Pierce,TX',
'77468': 'Pledger,TX',
'77469': 'Richmond,TX',
'77470': 'Rock Island,TX',
'77471': 'Rosenberg,TX',
'77473': 'San Felipe,TX',
'77474': 'Sealy,TX',
'77475': 'Sheridan,TX',
'77476': 'Simonton,TX',
'77477': 'Stafford,TX',
'77478': 'Sugar Land,TX',
'77479': 'Sugar Land,TX',
'77480': 'Sweeny,TX',
'77481': 'Thompsons,TX',
'77482': 'Van Vleck,TX',
'77483': 'Wadsworth,TX',
'77484': 'Waller,TX',
'77485': 'Wallis,TX',
'77486': 'West Columbia,TX',
'77487': 'Sugar Land,TX',
'77488': 'Wharton,TX',
'77489': 'Missouri City,TX',
'77491': 'Katy,TX',
'77492': 'Katy,TX',
'77493': 'Katy,TX',
'77494': 'Katy,TX',
'77496': 'Sugar Land,TX',
'77497': 'Stafford,TX',
'77498': 'Sugarland,TX',
'77501': 'Pasadena,TX',
'77502': 'Pasadena,TX',
'77503': 'Pasadena,TX',
'77504': 'Pasadena,TX',
'77505': 'Pasadena,TX',
'77506': 'Pasadena,TX',
'77507': 'Pasadena,TX',
'77508': 'Pasadena,TX',
'77510': 'Santa Fe,TX',
'77511': 'Alvin,TX',
'77512': 'Alvin,TX',
'77514': 'Anahuac,TX',
'77515': 'Angleton,TX',
'77516': 'Angleton,TX',
'77517': 'Santa Fe,TX',
'77518': 'Bacliff,TX',
'77519': 'Batson,TX',
'77520': 'Baytown,TX',
'77521': 'Baytown,TX',
'77522': 'Baytown,TX',
'77523': 'Baytown,TX',
'77530': 'Channelview,TX',
'77531': 'Clute,TX',
'77532': 'Crosby,TX',
'77533': 'Daisetta,TX',
'77534': 'Danbury,TX',
'77535': 'Dayton,TX',
'77536': 'Deer Park,TX',
'77538': 'Devers,TX',
'77539': 'Dickinson,TX',
'77541': 'Freeport,TX',
'77542': 'Freeport,TX',
'77545': 'Fresno,TX',
'77546': 'Friendswood,TX',
'77547': 'Galena Park,TX',
'77549': 'Friendswood,TX',
'77550': 'Galveston,TX',
'77551': 'Galveston,TX',
'77552': 'Galveston,TX',
'77553': 'Galveston,TX',
'77554': 'Galveston,TX',
'77555': 'Galveston,TX',
'77560': 'Hankamer,TX',
'77561': 'Hardin,TX',
'77562': 'Highlands,TX',
'77563': 'Hitchcock,TX',
'77564': 'Hull,TX',
'77565': 'Kemah,TX',
'77566': 'Lake Jackson,TX',
'77568': 'La Marque,TX',
'77571': 'La Porte,TX',
'77572': 'La Porte,TX',
'77573': 'League City,TX',
'77574': 'League City,TX',
'77575': 'Liberty,TX',
'77577': 'Liverpool,TX',
'77578': 'Manvel,TX',
'77580': 'Mont Belvieu,TX',
'77581': 'Pearland,TX',
'77582': 'Raywood,TX',
'77583': 'Rosharon,TX',
'77584': 'Pearland,TX',
'77585': 'Saratoga,TX',
'77586': 'Seabrook,TX',
'77587': 'South Houston,TX',
'77588': 'Pearland,TX',
'77590': 'Texas City,TX',
'77591': 'Texas City,TX',
'77592': 'Texas City,TX',
'77597': 'Wallisville,TX',
'77598': 'Webster,TX',
'77611': 'Bridge City,TX',
'77612': 'Buna,TX',
'77613': 'China,TX',
'77614': 'Deweyville,TX',
'77615': 'Evadale,TX',
'77616': 'Fred,TX',
'77617': 'Gilchrist,TX',
'77619': 'Groves,TX',
'77622': 'Hamshire,TX',
'77623': 'High Island,TX',
'77624': 'Hillister,TX',
'77625': 'Kountze,TX',
'77626': 'Mauriceville,TX',
'77627': 'Nederland,TX',
'77629': 'Nome,TX',
'77630': 'Orange,TX',
'77631': 'Orange,TX',
'77632': 'Orange,TX',
'77639': 'Orangefield,TX',
'77640': 'Port Arthur,TX',
'77641': 'Port Arthur,TX',
'77642': 'Port Arthur,TX',
'77643': 'Port Arthur,TX',
'77650': 'Port Bolivar,TX',
'77651': 'Port Neches,TX',
'77655': 'Sabine Pass,TX',
'77656': 'Silsbee,TX',
'77657': 'Lumberton,TX',
'77659': 'Sour Lake,TX',
'77660': 'Spurger,TX',
'77661': 'Stowell,TX',
'77662': 'Vidor,TX',
'77663': 'Village Mills,TX',
'77664': 'Warren,TX',
'77665': 'Winnie,TX',
'77670': 'Vidor,TX',
'77701': 'Beaumont,TX',
'77702': 'Beaumont,TX',
'77703': 'Beaumont,TX',
'77704': 'Beaumont,TX',
'77705': 'Beaumont,TX',
'77706': 'Beaumont,TX',
'77707': 'Beaumont,TX',
'77708': 'Beaumont,TX',
'77709': 'Voth,TX',
'77710': 'Beaumont,TX',
'77713': 'Beaumont,TX',
'77720': 'Beaumont,TX',
'77725': 'Beaumont,TX',
'77726': 'Beaumont,TX',
'77801': 'Bryan,TX',
'77802': 'Bryan,TX',
'77803': 'Bryan,TX',
'77805': 'Bryan,TX',
'77806': 'Bryan,TX',
'77807': 'Bryan,TX',
'77808': 'Bryan,TX',
'77830': 'Anderson,TX',
'77831': 'Bedias,TX',
'77833': 'Brenham,TX',
'77834': 'Brenham,TX',
'77835': 'Burton,TX',
'77836': 'Caldwell,TX',
'77837': 'Calvert,TX',
'77838': 'Chriesman,TX',
'77839': 'Clay,TX',
'77840': 'College Station,TX',
'77841': 'College Station,TX',
'77842': 'College Station,TX',
'77843': 'College Station,TX',
'77844': 'College Station,TX',
'77845': 'College Station,TX',
'77850': 'Concord,TX',
'77852': 'Deanville,TX',
'77853': 'Dime Box,TX',
'77855': 'Flynn,TX',
'77856': 'Franklin,TX',
'77857': 'Gause,TX',
'77859': 'Hearne,TX',
'77861': 'Iola,TX',
'77862': 'Kurten,TX',
'77863': 'Lyons,TX',
'77864': 'Madisonville,TX',
'77865': 'Marquez,TX',
'77866': 'Millican,TX',
'77867': 'Mumford,TX',
'77868': 'Navasota,TX',
'77869': 'Navasota,TX',
'77870': 'New Baden,TX',
'77871': 'Normangee,TX',
'77872': 'North Zulch,TX',
'77873': 'Richards,TX',
'77875': 'Roans Prairie,TX',
'77876': 'Shiro,TX',
'77878': 'Snook,TX',
'77879': 'Somerville,TX',
'77880': 'Washington,TX',
'77881': 'Wellborn,TX',
'77882': 'Wheelock,TX',
'77901': 'Victoria,TX',
'77902': 'Victoria,TX',
'77903': 'Victoria,TX',
'77904': 'Victoria,TX',
'77905': 'Victoria,TX',
'77950': 'Austwell,TX',
'77951': 'Bloomington,TX',
'77954': 'Cuero,TX',
'77957': 'Edna,TX',
'77960': 'Fannin,TX',
'77961': 'Francitas,TX',
'77962': 'Ganado,TX',
'77963': 'Goliad,TX',
'77964': 'Hallettsville,TX',
'77967': 'Hochheim,TX',
'77968': 'Inez,TX',
'77969': 'La Salle,TX',
'77970': 'La Ward,TX',
'77971': 'Lolita,TX',
'77972': 'Long Mott,TX',
'77973': 'Mcfaddin,TX',
'77974': 'Meyersville,TX',
'77975': 'Moulton,TX',
'77976': 'Nursery,TX',
'77977': 'Placedo,TX',
'77978': 'Point Comfort,TX',
'77979': 'Port Lavaca,TX',
'77982': 'Port O Connor,TX',
'77983': 'Seadrift,TX',
'77984': 'Shiner,TX',
'77985': 'Speaks,TX',
'77986': 'Sublime,TX',
'77987': 'Sweet Home,TX',
'77988': 'Telferner,TX',
'77989': 'Thomaston,TX',
'77990': 'Tivoli,TX',
'77991': 'Vanderbilt,TX',
'77993': 'Weesatche,TX',
'77994': 'Westhoff,TX',
'77995': 'Yoakum,TX',
'78001': 'Artesia Wells,TX',
'78002': 'Atascosa,TX',
'78003': 'Bandera,TX',
'78004': 'Bergheim,TX',
'78005': 'Bigfoot,TX',
'78006': 'Boerne,TX',
'78007': 'Calliham,TX',
'78008': 'Campbellton,TX',
'78009': 'Castroville,TX',
'78010': 'Center Point,TX',
'78011': 'Charlotte,TX',
'78012': 'Christine,TX',
'78013': 'Comfort,TX',
'78014': 'Cotulla,TX',
'78015': 'Boerne,TX',
'78016': 'Devine,TX',
'78017': 'Dilley,TX',
'78019': 'Encinal,TX',
'78021': 'Fowlerton,TX',
'78022': 'George West,TX',
'78023': 'Helotes,TX',
'78024': 'Hunt,TX',
'78025': 'Ingram,TX',
'78026': 'Jourdanton,TX',
'78027': 'Kendalia,TX',
'78028': 'Kerrville,TX',
'78029': 'Kerrville,TX',
'78039': 'La Coste,TX',
'78040': 'Laredo,TX',
'78041': 'Laredo,TX',
'78042': 'Laredo,TX',
'78043': 'Laredo,TX',
'78044': 'Laredo,TX',
'78045': 'Laredo,TX',
'78046': 'Laredo,TX',
'78049': 'Laredo,TX',
'78050': 'Leming,TX',
'78052': 'Lytle,TX',
'78053': 'Mc Coy,TX',
'78054': 'Macdona,TX',
'78055': 'Medina,TX',
'78056': 'Mico,TX',
'78057': 'Moore,TX',
'78058': 'Mountain Home,TX',
'78059': 'Natalia,TX',
'78060': 'Oakville,TX',
'78061': 'Pearsall,TX',
'78062': 'Peggy,TX',
'78063': 'Pipe Creek,TX',
'78064': 'Pleasanton,TX',
'78065': 'Poteet,TX',
'78066': 'Rio Medina,TX',
'78067': 'San Ygnacio,TX',
'78069': 'Somerset,TX',
'78070': 'Spring Branch,TX',
'78071': 'Three Rivers,TX',
'78072': 'Tilden,TX',
'78073': 'Von Ormy,TX',
'78074': 'Waring,TX',
'78075': 'Whitsett,TX',
'78076': 'Zapata,TX',
'78101': 'Adkins,TX',
'78102': 'Beeville,TX',
'78104': 'Beeville,TX',
'78107': 'Berclair,TX',
'78108': 'Cibolo,TX',
'78109': 'Converse,TX',
'78111': 'Ecleto,TX',
'78112': 'Elmendorf,TX',
'78113': 'Falls City,TX',
'78114': 'Floresville,TX',
'78115': 'Geronimo,TX',
'78116': 'Gillett,TX',
'78117': 'Hobson,TX',
'78118': 'Karnes City,TX',
'78119': 'Kenedy,TX',
'78121': 'La Vernia,TX',
'78122': 'Leesville,TX',
'78123': 'Mc Queeney,TX',
'78124': 'Marion,TX',
'78125': 'Mineral,TX',
'78130': 'New Braunfels,TX',
'78131': 'New Braunfels,TX',
'78132': 'New Braunfels,TX',
'78133': 'Canyon Lake,TX',
'78135': 'New Braunfels,TX',
'78140': 'Nixon,TX',
'78141': 'Nordheim,TX',
'78142': 'Normanna,TX',
'78143': 'Pandora,TX',
'78144': 'Panna Maria,TX',
'78145': 'Pawnee,TX',
'78146': 'Pettus,TX',
'78147': 'Poth,TX',
'78148': 'Universal City,TX',
'78150': 'Universal City,TX',
'78151': 'Runge,TX',
'78152': 'Saint Hedwig,TX',
'78154': 'Schertz,TX',
'78155': 'Seguin,TX',
'78156': 'Seguin,TX',
'78159': 'Smiley,TX',
'78160': 'Stockdale,TX',
'78161': 'Sutherland Springs,TX',
'78162': 'Tuleta,TX',
'78163': 'Bulverde,TX',
'78164': 'Yorktown,TX',
'78201': 'San Antonio,TX',
'78202': 'San Antonio,TX',
'78203': 'San Antonio,TX',
'78204': 'San Antonio,TX',
'78205': 'San Antonio,TX',
'78206': 'San Antonio,TX',
'78207': 'San Antonio,TX',
'78208': 'San Antonio,TX',
'78209': 'San Antonio,TX',
'78210': 'San Antonio,TX',
'78211': 'San Antonio,TX',
'78212': 'San Antonio,TX',
'78213': 'San Antonio,TX',
'78214': 'San Antonio,TX',
'78215': 'San Antonio,TX',
'78216': 'San Antonio,TX',
'78217': 'San Antonio,TX',
'78218': 'San Antonio,TX',
'78219': 'San Antonio,TX',
'78220': 'San Antonio,TX',
'78221': 'San Antonio,TX',
'78222': 'San Antonio,TX',
'78223': 'San Antonio,TX',
'78224': 'San Antonio,TX',
'78225': 'San Antonio,TX',
'78226': 'San Antonio,TX',
'78227': 'San Antonio,TX',
'78228': 'San Antonio,TX',
'78229': 'San Antonio,TX',
'78230': 'San Antonio,TX',
'78231': 'San Antonio,TX',
'78232': 'San Antonio,TX',
'78233': 'San Antonio,TX',
'78234': 'San Antonio,TX',
'78235': 'San Antonio,TX',
'78236': 'San Antonio,TX',
'78237': 'San Antonio,TX',
'78238': 'San Antonio,TX',
'78239': 'San Antonio,TX',
'78240': 'San Antonio,TX',
'78241': 'San Antonio,TX',
'78242': 'San Antonio,TX',
'78243': 'San Antonio,TX',
'78244': 'San Antonio,TX',
'78245': 'San Antonio,TX',
'78246': 'San Antonio,TX',
'78247': 'San Antonio,TX',
'78248': 'San Antonio,TX',
'78249': 'San Antonio,TX',
'78250': 'San Antonio,TX',
'78251': 'San Antonio,TX',
'78252': 'San Antonio,TX',
'78253': 'San Antonio,TX',
'78254': 'San Antonio,TX',
'78255': 'San Antonio,TX',
'78256': 'San Antonio,TX',
'78257': 'San Antonio,TX',
'78258': 'San Antonio,TX',
'78259': 'San Antonio,TX',
'78260': 'San Antonio,TX',
'78261': 'San Antonio,TX',
'78262': 'San Antonio,TX',
'78263': 'San Antonio,TX',
'78264': 'San Antonio,TX',
'78265': 'San Antonio,TX',
'78266': 'San Antonio,TX',
'78268': 'San Antonio,TX',
'78269': 'San Antonio,TX',
'78270': 'San Antonio,TX',
'78275': 'San Antonio,TX',
'78278': 'San Antonio,TX',
'78279': 'San Antonio,TX',
'78280': 'San Antonio,TX',
'78283': 'San Antonio,TX',
'78284': 'San Antonio,TX',
'78285': 'San Antonio,TX',
'78286': 'San Antonio,TX',
'78287': 'San Antonio,TX',
'78288': 'San Antonio,TX',
'78289': 'San Antonio,TX',
'78291': 'San Antonio,TX',
'78292': 'San Antonio,TX',
'78293': 'San Antonio,TX',
'78294': 'San Antonio,TX',
'78295': 'San Antonio,TX',
'78296': 'San Antonio,TX',
'78297': 'San Antonio,TX',
'78298': 'San Antonio,TX',
'78299': 'San Antonio,TX',
'78330': 'Agua Dulce,TX',
'78332': 'Alice,TX',
'78333': 'Alice,TX',
'78335': 'Aransas Pass,TX',
'78336': 'Aransas Pass,TX',
'78338': 'Armstrong,TX',
'78339': 'Banquete,TX',
'78340': 'Bayside,TX',
'78341': 'Benavides,TX',
'78342': 'Ben Bolt,TX',
'78343': 'Bishop,TX',
'78344': 'Bruni,TX',
'78347': 'Chapman Ranch,TX',
'78349': 'Concepcion,TX',
'78350': 'Dinero,TX',
'78351': 'Driscoll,TX',
'78352': 'Edroy,TX',
'78353': 'Encino,TX',
'78355': 'Falfurrias,TX',
'78357': 'Freer,TX',
'78358': 'Fulton,TX',
'78359': 'Gregory,TX',
'78360': 'Guerra,TX',
'78361': 'Hebbronville,TX',
'78362': 'Ingleside,TX',
'78363': 'Kingsville,TX',
'78364': 'Kingsville,TX',
'78368': 'Mathis,TX',
'78369': 'Mirando City,TX',
'78370': 'Odem,TX',
'78371': 'Oilton,TX',
'78372': 'Orange Grove,TX',
'78373': 'Port Aransas,TX',
'78374': 'Portland,TX',
'78375': 'Premont,TX',
'78376': 'Realitos,TX',
'78377': 'Refugio,TX',
'78379': 'Riviera,TX',
'78380': 'Robstown,TX',
'78381': 'Rockport,TX',
'78382': 'Rockport,TX',
'78383': 'Sandia,TX',
'78384': 'San Diego,TX',
'78385': 'Sarita,TX',
'78387': 'Sinton,TX',
'78389': 'Skidmore,TX',
'78390': 'Taft,TX',
'78391': 'Tynan,TX',
'78393': 'Woodsboro,TX',
'78401': 'Corpus Christi,TX',
'78402': 'Corpus Christi,TX',
'78403': 'Corpus Christi,TX',
'78404': 'Corpus Christi,TX',
'78405': 'Corpus Christi,TX',
'78406': 'Corpus Christi,TX',
'78407': 'Corpus Christi,TX',
'78408': 'Corpus Christi,TX',
'78409': 'Corpus Christi,TX',
'78410': 'Corpus Christi,TX',
'78411': 'Corpus Christi,TX',
'78412': 'Corpus Christi,TX',
'78413': 'Corpus Christi,TX',
'78414': 'Corpus Christi,TX',
'78415': 'Corpus Christi,TX',
'78416': 'Corpus Christi,TX',
'78417': 'Corpus Christi,TX',
'78418': 'Corpus Christi,TX',
'78419': 'Corpus Christi,TX',
'78426': 'Corpus Christi,TX',
'78427': 'Corpus Christi,TX',
'78460': 'Corpus Christi,TX',
'78461': 'Corpus Christi,TX',
'78463': 'Corpus Christi,TX',
'78465': 'Corpus Christi,TX',
'78466': 'Corpus Christi,TX',
'78467': 'Corpus Christi,TX',
'78468': 'Corpus Christi,TX',
'78469': 'Corpus Christi,TX',
'78470': 'Corpus Christi,TX',
'78471': 'Corpus Christi,TX',
'78472': 'Corpus Christi,TX',
'78473': 'Corpus Christi,TX',
'78474': 'Corpus Christi,TX',
'78475': 'Corpus Christi,TX',
'78476': 'Corpus Christi,TX',
'78477': 'Corpus Christi,TX',
'78478': 'Corpus Christi,TX',
'78480': 'Corpus Christi,TX',
'78501': 'Mcallen,TX',
'78502': 'Mcallen,TX',
'78503': 'Mcallen,TX',
'78504': 'Mcallen,TX',
'78505': 'Mcallen,TX',
'78516': 'Alamo,TX',
'78520': 'Brownsville,TX',
'78521': 'Brownsville,TX',
'78522': 'Brownsville,TX',
'78523': 'Brownsville,TX',
'78526': 'Brownsville,TX',
'78535': 'Combes,TX',
'78536': 'Delmita,TX',
'78537': 'Donna,TX',
'78538': 'Edcouch,TX',
'78539': 'Edinburg,TX',
'78540': 'Edinburg,TX',
'78542': 'Edinburg,TX',
'78543': 'Elsa,TX',
'78545': 'Falcon Heights,TX',
'78547': 'Garciasville,TX',
'78548': 'Grulla,TX',
'78549': 'Hargill,TX',
'78550': 'Harlingen,TX',
'78551': 'Harlingen,TX',
'78552': 'Harlingen,TX',
'78553': 'Harlingen,TX',
'78557': 'Hidalgo,TX',
'78558': 'La Blanca,TX',
'78559': 'La Feria,TX',
'78560': 'La Joya,TX',
'78561': 'Lasara,TX',
'78562': 'La Villa,TX',
'78563': 'Linn,TX',
'78564': 'Lopeno,TX',
'78565': 'Los Ebanos,TX',
'78566': 'Los Fresnos,TX',
'78567': 'Los Indios,TX',
'78568': 'Lozano,TX',
'78569': 'Lyford,TX',
'78570': 'Mercedes,TX',
'78572': 'Mission,TX',
'78573': 'Mission,TX',
'78574': 'Palmview,TX',
'78575': 'Olmito,TX',
'78576': 'Penitas,TX',
'78577': 'Pharr,TX',
'78578': 'Port Isabel,TX',
'78579': 'Progreso,TX',
'78580': 'Raymondville,TX',
'78582': 'Rio Grande City,TX',
'78583': 'Rio Hondo,TX',
'78584': 'Roma,TX',
'78585': 'Salineno,TX',
'78586': 'San Benito,TX',
'78588': 'San Isidro,TX',
'78589': 'San Juan,TX',
'78590': 'San Perlita,TX',
'78591': 'Santa Elena,TX',
'78592': 'Santa Maria,TX',
'78593': 'Santa Rosa,TX',
'78594': 'Sebastian,TX',
'78595': 'Sullivan City,TX',
'78596': 'Weslaco,TX',
'78597': 'South Padre Island,TX',
'78598': 'Port Mansfield,TX',
'78599': 'Weslaco,TX',
'78602': 'Bastrop,TX',
'78603': 'Bebe,TX',
'78604': 'Belmont,TX',
'78605': 'Bertram,TX',
'78606': 'Blanco,TX',
'78607': 'Bluffton,TX',
'78608': 'Briggs,TX',
'78609': 'Buchanan Dam,TX',
'78610': 'Buda,TX',
'78611': 'Burnet,TX',
'78612': 'Cedar Creek,TX',
'78613': 'Cedar Park,TX',
'78614': 'Cost,TX',
'78615': 'Coupland,TX',
'78616': 'Dale,TX',
'78617': 'Del Valle,TX',
'78618': 'Doss,TX',
'78619': 'Driftwood,TX',
'78620': 'Dripping Springs,TX',
'78621': 'Elgin,TX',
'78622': 'Fentress,TX',
'78623': 'Fischer,TX',
'78624': 'Fredericksburg,TX',
'78626': 'Georgetown,TX',
'78627': 'Georgetown,TX',
'78628': 'Georgetown,TX',
'78629': 'Gonzales,TX',
'78630': 'Cedar Park,TX',
'78631': 'Harper,TX',
'78632': 'Harwood,TX',
'78633': 'Georgetown,TX',
'78634': 'Hutto,TX',
'78635': 'Hye,TX',
'78636': 'Johnson City,TX',
'78638': 'Kingsbury,TX',
'78639': 'Kingsland,TX',
'78640': 'Kyle,TX',
'78641': 'Leander,TX',
'78642': 'Liberty Hill,TX',
'78643': 'Llano,TX',
'78644': 'Lockhart,TX',
'78645': 'Leander,TX',
'78646': 'Leander,TX',
'78648': 'Luling,TX',
'78650': 'Mc Dade,TX',
'78651': 'Mc Neil,TX',
'78652': 'Manchaca,TX',
'78653': 'Manor,TX',
'78654': 'Marble Falls,TX',
'78655': 'Martindale,TX',
'78656': 'Maxwell,TX',
'78657': 'Marble Falls,TX',
'78658': 'Ottine,TX',
'78659': 'Paige,TX',
'78660': 'Pflugerville,TX',
'78661': 'Prairie Lea,TX',
'78662': 'Red Rock,TX',
'78663': 'Round Mountain,TX',
'78664': 'Round Rock,TX',
'78665': 'Sandy,TX',
'78666': 'San Marcos,TX',
'78667': 'San Marcos,TX',
'78669': 'Spicewood,TX',
'78670': 'Staples,TX',
'78671': 'Stonewall,TX',
'78672': 'Tow,TX',
'78673': 'Walburg,TX',
'78674': 'Weir,TX',
'78675': 'Willow City,TX',
'78676': 'Wimberley,TX',
'78677': 'Wrightsboro,TX',
'78680': 'Round Rock,TX',
'78681': 'Round Rock,TX',
'78682': 'Round Rock,TX',
'78683': 'Round Rock,TX',
'78691': 'Pflugerville,TX',
'78701': 'Austin,TX',
'78702': 'Austin,TX',
'78703': 'Austin,TX',
'78704': 'Austin,TX',
'78705': 'Austin,TX',
'78708': 'Austin,TX',
'78709': 'Austin,TX',
'78710': 'Austin,TX',
'78711': 'Austin,TX',
'78712': 'Austin,TX',
'78713': 'Austin,TX',
'78714': 'Austin,TX',
'78715': 'Austin,TX',
'78716': 'Austin,TX',
'78717': 'Austin,TX',
'78718': 'Austin,TX',
'78719': 'Austin,TX',
'78720': 'Austin,TX',
'78721': 'Austin,TX',
'78722': 'Austin,TX',
'78723': 'Austin,TX',
'78724': 'Austin,TX',
'78725': 'Austin,TX',
'78726': 'Austin,TX',
'78727': 'Austin,TX',
'78728': 'Austin,TX',
'78729': 'Austin,TX',
'78730': 'Austin,TX',
'78731': 'Austin,TX',
'78732': 'Austin,TX',
'78733': 'Austin,TX',
'78734': 'Austin,TX',
'78735': 'Austin,TX',
'78736': 'Austin,TX',
'78737': 'Austin,TX',
'78738': 'Austin,TX',
'78739': 'Austin,TX',
'78741': 'Austin,TX',
'78742': 'Austin,TX',
'78744': 'Austin,TX',
'78745': 'Austin,TX',
'78746': 'Austin,TX',
'78747': 'Austin,TX',
'78748': 'Austin,TX',
'78749': 'Austin,TX',
'78750': 'Austin,TX',
'78751': 'Austin,TX',
'78752': 'Austin,TX',
'78753': 'Austin,TX',
'78754': 'Austin,TX',
'78755': 'Austin,TX',
'78756': 'Austin,TX',
'78757': 'Austin,TX',
'78758': 'Austin,TX',
'78759': 'Austin,TX',
'78760': 'Austin,TX',
'78761': 'Austin,TX',
'78762': 'Austin,TX',
'78763': 'Austin,TX',
'78764': 'Austin,TX',
'78765': 'Austin,TX',
'78766': 'Austin,TX',
'78767': 'Austin,TX',
'78768': 'Austin,TX',
'78769': 'Austin,TX',
'78772': 'Austin,TX',
'78773': 'Austin,TX',
'78774': 'Austin,TX',
'78778': 'Austin,TX',
'78779': 'Austin,TX',
'78780': 'Austin,TX',
'78781': 'Austin,TX',
'78783': 'Austin,TX',
'78785': 'Austin,TX',
'78786': 'Austin,TX',
'78788': 'Austin,TX',
'78789': 'Austin,TX',
'78798': 'Dell Computers,TX',
'78799': 'Austin,TX',
'78801': 'Uvalde,TX',
'78802': 'Uvalde,TX',
'78827': 'Asherton,TX',
'78828': 'Barksdale,TX',
'78829': 'Batesville,TX',
'78830': 'Big Wells,TX',
'78832': 'Brackettville,TX',
'78833': 'Camp Wood,TX',
'78834': 'Carrizo Springs,TX',
'78836': 'Catarina,TX',
'78837': 'Comstock,TX',
'78838': 'Concan,TX',
'78839': 'Crystal City,TX',
'78840': 'Del Rio,TX',
'78841': 'Del Rio,TX',
'78842': 'Del Rio,TX',
'78843': 'Laughlin A F B,TX',
'78847': 'Del Rio,TX',
'78850': 'D Hanis,TX',
'78851': 'Dryden,TX',
'78852': 'Eagle Pass,TX',
'78853': 'Eagle Pass,TX',
'78860': 'El Indio,TX',
'78861': 'Hondo,TX',
'78870': 'Knippa,TX',
'78871': 'Langtry,TX',
'78872': 'La Pryor,TX',
'78873': 'Leakey,TX',
'78877': 'Quemado,TX',
'78879': 'Rio Frio,TX',
'78880': 'Rocksprings,TX',
'78881': 'Sabinal,TX',
'78883': 'Tarpley,TX',
'78884': 'Utopia,TX',
'78885': 'Vanderpool,TX',
'78886': 'Yancey,TX',
'78931': 'Bleiblerville,TX',
'78932': 'Carmine,TX',
'78933': 'Cat Spring,TX',
'78934': 'Columbus,TX',
'78935': 'Alleyton,TX',
'78938': 'Ellinger,TX',
'78940': 'Fayetteville,TX',
'78941': 'Flatonia,TX',
'78942': 'Giddings,TX',
'78943': 'Glidden,TX',
'78944': 'Industry,TX',
'78945': 'La Grange,TX',
'78946': 'Ledbetter,TX',
'78947': 'Lexington,TX',
'78948': 'Lincoln,TX',
'78949': 'Muldoon,TX',
'78950': 'New Ulm,TX',
'78951': 'Oakland,TX',
'78952': 'Plum,TX',
'78953': 'Rosanky,TX',
'78954': 'Round Top,TX',
'78956': 'Schulenburg,TX',
'78957': 'Smithville,TX',
'78959': 'Waelder,TX',
'78960': 'Warda,TX',
'78961': 'Round Top,TX',
'78962': 'Weimar,TX',
'78963': 'West Point,TX',
'79001': 'Adrian,TX',
'79002': 'Alanreed,TX',
'79003': 'Allison,TX',
'79005': 'Booker,TX',
'79007': 'Borger,TX',
'79008': 'Borger,TX',
'79009': 'Bovina,TX',
'79010': 'Boys Ranch,TX',
'79011': 'Briscoe,TX',
'79012': 'Bushland,TX',
'79013': 'Cactus,TX',
'79014': 'Canadian,TX',
'79015': 'Canyon,TX',
'79016': 'Canyon,TX',
'79018': 'Channing,TX',
'79019': 'Claude,TX',
'79021': 'Cotton Center,TX',
'79022': 'Dalhart,TX',
'79024': 'Darrouzett,TX',
'79025': 'Dawn,TX',
'79027': 'Dimmitt,TX',
'79029': 'Dumas,TX',
'79031': 'Earth,TX',
'79032': 'Edmonson,TX',
'79033': 'Farnsworth,TX',
'79034': 'Follett,TX',
'79035': 'Friona,TX',
'79036': 'Fritch,TX',
'79039': 'Groom,TX',
'79040': 'Gruver,TX',
'79041': 'Hale Center,TX',
'79042': 'Happy,TX',
'79043': 'Hart,TX',
'79044': 'Hartley,TX',
'79045': 'Hereford,TX',
'79046': 'Higgins,TX',
'79051': 'Kerrick,TX',
'79052': 'Kress,TX',
'79053': 'Lazbuddie,TX',
'79054': 'Lefors,TX',
'79056': 'Lipscomb,TX',
'79057': 'Mclean,TX',
'79058': 'Masterson,TX',
'79059': 'Miami,TX',
'79061': 'Mobeetie,TX',
'79062': 'Morse,TX',
'79063': 'Nazareth,TX',
'79064': 'Olton,TX',
'79065': 'Pampa,TX',
'79066': 'Pampa,TX',
'79068': 'Panhandle,TX',
'79070': 'Perryton,TX',
'79072': 'Plainview,TX',
'79073': 'Plainview,TX',
'79077': 'Samnorwood,TX',
'79078': 'Sanford,TX',
'79079': 'Shamrock,TX',
'79080': 'Skellytown,TX',
'79081': 'Spearman,TX',
'79082': 'Springlake,TX',
'79083': 'Stinnett,TX',
'79084': 'Stratford,TX',
'79085': 'Summerfield,TX',
'79086': 'Sunray,TX',
'79087': 'Texline,TX',
'79088': 'Tulia,TX',
'79091': 'Umbarger,TX',
'79092': 'Vega,TX',
'79093': 'Waka,TX',
'79094': 'Wayside,TX',
'79095': 'Wellington,TX',
'79096': 'Wheeler,TX',
'79097': 'White Deer,TX',
'79098': 'Wildorado,TX',
'79101': 'Amarillo,TX',
'79102': 'Amarillo,TX',
'79103': 'Amarillo,TX',
'79104': 'Amarillo,TX',
'79105': 'Amarillo,TX',
'79106': 'Amarillo,TX',
'79107': 'Amarillo,TX',
'79108': 'Amarillo,TX',
'79109': 'Amarillo,TX',
'79110': 'Amarillo,TX',
'79111': 'Amarillo,TX',
'79114': 'Amarillo,TX',
'79116': 'Amarillo,TX',
'79117': 'Amarillo,TX',
'79118': 'Amarillo,TX',
'79119': 'Amarillo,TX',
'79120': 'Amarillo,TX',
'79121': 'Amarillo,TX',
'79123': 'Amarillo,TX',
'79124': 'Amarillo,TX',
'79159': 'Amarillo,TX',
'79163': 'Amarillo,TX',
'79164': 'Amarillo,TX',
'79165': 'Amarillo,TX',
'79166': 'Amarillo,TX',
'79167': 'Amarillo,TX',
'79168': 'Amarillo,TX',
'79170': 'Amarillo,TX',
'79171': 'Amarillo,TX',
'79172': 'Amarillo,TX',
'79174': 'Amarillo,TX',
'79175': 'Amarillo,TX',
'79178': 'Amarillo,TX',
'79180': 'Amarillo,TX',
'79181': 'Amarillo,TX',
'79182': 'Amarillo,TX',
'79184': 'Amarillo,TX',
'79185': 'Amarillo,TX',
'79186': 'Amarillo,TX',
'79187': 'Amarillo,TX',
'79189': 'Amarillo,TX',
'79201': 'Childress,TX',
'79220': 'Afton,TX',
'79221': 'Aiken,TX',
'79222': 'Carey,TX',
'79223': 'Cee Vee,TX',
'79224': 'Chalk,TX',
'79225': 'Chillicothe,TX',
'79226': 'Clarendon,TX',
'79227': 'Crowell,TX',
'79229': 'Dickens,TX',
'79230': 'Dodson,TX',
'79231': 'Dougherty,TX',
'79232': 'Dumont,TX',
'79233': 'Estelline,TX',
'79234': 'Flomot,TX',
'79235': 'Floydada,TX',
'79236': 'Guthrie,TX',
'79237': 'Hedley,TX',
'79238': 'Kirkland,TX',
'79239': 'Lakeview,TX',
'79240': 'Lelia Lake,TX',
'79241': 'Lockney,TX',
'79243': 'Mcadoo,TX',
'79244': 'Matador,TX',
'79245': 'Memphis,TX',
'79247': 'Odell,TX',
'79248': 'Paducah,TX',
'79250': 'Petersburg,TX',
'79251': 'Quail,TX',
'79252': 'Quanah,TX',
'79255': 'Quitaque,TX',
'79256': 'Roaring Springs,TX',
'79257': 'Silverton,TX',
'79258': 'South Plains,TX',
'79259': 'Tell,TX',
'79261': 'Turkey,TX',
'79311': 'Abernathy,TX',
'79312': 'Amherst,TX',
'79313': 'Anton,TX',
'79314': 'Bledsoe,TX',
'79316': 'Brownfield,TX',
'79320': 'Bula,TX',
'79322': 'Crosbyton,TX',
'79323': 'Denver City,TX',
'79324': 'Enochs,TX',
'79325': 'Farwell,TX',
'79326': 'Fieldton,TX',
'79329': 'Idalou,TX',
'79330': 'Justiceburg,TX',
'79331': 'Lamesa,TX',
'79336': 'Levelland,TX',
'79338': 'Levelland,TX',
'79339': 'Littlefield,TX',
'79342': 'Loop,TX',
'79343': 'Lorenzo,TX',
'79344': 'Maple,TX',
'79345': 'Meadow,TX',
'79346': 'Morton,TX',
'79347': 'Muleshoe,TX',
'79350': 'New Deal,TX',
'79351': 'Odonnell,TX',
'79353': 'Pep,TX',
'79355': 'Plains,TX',
'79356': 'Post,TX',
'79357': 'Ralls,TX',
'79358': 'Ropesville,TX',
'79359': 'Seagraves,TX',
'79360': 'Seminole,TX',
'79363': 'Shallowater,TX',
'79364': 'Slaton,TX',
'79366': 'Ransom Canyon,TX',
'79367': 'Smyer,TX',
'79369': 'Spade,TX',
'79370': 'Spur,TX',
'79371': 'Sudan,TX',
'79372': 'Sundown,TX',
'79373': 'Tahoka,TX',
'79376': 'Tokio,TX',
'79377': 'Welch,TX',
'79378': 'Wellman,TX',
'79379': 'Whiteface,TX',
'79380': 'Whitharral,TX',
'79381': 'Wilson,TX',
'79382': 'Wolfforth,TX',
'79383': 'New Home,TX',
'79401': 'Lubbock,TX',
'79402': 'Lubbock,TX',
'79403': 'Lubbock,TX',
'79404': 'Lubbock,TX',
'79405': 'Lubbock,TX',
'79406': 'Lubbock,TX',
'79407': 'Lubbock,TX',
'79408': 'Lubbock,TX',
'79409': 'Lubbock,TX',
'79410': 'Lubbock,TX',
'79411': 'Lubbock,TX',
'79412': 'Lubbock,TX',
'79413': 'Lubbock,TX',
'79414': 'Lubbock,TX',
'79415': 'Lubbock,TX',
'79416': 'Lubbock,TX',
'79423': 'Lubbock,TX',
'79424': 'Lubbock,TX',
'79430': 'Lubbock,TX',
'79452': 'Lubbock,TX',
'79453': 'Lubbock,TX',
'79457': 'Lubbock,TX',
'79464': 'Lubbock,TX',
'79490': 'Lubbock,TX',
'79491': 'Lubbock,TX',
'79493': 'Lubbock,TX',
'79499': 'Lubbock,TX',
'79501': 'Anson,TX',
'79502': 'Aspermont,TX',
'79503': 'Avoca,TX',
'79504': 'Baird,TX',
'79505': 'Benjamin,TX',
'79506': 'Blackwell,TX',
'79508': 'Buffalo Gap,TX',
'79510': 'Clyde,TX',
'79511': 'Coahoma,TX',
'79512': 'Colorado City,TX',
'79516': 'Dunn,TX',
'79517': 'Fluvanna,TX',
'79518': 'Girard,TX',
'79519': 'Goldsboro,TX',
'79520': 'Hamlin,TX',
'79521': 'Haskell,TX',
'79525': 'Hawley,TX',
'79526': 'Hermleigh,TX',
'79527': 'Ira,TX',
'79528': 'Jayton,TX',
'79529': 'Knox City,TX',
'79530': 'Lawn,TX',
'79532': 'Loraine,TX',
'79533': 'Lueders,TX',
'79534': 'Mc Caulley,TX',
'79535': 'Maryneal,TX',
'79536': 'Merkel,TX',
'79537': 'Nolan,TX',
'79538': 'Novice,TX',
'79539': 'O Brien,TX',
'79540': 'Old Glory,TX',
'79541': 'Ovalo,TX',
'79543': 'Roby,TX',
'79544': 'Rochester,TX',
'79545': 'Roscoe,TX',
'79546': 'Rotan,TX',
'79547': 'Rule,TX',
'79548': 'Rule,TX',
'79549': 'Snyder,TX',
'79550': 'Snyder,TX',
'79553': 'Stamford,TX',
'79556': 'Sweetwater,TX',
'79560': 'Sylvester,TX',
'79561': 'Trent,TX',
'79562': 'Tuscola,TX',
'79563': 'Tye,TX',
'79565': 'Westbrook,TX',
'79566': 'Wingate,TX',
'79567': 'Winters,TX',
'79601': 'Abilene,TX',
'79602': 'Abilene,TX',
'79603': 'Abilene,TX',
'79604': 'Abilene,TX',
'79605': 'Abilene,TX',
'79606': 'Abilene,TX',
'79607': 'Dyess Afb,TX',
'79608': 'Abilene,TX',
'79697': 'Abilene,TX',
'79698': 'Abilene,TX',
'79699': 'Abilene,TX',
'79701': 'Midland,TX',
'79702': 'Midland,TX',
'79703': 'Midland,TX',
'79704': 'Midland,TX',
'79705': 'Midland,TX',
'79706': 'Midland,TX',
'79707': 'Midland,TX',
'79708': 'Midland,TX',
'79710': 'Midland,TX',
'79711': 'Midland,TX',
'79712': 'Midland,TX',
'79713': 'Ackerly,TX',
'79714': 'Andrews,TX',
'79718': 'Balmorhea,TX',
'79719': 'Barstow,TX',
'79720': 'Big Spring,TX',
'79721': 'Big Spring,TX',
'79730': 'Coyanosa,TX',
'79731': 'Crane,TX',
'79733': 'Forsan,TX',
'79734': 'Fort Davis,TX',
'79735': 'Fort Stockton,TX',
'79738': 'Gail,TX',
'79739': 'Garden City,TX',
'79740': 'Girvin,TX',
'79741': 'Goldsmith,TX',
'79742': 'Grandfalls,TX',
'79743': 'Imperial,TX',
'79744': 'Iraan,TX',
'79745': 'Kermit,TX',
'79748': 'Knott,TX',
'79749': 'Lenorah,TX',
'79752': 'Mc Camey,TX',
'79754': 'Mentone,TX',
'79755': 'Midkiff,TX',
'79756': 'Monahans,TX',
'79758': 'Gardendale,TX',
'79759': 'Notrees,TX',
'79760': 'Odessa,TX',
'79761': 'Odessa,TX',
'79762': 'Odessa,TX',
'79763': 'Odessa,TX',
'79764': 'Odessa,TX',
'79765': 'Odessa,TX',
'79766': 'Odessa,TX',
'79768': 'Odessa,TX',
'79769': 'Odessa,TX',
'79770': 'Orla,TX',
'79772': 'Pecos,TX',
'79776': 'Penwell,TX',
'79777': 'Pyote,TX',
'79778': 'Rankin,TX',
'79779': 'Royalty,TX',
'79780': 'Saragosa,TX',
'79781': 'Sheffield,TX',
'79782': 'Stanton,TX',
'79783': 'Tarzan,TX',
'79785': 'Toyah,TX',
'79786': 'Toyahvale,TX',
'79788': 'Wickett,TX',
'79789': 'Wink,TX',
'79821': 'Anthony,TX',
'79830': 'Alpine,TX',
'79831': 'Alpine,TX',
'79832': 'Alpine,TX',
'79834': 'Big Bend National Park,TX',
'79835': 'Canutillo,TX',
'79836': 'Clint,TX',
'79837': 'Dell City,TX',
'79838': 'Fabens,TX',
'79839': 'Fort Hancock,TX',
'79842': 'Marathon,TX',
'79843': 'Marfa,TX',
'79845': 'Presidio,TX',
'79846': 'Redford,TX',
'79847': 'Salt Flat,TX',
'79848': 'Sanderson,TX',
'79849': 'San Elizario,TX',
'79850': 'Shafter,TX',
'79851': 'Sierra Blanca,TX',
'79852': 'Terlingua,TX',
'79853': 'Tornillo,TX',
'79854': 'Valentine,TX',
'79855': 'Van Horn,TX',
'79901': 'El Paso,TX',
'79902': 'El Paso,TX',
'79903': 'El Paso,TX',
'79904': 'El Paso,TX',
'79905': 'El Paso,TX',
'79906': 'El Paso,TX',
'79907': 'El Paso,TX',
'79908': 'El Paso,TX',
'79910': 'El Paso,TX',
'79911': 'El Paso,TX',
'79912': 'El Paso,TX',
'79913': 'El Paso,TX',
'79914': 'El Paso,TX',
'79915': 'El Paso,TX',
'79916': 'El Paso,TX',
'79917': 'El Paso,TX',
'79918': 'El Paso,TX',
'79920': 'El Paso,TX',
'79922': 'El Paso,TX',
'79923': 'El Paso,TX',
'79924': 'El Paso,TX',
'79925': 'El Paso,TX',
'79926': 'El Paso,TX',
'79927': 'El Paso,TX',
'79928': 'El Paso,TX',
'79929': 'El Paso,TX',
'79930': 'El Paso,TX',
'79931': 'El Paso,TX',
'79932': 'El Paso,TX',
'79934': 'El Paso,TX',
'79935': 'El Paso,TX',
'79936': 'El Paso,TX',
'79937': 'El Paso,TX',
'79938': 'El Paso,TX',
'79940': 'El Paso,TX',
'79941': 'El Paso,TX',
'79942': 'El Paso,TX',
'79943': 'El Paso,TX',
'79944': 'El Paso,TX',
'79945': 'El Paso,TX',
'79946': 'El Paso,TX',
'79947': 'El Paso,TX',
'79948': 'El Paso,TX',
'79949': 'El Paso,TX',
'79950': 'El Paso,TX',
'79951': 'El Paso,TX',
'79952': 'El Paso,TX',
'79953': 'El Paso,TX',
'79954': 'El Paso,TX',
'79955': 'El Paso,TX',
'79958': 'El Paso,TX',
'79960': 'El Paso,TX',
'79961': 'El Paso,TX',
'79966': 'El Paso,TX',
'79968': 'El Paso,TX',
'79973': 'El Paso,TX',
'79974': 'El Paso,TX',
'79975': 'El Paso,TX',
'79976': 'El Paso,TX',
'79977': 'El Paso,TX',
'79978': 'El Paso,TX',
'79980': 'El Paso,TX',
'79982': 'El Paso,TX',
'79983': 'El Paso,TX',
'79984': 'El Paso,TX',
'79985': 'El Paso,TX',
'79986': 'El Paso,TX',
'79987': 'El Paso,TX',
'79988': 'El Paso,TX',
'79989': 'El Paso,TX',
'79990': 'El Paso,TX',
'79991': 'El Paso,TX',
'79992': 'El Paso,TX',
'79993': 'El Paso,TX',
'79994': 'El Paso,TX',
'79995': 'El Paso,TX',
'79996': 'El Paso,TX',
'79997': 'El Paso,TX',
'79998': 'El Paso,TX',
'79999': 'El Paso,TX',
'80001': 'Arvada,CO',
'80002': 'Arvada,CO',
'80003': 'Arvada,CO',
'80004': 'Arvada,CO',
'80005': 'Arvada,CO',
'80006': 'Arvada,CO',
'80007': 'Arvada,CO',
'80010': 'Aurora,CO',
'80011': 'Aurora,CO',
'80012': 'Aurora,CO',
'80013': 'Aurora,CO',
'80014': 'Aurora,CO',
'80015': 'Aurora,CO',
'80016': 'Aurora,CO',
'80017': 'Aurora,CO',
'80018': 'Aurora,CO',
'80019': 'Aurora,CO',
'80020': 'Broomfield,CO',
'80021': 'Broomfield,CO',
'80022': 'Commerce City,CO',
'80024': 'Dupont,CO',
'80025': 'Eldorado Springs,CO',
'80026': 'Lafayette,CO',
'80027': 'Louisville,CO',
'80028': 'Louisville,CO',
'80030': 'Westminster,CO',
'80031': 'Westminster,CO',
'80033': 'Wheat Ridge,CO',
'80034': 'Wheat Ridge,CO',
'80035': 'Westminster,CO',
'80036': 'Westminster,CO',
'80037': 'Commerce City,CO',
'80038': 'Broomfield,CO',
'80040': 'Aurora,CO',
'80041': 'Aurora,CO',
'80042': 'Aurora,CO',
'80044': 'Aurora,CO',
'80045': 'Aurora,CO',
'80046': 'Aurora,CO',
'80047': 'Aurora,CO',
'80101': 'Agate,CO',
'80102': 'Bennett,CO',
'80103': 'Byers,CO',
'80104': 'Castle Rock,CO',
'80105': 'Deer Trail,CO',
'80106': 'Elbert,CO',
'80107': 'Elizabeth,CO',
'80110': 'Englewood,CO',
'80111': 'Englewood,CO',
'80112': 'Englewood,CO',
'80113': 'Englewood,CO',
'80116': 'Franktown,CO',
'80117': 'Kiowa,CO',
'80118': 'Larkspur,CO',
'80120': 'Littleton,CO',
'80121': 'Littleton,CO',
'80122': 'Littleton,CO',
'80123': 'Littleton,CO',
'80124': 'Littleton,CO',
'80125': 'Littleton,CO',
'80126': 'Littleton,CO',
'80127': 'Littleton,CO',
'80128': 'Littleton,CO',
'80129': 'Littleton,CO',
'80130': 'Littleton,CO',
'80131': 'Louviers,CO',
'80132': 'Monument,CO',
'80133': 'Palmer Lake,CO',
'80134': 'Parker,CO',
'80135': 'Sedalia,CO',
'80136': 'Strasburg,CO',
'80137': 'Watkins,CO',
'80138': 'Parker,CO',
'80150': 'Englewood,CO',
'80151': 'Englewood,CO',
'80154': 'Englewood,CO',
'80155': 'Englewood,CO',
'80160': 'Littleton,CO',
'80161': 'Littleton,CO',
'80162': 'Littleton,CO',
'80163': 'Littleton,CO',
'80165': 'Littleton,CO',
'80166': 'Littleton,CO',
'80201': 'Denver,CO',
'80202': 'Denver,CO',
'80203': 'Denver,CO',
'80204': 'Denver,CO',
'80205': 'Denver,CO',
'80206': 'Denver,CO',
'80207': 'Denver,CO',
'80208': 'Denver,CO',
'80209': 'Denver,CO',
'80210': 'Denver,CO',
'80211': 'Denver,CO',
'80212': 'Denver,CO',
'80214': 'Denver,CO',
'80215': 'Denver,CO',
'80216': 'Denver,CO',
'80217': 'Denver,CO',
'80218': 'Denver,CO',
'80219': 'Denver,CO',
'80220': 'Denver,CO',
'80221': 'Denver,CO',
'80222': 'Denver,CO',
'80223': 'Denver,CO',
'80224': 'Denver,CO',
'80225': 'Denver,CO',
'80226': 'Denver,CO',
'80227': 'Denver,CO',
'80228': 'Denver,CO',
'80229': 'Denver,CO',
'80230': 'Denver,CO',
'80231': 'Denver,CO',
'80232': 'Denver,CO',
'80233': 'Denver,CO',
'80234': 'Denver,CO',
'80235': 'Denver,CO',
'80236': 'Denver,CO',
'80237': 'Denver,CO',
'80238': 'Denver,CO',
'80239': 'Denver,CO',
'80241': 'Denver,CO',
'80243': 'Denver,CO',
'80244': 'Denver,CO',
'80246': 'Denver,CO',
'80247': 'Denver,CO',
'80248': 'Denver,CO',
'80249': 'Denver,CO',
'80250': 'Denver,CO',
'80251': 'Denver,CO',
'80252': 'Denver,CO',
'80254': 'Denver,CO',
'80255': 'Denver,CO',
'80256': 'Denver,CO',
'80257': 'Denver,CO',
'80259': 'Denver,CO',
'80260': 'Denver,CO',
'80261': 'Denver,CO',
'80262': 'Denver,CO',
'80263': 'Denver,CO',
'80264': 'Denver,CO',
'80265': 'Denver,CO',
'80266': 'Denver,CO',
'80270': 'Denver,CO',
'80271': 'Denver,CO',
'80273': 'Denver,CO',
'80274': 'Denver,CO',
'80275': 'Denver,CO',
'80279': 'Denver,CO',
'80280': 'Denver,CO',
'80281': 'Denver,CO',
'80285': 'Denver,CO',
'80290': 'Denver,CO',
'80291': 'Denver,CO',
'80292': 'Denver,CO',
'80293': 'Denver,CO',
'80294': 'Denver,CO',
'80295': 'Denver,CO',
'80299': 'Denver,CO',
'80301': 'Boulder,CO',
'80302': 'Boulder,CO',
'80303': 'Boulder,CO',
'80304': 'Boulder,CO',
'80305': 'Boulder,CO',
'80306': 'Boulder,CO',
'80307': 'Boulder,CO',
'80308': 'Boulder,CO',
'80309': 'Boulder,CO',
'80310': 'Boulder,CO',
'80314': 'Boulder,CO',
'80321': 'Boulder,CO',
'80322': 'Boulder,CO',
'80323': 'Boulder,CO',
'80328': 'Boulder,CO',
'80329': 'Boulder,CO',
'80401': 'Golden,CO',
'80402': 'Golden,CO',
'80403': 'Golden,CO',
'80419': 'Golden,CO',
'80420': 'Alma,CO',
'80421': 'Bailey,CO',
'80422': 'Black Hawk,CO',
'80423': 'Bond,CO',
'80424': 'Breckenridge,CO',
'80425': 'Buffalo Creek,CO',
'80426': 'Burns,CO',
'80427': 'Central City,CO',
'80428': 'Clark,CO',
'80429': 'Climax,CO',
'80430': 'Coalmont,CO',
'80432': 'Como,CO',
'80433': 'Conifer,CO',
'80434': 'Cowdrey,CO',
'80435': 'Dillon,CO',
'80436': 'Dumont,CO',
'80437': 'Evergreen,CO',
'80438': 'Empire,CO',
'80439': 'Evergreen,CO',
'80440': 'Fairplay,CO',
'80442': 'Fraser,CO',
'80443': 'Frisco,CO',
'80444': 'Georgetown,CO',
'80446': 'Granby,CO',
'80447': 'Grand Lake,CO',
'80448': 'Grant,CO',
'80449': 'Hartsel,CO',
'80451': 'Hot Sulphur Springs,CO',
'80452': 'Idaho Springs,CO',
'80453': 'Idledale,CO',
'80454': 'Indian Hills,CO',
'80455': 'Jamestown,CO',
'80456': 'Jefferson,CO',
'80457': 'Kittredge,CO',
'80459': 'Kremmling,CO',
'80461': 'Leadville,CO',
'80463': 'Mc Coy,CO',
'80465': 'Morrison,CO',
'80466': 'Nederland,CO',
'80467': 'Oak Creek,CO',
'80468': 'Parshall,CO',
'80469': 'Phippsburg,CO',
'80470': 'Pine,CO',
'80471': 'Pinecliffe,CO',
'80473': 'Rand,CO',
'80474': 'Rollinsville,CO',
'80475': 'Shawnee,CO',
'80476': 'Silver Plume,CO',
'80477': 'Steamboat Springs,CO',
'80478': 'Tabernash,CO',
'80479': 'Toponas,CO',
'80480': 'Walden,CO',
'80481': 'Ward,CO',
'80482': 'Winter Park,CO',
'80483': 'Yampa,CO',
'80487': 'Steamboat Springs,CO',
'80488': 'Steamboat Springs,CO',
'80497': 'Silverthorne,CO',
'80498': 'Silverthorne,CO',
'80501': 'Longmont,CO',
'80502': 'Longmont,CO',
'80503': 'Longmont,CO',
'80504': 'Longmont,CO',
'80510': 'Allenspark,CO',
'80511': 'Estes Park,CO',
'80512': 'Bellvue,CO',
'80513': 'Berthoud,CO',
'80514': 'Dacono,CO',
'80515': 'Drake,CO',
'80516': 'Erie,CO',
'80517': 'Estes Park,CO',
'80520': 'Firestone,CO',
'80521': 'Fort Collins,CO',
'80522': 'Fort Collins,CO',
'80523': 'Fort Collins,CO',
'80524': 'Fort Collins,CO',
'80525': 'Fort Collins,CO',
'80526': 'Fort Collins,CO',
'80527': 'Fort Collins,CO',
'80528': 'Fort Collins,CO',
'80530': 'Frederick,CO',
'80532': 'Glen Haven,CO',
'80533': 'Hygiene,CO',
'80534': 'Johnstown,CO',
'80535': 'Laporte,CO',
'80536': 'Livermore,CO',
'80537': 'Loveland,CO',
'80538': 'Loveland,CO',
'80539': 'Loveland,CO',
'80540': 'Lyons,CO',
'80541': 'Masonville,CO',
'80542': 'Mead,CO',
'80543': 'Milliken,CO',
'80544': 'Niwot,CO',
'80545': 'Red Feather Lakes,CO',
'80546': 'Severance,CO',
'80547': 'Timnath,CO',
'80549': 'Wellington,CO',
'80550': 'Windsor,CO',
'80551': 'Windsor,CO',
'80553': 'Fort Collins,CO',
'80601': 'Brighton,CO',
'80602': 'Brighton,CO',
'80603': 'Brighton,CO',
'80610': 'Ault,CO',
'80611': 'Briggsdale,CO',
'80612': 'Carr,CO',
'80614': 'Eastlake,CO',
'80615': 'Eaton,CO',
'80620': 'Evans,CO',
'80621': 'Fort Lupton,CO',
'80622': 'Galeton,CO',
'80623': 'Gilcrest,CO',
'80624': 'Gill,CO',
'80631': 'Greeley,CO',
'80632': 'Greeley,CO',
'80633': 'Greeley,CO',
'80634': 'Greeley,CO',
'80638': 'Greeley,CO',
'80639': 'Greeley,CO',
'80640': 'Henderson,CO',
'80642': 'Hudson,CO',
'80643': 'Keenesburg,CO',
'80644': 'Kersey,CO',
'80645': 'La Salle,CO',
'80646': 'Lucerne,CO',
'80648': 'Nunn,CO',
'80649': 'Orchard,CO',
'80650': 'Pierce,CO',
'80651': 'Platteville,CO',
'80652': 'Roggen,CO',
'80653': 'Weldona,CO',
'80654': 'Wiggins,CO',
'80701': 'Fort Morgan,CO',
'80705': 'Log Lane Village,CO',
'80720': 'Akron,CO',
'80721': 'Amherst,CO',
'80722': 'Atwood,CO',
'80723': 'Brush,CO',
'80726': 'Crook,CO',
'80727': 'Eckley,CO',
'80728': 'Fleming,CO',
'80729': 'Grover,CO',
'80731': 'Haxtun,CO',
'80732': 'Hereford,CO',
'80733': 'Hillrose,CO',
'80734': 'Holyoke,CO',
'80735': 'Idalia,CO',
'80736': 'Iliff,CO',
'80737': 'Julesburg,CO',
'80740': 'Lindon,CO',
'80741': 'Merino,CO',
'80742': 'New Raymer,CO',
'80743': 'Otis,CO',
'80744': 'Ovid,CO',
'80745': 'Padroni,CO',
'80746': 'Paoli,CO',
'80747': 'Peetz,CO',
'80749': 'Sedgwick,CO',
'80750': 'Snyder,CO',
'80751': 'Sterling,CO',
'80754': 'Stoneham,CO',
'80755': 'Vernon,CO',
'80757': 'Woodrow,CO',
'80758': 'Wray,CO',
'80759': 'Yuma,CO',
'80801': 'Anton,CO',
'80802': 'Arapahoe,CO',
'80804': 'Arriba,CO',
'80805': 'Bethune,CO',
'80807': 'Burlington,CO',
'80808': 'Calhan,CO',
'80809': 'Cascade,CO',
'80810': 'Cheyenne Wells,CO',
'80812': 'Cope,CO',
'80813': 'Cripple Creek,CO',
'80814': 'Divide,CO',
'80815': 'Flagler,CO',
'80816': 'Florissant,CO',
'80817': 'Fountain,CO',
'80818': 'Genoa,CO',
'80819': 'Green Mountain Falls,CO',
'80820': 'Guffey,CO',
'80821': 'Hugo,CO',
'80822': 'Joes,CO',
'80823': 'Karval,CO',
'80824': 'Kirk,CO',
'80825': 'Kit Carson,CO',
'80826': 'Limon,CO',
'80827': 'Lake George,CO',
'80828': 'Limon,CO',
'80829': 'Manitou Springs,CO',
'80830': 'Matheson,CO',
'80831': 'Peyton,CO',
'80832': 'Ramah,CO',
'80833': 'Rush,CO',
'80834': 'Seibert,CO',
'80835': 'Simla,CO',
'80836': 'Stratton,CO',
'80840': 'U S A F Academy,CO',
'80841': 'U S A F Academy,CO',
'80860': 'Victor,CO',
'80861': 'Vona,CO',
'80862': 'Wild Horse,CO',
'80863': 'Woodland Park,CO',
'80864': 'Yoder,CO',
'80866': 'Woodland Park,CO',
'80901': 'Colorado Springs,CO',
'80903': 'Colorado Springs,CO',
'80904': 'Colorado Springs,CO',
'80905': 'Colorado Springs,CO',
'80906': 'Colorado Springs,CO',
'80907': 'Colorado Springs,CO',
'80908': 'Colorado Springs,CO',
'80909': 'Colorado Springs,CO',
'80910': 'Colorado Springs,CO',
'80911': 'Colorado Springs,CO',
'80912': 'Colorado Springs,CO',
'80913': 'Colorado Springs,CO',
'80914': 'Colorado Springs,CO',
'80915': 'Colorado Springs,CO',
'80916': 'Colorado Springs,CO',
'80917': 'Colorado Springs,CO',
'80918': 'Colorado Springs,CO',
'80919': 'Colorado Springs,CO',
'80920': 'Colorado Springs,CO',
'80921': 'Colorado Springs,CO',
'80922': 'Colorado Springs,CO',
'80923': 'Colorado Springs,CO',
'80924': 'Colorado Springs,CO',
'80925': 'Colorado Springs,CO',
'80926': 'Colorado Springs,CO',
'80927': 'Colorado Springs,CO',
'80928': 'Colorado Springs,CO',
'80929': 'Colorado Springs,CO',
'80930': 'Colorado Springs,CO',
'80931': 'Colorado Springs,CO',
'80932': 'Colorado Springs,CO',
'80933': 'Colorado Springs,CO',
'80934': 'Colorado Springs,CO',
'80935': 'Colorado Springs,CO',
'80936': 'Colorado Springs,CO',
'80937': 'Colorado Springs,CO',
'80938': 'Colorado Springs,CO',
'80939': 'Colorado Springs,CO',
'80940': 'Colorado Springs,CO',
'80941': 'Colorado Springs,CO',
'80942': 'Colorado Springs,CO',
'80943': 'Colorado Springs,CO',
'80944': 'Colorado Springs,CO',
'80945': 'Colorado Springs,CO',
'80946': 'Colorado Springs,CO',
'80947': 'Colorado Springs,CO',
'80949': 'Colorado Springs,CO',
'80950': 'Colorado Springs,CO',
'80951': 'Colorado Springs,CO',
'80960': 'Colorado Springs,CO',
'80962': 'Colorado Springs,CO',
'80970': 'Colorado Springs,CO',
'80977': 'Colorado Springs,CO',
'80995': 'Colorado Springs,CO',
'80997': 'Colorado Springs,CO',
'81001': 'Pueblo,CO',
'81002': 'Pueblo,CO',
'81003': 'Pueblo,CO',
'81004': 'Pueblo,CO',
'81005': 'Pueblo,CO',
'81006': 'Pueblo,CO',
'81007': 'Pueblo,CO',
'81008': 'Pueblo,CO',
'81009': 'Pueblo,CO',
'81010': 'Pueblo,CO',
'81011': 'Pueblo,CO',
'81012': 'Pueblo,CO',
'81013': 'Pueblo,CO',
'81014': 'Pueblo,CO',
'81015': 'Pueblo,CO',
'81019': 'Colorado City,CO',
'81020': 'Aguilar,CO',
'81021': 'Arlington,CO',
'81022': 'Avondale,CO',
'81023': 'Beulah,CO',
'81024': 'Boncarbo,CO',
'81025': 'Boone,CO',
'81027': 'Branson,CO',
'81029': 'Campo,CO',
'81030': 'Cheraw,CO',
'81033': 'Crowley,CO',
'81034': 'Crowley,CO',
'81036': 'Eads,CO',
'81038': 'Fort Lyon,CO',
'81039': 'Fowler,CO',
'81040': 'Gardner,CO',
'81041': 'Granada,CO',
'81042': 'Gulnare,CO',
'81043': 'Hartman,CO',
'81044': 'Hasty,CO',
'81045': 'Haswell,CO',
'81046': 'Hoehne,CO',
'81047': 'Holly,CO',
'81049': 'Kim,CO',
'81050': 'La Junta,CO',
'81052': 'Lamar,CO',
'81054': 'Las Animas,CO',
'81055': 'La Veta,CO',
'81057': 'Mc Clave,CO',
'81058': 'Manzanola,CO',
'81059': 'Model,CO',
'81062': 'Olney Springs,CO',
'81063': 'Ordway,CO',
'81064': 'Pritchett,CO',
'81066': 'Walsenburg,CO',
'81067': 'Rocky Ford,CO',
'81069': 'Rye,CO',
'81071': 'Sheridan Lake,CO',
'81073': 'Springfield,CO',
'81074': 'Starkville,CO',
'81075': 'Stonington,CO',
'81076': 'Sugar City,CO',
'81077': 'Swink,CO',
'81081': 'Trinchera,CO',
'81082': 'Trinidad,CO',
'81084': 'Two Buttes,CO',
'81087': 'Vilas,CO',
'81089': 'Walsenburg,CO',
'81090': 'Walsh,CO',
'81091': 'Weston,CO',
'81092': 'Wiley,CO',
'81101': 'Alamosa,CO',
'81102': 'Alamosa,CO',
'81120': 'Antonito,CO',
'81121': 'Arboles,CO',
'81122': 'Bayfield,CO',
'81123': 'Blanca,CO',
'81124': 'Capulin,CO',
'81125': 'Center,CO',
'81126': 'Chama,CO',
'81127': 'Chimney Rock,CO',
'81128': 'Chromo,CO',
'81129': 'Conejos,CO',
'81130': 'Creede,CO',
'81131': 'Crestone,CO',
'81132': 'Del Norte,CO',
'81133': 'Fort Garland,CO',
'81134': 'Garcia,CO',
'81135': 'Homelake,CO',
'81136': 'Hooper,CO',
'81137': 'Ignacio,CO',
'81138': 'Jaroso,CO',
'81140': 'La Jara,CO',
'81141': 'Manassa,CO',
'81143': 'Moffat,CO',
'81144': 'Monte Vista,CO',
'81146': 'Mosca,CO',
'81147': 'Pagosa Springs,CO',
'81148': 'Romeo,CO',
'81149': 'Saguache,CO',
'81151': 'Sanford,CO',
'81152': 'San Luis,CO',
'81153': 'San Pablo,CO',
'81154': 'South Fork,CO',
'81155': 'Villa Grove,CO',
'81157': 'Pagosa Springs,CO',
'81201': 'Salida,CO',
'81210': 'Almont,CO',
'81211': 'Buena Vista,CO',
'81212': 'Canon City,CO',
'81215': 'Canon City,CO',
'81220': 'Cimarron,CO',
'81221': 'Coal Creek,CO',
'81222': 'Coaldale,CO',
'81223': 'Cotopaxi,CO',
'81224': 'Crested Butte,CO',
'81225': 'Crested Butte,CO',
'81226': 'Florence,CO',
'81227': 'Monarch,CO',
'81228': 'Granite,CO',
'81230': 'Gunnison,CO',
'81231': 'Gunnison,CO',
'81232': 'Hillside,CO',
'81233': 'Howard,CO',
'81235': 'Lake City,CO',
'81236': 'Nathrop,CO',
'81237': 'Ohio City,CO',
'81239': 'Parlin,CO',
'81240': 'Penrose,CO',
'81241': 'Pitkin,CO',
'81242': 'Poncha Springs,CO',
'81243': 'Powderhorn,CO',
'81244': 'Rockvale,CO',
'81246': 'Canon City,CO',
'81247': 'Gunnison,CO',
'81248': 'Sargents,CO',
'81251': 'Twin Lakes,CO',
'81252': 'Westcliffe,CO',
'81253': 'Wetmore,CO',
'81290': 'Florence,CO',
'81301': 'Durango,CO',
'81302': 'Durango,CO',
'81303': 'Durango,CO',
'81320': 'Cahone,CO',
'81321': 'Cortez,CO',
'81323': 'Dolores,CO',
'81324': 'Dove Creek,CO',
'81325': 'Egnar,CO',
'81326': 'Hesperus,CO',
'81327': 'Lewis,CO',
'81328': 'Mancos,CO',
'81329': 'Marvel,CO',
'81330': 'Mesa Verde National Park,CO',
'81331': 'Pleasant View,CO',
'81332': 'Rico,CO',
'81334': 'Towaoc,CO',
'81335': 'Yellow Jacket,CO',
'81401': 'Montrose,CO',
'81402': 'Montrose,CO',
'81403': 'Montrose,CO',
'81410': 'Austin,CO',
'81411': 'Bedrock,CO',
'81413': 'Cedaredge,CO',
'81414': 'Cory,CO',
'81415': 'Crawford,CO',
'81416': 'Delta,CO',
'81418': 'Eckert,CO',
'81419': 'Hotchkiss,CO',
'81420': 'Lazear,CO',
'81421': 'Maher,CO',
'81422': 'Naturita,CO',
'81423': 'Norwood,CO',
'81424': 'Nucla,CO',
'81425': 'Olathe,CO',
'81426': 'Ophir,CO',
'81427': 'Ouray,CO',
'81428': 'Paonia,CO',
'81429': 'Paradox,CO',
'81430': 'Placerville,CO',
'81431': 'Redvale,CO',
'81432': 'Ridgway,CO',
'81433': 'Silverton,CO',
'81434': 'Somerset,CO',
'81435': 'Telluride,CO',
'81501': 'Grand Junction,CO',
'81502': 'Grand Junction,CO',
'81503': 'Grand Junction,CO',
'81504': 'Grand Junction,CO',
'81505': 'Grand Junction,CO',
'81506': 'Grand Junction,CO',
'81507': 'Grand Junction,CO',
'81520': 'Clifton,CO',
'81521': 'Fruita,CO',
'81522': 'Gateway,CO',
'81523': 'Glade Park,CO',
'81524': 'Loma,CO',
'81525': 'Mack,CO',
'81526': 'Palisade,CO',
'81527': 'Whitewater,CO',
'81601': 'Glenwood Springs,CO',
'81602': 'Glenwood Springs,CO',
'81610': 'Dinosaur,CO',
'81611': 'Aspen,CO',
'81612': 'Aspen,CO',
'81615': 'Snowmass Village,CO',
'81620': 'Avon,CO',
'81621': 'Basalt,CO',
'81623': 'Carbondale,CO',
'81624': 'Collbran,CO',
'81625': 'Craig,CO',
'81626': 'Craig,CO',
'81630': 'De Beque,CO',
'81631': 'Eagle,CO',
'81632': 'Edwards,CO',
'81633': 'Dinosaur,CO',
'81635': 'Parachute,CO',
'81636': 'Battlement Mesa,CO',
'81637': 'Gypsum,CO',
'81638': 'Hamilton,CO',
'81639': 'Hayden,CO',
'81640': 'Maybell,CO',
'81641': 'Meeker,CO',
'81642': 'Meredith,CO',
'81643': 'Mesa,CO',
'81645': 'Minturn,CO',
'81646': 'Molina,CO',
'81647': 'New Castle,CO',
'81648': 'Rangely,CO',
'81649': 'Red Cliff,CO',
'81650': 'Rifle,CO',
'81652': 'Silt,CO',
'81653': 'Slater,CO',
'81654': 'Snowmass,CO',
'81655': 'Wolcott,CO',
'81656': 'Woody Creek,CO',
'81657': 'Vail,CO',
'81658': 'Vail,CO',
'82001': 'Cheyenne,WY',
'82002': 'Cheyenne,WY',
'82003': 'Cheyenne,WY',
'82005': 'Fe Warren Afb,WY',
'82006': 'Cheyenne,WY',
'82007': 'Cheyenne,WY',
'82008': 'Cheyenne,WY',
'82009': 'Cheyenne,WY',
'82010': 'Cheyenne,WY',
'82050': 'Albin,WY',
'82051': 'Bosler,WY',
'82052': 'Buford,WY',
'82053': 'Burns,WY',
'82054': 'Carpenter,WY',
'82055': 'Centennial,WY',
'82058': 'Garrett,WY',
'82059': 'Granite Canon,WY',
'82060': 'Hillsdale,WY',
'82061': 'Horse Creek,WY',
'82063': 'Jelm,WY',
'82070': 'Laramie,WY',
'82071': 'Laramie,WY',
'82072': 'Laramie,WY',
'82073': 'Laramie,WY',
'82081': 'Meriden,WY',
'82082': 'Pine Bluffs,WY',
'82083': 'Rock River,WY',
'82084': 'Tie Siding,WY',
'82190': 'Yellowstone National Park,WY',
'82201': 'Wheatland,WY',
'82210': 'Chugwater,WY',
'82212': 'Fort Laramie,WY',
'82213': 'Glendo,WY',
'82214': 'Guernsey,WY',
'82215': 'Hartville,WY',
'82217': 'Hawk Springs,WY',
'82218': 'Huntley,WY',
'82219': 'Jay Em,WY',
'82221': 'Lagrange,WY',
'82222': 'Lance Creek,WY',
'82223': 'Lingle,WY',
'82224': 'Lost Springs,WY',
'82225': 'Lusk,WY',
'82227': 'Manville,WY',
'82229': 'Shawnee,WY',
'82240': 'Torrington,WY',
'82242': 'Van Tassell,WY',
'82243': 'Veteran,WY',
'82244': 'Yoder,WY',
'82301': 'Rawlins,WY',
'82310': 'Jeffrey City,WY',
'82321': 'Baggs,WY',
'82322': 'Bairoil,WY',
'82323': 'Dixon,WY',
'82324': 'Elk Mountain,WY',
'82325': 'Encampment,WY',
'82327': 'Hanna,WY',
'82329': 'Medicine Bow,WY',
'82331': 'Saratoga,WY',
'82332': 'Savery,WY',
'82334': 'Sinclair,WY',
'82335': 'Walcott,WY',
'82336': 'Wamsutter,WY',
'82401': 'Worland,WY',
'82410': 'Basin,WY',
'82411': 'Burlington,WY',
'82412': 'Byron,WY',
'82414': 'Cody,WY',
'82420': 'Cowley,WY',
'82421': 'Deaver,WY',
'82422': 'Emblem,WY',
'82423': 'Frannie,WY',
'82426': 'Greybull,WY',
'82427': 'Hamilton Dome,WY',
'82428': 'Hyattville,WY',
'82430': 'Kirby,WY',
'82431': 'Lovell,WY',
'82432': 'Manderson,WY',
'82433': 'Meeteetse,WY',
'82434': 'Otto,WY',
'82435': 'Powell,WY',
'82440': 'Ralston,WY',
'82441': 'Shell,WY',
'82442': 'Ten Sleep,WY',
'82443': 'Thermopolis,WY',
'82450': 'Wapiti,WY',
'82501': 'Riverton,WY',
'82510': 'Arapahoe,WY',
'82512': 'Crowheart,WY',
'82513': 'Dubois,WY',
'82514': 'Fort Washakie,WY',
'82515': 'Hudson,WY',
'82516': 'Kinnear,WY',
'82520': 'Lander,WY',
'82523': 'Pavillion,WY',
'82524': 'Saint Stephens,WY',
'82601': 'Casper,WY',
'82602': 'Casper,WY',
'82604': 'Casper,WY',
'82605': 'Casper,WY',
'82609': 'Casper,WY',
'82615': 'Shirley Basin,WY',
'82620': 'Alcova,WY',
'82630': 'Arminto,WY',
'82631': 'Bill,WY',
'82633': 'Douglas,WY',
'82635': 'Edgerton,WY',
'82636': 'Evansville,WY',
'82637': 'Glenrock,WY',
'82638': 'Hiland,WY',
'82639': 'Kaycee,WY',
'82640': 'Linch,WY',
'82642': 'Lysite,WY',
'82643': 'Midwest,WY',
'82644': 'Mills,WY',
'82646': 'Natrona,WY',
'82648': 'Powder River,WY',
'82649': 'Shoshoni,WY',
'82701': 'Newcastle,WY',
'82710': 'Aladdin,WY',
'82711': 'Alva,WY',
'82712': 'Beulah,WY',
'82713': 'Carlile,WY',
'82714': 'Devils Tower,WY',
'82715': 'Four Corners,WY',
'82716': 'Gillette,WY',
'82717': 'Gillette,WY',
'82718': 'Gillette,WY',
'82720': 'Hulett,WY',
'82721': 'Moorcroft,WY',
'82723': 'Osage,WY',
'82725': 'Recluse,WY',
'82727': 'Rozet,WY',
'82729': 'Sundance,WY',
'82730': 'Upton,WY',
'82731': 'Weston,WY',
'82732': 'Wright,WY',
'82801': 'Sheridan,WY',
'82831': 'Arvada,WY',
'82832': 'Banner,WY',
'82833': 'Big Horn,WY',
'82834': 'Buffalo,WY',
'82835': 'Clearmont,WY',
'82836': 'Dayton,WY',
'82837': 'Leiter,WY',
'82838': 'Parkman,WY',
'82839': 'Ranchester,WY',
'82840': 'Saddlestring,WY',
'82842': 'Story,WY',
'82844': 'Wolf,WY',
'82845': 'Wyarno,WY',
'82901': 'Rock Springs,WY',
'82902': 'Rock Springs,WY',
'82922': 'Bondurant,WY',
'82923': 'Boulder,WY',
'82925': 'Cora,WY',
'82929': 'Little America,WY',
'82930': 'Evanston,WY',
'82931': 'Evanston,WY',
'82932': 'Farson,WY',
'82933': 'Fort Bridger,WY',
'82934': 'Granger,WY',
'82935': 'Green River,WY',
'82936': 'Lonetree,WY',
'82937': 'Lyman,WY',
'82938': 'Mc Kinnon,WY',
'82939': 'Mountain View,WY',
'82941': 'Pinedale,WY',
'82942': 'Point Of Rocks,WY',
'82943': 'Reliance,WY',
'82944': 'Robertson,WY',
'82945': 'Superior,WY',
'83001': 'Jackson,WY',
'83002': 'Jackson,WY',
'83011': 'Kelly,WY',
'83012': 'Moose,WY',
'83013': 'Moran,WY',
'83014': 'Wilson,WY',
'83025': 'Teton Village,WY',
'83101': 'Kemmerer,WY',
'83110': 'Afton,WY',
'83111': 'Auburn,WY',
'83112': 'Bedford,WY',
'83113': 'Big Piney,WY',
'83114': 'Cokeville,WY',
'83115': 'Daniel,WY',
'83116': 'Diamondville,WY',
'83118': 'Etna,WY',
'83119': 'Fairview,WY',
'83120': 'Freedom,WY',
'83121': 'Frontier,WY',
'83122': 'Grover,WY',
'83123': 'La Barge,WY',
'83124': 'Opal,WY',
'83126': 'Smoot,WY',
'83127': 'Thayne,WY',
'83128': 'Alpine,WY',
'83201': 'Pocatello,ID',
'83202': 'Pocatello,ID',
'83203': 'Fort Hall,ID',
'83204': 'Pocatello,ID',
'83205': 'Pocatello,ID',
'83206': 'Pocatello,ID',
'83209': 'Pocatello,ID',
'83210': 'Aberdeen,ID',
'83211': 'American Falls,ID',
'83212': 'Arbon,ID',
'83213': 'Arco,ID',
'83214': 'Arimo,ID',
'83215': 'Atomic City,ID',
'83217': 'Bancroft,ID',
'83218': 'Basalt,ID',
'83220': 'Bern,ID',
'83221': 'Blackfoot,ID',
'83223': 'Bloomington,ID',
'83226': 'Challis,ID',
'83227': 'Clayton,ID',
'83228': 'Clifton,ID',
'83229': 'Cobalt,ID',
'83230': 'Conda,ID',
'83232': 'Dayton,ID',
'83233': 'Dingle,ID',
'83234': 'Downey,ID',
'83235': 'Ellis,ID',
'83236': 'Firth,ID',
'83237': 'Franklin,ID',
'83238': 'Geneva,ID',
'83239': 'Georgetown,ID',
'83241': 'Grace,ID',
'83243': 'Holbrook,ID',
'83244': 'Howe,ID',
'83245': 'Inkom,ID',
'83246': 'Lava Hot Springs,ID',
'83250': 'Mccammon,ID',
'83251': 'Mackay,ID',
'83252': 'Malad City,ID',
'83253': 'May,ID',
'83254': 'Montpelier,ID',
'83255': 'Moore,ID',
'83256': 'Moreland,ID',
'83261': 'Paris,ID',
'83262': 'Pingree,ID',
'83263': 'Preston,ID',
'83271': 'Rockland,ID',
'83272': 'Saint Charles,ID',
'83274': 'Shelley,ID',
'83276': 'Soda Springs,ID',
'83277': 'Springfield,ID',
'83278': 'Stanley,ID',
'83281': 'Swanlake,ID',
'83283': 'Thatcher,ID',
'83285': 'Wayan,ID',
'83286': 'Weston,ID',
'83287': 'Fish Haven,ID',
'83301': 'Twin Falls,ID',
'83302': 'Rogerson,ID',
'83303': 'Twin Falls,ID',
'83311': 'Albion,ID',
'83312': 'Almo,ID',
'83313': 'Bellevue,ID',
'83314': 'Bliss,ID',
'83316': 'Buhl,ID',
'83318': 'Burley,ID',
'83320': 'Carey,ID',
'83321': 'Castleford,ID',
'83322': 'Corral,ID',
'83323': 'Declo,ID',
'83324': 'Dietrich,ID',
'83325': 'Eden,ID',
'83327': 'Fairfield,ID',
'83328': 'Filer,ID',
'83330': 'Gooding,ID',
'83332': 'Hagerman,ID',
'83333': 'Hailey,ID',
'83334': 'Hansen,ID',
'83335': 'Hazelton,ID',
'83336': 'Heyburn,ID',
'83337': 'Hill City,ID',
'83338': 'Jerome,ID',
'83340': 'Ketchum,ID',
'83341': 'Kimberly,ID',
'83342': 'Malta,ID',
'83343': 'Minidoka,ID',
'83344': 'Murtaugh,ID',
'83346': 'Oakley,ID',
'83347': 'Paul,ID',
'83348': 'Picabo,ID',
'83349': 'Richfield,ID',
'83350': 'Rupert,ID',
'83352': 'Shoshone,ID',
'83353': 'Sun Valley,ID',
'83354': 'Sun Valley,ID',
'83355': 'Wendell,ID',
'83401': 'Idaho Falls,ID',
'83402': 'Idaho Falls,ID',
'83403': 'Idaho Falls,ID',
'83404': 'Idaho Falls,ID',
'83405': 'Idaho Falls,ID',
'83406': 'Idaho Falls,ID',
'83414': 'Alta,WY',
'83415': 'Idaho Falls,ID',
'83420': 'Ashton,ID',
'83421': 'Chester,ID',
'83422': 'Driggs,ID',
'83423': 'Dubois,ID',
'83424': 'Felt,ID',
'83425': 'Hamer,ID',
'83427': 'Iona,ID',
'83428': 'Irwin,ID',
'83429': 'Island Park,ID',
'83431': 'Lewisville,ID',
'83433': 'Macks Inn,ID',
'83434': 'Menan,ID',
'83435': 'Monteview,ID',
'83436': 'Newdale,ID',
'83438': 'Parker,ID',
'83440': 'Rexburg,ID',
'83441': 'Rexburg,ID',
'83442': 'Rigby,ID',
'83443': 'Ririe,ID',
'83444': 'Roberts,ID',
'83445': 'Saint Anthony,ID',
'83446': 'Spencer,ID',
'83447': 'Squirrel,ID',
'83448': 'Sugar City,ID',
'83449': 'Swan Valley,ID',
'83450': 'Terreton,ID',
'83451': 'Teton,ID',
'83452': 'Tetonia,ID',
'83454': 'Ucon,ID',
'83455': 'Victor,ID',
'83460': 'Rexburg,ID',
'83462': 'Carmen,ID',
'83463': 'Gibbonsville,ID',
'83464': 'Leadore,ID',
'83465': 'Lemhi,ID',
'83466': 'North Fork,ID',
'83467': 'Salmon,ID',
'83468': 'Tendoy,ID',
'83469': 'Shoup,ID',
'83501': 'Lewiston,ID',
'83520': 'Ahsahka,ID',
'83522': 'Cottonwood,ID',
'83523': 'Craigmont,ID',
'83524': 'Culdesac,ID',
'83525': 'Elk City,ID',
'83526': 'Ferdinand,ID',
'83530': 'Grangeville,ID',
'83531': 'Fenn,ID',
'83533': 'Greencreek,ID',
'83535': 'Juliaetta,ID',
'83536': 'Kamiah,ID',
'83537': 'Kendrick,ID',
'83539': 'Kooskia,ID',
'83540': 'Lapwai,ID',
'83541': 'Lenore,ID',
'83542': 'Lucile,ID',
'83543': 'Nezperce,ID',
'83544': 'Orofino,ID',
'83545': 'Peck,ID',
'83546': 'Pierce,ID',
'83547': 'Pollock,ID',
'83548': 'Reubens,ID',
'83549': 'Riggins,ID',
'83551': 'Spalding,ID',
'83552': 'Stites,ID',
'83553': 'Weippe,ID',
'83554': 'White Bird,ID',
'83555': 'Winchester,ID',
'83601': 'Atlanta,ID',
'83602': 'Banks,ID',
'83604': 'Bruneau,ID',
'83605': 'Caldwell,ID',
'83606': 'Caldwell,ID',
'83607': 'Caldwell,ID',
'83610': 'Cambridge,ID',
'83611': 'Cascade,ID',
'83612': 'Council,ID',
'83615': 'Donnelly,ID',
'83616': 'Eagle,ID',
'83617': 'Emmett,ID',
'83619': 'Fruitland,ID',
'83620': 'Fruitvale,ID',
'83622': 'Garden Valley,ID',
'83623': 'Glenns Ferry,ID',
'83624': 'Grand View,ID',
'83626': 'Greenleaf,ID',
'83627': 'Hammett,ID',
'83628': 'Homedale,ID',
'83629': 'Horseshoe Bend,ID',
'83630': 'Huston,ID',
'83631': 'Idaho City,ID',
'83632': 'Indian Valley,ID',
'83633': 'King Hill,ID',
'83634': 'Kuna,ID',
'83635': 'Lake Fork,ID',
'83636': 'Letha,ID',
'83637': 'Lowman,ID',
'83638': 'Mccall,ID',
'83639': 'Marsing,ID',
'83641': 'Melba,ID',
'83642': 'Meridian,ID',
'83643': 'Mesa,ID',
'83644': 'Middleton,ID',
'83645': 'Midvale,ID',
'83646': 'Meridian,ID',
'83647': 'Mountain Home,ID',
'83648': 'Mountain Home A F B,ID',
'83650': 'Murphy,ID',
'83651': 'Nampa,ID',
'83652': 'Nampa,ID',
'83653': 'Nampa,ID',
'83654': 'New Meadows,ID',
'83655': 'New Plymouth,ID',
'83656': 'Notus,ID',
'83657': 'Ola,ID',
'83660': 'Parma,ID',
'83661': 'Payette,ID',
'83666': 'Placerville,ID',
'83669': 'Star,ID',
'83670': 'Sweet,ID',
'83671': 'Warren,ID',
'83672': 'Weiser,ID',
'83676': 'Wilder,ID',
'83677': 'Yellow Pine,ID',
'83680': 'Meridian,ID',
'83686': 'Nampa,ID',
'83687': 'Nampa,ID',
'83701': 'Boise,ID',
'83702': 'Boise,ID',
'83703': 'Boise,ID',
'83704': 'Boise,ID',
'83705': 'Boise,ID',
'83706': 'Boise,ID',
'83707': 'Boise,ID',
'83708': 'Boise,ID',
'83709': 'Boise,ID',
'83711': 'Boise,ID',
'83712': 'Boise,ID',
'83713': 'Boise,ID',
'83714': 'Garden City,ID',
'83715': 'Boise,ID',
'83716': 'Boise,ID',
'83717': 'Boise,ID',
'83719': 'Boise,ID',
'83720': 'Boise,ID',
'83721': 'Boise,ID',
'83722': 'Boise,ID',
'83723': 'Boise,ID',
'83724': 'Boise,ID',
'83725': 'Boise,ID',
'83726': 'Boise,ID',
'83727': 'Boise,ID',
'83728': 'Boise,ID',
'83729': 'Boise,ID',
'83730': 'Boise,ID',
'83731': 'Boise,ID',
'83732': 'Boise,ID',
'83733': 'Boise,ID',
'83735': 'Boise,ID',
'83744': 'Boise,ID',
'83756': 'Boise,ID',
'83757': 'Boise,ID',
'83788': 'Boise,ID',
'83799': 'Boise,ID',
'83801': 'Athol,ID',
'83802': 'Avery,ID',
'83803': 'Bayview,ID',
'83804': 'Blanchard,ID',
'83805': 'Bonners Ferry,ID',
'83806': 'Bovill,ID',
'83808': 'Calder,ID',
'83809': 'Careywood,ID',
'83810': 'Cataldo,ID',
'83811': 'Clark Fork,ID',
'83812': 'Clarkia,ID',
'83813': 'Cocolalla,ID',
'83814': 'Coeur D Alene,ID',
'83815': 'Coeur D Alene,ID',
'83816': 'Coeur D Alene,ID',
'83821': 'Coolin,ID',
'83822': 'Oldtown,ID',
'83823': 'Deary,ID',
'83824': 'Desmet,ID',
'83825': 'Dover,ID',
'83826': 'Eastport,ID',
'83827': 'Elk River,ID',
'83830': 'Fernwood,ID',
'83832': 'Genesee,ID',
'83833': 'Harrison,ID',
'83834': 'Harvard,ID',
'83835': 'Hayden,ID',
'83836': 'Hope,ID',
'83837': 'Kellogg,ID',
'83839': 'Kingston,ID',
'83840': 'Kootenai,ID',
'83841': 'Laclede,ID',
'83842': 'Medimont,ID',
'83843': 'Moscow,ID',
'83844': 'Moscow,ID',
'83845': 'Moyie Springs,ID',
'83846': 'Mullan,ID',
'83847': 'Naples,ID',
'83848': 'Nordman,ID',
'83849': 'Osburn,ID',
'83850': 'Pinehurst,ID',
'83851': 'Plummer,ID',
'83852': 'Ponderay,ID',
'83853': 'Porthill,ID',
'83854': 'Post Falls,ID',
'83855': 'Potlatch,ID',
'83856': 'Priest River,ID',
'83857': 'Princeton,ID',
'83858': 'Rathdrum,ID',
'83860': 'Sagle,ID',
'83861': 'Saint Maries,ID',
'83862': 'Samuels,ID',
'83864': 'Sandpoint,ID',
'83865': 'Colburn,ID',
'83866': 'Santa,ID',
'83867': 'Silverton,ID',
'83868': 'Smelterville,ID',
'83869': 'Spirit Lake,ID',
'83870': 'Tensed,ID',
'83871': 'Troy,ID',
'83872': 'Viola,ID',
'83873': 'Wallace,ID',
'83874': 'Murray,ID',
'83876': 'Worley,ID',
'83877': 'Post Falls,ID',
'83888': 'Sandpoint,ID',
'84001': 'Altamont,UT',
'84002': 'Altonah,UT',
'84003': 'American Fork,UT',
'84004': 'Alpine,UT',
'84005': 'Lehi,UT',
'84006': 'Bingham Canyon,UT',
'84007': 'Bluebell,UT',
'84008': 'Bonanza,UT',
'84010': 'Bountiful,UT',
'84011': 'Bountiful,UT',
'84013': 'Cedar Valley,UT',
'84014': 'Centerville,UT',
'84015': 'Clearfield,UT',
'84016': 'Clearfield,UT',
'84017': 'Coalville,UT',
'84018': 'Croydon,UT',
'84020': 'Draper,UT',
'84021': 'Duchesne,UT',
'84022': 'Dugway,UT',
'84023': 'Dutch John,UT',
'84024': 'Echo,UT',
'84025': 'Farmington,UT',
'84026': 'Fort Duchesne,UT',
'84027': 'Fruitland,UT',
'84028': 'Garden City,UT',
'84029': 'Grantsville,UT',
'84030': 'Gusher,UT',
'84031': 'Hanna,UT',
'84032': 'Heber City,UT',
'84033': 'Henefer,UT',
'84034': 'Ibapah,UT',
'84035': 'Jensen,UT',
'84036': 'Kamas,UT',
'84037': 'Kaysville,UT',
'84038': 'Laketown,UT',
'84039': 'Lapoint,UT',
'84040': 'Layton,UT',
'84041': 'Layton,UT',
'84042': 'Lindon,UT',
'84043': 'Lehi,UT',
'84044': 'Magna,UT',
'84045': 'Saratoga Springs,UT',
'84046': 'Manila,UT',
'84047': 'Midvale,UT',
'84049': 'Midway,UT',
'84050': 'Morgan,UT',
'84051': 'Mountain Home,UT',
'84052': 'Myton,UT',
'84053': 'Neola,UT',
'84054': 'North Salt Lake,UT',
'84055': 'Oakley,UT',
'84056': 'Hill Afb,UT',
'84057': 'Orem,UT',
'84058': 'Orem,UT',
'84059': 'Orem,UT',
'84060': 'Park City,UT',
'84061': 'Peoa,UT',
'84062': 'Pleasant Grove,UT',
'84063': 'Randlett,UT',
'84064': 'Randolph,UT',
'84065': 'Riverton,UT',
'84066': 'Roosevelt,UT',
'84067': 'Roy,UT',
'84068': 'Park City,UT',
'84069': 'Rush Valley,UT',
'84070': 'Sandy,UT',
'84071': 'Stockton,UT',
'84072': 'Tabiona,UT',
'84073': 'Talmage,UT',
'84074': 'Tooele,UT',
'84075': 'Syracuse,UT',
'84076': 'Tridell,UT',
'84078': 'Vernal,UT',
'84079': 'Vernal,UT',
'84080': 'Vernon,UT',
'84081': 'West Jordan,UT',
'84082': 'Wallsburg,UT',
'84083': 'Wendover,UT',
'84084': 'West Jordan,UT',
'84085': 'Whiterocks,UT',
'84086': 'Woodruff,UT',
'84087': 'Woods Cross,UT',
'84088': 'West Jordan,UT',
'84089': 'Clearfield,UT',
'84090': 'Sandy,UT',
'84091': 'Sandy,UT',
'84092': 'Sandy,UT',
'84093': 'Sandy,UT',
'84094': 'Sandy,UT',
'84095': 'South Jordan,UT',
'84096': 'Riverton,UT',
'84097': 'Orem,UT',
'84098': 'Park City,UT',
'84101': 'Salt Lake City,UT',
'84102': 'Salt Lake City,UT',
'84103': 'Salt Lake City,UT',
'84104': 'Salt Lake City,UT',
'84105': 'Salt Lake City,UT',
'84106': 'Salt Lake City,UT',
'84107': 'Salt Lake City,UT',
'84108': 'Salt Lake City,UT',
'84109': 'Salt Lake City,UT',
'84110': 'Salt Lake City,UT',
'84111': 'Salt Lake City,UT',
'84112': 'Salt Lake City,UT',
'84113': 'Salt Lake City,UT',
'84114': 'Salt Lake City,UT',
'84115': 'Salt Lake City,UT',
'84116': 'Salt Lake City,UT',
'84117': 'Salt Lake City,UT',
'84118': 'Salt Lake City,UT',
'84119': 'Salt Lake City,UT',
'84120': 'Salt Lake City,UT',
'84121': 'Salt Lake City,UT',
'84122': 'Salt Lake City,UT',
'84123': 'Salt Lake City,UT',
'84124': 'Salt Lake City,UT',
'84125': 'Salt Lake City,UT',
'84126': 'Salt Lake City,UT',
'84127': 'Salt Lake City,UT',
'84128': 'Salt Lake City,UT',
'84130': 'Salt Lake City,UT',
'84131': 'Salt Lake City,UT',
'84132': 'Salt Lake City,UT',
'84133': 'Salt Lake City,UT',
'84134': 'Salt Lake City,UT',
'84135': 'Salt Lake City,UT',
'84136': 'Salt Lake City,UT',
'84138': 'Salt Lake City,UT',
'84139': 'Salt Lake City,UT',
'84140': 'Salt Lake City,UT',
'84141': 'Salt Lake City,UT',
'84142': 'Salt Lake City,UT',
'84143': 'Salt Lake City,UT',
'84144': 'Salt Lake City,UT',
'84145': 'Salt Lake City,UT',
'84147': 'Salt Lake City,UT',
'84148': 'Salt Lake City,UT',
'84150': 'Salt Lake City,UT',
'84151': 'Salt Lake City,UT',
'84152': 'Salt Lake City,UT',
'84153': 'Salt Lake City,UT',
'84157': 'Salt Lake City,UT',
'84158': 'Salt Lake City,UT',
'84165': 'Salt Lake City,UT',
'84170': 'Salt Lake City,UT',
'84171': 'Salt Lake City,UT',
'84180': 'Salt Lake City,UT',
'84184': 'Salt Lake City,UT',
'84189': 'Salt Lake City,UT',
'84190': 'Salt Lake City,UT',
'84193': 'Salt Lake City,UT',
'84194': 'Salt Lake City,UT',
'84195': 'Salt Lake City,UT',
'84199': 'Salt Lake City,UT',
'84201': 'Ogden,UT',
'84244': 'Ogden,UT',
'84301': 'Bear River City,UT',
'84302': 'Brigham City,UT',
'84304': 'Cache Junction,UT',
'84305': 'Clarkston,UT',
'84306': 'Collinston,UT',
'84307': 'Corinne,UT',
'84308': 'Cornish,UT',
'84309': 'Deweyville,UT',
'84310': 'Eden,UT',
'84311': 'Fielding,UT',
'84312': 'Garland,UT',
'84313': 'Grouse Creek,UT',
'84314': 'Honeyville,UT',
'84315': 'Hooper,UT',
'84316': 'Howell,UT',
'84317': 'Huntsville,UT',
'84318': 'Hyde Park,UT',
'84319': 'Hyrum,UT',
'84320': 'Lewiston,UT',
'84321': 'Logan,UT',
'84322': 'Logan,UT',
'84323': 'Logan,UT',
'84324': 'Mantua,UT',
'84325': 'Mendon,UT',
'84326': 'Millville,UT',
'84327': 'Newton,UT',
'84328': 'Paradise,UT',
'84329': 'Park Valley,UT',
'84330': 'Plymouth,UT',
'84331': 'Portage,UT',
'84332': 'Providence,UT',
'84333': 'Richmond,UT',
'84334': 'Riverside,UT',
'84335': 'Smithfield,UT',
'84336': 'Snowville,UT',
'84337': 'Tremonton,UT',
'84338': 'Trenton,UT',
'84339': 'Wellsville,UT',
'84340': 'Willard,UT',
'84341': 'Logan,UT',
'84401': 'Ogden,UT',
'84402': 'Ogden,UT',
'84403': 'Ogden,UT',
'84404': 'Ogden,UT',
'84405': 'Ogden,UT',
'84407': 'Ogden,UT',
'84408': 'Ogden,UT',
'84409': 'Ogden,UT',
'84412': 'Ogden,UT',
'84414': 'Ogden,UT',
'84415': 'Ogden,UT',
'84501': 'Price,UT',
'84510': 'Aneth,UT',
'84511': 'Blanding,UT',
'84512': 'Bluff,UT',
'84513': 'Castle Dale,UT',
'84515': 'Cisco,UT',
'84516': 'Clawson,UT',
'84518': 'Cleveland,UT',
'84520': 'East Carbon,UT',
'84521': 'Elmo,UT',
'84522': 'Emery,UT',
'84523': 'Ferron,UT',
'84525': 'Green River,UT',
'84526': 'Helper,UT',
'84527': 'Hiawatha,UT',
'84528': 'Huntington,UT',
'84529': 'Kenilworth,UT',
'84530': 'La Sal,UT',
'84531': 'Mexican Hat,UT',
'84532': 'Moab,UT',
'84533': 'Lake Powell,UT',
'84534': 'Montezuma Creek,UT',
'84535': 'Monticello,UT',
'84536': 'Monument Valley,UT',
'84537': 'Orangeville,UT',
'84539': 'Sunnyside,UT',
'84540': 'Thompson,UT',
'84542': 'Wellington,UT',
'84601': 'Provo,UT',
'84602': 'Provo,UT',
'84603': 'Provo,UT',
'84604': 'Provo,UT',
'84605': 'Provo,UT',
'84606': 'Provo,UT',
'84620': 'Aurora,UT',
'84621': 'Axtell,UT',
'84622': 'Centerfield,UT',
'84623': 'Chester,UT',
'84624': 'Delta,UT',
'84626': 'Elberta,UT',
'84627': 'Ephraim,UT',
'84628': 'Eureka,UT',
'84629': 'Fairview,UT',
'84630': 'Fayette,UT',
'84631': 'Fillmore,UT',
'84632': 'Fountain Green,UT',
'84633': 'Goshen,UT',
'84634': 'Gunnison,UT',
'84635': 'Hinckley,UT',
'84636': 'Holden,UT',
'84637': 'Kanosh,UT',
'84638': 'Leamington,UT',
'84639': 'Levan,UT',
'84640': 'Lynndyl,UT',
'84642': 'Manti,UT',
'84643': 'Mayfield,UT',
'84644': 'Meadow,UT',
'84645': 'Mona,UT',
'84646': 'Moroni,UT',
'84647': 'Mount Pleasant,UT',
'84648': 'Nephi,UT',
'84649': 'Oak City,UT',
'84650': 'Oasis,UT',
'84651': 'Payson,UT',
'84652': 'Redmond,UT',
'84653': 'Salem,UT',
'84654': 'Salina,UT',
'84655': 'Santaquin,UT',
'84656': 'Scipio,UT',
'84657': 'Sigurd,UT',
'84660': 'Spanish Fork,UT',
'84662': 'Spring City,UT',
'84663': 'Springville,UT',
'84664': 'Mapleton,UT',
'84665': 'Sterling,UT',
'84667': 'Wales,UT',
'84701': 'Richfield,UT',
'84710': 'Alton,UT',
'84711': 'Annabella,UT',
'84712': 'Antimony,UT',
'84713': 'Beaver,UT',
'84714': 'Beryl,UT',
'84715': 'Bicknell,UT',
'84716': 'Boulder,UT',
'84717': 'Bryce Canyon,UT',
'84718': 'Cannonville,UT',
'84719': 'Brian Head,UT',
'84720': 'Cedar City,UT',
'84721': 'Cedar City,UT',
'84722': 'Central,UT',
'84723': 'Circleville,UT',
'84724': 'Elsinore,UT',
'84725': 'Enterprise,UT',
'84726': 'Escalante,UT',
'84728': 'Garrison,UT',
'84729': 'Glendale,UT',
'84730': 'Glenwood,UT',
'84731': 'Greenville,UT',
'84732': 'Greenwich,UT',
'84733': 'Gunlock,UT',
'84734': 'Hanksville,UT',
'84735': 'Hatch,UT',
'84736': 'Henrieville,UT',
'84737': 'Hurricane,UT',
'84738': 'Ivins,UT',
'84739': 'Joseph,UT',
'84740': 'Junction,UT',
'84741': 'Kanab,UT',
'84742': 'Kanarraville,UT',
'84743': 'Kingston,UT',
'84744': 'Koosharem,UT',
'84745': 'La Verkin,UT',
'84746': 'Leeds,UT',
'84747': 'Loa,UT',
'84749': 'Lyman,UT',
'84750': 'Marysvale,UT',
'84751': 'Milford,UT',
'84752': 'Minersville,UT',
'84753': 'Modena,UT',
'84754': 'Monroe,UT',
'84755': 'Mount Carmel,UT',
'84756': 'Newcastle,UT',
'84757': 'New Harmony,UT',
'84758': 'Orderville,UT',
'84759': 'Panguitch,UT',
'84760': 'Paragonah,UT',
'84761': 'Parowan,UT',
'84762': 'Duck Creek Village,UT',
'84763': 'Rockville,UT',
'84764': 'Bryce,UT',
'84765': 'Santa Clara,UT',
'84766': 'Sevier,UT',
'84767': 'Springdale,UT',
'84770': 'Saint George,UT',
'84771': 'Saint George,UT',
'84772': 'Summit,UT',
'84773': 'Teasdale,UT',
'84774': 'Toquerville,UT',
'84775': 'Torrey,UT',
'84776': 'Tropic,UT',
'84779': 'Virgin,UT',
'84780': 'Washington,UT',
'84781': 'Pine Valley,UT',
'84782': 'Veyo,UT',
'84783': 'Dammeron Valley,UT',
'84784': 'Hildale,UT',
'84790': 'Saint George,UT',
'84791': 'Saint George,UT',
'85001': 'Phoenix,AZ',
'85002': 'Phoenix,AZ',
'85003': 'Phoenix,AZ',
'85004': 'Phoenix,AZ',
'85005': 'Phoenix,AZ',
'85006': 'Phoenix,AZ',
'85007': 'Phoenix,AZ',
'85008': 'Phoenix,AZ',
'85009': 'Phoenix,AZ',
'85010': 'Phoenix,AZ',
'85011': 'Phoenix,AZ',
'85012': 'Phoenix,AZ',
'85013': 'Phoenix,AZ',
'85014': 'Phoenix,AZ',
'85015': 'Phoenix,AZ',
'85016': 'Phoenix,AZ',
'85017': 'Phoenix,AZ',
'85018': 'Phoenix,AZ',
'85019': 'Phoenix,AZ',
'85020': 'Phoenix,AZ',
'85021': 'Phoenix,AZ',
'85022': 'Phoenix,AZ',
'85023': 'Phoenix,AZ',
'85024': 'Phoenix,AZ',
'85025': 'Phoenix,AZ',
'85026': 'Phoenix,AZ',
'85027': 'Phoenix,AZ',
'85028': 'Phoenix,AZ',
'85029': 'Phoenix,AZ',
'85030': 'Phoenix,AZ',
'85031': 'Phoenix,AZ',
'85032': 'Phoenix,AZ',
'85033': 'Phoenix,AZ',
'85034': 'Phoenix,AZ',
'85035': 'Phoenix,AZ',
'85036': 'Phoenix,AZ',
'85037': 'Phoenix,AZ',
'85038': 'Phoenix,AZ',
'85039': 'Phoenix,AZ',
'85040': 'Phoenix,AZ',
'85041': 'Phoenix,AZ',
'85042': 'Phoenix,AZ',
'85043': 'Phoenix,AZ',
'85044': 'Phoenix,AZ',
'85045': 'Phoenix,AZ',
'85046': 'Phoenix,AZ',
'85048': 'Phoenix,AZ',
'85050': 'Phoenix,AZ',
'85051': 'Phoenix,AZ',
'85053': 'Phoenix,AZ',
'85054': 'Phoenix,AZ',
'85055': 'Phoenix,AZ',
'85060': 'Phoenix,AZ',
'85061': 'Phoenix,AZ',
'85062': 'Phoenix,AZ',
'85063': 'Phoenix,AZ',
'85064': 'Phoenix,AZ',
'85065': 'Phoenix,AZ',
'85066': 'Phoenix,AZ',
'85067': 'Phoenix,AZ',
'85068': 'Phoenix,AZ',
'85069': 'Phoenix,AZ',
'85070': 'Phoenix,AZ',
'85071': 'Phoenix,AZ',
'85072': 'Phoenix,AZ',
'85073': 'Phoenix,AZ',
'85074': 'Phoenix,AZ',
'85075': 'Phoenix,AZ',
'85076': 'Phoenix,AZ',
'85077': 'Phoenix,AZ',
'85078': 'Phoenix,AZ',
'85079': 'Phoenix,AZ',
'85080': 'Phoenix,AZ',
'85082': 'Phoenix,AZ',
'85083': 'Phoenix,AZ',
'85085': 'Phoenix,AZ',
'85086': 'Phoenix,AZ',
'85087': 'New River,AZ',
'85096': 'Census Bureau,AZ',
'85097': 'Census Bureau,AZ',
'85098': 'Phoenix,AZ',
'85099': 'Phoenix,AZ',
'85117': 'Apache Jct,AZ',
'85118': 'Suprston Mtn,AZ',
'85119': 'Apache Jct,AZ',
'85120': 'Apache Jct,AZ',
'85121': 'Sacaton,AZ',
'85122': 'Eleven Mile Corner,AZ',
'85123': 'Casa Grande,AZ',
'85127': 'Queen Creek,AZ',
'85128': 'Coolidge,AZ',
'85130': 'Casa Grande,AZ',
'85131': 'Toltec,AZ',
'85132': 'Florence,AZ',
'85135': 'Hayden,AZ',
'85137': 'Kearny,AZ',
'85138': 'Maricopa,AZ',
'85139': 'Mobile,AZ',
'85140': 'San Tan Valley,AZ',
'85141': 'Picacho,AZ',
'85142': 'Chandler Hts,AZ',
'85143': 'Queen Creek,AZ',
'85145': 'Red Rock,AZ',
'85147': 'Sacaton,AZ',
'85172': 'Stanfield,AZ',
'85173': 'Superior,AZ',
'85178': 'Apache Jct,AZ',
'85190': 'Apache Junction,AZ',
'85191': 'Valley Farms,AZ',
'85192': 'Dudleyville,AZ',
'85193': 'Casa Grande,AZ',
'85194': 'Casa Grande,AZ',
'85201': 'Mesa,AZ',
'85202': 'Mesa,AZ',
'85203': 'Mesa,AZ',
'85204': 'Mesa,AZ',
'85205': 'Mesa,AZ',
'85206': 'Mesa,AZ',
'85207': 'Mesa,AZ',
'85208': 'Mesa,AZ',
'85209': 'Mesa,AZ',
'85210': 'Mesa,AZ',
'85211': 'Mesa,AZ',
'85212': 'Mesa,AZ',
'85213': 'Mesa,AZ',
'85214': 'Mesa,AZ',
'85215': 'Mesa,AZ',
'85216': 'Mesa,AZ',
'85217': 'Apache Junction,AZ',
'85218': 'Apache Junction,AZ',
'85219': 'Apache Junction,AZ',
'85220': 'Apache Junction,AZ',
'85221': 'Bapchule,AZ',
'85222': 'Casa Grande,AZ',
'85223': 'Arizona City,AZ',
'85224': 'Chandler,AZ',
'85225': 'Chandler,AZ',
'85226': 'Chandler,AZ',
'85227': 'Chandler Heights,AZ',
'85228': 'Coolidge,AZ',
'85230': 'Casa Grande,AZ',
'85231': 'Eloy,AZ',
'85232': 'Florence,AZ',
'85233': 'Gilbert,AZ',
'85234': 'Gilbert,AZ',
'85235': 'Hayden,AZ',
'85236': 'Higley,AZ',
'85237': 'Kearny,AZ',
'85239': 'Maricopa,AZ',
'85241': 'Picacho,AZ',
'85242': 'Queen Creek,AZ',
'85244': 'Chandler,AZ',
'85245': 'Red Rock,AZ',
'85246': 'Chandler,AZ',
'85247': 'Sacaton,AZ',
'85248': 'Chandler,AZ',
'85249': 'Chandler,AZ',
'85250': 'Scottsdale,AZ',
'85251': 'Scottsdale,AZ',
'85252': 'Scottsdale,AZ',
'85253': 'Paradise Valley,AZ',
'85254': 'Scottsdale,AZ',
'85255': 'Scottsdale,AZ',
'85256': 'Scottsdale,AZ',
'85257': 'Scottsdale,AZ',
'85258': 'Scottsdale,AZ',
'85259': 'Scottsdale,AZ',
'85260': 'Scottsdale,AZ',
'85261': 'Scottsdale,AZ',
'85262': 'Scottsdale,AZ',
'85263': 'Rio Verde,AZ',
'85264': 'Fort Mcdowell,AZ',
'85266': 'Scottsdale,AZ',
'85267': 'Scottsdale,AZ',
'85268': 'Fountain Hills,AZ',
'85269': 'Fountain Hills,AZ',
'85271': 'Scottsdale,AZ',
'85272': 'Stanfield,AZ',
'85273': 'Superior,AZ',
'85274': 'Mesa,AZ',
'85275': 'Mesa,AZ',
'85277': 'Mesa,AZ',
'85278': 'Apache Junction,AZ',
'85279': 'Florence,AZ',
'85280': 'Tempe,AZ',
'85281': 'Tempe,AZ',
'85282': 'Tempe,AZ',
'85283': 'Tempe,AZ',
'85284': 'Tempe,AZ',
'85285': 'Tempe,AZ',
'85287': 'Tempe,AZ',
'85289': 'Tempe,AZ',
'85290': 'Tortilla Flat,AZ',
'85291': 'Valley Farms,AZ',
'85292': 'Winkelman,AZ',
'85296': 'Gilbert,AZ',
'85297': 'Gilbert,AZ',
'85299': 'Gilbert,AZ',
'85301': 'Glendale,AZ',
'85302': 'Glendale,AZ',
'85303': 'Glendale,AZ',
'85304': 'Glendale,AZ',
'85305': 'Glendale,AZ',
'85306': 'Glendale,AZ',
'85307': 'Glendale,AZ',
'85308': 'Glendale,AZ',
'85309': 'Luke Afb,AZ',
'85310': 'Glendale,AZ',
'85311': 'Glendale,AZ',
'85312': 'Glendale,AZ',
'85313': 'Glendale,AZ',
'85318': 'Glendale,AZ',
'85320': 'Aguila,AZ',
'85321': 'Ajo,AZ',
'85322': 'Arlington,AZ',
'85323': 'Avondale,AZ',
'85324': 'Black Canyon City,AZ',
'85325': 'Bouse,AZ',
'85326': 'Buckeye,AZ',
'85327': 'Cave Creek,AZ',
'85328': 'Cibola,AZ',
'85329': 'Cashion,AZ',
'85331': 'Cave Creek,AZ',
'85332': 'Congress,AZ',
'85333': 'Dateland,AZ',
'85334': 'Ehrenberg,AZ',
'85335': 'El Mirage,AZ',
'85336': 'Gadsden,AZ',
'85337': 'Gila Bend,AZ',
'85338': 'Goodyear,AZ',
'85339': 'Laveen,AZ',
'85340': 'Litchfield Park,AZ',
'85341': 'Lukeville,AZ',
'85342': 'Morristown,AZ',
'85343': 'Palo Verde,AZ',
'85344': 'Parker,AZ',
'85345': 'Peoria,AZ',
'85346': 'Quartzsite,AZ',
'85347': 'Roll,AZ',
'85348': 'Salome,AZ',
'85349': 'San Luis,AZ',
'85350': 'Somerton,AZ',
'85351': 'Sun City,AZ',
'85352': 'Tacna,AZ',
'85353': 'Tolleson,AZ',
'85354': 'Tonopah,AZ',
'85355': 'Waddell,AZ',
'85356': 'Wellton,AZ',
'85357': 'Wenden,AZ',
'85358': 'Wickenburg,AZ',
'85359': 'Quartzsite,AZ',
'85360': 'Wikieup,AZ',
'85361': 'Wittmann,AZ',
'85362': 'Yarnell,AZ',
'85363': 'Youngtown,AZ',
'85364': 'Yuma,AZ',
'85365': 'Yuma,AZ',
'85366': 'Yuma,AZ',
'85367': 'Yuma,AZ',
'85369': 'Yuma,AZ',
'85371': 'Poston,AZ',
'85372': 'Sun City,AZ',
'85373': 'Sun City,AZ',
'85374': 'Surprise,AZ',
'85375': 'Sun City West,AZ',
'85376': 'Sun City West,AZ',
'85377': 'Carefree,AZ',
'85378': 'Surprise,AZ',
'85379': 'Surprise,AZ',
'85380': 'Peoria,AZ',
'85381': 'Peoria,AZ',
'85382': 'Peoria,AZ',
'85383': 'Peoria,AZ',
'85385': 'Peoria,AZ',
'85387': 'Surprise,AZ',
'85388': 'Surprise,AZ',
'85390': 'Wickenburg,AZ',
'85396': 'Buckeye,AZ',
'85501': 'Globe,AZ',
'85502': 'Globe,AZ',
'85530': 'Bylas,AZ',
'85531': 'Central,AZ',
'85532': 'Claypool,AZ',
'85533': 'Clifton,AZ',
'85534': 'Duncan,AZ',
'85535': 'Eden,AZ',
'85536': 'Fort Thomas,AZ',
'85539': 'Miami,AZ',
'85540': 'Morenci,AZ',
'85541': 'Payson,AZ',
'85542': 'Peridot,AZ',
'85543': 'Pima,AZ',
'85544': 'Pine,AZ',
'85545': 'Roosevelt,AZ',
'85546': 'Safford,AZ',
'85547': 'Payson,AZ',
'85548': 'Safford,AZ',
'85550': 'San Carlos,AZ',
'85551': 'Solomon,AZ',
'85552': 'Thatcher,AZ',
'85553': 'Tonto Basin,AZ',
'85554': 'Young,AZ',
'85601': 'Arivaca,AZ',
'85602': 'Benson,AZ',
'85603': 'Bisbee,AZ',
'85605': 'Bowie,AZ',
'85606': 'Cochise,AZ',
'85607': 'Douglas,AZ',
'85608': 'Douglas,AZ',
'85609': 'Dragoon,AZ',
'85610': 'Elfrida,AZ',
'85611': 'Elgin,AZ',
'85613': 'Fort Huachuca,AZ',
'85614': 'Green Valley,AZ',
'85615': 'Hereford,AZ',
'85616': 'Huachuca City,AZ',
'85617': 'Mc Neal,AZ',
'85618': 'Mammoth,AZ',
'85619': 'Mount Lemmon,AZ',
'85620': 'Naco,AZ',
'85621': 'Nogales,AZ',
'85622': 'Green Valley,AZ',
'85623': 'Oracle,AZ',
'85624': 'Patagonia,AZ',
'85625': 'Pearce,AZ',
'85626': 'Pirtleville,AZ',
'85627': 'Pomerene,AZ',
'85628': 'Nogales,AZ',
'85629': 'Sahuarita,AZ',
'85630': 'Saint David,AZ',
'85631': 'San Manuel,AZ',
'85632': 'San Simon,AZ',
'85633': 'Sasabe,AZ',
'85634': 'Sells,AZ',
'85635': 'Sierra Vista,AZ',
'85636': 'Sierra Vista,AZ',
'85637': 'Sonoita,AZ',
'85638': 'Tombstone,AZ',
'85639': 'Topawa,AZ',
'85640': 'Tumacacori,AZ',
'85641': 'Vail,AZ',
'85643': 'Willcox,AZ',
'85644': 'Willcox,AZ',
'85645': 'Amado,AZ',
'85646': 'Tubac,AZ',
'85648': 'Rio Rico,AZ',
'85650': 'Sierra Vista,AZ',
'85652': 'Cortaro,AZ',
'85653': 'Marana,AZ',
'85654': 'Rillito,AZ',
'85655': 'Douglas,AZ',
'85662': 'Nogales,AZ',
'85670': 'Fort Huachuca,AZ',
'85671': 'Sierra Vista,AZ',
'85701': 'Tucson,AZ',
'85702': 'Tucson,AZ',
'85703': 'Tucson,AZ',
'85704': 'Tucson,AZ',
'85705': 'Tucson,AZ',
'85706': 'Tucson,AZ',
'85707': 'Tucson,AZ',
'85708': 'Tucson,AZ',
'85709': 'Tucson,AZ',
'85710': 'Tucson,AZ',
'85711': 'Tucson,AZ',
'85712': 'Tucson,AZ',
'85713': 'Tucson,AZ',
'85714': 'Tucson,AZ',
'85715': 'Tucson,AZ',
'85716': 'Tucson,AZ',
'85717': 'Tucson,AZ',
'85718': 'Tucson,AZ',
'85719': 'Tucson,AZ',
'85720': 'Tucson,AZ',
'85721': 'Tucson,AZ',
'85722': 'Tucson,AZ',
'85723': 'Tucson,AZ',
'85724': 'Tucson,AZ',
'85725': 'Tucson,AZ',
'85726': 'Tucson,AZ',
'85728': 'Tucson,AZ',
'85730': 'Tucson,AZ',
'85731': 'Tucson,AZ',
'85732': 'Tucson,AZ',
'85733': 'Tucson,AZ',
'85734': 'Tucson,AZ',
'85735': 'Tucson,AZ',
'85736': 'Tucson,AZ',
'85737': 'Tucson,AZ',
'85738': 'Catalina,AZ',
'85739': 'Tucson,AZ',
'85740': 'Tucson,AZ',
'85741': 'Tucson,AZ',
'85742': 'Tucson,AZ',
'85743': 'Tucson,AZ',
'85744': 'Tucson,AZ',
'85745': 'Tucson,AZ',
'85746': 'Tucson,AZ',
'85747': 'Tucson,AZ',
'85748': 'Tucson,AZ',
'85749': 'Tucson,AZ',
'85750': 'Tucson,AZ',
'85751': 'Tucson,AZ',
'85752': 'Tucson,AZ',
'85754': 'Tucson,AZ',
'85755': 'Tucson,AZ',
'85756': 'Tucson,AZ',
'85757': 'Tucson,AZ',
'85775': 'Tucson,AZ',
'85777': 'Tucson,AZ',
'85901': 'Show Low,AZ',
'85902': 'Show Low,AZ',
'85911': 'Cibecue,AZ',
'85912': 'White Mountain Lake,AZ',
'85920': 'Alpine,AZ',
'85922': 'Blue,AZ',
'85923': 'Clay Springs,AZ',
'85924': 'Concho,AZ',
'85925': 'Eagar,AZ',
'85926': 'Fort Apache,AZ',
'85927': 'Greer,AZ',
'85928': 'Heber,AZ',
'85929': 'Lakeside,AZ',
'85930': 'Mcnary,AZ',
'85931': 'Forest Lakes,AZ',
'85932': 'Nutrioso,AZ',
'85933': 'Overgaard,AZ',
'85934': 'Pinedale,AZ',
'85935': 'Pinetop,AZ',
'85936': 'Saint Johns,AZ',
'85937': 'Snowflake,AZ',
'85938': 'Springerville,AZ',
'85939': 'Taylor,AZ',
'85940': 'Vernon,AZ',
'85941': 'Whiteriver,AZ',
'85942': 'Woodruff,AZ',
'86001': 'Flagstaff,AZ',
'86002': 'Flagstaff,AZ',
'86003': 'Flagstaff,AZ',
'86004': 'Flagstaff,AZ',
'86011': 'Flagstaff,AZ',
'86015': 'Bellemont,AZ',
'86016': 'Gray Mountain,AZ',
'86017': 'Munds Park,AZ',
'86018': 'Parks,AZ',
'86020': 'Cameron,AZ',
'86021': 'Colorado City,AZ',
'86022': 'Fredonia,AZ',
'86023': 'Grand Canyon,AZ',
'86024': 'Happy Jack,AZ',
'86025': 'Holbrook,AZ',
'86028': 'Petrified Forest Natl Pk,AZ',
'86029': 'Sun Valley,AZ',
'86030': 'Hotevilla,AZ',
'86031': 'Indian Wells,AZ',
'86032': 'Joseph City,AZ',
'86033': 'Kayenta,AZ',
'86034': 'Keams Canyon,AZ',
'86035': 'Leupp,AZ',
'86036': 'Marble Canyon,AZ',
'86038': 'Mormon Lake,AZ',
'86039': 'Kykotsmovi Village,AZ',
'86040': 'Page,AZ',
'86042': 'Polacca,AZ',
'86043': 'Second Mesa,AZ',
'86044': 'Tonalea,AZ',
'86045': 'Tuba City,AZ',
'86046': 'Williams,AZ',
'86047': 'Winslow,AZ',
'86052': 'North Rim,AZ',
'86053': 'Kaibito,AZ',
'86054': 'Shonto,AZ',
'86301': 'Prescott,AZ',
'86302': 'Prescott,AZ',
'86303': 'Prescott,AZ',
'86304': 'Prescott,AZ',
'86305': 'Prescott,AZ',
'86312': 'Prescott Valley,AZ',
'86313': 'Prescott,AZ',
'86314': 'Prescott Valley,AZ',
'86315': 'Prescott,AZ',
'86320': 'Ash Fork,AZ',
'86321': 'Bagdad,AZ',
'86322': 'Camp Verde,AZ',
'86323': 'Chino Valley,AZ',
'86324': 'Clarkdale,AZ',
'86325': 'Cornville,AZ',
'86326': 'Cottonwood,AZ',
'86327': 'Dewey,AZ',
'86329': 'Humboldt,AZ',
'86330': 'Iron Springs,AZ',
'86331': 'Jerome,AZ',
'86332': 'Kirkland,AZ',
'86333': 'Mayer,AZ',
'86334': 'Paulden,AZ',
'86335': 'Rimrock,AZ',
'86336': 'Sedona,AZ',
'86337': 'Seligman,AZ',
'86338': 'Skull Valley,AZ',
'86339': 'Sedona,AZ',
'86340': 'Sedona,AZ',
'86341': 'Sedona,AZ',
'86342': 'Lake Montezuma,AZ',
'86343': 'Crown King,AZ',
'86351': 'Sedona,AZ',
'86401': 'Kingman,AZ',
'86402': 'Kingman,AZ',
'86403': 'Lake Havasu City,AZ',
'86404': 'Lake Havasu City,AZ',
'86405': 'Lake Havasu City,AZ',
'86406': 'Lake Havasu City,AZ',
'86409': 'Kingman,AZ',
'86411': 'Hackberry,AZ',
'86412': 'Hualapai,AZ',
'86413': 'Golden Valley,AZ',
'86426': 'Fort Mohave,AZ',
'86427': 'Fort Mohave,AZ',
'86429': 'Bullhead City,AZ',
'86430': 'Bullhead City,AZ',
'86431': 'Chloride,AZ',
'86432': 'Littlefield,AZ',
'86433': 'Oatman,AZ',
'86434': 'Peach Springs,AZ',
'86435': 'Supai,AZ',
'86436': 'Topock,AZ',
'86437': 'Valentine,AZ',
'86438': 'Yucca,AZ',
'86439': 'Bullhead City,AZ',
'86440': 'Mohave Valley,AZ',
'86441': 'Dolan Springs,AZ',
'86442': 'Bullhead City,AZ',
'86443': 'Temple Bar Marina,AZ',
'86444': 'Meadview,AZ',
'86445': 'Willow Beach,AZ',
'86446': 'Mohave Valley,AZ',
'86502': 'Chambers,AZ',
'86503': 'Chinle,AZ',
'86504': 'Fort Defiance,AZ',
'86505': 'Ganado,AZ',
'86506': 'Houck,AZ',
'86507': 'Lukachukai,AZ',
'86508': 'Lupton,AZ',
'86510': 'Pinon,AZ',
'86511': 'Saint Michaels,AZ',
'86512': 'Sanders,AZ',
'86514': 'Teec Nos Pos,AZ',
'86515': 'Window Rock,AZ',
'86520': 'Blue Gap,AZ',
'86535': 'Dennehotso,AZ',
'86538': 'Many Farms,AZ',
'86540': 'Nazlini,AZ',
'86544': 'Red Valley,AZ',
'86545': 'Rock Point,AZ',
'86547': 'Round Rock,AZ',
'86549': 'Sawmill,AZ',
'86555': 'Douglas,AZ',
'86556': 'Tsaile,AZ',
'87001': 'Algodones,NM',
'87002': 'Belen,NM',
'87004': 'Bernalillo,NM',
'87005': 'Bluewater,NM',
'87006': 'Bosque,NM',
'87007': 'Casa Blanca,NM',
'87008': 'Cedar Crest,NM',
'87009': 'Cedarvale,NM',
'87010': 'Cerrillos,NM',
'87011': 'Claunch,NM',
'87012': 'Coyote,NM',
'87013': 'Cuba,NM',
'87014': 'Cubero,NM',
'87015': 'Edgewood,NM',
'87016': 'Estancia,NM',
'87017': 'Gallina,NM',
'87018': 'Counselor,NM',
'87020': 'Grants,NM',
'87021': 'Milan,NM',
'87022': 'Isleta,NM',
'87023': 'Jarales,NM',
'87024': 'Jemez Pueblo,NM',
'87025': 'Jemez Springs,NM',
'87026': 'Laguna,NM',
'87027': 'La Jara,NM',
'87028': 'La Joya,NM',
'87029': 'Lindrith,NM',
'87031': 'Los Lunas,NM',
'87032': 'Mc Intosh,NM',
'87034': 'Pueblo Of Acoma,NM',
'87035': 'Moriarty,NM',
'87036': 'Mountainair,NM',
'87037': 'Nageezi,NM',
'87038': 'New Laguna,NM',
'87040': 'Paguate,NM',
'87041': 'Pena Blanca,NM',
'87042': 'Peralta,NM',
'87043': 'Placitas,NM',
'87044': 'Ponderosa,NM',
'87045': 'Prewitt,NM',
'87046': 'Regina,NM',
'87047': 'Sandia Park,NM',
'87048': 'Corrales,NM',
'87049': 'San Fidel,NM',
'87051': 'San Rafael,NM',
'87052': 'Santo Domingo Pueblo,NM',
'87053': 'San Ysidro,NM',
'87056': 'Stanley,NM',
'87057': 'Tajique,NM',
'87059': 'Tijeras,NM',
'87060': 'Tome,NM',
'87061': 'Torreon,NM',
'87062': 'Veguita,NM',
'87063': 'Willard,NM',
'87064': 'Youngsville,NM',
'87068': 'Bosque Farms,NM',
'87070': 'Clines Corners,NM',
'87072': 'Cochiti Pueblo,NM',
'87083': 'Cochiti Lake,NM',
'87101': 'Albuquerque,NM',
'87102': 'Albuquerque,NM',
'87103': 'Albuquerque,NM',
'87104': 'Albuquerque,NM',
'87105': 'Albuquerque,NM',
'87106': 'Albuquerque,NM',
'87107': 'Albuquerque,NM',
'87108': 'Albuquerque,NM',
'87109': 'Albuquerque,NM',
'87110': 'Albuquerque,NM',
'87111': 'Albuquerque,NM',
'87112': 'Albuquerque,NM',
'87113': 'Albuquerque,NM',
'87114': 'Albuquerque,NM',
'87115': 'Albuquerque,NM',
'87116': 'Albuquerque,NM',
'87117': 'Kirtland Afb,NM',
'87118': 'Albuquerque,NM',
'87119': 'Albuquerque,NM',
'87120': 'Albuquerque,NM',
'87121': 'Albuquerque,NM',
'87122': 'Albuquerque,NM',
'87123': 'Albuquerque,NM',
'87124': 'Rio Rancho,NM',
'87125': 'Albuquerque,NM',
'87131': 'Albuquerque,NM',
'87151': 'Metropolitan Detention Ctr,NM',
'87153': 'Albuquerque,NM',
'87154': 'Albuquerque,NM',
'87158': 'Albuquerque,NM',
'87165': 'Albuquerque,NM',
'87174': 'Rio Rancho,NM',
'87176': 'Albuquerque,NM',
'87181': 'Albuquerque,NM',
'87184': 'Albuquerque,NM',
'87185': 'Albuquerque,NM',
'87187': 'Albuquerque,NM',
'87190': 'Albuquerque,NM',
'87191': 'Albuquerque,NM',
'87192': 'Albuquerque,NM',
'87193': 'Albuquerque,NM',
'87194': 'Albuquerque,NM',
'87195': 'Albuquerque,NM',
'87196': 'Albuquerque,NM',
'87197': 'Albuquerque,NM',
'87198': 'Albuquerque,NM',
'87199': 'Albuquerque,NM',
'87201': 'Albuquerque,NM',
'87301': 'Gallup,NM',
'87302': 'Gallup,NM',
'87305': 'Gallup,NM',
'87310': 'Brimhall,NM',
'87311': 'Church Rock,NM',
'87312': 'Continental Divide,NM',
'87313': 'Crownpoint,NM',
'87315': 'Fence Lake,NM',
'87316': 'Fort Wingate,NM',
'87317': 'Gamerco,NM',
'87319': 'Mentmore,NM',
'87320': 'Mexican Springs,NM',
'87321': 'Ramah,NM',
'87322': 'Rehoboth,NM',
'87323': 'Thoreau,NM',
'87325': 'Tohatchi,NM',
'87326': 'Vanderwagen,NM',
'87327': 'Zuni,NM',
'87328': 'Navajo,NM',
'87347': 'Jamestown,NM',
'87357': 'Pinehill,NM',
'87364': 'Sheep Springs,NM',
'87365': 'Smith Lake,NM',
'87375': 'Yatahey,NM',
'87401': 'Farmington,NM',
'87402': 'Farmington,NM',
'87410': 'Aztec,NM',
'87412': 'Blanco,NM',
'87413': 'Bloomfield,NM',
'87415': 'Flora Vista,NM',
'87416': 'Fruitland,NM',
'87417': 'Kirtland,NM',
'87418': 'La Plata,NM',
'87419': 'Navajo Dam,NM',
'87420': 'Shiprock,NM',
'87421': 'Waterflow,NM',
'87455': 'Newcomb,NM',
'87461': 'Sanostee,NM',
'87499': 'Farmington,NM',
'87500': 'Santa Fe,NM',
'87501': 'Santa Fe,NM',
'87502': 'Santa Fe,NM',
'87503': 'Santa Fe,NM',
'87504': 'Santa Fe,NM',
'87505': 'Santa Fe,NM',
'87506': 'Santa Fe,NM',
'87507': 'Santa Fe,NM',
'87508': 'Santa Fe,NM',
'87509': 'Santa Fe,NM',
'87510': 'Abiquiu,NM',
'87511': 'Alcalde,NM',
'87512': 'Amalia,NM',
'87513': 'Arroyo Hondo,NM',
'87514': 'Arroyo Seco,NM',
'87515': 'Canjilon,NM',
'87516': 'Canones,NM',
'87517': 'Carson,NM',
'87518': 'Cebolla,NM',
'87519': 'Cerro,NM',
'87520': 'Chama,NM',
'87521': 'Chamisal,NM',
'87522': 'Chimayo,NM',
'87523': 'Cordova,NM',
'87524': 'Costilla,NM',
'87525': 'Taos Ski Valley,NM',
'87527': 'Dixon,NM',
'87528': 'Dulce,NM',
'87529': 'El Prado,NM',
'87530': 'El Rito,NM',
'87531': 'Embudo,NM',
'87532': 'Espanola,NM',
'87533': 'Espanola,NM',
'87535': 'Glorieta,NM',
'87537': 'Hernandez,NM',
'87538': 'Ilfeld,NM',
'87539': 'La Madera,NM',
'87540': 'Lamy,NM',
'87543': 'Llano,NM',
'87544': 'Los Alamos,NM',
'87545': 'Los Alamos,NM',
'87548': 'Medanales,NM',
'87549': 'Ojo Caliente,NM',
'87551': 'Los Ojos,NM',
'87552': 'Pecos,NM',
'87553': 'Penasco,NM',
'87554': 'Petaca,NM',
'87556': 'Questa,NM',
'87557': 'Ranchos De Taos,NM',
'87558': 'Red River,NM',
'87560': 'Ribera,NM',
'87562': 'Rowe,NM',
'87564': 'San Cristobal,NM',
'87565': 'San Jose,NM',
'87566': 'San Juan Pueblo,NM',
'87567': 'Santa Cruz,NM',
'87569': 'Serafina,NM',
'87571': 'Taos,NM',
'87573': 'Tererro,NM',
'87574': 'Tesuque,NM',
'87575': 'Tierra Amarilla,NM',
'87576': 'Trampas,NM',
'87577': 'Tres Piedras,NM',
'87578': 'Truchas,NM',
'87579': 'Vadito,NM',
'87580': 'Valdez,NM',
'87581': 'Vallecitos,NM',
'87582': 'Velarde,NM',
'87583': 'Villanueva,NM',
'87592': 'Santa Fe,NM',
'87594': 'Santa Fe,NM',
'87701': 'Las Vegas,NM',
'87710': 'Angel Fire,NM',
'87711': 'Anton Chico,NM',
'87712': 'Buena Vista,NM',
'87713': 'Chacon,NM',
'87714': 'Cimarron,NM',
'87715': 'Cleveland,NM',
'87718': 'Eagle Nest,NM',
'87722': 'Guadalupita,NM',
'87723': 'Holman,NM',
'87724': 'La Loma,NM',
'87728': 'Maxwell,NM',
'87729': 'Miami,NM',
'87730': 'Mills,NM',
'87731': 'Montezuma,NM',
'87732': 'Mora,NM',
'87733': 'Mosquero,NM',
'87734': 'Ocate,NM',
'87735': 'Ojo Feliz,NM',
'87736': 'Rainsville,NM',
'87740': 'Raton,NM',
'87742': 'Rociada,NM',
'87743': 'Roy,NM',
'87745': 'Sapello,NM',
'87746': 'Solano,NM',
'87747': 'Springer,NM',
'87749': 'Ute Park,NM',
'87750': 'Valmora,NM',
'87752': 'Wagon Mound,NM',
'87753': 'Watrous,NM',
'87801': 'Socorro,NM',
'87820': 'Aragon,NM',
'87821': 'Datil,NM',
'87823': 'Lemitar,NM',
'87824': 'Luna,NM',
'87825': 'Magdalena,NM',
'87827': 'Pie Town,NM',
'87828': 'Polvadera,NM',
'87829': 'Quemado,NM',
'87830': 'Reserve,NM',
'87831': 'San Acacia,NM',
'87832': 'San Antonio,NM',
'87901': 'Truth Or Consequences,NM',
'87930': 'Arrey,NM',
'87931': 'Caballo,NM',
'87933': 'Derry,NM',
'87935': 'Elephant Butte,NM',
'87936': 'Garfield,NM',
'87937': 'Hatch,NM',
'87939': 'Monticello,NM',
'87940': 'Rincon,NM',
'87941': 'Salem,NM',
'87942': 'Williamsburg,NM',
'87943': 'Winston,NM',
'88001': 'Las Cruces,NM',
'88002': 'White Sands Missile Range,NM',
'88003': 'Las Cruces,NM',
'88004': 'Las Cruces,NM',
'88005': 'Las Cruces,NM',
'88006': 'Las Cruces,NM',
'88007': 'Las Cruces,NM',
'88008': 'Santa Teresa,NM',
'88009': 'Playas,NM',
'88011': 'Las Cruces,NM',
'88012': 'Las Cruces,NM',
'88013': 'Las Cruces,NM',
'88020': 'Animas,NM',
'88021': 'Anthony,NM',
'88022': 'Arenas Valley,NM',
'88023': 'Bayard,NM',
'88024': 'Berino,NM',
'88025': 'Buckhorn,NM',
'88026': 'Santa Clara,NM',
'88027': 'Chamberino,NM',
'88028': 'Cliff,NM',
'88029': 'Columbus,NM',
'88030': 'Deming,NM',
'88031': 'Deming,NM',
'88032': 'Dona Ana,NM',
'88033': 'Fairacres,NM',
'88034': 'Faywood,NM',
'88036': 'Fort Bayard,NM',
'88038': 'Gila,NM',
'88039': 'Glenwood,NM',
'88040': 'Hachita,NM',
'88041': 'Hanover,NM',
'88042': 'Hillsboro,NM',
'88043': 'Hurley,NM',
'88044': 'La Mesa,NM',
'88045': 'Lordsburg,NM',
'88046': 'Mesilla,NM',
'88047': 'Mesilla Park,NM',
'88048': 'Mesquite,NM',
'88049': 'Mimbres,NM',
'88051': 'Mule Creek,NM',
'88052': 'Organ,NM',
'88053': 'Pinos Altos,NM',
'88054': 'Radium Springs,NM',
'88055': 'Redrock,NM',
'88056': 'Rodeo,NM',
'88058': 'San Miguel,NM',
'88061': 'Silver City,NM',
'88062': 'Silver City,NM',
'88063': 'Sunland Park,NM',
'88065': 'Tyrone,NM',
'88072': 'Vado,NM',
'88101': 'Clovis,NM',
'88102': 'Clovis,NM',
'88103': 'Cannon Afb,NM',
'88112': 'Broadview,NM',
'88113': 'Causey,NM',
'88114': 'Crossroads,NM',
'88115': 'Dora,NM',
'88116': 'Elida,NM',
'88118': 'Floyd,NM',
'88119': 'Fort Sumner,NM',
'88120': 'Grady,NM',
'88121': 'House,NM',
'88122': 'Kenna,NM',
'88123': 'Lingo,NM',
'88124': 'Melrose,NM',
'88125': 'Milnesand,NM',
'88126': 'Pep,NM',
'88130': 'Portales,NM',
'88132': 'Rogers,NM',
'88133': 'Saint Vrain,NM',
'88134': 'Taiban,NM',
'88135': 'Texico,NM',
'88136': 'Yeso,NM',
'88201': 'Roswell,NM',
'88202': 'Roswell,NM',
'88203': 'Roswell,NM',
'88210': 'Artesia,NM',
'88211': 'Artesia,NM',
'88213': 'Caprock,NM',
'88220': 'Carlsbad,NM',
'88221': 'Carlsbad,NM',
'88230': 'Dexter,NM',
'88231': 'Eunice,NM',
'88232': 'Hagerman,NM',
'88240': 'Hobbs,NM',
'88241': 'Hobbs,NM',
'88242': 'Hobbs,NM',
'88244': 'Hobbs,NM',
'88250': 'Hope,NM',
'88252': 'Jal,NM',
'88253': 'Lake Arthur,NM',
'88254': 'Lakewood,NM',
'88255': 'Loco Hills,NM',
'88256': 'Loving,NM',
'88260': 'Lovington,NM',
'88262': 'Mc Donald,NM',
'88263': 'Malaga,NM',
'88264': 'Maljamar,NM',
'88265': 'Monument,NM',
'88267': 'Tatum,NM',
'88268': 'Whites City,NM',
'88301': 'Carrizozo,NM',
'88310': 'Alamogordo,NM',
'88311': 'Alamogordo,NM',
'88312': 'Alto,NM',
'88314': 'Bent,NM',
'88316': 'Capitan,NM',
'88317': 'Cloudcroft,NM',
'88318': 'Corona,NM',
'88321': 'Encino,NM',
'88323': 'Fort Stanton,NM',
'88324': 'Glencoe,NM',
'88325': 'High Rolls Mountain Park,NM',
'88330': 'Holloman Air Force Base,NM',
'88336': 'Hondo,NM',
'88337': 'La Luz,NM',
'88338': 'Lincoln,NM',
'88339': 'Mayhill,NM',
'88340': 'Mescalero,NM',
'88341': 'Nogal,NM',
'88342': 'Orogrande,NM',
'88343': 'Picacho,NM',
'88344': 'Pinon,NM',
'88345': 'Ruidoso,NM',
'88346': 'Ruidoso Downs,NM',
'88347': 'Sacramento,NM',
'88348': 'San Patricio,NM',
'88349': 'Sunspot,NM',
'88350': 'Timberon,NM',
'88351': 'Tinnie,NM',
'88352': 'Tularosa,NM',
'88353': 'Vaughn,NM',
'88354': 'Weed,NM',
'88355': 'Ruidoso,NM',
'88401': 'Tucumcari,NM',
'88410': 'Amistad,NM',
'88411': 'Bard,NM',
'88414': 'Capulin,NM',
'88415': 'Clayton,NM',
'88416': 'Conchas Dam,NM',
'88417': 'Cuervo,NM',
'88418': 'Des Moines,NM',
'88419': 'Folsom,NM',
'88421': 'Garita,NM',
'88422': 'Gladstone,NM',
'88424': 'Grenville,NM',
'88426': 'Logan,NM',
'88427': 'Mc Alister,NM',
'88429': 'Mount Dora,NM',
'88430': 'Nara Visa,NM',
'88431': 'Newkirk,NM',
'88433': 'Quay,NM',
'88434': 'San Jon,NM',
'88435': 'Santa Rosa,NM',
'88436': 'Sedan,NM',
'88437': 'Seneca,NM',
'88439': 'Trementina,NM',
'88441': 'Bell Ranch,NM',
'88510': 'El Paso,TX',
'88511': 'El Paso,TX',
'88512': 'El Paso,TX',
'88513': 'El Paso,TX',
'88514': 'El Paso,TX',
'88515': 'El Paso,TX',
'88516': 'El Paso,TX',
'88517': 'El Paso,TX',
'88518': 'El Paso,TX',
'88519': 'El Paso,TX',
'88520': 'El Paso,TX',
'88521': 'El Paso,TX',
'88523': 'El Paso,TX',
'88524': 'El Paso,TX',
'88525': 'El Paso,TX',
'88526': 'El Paso,TX',
'88527': 'El Paso,TX',
'88528': 'El Paso,TX',
'88529': 'El Paso,TX',
'88530': 'El Paso,TX',
'88531': 'El Paso,TX',
'88532': 'El Paso,TX',
'88533': 'El Paso,TX',
'88534': 'El Paso,TX',
'88535': 'El Paso,TX',
'88536': 'El Paso,TX',
'88538': 'El Paso,TX',
'88539': 'El Paso,TX',
'88540': 'El Paso,TX',
'88541': 'El Paso,TX',
'88542': 'El Paso,TX',
'88543': 'El Paso,TX',
'88544': 'El Paso,TX',
'88545': 'El Paso,TX',
'88546': 'El Paso,TX',
'88547': 'El Paso,TX',
'88548': 'El Paso,TX',
'88549': 'El Paso,TX',
'88550': 'El Paso,TX',
'88553': 'El Paso,TX',
'88554': 'El Paso,TX',
'88555': 'El Paso,TX',
'88556': 'El Paso,TX',
'88557': 'El Paso,TX',
'88558': 'El Paso,TX',
'88559': 'El Paso,TX',
'88560': 'El Paso,TX',
'88561': 'El Paso,TX',
'88562': 'El Paso,TX',
'88563': 'El Paso,TX',
'88565': 'El Paso,TX',
'88566': 'El Paso,TX',
'88567': 'El Paso,TX',
'88568': 'El Paso,TX',
'88569': 'El Paso,TX',
'88570': 'El Paso,TX',
'88571': 'El Paso,TX',
'88572': 'El Paso,TX',
'88573': 'El Paso,TX',
'88574': 'El Paso,TX',
'88575': 'El Paso,TX',
'88576': 'El Paso,TX',
'88577': 'El Paso,TX',
'88578': 'El Paso,TX',
'88579': 'El Paso,TX',
'88580': 'El Paso,TX',
'88581': 'El Paso,TX',
'88582': 'El Paso,TX',
'88583': 'El Paso,TX',
'88584': 'El Paso,TX',
'88585': 'El Paso,TX',
'88586': 'El Paso,TX',
'88587': 'El Paso,TX',
'88588': 'El Paso,TX',
'88589': 'El Paso,TX',
'88590': 'El Paso,TX',
'88595': 'El Paso,TX',
'88901': 'The Lakes,NV',
'88905': 'The Lakes,NV',
'89001': 'Alamo,NV',
'89002': 'Henderson,NV',
'89003': 'Beatty,NV',
'89004': 'Blue Diamond,NV',
'89005': 'Boulder City,NV',
'89006': 'Boulder City,NV',
'89007': 'Bunkerville,NV',
'89008': 'Caliente,NV',
'89009': 'Henderson,NV',
'89010': 'Dyer,NV',
'89011': 'Henderson,NV',
'89012': 'Henderson,NV',
'89013': 'Goldfield,NV',
'89014': 'Henderson,NV',
'89015': 'Henderson,NV',
'89016': 'Henderson,NV',
'89017': 'Hiko,NV',
'89018': 'Indian Springs,NV',
'89019': 'Jean,NV',
'89020': 'Amargosa Valley,NV',
'89021': 'Logandale,NV',
'89022': 'Manhattan,NV',
'89023': 'Mercury,NV',
'89024': 'Mesquite,NV',
'89025': 'Moapa,NV',
'89026': 'Jean,NV',
'89027': 'Mesquite,NV',
'89028': 'Laughlin,NV',
'89029': 'Laughlin,NV',
'89030': 'North Las Vegas,NV',
'89031': 'North Las Vegas,NV',
'89032': 'North Las Vegas,NV',
'89033': 'North Las Vegas,NV',
'89036': 'North Las Vegas,NV',
'89037': 'Moapa,NV',
'89039': 'Cal Nev Ari,NV',
'89040': 'Overton,NV',
'89041': 'Pahrump,NV',
'89042': 'Panaca,NV',
'89043': 'Pioche,NV',
'89044': 'Las Vegas,NV',
'89045': 'Round Mountain,NV',
'89046': 'Searchlight,NV',
'89047': 'Silverpeak,NV',
'89048': 'Pahrump,NV',
'89049': 'Tonopah,NV',
'89052': 'Henderson,NV',
'89053': 'Henderson,NV',
'89060': 'Pahrump,NV',
'89061': 'Pahrump,NV',
'89067': 'Moapa,NV',
'89070': 'Indian Springs,NV',
'89074': 'Henderson,NV',
'89077': 'Henderson,NV',
'89081': 'North Las Vegas,NV',
'89084': 'North Las Vegas,NV',
'89085': 'North Las Vegas,NV',
'89086': 'North Las Vegas,NV',
'89087': 'North Las Vegas,NV',
'89101': 'Las Vegas,NV',
'89102': 'Las Vegas,NV',
'89103': 'Las Vegas,NV',
'89104': 'Las Vegas,NV',
'89105': 'Las Vegas,NV',
'89106': 'Las Vegas,NV',
'89107': 'Las Vegas,NV',
'89108': 'Las Vegas,NV',
'89109': 'Las Vegas,NV',
'89110': 'Las Vegas,NV',
'89111': 'Las Vegas,NV',
'89112': 'Las Vegas,NV',
'89113': 'Las Vegas,NV',
'89114': 'Las Vegas,NV',
'89115': 'Las Vegas,NV',
'89116': 'Las Vegas,NV',
'89117': 'Las Vegas,NV',
'89118': 'Las Vegas,NV',
'89119': 'Las Vegas,NV',
'89120': 'Las Vegas,NV',
'89121': 'Las Vegas,NV',
'89122': 'Las Vegas,NV',
'89123': 'Las Vegas,NV',
'89124': 'Las Vegas,NV',
'89125': 'Las Vegas,NV',
'89126': 'Las Vegas,NV',
'89127': 'Las Vegas,NV',
'89128': 'Las Vegas,NV',
'89129': 'Las Vegas,NV',
'89130': 'Las Vegas,NV',
'89131': 'Las Vegas,NV',
'89132': 'Las Vegas,NV',
'89133': 'Las Vegas,NV',
'89134': 'Las Vegas,NV',
'89135': 'Las Vegas,NV',
'89136': 'Las Vegas,NV',
'89137': 'Las Vegas,NV',
'89138': 'Las Vegas,NV',
'89139': 'Las Vegas,NV',
'89140': 'Las Vegas,NV',
'89141': 'Las Vegas,NV',
'89142': 'Las Vegas,NV',
'89143': 'Las Vegas,NV',
'89144': 'Las Vegas,NV',
'89145': 'Las Vegas,NV',
'89146': 'Las Vegas,NV',
'89147': 'Las Vegas,NV',
'89148': 'Las Vegas,NV',
'89149': 'Las Vegas,NV',
'89150': 'Las Vegas,NV',
'89151': 'Las Vegas,NV',
'89152': 'Las Vegas,NV',
'89153': 'Las Vegas,NV',
'89154': 'Las Vegas,NV',
'89155': 'Las Vegas,NV',
'89156': 'Las Vegas,NV',
'89157': 'Las Vegas,NV',
'89158': 'Las Vegas,NV',
'89159': 'Las Vegas,NV',
'89160': 'Las Vegas,NV',
'89161': 'Las Vegas,NV',
'89162': 'Las Vegas,NV',
'89163': 'The Lakes,NV',
'89164': 'Las Vegas,NV',
'89165': 'Las Vegas,NV',
'89166': 'Las Vegas,NV',
'89169': 'Las Vegas,NV',
'89170': 'Las Vegas,NV',
'89173': 'Las Vegas,NV',
'89177': 'Las Vegas,NV',
'89178': 'Las Vegas,NV',
'89179': 'Las Vegas,NV',
'89180': 'Las Vegas,NV',
'89183': 'Las Vegas,NV',
'89185': 'Las Vegas,NV',
'89191': 'Nellis Afb,NV',
'89193': 'Las Vegas,NV',
'89195': 'Las Vegas,NV',
'89199': 'Las Vegas,NV',
'89301': 'Ely,NV',
'89310': 'Austin,NV',
'89311': 'Baker,NV',
'89314': 'Duckwater,NV',
'89315': 'Ely,NV',
'89316': 'Eureka,NV',
'89317': 'Lund,NV',
'89318': 'Mc Gill,NV',
'89319': 'Ruth,NV',
'89402': 'Crystal Bay,NV',
'89403': 'Dayton,NV',
'89404': 'Denio,NV',
'89405': 'Empire,NV',
'89406': 'Fallon,NV',
'89407': 'Fallon,NV',
'89408': 'Fernley,NV',
'89409': 'Gabbs,NV',
'89410': 'Gardnerville,NV',
'89411': 'Genoa,NV',
'89412': 'Gerlach,NV',
'89413': 'Glenbrook,NV',
'89414': 'Golconda,NV',
'89415': 'Hawthorne,NV',
'89418': 'Imlay,NV',
'89419': 'Lovelock,NV',
'89420': 'Luning,NV',
'89421': 'Mc Dermitt,NV',
'89422': 'Mina,NV',
'89423': 'Minden,NV',
'89424': 'Nixon,NV',
'89425': 'Orovada,NV',
'89426': 'Paradise Valley,NV',
'89427': 'Schurz,NV',
'89428': 'Silver City,NV',
'89429': 'Silver Springs,NV',
'89430': 'Smith,NV',
'89431': 'Sparks,NV',
'89432': 'Sparks,NV',
'89433': 'Sun Valley,NV',
'89434': 'Sparks,NV',
'89435': 'Sparks,NV',
'89436': 'Sparks,NV',
'89438': 'Valmy,NV',
'89439': 'Verdi,NV',
'89440': 'Virginia City,NV',
'89441': 'Sparks,NV',
'89442': 'Wadsworth,NV',
'89444': 'Wellington,NV',
'89445': 'Winnemucca,NV',
'89446': 'Winnemucca,NV',
'89447': 'Yerington,NV',
'89448': 'Zephyr Cove,NV',
'89449': 'Stateline,NV',
'89450': 'Incline Village,NV',
'89451': 'Incline Village,NV',
'89452': 'Incline Village,NV',
'89460': 'Gardnerville,NV',
'89494': 'Sparks,NV',
'89496': 'Fallon,NV',
'89501': 'Reno,NV',
'89502': 'Reno,NV',
'89503': 'Reno,NV',
'89504': 'Reno,NV',
'89505': 'Reno,NV',
'89506': 'Reno,NV',
'89507': 'Reno,NV',
'89509': 'Reno,NV',
'89510': 'Reno,NV',
'89511': 'Reno,NV',
'89512': 'Reno,NV',
'89513': 'Reno,NV',
'89515': 'Reno,NV',
'89519': 'Reno,NV',
'89520': 'Reno,NV',
'89521': 'Vc Highlands,NV',
'89523': 'Reno,NV',
'89533': 'Reno,NV',
'89555': 'Reno,NV',
'89557': 'Reno,NV',
'89570': 'Reno,NV',
'89595': 'Reno,NV',
'89599': 'Reno,NV',
'89701': 'Carson City,NV',
'89702': 'Carson City,NV',
'89703': 'Carson City,NV',
'89704': 'Washoe Valley,NV',
'89705': 'Carson City,NV',
'89706': 'Carson City,NV',
'89711': 'Carson City,NV',
'89712': 'Carson City,NV',
'89713': 'Carson City,NV',
'89714': 'Carson City,NV',
'89721': 'Carson City,NV',
'89801': 'Elko,NV',
'89802': 'Elko,NV',
'89803': 'Elko,NV',
'89815': 'Spring Creek,NV',
'89820': 'Battle Mountain,NV',
'89821': 'Crescent Valley,NV',
'89822': 'Carlin,NV',
'89823': 'Deeth,NV',
'89824': 'Halleck,NV',
'89825': 'Jackpot,NV',
'89826': 'Jarbidge,NV',
'89828': 'Lamoille,NV',
'89830': 'Montello,NV',
'89831': 'Mountain City,NV',
'89832': 'Owyhee,NV',
'89833': 'Ruby Valley,NV',
'89834': 'Tuscarora,NV',
'89835': 'Wells,NV',
'89883': 'West Wendover,NV',
'90001': 'Los Angeles,CA',
'90002': 'Los Angeles,CA',
'90003': 'Los Angeles,CA',
'90004': 'Los Angeles,CA',
'90005': 'Los Angeles,CA',
'90006': 'Los Angeles,CA',
'90007': 'Los Angeles,CA',
'90008': 'Los Angeles,CA',
'90009': 'Los Angeles,CA',
'90010': 'Los Angeles,CA',
'90011': 'Los Angeles,CA',
'90012': 'Los Angeles,CA',
'90013': 'Los Angeles,CA',
'90014': 'Los Angeles,CA',
'90015': 'Los Angeles,CA',
'90016': 'Los Angeles,CA',
'90017': 'Los Angeles,CA',
'90018': 'Los Angeles,CA',
'90019': 'Los Angeles,CA',
'90020': 'Los Angeles,CA',
'90021': 'Los Angeles,CA',
'90022': 'Los Angeles,CA',
'90023': 'Los Angeles,CA',
'90024': 'Los Angeles,CA',
'90025': 'Los Angeles,CA',
'90026': 'Los Angeles,CA',
'90027': 'Los Angeles,CA',
'90028': 'Los Angeles,CA',
'90029': 'Los Angeles,CA',
'90030': 'Los Angeles,CA',
'90031': 'Los Angeles,CA',
'90032': 'Los Angeles,CA',
'90033': 'Los Angeles,CA',
'90034': 'Los Angeles,CA',
'90035': 'Los Angeles,CA',
'90036': 'Los Angeles,CA',
'90037': 'Los Angeles,CA',
'90038': 'Los Angeles,CA',
'90039': 'Los Angeles,CA',
'90040': 'Los Angeles,CA',
'90041': 'Los Angeles,CA',
'90042': 'Los Angeles,CA',
'90043': 'Los Angeles,CA',
'90044': 'Los Angeles,CA',
'90045': 'Los Angeles,CA',
'90046': 'Los Angeles,CA',
'90047': 'Los Angeles,CA',
'90048': 'Los Angeles,CA',
'90049': 'Los Angeles,CA',
'90050': 'Los Angeles,CA',
'90051': 'Los Angeles,CA',
'90052': 'Los Angeles,CA',
'90053': 'Los Angeles,CA',
'90054': 'Los Angeles,CA',
'90055': 'Los Angeles,CA',
'90056': 'Los Angeles,CA',
'90057': 'Los Angeles,CA',
'90058': 'Los Angeles,CA',
'90059': 'Los Angeles,CA',
'90060': 'Los Angeles,CA',
'90061': 'Los Angeles,CA',
'90062': 'Los Angeles,CA',
'90063': 'Los Angeles,CA',
'90064': 'Los Angeles,CA',
'90065': 'Los Angeles,CA',
'90066': 'Los Angeles,CA',
'90067': 'Los Angeles,CA',
'90068': 'Los Angeles,CA',
'90069': 'West Hollywood,CA',
'90070': 'Los Angeles,CA',
'90071': 'Los Angeles,CA',
'90072': 'Los Angeles,CA',
'90073': 'Los Angeles,CA',
'90074': 'Los Angeles,CA',
'90075': 'Los Angeles,CA',
'90076': 'Los Angeles,CA',
'90077': 'Los Angeles,CA',
'90078': 'Los Angeles,CA',
'90079': 'Los Angeles,CA',
'90080': 'Los Angeles,CA',
'90081': 'Los Angeles,CA',
'90082': 'Los Angeles,CA',
'90083': 'Los Angeles,CA',
'90084': 'Los Angeles,CA',
'90086': 'Los Angeles,CA',
'90087': 'Los Angeles,CA',
'90088': 'Los Angeles,CA',
'90089': 'Los Angeles,CA',
'90090': 'Los Angeles Dodgers,CA',
'90091': 'Los Angeles,CA',
'90093': 'Los Angeles,CA',
'90094': 'Los Angeles,CA',
'90095': 'Los Angeles,CA',
'90096': 'Los Angeles,CA',
'90097': 'Los Angeles,CA',
'90099': 'Los Angeles,CA',
'90101': 'Los Angeles,CA',
'90102': 'Los Angeles,CA',
'90103': 'Los Angeles,CA',
'90174': 'Los Angeles,CA',
'90185': 'Los Angeles,CA',
'90189': 'Los Angeles,CA',
'90201': 'Bell,CA',
'90202': 'Bell Gardens,CA',
'90209': 'Beverly Hills,CA',
'90210': 'Beverly Hills,CA',
'90211': 'Beverly Hills,CA',
'90212': 'Beverly Hills,CA',
'90213': 'Beverly Hills,CA',
'90220': 'Compton,CA',
'90221': 'Compton,CA',
'90222': 'Compton,CA',
'90223': 'Compton,CA',
'90224': 'Compton,CA',
'90230': 'Culver City,CA',
'90231': 'Culver City,CA',
'90232': 'Culver City,CA',
'90233': 'Culver City,CA',
'90239': 'Downey,CA',
'90240': 'Downey,CA',
'90241': 'Downey,CA',
'90242': 'Downey,CA',
'90245': 'El Segundo,CA',
'90247': 'Gardena,CA',
'90248': 'Gardena,CA',
'90249': 'Gardena,CA',
'90250': 'Hawthorne,CA',
'90251': 'Hawthorne,CA',
'90254': 'Hermosa Beach,CA',
'90255': 'Huntington Park,CA',
'90260': 'Lawndale,CA',
'90261': 'Lawndale,CA',
'90262': 'Lynwood,CA',
'90263': 'Malibu,CA',
'90264': 'Malibu,CA',
'90265': 'Malibu,CA',
'90266': 'Manhattan Beach,CA',
'90267': 'Manhattan Beach,CA',
'90270': 'Maywood,CA',
'90272': 'Pacific Palisades,CA',
'90274': 'Palos Verdes Peninsula,CA',
'90275': 'Rancho Palos Verdes,CA',
'90277': 'Redondo Beach,CA',
'90278': 'Redondo Beach,CA',
'90280': 'South Gate,CA',
'90290': 'Topanga,CA',
'90291': 'Venice,CA',
'90292': 'Marina Del Rey,CA',
'90293': 'Playa Del Rey,CA',
'90294': 'Venice,CA',
'90295': 'Marina Del Rey,CA',
'90296': 'Playa Del Rey,CA',
'90301': 'Inglewood,CA',
'90302': 'Inglewood,CA',
'90303': 'Inglewood,CA',
'90304': 'Inglewood,CA',
'90305': 'Inglewood,CA',
'90306': 'Inglewood,CA',
'90307': 'Inglewood,CA',
'90308': 'Inglewood,CA',
'90309': 'Inglewood,CA',
'90310': 'Inglewood,CA',
'90311': 'Inglewood,CA',
'90312': 'Inglewood,CA',
'90313': 'Inglewood,CA',
'90397': 'Inglewood,CA',
'90398': 'Inglewood,CA',
'90401': 'Santa Monica,CA',
'90402': 'Santa Monica,CA',
'90403': 'Santa Monica,CA',
'90404': 'Santa Monica,CA',
'90405': 'Santa Monica,CA',
'90406': 'Santa Monica,CA',
'90407': 'Santa Monica,CA',
'90408': 'Santa Monica,CA',
'90409': 'Santa Monica,CA',
'90410': 'Santa Monica,CA',
'90411': 'Santa Monica,CA',
'90501': 'Torrance,CA',
'90502': 'Torrance,CA',
'90503': 'Torrance,CA',
'90504': 'Torrance,CA',
'90505': 'Torrance,CA',
'90506': 'Torrance,CA',
'90507': 'Torrance,CA',
'90508': 'Torrance,CA',
'90509': 'Torrance,CA',
'90510': 'Torrance,CA',
'90601': 'Whittier,CA',
'90602': 'Whittier,CA',
'90603': 'Whittier,CA',
'90604': 'Whittier,CA',
'90605': 'Whittier,CA',
'90606': 'Whittier,CA',
'90607': 'Whittier,CA',
'90608': 'Whittier,CA',
'90609': 'Whittier,CA',
'90610': 'Whittier,CA',
'90612': 'Whittier,CA',
'90620': 'Buena Park,CA',
'90621': 'Buena Park,CA',
'90622': 'Buena Park,CA',
'90623': 'La Palma,CA',
'90624': 'Buena Park,CA',
'90630': 'Cypress,CA',
'90631': 'La Habra,CA',
'90632': 'La Habra,CA',
'90633': 'La Habra,CA',
'90637': 'La Mirada,CA',
'90638': 'La Mirada,CA',
'90639': 'La Mirada,CA',
'90640': 'Montebello,CA',
'90650': 'Norwalk,CA',
'90651': 'Norwalk,CA',
'90652': 'Norwalk,CA',
'90659': 'Norwalk,CA',
'90660': 'Pico Rivera,CA',
'90661': 'Pico Rivera,CA',
'90662': 'Pico Rivera,CA',
'90665': 'Pico Rivera,CA',
'90670': 'Santa Fe Springs,CA',
'90671': 'Santa Fe Springs,CA',
'90680': 'Stanton,CA',
'90701': 'Artesia,CA',
'90702': 'Artesia,CA',
'90703': 'Cerritos,CA',
'90704': 'Avalon,CA',
'90706': 'Bellflower,CA',
'90707': 'Bellflower,CA',
'90710': 'Harbor City,CA',
'90711': 'Lakewood,CA',
'90712': 'Lakewood,CA',
'90713': 'Lakewood,CA',
'90714': 'Lakewood,CA',
'90715': 'Lakewood,CA',
'90716': 'Hawaiian Gardens,CA',
'90717': 'Lomita,CA',
'90720': 'Los Alamitos,CA',
'90721': 'Los Alamitos,CA',
'90723': 'Paramount,CA',
'90731': 'San Pedro,CA',
'90732': 'San Pedro,CA',
'90733': 'San Pedro,CA',
'90734': 'San Pedro,CA',
'90740': 'Seal Beach,CA',
'90742': 'Sunset Beach,CA',
'90743': 'Surfside,CA',
'90744': 'Wilmington,CA',
'90745': 'Carson,CA',
'90746': 'Carson,CA',
'90747': 'Carson,CA',
'90748': 'Wilmington,CA',
'90749': 'Carson,CA',
'90755': 'Signal Hl,CA',
'90801': 'Long Beach,CA',
'90802': 'Long Beach,CA',
'90803': 'Long Beach,CA',
'90804': 'Long Beach,CA',
'90805': 'Long Beach,CA',
'90806': 'Long Beach,CA',
'90807': 'Long Beach,CA',
'90808': 'Long Beach,CA',
'90809': 'Long Beach,CA',
'90810': 'Long Beach,CA',
'90813': 'Long Beach,CA',
'90814': 'Long Beach,CA',
'90815': 'Long Beach,CA',
'90822': 'Long Beach,CA',
'90831': 'Long Beach,CA',
'90832': 'Long Beach,CA',
'90833': 'Long Beach,CA',
'90834': 'Long Beach,CA',
'90835': 'Long Beach,CA',
'90840': 'Long Beach,CA',
'90842': 'Long Beach,CA',
'90844': 'Long Beach,CA',
'90845': 'Long Beach,CA',
'90846': 'Long Beach,CA',
'90847': 'Long Beach,CA',
'90848': 'Long Beach,CA',
'90853': 'Long Beach,CA',
'90888': 'Long Beach,CA',
'90895': 'Long Beach,CA',
'90899': 'Long Beach,CA',
'91001': 'Altadena,CA',
'91003': 'Altadena,CA',
'91006': 'Arcadia,CA',
'91007': 'Arcadia,CA',
'91009': 'Duarte,CA',
'91010': 'Duarte,CA',
'91011': 'La Canada Flintridge,CA',
'91012': 'La Canada Flintridge,CA',
'91016': 'Monrovia,CA',
'91017': 'Monrovia,CA',
'91020': 'Montrose,CA',
'91021': 'Montrose,CA',
'91023': 'Mount Wilson,CA',
'91024': 'Sierra Madre,CA',
'91025': 'Sierra Madre,CA',
'91030': 'South Pasadena,CA',
'91031': 'South Pasadena,CA',
'91040': 'Sunland,CA',
'91041': 'Sunland,CA',
'91042': 'Tujunga,CA',
'91043': 'Tujunga,CA',
'91046': 'Verdugo City,CA',
'91050': 'Pasadena,CA',
'91051': 'Pasadena,CA',
'91066': 'Arcadia,CA',
'91077': 'Arcadia,CA',
'91101': 'Pasadena,CA',
'91102': 'Pasadena,CA',
'91103': 'Pasadena,CA',
'91104': 'Pasadena,CA',
'91105': 'Pasadena,CA',
'91106': 'Pasadena,CA',
'91107': 'Pasadena,CA',
'91108': 'San Marino,CA',
'91109': 'Pasadena,CA',
'91110': 'Pasadena,CA',
'91114': 'Pasadena,CA',
'91115': 'Pasadena,CA',
'91116': 'Pasadena,CA',
'91117': 'Pasadena,CA',
'91118': 'San Marino,CA',
'91121': 'Pasadena,CA',
'91123': 'Pasadena,CA',
'91124': 'Pasadena,CA',
'91125': 'Pasadena,CA',
'91126': 'Pasadena,CA',
'91129': 'Pasadena,CA',
'91131': 'Pasadena,CA',
'91175': 'Pasadena,CA',
'91182': 'Pasadena,CA',
'91184': 'Pasadena,CA',
'91185': 'Pasadena,CA',
'91186': 'Pasadena,CA',
'91187': 'Pasadena,CA',
'91188': 'Pasadena,CA',
'91189': 'Pasadena,CA',
'91191': 'Pasadena,CA',
'91199': 'Pasadena,CA',
'91201': 'Glendale,CA',
'91202': 'Glendale,CA',
'91203': 'Glendale,CA',
'91204': 'Glendale,CA',
'91205': 'Glendale,CA',
'91206': 'Glendale,CA',
'91207': 'Glendale,CA',
'91208': 'Glendale,CA',
'91209': 'Glendale,CA',
'91210': 'Glendale,CA',
'91214': 'La Crescenta,CA',
'91221': 'Glendale,CA',
'91222': 'Glendale,CA',
'91224': 'La Crescenta,CA',
'91225': 'Glendale,CA',
'91226': 'Glendale,CA',
'91301': 'Agoura Hills,CA',
'91302': 'Calabasas,CA',
'91303': 'Canoga Park,CA',
'91304': 'Canoga Park,CA',
'91305': 'Canoga Park,CA',
'91306': 'Winnetka,CA',
'91307': 'West Hills,CA',
'91308': 'West Hills,CA',
'91309': 'Canoga Park,CA',
'91310': 'Castaic,CA',
'91311': 'Chatsworth,CA',
'91312': 'Chatsworth,CA',
'91313': 'Chatsworth,CA',
'91316': 'Encino,CA',
'91319': 'Newbury Park,CA',
'91320': 'Newbury Park,CA',
'91321': 'Newhall,CA',
'91322': 'Newhall,CA',
'91324': 'Northridge,CA',
'91325': 'Northridge,CA',
'91326': 'Northridge,CA',
'91327': 'Northridge,CA',
'91328': 'Northridge,CA',
'91329': 'Northridge,CA',
'91330': 'Northridge,CA',
'91331': 'Pacoima,CA',
'91333': 'Pacoima,CA',
'91334': 'Pacoima,CA',
'91335': 'Reseda,CA',
'91337': 'Reseda,CA',
'91340': 'San Fernando,CA',
'91341': 'San Fernando,CA',
'91342': 'Sylmar,CA',
'91343': 'North Hills,CA',
'91344': 'Granada Hills,CA',
'91345': 'Mission Hills,CA',
'91346': 'Mission Hills,CA',
'91350': 'Santa Clarita,CA',
'91351': 'Canyon Country,CA',
'91352': 'Sun Valley,CA',
'91353': 'Sun Valley,CA',
'91354': 'Valencia,CA',
'91355': 'Valencia,CA',
'91356': 'Tarzana,CA',
'91357': 'Tarzana,CA',
'91358': 'Thousand Oaks,CA',
'91359': 'Westlake Village,CA',
'91360': 'Thousand Oaks,CA',
'91361': 'Westlake Village,CA',
'91362': 'Thousand Oaks,CA',
'91363': 'Westlake Village,CA',
'91364': 'Woodland Hills,CA',
'91365': 'Woodland Hills,CA',
'91367': 'Woodland Hills,CA',
'91371': 'Woodland Hills,CA',
'91372': 'Calabasas,CA',
'91376': 'Agoura Hills,CA',
'91377': 'Oak Park,CA',
'91380': 'Santa Clarita,CA',
'91381': 'Stevenson Ranch,CA',
'91382': 'Santa Clarita,CA',
'91383': 'Santa Clarita,CA',
'91384': 'Castaic,CA',
'91385': 'Valencia,CA',
'91386': 'Canyon Country,CA',
'91387': 'Canyon Country,CA',
'91388': 'Van Nuys,CA',
'91390': 'Santa Clarita,CA',
'91392': 'Sylmar,CA',
'91393': 'North Hills,CA',
'91394': 'Granada Hills,CA',
'91395': 'Mission Hills,CA',
'91396': 'Winnetka,CA',
'91399': 'Woodland Hills,CA',
'91401': 'Van Nuys,CA',
'91402': 'Panorama City,CA',
'91403': 'Sherman Oaks,CA',
'91404': 'Van Nuys,CA',
'91405': 'Van Nuys,CA',
'91406': 'Van Nuys,CA',
'91407': 'Van Nuys,CA',
'91408': 'Van Nuys,CA',
'91409': 'Van Nuys,CA',
'91410': 'Van Nuys,CA',
'91411': 'Van Nuys,CA',
'91412': 'Panorama City,CA',
'91413': 'Sherman Oaks,CA',
'91416': 'Encino,CA',
'91423': 'Sherman Oaks,CA',
'91426': 'Encino,CA',
'91436': 'Encino,CA',
'91470': 'Van Nuys,CA',
'91482': 'Van Nuys,CA',
'91495': 'Sherman Oaks,CA',
'91496': 'Van Nuys,CA',
'91497': 'Van Nuys,CA',
'91499': 'Van Nuys,CA',
'91501': 'Burbank,CA',
'91502': 'Burbank,CA',
'91503': 'Burbank,CA',
'91504': 'Burbank,CA',
'91505': 'Burbank,CA',
'91506': 'Burbank,CA',
'91507': 'Burbank,CA',
'91508': 'Burbank,CA',
'91510': 'Burbank,CA',
'91521': 'Burbank,CA',
'91522': 'Burbank,CA',
'91523': 'Burbank,CA',
'91526': 'Burbank,CA',
'91601': 'North Hollywood,CA',
'91602': 'North Hollywood,CA',
'91603': 'North Hollywood,CA',
'91604': 'Studio City,CA',
'91605': 'North Hollywood,CA',
'91606': 'North Hollywood,CA',
'91607': 'Valley Village,CA',
'91608': 'Universal City,CA',
'91609': 'North Hollywood,CA',
'91610': 'Toluca Lake,CA',
'91611': 'North Hollywood,CA',
'91612': 'North Hollywood,CA',
'91614': 'Studio City,CA',
'91615': 'North Hollywood,CA',
'91616': 'North Hollywood,CA',
'91617': 'Valley Village,CA',
'91618': 'North Hollywood,CA',
'91701': 'Rancho Cucamonga,CA',
'91702': 'Azusa,CA',
'91706': 'Baldwin Park,CA',
'91708': 'Chino,CA',
'91709': 'Chino Hills,CA',
'91710': 'Chino,CA',
'91711': 'Claremont,CA',
'91714': 'City Of Industry,CA',
'91715': 'City Of Industry,CA',
'91716': 'City Of Industry,CA',
'91722': 'Covina,CA',
'91723': 'Covina,CA',
'91724': 'Covina,CA',
'91729': 'Rancho Cucamonga,CA',
'91730': 'Rancho Cucamonga,CA',
'91731': 'El Monte,CA',
'91732': 'El Monte,CA',
'91733': 'South El Monte,CA',
'91734': 'El Monte,CA',
'91735': 'El Monte,CA',
'91737': 'Rancho Cucamonga,CA',
'91739': 'Rancho Cucamonga,CA',
'91740': 'Glendora,CA',
'91741': 'Glendora,CA',
'91743': 'Guasti,CA',
'91744': 'La Puente,CA',
'91745': 'Hacienda Heights,CA',
'91746': 'La Puente,CA',
'91747': 'La Puente,CA',
'91748': 'Rowland Heights,CA',
'91749': 'La Puente,CA',
'91750': 'La Verne,CA',
'91752': 'Mira Loma,CA',
'91754': 'Monterey Park,CA',
'91755': 'Monterey Park,CA',
'91756': 'Monterey Park,CA',
'91758': 'Ontario,CA',
'91759': 'Mt Baldy,CA',
'91761': 'Ontario,CA',
'91762': 'Ontario,CA',
'91763': 'Montclair,CA',
'91764': 'Ontario,CA',
'91765': 'Diamond Bar,CA',
'91766': 'Pomona,CA',
'91767': 'Pomona,CA',
'91768': 'Pomona,CA',
'91769': 'Pomona,CA',
'91770': 'Rosemead,CA',
'91771': 'Rosemead,CA',
'91772': 'Rosemead,CA',
'91773': 'San Dimas,CA',
'91775': 'San Gabriel,CA',
'91776': 'San Gabriel,CA',
'91778': 'San Gabriel,CA',
'91780': 'Temple City,CA',
'91784': 'Upland,CA',
'91785': 'Upland,CA',
'91786': 'Upland,CA',
'91788': 'Walnut,CA',
'91789': 'Walnut,CA',
'91790': 'West Covina,CA',
'91791': 'West Covina,CA',
'91792': 'West Covina,CA',
'91793': 'West Covina,CA',
'91795': 'Walnut,CA',
'91797': 'Pomona,CA',
'91798': 'Ontario,CA',
'91799': 'Pomona,CA',
'91801': 'Alhambra,CA',
'91802': 'Alhambra,CA',
'91803': 'Alhambra,CA',
'91804': 'Alhambra,CA',
'91841': 'Alhambra,CA',
'91896': 'Alhambra,CA',
'91899': 'Alhambra,CA',
'91901': 'Alpine,CA',
'91902': 'Bonita,CA',
'91903': 'Alpine,CA',
'91905': 'Boulevard,CA',
'91906': 'Campo,CA',
'91908': 'Bonita,CA',
'91909': 'Chula Vista,CA',
'91910': 'Chula Vista,CA',
'91911': 'Chula Vista,CA',
'91912': 'Chula Vista,CA',
'91913': 'Chula Vista,CA',
'91914': 'Chula Vista,CA',
'91915': 'Chula Vista,CA',
'91916': 'Descanso,CA',
'91917': 'Dulzura,CA',
'91921': 'Chula Vista,CA',
'91931': 'Guatay,CA',
'91932': 'Imperial Beach,CA',
'91933': 'Imperial Beach,CA',
'91934': 'Jacumba,CA',
'91935': 'Jamul,CA',
'91941': 'La Mesa,CA',
'91942': 'La Mesa,CA',
'91943': 'La Mesa,CA',
'91944': 'La Mesa,CA',
'91945': 'Lemon Grove,CA',
'91946': 'Lemon Grove,CA',
'91947': 'Lincoln Acres,CA',
'91948': 'Mount Laguna,CA',
'91950': 'National City,CA',
'91951': 'National City,CA',
'91962': 'Pine Valley,CA',
'91963': 'Potrero,CA',
'91976': 'Spring Valley,CA',
'91977': 'Spring Valley,CA',
'91978': 'Spring Valley,CA',
'91979': 'Spring Valley,CA',
'91980': 'Tecate,CA',
'91987': 'Tecate,CA',
'91990': 'Potrero,CA',
'92003': 'Bonsall,CA',
'92004': 'Borrego Springs,CA',
'92007': 'Cardiff By The Sea,CA',
'92008': 'Carlsbad,CA',
'92009': 'Carlsbad,CA',
'92011': 'Carlsbad,CA',
'92013': 'Carlsbad,CA',
'92014': 'Del Mar,CA',
'92018': 'Carlsbad,CA',
'92019': 'El Cajon,CA',
'92020': 'El Cajon,CA',
'92021': 'El Cajon,CA',
'92022': 'El Cajon,CA',
'92023': 'Encinitas,CA',
'92024': 'Encinitas,CA',
'92025': 'Escondido,CA',
'92026': 'Escondido,CA',
'92027': 'Escondido,CA',
'92028': 'Fallbrook,CA',
'92029': 'Escondido,CA',
'92030': 'Escondido,CA',
'92033': 'Escondido,CA',
'92036': 'Julian,CA',
'92037': 'La Jolla,CA',
'92038': 'La Jolla,CA',
'92039': 'La Jolla,CA',
'92040': 'Lakeside,CA',
'92046': 'Escondido,CA',
'92049': 'Oceanside,CA',
'92051': 'Oceanside,CA',
'92052': 'Oceanside,CA',
'92054': 'Oceanside,CA',
'92055': 'Camp Pendleton,CA',
'92056': 'Oceanside,CA',
'92057': 'Oceanside,CA',
'92058': 'Oceanside,CA',
'92059': 'Pala,CA',
'92060': 'Palomar Mountain,CA',
'92061': 'Pauma Valley,CA',
'92064': 'Poway,CA',
'92065': 'Ramona,CA',
'92066': 'Ranchita,CA',
'92067': 'Rancho Santa Fe,CA',
'92068': 'San Luis Rey,CA',
'92069': 'San Marcos,CA',
'92070': 'Santa Ysabel,CA',
'92071': 'Santee,CA',
'92072': 'Santee,CA',
'92074': 'Poway,CA',
'92075': 'Solana Beach,CA',
'92078': 'San Marcos,CA',
'92079': 'San Marcos,CA',
'92081': 'Vista,CA',
'92082': 'Valley Center,CA',
'92083': 'Vista,CA',
'92084': 'Vista,CA',
'92085': 'Vista,CA',
'92086': 'Warner Springs,CA',
'92088': 'Fallbrook,CA',
'92090': 'El Cajon,CA',
'92091': 'Rancho Santa Fe,CA',
'92092': 'La Jolla,CA',
'92093': 'La Jolla,CA',
'92096': 'San Marcos,CA',
'92101': 'San Diego,CA',
'92102': 'San Diego,CA',
'92103': 'San Diego,CA',
'92104': 'San Diego,CA',
'92105': 'San Diego,CA',
'92106': 'San Diego,CA',
'92107': 'San Diego,CA',
'92108': 'San Diego,CA',
'92109': 'San Diego,CA',
'92110': 'San Diego,CA',
'92111': 'San Diego,CA',
'92112': 'San Diego,CA',
'92113': 'San Diego,CA',
'92114': 'San Diego,CA',
'92115': 'San Diego,CA',
'92116': 'San Diego,CA',
'92117': 'San Diego,CA',
'92118': 'Coronado,CA',
'92119': 'San Diego,CA',
'92120': 'San Diego,CA',
'92121': 'San Diego,CA',
'92122': 'San Diego,CA',
'92123': 'San Diego,CA',
'92124': 'San Diego,CA',
'92126': 'San Diego,CA',
'92127': 'San Diego,CA',
'92128': 'San Diego,CA',
'92129': 'San Diego,CA',
'92130': 'San Diego,CA',
'92131': 'San Diego,CA',
'92132': 'San Diego,CA',
'92133': 'San Diego,CA',
'92134': 'San Diego,CA',
'92135': 'San Diego,CA',
'92136': 'San Diego,CA',
'92137': 'San Diego,CA',
'92138': 'San Diego,CA',
'92139': 'San Diego,CA',
'92140': 'San Diego,CA',
'92142': 'San Diego,CA',
'92143': 'San Ysidro,CA',
'92145': 'San Diego,CA',
'92147': 'San Diego,CA',
'92149': 'San Diego,CA',
'92150': 'San Diego,CA',
'92152': 'San Diego,CA',
'92153': 'San Diego,CA',
'92154': 'San Diego,CA',
'92155': 'San Diego,CA',
'92158': 'San Diego,CA',
'92159': 'San Diego,CA',
'92160': 'San Diego,CA',
'92161': 'San Diego,CA',
'92162': 'San Diego,CA',
'92163': 'San Diego,CA',
'92164': 'San Diego,CA',
'92165': 'San Diego,CA',
'92166': 'San Diego,CA',
'92167': 'San Diego,CA',
'92168': 'San Diego,CA',
'92169': 'San Diego,CA',
'92170': 'San Diego,CA',
'92171': 'San Diego,CA',
'92172': 'San Diego,CA',
'92173': 'San Ysidro,CA',
'92174': 'San Diego,CA',
'92175': 'San Diego,CA',
'92176': 'San Diego,CA',
'92177': 'San Diego,CA',
'92178': 'Coronado,CA',
'92179': 'San Diego,CA',
'92182': 'San Diego,CA',
'92184': 'San Diego,CA',
'92186': 'San Diego,CA',
'92187': 'San Diego,CA',
'92190': 'San Diego,CA',
'92191': 'San Diego,CA',
'92192': 'San Diego,CA',
'92193': 'San Diego,CA',
'92194': 'San Diego,CA',
'92195': 'San Diego,CA',
'92196': 'San Diego,CA',
'92197': 'San Diego,CA',
'92198': 'San Diego,CA',
'92199': 'San Diego,CA',
'92201': 'Indio,CA',
'92202': 'Indio,CA',
'92203': 'Indio,CA',
'92210': 'Indian Wells,CA',
'92211': 'Palm Desert,CA',
'92220': 'Banning,CA',
'92222': 'Bard,CA',
'92223': 'Beaumont,CA',
'92225': 'Blythe,CA',
'92226': 'Blythe,CA',
'92227': 'Brawley,CA',
'92230': 'Cabazon,CA',
'92231': 'Calexico,CA',
'92232': 'Calexico,CA',
'92233': 'Calipatria,CA',
'92234': 'Cathedral City,CA',
'92235': 'Cathedral City,CA',
'92236': 'Coachella,CA',
'92239': 'Desert Center,CA',
'92240': 'Desert Hot Springs,CA',
'92241': 'Desert Hot Springs,CA',
'92242': 'Earp,CA',
'92243': 'El Centro,CA',
'92244': 'El Centro,CA',
'92247': 'La Quinta,CA',
'92248': 'La Quinta,CA',
'92249': 'Heber,CA',
'92250': 'Holtville,CA',
'92251': 'Imperial,CA',
'92252': 'Joshua Tree,CA',
'92253': 'La Quinta,CA',
'92254': 'Mecca,CA',
'92255': 'Palm Desert,CA',
'92256': 'Morongo Valley,CA',
'92257': 'Niland,CA',
'92258': 'North Palm Springs,CA',
'92259': 'Ocotillo,CA',
'92260': 'Palm Desert,CA',
'92261': 'Palm Desert,CA',
'92262': 'Palm Springs,CA',
'92263': 'Palm Springs,CA',
'92264': 'Palm Springs,CA',
'92266': 'Palo Verde,CA',
'92267': 'Parker Dam,CA',
'92268': 'Pioneertown,CA',
'92270': 'Rancho Mirage,CA',
'92273': 'Seeley,CA',
'92274': 'Thermal,CA',
'92275': 'Salton City,CA',
'92276': 'Thousand Palms,CA',
'92277': 'Twentynine Palms,CA',
'92278': 'Twentynine Palms,CA',
'92280': 'Vidal,CA',
'92281': 'Westmorland,CA',
'92282': 'White Water,CA',
'92283': 'Winterhaven,CA',
'92284': 'Yucca Valley,CA',
'92285': 'Landers,CA',
'92286': 'Yucca Valley,CA',
'92292': 'Palm Springs,CA',
'92301': 'Adelanto,CA',
'92304': 'Amboy,CA',
'92305': 'Angelus Oaks,CA',
'92307': 'Apple Valley,CA',
'92308': 'Apple Valley,CA',
'92309': 'Baker,CA',
'92310': 'Fort Irwin,CA',
'92311': 'Barstow,CA',
'92312': 'Barstow,CA',
'92313': 'Grand Terrace,CA',
'92314': 'Big Bear City,CA',
'92315': 'Big Bear Lake,CA',
'92316': 'Bloomington,CA',
'92317': 'Blue Jay,CA',
'92318': 'Bryn Mawr,CA',
'92320': 'Calimesa,CA',
'92321': 'Cedar Glen,CA',
'92322': 'Cedarpines Park,CA',
'92323': 'Cima,CA',
'92324': 'Colton,CA',
'92325': 'Crestline,CA',
'92326': 'Crest Park,CA',
'92327': 'Daggett,CA',
'92328': 'Death Valley,CA',
'92329': 'Phelan,CA',
'92331': 'Fontana,CA',
'92332': 'Essex,CA',
'92333': 'Fawnskin,CA',
'92334': 'Fontana,CA',
'92335': 'Fontana,CA',
'92336': 'Fontana,CA',
'92337': 'Fontana,CA',
'92338': 'Ludlow,CA',
'92339': 'Forest Falls,CA',
'92340': 'Hesperia,CA',
'92341': 'Green Valley Lake,CA',
'92342': 'Helendale,CA',
'92344': 'Oak Hills,CA',
'92345': 'Hesperia,CA',
'92346': 'Highland,CA',
'92347': 'Hinkley,CA',
'92350': 'Loma Linda,CA',
'92352': 'Lake Arrowhead,CA',
'92354': 'Loma Linda,CA',
'92356': 'Lucerne Valley,CA',
'92357': 'Loma Linda,CA',
'92358': 'Lytle Creek,CA',
'92359': 'Mentone,CA',
'92363': 'Needles,CA',
'92364': 'Nipton,CA',
'92365': 'Newberry Springs,CA',
'92366': 'Mountain Pass,CA',
'92368': 'Oro Grande,CA',
'92369': 'Patton,CA',
'92371': 'Phelan,CA',
'92372': 'Pinon Hills,CA',
'92373': 'Redlands,CA',
'92374': 'Redlands,CA',
'92375': 'Redlands,CA',
'92376': 'Rialto,CA',
'92377': 'Rialto,CA',
'92378': 'Rimforest,CA',
'92382': 'Running Springs,CA',
'92384': 'Shoshone,CA',
'92385': 'Skyforest,CA',
'92386': 'Sugarloaf,CA',
'92389': 'Tecopa,CA',
'92391': 'Twin Peaks,CA',
'92392': 'Victorville,CA',
'92393': 'Victorville,CA',
'92394': 'Victorville,CA',
'92395': 'Victorville,CA',
'92397': 'Wrightwood,CA',
'92398': 'Yermo,CA',
'92399': 'Yucaipa,CA',
'92401': 'San Bernardino,CA',
'92402': 'San Bernardino,CA',
'92403': 'San Bernardino,CA',
'92404': 'San Bernardino,CA',
'92405': 'San Bernardino,CA',
'92406': 'San Bernardino,CA',
'92407': 'San Bernardino,CA',
'92408': 'San Bernardino,CA',
'92410': 'San Bernardino,CA',
'92411': 'San Bernardino,CA',
'92412': 'San Bernardino,CA',
'92413': 'San Bernardino,CA',
'92414': 'San Bernardino,CA',
'92415': 'San Bernardino,CA',
'92418': 'San Bernardino,CA',
'92420': 'San Bernardino,CA',
'92423': 'San Bernardino,CA',
'92424': 'San Bernardino,CA',
'92427': 'San Bernardino,CA',
'92501': 'Riverside,CA',
'92502': 'Riverside,CA',
'92503': 'Riverside,CA',
'92504': 'Riverside,CA',
'92505': 'Riverside,CA',
'92506': 'Riverside,CA',
'92507': 'Riverside,CA',
'92508': 'Riverside,CA',
'92509': 'Riverside,CA',
'92513': 'Riverside,CA',
'92514': 'Riverside,CA',
'92515': 'Riverside,CA',
'92516': 'Riverside,CA',
'92517': 'Riverside,CA',
'92518': 'March Air Force Base,CA',
'92519': 'Riverside,CA',
'92521': 'Riverside,CA',
'92522': 'Riverside,CA',
'92530': 'Lake Elsinore,CA',
'92531': 'Lake Elsinore,CA',
'92532': 'Lake Elsinore,CA',
'92536': 'Aguanga,CA',
'92539': 'Anza,CA',
'92543': 'Hemet,CA',
'92544': 'Hemet,CA',
'92545': 'Hemet,CA',
'92546': 'Hemet,CA',
'92548': 'Homeland,CA',
'92549': 'Idyllwild,CA',
'92551': 'Moreno Valley,CA',
'92552': 'Moreno Valley,CA',
'92553': 'Moreno Valley,CA',
'92554': 'Moreno Valley,CA',
'92555': 'Moreno Valley,CA',
'92556': 'Moreno Valley,CA',
'92557': 'Moreno Valley,CA',
'92561': 'Mountain Center,CA',
'92562': 'Murrieta,CA',
'92563': 'Murrieta,CA',
'92564': 'Murrieta,CA',
'92567': 'Nuevo,CA',
'92570': 'Perris,CA',
'92571': 'Perris,CA',
'92572': 'Perris,CA',
'92581': 'San Jacinto,CA',
'92582': 'San Jacinto,CA',
'92583': 'San Jacinto,CA',
'92584': 'Menifee,CA',
'92585': 'Sun City,CA',
'92586': 'Sun City,CA',
'92587': 'Sun City,CA',
'92589': 'Temecula,CA',
'92590': 'Temecula,CA',
'92591': 'Temecula,CA',
'92592': 'Temecula,CA',
'92593': 'Temecula,CA',
'92595': 'Wildomar,CA',
'92596': 'Winchester,CA',
'92599': 'Perris,CA',
'92602': 'Irvine,CA',
'92603': 'Irvine,CA',
'92604': 'Irvine,CA',
'92605': 'Huntington Beach,CA',
'92606': 'Irvine,CA',
'92607': 'Laguna Niguel,CA',
'92609': 'El Toro,CA',
'92610': 'Foothill Ranch,CA',
'92612': 'Irvine,CA',
'92614': 'Irvine,CA',
'92615': 'Huntington Beach,CA',
'92616': 'Irvine,CA',
'92617': 'Irvine,CA',
'92618': 'Irvine,CA',
'92619': 'Irvine,CA',
'92620': 'Irvine,CA',
'92623': 'Irvine,CA',
'92624': 'Capistrano Beach,CA',
'92625': 'Corona Del Mar,CA',
'92626': 'Costa Mesa,CA',
'92627': 'Costa Mesa,CA',
'92628': 'Costa Mesa,CA',
'92629': 'Dana Point,CA',
'92630': 'Lake Forest,CA',
'92637': 'Laguna Hills,CA',
'92646': 'Huntington Beach,CA',
'92647': 'Huntington Beach,CA',
'92648': 'Huntington Beach,CA',
'92649': 'Huntington Beach,CA',
'92650': 'East Irvine,CA',
'92651': 'Laguna Beach,CA',
'92652': 'Laguna Beach,CA',
'92653': 'Laguna Hills,CA',
'92654': 'Laguna Hills,CA',
'92655': 'Midway City,CA',
'92656': 'Aliso Viejo,CA',
'92657': 'Newport Coast,CA',
'92658': 'Newport Beach,CA',
'92659': 'Newport Beach,CA',
'92660': 'Newport Beach,CA',
'92661': 'Newport Beach,CA',
'92662': 'Newport Beach,CA',
'92663': 'Newport Beach,CA',
'92672': 'San Clemente,CA',
'92673': 'San Clemente,CA',
'92674': 'San Clemente,CA',
'92675': 'San Juan Capistrano,CA',
'92676': 'Silverado,CA',
'92677': 'Laguna Niguel,CA',
'92678': 'Trabuco Canyon,CA',
'92679': 'Trabuco Canyon,CA',
'92683': 'Westminster,CA',
'92684': 'Westminster,CA',
'92685': 'Westminster,CA',
'92688': 'Rancho Santa Margarita,CA',
'92690': 'Mission Viejo,CA',
'92691': 'Mission Viejo,CA',
'92692': 'Mission Viejo,CA',
'92693': 'San Juan Capistrano,CA',
'92694': 'Ladera Ranch,CA',
'92697': 'Irvine,CA',
'92698': 'Aliso Viejo,CA',
'92701': 'Santa Ana,CA',
'92702': 'Santa Ana,CA',
'92703': 'Santa Ana,CA',
'92704': 'Santa Ana,CA',
'92705': 'Santa Ana,CA',
'92706': 'Santa Ana,CA',
'92707': 'Santa Ana,CA',
'92708': 'Fountain Valley,CA',
'92709': 'Irvine,CA',
'92710': 'Irvine,CA',
'92711': 'Santa Ana,CA',
'92712': 'Santa Ana,CA',
'92725': 'Santa Ana,CA',
'92728': 'Fountain Valley,CA',
'92735': 'Santa Ana,CA',
'92780': 'Tustin,CA',
'92781': 'Tustin,CA',
'92782': 'Tustin,CA',
'92799': 'Santa Ana,CA',
'92801': 'Anaheim,CA',
'92802': 'Anaheim,CA',
'92803': 'Anaheim,CA',
'92804': 'Anaheim,CA',
'92805': 'Anaheim,CA',
'92806': 'Anaheim,CA',
'92807': 'Anaheim,CA',
'92808': 'Anaheim,CA',
'92809': 'Anaheim,CA',
'92811': 'Atwood,CA',
'92812': 'Anaheim,CA',
'92814': 'Anaheim,CA',
'92815': 'Anaheim,CA',
'92816': 'Anaheim,CA',
'92817': 'Anaheim,CA',
'92821': 'Brea,CA',
'92822': 'Brea,CA',
'92823': 'Brea,CA',
'92825': 'Anaheim,CA',
'92831': 'Fullerton,CA',
'92832': 'Fullerton,CA',
'92833': 'Fullerton,CA',
'92834': 'Fullerton,CA',
'92835': 'Fullerton,CA',
'92836': 'Fullerton,CA',
'92837': 'Fullerton,CA',
'92838': 'Fullerton,CA',
'92840': 'Garden Grove,CA',
'92841': 'Garden Grove,CA',
'92842': 'Garden Grove,CA',
'92843': 'Garden Grove,CA',
'92844': 'Garden Grove,CA',
'92845': 'Garden Grove,CA',
'92846': 'Garden Grove,CA',
'92850': 'Anaheim,CA',
'92856': 'Orange,CA',
'92857': 'Orange,CA',
'92859': 'Orange,CA',
'92860': 'Norco,CA',
'92861': 'Villa Park,CA',
'92862': 'Orange,CA',
'92863': 'Orange,CA',
'92864': 'Orange,CA',
'92865': 'Orange,CA',
'92866': 'Orange,CA',
'92867': 'Orange,CA',
'92868': 'Orange,CA',
'92869': 'Orange,CA',
'92870': 'Placentia,CA',
'92871': 'Placentia,CA',
'92877': 'Corona,CA',
'92878': 'Corona,CA',
'92879': 'Corona,CA',
'92880': 'Corona,CA',
'92881': 'Corona,CA',
'92882': 'Corona,CA',
'92883': 'Corona,CA',
'92885': 'Yorba Linda,CA',
'92886': 'Yorba Linda,CA',
'92887': 'Yorba Linda,CA',
'92899': 'Anaheim,CA',
'93001': 'Ventura,CA',
'93002': 'Ventura,CA',
'93003': 'Ventura,CA',
'93004': 'Ventura,CA',
'93005': 'Ventura,CA',
'93006': 'Ventura,CA',
'93007': 'Ventura,CA',
'93009': 'Ventura,CA',
'93010': 'Camarillo,CA',
'93011': 'Camarillo,CA',
'93012': 'Camarillo,CA',
'93013': 'Carpinteria,CA',
'93014': 'Carpinteria,CA',
'93015': 'Fillmore,CA',
'93016': 'Fillmore,CA',
'93020': 'Moorpark,CA',
'93021': 'Moorpark,CA',
'93022': 'Oak View,CA',
'93023': 'Ojai,CA',
'93024': 'Ojai,CA',
'93030': 'Oxnard,CA',
'93031': 'Oxnard,CA',
'93032': 'Oxnard,CA',
'93033': 'Oxnard,CA',
'93034': 'Oxnard,CA',
'93035': 'Oxnard,CA',
'93036': 'Oxnard,CA',
'93040': 'Piru,CA',
'93041': 'Port Hueneme,CA',
'93042': 'Point Mugu Nawc,CA',
'93043': 'Port Hueneme Cbc Base,CA',
'93044': 'Port Hueneme,CA',
'93060': 'Santa Paula,CA',
'93061': 'Santa Paula,CA',
'93062': 'Simi Valley,CA',
'93063': 'Simi Valley,CA',
'93064': 'Brandeis,CA',
'93065': 'Simi Valley,CA',
'93066': 'Somis,CA',
'93067': 'Summerland,CA',
'93093': 'Simi Valley,CA',
'93094': 'Simi Valley,CA',
'93099': 'Simi Valley,CA',
'93101': 'Santa Barbara,CA',
'93102': 'Santa Barbara,CA',
'93103': 'Santa Barbara,CA',
'93105': 'Santa Barbara,CA',
'93106': 'Santa Barbara,CA',
'93107': 'Santa Barbara,CA',
'93108': 'Santa Barbara,CA',
'93109': 'Santa Barbara,CA',
'93110': 'Santa Barbara,CA',
'93111': 'Santa Barbara,CA',
'93116': 'Goleta,CA',
'93117': 'Goleta,CA',
'93118': 'Goleta,CA',
'93120': 'Santa Barbara,CA',
'93121': 'Santa Barbara,CA',
'93130': 'Santa Barbara,CA',
'93140': 'Santa Barbara,CA',
'93150': 'Santa Barbara,CA',
'93160': 'Santa Barbara,CA',
'93190': 'Santa Barbara,CA',
'93199': 'Goleta,CA',
'93201': 'Alpaugh,CA',
'93202': 'Armona,CA',
'93203': 'Arvin,CA',
'93204': 'Avenal,CA',
'93205': 'Bodfish,CA',
'93206': 'Buttonwillow,CA',
'93207': 'California Hot Springs,CA',
'93208': 'Camp Nelson,CA',
'93210': 'Coalinga,CA',
'93212': 'Corcoran,CA',
'93215': 'Delano,CA',
'93216': 'Delano,CA',
'93218': 'Ducor,CA',
'93219': 'Earlimart,CA',
'93220': 'Edison,CA',
'93221': 'Exeter,CA',
'93222': 'Frazier Park,CA',
'93223': 'Farmersville,CA',
'93224': 'Fellows,CA',
'93225': 'Frazier Park,CA',
'93226': 'Glennville,CA',
'93227': 'Goshen,CA',
'93230': 'Hanford,CA',
'93232': 'Hanford,CA',
'93234': 'Huron,CA',
'93235': 'Ivanhoe,CA',
'93237': 'Kaweah,CA',
'93238': 'Kernville,CA',
'93239': 'Kettleman City,CA',
'93240': 'Lake Isabella,CA',
'93241': 'Lamont,CA',
'93242': 'Laton,CA',
'93243': 'Lebec,CA',
'93244': 'Lemon Cove,CA',
'93245': 'Lemoore,CA',
'93246': 'Lemoore,CA',
'93247': 'Lindsay,CA',
'93249': 'Lost Hills,CA',
'93250': 'Mc Farland,CA',
'93251': 'Mc Kittrick,CA',
'93252': 'Maricopa,CA',
'93254': 'New Cuyama,CA',
'93255': 'Onyx,CA',
'93256': 'Pixley,CA',
'93257': 'Porterville,CA',
'93258': 'Porterville,CA',
'93260': 'Posey,CA',
'93261': 'Richgrove,CA',
'93262': 'Sequoia National Park,CA',
'93263': 'Shafter,CA',
'93265': 'Springville,CA',
'93266': 'Stratford,CA',
'93267': 'Strathmore,CA',
'93268': 'Taft,CA',
'93270': 'Terra Bella,CA',
'93271': 'Three Rivers,CA',
'93272': 'Tipton,CA',
'93274': 'Tulare,CA',
'93275': 'Tulare,CA',
'93276': 'Tupman,CA',
'93277': 'Visalia,CA',
'93278': 'Visalia,CA',
'93279': 'Visalia,CA',
'93280': 'Wasco,CA',
'93282': 'Waukena,CA',
'93283': 'Weldon,CA',
'93285': 'Wofford Heights,CA',
'93286': 'Woodlake,CA',
'93287': 'Woody,CA',
'93290': 'Visalia,CA',
'93291': 'Visalia,CA',
'93292': 'Visalia,CA',
'93301': 'Bakersfield,CA',
'93302': 'Bakersfield,CA',
'93303': 'Bakersfield,CA',
'93304': 'Bakersfield,CA',
'93305': 'Bakersfield,CA',
'93306': 'Bakersfield,CA',
'93307': 'Bakersfield,CA',
'93308': 'Bakersfield,CA',
'93309': 'Bakersfield,CA',
'93311': 'Bakersfield,CA',
'93312': 'Bakersfield,CA',
'93313': 'Bakersfield,CA',
'93314': 'Shafter,CA',
'93380': 'Bakersfield,CA',
'93381': 'Bakersfield,CA',
'93382': 'Bakersfield,CA',
'93383': 'Bakersfield,CA',
'93384': 'Bakersfield,CA',
'93385': 'Bakersfield,CA',
'93386': 'Bakersfield,CA',
'93387': 'Bakersfield,CA',
'93388': 'Bakersfield,CA',
'93389': 'Bakersfield,CA',
'93390': 'Bakersfield,CA',
'93401': 'San Luis Obispo,CA',
'93402': 'Los Osos,CA',
'93403': 'San Luis Obispo,CA',
'93405': 'San Luis Obispo,CA',
'93406': 'San Luis Obispo,CA',
'93407': 'San Luis Obispo,CA',
'93408': 'San Luis Obispo,CA',
'93409': 'San Luis Obispo,CA',
'93410': 'San Luis Obispo,CA',
'93412': 'Los Osos,CA',
'93420': 'Arroyo Grande,CA',
'93421': 'Arroyo Grande,CA',
'93422': 'Atascadero,CA',
'93423': 'Atascadero,CA',
'93424': 'Avila Beach,CA',
'93426': 'Bradley,CA',
'93427': 'Buellton,CA',
'93428': 'Cambria,CA',
'93429': 'Casmalia,CA',
'93430': 'Cayucos,CA',
'93432': 'Creston,CA',
'93433': 'Grover Beach,CA',
'93434': 'Guadalupe,CA',
'93435': 'Harmony,CA',
'93436': 'Lompoc,CA',
'93437': 'Lompoc,CA',
'93438': 'Lompoc,CA',
'93440': 'Los Alamos,CA',
'93441': 'Los Olivos,CA',
'93442': 'Morro Bay,CA',
'93443': 'Morro Bay,CA',
'93444': 'Nipomo,CA',
'93445': 'Oceano,CA',
'93446': 'Paso Robles,CA',
'93447': 'Paso Robles,CA',
'93448': 'Pismo Beach,CA',
'93449': 'Pismo Beach,CA',
'93450': 'San Ardo,CA',
'93451': 'San Miguel,CA',
'93452': 'San Simeon,CA',
'93453': 'Santa Margarita,CA',
'93454': 'Santa Maria,CA',
'93455': 'Santa Maria,CA',
'93456': 'Santa Maria,CA',
'93457': 'Santa Maria,CA',
'93458': 'Santa Maria,CA',
'93460': 'Santa Ynez,CA',
'93461': 'Shandon,CA',
'93463': 'Solvang,CA',
'93464': 'Solvang,CA',
'93465': 'Templeton,CA',
'93475': 'Oceano,CA',
'93483': 'Grover Beach,CA',
'93501': 'Mojave,CA',
'93502': 'Mojave,CA',
'93504': 'California City,CA',
'93505': 'California City,CA',
'93510': 'Acton,CA',
'93512': 'Benton,CA',
'93513': 'Big Pine,CA',
'93514': 'Bishop,CA',
'93515': 'Bishop,CA',
'93516': 'Boron,CA',
'93517': 'Bridgeport,CA',
'93518': 'Caliente,CA',
'93519': 'Cantil,CA',
'93522': 'Darwin,CA',
'93523': 'Edwards,CA',
'93524': 'Edwards,CA',
'93526': 'Independence,CA',
'93527': 'Inyokern,CA',
'93528': 'Johannesburg,CA',
'93529': 'June Lake,CA',
'93530': 'Keeler,CA',
'93531': 'Keene,CA',
'93532': 'Lake Hughes,CA',
'93534': 'Lancaster,CA',
'93535': 'Lancaster,CA',
'93536': 'Lancaster,CA',
'93539': 'Lancaster,CA',
'93541': 'Lee Vining,CA',
'93542': 'Little Lake,CA',
'93543': 'Littlerock,CA',
'93544': 'Llano,CA',
'93545': 'Lone Pine,CA',
'93546': 'Mammoth Lakes,CA',
'93549': 'Olancha,CA',
'93550': 'Palmdale,CA',
'93551': 'Palmdale,CA',
'93552': 'Palmdale,CA',
'93553': 'Pearblossom,CA',
'93554': 'Randsburg,CA',
'93555': 'Ridgecrest,CA',
'93556': 'Ridgecrest,CA',
'93558': 'Red Mountain,CA',
'93560': 'Rosamond,CA',
'93561': 'Tehachapi,CA',
'93562': 'Trona,CA',
'93563': 'Valyermo,CA',
'93581': 'Tehachapi,CA',
'93584': 'Lancaster,CA',
'93586': 'Lancaster,CA',
'93590': 'Palmdale,CA',
'93591': 'Palmdale,CA',
'93592': 'Trona,CA',
'93596': 'Boron,CA',
'93599': 'Palmdale,CA',
'93601': 'Ahwahnee,CA',
'93602': 'Auberry,CA',
'93603': 'Badger,CA',
'93604': 'Bass Lake,CA',
'93605': 'Big Creek,CA',
'93606': 'Biola,CA',
'93607': 'Burrel,CA',
'93608': 'Cantua Creek,CA',
'93609': 'Caruthers,CA',
'93610': 'Chowchilla,CA',
'93611': 'Clovis,CA',
'93612': 'Clovis,CA',
'93613': 'Clovis,CA',
'93614': 'Coarsegold,CA',
'93615': 'Cutler,CA',
'93616': 'Del Rey,CA',
'93618': 'Dinuba,CA',
'93619': 'Clovis,CA',
'93620': 'Dos Palos,CA',
'93621': 'Dunlap,CA',
'93622': 'Firebaugh,CA',
'93623': 'Fish Camp,CA',
'93624': 'Five Points,CA',
'93625': 'Fowler,CA',
'93626': 'Friant,CA',
'93627': 'Helm,CA',
'93628': 'Hume,CA',
'93630': 'Kerman,CA',
'93631': 'Kingsburg,CA',
'93633': 'Kings Canyon National Pk,CA',
'93634': 'Lakeshore,CA',
'93635': 'Los Banos,CA',
'93636': 'Madera,CA',
'93637': 'Madera,CA',
'93638': 'Madera,CA',
'93639': 'Madera,CA',
'93640': 'Mendota,CA',
'93641': 'Miramonte,CA',
'93642': 'Mono Hot Springs,CA',
'93643': 'North Fork,CA',
'93644': 'Oakhurst,CA',
'93645': 'O Neals,CA',
'93646': 'Orange Cove,CA',
'93647': 'Orosi,CA',
'93648': 'Parlier,CA',
'93649': 'Piedra,CA',
'93650': 'Fresno,CA',
'93651': 'Prather,CA',
'93652': 'Raisin,CA',
'93653': 'Raymond,CA',
'93654': 'Reedley,CA',
'93656': 'Riverdale,CA',
'93657': 'Sanger,CA',
'93660': 'San Joaquin,CA',
'93661': 'Santa Rita Park,CA',
'93662': 'Selma,CA',
'93664': 'Shaver Lake,CA',
'93665': 'South Dos Palos,CA',
'93666': 'Sultana,CA',
'93667': 'Tollhouse,CA',
'93668': 'Tranquillity,CA',
'93669': 'Wishon,CA',
'93670': 'Yettem,CA',
'93673': 'Traver,CA',
'93675': 'Squaw Valley,CA',
'93701': 'Fresno,CA',
'93702': 'Fresno,CA',
'93703': 'Fresno,CA',
'93704': 'Fresno,CA',
'93705': 'Fresno,CA',
'93706': 'Fresno,CA',
'93707': 'Fresno,CA',
'93708': 'Fresno,CA',
'93709': 'Fresno,CA',
'93710': 'Fresno,CA',
'93711': 'Fresno,CA',
'93712': 'Fresno,CA',
'93714': 'Fresno,CA',
'93715': 'Fresno,CA',
'93716': 'Fresno,CA',
'93717': 'Fresno,CA',
'93718': 'Fresno,CA',
'93720': 'Fresno,CA',
'93721': 'Fresno,CA',
'93722': 'Fresno,CA',
'93723': 'Fresno,CA',
'93724': 'Fresno,CA',
'93725': 'Fresno,CA',
'93726': 'Fresno,CA',
'93727': 'Fresno,CA',
'93728': 'Fresno,CA',
'93729': 'Fresno,CA',
'93730': 'Fresno,CA',
'93737': 'City Center,NV',
'93740': 'Fresno,CA',
'93741': 'Fresno,CA',
'93744': 'Fresno,CA',
'93745': 'Fresno,CA',
'93747': 'Fresno,CA',
'93750': 'Fresno,CA',
'93755': 'Fresno,CA',
'93760': 'Fresno,CA',
'93761': 'Fresno,CA',
'93762': 'Fresno,CA',
'93764': 'Fresno,CA',
'93765': 'Fresno,CA',
'93771': 'Fresno,CA',
'93772': 'Fresno,CA',
'93773': 'Fresno,CA',
'93774': 'Fresno,CA',
'93775': 'Fresno,CA',
'93776': 'Fresno,CA',
'93777': 'Fresno,CA',
'93778': 'Fresno,CA',
'93779': 'Fresno,CA',
'93780': 'Fresno,CA',
'93784': 'Fresno,CA',
'93786': 'Fresno,CA',
'93790': 'Fresno,CA',
'93791': 'Fresno,CA',
'93792': 'Fresno,CA',
'93793': 'Fresno,CA',
'93794': 'Fresno,CA',
'93844': 'Fresno,CA',
'93888': 'Fresno,CA',
'93901': 'Salinas,CA',
'93902': 'Salinas,CA',
'93905': 'Salinas,CA',
'93906': 'Salinas,CA',
'93907': 'Salinas,CA',
'93908': 'Salinas,CA',
'93912': 'Salinas,CA',
'93915': 'Salinas,CA',
'93920': 'Big Sur,CA',
'93921': 'Carmel,CA',
'93922': 'Carmel,CA',
'93923': 'Carmel,CA',
'93924': 'Carmel Valley,CA',
'93925': 'Chualar,CA',
'93926': 'Gonzales,CA',
'93927': 'Greenfield,CA',
'93928': 'Jolon,CA',
'93930': 'King City,CA',
'93932': 'Lockwood,CA',
'93933': 'Marina,CA',
'93940': 'Monterey,CA',
'93942': 'Monterey,CA',
'93943': 'Monterey,CA',
'93944': 'Monterey,CA',
'93950': 'Pacific Grove,CA',
'93953': 'Pebble Beach,CA',
'93954': 'San Lucas,CA',
'93955': 'Seaside,CA',
'93960': 'Soledad,CA',
'93962': 'Spreckels,CA',
'94002': 'Belmont,CA',
'94003': 'Belmont,CA',
'94005': 'Brisbane,CA',
'94010': 'Burlingame,CA',
'94011': 'Burlingame,CA',
'94012': 'Burlingame,CA',
'94013': 'Daly City,CA',
'94014': 'Daly City,CA',
'94015': 'Daly City,CA',
'94016': 'Daly City,CA',
'94017': 'Daly City,CA',
'94018': 'El Granada,CA',
'94019': 'Half Moon Bay,CA',
'94020': 'La Honda,CA',
'94021': 'Loma Mar,CA',
'94022': 'Los Altos,CA',
'94023': 'Los Altos,CA',
'94024': 'Los Altos,CA',
'94025': 'Menlo Park,CA',
'94026': 'Menlo Park,CA',
'94027': 'Atherton,CA',
'94028': 'Portola Valley,CA',
'94029': 'Menlo Park,CA',
'94030': 'Millbrae,CA',
'94031': 'Millbrae,CA',
'94035': 'Mountain View,CA',
'94037': 'Montara,CA',
'94038': 'Moss Beach,CA',
'94039': 'Mountain View,CA',
'94040': 'Mountain View,CA',
'94041': 'Mountain View,CA',
'94042': 'Mountain View,CA',
'94043': 'Mountain View,CA',
'94044': 'Pacifica,CA',
'94045': 'Pacifica,CA',
'94059': 'Redwood City,CA',
'94060': 'Pescadero,CA',
'94061': 'Redwood City,CA',
'94062': 'Redwood City,CA',
'94063': 'Redwood City,CA',
'94064': 'Redwood City,CA',
'94065': 'Redwood City,CA',
'94066': 'San Bruno,CA',
'94067': 'San Bruno,CA',
'94070': 'San Carlos,CA',
'94071': 'San Carlos,CA',
'94074': 'San Gregorio,CA',
'94080': 'South San Francisco,CA',
'94083': 'South San Francisco,CA',
'94085': 'Sunnyvale,CA',
'94086': 'Sunnyvale,CA',
'94087': 'Sunnyvale,CA',
'94088': 'Sunnyvale,CA',
'94089': 'Sunnyvale,CA',
'94090': 'Sunnyvale,CA',
'94096': 'San Bruno,CA',
'94098': 'San Bruno,CA',
'94099': 'South San Francisco,CA',
'94101': 'San Francisco,CA',
'94102': 'San Francisco,CA',
'94103': 'San Francisco,CA',
'94104': 'San Francisco,CA',
'94105': 'San Francisco,CA',
'94106': 'San Francisco,CA',
'94107': 'San Francisco,CA',
'94108': 'San Francisco,CA',
'94109': 'San Francisco,CA',
'94110': 'San Francisco,CA',
'94111': 'San Francisco,CA',
'94112': 'San Francisco,CA',
'94114': 'San Francisco,CA',
'94115': 'San Francisco,CA',
'94116': 'San Francisco,CA',
'94117': 'San Francisco,CA',
'94118': 'San Francisco,CA',
'94119': 'San Francisco,CA',
'94120': 'San Francisco,CA',
'94121': 'San Francisco,CA',
'94122': 'San Francisco,CA',
'94123': 'San Francisco,CA',
'94124': 'San Francisco,CA',
'94125': 'San Francisco,CA',
'94126': 'San Francisco,CA',
'94127': 'San Francisco,CA',
'94128': 'San Francisco,CA',
'94129': 'San Francisco,CA',
'94130': 'San Francisco,CA',
'94131': 'San Francisco,CA',
'94132': 'San Francisco,CA',
'94133': 'San Francisco,CA',
'94134': 'San Francisco,CA',
'94135': 'San Francisco,CA',
'94136': 'San Francisco,CA',
'94137': 'San Francisco,CA',
'94138': 'San Francisco,CA',
'94139': 'San Francisco,CA',
'94140': 'San Francisco,CA',
'94141': 'San Francisco,CA',
'94142': 'San Francisco,CA',
'94143': 'San Francisco,CA',
'94144': 'San Francisco,CA',
'94145': 'San Francisco,CA',
'94146': 'San Francisco,CA',
'94147': 'San Francisco,CA',
'94150': 'San Francisco,CA',
'94151': 'San Francisco,CA',
'94152': 'San Francisco,CA',
'94153': 'San Francisco,CA',
'94154': 'San Francisco,CA',
'94155': 'San Francisco,CA',
'94156': 'San Francisco,CA',
'94157': 'San Francisco,CA',
'94158': 'San Francisco,CA',
'94159': 'San Francisco,CA',
'94160': 'San Francisco,CA',
'94161': 'San Francisco,CA',
'94162': 'San Francisco,CA',
'94163': 'San Francisco,CA',
'94164': 'San Francisco,CA',
'94165': 'San Francisco,CA',
'94166': 'San Francisco,CA',
'94167': 'San Francisco,CA',
'94168': 'San Francisco,CA',
'94169': 'San Francisco,CA',
'94170': 'San Francisco,CA',
'94171': 'San Francisco,CA',
'94172': 'San Francisco,CA',
'94175': 'San Francisco,CA',
'94177': 'San Francisco,CA',
'94188': 'San Francisco,CA',
'94199': 'San Francisco,CA',
'94203': 'Sacramento,CA',
'94204': 'Sacramento,CA',
'94205': 'Sacramento,CA',
'94206': 'Sacramento,CA',
'94207': 'Sacramento,CA',
'94208': 'Sacramento,CA',
'94209': 'Sacramento,CA',
'94211': 'Sacramento,CA',
'94229': 'Sacramento,CA',
'94230': 'Sacramento,CA',
'94232': 'Sacramento,CA',
'94234': 'Sacramento,CA',
'94235': 'Sacramento,CA',
'94236': 'Sacramento,CA',
'94237': 'Sacramento,CA',
'94239': 'Sacramento,CA',
'94240': 'Sacramento,CA',
'94243': 'Sacramento,CA',
'94244': 'Sacramento,CA',
'94245': 'Sacramento,CA',
'94246': 'Sacramento,CA',
'94247': 'Sacramento,CA',
'94248': 'Sacramento,CA',
'94249': 'Sacramento,CA',
'94250': 'Sacramento,CA',
'94252': 'Sacramento,CA',
'94253': 'Sacramento,CA',
'94254': 'Sacramento,CA',
'94256': 'Sacramento,CA',
'94257': 'Sacramento,CA',
'94258': 'Sacramento,CA',
'94259': 'Sacramento,CA',
'94261': 'Sacramento,CA',
'94262': 'Sacramento,CA',
'94263': 'Sacramento,CA',
'94267': 'Sacramento,CA',
'94268': 'Sacramento,CA',
'94269': 'Sacramento,CA',
'94271': 'Sacramento,CA',
'94273': 'Sacramento,CA',
'94274': 'Sacramento,CA',
'94277': 'Sacramento,CA',
'94278': 'Sacramento,CA',
'94279': 'Sacramento,CA',
'94280': 'Sacramento,CA',
'94282': 'Sacramento,CA',
'94283': 'Sacramento,CA',
'94284': 'Sacramento,CA',
'94285': 'Sacramento,CA',
'94286': 'Sacramento,CA',
'94287': 'Sacramento,CA',
'94288': 'Sacramento,CA',
'94289': 'Sacramento,CA',
'94290': 'Sacramento,CA',
'94291': 'Sacramento,CA',
'94293': 'Sacramento,CA',
'94294': 'Sacramento,CA',
'94295': 'Sacramento,CA',
'94296': 'Sacramento,CA',
'94297': 'Sacramento,CA',
'94298': 'Sacramento,CA',
'94299': 'Sacramento,CA',
'94301': 'Palo Alto,CA',
'94302': 'Palo Alto,CA',
'94303': 'Palo Alto,CA',
'94304': 'Palo Alto,CA',
'94305': 'Stanford,CA',
'94306': 'Palo Alto,CA',
'94307': 'Palo Alto,CA',
'94308': 'Palo Alto,CA',
'94309': 'Palo Alto,CA',
'94310': 'Palo Alto,CA',
'94401': 'San Mateo,CA',
'94402': 'San Mateo,CA',
'94403': 'San Mateo,CA',
'94404': 'San Mateo,CA',
'94405': 'San Mateo,CA',
'94406': 'San Mateo,CA',
'94407': 'San Mateo,CA',
'94408': 'San Mateo,CA',
'94409': 'San Mateo,CA',
'94497': 'San Mateo,CA',
'94501': 'Alameda,CA',
'94502': 'Alameda,CA',
'94503': 'American Canyon,CA',
'94506': 'Danville,CA',
'94507': 'Alamo,CA',
'94508': 'Angwin,CA',
'94509': 'Antioch,CA',
'94510': 'Benicia,CA',
'94511': 'Bethel Island,CA',
'94512': 'Birds Landing,CA',
'94513': 'Brentwood,CA',
'94514': 'Byron,CA',
'94515': 'Calistoga,CA',
'94516': 'Canyon,CA',
'94517': 'Clayton,CA',
'94518': 'Concord,CA',
'94519': 'Concord,CA',
'94520': 'Concord,CA',
'94521': 'Concord,CA',
'94522': 'Concord,CA',
'94523': 'Pleasant Hill,CA',
'94524': 'Concord,CA',
'94525': 'Crockett,CA',
'94526': 'Danville,CA',
'94527': 'Concord,CA',
'94528': 'Diablo,CA',
'94529': 'Concord,CA',
'94530': 'El Cerrito,CA',
'94531': 'Antioch,CA',
'94533': 'Fairfield,CA',
'94535': 'Travis Afb,CA',
'94536': 'Fremont,CA',
'94537': 'Fremont,CA',
'94538': 'Fremont,CA',
'94539': 'Fremont,CA',
'94540': 'Hayward,CA',
'94541': 'Hayward,CA',
'94542': 'Hayward,CA',
'94543': 'Hayward,CA',
'94544': 'Hayward,CA',
'94545': 'Hayward,CA',
'94546': 'Castro Valley,CA',
'94547': 'Hercules,CA',
'94548': 'Knightsen,CA',
'94549': 'Lafayette,CA',
'94550': 'Livermore,CA',
'94551': 'Livermore,CA',
'94552': 'Castro Valley,CA',
'94553': 'Martinez,CA',
'94555': 'Fremont,CA',
'94556': 'Moraga,CA',
'94557': 'Hayward,CA',
'94558': 'Napa,CA',
'94559': 'Napa,CA',
'94560': 'Newark,CA',
'94561': 'Oakley,CA',
'94562': 'Oakville,CA',
'94563': 'Orinda,CA',
'94564': 'Pinole,CA',
'94565': 'Pittsburg,CA',
'94566': 'Pleasanton,CA',
'94567': 'Pope Valley,CA',
'94568': 'Dublin,CA',
'94569': 'Port Costa,CA',
'94570': 'Moraga,CA',
'94571': 'Rio Vista,CA',
'94572': 'Rodeo,CA',
'94573': 'Rutherford,CA',
'94574': 'Saint Helena,CA',
'94575': 'Moraga,CA',
'94576': 'Deer Park,CA',
'94577': 'San Leandro,CA',
'94578': 'San Leandro,CA',
'94579': 'San Leandro,CA',
'94580': 'San Lorenzo,CA',
'94581': 'Napa,CA',
'94582': 'San Ramon,CA',
'94583': 'San Ramon,CA',
'94585': 'Suisun City,CA',
'94586': 'Sunol,CA',
'94587': 'Union City,CA',
'94588': 'Pleasanton,CA',
'94589': 'Vallejo,CA',
'94590': 'Vallejo,CA',
'94591': 'Vallejo,CA',
'94592': 'Vallejo,CA',
'94595': 'Walnut Creek,CA',
'94596': 'Walnut Creek,CA',
'94597': 'Walnut Creek,CA',
'94598': 'Walnut Creek,CA',
'94599': 'Yountville,CA',
'94601': 'Oakland,CA',
'94602': 'Oakland,CA',
'94603': 'Oakland,CA',
'94604': 'Oakland,CA',
'94605': 'Oakland,CA',
'94606': 'Oakland,CA',
'94607': 'Oakland,CA',
'94608': 'Emeryville,CA',
'94609': 'Oakland,CA',
'94610': 'Oakland,CA',
'94611': 'Oakland,CA',
'94612': 'Oakland,CA',
'94613': 'Oakland,CA',
'94614': 'Oakland,CA',
'94615': 'Oakland,CA',
'94617': 'Oakland,CA',
'94618': 'Oakland,CA',
'94619': 'Oakland,CA',
'94620': 'Piedmont,CA',
'94621': 'Oakland,CA',
'94622': 'Oakland,CA',
'94623': 'Oakland,CA',
'94624': 'Oakland,CA',
'94625': 'Oakland,CA',
'94626': 'Oakland,CA',
'94627': 'Oakland,CA',
'94643': 'Oakland,CA',
'94649': 'Oakland,CA',
'94659': 'Oakland,CA',
'94660': 'Oakland,CA',
'94661': 'Oakland,CA',
'94662': 'Emeryville,CA',
'94666': 'Oakland,CA',
'94701': 'Berkeley,CA',
'94702': 'Berkeley,CA',
'94703': 'Berkeley,CA',
'94704': 'Berkeley,CA',
'94705': 'Berkeley,CA',
'94706': 'Albany,CA',
'94707': 'Berkeley,CA',
'94708': 'Berkeley,CA',
'94709': 'Berkeley,CA',
'94710': 'Berkeley,CA',
'94712': 'Berkeley,CA',
'94720': 'Berkeley,CA',
'94801': 'Richmond,CA',
'94802': 'Richmond,CA',
'94803': 'El Sobrante,CA',
'94804': 'Richmond,CA',
'94805': 'Richmond,CA',
'94806': 'San Pablo,CA',
'94807': 'Richmond,CA',
'94808': 'Richmond,CA',
'94820': 'El Sobrante,CA',
'94850': 'Richmond,CA',
'94901': 'San Rafael,CA',
'94903': 'San Rafael,CA',
'94904': 'Greenbrae,CA',
'94912': 'San Rafael,CA',
'94913': 'San Rafael,CA',
'94914': 'Kentfield,CA',
'94915': 'San Rafael,CA',
'94920': 'Belvedere Tiburon,CA',
'94922': 'Bodega,CA',
'94923': 'Bodega Bay,CA',
'94924': 'Bolinas,CA',
'94925': 'Corte Madera,CA',
'94926': 'Cotati,CA',
'94927': 'Rohnert Park,CA',
'94928': 'Rohnert Park,CA',
'94929': 'Dillon Beach,CA',
'94930': 'Fairfax,CA',
'94931': 'Cotati,CA',
'94933': 'Forest Knolls,CA',
'94937': 'Inverness,CA',
'94938': 'Lagunitas,CA',
'94939': 'Larkspur,CA',
'94940': 'Marshall,CA',
'94941': 'Mill Valley,CA',
'94942': 'Mill Valley,CA',
'94945': 'Novato,CA',
'94946': 'Nicasio,CA',
'94947': 'Novato,CA',
'94948': 'Novato,CA',
'94949': 'Novato,CA',
'94950': 'Olema,CA',
'94951': 'Penngrove,CA',
'94952': 'Petaluma,CA',
'94953': 'Petaluma,CA',
'94954': 'Petaluma,CA',
'94955': 'Petaluma,CA',
'94956': 'Point Reyes Station,CA',
'94957': 'Ross,CA',
'94960': 'San Anselmo,CA',
'94963': 'San Geronimo,CA',
'94964': 'San Quentin,CA',
'94965': 'Sausalito,CA',
'94966': 'Sausalito,CA',
'94970': 'Stinson Beach,CA',
'94971': 'Tomales,CA',
'94972': 'Valley Ford,CA',
'94973': 'Woodacre,CA',
'94974': 'San Quentin,CA',
'94975': 'Petaluma,CA',
'94976': 'Corte Madera,CA',
'94977': 'Larkspur,CA',
'94978': 'Fairfax,CA',
'94979': 'San Anselmo,CA',
'94998': 'Novato,CA',
'94999': 'Petaluma,CA',
'95001': 'Aptos,CA',
'95002': 'Alviso,CA',
'95003': 'Aptos,CA',
'95004': 'Aromas,CA',
'95005': 'Ben Lomond,CA',
'95006': 'Boulder Creek,CA',
'95007': 'Brookdale,CA',
'95008': 'Campbell,CA',
'95009': 'Campbell,CA',
'95010': 'Capitola,CA',
'95011': 'Campbell,CA',
'95012': 'Castroville,CA',
'95013': 'Coyote,CA',
'95014': 'Cupertino,CA',
'95015': 'Cupertino,CA',
'95017': 'Davenport,CA',
'95018': 'Felton,CA',
'95019': 'Freedom,CA',
'95020': 'Gilroy,CA',
'95021': 'Gilroy,CA',
'95023': 'Hollister,CA',
'95024': 'Hollister,CA',
'95026': 'Holy City,CA',
'95030': 'Los Gatos,CA',
'95031': 'Los Gatos,CA',
'95032': 'Los Gatos,CA',
'95033': 'Los Gatos,CA',
'95035': 'Milpitas,CA',
'95036': 'Milpitas,CA',
'95037': 'Morgan Hill,CA',
'95038': 'Morgan Hill,CA',
'95039': 'Moss Landing,CA',
'95041': 'Mount Hermon,CA',
'95042': 'New Almaden,CA',
'95043': 'Paicines,CA',
'95044': 'Redwood Estates,CA',
'95045': 'San Juan Bautista,CA',
'95046': 'San Martin,CA',
'95050': 'Santa Clara,CA',
'95051': 'Santa Clara,CA',
'95052': 'Santa Clara,CA',
'95053': 'Santa Clara,CA',
'95054': 'Santa Clara,CA',
'95055': 'Santa Clara,CA',
'95056': 'Santa Clara,CA',
'95060': 'Santa Cruz,CA',
'95061': 'Santa Cruz,CA',
'95062': 'Santa Cruz,CA',
'95063': 'Santa Cruz,CA',
'95064': 'Santa Cruz,CA',
'95065': 'Santa Cruz,CA',
'95066': 'Scotts Valley,CA',
'95067': 'Scotts Valley,CA',
'95070': 'Saratoga,CA',
'95071': 'Saratoga,CA',
'95073': 'Soquel,CA',
'95075': 'Tres Pinos,CA',
'95076': 'Watsonville,CA',
'95077': 'Watsonville,CA',
'95101': 'San Jose,CA',
'95102': 'San Jose,CA',
'95103': 'San Jose,CA',
'95106': 'San Jose,CA',
'95108': 'San Jose,CA',
'95109': 'San Jose,CA',
'95110': 'San Jose,CA',
'95111': 'San Jose,CA',
'95112': 'San Jose,CA',
'95113': 'San Jose,CA',
'95114': 'San Jose,CA',
'95115': 'San Jose,CA',
'95116': 'San Jose,CA',
'95117': 'San Jose,CA',
'95118': 'San Jose,CA',
'95119': 'San Jose,CA',
'95120': 'San Jose,CA',
'95121': 'San Jose,CA',
'95122': 'San Jose,CA',
'95123': 'San Jose,CA',
'95124': 'San Jose,CA',
'95125': 'San Jose,CA',
'95126': 'San Jose,CA',
'95127': 'San Jose,CA',
'95128': 'San Jose,CA',
'95129': 'San Jose,CA',
'95130': 'San Jose,CA',
'95131': 'San Jose,CA',
'95132': 'San Jose,CA',
'95133': 'San Jose,CA',
'95134': 'San Jose,CA',
'95135': 'San Jose,CA',
'95136': 'San Jose,CA',
'95137': 'San Jose,CA',
'95138': 'San Jose,CA',
'95139': 'San Jose,CA',
'95140': 'Mount Hamilton,CA',
'95141': 'San Jose,CA',
'95142': 'San Jose,CA',
'95148': 'San Jose,CA',
'95150': 'San Jose,CA',
'95151': 'San Jose,CA',
'95152': 'San Jose,CA',
'95153': 'San Jose,CA',
'95154': 'San Jose,CA',
'95155': 'San Jose,CA',
'95156': 'San Jose,CA',
'95157': 'San Jose,CA',
'95158': 'San Jose,CA',
'95159': 'San Jose,CA',
'95160': 'San Jose,CA',
'95161': 'San Jose,CA',
'95164': 'San Jose,CA',
'95170': 'San Jose,CA',
'95171': 'San Jose,CA',
'95172': 'San Jose,CA',
'95173': 'San Jose,CA',
'95190': 'San Jose,CA',
'95191': 'San Jose,CA',
'95192': 'San Jose,CA',
'95193': 'San Jose,CA',
'95194': 'San Jose,CA',
'95196': 'San Jose,CA',
'95201': 'Stockton,CA',
'95202': 'Stockton,CA',
'95203': 'Stockton,CA',
'95204': 'Stockton,CA',
'95205': 'Stockton,CA',
'95206': 'Stockton,CA',
'95207': 'Stockton,CA',
'95208': 'Stockton,CA',
'95209': 'Stockton,CA',
'95210': 'Stockton,CA',
'95211': 'Stockton,CA',
'95212': 'Stockton,CA',
'95213': 'Stockton,CA',
'95215': 'Stockton,CA',
'95219': 'Stockton,CA',
'95220': 'Acampo,CA',
'95221': 'Altaville,CA',
'95222': 'Angels Camp,CA',
'95223': 'Arnold,CA',
'95224': 'Avery,CA',
'95225': 'Burson,CA',
'95226': 'Campo Seco,CA',
'95227': 'Clements,CA',
'95228': 'Copperopolis,CA',
'95229': 'Douglas Flat,CA',
'95230': 'Farmington,CA',
'95231': 'French Camp,CA',
'95232': 'Glencoe,CA',
'95233': 'Hathaway Pines,CA',
'95234': 'Holt,CA',
'95236': 'Linden,CA',
'95237': 'Lockeford,CA',
'95240': 'Lodi,CA',
'95241': 'Lodi,CA',
'95242': 'Lodi,CA',
'95245': 'Mokelumne Hill,CA',
'95246': 'Mountain Ranch,CA',
'95247': 'Murphys,CA',
'95248': 'Rail Road Flat,CA',
'95249': 'San Andreas,CA',
'95250': 'Sheep Ranch,CA',
'95251': 'Vallecito,CA',
'95252': 'Valley Springs,CA',
'95253': 'Victor,CA',
'95254': 'Wallace,CA',
'95255': 'West Point,CA',
'95257': 'Wilseyville,CA',
'95258': 'Woodbridge,CA',
'95267': 'Stockton,CA',
'95269': 'Stockton,CA',
'95290': 'Stockton,CA',
'95296': 'Lyoth,CA',
'95297': 'Stockton,CA',
'95298': 'Stockton,CA',
'95301': 'Atwater,CA',
'95303': 'Ballico,CA',
'95304': 'Tracy,CA',
'95305': 'Big Oak Flat,CA',
'95306': 'Catheys Valley,CA',
'95307': 'Ceres,CA',
'95309': 'Chinese Camp,CA',
'95310': 'Columbia,CA',
'95311': 'Coulterville,CA',
'95312': 'Cressey,CA',
'95313': 'Crows Landing,CA',
'95314': 'Dardanelle,CA',
'95315': 'Delhi,CA',
'95316': 'Denair,CA',
'95317': 'El Nido,CA',
'95318': 'El Portal,CA',
'95319': 'Empire,CA',
'95320': 'Escalon,CA',
'95321': 'Groveland,CA',
'95322': 'Gustine,CA',
'95323': 'Hickman,CA',
'95324': 'Hilmar,CA',
'95325': 'Hornitos,CA',
'95326': 'Hughson,CA',
'95327': 'Jamestown,CA',
'95328': 'Keyes,CA',
'95329': 'La Grange,CA',
'95330': 'Lathrop,CA',
'95333': 'Le Grand,CA',
'95334': 'Livingston,CA',
'95335': 'Long Barn,CA',
'95336': 'Manteca,CA',
'95337': 'Manteca,CA',
'95338': 'Mariposa,CA',
'95340': 'Merced,CA',
'95341': 'Merced,CA',
'95342': 'Atwater,CA',
'95343': 'Merced,CA',
'95344': 'Merced,CA',
'95345': 'Midpines,CA',
'95346': 'Mi Wuk Village,CA',
'95347': 'Moccasin,CA',
'95348': 'Merced,CA',
'95350': 'Modesto,CA',
'95351': 'Modesto,CA',
'95352': 'Modesto,CA',
'95353': 'Modesto,CA',
'95354': 'Modesto,CA',
'95355': 'Modesto,CA',
'95356': 'Modesto,CA',
'95357': 'Modesto,CA',
'95358': 'Modesto,CA',
'95360': 'Newman,CA',
'95361': 'Oakdale,CA',
'95363': 'Patterson,CA',
'95364': 'Pinecrest,CA',
'95365': 'Planada,CA',
'95366': 'Ripon,CA',
'95367': 'Riverbank,CA',
'95368': 'Salida,CA',
'95369': 'Snelling,CA',
'95370': 'Sonora,CA',
'95372': 'Soulsbyville,CA',
'95373': 'Standard,CA',
'95374': 'Stevinson,CA',
'95375': 'Strawberry,CA',
'95376': 'Tracy,CA',
'95377': 'Tracy,CA',
'95378': 'Tracy,CA',
'95379': 'Tuolumne,CA',
'95380': 'Turlock,CA',
'95381': 'Turlock,CA',
'95382': 'Turlock,CA',
'95383': 'Twain Harte,CA',
'95385': 'Vernalis,CA',
'95386': 'Waterford,CA',
'95387': 'Westley,CA',
'95388': 'Winton,CA',
'95389': 'Yosemite National Park,CA',
'95390': 'Riverbank,CA',
'95391': 'Tracy,CA',
'95397': 'Modesto,CA',
'95401': 'Santa Rosa,CA',
'95402': 'Santa Rosa,CA',
'95403': 'Santa Rosa,CA',
'95404': 'Santa Rosa,CA',
'95405': 'Santa Rosa,CA',
'95406': 'Santa Rosa,CA',
'95407': 'Santa Rosa,CA',
'95408': 'Santa Rosa,CA',
'95409': 'Santa Rosa,CA',
'95410': 'Albion,CA',
'95412': 'Annapolis,CA',
'95415': 'Boonville,CA',
'95416': 'Boyes Hot Springs,CA',
'95417': 'Branscomb,CA',
'95418': 'Calpella,CA',
'95419': 'Camp Meeker,CA',
'95420': 'Caspar,CA',
'95421': 'Cazadero,CA',
'95422': 'Clearlake,CA',
'95423': 'Clearlake Oaks,CA',
'95424': 'Clearlake Park,CA',
'95425': 'Cloverdale,CA',
'95426': 'Cobb,CA',
'95427': 'Comptche,CA',
'95428': 'Covelo,CA',
'95429': 'Dos Rios,CA',
'95430': 'Duncans Mills,CA',
'95431': 'Eldridge,CA',
'95432': 'Elk,CA',
'95433': 'El Verano,CA',
'95435': 'Finley,CA',
'95436': 'Forestville,CA',
'95437': 'Fort Bragg,CA',
'95439': 'Fulton,CA',
'95441': 'Geyserville,CA',
'95442': 'Glen Ellen,CA',
'95443': 'Glenhaven,CA',
'95444': 'Graton,CA',
'95445': 'Gualala,CA',
'95446': 'Guerneville,CA',
'95448': 'Healdsburg,CA',
'95449': 'Hopland,CA',
'95450': 'Jenner,CA',
'95451': 'Kelseyville,CA',
'95452': 'Kenwood,CA',
'95453': 'Lakeport,CA',
'95454': 'Laytonville,CA',
'95456': 'Littleriver,CA',
'95457': 'Lower Lake,CA',
'95458': 'Lucerne,CA',
'95459': 'Manchester,CA',
'95460': 'Mendocino,CA',
'95461': 'Middletown,CA',
'95462': 'Monte Rio,CA',
'95463': 'Navarro,CA',
'95464': 'Nice,CA',
'95465': 'Occidental,CA',
'95466': 'Philo,CA',
'95467': '95467,CA',
'95468': 'Point Arena,CA',
'95469': 'Potter Valley,CA',
'95470': 'Redwood Valley,CA',
'95471': 'Rio Nido,CA',
'95472': 'Sebastopol,CA',
'95473': 'Sebastopol,CA',
'95476': 'Sonoma,CA',
'95480': 'Stewarts Point,CA',
'95481': 'Talmage,CA',
'95482': 'Ukiah,CA',
'95485': 'Upper Lake,CA',
'95486': 'Villa Grande,CA',
'95487': 'Vineburg,CA',
'95488': 'Westport,CA',
'95490': 'Willits,CA',
'95492': 'Windsor,CA',
'95493': 'Witter Springs,CA',
'95494': 'Yorkville,CA',
'95497': 'The Sea Ranch,CA',
'95501': 'Eureka,CA',
'95502': 'Eureka,CA',
'95503': 'Eureka,CA',
'95511': 'Alderpoint,CA',
'95514': 'Blocksburg,CA',
'95518': 'Arcata,CA',
'95519': 'Mckinleyville,CA',
'95521': 'Arcata,CA',
'95524': 'Bayside,CA',
'95525': 'Blue Lake,CA',
'95526': 'Bridgeville,CA',
'95527': 'Burnt Ranch,CA',
'95528': 'Carlotta,CA',
'95531': 'Crescent City,CA',
'95532': 'Crescent City,CA',
'95534': 'Cutten,CA',
'95536': 'Ferndale,CA',
'95537': 'Fields Landing,CA',
'95538': 'Fort Dick,CA',
'95540': 'Fortuna,CA',
'95542': 'Garberville,CA',
'95543': 'Gasquet,CA',
'95545': 'Honeydew,CA',
'95546': 'Hoopa,CA',
'95547': 'Hydesville,CA',
'95548': 'Klamath,CA',
'95549': 'Kneeland,CA',
'95550': 'Korbel,CA',
'95551': 'Loleta,CA',
'95552': 'Mad River,CA',
'95553': 'Miranda,CA',
'95554': 'Myers Flat,CA',
'95555': 'Orick,CA',
'95556': 'Orleans,CA',
'95558': 'Petrolia,CA',
'95559': 'Phillipsville,CA',
'95560': 'Redway,CA',
'95562': 'Rio Dell,CA',
'95563': 'Salyer,CA',
'95564': 'Samoa,CA',
'95565': 'Scotia,CA',
'95567': 'Smith River,CA',
'95568': 'Somes Bar,CA',
'95569': 'Redcrest,CA',
'95570': 'Trinidad,CA',
'95571': 'Weott,CA',
'95573': 'Willow Creek,CA',
'95585': 'Leggett,CA',
'95587': 'Piercy,CA',
'95589': 'Whitethorn,CA',
'95595': 'Zenia,CA',
'95601': 'Amador City,CA',
'95602': 'Auburn,CA',
'95603': 'Auburn,CA',
'95604': 'Auburn,CA',
'95605': 'West Sacramento,CA',
'95606': 'Brooks,CA',
'95607': 'Capay,CA',
'95608': 'Carmichael,CA',
'95609': 'Carmichael,CA',
'95610': 'Citrus Heights,CA',
'95611': 'Citrus Heights,CA',
'95612': 'Clarksburg,CA',
'95613': 'Coloma,CA',
'95614': 'Cool,CA',
'95615': 'Courtland,CA',
'95616': 'Davis,CA',
'95617': 'Davis,CA',
'95618': 'El Macero,CA',
'95619': 'Diamond Springs,CA',
'95620': 'Dixon,CA',
'95621': 'Citrus Heights,CA',
'95623': 'El Dorado,CA',
'95624': 'Elk Grove,CA',
'95625': 'Elmira,CA',
'95626': 'Elverta,CA',
'95627': 'Esparto,CA',
'95628': 'Fair Oaks,CA',
'95629': 'Fiddletown,CA',
'95630': 'Folsom,CA',
'95631': 'Foresthill,CA',
'95632': 'Galt,CA',
'95633': 'Garden Valley,CA',
'95634': 'Georgetown,CA',
'95635': 'Greenwood,CA',
'95636': 'Grizzly Flats,CA',
'95637': 'Guinda,CA',
'95638': 'Herald,CA',
'95639': 'Hood,CA',
'95640': 'Ione,CA',
'95641': 'Isleton,CA',
'95642': 'Jackson,CA',
'95644': 'Kit Carson,CA',
'95645': 'Knights Landing,CA',
'95646': 'Kirkwood,CA',
'95648': 'Lincoln,CA',
'95650': 'Loomis,CA',
'95651': 'Lotus,CA',
'95652': 'Mcclellan,CA',
'95653': 'Madison,CA',
'95654': 'Martell,CA',
'95655': 'Mather,CA',
'95656': 'Mount Aukum,CA',
'95658': 'Newcastle,CA',
'95659': 'Nicolaus,CA',
'95660': 'North Highlands,CA',
'95661': 'Roseville,CA',
'95662': 'Orangevale,CA',
'95663': 'Penryn,CA',
'95664': 'Pilot Hill,CA',
'95665': 'Pine Grove,CA',
'95666': 'Pioneer,CA',
'95667': 'Placerville,CA',
'95668': 'Pleasant Grove,CA',
'95669': 'Plymouth,CA',
'95670': 'Rancho Cordova,CA',
'95671': 'Represa,CA',
'95672': 'Rescue,CA',
'95673': 'Rio Linda,CA',
'95674': 'Rio Oso,CA',
'95675': 'River Pines,CA',
'95676': 'Robbins,CA',
'95677': 'Rocklin,CA',
'95678': 'Roseville,CA',
'95679': 'Rumsey,CA',
'95680': 'Ryde,CA',
'95681': 'Sheridan,CA',
'95682': 'Shingle Springs,CA',
'95683': 'Sloughhouse,CA',
'95684': 'Somerset,CA',
'95685': 'Sutter Creek,CA',
'95686': 'Thornton,CA',
'95687': 'Vacaville,CA',
'95688': 'Vacaville,CA',
'95689': 'Volcano,CA',
'95690': 'Walnut Grove,CA',
'95691': 'West Sacramento,CA',
'95692': 'Wheatland,CA',
'95693': 'Wilton,CA',
'95694': 'Winters,CA',
'95695': 'Woodland,CA',
'95696': 'Vacaville,CA',
'95697': 'Yolo,CA',
'95698': 'Zamora,CA',
'95699': 'Drytown,CA',
'95701': 'Alta,CA',
'95703': 'Applegate,CA',
'95709': 'Camino,CA',
'95712': 'Chicago Park,CA',
'95713': 'Colfax,CA',
'95714': 'Dutch Flat,CA',
'95715': 'Emigrant Gap,CA',
'95717': 'Gold Run,CA',
'95720': 'Kyburz,CA',
'95721': 'Echo Lake,CA',
'95722': 'Meadow Vista,CA',
'95724': 'Norden,CA',
'95726': 'Pollock Pines,CA',
'95728': 'Soda Springs,CA',
'95735': 'Twin Bridges,CA',
'95736': 'Weimar,CA',
'95741': 'Rancho Cordova,CA',
'95742': 'Rancho Cordova,CA',
'95743': 'Rancho Cordova,CA',
'95746': 'Granite Bay,CA',
'95747': 'Roseville,CA',
'95757': 'Elk Grove,CA',
'95758': 'Elk Grove,CA',
'95759': 'Elk Grove,CA',
'95762': 'El Dorado Hills,CA',
'95763': 'Folsom,CA',
'95765': 'Rocklin,CA',
'95776': 'Woodland,CA',
'95798': 'West Sacramento,CA',
'95799': 'West Sacramento,CA',
'95812': 'Sacramento,CA',
'95813': 'Sacramento,CA',
'95814': 'Sacramento,CA',
'95815': 'Sacramento,CA',
'95816': 'Sacramento,CA',
'95817': 'Sacramento,CA',
'95818': 'Sacramento,CA',
'95819': 'Sacramento,CA',
'95820': 'Sacramento,CA',
'95821': 'Sacramento,CA',
'95822': 'Sacramento,CA',
'95823': 'Sacramento,CA',
'95824': 'Sacramento,CA',
'95825': 'Sacramento,CA',
'95826': 'Sacramento,CA',
'95827': 'Sacramento,CA',
'95828': 'Sacramento,CA',
'95829': 'Sacramento,CA',
'95830': 'Sacramento,CA',
'95831': 'Sacramento,CA',
'95832': 'Sacramento,CA',
'95833': 'Sacramento,CA',
'95834': 'Sacramento,CA',
'95835': 'Sacramento,CA',
'95836': 'Sacramento,CA',
'95837': 'Sacramento,CA',
'95838': 'Sacramento,CA',
'95840': 'Sacramento,CA',
'95841': 'Sacramento,CA',
'95842': 'Sacramento,CA',
'95843': 'Antelope,CA',
'95851': 'Sacramento,CA',
'95852': 'Sacramento,CA',
'95853': 'Sacramento,CA',
'95857': 'Sacramento,CA',
'95860': 'Sacramento,CA',
'95864': 'Sacramento,CA',
'95865': 'Sacramento,CA',
'95866': 'Sacramento,CA',
'95867': 'Sacramento,CA',
'95873': 'Sacramento,CA',
'95887': 'Sacramento,CA',
'95894': 'Sacramento,CA',
'95899': 'Sacramento,CA',
'95901': 'Marysville,CA',
'95903': 'Beale Afb,CA',
'95910': 'Alleghany,CA',
'95912': 'Arbuckle,CA',
'95913': 'Artois,CA',
'95914': 'Bangor,CA',
'95915': 'Belden,CA',
'95916': 'Berry Creek,CA',
'95917': 'Biggs,CA',
'95918': 'Browns Valley,CA',
'95919': 'Brownsville,CA',
'95920': 'Butte City,CA',
'95922': 'Camptonville,CA',
'95923': 'Canyondam,CA',
'95924': 'Cedar Ridge,CA',
'95925': 'Challenge,CA',
'95926': 'Chico,CA',
'95927': 'Chico,CA',
'95928': 'Chico,CA',
'95929': 'Chico,CA',
'95930': 'Clipper Mills,CA',
'95931': 'College City,CA',
'95932': 'Colusa,CA',
'95934': 'Crescent Mills,CA',
'95935': 'Dobbins,CA',
'95936': 'Downieville,CA',
'95937': 'Dunnigan,CA',
'95938': 'Durham,CA',
'95939': 'Elk Creek,CA',
'95940': 'Feather Falls,CA',
'95941': 'Forbestown,CA',
'95942': 'Forest Ranch,CA',
'95943': 'Glenn,CA',
'95944': 'Goodyears Bar,CA',
'95945': 'Grass Valley,CA',
'95946': 'Penn Valley,CA',
'95947': 'Greenville,CA',
'95948': 'Gridley,CA',
'95949': 'Grass Valley,CA',
'95950': 'Grimes,CA',
'95951': 'Hamilton City,CA',
'95953': 'Live Oak,CA',
'95954': 'Magalia,CA',
'95955': 'Maxwell,CA',
'95956': 'Meadow Valley,CA',
'95957': 'Meridian,CA',
'95958': 'Nelson,CA',
'95959': 'Nevada City,CA',
'95960': 'North San Juan,CA',
'95961': 'Olivehurst,CA',
'95962': 'Oregon House,CA',
'95963': 'Orland,CA',
'95965': 'Oroville,CA',
'95966': 'Oroville,CA',
'95967': 'Paradise,CA',
'95968': 'Palermo,CA',
'95969': 'Paradise,CA',
'95970': 'Princeton,CA',
'95971': 'Quincy,CA',
'95972': 'Rackerby,CA',
'95973': 'Chico,CA',
'95974': 'Richvale,CA',
'95975': 'Rough And Ready,CA',
'95976': 'Chico,CA',
'95977': 'Smartville,CA',
'95978': 'Stirling City,CA',
'95979': 'Stonyford,CA',
'95980': 'Storrie,CA',
'95981': 'Strawberry Valley,CA',
'95982': 'Sutter,CA',
'95983': 'Taylorsville,CA',
'95984': 'Twain,CA',
'95986': 'Washington,CA',
'95987': 'Williams,CA',
'95988': 'Willows,CA',
'95991': 'Yuba City,CA',
'95992': 'Yuba City,CA',
'95993': 'Yuba City,CA',
'96001': 'Redding,CA',
'96002': 'Redding,CA',
'96003': 'Redding,CA',
'96006': 'Adin,CA',
'96007': 'Anderson,CA',
'96008': 'Bella Vista,CA',
'96009': 'Bieber,CA',
'96010': 'Big Bar,CA',
'96011': 'Big Bend,CA',
'96013': 'Burney,CA',
'96014': 'Callahan,CA',
'96015': 'Canby,CA',
'96016': 'Cassel,CA',
'96017': 'Castella,CA',
'96019': 'Shasta Lake,CA',
'96020': 'Chester,CA',
'96021': 'Corning,CA',
'96022': 'Cottonwood,CA',
'96023': 'Dorris,CA',
'96024': 'Douglas City,CA',
'96025': 'Dunsmuir,CA',
'96027': 'Etna,CA',
'96028': 'Fall River Mills,CA',
'96029': 'Flournoy,CA',
'96031': 'Forks Of Salmon,CA',
'96032': 'Fort Jones,CA',
'96033': 'French Gulch,CA',
'96034': 'Gazelle,CA',
'96035': 'Gerber,CA',
'96037': 'Greenview,CA',
'96038': 'Grenada,CA',
'96039': 'Happy Camp,CA',
'96040': 'Hat Creek,CA',
'96041': 'Hayfork,CA',
'96044': 'Hornbrook,CA',
'96046': 'Hyampom,CA',
'96047': 'Igo,CA',
'96048': 'Junction City,CA',
'96049': 'Redding,CA',
'96050': 'Klamath River,CA',
'96051': 'Lakehead,CA',
'96052': 'Lewiston,CA',
'96054': 'Lookout,CA',
'96055': 'Los Molinos,CA',
'96056': 'Mcarthur,CA',
'96057': 'Mccloud,CA',
'96058': 'Macdoel,CA',
'96059': 'Manton,CA',
'96061': 'Mill Creek,CA',
'96062': 'Millville,CA',
'96063': 'Mineral,CA',
'96064': 'Montague,CA',
'96065': 'Montgomery Creek,CA',
'96067': 'Mount Shasta,CA',
'96068': 'Nubieber,CA',
'96069': 'Oak Run,CA',
'96070': 'Obrien,CA',
'96071': 'Old Station,CA',
'96073': 'Palo Cedro,CA',
'96074': 'Paskenta,CA',
'96075': 'Paynes Creek,CA',
'96076': 'Platina,CA',
'96078': 'Proberta,CA',
'96079': 'Shasta Lake,CA',
'96080': 'Red Bluff,CA',
'96084': 'Round Mountain,CA',
'96085': 'Scott Bar,CA',
'96086': 'Seiad Valley,CA',
'96087': 'Shasta,CA',
'96088': 'Shingletown,CA',
'96089': 'Shasta Lake,CA',
'96090': 'Tehama,CA',
'96091': 'Trinity Center,CA',
'96092': 'Vina,CA',
'96093': 'Weaverville,CA',
'96094': 'Weed,CA',
'96095': 'Whiskeytown,CA',
'96096': 'Whitmore,CA',
'96097': 'Yreka,CA',
'96099': 'Redding,CA',
'96101': 'Alturas,CA',
'96103': 'Blairsden Graeagle,CA',
'96104': 'Cedarville,CA',
'96105': 'Chilcoot,CA',
'96106': 'Clio,CA',
'96107': 'Coleville,CA',
'96108': 'Davis Creek,CA',
'96109': 'Doyle,CA',
'96110': 'Eagleville,CA',
'96111': 'Floriston,CA',
'96112': 'Fort Bidwell,CA',
'96113': 'Herlong,CA',
'96114': 'Janesville,CA',
'96115': 'Lake City,CA',
'96116': 'Likely,CA',
'96117': 'Litchfield,CA',
'96118': 'Loyalton,CA',
'96119': 'Madeline,CA',
'96120': 'Markleeville,CA',
'96121': 'Milford,CA',
'96122': 'Portola,CA',
'96123': 'Ravendale,CA',
'96124': 'Calpine,CA',
'96125': 'Sierra City,CA',
'96126': 'Sierraville,CA',
'96127': 'Susanville,CA',
'96128': 'Standish,CA',
'96129': 'Beckwourth,CA',
'96130': 'Susanville,CA',
'96132': 'Termo,CA',
'96133': 'Topaz,CA',
'96134': 'Tulelake,CA',
'96135': 'Vinton,CA',
'96136': 'Wendel,CA',
'96137': 'Westwood,CA',
'96140': 'Carnelian Bay,CA',
'96141': 'Homewood,CA',
'96142': 'Tahoma,CA',
'96143': 'Kings Beach,CA',
'96145': 'Tahoe City,CA',
'96146': 'Olympic Valley,CA',
'96148': 'Tahoe Vista,CA',
'96150': 'South Lake Tahoe,CA',
'96151': 'South Lake Tahoe,CA',
'96152': 'South Lake Tahoe,CA',
'96154': 'South Lake Tahoe,CA',
'96155': 'South Lake Tahoe,CA',
'96156': 'South Lake Tahoe,CA',
'96157': 'South Lake Tahoe,CA',
'96158': 'South Lake Tahoe,CA',
'96160': 'Truckee,CA',
'96161': 'Truckee,CA',
'96162': 'Truckee,CA',
'97001': 'Antelope,OR',
'97002': 'Aurora,OR',
'97004': 'Beavercreek,OR',
'97005': 'Beaverton,OR',
'97006': 'Beaverton,OR',
'97007': 'Beaverton,OR',
'97008': 'Beaverton,OR',
'97009': 'Boring,OR',
'97010': 'Bridal Veil,OR',
'97011': 'Brightwood,OR',
'97013': 'Canby,OR',
'97014': 'Cascade Locks,OR',
'97015': 'Clackamas,OR',
'97016': 'Clatskanie,OR',
'97017': 'Colton,OR',
'97018': 'Columbia City,OR',
'97019': 'Corbett,OR',
'97020': 'Donald,OR',
'97021': 'Dufur,OR',
'97022': 'Eagle Creek,OR',
'97023': 'Estacada,OR',
'97024': 'Fairview,OR',
'97026': 'Gervais,OR',
'97027': 'Gladstone,OR',
'97028': 'Government Camp,OR',
'97029': 'Grass Valley,OR',
'97030': 'Gresham,OR',
'97031': 'Hood River,OR',
'97032': 'Hubbard,OR',
'97033': 'Kent,OR',
'97034': 'Lake Oswego,OR',
'97035': 'Lake Oswego,OR',
'97036': 'Marylhurst,OR',
'97037': 'Maupin,OR',
'97038': 'Molalla,OR',
'97039': 'Moro,OR',
'97040': 'Mosier,OR',
'97041': 'Mount Hood Parkdale,OR',
'97042': 'Mulino,OR',
'97044': 'Odell,OR',
'97045': 'Oregon City,OR',
'97048': 'Rainier,OR',
'97049': 'Rhododendron,OR',
'97050': 'Rufus,OR',
'97051': 'Saint Helens,OR',
'97053': 'Warren,OR',
'97054': 'Deer Island,OR',
'97055': 'Sandy,OR',
'97056': 'Scappoose,OR',
'97057': 'Shaniko,OR',
'97058': 'The Dalles,OR',
'97060': 'Troutdale,OR',
'97062': 'Tualatin,OR',
'97063': 'Tygh Valley,OR',
'97064': 'Vernonia,OR',
'97065': 'Wasco,OR',
'97067': 'Welches,OR',
'97068': 'West Linn,OR',
'97070': 'Wilsonville,OR',
'97071': 'Woodburn,OR',
'97075': 'Beaverton,OR',
'97076': 'Beaverton,OR',
'97077': 'Beaverton,OR',
'97078': 'Beaverton,OR',
'97080': 'Gresham,OR',
'97086': 'Portland,OR',
'97089': 'Happy Valley,OR',
'97101': 'Amity,OR',
'97102': 'Arch Cape,OR',
'97103': 'Astoria,OR',
'97106': 'Banks,OR',
'97107': 'Bay City,OR',
'97108': 'Beaver,OR',
'97109': 'Buxton,OR',
'97110': 'Cannon Beach,OR',
'97111': 'Carlton,OR',
'97112': 'Cloverdale,OR',
'97113': 'Cornelius,OR',
'97114': 'Dayton,OR',
'97115': 'Dundee,OR',
'97116': 'Forest Grove,OR',
'97117': 'Gales Creek,OR',
'97118': 'Garibaldi,OR',
'97119': 'Gaston,OR',
'97121': 'Hammond,OR',
'97122': 'Hebo,OR',
'97123': 'Hillsboro,OR',
'97124': 'Hillsboro,OR',
'97125': 'Manning,OR',
'97127': 'Lafayette,OR',
'97128': 'Mcminnville,OR',
'97130': 'Manzanita,OR',
'97131': 'Nehalem,OR',
'97132': 'Newberg,OR',
'97133': 'North Plains,OR',
'97134': 'Oceanside,OR',
'97135': 'Pacific City,OR',
'97136': 'Rockaway Beach,OR',
'97137': 'Saint Paul,OR',
'97138': 'Seaside,OR',
'97140': 'Sherwood,OR',
'97141': 'Tillamook,OR',
'97143': 'Netarts,OR',
'97144': 'Timber,OR',
'97145': 'Tolovana Park,OR',
'97146': 'Warrenton,OR',
'97147': 'Wheeler,OR',
'97148': 'Yamhill,OR',
'97149': 'Neskowin,OR',
'97201': 'Portland,OR',
'97202': 'Portland,OR',
'97203': 'Portland,OR',
'97204': 'Portland,OR',
'97205': 'Portland,OR',
'97206': 'Portland,OR',
'97207': 'Portland,OR',
'97208': 'Portland,OR',
'97209': 'Portland,OR',
'97210': 'Portland,OR',
'97211': 'Portland,OR',
'97212': 'Portland,OR',
'97213': 'Portland,OR',
'97214': 'Portland,OR',
'97215': 'Portland,OR',
'97216': 'Portland,OR',
'97217': 'Portland,OR',
'97218': 'Portland,OR',
'97219': 'Portland,OR',
'97220': 'Portland,OR',
'97221': 'Portland,OR',
'97222': 'Portland,OR',
'97223': 'Portland,OR',
'97224': 'Portland,OR',
'97225': 'Portland,OR',
'97227': 'Portland,OR',
'97228': 'Portland,OR',
'97229': 'Portland,OR',
'97230': 'Portland,OR',
'97231': 'Portland,OR',
'97232': 'Portland,OR',
'97233': 'Portland,OR',
'97236': 'Portland,OR',
'97238': 'Portland,OR',
'97239': 'Portland,OR',
'97240': 'Portland,OR',
'97242': 'Portland,OR',
'97251': 'Portland,OR',
'97253': 'Portland,OR',
'97254': 'Portland,OR',
'97255': 'Portland,OR',
'97256': 'Portland,OR',
'97258': 'Portland,OR',
'97259': 'Portland,OR',
'97266': 'Portland,OR',
'97267': 'Portland,OR',
'97268': 'Portland,OR',
'97269': 'Portland,OR',
'97271': 'Portland,OR',
'97272': 'Portland,OR',
'97280': 'Portland,OR',
'97281': 'Portland,OR',
'97282': 'Portland,OR',
'97283': 'Portland,OR',
'97286': 'Portland,OR',
'97290': 'Portland,OR',
'97291': 'Portland,OR',
'97292': 'Portland,OR',
'97293': 'Portland,OR',
'97294': 'Portland,OR',
'97296': 'Portland,OR',
'97298': 'Portland,OR',
'97299': 'Portland,OR',
'97301': 'Salem,OR',
'97302': 'Salem,OR',
'97303': 'Salem,OR',
'97304': 'Salem,OR',
'97305': 'Salem,OR',
'97306': 'Salem,OR',
'97307': 'Keizer,OR',
'97308': 'Salem,OR',
'97309': 'Salem,OR',
'97310': 'Salem,OR',
'97311': 'Salem,OR',
'97312': 'Salem,OR',
'97313': 'Salem,OR',
'97314': 'Salem,OR',
'97317': 'Salem,OR',
'97321': 'Albany,OR',
'97324': 'Alsea,OR',
'97325': 'Aumsville,OR',
'97326': 'Blodgett,OR',
'97327': 'Brownsville,OR',
'97329': 'Cascadia,OR',
'97330': 'Corvallis,OR',
'97331': 'Corvallis,OR',
'97333': 'Corvallis,OR',
'97335': 'Crabtree,OR',
'97336': 'Crawfordsville,OR',
'97338': 'Dallas,OR',
'97339': 'Corvallis,OR',
'97341': 'Depoe Bay,OR',
'97342': 'Detroit,OR',
'97343': 'Eddyville,OR',
'97344': 'Falls City,OR',
'97345': 'Foster,OR',
'97346': 'Gates,OR',
'97347': 'Grand Ronde,OR',
'97348': 'Halsey,OR',
'97350': 'Idanha,OR',
'97351': 'Independence,OR',
'97352': 'Jefferson,OR',
'97355': 'Lebanon,OR',
'97357': 'Logsden,OR',
'97358': 'Lyons,OR',
'97359': 'Marion,OR',
'97360': 'Mill City,OR',
'97361': 'Monmouth,OR',
'97362': 'Mount Angel,OR',
'97364': 'Neotsu,OR',
'97365': 'Newport,OR',
'97366': 'South Beach,OR',
'97367': 'Lincoln City,OR',
'97368': 'Otis,OR',
'97369': 'Otter Rock,OR',
'97370': 'Philomath,OR',
'97371': 'Rickreall,OR',
'97372': 'Rose Lodge,OR',
'97373': 'Saint Benedict,OR',
'97374': 'Scio,OR',
'97375': 'Scotts Mills,OR',
'97376': 'Seal Rock,OR',
'97377': 'Shedd,OR',
'97378': 'Sheridan,OR',
'97380': 'Siletz,OR',
'97381': 'Silverton,OR',
'97383': 'Stayton,OR',
'97384': 'Mehama,OR',
'97385': 'Sublimity,OR',
'97386': 'Sweet Home,OR',
'97388': 'Gleneden Beach,OR',
'97389': 'Tangent,OR',
'97390': 'Tidewater,OR',
'97391': 'Toledo,OR',
'97392': 'Turner,OR',
'97394': 'Waldport,OR',
'97396': 'Willamina,OR',
'97401': 'Eugene,OR',
'97402': 'Eugene,OR',
'97403': 'Eugene,OR',
'97404': 'Eugene,OR',
'97405': 'Eugene,OR',
'97406': 'Agness,OR',
'97407': 'Allegany,OR',
'97408': 'Eugene,OR',
'97409': 'Alvadore,OR',
'97410': 'Azalea,OR',
'97411': 'Bandon,OR',
'97412': 'Blachly,OR',
'97413': 'Blue River,OR',
'97414': 'Broadbent,OR',
'97415': 'Brookings,OR',
'97416': 'Camas Valley,OR',
'97417': 'Canyonville,OR',
'97419': 'Cheshire,OR',
'97420': 'Coos Bay,OR',
'97423': 'Coquille,OR',
'97424': 'Cottage Grove,OR',
'97425': 'Crescent Lake,OR',
'97426': 'Creswell,OR',
'97427': 'Culp Creek,OR',
'97428': 'Curtin,OR',
'97429': 'Days Creek,OR',
'97430': 'Deadwood,OR',
'97431': 'Dexter,OR',
'97432': 'Dillard,OR',
'97434': 'Dorena,OR',
'97435': 'Drain,OR',
'97436': 'Elkton,OR',
'97437': 'Elmira,OR',
'97438': 'Fall Creek,OR',
'97439': 'Florence,OR',
'97440': 'Eugene,OR',
'97441': 'Gardiner,OR',
'97442': 'Glendale,OR',
'97443': 'Glide,OR',
'97444': 'Gold Beach,OR',
'97446': 'Harrisburg,OR',
'97447': 'Idleyld Park,OR',
'97448': 'Junction City,OR',
'97449': 'Lakeside,OR',
'97450': 'Langlois,OR',
'97451': 'Lorane,OR',
'97452': 'Lowell,OR',
'97453': 'Mapleton,OR',
'97454': 'Marcola,OR',
'97455': 'Pleasant Hill,OR',
'97456': 'Monroe,OR',
'97457': 'Myrtle Creek,OR',
'97458': 'Myrtle Point,OR',
'97459': 'North Bend,OR',
'97460': 'Norway,OR',
'97461': 'Noti,OR',
'97462': 'Oakland,OR',
'97463': 'Oakridge,OR',
'97464': 'Ophir,OR',
'97465': 'Port Orford,OR',
'97466': 'Powers,OR',
'97467': 'Reedsport,OR',
'97469': 'Riddle,OR',
'97470': 'Roseburg,OR',
'97471': 'Roseburg,OR',
'97472': 'Saginaw,OR',
'97473': 'Scottsburg,OR',
'97476': 'Sixes,OR',
'97477': 'Springfield,OR',
'97478': 'Springfield,OR',
'97479': 'Sutherlin,OR',
'97480': 'Swisshome,OR',
'97481': 'Tenmile,OR',
'97482': 'Thurston,OR',
'97484': 'Tiller,OR',
'97486': 'Umpqua,OR',
'97487': 'Veneta,OR',
'97488': 'Vida,OR',
'97489': 'Walterville,OR',
'97490': 'Walton,OR',
'97491': 'Wedderburn,OR',
'97492': 'Westfir,OR',
'97493': 'Westlake,OR',
'97494': 'Wilbur,OR',
'97495': 'Winchester,OR',
'97496': 'Winston,OR',
'97497': 'Wolf Creek,OR',
'97498': 'Yachats,OR',
'97499': 'Yoncalla,OR',
'97501': 'Medford,OR',
'97502': 'Central Point,OR',
'97503': 'White City,OR',
'97504': 'Medford,OR',
'97520': 'Ashland,OR',
'97522': 'Butte Falls,OR',
'97523': 'Cave Junction,OR',
'97524': 'Eagle Point,OR',
'97525': 'Gold Hill,OR',
'97526': 'Grants Pass,OR',
'97527': 'Grants Pass,OR',
'97528': 'Grants Pass,OR',
'97530': 'Jacksonville,OR',
'97531': 'Kerby,OR',
'97532': 'Merlin,OR',
'97533': 'Murphy,OR',
'97534': 'O Brien,OR',
'97535': 'Phoenix,OR',
'97536': 'Prospect,OR',
'97537': 'Rogue River,OR',
'97538': 'Selma,OR',
'97539': 'Shady Cove,OR',
'97540': 'Talent,OR',
'97541': 'Trail,OR',
'97543': 'Wilderville,OR',
'97544': 'Williams,OR',
'97601': 'Klamath Falls,OR',
'97602': 'Klamath Falls,OR',
'97603': 'Klamath Falls,OR',
'97604': 'Crater Lake,OR',
'97620': 'Adel,OR',
'97621': 'Beatty,OR',
'97622': 'Bly,OR',
'97623': 'Bonanza,OR',
'97624': 'Chiloquin,OR',
'97625': 'Dairy,OR',
'97626': 'Fort Klamath,OR',
'97627': 'Keno,OR',
'97630': 'Lakeview,OR',
'97632': 'Malin,OR',
'97633': 'Merrill,OR',
'97634': 'Midland,OR',
'97635': 'New Pine Creek,OR',
'97636': 'Paisley,OR',
'97637': 'Plush,OR',
'97638': 'Silver Lake,OR',
'97639': 'Sprague River,OR',
'97640': 'Summer Lake,OR',
'97641': 'Christmas Valley,OR',
'97701': 'Bend,OR',
'97702': 'Bend,OR',
'97707': 'Bend,OR',
'97708': 'Bend,OR',
'97709': 'Bend,OR',
'97710': 'Fields,OR',
'97711': 'Ashwood,OR',
'97712': 'Brothers,OR',
'97720': 'Burns,OR',
'97721': 'Princeton,OR',
'97722': 'Diamond,OR',
'97730': 'Camp Sherman,OR',
'97731': 'Chemult,OR',
'97732': 'Crane,OR',
'97733': 'Crescent,OR',
'97734': 'Culver,OR',
'97735': 'Fort Rock,OR',
'97736': 'Frenchglen,OR',
'97737': 'Gilchrist,OR',
'97738': 'Hines,OR',
'97739': 'La Pine,OR',
'97740': 'Lawen,OR',
'97741': 'Madras,OR',
'97750': 'Mitchell,OR',
'97751': 'Paulina,OR',
'97752': 'Post,OR',
'97753': 'Powell Butte,OR',
'97754': 'Prineville,OR',
'97756': 'Redmond,OR',
'97758': 'Riley,OR',
'97759': 'Sisters,OR',
'97760': 'Terrebonne,OR',
'97761': 'Warm Springs,OR',
'97801': 'Pendleton,OR',
'97810': 'Adams,OR',
'97812': 'Arlington,OR',
'97813': 'Athena,OR',
'97814': 'Baker City,OR',
'97817': 'Bates,OR',
'97818': 'Boardman,OR',
'97819': 'Bridgeport,OR',
'97820': 'Canyon City,OR',
'97821': 'Cayuse,OR',
'97823': 'Condon,OR',
'97824': 'Cove,OR',
'97825': 'Dayville,OR',
'97826': 'Echo,OR',
'97827': 'Elgin,OR',
'97828': 'Enterprise,OR',
'97830': 'Fossil,OR',
'97831': 'Fox,OR',
'97833': 'Haines,OR',
'97834': 'Halfway,OR',
'97835': 'Helix,OR',
'97836': 'Heppner,OR',
'97837': 'Hereford,OR',
'97838': 'Hermiston,OR',
'97839': 'Lexington,OR',
'97840': 'Oxbow,OR',
'97841': 'Imbler,OR',
'97842': 'Imnaha,OR',
'97843': 'Ione,OR',
'97844': 'Irrigon,OR',
'97845': 'John Day,OR',
'97846': 'Joseph,OR',
'97848': 'Kimberly,OR',
'97850': 'La Grande,OR',
'97856': 'Long Creek,OR',
'97857': 'Lostine,OR',
'97859': 'Meacham,OR',
'97861': 'Mikkalo,OR',
'97862': 'Milton Freewater,OR',
'97864': 'Monument,OR',
'97865': 'Mount Vernon,OR',
'97867': 'North Powder,OR',
'97868': 'Pilot Rock,OR',
'97869': 'Prairie City,OR',
'97870': 'Richland,OR',
'97872': 'Ritter,OR',
'97873': 'Seneca,OR',
'97874': 'Spray,OR',
'97875': 'Stanfield,OR',
'97876': 'Summerville,OR',
'97877': 'Sumpter,OR',
'97880': 'Ukiah,OR',
'97882': 'Umatilla,OR',
'97883': 'Union,OR',
'97884': 'Unity,OR',
'97885': 'Wallowa,OR',
'97886': 'Weston,OR',
'97901': 'Adrian,OR',
'97902': 'Arock,OR',
'97903': 'Brogan,OR',
'97904': 'Drewsey,OR',
'97905': 'Durkee,OR',
'97906': 'Harper,OR',
'97907': 'Huntington,OR',
'97908': 'Ironside,OR',
'97909': 'Jamieson,OR',
'97910': 'Jordan Valley,OR',
'97911': 'Juntura,OR',
'97913': 'Nyssa,OR',
'97914': 'Ontario,OR',
'97917': 'Riverside,OR',
'97918': 'Vale,OR',
'97920': 'Westfall,OR',
'98001': 'Auburn,WA',
'98002': 'Auburn,WA',
'98003': 'Federal Way,WA',
'98004': 'Bellevue,WA',
'98005': 'Bellevue,WA',
'98006': 'Bellevue,WA',
'98007': 'Bellevue,WA',
'98008': 'Bellevue,WA',
'98009': 'Bellevue,WA',
'98010': 'Black Diamond,WA',
'98011': 'Bothell,WA',
'98012': 'Bothell,WA',
'98013': 'Burton,WA',
'98014': 'Carnation,WA',
'98015': 'Bellevue,WA',
'98019': 'Duvall,WA',
'98020': 'Edmonds,WA',
'98021': 'Bothell,WA',
'98022': 'Enumclaw,WA',
'98023': 'Federal Way,WA',
'98024': 'Fall City,WA',
'98025': 'Hobart,WA',
'98026': 'Edmonds,WA',
'98027': 'Issaquah,WA',
'98028': 'Kenmore,WA',
'98029': 'Issaquah,WA',
'98031': 'Kent,WA',
'98032': 'Kent,WA',
'98033': 'Kirkland,WA',
'98034': 'Kirkland,WA',
'98035': 'Kent,WA',
'98036': 'Lynnwood,WA',
'98037': 'Lynnwood,WA',
'98038': 'Maple Valley,WA',
'98039': 'Medina,WA',
'98040': 'Mercer Island,WA',
'98041': 'Bothell,WA',
'98042': 'Kent,WA',
'98043': 'Mountlake Terrace,WA',
'98045': 'North Bend,WA',
'98046': 'Lynnwood,WA',
'98047': 'Pacific,WA',
'98050': 'Preston,WA',
'98051': 'Ravensdale,WA',
'98052': 'Redmond,WA',
'98053': 'Redmond,WA',
'98054': 'Redondo,WA',
'98055': 'Renton,WA',
'98056': 'Renton,WA',
'98057': 'Renton,WA',
'98058': 'Renton,WA',
'98059': 'Renton,WA',
'98061': 'Rollingbay,WA',
'98062': 'Seahurst,WA',
'98063': 'Federal Way,WA',
'98064': 'Kent,WA',
'98065': 'Snoqualmie,WA',
'98068': 'Snoqualmie Pass,WA',
'98070': 'Vashon,WA',
'98071': 'Auburn,WA',
'98072': 'Woodinville,WA',
'98073': 'Redmond,WA',
'98074': 'Sammamish,WA',
'98075': 'Sammamish,WA',
'98077': 'Woodinville,WA',
'98082': 'Bothell,WA',
'98083': 'Kirkland,WA',
'98087': 'Lynnwood,WA',
'98089': 'Midway,WA',
'98092': 'Auburn,WA',
'98093': 'Federal Way,WA',
'98101': 'Seattle,WA',
'98102': 'Seattle,WA',
'98103': 'Seattle,WA',
'98104': 'Seattle,WA',
'98105': 'Seattle,WA',
'98106': 'Seattle,WA',
'98107': 'Seattle,WA',
'98108': 'Seattle,WA',
'98109': 'Seattle,WA',
'98110': 'Bainbridge Island,WA',
'98111': 'Seattle,WA',
'98112': 'Seattle,WA',
'98113': 'Seattle,WA',
'98114': 'Seattle,WA',
'98115': 'Seattle,WA',
'98116': 'Seattle,WA',
'98117': 'Seattle,WA',
'98118': 'Seattle,WA',
'98119': 'Seattle,WA',
'98121': 'Seattle,WA',
'98122': 'Seattle,WA',
'98124': 'Seattle,WA',
'98125': 'Seattle,WA',
'98126': 'Seattle,WA',
'98127': 'Seattle,WA',
'98129': 'Seattle,WA',
'98131': 'Seattle,WA',
'98132': 'Seattle,WA',
'98133': 'Seattle,WA',
'98134': 'Seattle,WA',
'98136': 'Seattle,WA',
'98138': 'Seattle,WA',
'98139': 'Seattle,WA',
'98141': 'Seattle,WA',
'98144': 'Seattle,WA',
'98145': 'Seattle,WA',
'98146': 'Seattle,WA',
'98148': 'Seattle,WA',
'98151': 'Seattle,WA',
'98154': 'Seattle,WA',
'98155': 'Seattle,WA',
'98158': 'Seattle,WA',
'98160': 'Seattle,WA',
'98161': 'Seattle,WA',
'98164': 'Seattle,WA',
'98165': 'Seattle,WA',
'98166': 'Seattle,WA',
'98168': 'Seattle,WA',
'98170': 'Seattle,WA',
'98171': 'Seattle,WA',
'98174': 'Seattle,WA',
'98175': 'Seattle,WA',
'98177': 'Seattle,WA',
'98178': 'Seattle,WA',
'98181': 'Seattle,WA',
'98184': 'Seattle,WA',
'98185': 'Seattle,WA',
'98188': 'Seattle,WA',
'98189': 'Diagnos Techs Inc,WA',
'98190': 'Seattle,WA',
'98191': 'Seattle,WA',
'98194': 'Seattle,WA',
'98195': 'Seattle,WA',
'98198': 'Seattle,WA',
'98199': 'Seattle,WA',
'98201': 'Everett,WA',
'98203': 'Everett,WA',
'98204': 'Everett,WA',
'98205': 'Everett,WA',
'98206': 'Everett,WA',
'98207': 'Everett,WA',
'98208': 'Everett,WA',
'98213': 'Everett,WA',
'98220': 'Acme,WA',
'98221': 'Anacortes,WA',
'98222': 'Blakely Island,WA',
'98223': 'Arlington,WA',
'98224': 'Baring,WA',
'98225': 'Bellingham,WA',
'98226': 'Bellingham,WA',
'98227': 'Bellingham,WA',
'98228': 'Bellingham,WA',
'98230': 'Blaine,WA',
'98231': 'Blaine,WA',
'98232': 'Bow,WA',
'98233': 'Burlington,WA',
'98235': 'Clearlake,WA',
'98236': 'Clinton,WA',
'98237': 'Concrete,WA',
'98238': 'Conway,WA',
'98239': 'Coupeville,WA',
'98240': 'Custer,WA',
'98241': 'Darrington,WA',
'98243': 'Deer Harbor,WA',
'98244': 'Deming,WA',
'98245': 'Eastsound,WA',
'98247': 'Everson,WA',
'98248': 'Ferndale,WA',
'98249': 'Freeland,WA',
'98250': 'Friday Harbor,WA',
'98251': 'Gold Bar,WA',
'98252': 'Granite Falls,WA',
'98253': 'Greenbank,WA',
'98255': 'Hamilton,WA',
'98256': 'Index,WA',
'98257': 'La Conner,WA',
'98258': 'Lake Stevens,WA',
'98259': 'North Lakewood,WA',
'98260': 'Langley,WA',
'98261': 'Lopez Island,WA',
'98262': 'Lummi Island,WA',
'98263': 'Lyman,WA',
'98264': 'Lynden,WA',
'98266': 'Maple Falls,WA',
'98267': 'Marblemount,WA',
'98270': 'Marysville,WA',
'98271': 'Marysville,WA',
'98272': 'Monroe,WA',
'98273': 'Mount Vernon,WA',
'98274': 'Mount Vernon,WA',
'98275': 'Mukilteo,WA',
'98276': 'Nooksack,WA',
'98277': 'Oak Harbor,WA',
'98278': 'Oak Harbor,WA',
'98279': 'Olga,WA',
'98280': 'Orcas,WA',
'98281': 'Point Roberts,WA',
'98282': 'Camano Island,WA',
'98283': 'Rockport,WA',
'98284': 'Sedro Woolley,WA',
'98286': 'Shaw Island,WA',
'98287': 'Silvana,WA',
'98288': 'Skykomish,WA',
'98290': 'Snohomish,WA',
'98291': 'Snohomish,WA',
'98292': 'Stanwood,WA',
'98293': 'Startup,WA',
'98294': 'Sultan,WA',
'98295': 'Sumas,WA',
'98296': 'Snohomish,WA',
'98297': 'Waldron,WA',
'98303': 'Anderson Island,WA',
'98304': 'Ashford,WA',
'98305': 'Beaver,WA',
'98310': 'Bremerton,WA',
'98311': 'Bremerton,WA',
'98312': 'Bremerton,WA',
'98314': 'Bremerton,WA',
'98315': 'Silverdale,WA',
'98320': 'Brinnon,WA',
'98321': 'Buckley,WA',
'98322': 'Burley,WA',
'98323': 'Carbonado,WA',
'98324': 'Carlsborg,WA',
'98325': 'Chimacum,WA',
'98326': 'Clallam Bay,WA',
'98327': 'Dupont,WA',
'98328': 'Eatonville,WA',
'98329': 'Gig Harbor,WA',
'98330': 'Elbe,WA',
'98331': 'Forks,WA',
'98332': 'Gig Harbor,WA',
'98333': 'Fox Island,WA',
'98335': 'Gig Harbor,WA',
'98336': 'Glenoma,WA',
'98337': 'Bremerton,WA',
'98338': 'Graham,WA',
'98339': 'Port Hadlock,WA',
'98340': 'Hansville,WA',
'98342': 'Indianola,WA',
'98343': 'Joyce,WA',
'98344': 'Kapowsin,WA',
'98345': 'Keyport,WA',
'98346': 'Kingston,WA',
'98348': 'La Grande,WA',
'98349': 'Lakebay,WA',
'98350': 'La Push,WA',
'98351': 'Longbranch,WA',
'98352': 'Sumner,WA',
'98353': 'Manchester,WA',
'98354': 'Milton,WA',
'98355': 'Mineral,WA',
'98356': 'Morton,WA',
'98357': 'Neah Bay,WA',
'98358': 'Nordland,WA',
'98359': 'Olalla,WA',
'98360': 'Orting,WA',
'98361': 'Packwood,WA',
'98362': 'Port Angeles,WA',
'98363': 'Port Angeles,WA',
'98364': 'Port Gamble,WA',
'98365': 'Port Ludlow,WA',
'98366': 'Port Orchard,WA',
'98367': 'Port Orchard,WA',
'98368': 'Port Townsend,WA',
'98370': 'Poulsbo,WA',
'98371': 'Puyallup,WA',
'98372': 'Puyallup,WA',
'98373': 'Puyallup,WA',
'98374': 'Puyallup,WA',
'98375': 'Puyallup,WA',
'98376': 'Quilcene,WA',
'98377': 'Randle,WA',
'98378': 'Retsil,WA',
'98380': 'Seabeck,WA',
'98381': 'Sekiu,WA',
'98382': 'Sequim,WA',
'98383': 'Silverdale,WA',
'98384': 'South Colby,WA',
'98385': 'South Prairie,WA',
'98386': 'Southworth,WA',
'98387': 'Spanaway,WA',
'98388': 'Steilacoom,WA',
'98390': 'Sumner,WA',
'98392': 'Suquamish,WA',
'98393': 'Tracyton,WA',
'98394': 'Vaughn,WA',
'98395': 'Wauna,WA',
'98396': 'Wilkeson,WA',
'98397': 'Longmire,WA',
'98398': 'Paradise Inn,WA',
'98401': 'Tacoma,WA',
'98402': 'Tacoma,WA',
'98403': 'Tacoma,WA',
'98404': 'Tacoma,WA',
'98405': 'Tacoma,WA',
'98406': 'Tacoma,WA',
'98407': 'Tacoma,WA',
'98408': 'Tacoma,WA',
'98409': 'Tacoma,WA',
'98411': 'Tacoma,WA',
'98412': 'Tacoma,WA',
'98413': 'Tacoma,WA',
'98415': 'Tacoma,WA',
'98416': 'Tacoma,WA',
'98417': 'Tacoma,WA',
'98418': 'Tacoma,WA',
'98419': 'Tacoma,WA',
'98421': 'Tacoma,WA',
'98422': 'Tacoma,WA',
'98424': 'Tacoma,WA',
'98430': 'Camp Murray,WA',
'98431': 'Tacoma,WA',
'98433': 'Tacoma,WA',
'98438': 'Mcchord Afb,WA',
'98439': 'Lakewood,WA',
'98442': 'Tacoma,WA',
'98443': 'Tacoma,WA',
'98444': 'Tacoma,WA',
'98445': 'Tacoma,WA',
'98446': 'Tacoma,WA',
'98447': 'Tacoma,WA',
'98448': 'Tacoma,WA',
'98450': 'Tacoma,WA',
'98455': 'Tacoma,WA',
'98460': 'Tacoma,WA',
'98464': 'Tacoma,WA',
'98465': 'Tacoma,WA',
'98466': 'Tacoma,WA',
'98467': 'University Place,WA',
'98471': 'Tacoma,WA',
'98477': 'Tacoma,WA',
'98481': 'Tacoma,WA',
'98490': 'Tacoma,WA',
'98492': 'Lakewood,WA',
'98493': 'Tacoma,WA',
'98496': 'Tacoma,WA',
'98497': 'Lakewood,WA',
'98498': 'Lakewood,WA',
'98499': 'Lakewood,WA',
'98501': 'Olympia,WA',
'98502': 'Olympia,WA',
'98503': 'Lacey,WA',
'98504': 'Olympia,WA',
'98505': 'Olympia,WA',
'98506': 'Olympia,WA',
'98507': 'Olympia,WA',
'98508': 'Olympia,WA',
'98509': 'Lacey,WA',
'98511': 'Tumwater,WA',
'98512': 'Olympia,WA',
'98513': 'Olympia,WA',
'98516': 'Olympia,WA',
'98520': 'Aberdeen,WA',
'98522': 'Adna,WA',
'98524': 'Allyn,WA',
'98526': 'Amanda Park,WA',
'98527': 'Bay Center,WA',
'98528': 'Belfair,WA',
'98530': 'Bucoda,WA',
'98531': 'Centralia,WA',
'98532': 'Chehalis,WA',
'98533': 'Cinebar,WA',
'98535': 'Copalis Beach,WA',
'98536': 'Copalis Crossing,WA',
'98537': 'Cosmopolis,WA',
'98538': 'Curtis,WA',
'98539': 'Doty,WA',
'98540': 'East Olympia,WA',
'98541': 'Elma,WA',
'98542': 'Ethel,WA',
'98544': 'Galvin,WA',
'98546': 'Grapeview,WA',
'98547': 'Grayland,WA',
'98548': 'Hoodsport,WA',
'98550': 'Hoquiam,WA',
'98552': 'Humptulips,WA',
'98554': 'Lebam,WA',
'98555': 'Lilliwaup,WA',
'98556': 'Littlerock,WA',
'98557': 'Mccleary,WA',
'98558': 'Mckenna,WA',
'98559': 'Malone,WA',
'98560': 'Matlock,WA',
'98561': 'Menlo,WA',
'98562': 'Moclips,WA',
'98563': 'Montesano,WA',
'98564': 'Mossyrock,WA',
'98565': 'Napavine,WA',
'98566': 'Neilton,WA',
'98568': 'Oakville,WA',
'98569': 'Ocean Shores,WA',
'98570': 'Onalaska,WA',
'98571': 'Pacific Beach,WA',
'98572': 'Pe Ell,WA',
'98575': 'Quinault,WA',
'98576': 'Rainier,WA',
'98577': 'Raymond,WA',
'98579': 'Rochester,WA',
'98580': 'Roy,WA',
'98581': 'Ryderwood,WA',
'98582': 'Salkum,WA',
'98583': 'Satsop,WA',
'98584': 'Shelton,WA',
'98585': 'Silver Creek,WA',
'98586': 'South Bend,WA',
'98587': 'Taholah,WA',
'98588': 'Tahuya,WA',
'98589': 'Tenino,WA',
'98590': 'Tokeland,WA',
'98591': 'Toledo,WA',
'98592': 'Union,WA',
'98593': 'Vader,WA',
'98595': 'Westport,WA',
'98596': 'Winlock,WA',
'98597': 'Yelm,WA',
'98599': 'Olympia,WA',
'98601': 'Amboy,WA',
'98602': 'Appleton,WA',
'98603': 'Ariel,WA',
'98604': 'Battle Ground,WA',
'98605': 'Bingen,WA',
'98606': 'Brush Prairie,WA',
'98607': 'Camas,WA',
'98609': 'Carrolls,WA',
'98610': 'Carson,WA',
'98611': 'Castle Rock,WA',
'98612': 'Cathlamet,WA',
'98613': 'Centerville,WA',
'98614': 'Chinook,WA',
'98616': 'Cougar,WA',
'98617': 'Dallesport,WA',
'98619': 'Glenwood,WA',
'98620': 'Goldendale,WA',
'98621': 'Grays River,WA',
'98622': 'Heisson,WA',
'98623': 'Husum,WA',
'98624': 'Ilwaco,WA',
'98625': 'Kalama,WA',
'98626': 'Kelso,WA',
'98628': 'Klickitat,WA',
'98629': 'La Center,WA',
'98631': 'Long Beach,WA',
'98632': 'Longview,WA',
'98635': 'Lyle,WA',
'98637': 'Nahcotta,WA',
'98638': 'Naselle,WA',
'98639': 'North Bonneville,WA',
'98640': 'Ocean Park,WA',
'98641': 'Oysterville,WA',
'98642': 'Ridgefield,WA',
'98643': 'Rosburg,WA',
'98644': 'Seaview,WA',
'98645': 'Silverlake,WA',
'98647': 'Skamokawa,WA',
'98648': 'Stevenson,WA',
'98649': 'Toutle,WA',
'98650': 'Trout Lake,WA',
'98651': 'Underwood,WA',
'98660': 'Vancouver,WA',
'98661': 'Vancouver,WA',
'98662': 'Vancouver,WA',
'98663': 'Vancouver,WA',
'98664': 'Vancouver,WA',
'98665': 'Vancouver,WA',
'98666': 'Vancouver,WA',
'98667': 'Vancouver,WA',
'98668': 'Vancouver,WA',
'98670': 'Wahkiacus,WA',
'98671': 'Washougal,WA',
'98672': 'White Salmon,WA',
'98673': 'Wishram,WA',
'98674': 'Woodland,WA',
'98675': 'Yacolt,WA',
'98682': 'Vancouver,WA',
'98683': 'Vancouver,WA',
'98684': 'Vancouver,WA',
'98685': 'Vancouver,WA',
'98686': 'Vancouver,WA',
'98687': 'Vancouver,WA',
'98801': 'Wenatchee,WA',
'98802': 'East Wenatchee,WA',
'98807': 'Wenatchee,WA',
'98811': 'Ardenvoir,WA',
'98812': 'Brewster,WA',
'98813': 'Bridgeport,WA',
'98814': 'Carlton,WA',
'98815': 'Cashmere,WA',
'98816': 'Chelan,WA',
'98817': 'Chelan Falls,WA',
'98819': 'Conconully,WA',
'98821': 'Dryden,WA',
'98822': 'Entiat,WA',
'98823': 'Ephrata,WA',
'98824': 'George,WA',
'98826': 'Leavenworth,WA',
'98827': 'Loomis,WA',
'98828': 'Malaga,WA',
'98829': 'Malott,WA',
'98830': 'Mansfield,WA',
'98831': 'Manson,WA',
'98832': 'Marlin,WA',
'98833': 'Mazama,WA',
'98834': 'Methow,WA',
'98836': 'Monitor,WA',
'98837': 'Moses Lake,WA',
'98840': 'Okanogan,WA',
'98841': 'Omak,WA',
'98843': 'Orondo,WA',
'98844': 'Oroville,WA',
'98845': 'Palisades,WA',
'98846': 'Pateros,WA',
'98847': 'Peshastin,WA',
'98848': 'Quincy,WA',
'98849': 'Riverside,WA',
'98850': 'Rock Island,WA',
'98851': 'Soap Lake,WA',
'98852': 'Stehekin,WA',
'98853': 'Stratford,WA',
'98855': 'Tonasket,WA',
'98856': 'Twisp,WA',
'98857': 'Warden,WA',
'98858': 'Waterville,WA',
'98859': 'Wauconda,WA',
'98860': 'Wilson Creek,WA',
'98862': 'Winthrop,WA',
'98901': 'Yakima,WA',
'98902': 'Yakima,WA',
'98903': 'Yakima,WA',
'98904': 'Yakima,WA',
'98907': 'Yakima,WA',
'98908': 'Yakima,WA',
'98909': 'Yakima,WA',
'98920': 'Brownstown,WA',
'98921': 'Buena,WA',
'98922': 'Cle Elum,WA',
'98923': 'Cowiche,WA',
'98925': 'Easton,WA',
'98926': 'Ellensburg,WA',
'98929': 'Goose Prairie,WA',
'98930': 'Grandview,WA',
'98932': 'Granger,WA',
'98933': 'Harrah,WA',
'98934': 'Kittitas,WA',
'98935': 'Mabton,WA',
'98936': 'Moxee,WA',
'98937': 'Naches,WA',
'98938': 'Outlook,WA',
'98939': 'Parker,WA',
'98940': 'Ronald,WA',
'98941': 'Roslyn,WA',
'98942': 'Selah,WA',
'98943': 'South Cle Elum,WA',
'98944': 'Sunnyside,WA',
'98946': 'Thorp,WA',
'98947': 'Tieton,WA',
'98948': 'Toppenish,WA',
'98950': 'Vantage,WA',
'98951': 'Wapato,WA',
'98952': 'White Swan,WA',
'98953': 'Zillah,WA',
'99001': 'Airway Heights,WA',
'99003': 'Chattaroy,WA',
'99004': 'Cheney,WA',
'99005': 'Colbert,WA',
'99006': 'Deer Park,WA',
'99008': 'Edwall,WA',
'99009': 'Elk,WA',
'99011': 'Fairchild Air Force Base,WA',
'99012': 'Fairfield,WA',
'99013': 'Ford,WA',
'99014': 'Four Lakes,WA',
'99015': 'Freeman,WA',
'99016': 'Greenacres,WA',
'99017': 'Lamont,WA',
'99018': 'Latah,WA',
'99019': 'Liberty Lake,WA',
'99020': 'Marshall,WA',
'99021': 'Mead,WA',
'99022': 'Medical Lake,WA',
'99023': 'Mica,WA',
'99025': 'Newman Lake,WA',
'99026': 'Nine Mile Falls,WA',
'99027': 'Otis Orchards,WA',
'99029': 'Reardan,WA',
'99030': 'Rockford,WA',
'99031': 'Spangle,WA',
'99032': 'Sprague,WA',
'99033': 'Tekoa,WA',
'99034': 'Tumtum,WA',
'99036': 'Valleyford,WA',
'99037': 'Veradale,WA',
'99039': 'Waverly,WA',
'99040': 'Wellpinit,WA',
'99101': 'Addy,WA',
'99102': 'Albion,WA',
'99103': 'Almira,WA',
'99104': 'Belmont,WA',
'99105': 'Benge,WA',
'99107': 'Boyds,WA',
'99109': 'Chewelah,WA',
'99110': 'Clayton,WA',
'99111': 'Colfax,WA',
'99113': 'Colton,WA',
'99114': 'Colville,WA',
'99115': 'Coulee City,WA',
'99116': 'Coulee Dam,WA',
'99117': 'Creston,WA',
'99118': 'Curlew,WA',
'99119': 'Cusick,WA',
'99121': 'Danville,WA',
'99122': 'Davenport,WA',
'99123': 'Electric City,WA',
'99124': 'Elmer City,WA',
'99125': 'Endicott,WA',
'99126': 'Evans,WA',
'99127': 'Saint John,WA',
'99128': 'Farmington,WA',
'99129': 'Fruitland,WA',
'99130': 'Garfield,WA',
'99131': 'Gifford,WA',
'99133': 'Grand Coulee,WA',
'99134': 'Harrington,WA',
'99135': 'Hartline,WA',
'99136': 'Hay,WA',
'99137': 'Hunters,WA',
'99138': 'Inchelium,WA',
'99139': 'Ione,WA',
'99140': 'Keller,WA',
'99141': 'Kettle Falls,WA',
'99143': 'Lacrosse,WA',
'99144': 'Lamona,WA',
'99146': 'Laurier,WA',
'99147': 'Lincoln,WA',
'99148': 'Loon Lake,WA',
'99149': 'Malden,WA',
'99150': 'Malo,WA',
'99151': 'Marcus,WA',
'99152': 'Metaline,WA',
'99153': 'Metaline Falls,WA',
'99154': 'Mohler,WA',
'99155': 'Nespelem,WA',
'99156': 'Newport,WA',
'99157': 'Northport,WA',
'99158': 'Oakesdale,WA',
'99159': 'Odessa,WA',
'99160': 'Orient,WA',
'99161': 'Palouse,WA',
'99163': 'Pullman,WA',
'99164': 'Pullman,WA',
'99165': 'Pullman,WA',
'99166': 'Republic,WA',
'99167': 'Rice,WA',
'99169': 'Ritzville,WA',
'99170': 'Rosalia,WA',
'99171': 'Saint John,WA',
'99173': 'Springdale,WA',
'99174': 'Steptoe,WA',
'99176': 'Thornton,WA',
'99179': 'Uniontown,WA',
'99180': 'Usk,WA',
'99181': 'Valley,WA',
'99185': 'Wilbur,WA',
'99201': 'Spokane,WA',
'99202': 'Spokane,WA',
'99203': 'Spokane,WA',
'99204': 'Spokane,WA',
'99205': 'Spokane,WA',
'99206': 'Spokane,WA',
'99207': 'Spokane,WA',
'99208': 'Spokane,WA',
'99209': 'Spokane,WA',
'99210': 'Spokane,WA',
'99211': 'Spokane,WA',
'99212': 'Spokane,WA',
'99213': 'Spokane,WA',
'99214': 'Spokane,WA',
'99215': 'Spokane,WA',
'99216': 'Spokane,WA',
'99217': 'Spokane,WA',
'99218': 'Spokane,WA',
'99219': 'Spokane,WA',
'99220': 'Spokane,WA',
'99223': 'Spokane,WA',
'99224': 'Spokane,WA',
'99228': 'Spokane,WA',
'99251': 'Spokane,WA',
'99252': 'Spokane,WA',
'99256': 'Spokane,WA',
'99258': 'Spokane,WA',
'99260': 'Spokane,WA',
'99299': 'Spokane,WA',
'99301': 'Pasco,WA',
'99302': 'Pasco,WA',
'99320': 'Benton City,WA',
'99321': 'Beverly,WA',
'99322': 'Bickleton,WA',
'99323': 'Burbank,WA',
'99324': 'College Place,WA',
'99326': 'Connell,WA',
'99327': 'Cunningham,WA',
'99328': 'Dayton,WA',
'99329': 'Dixie,WA',
'99330': 'Eltopia,WA',
'99332': 'Hatton,WA',
'99333': 'Hooper,WA',
'99335': 'Kahlotus,WA',
'99336': 'Kennewick,WA',
'99337': 'Kennewick,WA',
'99338': 'Kennewick,WA',
'99341': 'Lind,WA',
'99343': 'Mesa,WA',
'99344': 'Othello,WA',
'99345': 'Paterson,WA',
'99346': 'Plymouth,WA',
'99347': 'Pomeroy,WA',
'99348': 'Prescott,WA',
'99349': 'Mattawa,WA',
'99350': 'Prosser,WA',
'99352': 'Richland,WA',
'99353': 'West Richland,WA',
'99356': 'Roosevelt,WA',
'99357': 'Royal City,WA',
'99359': 'Starbuck,WA',
'99360': 'Touchet,WA',
'99361': 'Waitsburg,WA',
'99362': 'Walla Walla,WA',
'99363': 'Wallula,WA',
'99371': 'Washtucna,WA',
'99401': 'Anatone,WA',
'99402': 'Asotin,WA',
'99403': 'Clarkston,WA'
    };